'use strict';

var _tslib = require('../_tslib-17936c8d.js');
var React = require('react');
var styled = require('styled-components');
var Hyperlink = require('../Hyperlink-e5b9a045.js');
var ShouldDisplay = require('../ShouldDisplay-b776d697.js');
var styles = require('../styles-2eec2580.js');
var Spacing = require('../Spacing-3105a516.js');
var UseSize = require('../UseSize-b7bfbcb4.js');
var ResponsiveSizes = require('../ResponsiveSizes-61db354a.js');
var AchievementStar = require('../AchievementStar-e46f468f.js');
var classNames = require('classnames');
var Toggle = require('react-toggle');
var ReactDOM = require('react-dom');
var hooks_index = require('../hooks/index.js');
var animations_index = require('../animations/index.js');
var ArrowDown = require('../ArrowDown-74f74169.js');
var HoneygainLogoSdk = require('../HoneygainLogoSdk-3fe99053.js');
var SlickSlider = require('react-slick');
var ReactModal = require('react-modal');
var DatePicker = require('react-datepicker');
var RCSlider = require('rc-slider');
var RadixDialog = require('@radix-ui/react-dialog');
require('../UseHasMounted-b444dd79.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var styled__default = /*#__PURE__*/_interopDefault(styled);
var classNames__default = /*#__PURE__*/_interopDefault(classNames);
var Toggle__default = /*#__PURE__*/_interopDefault(Toggle);
var ReactDOM__namespace = /*#__PURE__*/_interopNamespace(ReactDOM);
var SlickSlider__default = /*#__PURE__*/_interopDefault(SlickSlider);
var ReactModal__default = /*#__PURE__*/_interopDefault(ReactModal);
var DatePicker__default = /*#__PURE__*/_interopDefault(DatePicker);
var RCSlider__default = /*#__PURE__*/_interopDefault(RCSlider);
var RadixDialog__namespace = /*#__PURE__*/_interopNamespace(RadixDialog);

var Badge = function (_a) {
    var text = _a.text, _b = _a.variant, variant = _b === void 0 ? 'info' : _b, _c = _a.size, size = _c === void 0 ? 'small' : _c;
    return (React__namespace.createElement(BadgeContainer, { "$variant": variant, "$size": size },
        React__namespace.createElement(Hyperlink.Text, { useCompact: true, type: "subtitle", color: size === 'small' ? ShouldDisplay.getColors(variant).color : styles.themeColors.black },
            React__namespace.createElement("span", null, text))));
};
var BadgeContainer = styled__default.default.div.withConfig({ displayName: "BadgeContainer", componentId: "-1jxtgvl" })(templateObject_1$21 || (templateObject_1$21 = _tslib.__makeTemplateObject(["\n  display: inline-flex;\n  padding: ", ";\n  border-radius: ", ";\n  background-color: ", ";\n"], ["\n  display: inline-flex;\n  padding: ", ";\n  border-radius: ", ";\n  background-color: ", ";\n"])), function (_a) {
    var $size = _a.$size;
    return ($size === 'small' ? '2px 8px' : '4px  8px');
}, function (_a) {
    var $size = _a.$size;
    return ($size === 'small' ? '10px' : '9999px');
}, function (_a) {
    var $variant = _a.$variant;
    return ShouldDisplay.getColors($variant).bgColor;
});
var templateObject_1$21;

var backgroundColors = {
    primary: styles.themeColors.blue['60'],
    secondary: 'transparent',
    text: 'transparent',
    accent: styles.themeColors.yellow['50'],
};
var colors = {
    primary: '#fff',
    secondary: styles.themeColors.blue['60'],
    text: styles.themeColors.blue['60'],
    accent: styles.themeColors.gray['90'],
};
var borderColors = {
    primary: 'transparent',
    secondary: "1px solid ".concat(styles.themeColors.blue['60']),
    text: 'transparent',
    accent: 'transparent',
};
var sizes$1 = {
    large: 64,
    regular: 48,
    small: 32,
};
var fontSizes$1 = {
    large: 16,
    regular: 16,
    small: 14,
};
var getWidth = function (width, breakpoint) {
    if (Spacing.isArray(width)) {
        switch (breakpoint) {
            case 'largeDesktop':
                return width[0];
            case 'desktop':
                return width[1];
            case 'tablet':
                return width.length == 4 ? width[2] : width[0];
            case 'mobile':
                return width.length == 4 ? width[3] : width[0];
        }
    }
    return width;
};
var ButtonView$4 = styled__default.default.button.withConfig({ shouldForwardProp: Spacing.isPropValid })(templateObject_1$20 || (templateObject_1$20 = _tslib.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  padding: 0;\n  cursor: ", ";\n  height: ", "px;\n  border-radius: 8px;\n  background-color: ", ";\n  color: ", ";\n  border: ", ";\n  transition: ", "s;\n  font-size: ", "px;\n\n  ", "\n\n  ", "\n    ", "\n\n    &:hover {\n    ", "\n  }\n\n  &:active {\n    ", "\n  }\n\n  &:focus {\n    ", "\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  padding: 0;\n  cursor: ", ";\n  height: ", "px;\n  border-radius: 8px;\n  background-color: ", ";\n  color: ", ";\n  border: ", ";\n  transition: ", "s;\n  font-size: ", "px;\n\n  ", "\n\n  ", "\n    ", "\n\n    &:hover {\n    ", "\n  }\n\n  &:active {\n    ", "\n  }\n\n  &:focus {\n    ", "\n  }\n"])), function (props) { return (props.inactive ? 'not-allowed' : 'pointer'); }, function (props) { return sizes$1[props.buttonSize]; }, function (props) {
    return props.color ? props.color : props.inactive ? styles.themeColors.gray['40'] : backgroundColors[props.buttonType];
}, function (props) { return (props.inactive ? 'white' : colors[props.buttonType]); }, function (props) { return borderColors[props.buttonType]; }, styles.transitionTime, fontSizes$1.regular, function (props) { var _a; return UseSize.getResponsiveProperty('width', (_a = props.fullWidth) !== null && _a !== void 0 ? _a : false, function (value) { return (value ? '100%' : '256px'); }); }, function (props) {
    return props.width
        ? "\n    @media ".concat(ResponsiveSizes.media['largeDesktop'], " {\n      width: ").concat(getWidth(props.width, 'largeDesktop'), "px;\n    }\n    @media ").concat(ResponsiveSizes.media['desktop'], " {\n      width: ").concat(getWidth(props.width, 'desktop'), "px;\n    }\n    @media ").concat(ResponsiveSizes.media['tablet'], " {\n      width: ").concat(getWidth(props.width, 'tablet'), "px;\n    }\n    @media ").concat(ResponsiveSizes.media['mobile'], " {\n      width: ").concat(getWidth(props.width, 'mobile'), "px;\n    }\n  ")
        : undefined;
}, function (props) {
    return props.useCompact
        ? "\n      @media ".concat(ResponsiveSizes.media['largeDesktop'], ", ").concat(ResponsiveSizes.media['tablet'], " {\n        height: ").concat(sizes$1.large, "px;\n        font-size: ").concat(fontSizes$1.large, "px;\n      }\n      @media ").concat(ResponsiveSizes.media['desktop'], ", ").concat(ResponsiveSizes.media['mobile'], " {  \n        height: ").concat(sizes$1.regular, "px;\n        font-size: ").concat(fontSizes$1.regular, "px;\n      }\n  ")
        : undefined;
}, function (props) {
    if (props.inactive) {
        return;
    }
    switch (props.buttonType) {
        case 'primary':
            return "\n              background-color: ".concat(props.hoverBackgroundColor ? props.hoverBackgroundColor : styles.themeColors.blue['50'], ";\n          ");
        case 'secondary':
        case 'text':
            return "\n              background-color: ".concat(props.hoverBackgroundColor ? props.hoverBackgroundColor : styles.themeColors.blue['10'], ";");
        case 'accent':
            return "\n              background-color: ".concat(props.hoverBackgroundColor ? props.hoverBackgroundColor : styles.themeColors.yellow['60'], ";\n          ");
    }
}, function (props) {
    if (props.inactive) {
        return;
    }
    switch (props.buttonType) {
        case 'primary':
            return "\n              background-color: ".concat(styles.themeColors.blue['70'], ";\n          ");
        case 'secondary':
        case 'text':
            return "\n              background-color: ".concat(styles.themeColors.blue['20'], ";\n          ");
        case 'accent':
            return "\n              background-color: ".concat(props.hoverBackgroundColor ? props.hoverBackgroundColor : styles.themeColors.yellow['60'], ";\n          ");
    }
}, function (props) {
    if (props.inactive) {
        return '';
    }
    switch (props.buttonType) {
        case 'primary':
        case 'secondary':
        case 'text':
            return "\n            box-shadow: 0 0 0 4px ".concat(styles.themeColors.blue['30'], ";\n          ");
        case 'accent':
            return '';
    }
});
var templateObject_1$20;

var LinkButton = React__namespace.forwardRef(function (_a, ref) {
    var size = _a.size, type = _a.type, _b = _a.iconSide, iconSide = _b === void 0 ? 'left' : _b, props = _tslib.__rest(_a, ["size", "type", "iconSide"]);
    return (React__namespace.createElement(ButtonView$4, _tslib.__assign({ as: "a", buttonType: type, buttonSize: size || 'regular', ref: ref }, props),
        React__namespace.createElement(Spacing.SpanFlex, { justify: "center", align: "center" },
            iconSide === 'left' && props.icon && (React__namespace.createElement(React__namespace.Fragment, null,
                props.icon,
                React__namespace.createElement(Spacing.SpanSpacing, { left: 1 }))),
            props.children,
            iconSide === 'right' && props.icon && (React__namespace.createElement(React__namespace.Fragment, null,
                React__namespace.createElement(Spacing.SpanSpacing, { left: 1 }),
                props.icon)))));
});
LinkButton.displayName = 'LinkButton';

var PriceInCoins = function (_a) {
    var amount = _a.amount, _b = _a.textType, textType = _b === void 0 ? Hyperlink.TextType.HEADING_SMALL_BOLD : _b, _c = _a.isGains, isGains = _c === void 0 ? false : _c, color = _a.color;
    return (React__namespace.createElement(Spacing.Flex, { align: Spacing.FlexAlign.CENTER },
        React__namespace.createElement(Hyperlink.Text, { type: textType, useCompact: true, color: color },
            React__namespace.createElement(Total, { isGains: isGains }, ShouldDisplay.formatAmount(amount))),
        React__namespace.createElement(Spacing.Spacing, { left: 0.5 }),
        React__namespace.createElement(AchievementStar.CoinsIcon, null)));
};
var Total = styled__default.default.span.withConfig({ displayName: "Total", componentId: "-1967mo3" })(templateObject_1$1$ || (templateObject_1$1$ = _tslib.__makeTemplateObject(["\n  &:before {\n    content: '", "';\n  }\n"], ["\n  &:before {\n    content: '", "';\n  }\n"])), function (_a) {
    var isGains = _a.isGains;
    return (isGains ? '+' : '');
});
var templateObject_1$1$;

var Button$3 = React__namespace.forwardRef(function (props, ref) { return (React__namespace.createElement(ButtonView$4, { style: props.style, useCompact: props.useCompact, onClick: props.onClick, className: props.className, buttonType: props.type, buttonSize: (props === null || props === void 0 ? void 0 : props.size) || 'regular', width: props.width, fullWidth: props.fullWidth, color: props.color, hoverBackgroundColor: props.hoverBackgroundColor, inactive: props.inactive, disabled: props.disabled, ref: ref },
    React__namespace.createElement(Spacing.SpanFlex, { justify: "center", align: "center" },
        props.icon && (React__namespace.createElement(React__namespace.Fragment, null,
            props.icon,
            React__namespace.createElement(Spacing.SpanSpacing, { left: 1 }))),
        props.children))); });
Button$3.displayName = 'Button';

var transparentColors = {
    primary: 'transparent',
    accent: 'transparent',
    danger: 'transparent',
};
var blueRedColors = {
    primary: styles.themeColors.blue[60],
    accent: styles.themeColors.blue[60],
    danger: styles.themeColors.red[60],
};
var yellowColors = {
    primary: styles.themeColors.yellow[50],
    accent: styles.themeColors.yellow[50],
    danger: styles.themeColors.yellow[50],
};
var backgroundsMap$1 = {
    default: {
        primary: {
            primary: styles.themeColors.blue[60],
            accent: styles.themeColors.yellow[50],
            danger: styles.themeColors.red[60],
        },
        ghost: transparentColors,
        text: transparentColors,
        copy: {
            primary: styles.themeColors.white,
            accent: styles.themeColors.white,
            danger: styles.themeColors.white,
        },
        copySpecial: transparentColors,
    },
    hover: {
        primary: {
            primary: styles.themeColors.blue[50],
            accent: styles.themeColors.yellow[40],
            danger: styles.themeColors.red[50],
        },
        ghost: {
            primary: styles.themeColors.blue[10],
            accent: styles.themeColors.blue[10],
            danger: styles.themeColors.red[10],
        },
        text: transparentColors,
        copy: {
            primary: styles.themeColors.blue[10],
            accent: styles.themeColors.blue[10],
            danger: styles.themeColors.red[10],
        },
        copySpecial: {
            primary: styles.themeColors.gray[70],
            accent: styles.themeColors.gray[70],
            danger: styles.themeColors.gray[70],
        },
    },
    active: {
        primary: {
            primary: styles.themeColors.blue[70],
            accent: styles.themeColors.yellow[60],
            danger: styles.themeColors.red[70],
        },
        ghost: {
            primary: styles.themeColors.blue[20],
            accent: styles.themeColors.blue[20],
            danger: styles.themeColors.red[20],
        },
        text: transparentColors,
        copy: {
            primary: styles.themeColors.blue[20],
            accent: styles.themeColors.blue[20],
            danger: styles.themeColors.red[20],
        },
        copySpecial: {
            primary: styles.themeColors.gray[70],
            accent: styles.themeColors.gray[70],
            danger: styles.themeColors.gray[70],
        },
    },
};
var colorsMap$1 = {
    default: {
        primary: {
            primary: styles.themeColors.white,
            accent: styles.themeColors.black,
            danger: styles.themeColors.white,
        },
        ghost: blueRedColors,
        text: blueRedColors,
        copy: blueRedColors,
        copySpecial: yellowColors,
    },
    hover: {
        primary: {
            primary: styles.themeColors.white,
            accent: styles.themeColors.black,
            danger: styles.themeColors.white,
        },
        ghost: blueRedColors,
        text: blueRedColors,
        copy: blueRedColors,
        copySpecial: yellowColors,
    },
    active: {
        primary: {
            primary: styles.themeColors.white,
            accent: styles.themeColors.black,
            danger: styles.themeColors.white,
        },
        ghost: blueRedColors,
        text: {
            primary: styles.themeColors.blue[80],
            accent: styles.themeColors.blue[80],
            danger: styles.themeColors.red[80],
        },
        copy: blueRedColors,
        copySpecial: yellowColors,
    },
};
var borderColorsMap$1 = {
    default: {
        primary: {
            primary: styles.themeColors.blue[60],
            accent: styles.themeColors.yellow[50],
            danger: styles.themeColors.red[60],
        },
        ghost: blueRedColors,
        text: transparentColors,
        copy: blueRedColors,
        copySpecial: yellowColors,
    },
    hover: {
        primary: {
            primary: styles.themeColors.blue[50],
            accent: styles.themeColors.yellow[40],
            danger: styles.themeColors.red[50],
        },
        ghost: blueRedColors,
        copy: blueRedColors,
        text: transparentColors,
        copySpecial: yellowColors,
    },
    active: {
        primary: {
            primary: styles.themeColors.blue[70],
            accent: styles.themeColors.yellow[60],
            danger: styles.themeColors.red[70],
        },
        ghost: blueRedColors,
        copy: blueRedColors,
        text: transparentColors,
        copySpecial: yellowColors,
    },
};

var fontSizes = {
    large: 16,
    medium: 16,
    small: 14,
};
var lineHeights = {
    large: 24,
    medium: 24,
    small: 21,
};
var paddings$1 = {
    large: '19px 42px',
    medium: '11px 42px',
    small: '3px 8px',
};
var ButtonView$3 = styled__default.default.button.withConfig({ shouldForwardProp: Spacing.isPropValid })(templateObject_1$1_ || (templateObject_1$1_ = _tslib.__makeTemplateObject(["\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  box-sizing: border-box;\n  padding: ", ";\n  width: 100%;\n  transition: ", "s;\n  font-weight: 500;\n  font-size: ", "px;\n  line-height: ", "px;\n  border-radius: ", "px;\n  cursor: ", ";\n  background-color: ", ";\n  color: ", ";\n  border: ", ";\n  opacity: ", ";\n\n  @media ", " {\n    width: ", ";\n  }\n\n  &:hover {\n    ", "\n  }\n\n  &:active {\n    ", "\n  }\n\n  &:focus {\n    ", "\n  }\n"], ["\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  box-sizing: border-box;\n  padding: ", ";\n  width: 100%;\n  transition: ", "s;\n  font-weight: 500;\n  font-size: ", "px;\n  line-height: ", "px;\n  border-radius: ", "px;\n  cursor: ", ";\n  background-color: ", ";\n  color: ", ";\n  border: ", ";\n  opacity: ", ";\n\n  @media ", " {\n    width: ", ";\n  }\n\n  &:hover {\n    ", "\n  }\n\n  &:active {\n    ", "\n  }\n\n  &:focus {\n    ", "\n  }\n"])), function (props) { return paddings$1[props.buttonSize]; }, styles.transitionTime, function (props) { return fontSizes[props.buttonSize]; }, function (props) { return lineHeights[props.buttonSize]; }, styles.themeBorder.radius.default, function (props) { return (props.disabled ? 'not-allowed' : 'pointer'); }, function (props) { return backgroundsMap$1.default[props.buttonVariant][props.buttonColor]; }, function (props) { return colorsMap$1.default[props.buttonVariant][props.buttonColor]; }, function (props) {
    return "".concat(props.border, " ").concat(props.borderStyle, " ").concat(borderColorsMap$1.default[props.buttonVariant][props.buttonColor]);
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? '20%' : undefined);
}, ResponsiveSizes.tablet, function (_a) {
    var fullWidth = _a.fullWidth;
    return (fullWidth ? '100%' : 'unset');
}, function (props) {
    if (props.disabled) {
        return;
    }
    return "\n        background-color: ".concat(backgroundsMap$1.hover[props.buttonVariant][props.buttonColor], ";\n        color:").concat(colorsMap$1.hover[props.buttonVariant][props.buttonColor], ";\n        border: ").concat(props.border, " ").concat(props.borderStyle, " ").concat(borderColorsMap$1.default[props.buttonVariant][props.buttonColor], " ").concat(borderColorsMap$1.hover[props.buttonVariant][props.buttonColor], ";\n      ");
}, function (props) {
    if (props.disabled) {
        return;
    }
    return "\n        background-color: ".concat(backgroundsMap$1.active[props.buttonVariant][props.buttonColor], ";\n        color:").concat(colorsMap$1.active[props.buttonVariant][props.buttonColor], ";\n        border: ").concat(props.border, " ").concat(props.borderStyle, " ").concat(borderColorsMap$1.default[props.buttonVariant][props.buttonColor], " ").concat(borderColorsMap$1.hover[props.buttonVariant][props.buttonColor], ";\n      ");
}, function (props) {
    if (props.disabled) {
        return '';
    }
    return "\n        background-color: ".concat(backgroundsMap$1.active[props.buttonVariant][props.buttonColor], ";\n        color:").concat(colorsMap$1.active[props.buttonVariant][props.buttonColor], ";\n        border: ").concat(props.border, " ").concat(props.borderStyle, " ").concat(borderColorsMap$1.default[props.buttonVariant][props.buttonColor], " ").concat(borderColorsMap$1.hover[props.buttonVariant][props.buttonColor], ";\n      ");
});
var templateObject_1$1_;

var DEFAULT_HREF = '/sprite.svg';
var IconContext = React__namespace.default.createContext({ spriteHref: DEFAULT_HREF });
var IconProvider = function (_a) {
    var _b = _a.spriteHref, spriteHref = _b === void 0 ? DEFAULT_HREF : _b, children = _a.children;
    return React__namespace.default.createElement(IconContext.Provider, { value: { spriteHref: spriteHref } }, children);
};

var Icon = function (_a) {
    var name = _a.name, props = _tslib.__rest(_a, ["name"]);
    var context = React__namespace.useContext(IconContext);
    return (React__namespace.createElement(StyledSvg, _tslib.__assign({}, props),
        React__namespace.createElement("use", { href: "".concat(context.spriteHref, "#ic_").concat(name) })));
};
var StyledSvg = styled__default.default.svg.withConfig({ displayName: "StyledSvg", componentId: "-v2e28x" })(templateObject_1$1Z || (templateObject_1$1Z = _tslib.__makeTemplateObject(["\n  --svg-color: ", ";\n"], ["\n  --svg-color: ", ";\n"])), function (_a) {
    var color = _a.color;
    return color;
});
var templateObject_1$1Z;

var Button$2 = React__namespace.forwardRef(function (_a, ref) {
    var _b = _a.iconSide, iconSide = _b === void 0 ? 'left' : _b, _c = _a.size, size = _c === void 0 ? 'medium' : _c, _d = _a.color, color = _d === void 0 ? 'primary' : _d, _e = _a.as, as = _e === void 0 ? 'button' : _e, target = _a.target, rel = _a.rel, props = _tslib.__rest(_a, ["iconSide", "size", "color", "as", "target", "rel"]);
    var defaultButtonBorderStyles = {
        border: '1px',
        borderStyle: 'solid',
    };
    var borderStyles = {
        primary: defaultButtonBorderStyles,
        ghost: defaultButtonBorderStyles,
        text: defaultButtonBorderStyles,
        copy: { border: '2px', borderStyle: 'dashed' },
        copySpecial: { border: '2px', borderStyle: 'dashed' },
    };
    var _f = borderStyles[props.variant] || borderStyles.primary, border = _f.border, borderStyle = _f.borderStyle;
    return (React__namespace.createElement(ButtonView$3, { as: as, href: props.href, onClick: props.onClick, buttonVariant: props.variant, buttonSize: size, buttonColor: color, fullWidth: props.fullWidth, disabled: props.disabled, loading: props.loading, border: border, borderStyle: borderStyle, className: props.className, target: target, rel: rel, ref: ref },
        React__namespace.createElement(Spacing.SpanFlex, { justify: "center", align: "center", flexDir: iconSide === 'right' ? 'row-reverse' : 'row', gap: "8px" }, props.loading ? (React__namespace.createElement(Loader$1, null)) : (React__namespace.createElement(React__namespace.Fragment, null,
            props.icon && (React__namespace.createElement(Icon, { name: props.icon, color: colorsMap$1.default[props.variant][color], width: 24, height: 24 })),
            props.children)))));
});
Button$2.displayName = 'Button';
var Loader$1 = styled__default.default.div.withConfig({ displayName: "Loader", componentId: "-w4b10s" })(templateObject_1$1Y || (templateObject_1$1Y = _tslib.__makeTemplateObject(["\n  box-sizing: border-box;\n  width: 24px;\n  height: 24px;\n  color: inherit;\n  pointer-events: none;\n\n  border: 0.2em solid transparent;\n  border-top-color: currentcolor;\n  border-radius: 50%;\n  animation: 1s loader-05 linear infinite;\n  position: relative;\n\n  &:before {\n    content: '';\n    box-sizing: border-box;\n    display: block;\n    width: inherit;\n    height: inherit;\n    position: absolute;\n    top: -0.2em;\n    left: -0.2em;\n    border: 0.2em solid currentcolor;\n    border-radius: 50%;\n    opacity: 0.5;\n  }\n\n  @keyframes loader-05 {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n"], ["\n  box-sizing: border-box;\n  width: 24px;\n  height: 24px;\n  color: inherit;\n  pointer-events: none;\n\n  border: 0.2em solid transparent;\n  border-top-color: currentcolor;\n  border-radius: 50%;\n  animation: 1s loader-05 linear infinite;\n  position: relative;\n\n  &:before {\n    content: '';\n    box-sizing: border-box;\n    display: block;\n    width: inherit;\n    height: inherit;\n    position: absolute;\n    top: -0.2em;\n    left: -0.2em;\n    border: 0.2em solid currentcolor;\n    border-radius: 50%;\n    opacity: 0.5;\n  }\n\n  @keyframes loader-05 {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n"])));
var templateObject_1$1Y;

var backgroundsMap = {
    default: {
        primary: {
            primary: styles.themeColors.blue[60],
            danger: styles.themeColors.red[60],
        },
        secondary: {
            primary: 'transparent',
            danger: 'transparent',
        },
        text: {
            primary: 'transparent',
            danger: 'transparent',
        },
    },
    hover: {
        primary: {
            primary: styles.themeColors.blue[50],
            danger: styles.themeColors.red[50],
        },
        secondary: {
            primary: styles.themeColors.blue[10],
            danger: styles.themeColors.red[10],
        },
        text: {
            primary: styles.themeColors.blue[10],
            danger: styles.themeColors.red[10],
        },
    },
    active: {
        primary: {
            primary: styles.themeColors.blue[70],
            danger: styles.themeColors.red[70],
        },
        secondary: {
            primary: styles.themeColors.blue[20],
            danger: styles.themeColors.red[20],
        },
        text: {
            primary: styles.themeColors.blue[20],
            danger: styles.themeColors.red[20],
        },
    },
};
var disabledBackgroundMap = {
    primary: {
        primary: styles.themeColors.blue[60],
        danger: styles.themeColors.red[60],
    },
    secondary: {
        primary: styles.themeColors.blue[20],
        danger: styles.themeColors.red[20],
    },
    text: {
        primary: styles.themeColors.blue[20],
        danger: styles.themeColors.red[20],
    },
};
var colorsMap = {
    default: {
        primary: {
            primary: styles.themeColors.white,
            danger: styles.themeColors.white,
        },
        secondary: {
            primary: '#15162E',
            danger: '#15162E',
        },
        text: {
            primary: '#15162E',
            danger: '#15162E',
        },
    },
    hover: {
        primary: {
            primary: styles.themeColors.white,
            danger: styles.themeColors.white,
        },
        secondary: {
            primary: '#15162E',
            danger: '#15162E',
        },
        text: {
            primary: '#15162E',
            danger: '#15162E',
        },
    },
    active: {
        primary: {
            primary: styles.themeColors.white,
            danger: styles.themeColors.white,
        },
        secondary: {
            primary: '#15162E',
            danger: '#15162E',
        },
        text: {
            primary: '#15162E',
            danger: '#15162E',
        },
    },
};
var borderColorsMap = {
    default: {
        primary: {
            primary: styles.themeColors.blue[60],
            danger: styles.themeColors.red[60],
        },
        secondary: {
            primary: styles.themeColors.blue[60],
            danger: styles.themeColors.red[60],
        },
        text: {
            primary: 'transparent',
            danger: 'transparent',
        },
    },
    hover: {
        primary: {
            primary: styles.themeColors.blue[50],
            danger: styles.themeColors.red[50],
        },
        secondary: {
            primary: styles.themeColors.blue[60],
            danger: styles.themeColors.red[60],
        },
        text: {
            primary: styles.themeColors.blue[10],
            danger: styles.themeColors.red[10],
        },
    },
    active: {
        primary: {
            primary: styles.themeColors.blue[70],
            danger: styles.themeColors.red[70],
        },
        secondary: {
            primary: styles.themeColors.blue[60],
            danger: styles.themeColors.red[60],
        },
        text: {
            primary: styles.themeColors.blue[20],
            danger: styles.themeColors.red[20],
        },
    },
};

var CSS_ICON_COLOR_VARIABLE = '--icon-button-color';
var paddings = {
    large: '12px',
    medium: '8px',
    small: '4px',
};
var sizes = {
    large: 40,
    medium: 32,
    small: 24,
};
var ButtonIcon = React__namespace.forwardRef(function (_a, ref) {
    var icon = _a.icon, variant = _a.variant, _b = _a.size, size = _b === void 0 ? 'large' : _b, _c = _a.color, color = _c === void 0 ? 'primary' : _c, disabled = _a.disabled; _tslib.__rest(_a, ["icon", "variant", "size", "color", "disabled"]);
    return (React__namespace.createElement(StyledIconButton, { variant: variant, size: size, color: color, disabled: disabled },
        React__namespace.createElement(Icon, { width: sizes["".concat(size)], height: sizes["".concat(size)], name: icon, color: "var(".concat(CSS_ICON_COLOR_VARIABLE, ")") })));
});
ButtonIcon.displayName = 'ButtonIcon';
var StyledIconButton = styled__default.default.button.withConfig({ shouldForwardProp: Spacing.isPropValid })(templateObject_1$1X || (templateObject_1$1X = _tslib.__makeTemplateObject(["\n  ", ": ", ";\n\n  display: block;\n  box-sizing: border-box;\n  appearance: none;\n  line-height: 0;\n  transition-property: color, background, opacity, border;\n  transition-duration: ", "s;\n  border-radius: ", "px;\n  cursor: ", ";\n  padding: ", ";\n  background-color: ", ";\n  color: ", ";\n  border: 1px solid ", ";\n  opacity: ", ";\n\n  &:hover {\n    ", ": ", ";\n\n    ", "\n  }\n\n  &:active,\n  &:focus {\n    ", ": ", ";\n\n    ", "\n  }\n"], ["\n  ", ": ", ";\n\n  display: block;\n  box-sizing: border-box;\n  appearance: none;\n  line-height: 0;\n  transition-property: color, background, opacity, border;\n  transition-duration: ", "s;\n  border-radius: ", "px;\n  cursor: ", ";\n  padding: ", ";\n  background-color: ", ";\n  color: ", ";\n  border: 1px solid ", ";\n  opacity: ", ";\n\n  &:hover {\n    ", ": ", ";\n\n    ", "\n  }\n\n  &:active,\n  &:focus {\n    ", ": ", ";\n\n    ", "\n  }\n"])), CSS_ICON_COLOR_VARIABLE, function (_a) {
    var variant = _a.variant, color = _a.color;
    return colorsMap.default["".concat(variant)]["".concat(color)];
}, styles.transitionTime, styles.themeBorder.radius.default, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'not-allowed' : 'pointer');
}, function (_a) {
    var size = _a.size;
    return paddings["".concat(size)];
}, function (_a) {
    var variant = _a.variant, color = _a.color, disabled = _a.disabled;
    if (disabled) {
        return disabledBackgroundMap["".concat(variant)]["".concat(color)];
    }
    return backgroundsMap.default["".concat(variant)]["".concat(color)];
}, function (_a) {
    var variant = _a.variant, color = _a.color;
    return colorsMap.default["".concat(variant)]["".concat(color)];
}, function (_a) {
    var variant = _a.variant, color = _a.color;
    return borderColorsMap.default["".concat(variant)]["".concat(color)];
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? '20%' : undefined);
}, CSS_ICON_COLOR_VARIABLE, function (_a) {
    var variant = _a.variant, color = _a.color;
    return colorsMap.hover["".concat(variant)]["".concat(color)];
}, function (_a) {
    var variant = _a.variant, color = _a.color, disabled = _a.disabled;
    if (disabled) {
        return;
    }
    return "\n        background-color: ".concat(backgroundsMap.hover["".concat(variant)]["".concat(color)], ";\n        color: ").concat(colorsMap.hover["".concat(variant)]["".concat(color)], ";\n        border: 1px solid ").concat(borderColorsMap.hover["".concat(variant)]["".concat(color)], ";\n        opacity: ").concat(variant === 'text' ? '0.6' : '1', "\n      ");
}, CSS_ICON_COLOR_VARIABLE, function (_a) {
    var variant = _a.variant, color = _a.color;
    return colorsMap.active["".concat(variant)]["".concat(color)];
}, function (_a) {
    var variant = _a.variant, color = _a.color, disabled = _a.disabled;
    if (disabled) {
        return;
    }
    return "\n        background-color: ".concat(backgroundsMap.active["".concat(variant)]["".concat(color)], ";\n        color:").concat(colorsMap.active["".concat(variant)]["".concat(color)], ";\n        border: 1px solid ").concat(borderColorsMap.active["".concat(variant)]["".concat(color)], ";\n        opacity: 1;\n      ");
});
var templateObject_1$1X;

var checkmark = 'check-sign';
var content = 'content';
var InputCheckbox = function (props) { return (React__namespace.createElement(ContainerView$2, { onClick: props.onClickLabel, className: classNames__default.default(props.error && 'error') },
    props.children && React__namespace.createElement("div", { className: content }, props.children),
    React__namespace.createElement("input", { type: "checkbox", onChange: function (event) { return props.onChange && props.onChange(event.target.checked); }, checked: props.checked, required: props.required, disabled: props.disabled }),
    React__namespace.createElement("span", { className: classNames__default.default(checkmark, 'checkbox') }, props.checkedIcon && props.checked ? props.checkedIcon : React__namespace.createElement(AchievementStar.CheckedIcon, null)))); };
var ContainerView$2 = styled__default.default.label.withConfig({ displayName: "ContainerView", componentId: "-d4gh3f" })(templateObject_1$1W || (templateObject_1$1W = _tslib.__makeTemplateObject(["\n  color: ", ";\n  font-weight: ", ";\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  position: relative;\n  padding-left: 20px;\n  height: 24px;\n  cursor: pointer;\n  user-select: none;\n  border-radius: 2px;\n\n  .", " svg {\n    display: none;\n  }\n  .", " {\n    display: flex;\n    align-items: center;\n    margin-left: 10px;\n  }\n  .", " {\n    border-radius: 2px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 24px;\n    width: 24px;\n    background-color: #ffffff;\n    border: 2px solid ", ";\n    box-sizing: border-box;\n    transition: 0.3s;\n  }\n  input {\n    border-radius: 2px;\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 24px;\n    width: 24px;\n    margin: 0;\n    padding: 0;\n    background-color: #ffffff;\n    &:checked ~ .", " {\n      background-color: ", ";\n      border-color: ", ";\n\n      &.checkbox {\n        svg {\n          display: block;\n        }\n      }\n    }\n    &:disabled:checked ~ .", " {\n      background-color: ", ";\n      border-color: ", ";\n    }\n\n    &:disabled ~ .", " {\n      background-color: ", ";\n      border-color: ", ";\n    }\n  }\n\n  &:hover input:not(:disabled):checked ~ .", " {\n    background-color: ", ";\n  }\n\n  &:hover input:not(:disabled) ~ .", " {\n    background-color: ", ";\n    border-color: ", ";\n  }\n\n  &.error .checkbox {\n    border-color: ", ";\n  }\n"], ["\n  color: ", ";\n  font-weight: ", ";\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  position: relative;\n  padding-left: 20px;\n  height: 24px;\n  cursor: pointer;\n  user-select: none;\n  border-radius: 2px;\n\n  .", " svg {\n    display: none;\n  }\n  .", " {\n    display: flex;\n    align-items: center;\n    margin-left: 10px;\n  }\n  .", " {\n    border-radius: 2px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 24px;\n    width: 24px;\n    background-color: #ffffff;\n    border: 2px solid ", ";\n    box-sizing: border-box;\n    transition: 0.3s;\n  }\n  input {\n    border-radius: 2px;\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 24px;\n    width: 24px;\n    margin: 0;\n    padding: 0;\n    background-color: #ffffff;\n    &:checked ~ .", " {\n      background-color: ", ";\n      border-color: ", ";\n\n      &.checkbox {\n        svg {\n          display: block;\n        }\n      }\n    }\n    &:disabled:checked ~ .", " {\n      background-color: ", ";\n      border-color: ", ";\n    }\n\n    &:disabled ~ .", " {\n      background-color: ", ";\n      border-color: ", ";\n    }\n  }\n\n  &:hover input:not(:disabled):checked ~ .", " {\n    background-color: ", ";\n  }\n\n  &:hover input:not(:disabled) ~ .", " {\n    background-color: ", ";\n    border-color: ", ";\n  }\n\n  &.error .checkbox {\n    border-color: ", ";\n  }\n"])), styles.themeColors.gray['90'], styles.FONT_WEIGHT.REGULAR, checkmark, content, checkmark, styles.themeColors.gray['50'], checkmark, styles.themeColors.blue['60'], styles.themeColors.blue['60'], checkmark, styles.themeColors.gray['40'], styles.themeColors.gray['40'], checkmark, styles.themeColors.gray['20'], styles.themeColors.gray['40'], checkmark, styles.themeColors.blue['50'], checkmark, styles.themeColors.blue['10'], styles.themeColors.blue['60'], styles.themeColors.red[60]);
var templateObject_1$1W;

var InputRadio = function (props) { return (React__namespace.createElement(StyledLabel, { onClick: props.onClickLabel, className: classNames__default.default(props.error && 'error') },
    React__namespace.createElement(StyledRadioButton, { type: "radio", onChange: function (event) { return props.onChange && props.onChange(event.target.checked); }, checked: props.checked, required: props.required, disabled: props.disabled, "$error": props.error }),
    props.children && React__namespace.createElement("div", null, props.children))); };
var StyledLabel = styled__default.default.label.withConfig({ displayName: "StyledLabel", componentId: "-1tygy0" })(templateObject_1$1V || (templateObject_1$1V = _tslib.__makeTemplateObject(["\n  display: flex;\n  gap: 8px;\n  align-items: center;\n"], ["\n  display: flex;\n  gap: 8px;\n  align-items: center;\n"])));
var StyledRadioButton = styled__default.default.input.withConfig({ displayName: "StyledRadioButton", componentId: "-1mmu750" })(templateObject_4$D || (templateObject_4$D = _tslib.__makeTemplateObject(["\n  -webkit-appearance: none;\n  appearance: none;\n  cursor: pointer;\n  background-color: #fff;\n  margin: 0;\n  font: inherit;\n  color: currentColor;\n  width: 20px;\n  height: 20px;\n  border: 2px solid ", ";\n  border-radius: 50%;\n  display: grid;\n  place-content: center;\n  transition-property: border-color;\n  transition-duration: 0.3s;\n\n  ", "\n\n  &:disabled {\n    border-color: ", ";\n  }\n\n  &::before {\n    content: '';\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    opacity: 0;\n    background-color: ", ";\n    transition-property: opacity;\n    transition-duration: 0.3s;\n\n    ", "\n  }\n\n  &:checked::before {\n    opacity: 1;\n  }\n\n  &:checked:disabled::before {\n    background-color: ", ";\n  }\n\n  &:focus {\n    box-shadow: 0px 0px 0px 4px ", ";\n    outline: none;\n  }\n"], ["\n  -webkit-appearance: none;\n  appearance: none;\n  cursor: pointer;\n  background-color: #fff;\n  margin: 0;\n  font: inherit;\n  color: currentColor;\n  width: 20px;\n  height: 20px;\n  border: 2px solid ", ";\n  border-radius: 50%;\n  display: grid;\n  place-content: center;\n  transition-property: border-color;\n  transition-duration: 0.3s;\n\n  ", "\n\n  &:disabled {\n    border-color: ", ";\n  }\n\n  &::before {\n    content: '';\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    opacity: 0;\n    background-color: ", ";\n    transition-property: opacity;\n    transition-duration: 0.3s;\n\n    ", "\n  }\n\n  &:checked::before {\n    opacity: 1;\n  }\n\n  &:checked:disabled::before {\n    background-color: ", ";\n  }\n\n  &:focus {\n    box-shadow: 0px 0px 0px 4px ", ";\n    outline: none;\n  }\n"])), styles.themeColors.blue[50], function (_a) {
    var $error = _a.$error;
    return $error && styled.css(templateObject_2$1s || (templateObject_2$1s = _tslib.__makeTemplateObject(["\n      border-color: ", ";\n    "], ["\n      border-color: ", ";\n    "])), styles.themeColors.red[60]);
}, styles.themeColors.gray['40'], styles.themeColors.blue[50], function (_a) {
    var $error = _a.$error;
    return $error && styled.css(templateObject_3$Z || (templateObject_3$Z = _tslib.__makeTemplateObject(["\n        background-color: ", ";\n      "], ["\n        background-color: ", ";\n      "])), styles.themeColors.red[60]);
}, styles.themeColors.gray['40'], styles.themeColors.blue[30]);
var templateObject_1$1V, templateObject_2$1s, templateObject_3$Z, templateObject_4$D;

var _a$2;
var IconButtonSize;
(function (IconButtonSize) {
    IconButtonSize["REGULAR"] = "regular";
    IconButtonSize["LARGE"] = "large";
})(IconButtonSize || (IconButtonSize = {}));
var IconButtonSizes = (_a$2 = {},
    _a$2[IconButtonSize.REGULAR] = 32,
    _a$2[IconButtonSize.LARGE] = 48,
    _a$2);
var IconButton$3 = function (props) {
    var Icon = props.icon;
    var buttonSize = IconButtonSizes[props.size || IconButtonSize.REGULAR];
    return (React__namespace.createElement(Anchor, { href: props.href, target: props.newWindow ? '_blank' : undefined, rel: props.rel, iconSize: buttonSize },
        React__namespace.createElement(Icon, { size: buttonSize - 8, color: styles.themeColors.gray[60] })));
};
var Anchor = styled__default.default.a.withConfig({ displayName: "Anchor", componentId: "-56sf6a" })(templateObject_1$1U || (templateObject_1$1U = _tslib.__makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  width: ", "px;\n  height: ", "px;\n  margin: 4px;\n  &:hover {\n    background-color: ", ";\n    border-radius: 4px;\n  }\n  &:focus,\n  &:active {\n    background-color: ", ";\n    border-radius: 4px;\n    svg {\n      fill: ", ";\n    }\n  }\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  width: ", "px;\n  height: ", "px;\n  margin: 4px;\n  &:hover {\n    background-color: ", ";\n    border-radius: 4px;\n  }\n  &:focus,\n  &:active {\n    background-color: ", ";\n    border-radius: 4px;\n    svg {\n      fill: ", ";\n    }\n  }\n"])), function (props) { return props.iconSize; }, function (props) { return props.iconSize; }, styles.themeColors.gray[20], styles.themeColors.gray[20], styles.themeColors.gray[70]);
var templateObject_1$1U;

var Label = function (props) { return (React__namespace.createElement(Spacing.Flex, { justify: Spacing.FlexJustify.SPACE_BETWEEN, className: props.className },
    React__namespace.createElement(Spacing.Flex, { justify: Spacing.FlexJustify.FLEX_START, align: Spacing.FlexAlign.CENTER }, props.title),
    React__namespace.createElement(Spacing.Flex, { justify: Spacing.FlexJustify.FLEX_END, align: Spacing.FlexAlign.CENTER }, props.values))); };

var LOADER_SIZE = 64;
var FeFilter = function () { return (React__namespace.createElement("svg", null,
    React__namespace.createElement("defs", null,
        React__namespace.createElement("filter", { id: "loader_goo" },
            React__namespace.createElement("feGaussianBlur", { in: "SourceGraphic", stdDeviation: "5", result: "blur" }),
            React__namespace.createElement("feColorMatrix", { in: "blur", mode: "matrix", values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -7", result: "loader_goo" }),
            React__namespace.createElement("feBlend", { in: "SourceGraphic", in2: "loader_goo" }))))); };
var Loader = function (props) { return (React__namespace.createElement(Wrapper$4, { scale: props.scale },
    _tslib.__spreadArray([], _tslib.__read(Array(8)), false).map(function (_, index) { return (React__namespace.createElement(BubbleWrap, { key: index },
        React__namespace.createElement(Bubble, null))); }),
    React__namespace.createElement(SatelliteWrapper, null,
        React__namespace.createElement(Satellite, null)),
    React__namespace.createElement(FeFilter, null))); };
var Wrapper$4 = styled__default.default.div.withConfig({ displayName: "Wrapper", componentId: "-dq4qo1" })(templateObject_1$1T || (templateObject_1$1T = _tslib.__makeTemplateObject(["\n  ", "\n  font-size: 16px;\n  position: relative;\n  border-radius: 50%;\n  filter: url('#loader_goo');\n\n  > * {\n    display: block;\n    position: absolute;\n    top: 40%;\n    left: 40%;\n    width: 0.8rem;\n    height: 0.8rem;\n  }\n\n  > *:nth-of-type(1) {\n    transform: rotate(0deg) translate(2rem) rotate(0deg);\n  }\n\n  > *:nth-of-type(1) > div {\n    animation: grow 4s ease infinite;\n    animation-delay: -0.1s;\n  }\n\n  > *:nth-of-type(2) {\n    transform: rotate(45deg) translate(2rem) rotate(-45deg);\n  }\n\n  > *:nth-of-type(2) > div {\n    animation: grow 4s ease infinite;\n    animation-delay: 0.4s;\n  }\n\n  > *:nth-of-type(3) {\n    transform: rotate(90deg) translate(2rem) rotate(-90deg);\n  }\n\n  > *:nth-of-type(3) > div {\n    animation: grow 4s ease infinite;\n    animation-delay: 0.9s;\n  }\n\n  > *:nth-of-type(4) {\n    transform: rotate(135deg) translate(2rem) rotate(-135deg);\n  }\n\n  > *:nth-of-type(4) > div {\n    animation: grow 4s ease infinite;\n    animation-delay: 1.4s;\n  }\n\n  > *:nth-of-type(5) {\n    transform: rotate(180deg) translate(2rem) rotate(-180deg);\n  }\n\n  > *:nth-of-type(5) > div {\n    animation: grow 4s ease infinite;\n    animation-delay: 1.9s;\n  }\n\n  > *:nth-of-type(6) {\n    transform: rotate(225deg) translate(2rem) rotate(-225deg);\n  }\n\n  > *:nth-of-type(6) > div {\n    animation: grow 4s ease infinite;\n    animation-delay: 2.4s;\n  }\n\n  > *:nth-of-type(7) {\n    transform: rotate(270deg) translate(2rem) rotate(-270deg);\n  }\n\n  > *:nth-of-type(7) > div {\n    animation: grow 4s ease infinite;\n    animation-delay: 2.9s;\n  }\n\n  > *:nth-of-type(8) {\n    transform: rotate(315deg) translate(2rem) rotate(-315deg);\n  }\n\n  > *:nth-of-type(8) > div {\n    animation: grow 4s ease infinite;\n    animation-delay: 3.4s;\n  }\n\n  @keyframes grow {\n    0%,\n    15%,\n    100% {\n      transform: scale(1);\n    }\n    5% {\n      transform: scale(1.2);\n    }\n  }\n"], ["\n  ", "\n  font-size: 16px;\n  position: relative;\n  border-radius: 50%;\n  filter: url('#loader_goo');\n\n  > * {\n    display: block;\n    position: absolute;\n    top: 40%;\n    left: 40%;\n    width: 0.8rem;\n    height: 0.8rem;\n  }\n\n  > *:nth-of-type(1) {\n    transform: rotate(0deg) translate(2rem) rotate(0deg);\n  }\n\n  > *:nth-of-type(1) > div {\n    animation: grow 4s ease infinite;\n    animation-delay: -0.1s;\n  }\n\n  > *:nth-of-type(2) {\n    transform: rotate(45deg) translate(2rem) rotate(-45deg);\n  }\n\n  > *:nth-of-type(2) > div {\n    animation: grow 4s ease infinite;\n    animation-delay: 0.4s;\n  }\n\n  > *:nth-of-type(3) {\n    transform: rotate(90deg) translate(2rem) rotate(-90deg);\n  }\n\n  > *:nth-of-type(3) > div {\n    animation: grow 4s ease infinite;\n    animation-delay: 0.9s;\n  }\n\n  > *:nth-of-type(4) {\n    transform: rotate(135deg) translate(2rem) rotate(-135deg);\n  }\n\n  > *:nth-of-type(4) > div {\n    animation: grow 4s ease infinite;\n    animation-delay: 1.4s;\n  }\n\n  > *:nth-of-type(5) {\n    transform: rotate(180deg) translate(2rem) rotate(-180deg);\n  }\n\n  > *:nth-of-type(5) > div {\n    animation: grow 4s ease infinite;\n    animation-delay: 1.9s;\n  }\n\n  > *:nth-of-type(6) {\n    transform: rotate(225deg) translate(2rem) rotate(-225deg);\n  }\n\n  > *:nth-of-type(6) > div {\n    animation: grow 4s ease infinite;\n    animation-delay: 2.4s;\n  }\n\n  > *:nth-of-type(7) {\n    transform: rotate(270deg) translate(2rem) rotate(-270deg);\n  }\n\n  > *:nth-of-type(7) > div {\n    animation: grow 4s ease infinite;\n    animation-delay: 2.9s;\n  }\n\n  > *:nth-of-type(8) {\n    transform: rotate(315deg) translate(2rem) rotate(-315deg);\n  }\n\n  > *:nth-of-type(8) > div {\n    animation: grow 4s ease infinite;\n    animation-delay: 3.4s;\n  }\n\n  @keyframes grow {\n    0%,\n    15%,\n    100% {\n      transform: scale(1);\n    }\n    5% {\n      transform: scale(1.2);\n    }\n  }\n"])), function (props) {
    return Spacing.isUndefined(props.scale)
        ? "\n  width: 4rem;\n  height: 4rem;\n      "
        : "\n  transform: scale(".concat(props.scale, ");\n  width: ").concat(props.scale * LOADER_SIZE, "px;\n  height: ").concat(props.scale * LOADER_SIZE, "px;\n  ");
});
var BubbleWrap = styled__default.default.div.withConfig({ displayName: "BubbleWrap", componentId: "-j2sc0i" })(templateObject_2$1r || (templateObject_2$1r = _tslib.__makeTemplateObject(["\n  max-width: 100%;\n"], ["\n  max-width: 100%;\n"])));
var Bubble = styled__default.default.div.withConfig({ displayName: "Bubble", componentId: "-jh2se2" })(templateObject_3$Y || (templateObject_3$Y = _tslib.__makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  background: ", ";\n"], ["\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  background: ", ";\n"])), styles.themeColors.other.loader.bubble);
var SatelliteWrapper = styled__default.default.div.withConfig({ displayName: "SatelliteWrapper", componentId: "-utzwdd" })(templateObject_4$C || (templateObject_4$C = _tslib.__makeTemplateObject(["\n  animation: spin 4s linear infinite;\n  @keyframes spin {\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n"], ["\n  animation: spin 4s linear infinite;\n  @keyframes spin {\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n"])));
var Satellite = styled__default.default.div.withConfig({ displayName: "Satellite", componentId: "-1jkepw" })(templateObject_5$o || (templateObject_5$o = _tslib.__makeTemplateObject(["\n  width: 0.75em;\n  height: 0.75em;\n  background: ", ";\n  border-radius: 50%;\n  margin-left: 2em;\n  box-shadow: 0 0 50px -4px ", ";\n"], ["\n  width: 0.75em;\n  height: 0.75em;\n  background: ", ";\n  border-radius: 50%;\n  margin-left: 2em;\n  box-shadow: 0 0 50px -4px ", ";\n"])), styles.themeColors.other.loader.satellite, styles.themeColors.other.loader.satellite);
var templateObject_1$1T, templateObject_2$1r, templateObject_3$Y, templateObject_4$C, templateObject_5$o;

var getIconColor = function (letter) {
    var colors = Object.values(styles.themeColors.other.avatar);
    var colorNr = letter.charCodeAt(0) % colors.length;
    return colors[colorNr];
};
var NamedAvatar = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 32 : _b, props = _tslib.__rest(_a, ["size"]);
    return (React__namespace.createElement(IconView$3, { className: props.className, style: { backgroundColor: getIconColor(props.firstLetter) }, size: size, hoverEnabled: props.hoverEnabled },
        React__namespace.createElement(Letter, null, props.firstLetter)));
};
var Letter = styled__default.default.span.withConfig({ displayName: "Letter", componentId: "-fyt4an" })(templateObject_1$1S || (templateObject_1$1S = _tslib.__makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), styles.themeColors.white);
var IconView$3 = styled__default.default(Spacing.Flex).withConfig({ displayName: "IconView", componentId: "-1s1715w" })(templateObject_2$1q || (templateObject_2$1q = _tslib.__makeTemplateObject(["\n  width: ", "px;\n  height: ", "px;\n  background-color: gray;\n  border-radius: 50%;\n  justify-content: ", ";\n  align-items: ", ";\n\n  ", "\n"], ["\n  width: ", "px;\n  height: ", "px;\n  background-color: gray;\n  border-radius: 50%;\n  justify-content: ", ";\n  align-items: ", ";\n\n  ", "\n"])), function (props) { return props.size; }, function (props) { return props.size; }, Spacing.FlexJustify.CENTER, Spacing.FlexAlign.CENTER, function (props) {
    return props.hoverEnabled
        ? "\n    &:hover {\n      border: 4px solid ".concat(styles.themeColors.gray[20], ";\n      margin-top: -4px;\n      margin-left: -4px;\n    }")
        : undefined;
});
var templateObject_1$1S, templateObject_2$1q;

var PlayButton = function (_a) {
    var isActive = _a.isActive, isHovering = _a.isHovering, props = _tslib.__rest(_a, ["isActive", "isHovering"]);
    return (React__namespace.createElement(Wrapper$3, _tslib.__assign({ width: "48", height: "48", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", "$isActive": isActive, "$isHovering": isHovering, role: "button" }, props),
        React__namespace.createElement("path", { className: "filler", opacity: "0.5", d: "M24.0857 45.7714C36.0151 45.7714 45.6857 36.1008 45.6857 24.1714C45.6857 12.2421 36.0151 2.57141 24.0857 2.57141C12.1564 2.57141 2.48572 12.2421 2.48572 24.1714C2.48572 36.1008 12.1564 45.7714 24.0857 45.7714Z", fill: "#15162E" }),
        React__namespace.createElement("path", { d: "M17.3806 24V16.4982C17.3806 14.6297 19.4034 13.464 21.0217 14.3965L27.5189 18.1474L34.016 21.8982C35.6343 22.8308 35.6343 25.1657 34.016 26.1017L27.5189 29.8525L21.0217 33.6034C19.4034 34.536 17.3806 33.3702 17.3806 31.5017V24Z", fill: "#F8F9F9" }),
        React__namespace.createElement("path", { d: "M19.808 34.2754C19.3314 34.2754 18.8583 34.152 18.4229 33.9017C17.5554 33.4011 17.0377 32.5028 17.0377 31.5017V16.4983C17.0377 15.4971 17.5554 14.5988 18.4229 14.0983C19.2903 13.5977 20.3257 13.5977 21.1931 14.0983L34.1874 21.6C35.0549 22.1006 35.5726 22.9988 35.5726 24C35.5726 25.0011 35.0549 25.8994 34.1874 26.4L21.1931 33.9017C20.7611 34.152 20.2846 34.2754 19.808 34.2754ZM19.808 14.4103C19.4514 14.4103 19.0914 14.5028 18.7657 14.6914C18.1143 15.0686 17.7234 15.744 17.7234 16.4948V31.4983C17.7234 32.2526 18.1143 32.9246 18.7657 33.3017C19.4171 33.6788 20.1954 33.6788 20.8503 33.3017L33.8446 25.8C34.496 25.4228 34.8869 24.7474 34.8869 23.9966C34.8869 23.2457 34.496 22.5703 33.8446 22.1931L20.8503 14.6914C20.5246 14.5028 20.1646 14.4103 19.808 14.4103Z", fill: "#121212" }),
        React__namespace.createElement("path", { d: "M24.0857 46.1143C11.9863 46.1143 2.14286 36.2709 2.14286 24.1714C2.14286 12.072 11.9863 2.22858 24.0857 2.22858C36.1851 2.22858 46.0286 12.072 46.0286 24.1714C46.0286 36.2709 36.1851 46.1143 24.0857 46.1143ZM24.0857 2.91429C12.3634 2.91429 2.82857 12.4491 2.82857 24.1714C2.82857 35.8937 12.3634 45.4286 24.0857 45.4286C35.808 45.4286 45.3429 35.8937 45.3429 24.1714C45.3429 12.4491 35.808 2.91429 24.0857 2.91429Z", fill: "#121212" })));
};
var Wrapper$3 = styled__default.default.svg.withConfig({ displayName: "Wrapper", componentId: "-vok3sk" })(templateObject_3$X || (templateObject_3$X = _tslib.__makeTemplateObject(["\n  cursor: pointer;\n  outline: none;\n  user-select: none;\n  transition: opacity 0.2s;\n\n  &:hover {\n    transform: translateY(-4%);\n  }\n\n  ", "\n\n  &:active {\n    .filler {\n      opacity: 0.7;\n    }\n  }\n\n  ", "\n"], ["\n  cursor: pointer;\n  outline: none;\n  user-select: none;\n  transition: opacity 0.2s;\n\n  &:hover {\n    transform: translateY(-4%);\n  }\n\n  ", "\n\n  &:active {\n    .filler {\n      opacity: 0.7;\n    }\n  }\n\n  ", "\n"])), function (props) {
    return props.$isHovering && styled.css(templateObject_1$1R || (templateObject_1$1R = _tslib.__makeTemplateObject(["\n      transform: translateY(-4%);\n    "], ["\n      transform: translateY(-4%);\n    "])));
}, function (props) {
    return props.$isActive && styled.css(templateObject_2$1p || (templateObject_2$1p = _tslib.__makeTemplateObject(["\n      .filler {\n        opacity: 0.7;\n      }\n    "], ["\n      .filler {\n        opacity: 0.7;\n      }\n    "])));
});
var templateObject_1$1R, templateObject_2$1p, templateObject_3$X;

var SocialButton = function (props) { return (React__namespace.createElement(ButtonView$2, { onClick: props.onClick },
    React__namespace.createElement(Spacing.Flex, { justify: Spacing.FlexJustify.CENTER, align: Spacing.FlexAlign.CENTER },
        props.icon && (React__namespace.createElement(React__namespace.Fragment, null,
            props.icon,
            React__namespace.createElement(Spacing.Spacing, { left: true }))),
        React__namespace.createElement(Hyperlink.Text, { type: Hyperlink.TextType.LABEL, useCompact: true },
            React__namespace.createElement("span", null, props.buttonText))))); };
var ButtonView$2 = styled__default.default.button.withConfig({ displayName: "ButtonView", componentId: "-y7am4a" })(templateObject_1$1Q || (templateObject_1$1Q = _tslib.__makeTemplateObject(["\n  text-align: center;\n  border: 1px solid ", ";\n  outline: none;\n  box-sizing: border-box;\n  cursor: pointer;\n  width: 100%;\n  background-color: ", ";\n  border-radius: ", "px;\n  padding: 12px 0;\n\n  &:hover {\n    background-color: ", ";\n    transition: background-color 250ms linear;\n  }\n\n  &:active {\n    background-color: ", ";\n  }\n"], ["\n  text-align: center;\n  border: 1px solid ", ";\n  outline: none;\n  box-sizing: border-box;\n  cursor: pointer;\n  width: 100%;\n  background-color: ", ";\n  border-radius: ", "px;\n  padding: 12px 0;\n\n  &:hover {\n    background-color: ", ";\n    transition: background-color 250ms linear;\n  }\n\n  &:active {\n    background-color: ", ";\n  }\n"])), styles.themeColors.gray['20'], styles.themeColors.white, styles.themeBorder.radius.default, styles.themeColors.gray['5'], styles.themeColors.gray['10']);
var templateObject_1$1Q;

var Switch = function (props) {
    return (React__namespace.createElement(SwitchView, { className: props.className },
        React__namespace.createElement(Toggle__default.default, { disabled: props.disabled, checked: props.checked, icons: false, onChange: function (e) { return props.onSwitch(e.currentTarget.checked); } })));
};
var SwitchView = styled__default.default.div.withConfig({ displayName: "SwitchView", componentId: "-d2ena" })(templateObject_1$1P || (templateObject_1$1P = _tslib.__makeTemplateObject(["\n  font-size: 0;\n\n  .react-toggle {\n    touch-action: pan-x;\n    display: inline-block;\n    position: relative;\n    cursor: pointer;\n    background-color: transparent;\n    border: 0;\n    padding: 0;\n    user-select: none;\n  }\n\n  .react-toggle-screenreader-only {\n    border: 0;\n    clip: rect(0 0 0 0);\n    height: 1px;\n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    width: 1px;\n  }\n\n  .react-toggle--disabled {\n    cursor: not-allowed;\n    opacity: 0.5;\n    transition: opacity 0.25s;\n  }\n\n  .react-toggle-track {\n    width: 40px;\n    height: 24px;\n    padding: 0;\n    border-radius: 30px;\n    background-color: ", ";\n    transition: all 0.2s ease;\n  }\n\n  .react-toggle--checked .react-toggle-track {\n    background-color: ", ";\n  }\n\n  .react-toggle--focus .react-toggle-track {\n    box-shadow: 0 0 0 4px ", ";\n  }\n\n  .react-toggle:hover:not(.react-toggle--disabled) .react-toggle-track {\n    background-color: ", ";\n  }\n\n  .react-toggle--checked:hover:not(.react-toggle--disabled) .react-toggle-track {\n    background-color: ", ";\n  }\n\n  .react-toggle-thumb {\n    transition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n    position: absolute;\n    top: 4px;\n    left: 4px;\n    width: 16px;\n    height: 16px;\n    border: 0;\n    border-radius: 50%;\n    background-color: #fff;\n    box-sizing: border-box;\n  }\n\n  .react-toggle--checked .react-toggle-thumb {\n    left: 20px;\n  }\n\n  .react-toggle:active:not(.react-toggle--disabled) .react-toggle-track {\n    background-color: ", ";\n  }\n\n  .react-toggle:active:not(.react-toggle--disabled).react-toggle--checked .react-toggle-track {\n    background-color: ", ";\n  }\n"], ["\n  font-size: 0;\n\n  .react-toggle {\n    touch-action: pan-x;\n    display: inline-block;\n    position: relative;\n    cursor: pointer;\n    background-color: transparent;\n    border: 0;\n    padding: 0;\n    user-select: none;\n  }\n\n  .react-toggle-screenreader-only {\n    border: 0;\n    clip: rect(0 0 0 0);\n    height: 1px;\n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    width: 1px;\n  }\n\n  .react-toggle--disabled {\n    cursor: not-allowed;\n    opacity: 0.5;\n    transition: opacity 0.25s;\n  }\n\n  .react-toggle-track {\n    width: 40px;\n    height: 24px;\n    padding: 0;\n    border-radius: 30px;\n    background-color: ", ";\n    transition: all 0.2s ease;\n  }\n\n  .react-toggle--checked .react-toggle-track {\n    background-color: ", ";\n  }\n\n  .react-toggle--focus .react-toggle-track {\n    box-shadow: 0 0 0 4px ", ";\n  }\n\n  .react-toggle:hover:not(.react-toggle--disabled) .react-toggle-track {\n    background-color: ", ";\n  }\n\n  .react-toggle--checked:hover:not(.react-toggle--disabled) .react-toggle-track {\n    background-color: ", ";\n  }\n\n  .react-toggle-thumb {\n    transition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1) 0ms;\n    position: absolute;\n    top: 4px;\n    left: 4px;\n    width: 16px;\n    height: 16px;\n    border: 0;\n    border-radius: 50%;\n    background-color: #fff;\n    box-sizing: border-box;\n  }\n\n  .react-toggle--checked .react-toggle-thumb {\n    left: 20px;\n  }\n\n  .react-toggle:active:not(.react-toggle--disabled) .react-toggle-track {\n    background-color: ", ";\n  }\n\n  .react-toggle:active:not(.react-toggle--disabled).react-toggle--checked .react-toggle-track {\n    background-color: ", ";\n  }\n"])), styles.themeColors.gray['30'], styles.themeColors.blue['50'], styles.themeColors.blue['30'], styles.themeColors.gray['20'], styles.themeColors.blue['40'], styles.themeColors.gray['40'], styles.themeColors.blue['50']);
var templateObject_1$1P;

var withIconLeft = styled.css(templateObject_1$1O || (templateObject_1$1O = _tslib.__makeTemplateObject(["\n  padding-left: 38px;\n"], ["\n  padding-left: 38px;\n"])));
var withIconRight = styled.css(templateObject_2$1o || (templateObject_2$1o = _tslib.__makeTemplateObject(["\n  padding-right: 38px;\n"], ["\n  padding-right: 38px;\n"])));
var isInvalid = styled.css(templateObject_3$W || (templateObject_3$W = _tslib.__makeTemplateObject(["\n  border-color: ", ";\n\n  &:focus {\n    border-color: ", ";\n  }\n"], ["\n  border-color: ", ";\n\n  &:focus {\n    border-color: ", ";\n  }\n"])), styles.themeColors.red[50], styles.themeColors.red[50]);
var Input = styled__default.default.input.withConfig({ shouldForwardProp: Spacing.isPropValid })(templateObject_4$B || (templateObject_4$B = _tslib.__makeTemplateObject(["\n  padding: 10px;\n  width: 100%;\n  font-size: 14px;\n  line-height: 150%;\n  background-color: ", ";\n  color: ", ";\n  border: 1px solid ", ";\n  border-radius: 8px;\n  outline: none;\n  box-sizing: border-box;\n  margin: 1px 0;\n\n  &::-webkit-input-placeholder {\n    color: ", ";\n  }\n\n  &::-moz-placeholder {\n    color: ", ";\n  }\n\n  &::placeholder {\n    color: ", ";\n  }\n\n  &[disabled] {\n    background-color: ", ";\n    border-color: ", ";\n    cursor: not-allowed;\n  }\n\n  &:focus {\n    border-color: ", ";\n    box-shadow: 0px 0px 0px 4px ", ";\n  }\n\n  ", "\n  ", "\n  ", "\n"], ["\n  padding: 10px;\n  width: 100%;\n  font-size: 14px;\n  line-height: 150%;\n  background-color: ", ";\n  color: ", ";\n  border: 1px solid ", ";\n  border-radius: 8px;\n  outline: none;\n  box-sizing: border-box;\n  margin: 1px 0;\n\n  &::-webkit-input-placeholder {\n    color: ", ";\n  }\n\n  &::-moz-placeholder {\n    color: ", ";\n  }\n\n  &::placeholder {\n    color: ", ";\n  }\n\n  &[disabled] {\n    background-color: ", ";\n    border-color: ", ";\n    cursor: not-allowed;\n  }\n\n  &:focus {\n    border-color: ", ";\n    box-shadow: 0px 0px 0px 4px ", ";\n  }\n\n  ", "\n  ", "\n  ", "\n"])), styles.themeColors.white, styles.themeColors.gray[90], styles.themeColors.gray[30], styles.themeColors.gray[40], styles.themeColors.gray[40], styles.themeColors.gray[40], styles.themeColors.gray[5], styles.themeColors.gray[30], styles.themeColors.blue[50], styles.themeColors.blue[30], function (props) { return props.withIconLeft && withIconLeft; }, function (props) { return props.withIconRight && withIconRight; }, function (props) { return props.isInvalid && isInvalid; });
var templateObject_1$1O, templateObject_2$1o, templateObject_3$W, templateObject_4$B;

var InputMessage = function (_a) {
    var children = _a.children, color = _a.color, icon = _a.icon;
    return (React__namespace.createElement(Container$u, { color: color },
        React__namespace.createElement(IconContainer$4, null, icon && React__namespace.createElement(Icon, { name: icon, width: 18, height: 18, color: color !== null && color !== void 0 ? color : styles.themeColors.red[50] })),
        React__namespace.createElement(Hyperlink.Text, { type: "subtitle", color: color !== null && color !== void 0 ? color : styles.themeColors.red[50] },
            React__namespace.createElement("span", null, children))));
};
var Container$u = styled__default.default.div.withConfig({ displayName: "Container", componentId: "-1juv08k" })(templateObject_1$1N || (templateObject_1$1N = _tslib.__makeTemplateObject(["\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n"], ["\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n"])));
var IconContainer$4 = styled__default.default.div.withConfig({ displayName: "IconContainer", componentId: "-ncz384" })(templateObject_2$1n || (templateObject_2$1n = _tslib.__makeTemplateObject(["\n  margin-right: 4px;\n"], ["\n  margin-right: 4px;\n"])));
var templateObject_1$1N, templateObject_2$1n;

var InputGroup = styled__default.default.div.withConfig({ displayName: "InputGroup", componentId: "-1x1nvab" })(templateObject_1$1M || (templateObject_1$1M = _tslib.__makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var templateObject_1$1M;

var InputIcon = styled__default.default(Spacing.Flex).attrs({ align: 'center' }).withConfig({ shouldForwardProp: Spacing.isPropValid })(templateObject_4$A || (templateObject_4$A = _tslib.__makeTemplateObject(["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 2;\n\n  ", "\n\n  ", "\n\n  ", "\n"], ["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 2;\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (props) {
    return props.side === 'left' && styled.css(templateObject_1$1L || (templateObject_1$1L = _tslib.__makeTemplateObject(["\n      left: 10px;\n    "], ["\n      left: 10px;\n    "])));
}, function (props) {
    return props.side === 'right' && styled.css(templateObject_2$1m || (templateObject_2$1m = _tslib.__makeTemplateObject(["\n      right: 10px;\n    "], ["\n      right: 10px;\n    "])));
}, function (props) {
    return !props.clickable && styled.css(templateObject_3$V || (templateObject_3$V = _tslib.__makeTemplateObject(["\n      pointer-events: none;\n    "], ["\n      pointer-events: none;\n    "])));
});
var templateObject_1$1L, templateObject_2$1m, templateObject_3$V, templateObject_4$A;

var paddingsMap = {
    small: 16,
    large: 24,
    xLarge: 32,
};
var CardBaseStyles = styled.css(templateObject_1$1K || (templateObject_1$1K = _tslib.__makeTemplateObject(["\n  border: ", ";\n  border-radius: ", "px;\n  background-color: ", ";\n  transition-property: background, box-shadow;\n  transition-duration: ", "s;\n  box-sizing: border-box;\n  ", "\n\n  ", "\n"], ["\n  border: ", ";\n  border-radius: ", "px;\n  background-color: ", ";\n  transition-property: background, box-shadow;\n  transition-duration: ", "s;\n  box-sizing: border-box;\n  ", "\n\n  ", "\n"])), styles.themeBorder.default, styles.themeBorder.radius.default, function (_a) {
    var backgroundColor = _a.backgroundColor, background = _a.background;
    return backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : styles.backgrounds[background !== null && background !== void 0 ? background : 'white'];
}, styles.transitionTime, function (_a) {
    var padding = _a.padding;
    return padding &&
        "\n      padding: ".concat(paddingsMap["".concat(padding)], "px; \n    ");
}, function (_a) {
    var hoverEffect = _a.hoverEffect, background = _a.background;
    return hoverEffect &&
        "\n      &:hover {\n        background-color: ".concat(styles.backgrounds[background === 'blue' ? 'white' : 'blue'], ";\n      } \n    ");
});
var CardBase = styled__default.default.div.withConfig({ shouldForwardProp: Spacing.isPropValid })(templateObject_2$1l || (templateObject_2$1l = _tslib.__makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), CardBaseStyles);
var templateObject_1$1K, templateObject_2$1l;

var CardClickable = function (_a) {
    var text = _a.text, url = _a.url, _b = _a.target, target = _b === void 0 ? '_self' : _b, icon = _a.icon, className = _a.className;
    return (React__namespace.createElement(StyledAnchorLink, { as: "a", className: className, href: url, target: target, hoverEffect: true },
        React__namespace.createElement(IconContainer$3, null, icon),
        React__namespace.createElement(Hyperlink.Text, { type: "body" },
            React__namespace.createElement("span", null, text))));
};
var StyledAnchorLink = styled__default.default(CardBase).withConfig({ displayName: "StyledAnchorLink", componentId: "-13fux6c" })(templateObject_1$1J || (templateObject_1$1J = _tslib.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 16px 32px;\n\n  @media ", " {\n    padding: 16px;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 16px 32px;\n\n  @media ", " {\n    padding: 16px;\n  }\n"])), ResponsiveSizes.media.mobile);
var IconContainer$3 = styled__default.default.div.withConfig({ displayName: "IconContainer", componentId: "-1pl1zyo" })(templateObject_2$1k || (templateObject_2$1k = _tslib.__makeTemplateObject(["\n  position: relative;\n  width: 56px;\n  height: 56px;\n  padding: 4px;\n\n  @media ", " {\n    width: 42px;\n    height: 42px;\n  }\n"], ["\n  position: relative;\n  width: 56px;\n  height: 56px;\n  padding: 4px;\n\n  @media ", " {\n    width: 42px;\n    height: 42px;\n  }\n"])), ResponsiveSizes.media.mobile);
var templateObject_1$1J, templateObject_2$1k;

var getWidthPx = function (widths, type, defaultWidth) {
    if (widths) {
        // eslint-disable-next-line security/detect-object-injection
        return isNaN(widths[type]) || Spacing.isUndefined(widths[type]) ? undefined : "".concat(widths[type], "px");
    }
    return "".concat(defaultWidth, "px");
};
var getWidthNumber = function (widths, type, defaultWidth) { return (widths ? widths[type] : defaultWidth); };
var getContainerMediaWidth = function (margins, type, defaultWidth) {
    var width = getWidthNumber(margins, type, defaultWidth);
    if (isNaN(width) || Spacing.isUndefined(width)) {
        return undefined;
    }
    return "calc(100% - ".concat(width * 2, "px);");
};
var Container$t = styled__default.default.div.withConfig({ shouldForwardProp: Spacing.isPropValid })(templateObject_1$1I || (templateObject_1$1I = _tslib.__makeTemplateObject(["\n  width: ", ";\n  margin: 0 auto;\n\n  @media ", " {\n    margin: ", ";\n  }\n\n  @media ", " {\n    max-width: ", ";\n    width: ", ";\n    margin: ", ";\n  }\n  @media ", " {\n    max-width: ", ";\n    width: ", ";\n    margin: ", ";\n  }\n  @media ", " {\n    max-width: ", ";\n    width: ", ";\n    margin: ", ";\n  }\n"], ["\n  width: ", ";\n  margin: 0 auto;\n\n  @media ", " {\n    margin: ", ";\n  }\n\n  @media ", " {\n    max-width: ", ";\n    width: ", ";\n    margin: ", ";\n  }\n  @media ", " {\n    max-width: ", ";\n    width: ", ";\n    margin: ", ";\n  }\n  @media ", " {\n    max-width: ", ";\n    width: ", ";\n    margin: ", ";\n  }\n"])), function (props) { return getWidthPx(props.widths, 'largeDesktop', 1128); }, ResponsiveSizes.media['largeDesktop'], function (props) {
    return props.margins && props.margins.largeDesktop ? "0 ".concat(props.margins.largeDesktop, "px") : undefined;
}, ResponsiveSizes.media.desktop, function (props) { return getWidthPx(props.widths, 'desktop', 1096); }, function (props) { return getContainerMediaWidth(props.margins, 'desktop', 64); }, function (props) {
    return props.margins && props.margins.desktop ? "0 ".concat(props.margins.desktop, "px") : undefined;
}, ResponsiveSizes.media.tablet, function (props) { return getWidthPx(props.widths, 'tablet', 1096); }, function (props) { return getContainerMediaWidth(props.margins, 'tablet', 24); }, function (props) {
    return props.margins && props.margins.tablet ? "0 ".concat(props.margins.tablet, "px") : undefined;
}, ResponsiveSizes.media.mobile, function (props) { return getWidthPx(props.widths, 'mobile', 1096); }, function (props) { return getContainerMediaWidth(props.margins, 'mobile', 24); }, function (props) {
    return props.margins && props.margins.mobile ? "0 ".concat(props.margins.mobile, "px") : undefined;
});
var templateObject_1$1I;

var HuaweiDownloadButton = React__namespace.forwardRef(function (props, ref) { return (React__namespace.createElement(StyledButtonView, _tslib.__assign({ as: "a", buttonType: "primary", buttonSize: "large", ref: ref }, props),
    React__namespace.createElement(Spacing.SpanFlex, { justify: "center", align: "center", gap: "10px" },
        React__namespace.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.2477 0H6.75233C1.80833 0 0 1.80834 0 6.75236V17.2478C0 22.1917 1.80833 24 6.75233 24H17.2444C22.1884 24 24 22.1917 24 17.2478V6.75236C24 1.80834 22.1917 0 17.2477 0Z", fill: "#C91C2E" }),
            React__namespace.createElement("path", { d: "M10.4709 13.9196H11.4334L10.9506 12.7969L10.4709 13.9196ZM10.2339 14.4855L9.94843 15.1388H9.29841L10.6808 12.0027H11.2424L12.6193 15.1388H11.9518L11.6699 14.4855H10.2339ZM20.6936 15.1367H21.3219V12.0027H20.6936V15.1367ZM18.1933 13.79H19.3511V13.2189H18.1933V12.5765H19.8741V12.0047H17.5653V15.1385H19.9347V14.567H18.1933V13.79ZM15.6971 14.1604L14.9846 12.0026H14.4652L13.7528 14.1604L13.0596 12.0041H12.382L13.4757 15.1403H14.0027L14.7161 13.0803L15.4293 15.1403H15.9611L17.0519 12.0041H16.3918L15.6971 14.1604ZM8.33942 13.7987C8.33942 14.3089 8.08604 14.5815 7.626 14.5815C7.16343 14.5815 6.90877 14.3012 6.90877 13.777V12.0045H6.27214V13.7987C6.27214 14.6814 6.76249 15.1875 7.6174 15.1875C8.48064 15.1875 8.9758 14.6718 8.9758 13.7728V12.0026H8.33942V13.7987ZM4.75307 12.0027H5.38944V15.1405H4.75307V13.8663H3.31534V15.1405H2.67871V12.0027H3.31534V13.2686H4.75307V12.0027Z", fill: "white" }),
            React__namespace.createElement("path", { d: "M12.0007 8.00586C9.79802 8.00586 8.00586 6.21367 8.00586 4.01097H8.57023C8.57023 5.90253 10.109 7.44151 12.0007 7.44151C13.8924 7.44151 15.4312 5.90253 15.4312 4.01097H15.9956C15.9956 6.21367 14.2034 8.00586 12.0007 8.00586Z", fill: "white" })),
        React__namespace.createElement(Spacing.Flex, { flexDir: "column", justify: "center", align: "center" },
            React__namespace.createElement(Hyperlink.Text, { type: "subtitle", color: styles.themeColors.white, align: "center" },
                React__namespace.createElement(SecondaryText, null, "Explore it on")),
            React__namespace.createElement(Hyperlink.Text, { type: "body", fontWeight: 700, color: styles.themeColors.white, align: "center" },
                React__namespace.createElement(PrimaryText, null, "AppGallery")))))); });
var StyledButtonView = styled__default.default(ButtonView$4).withConfig({ displayName: "StyledButtonView", componentId: "-1g9jljw" })(templateObject_1$1H || (templateObject_1$1H = _tslib.__makeTemplateObject(["\n  color: ", ";\n  background-color: #231f20;\n  height: 64px;\n\n  &:hover,\n  &:focus,\n  &:active {\n    background-color: #231f20;\n  }\n"], ["\n  color: ", ";\n  background-color: #231f20;\n  height: 64px;\n\n  &:hover,\n  &:focus,\n  &:active {\n    background-color: #231f20;\n  }\n"])), styles.themeColors.white);
var SecondaryText = styled__default.default.span.withConfig({ displayName: "SecondaryText", componentId: "-bmmxkr" })(templateObject_2$1j || (templateObject_2$1j = _tslib.__makeTemplateObject(["\n  && {\n    line-height: 1;\n    text-transform: uppercase;\n  }\n"], ["\n  && {\n    line-height: 1;\n    text-transform: uppercase;\n  }\n"])));
var PrimaryText = styled__default.default.span.withConfig({ displayName: "PrimaryText", componentId: "-1wt2tub" })(templateObject_3$U || (templateObject_3$U = _tslib.__makeTemplateObject(["\n  && {\n    line-height: 1;\n  }\n"], ["\n  && {\n    line-height: 1;\n  }\n"])));
HuaweiDownloadButton.displayName = 'HuaweiDownloadButton';
var templateObject_1$1H, templateObject_2$1j, templateObject_3$U;

var TRUSTPILOT_BUSINESS_UNIT_ID = '5db47bcc4de43a0001b54999';

var useTrustpilot = function () {
    if (typeof window === 'undefined') {
        return { trustBoxRef: null, hasTrustpilot: false };
    }
    var trustBoxRef = React.useRef(null);
    React.useEffect(function () {
        if (!trustBoxRef.current) {
            return;
        }
        if (!(window === null || window === void 0 ? void 0 : window.Trustpilot)) {
            return;
        }
        window.Trustpilot.loadFromElement(trustBoxRef.current);
    }, [trustBoxRef]);
    return { trustBoxRef: trustBoxRef, hasTrustpilot: !!(window === null || window === void 0 ? void 0 : window.Trustpilot) };
};
var TrustpilotStarter = function (_a) {
    var _b = _a.theme, theme = _b === void 0 ? 'light' : _b, _c = _a.height, height = _c === void 0 ? '100%' : _c, _d = _a.width, width = _d === void 0 ? '100%' : _d, _e = _a.locale, locale = _e === void 0 ? 'en-US' : _e, _f = _a.templateId, templateId = _f === void 0 ? '5613c9cde69ddc09340c6beb' : _f, _g = _a.businessUnitId, businessUnitId = _g === void 0 ? TRUSTPILOT_BUSINESS_UNIT_ID : _g;
    var trustBoxRef = useTrustpilot().trustBoxRef;
    return (React__namespace.default.createElement("div", { ref: trustBoxRef, className: "trustpilot-widget", "data-locale": locale, "data-template-id": templateId, "data-businessunit-id": businessUnitId, "data-style-height": height, "data-style-width": width, "data-theme": theme, style: { height: height, width: width } }));
};
var TrustpilotMicroStar = function (_a) {
    var _b = _a.theme, theme = _b === void 0 ? 'light' : _b, _c = _a.height, height = _c === void 0 ? '24px' : _c, _d = _a.width, width = _d === void 0 ? '100%' : _d, _e = _a.locale, locale = _e === void 0 ? 'en-US' : _e, _f = _a.templateId, templateId = _f === void 0 ? '5419b732fbfb950b10de65e5' : _f, _g = _a.businessUnitId, businessUnitId = _g === void 0 ? TRUSTPILOT_BUSINESS_UNIT_ID : _g;
    var trustBoxRef = useTrustpilot().trustBoxRef;
    return (React__namespace.default.createElement("div", { ref: trustBoxRef, className: "trustpilot-widget", "data-locale": locale, "data-template-id": templateId, "data-businessunit-id": businessUnitId, "data-style-height": height, "data-style-width": width, "data-theme": theme, style: { height: height, width: width } }));
};
var TrustpilotMicroCombo = function (_a) {
    var _b = _a.theme, theme = _b === void 0 ? 'light' : _b, _c = _a.height, height = _c === void 0 ? '20px' : _c, _d = _a.width, width = _d === void 0 ? '100%' : _d, _e = _a.locale, locale = _e === void 0 ? 'en-US' : _e, _f = _a.templateId, templateId = _f === void 0 ? '5419b6ffb0d04a076446a9af' : _f, _g = _a.businessUnitId, businessUnitId = _g === void 0 ? TRUSTPILOT_BUSINESS_UNIT_ID : _g;
    var trustBoxRef = useTrustpilot().trustBoxRef;
    return (React__namespace.default.createElement("div", { ref: trustBoxRef, className: "trustpilot-widget", "data-locale": locale, "data-template-id": templateId, "data-businessunit-id": businessUnitId, "data-style-height": height, "data-style-width": width, "data-theme": theme, style: { width: width, height: height } }));
};

const min$1 = Math.min;
const max$1 = Math.max;
const oppositeSideMap = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
const oppositeAlignmentMap = {
  start: 'end',
  end: 'start'
};
function clamp$1(start, value, end) {
  return max$1(start, min$1(value, end));
}
function evaluate(value, param) {
  return typeof value === 'function' ? value(param) : value;
}
function getSide(placement) {
  return placement.split('-')[0];
}
function getAlignment(placement) {
  return placement.split('-')[1];
}
function getOppositeAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
function getAxisLength(axis) {
  return axis === 'y' ? 'height' : 'width';
}
function getSideAxis(placement) {
  return ['top', 'bottom'].includes(getSide(placement)) ? 'y' : 'x';
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, alignment => oppositeAlignmentMap[alignment]);
}
function getSideList(side, isStart, rtl) {
  const lr = ['left', 'right'];
  const rl = ['right', 'left'];
  const tb = ['top', 'bottom'];
  const bt = ['bottom', 'top'];
  switch (side) {
    case 'top':
    case 'bottom':
      if (rtl) return isStart ? rl : lr;
      return isStart ? lr : rl;
    case 'left':
    case 'right':
      return isStart ? tb : bt;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list = getSideList(getSide(placement), direction === 'start', rtl);
  if (alignment) {
    list = list.map(side => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, side => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function getPaddingObject(padding) {
  return typeof padding !== 'number' ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  return {
    ...rect,
    top: rect.y,
    left: rect.x,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  };
}

function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide(placement);
  const isVertical = sideAxis === 'y';
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case 'top':
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case 'bottom':
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case 'right':
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case 'left':
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case 'start':
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case 'end':
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain positioning strategy.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */
const computePosition$1 = async (reference, floating, config) => {
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform
  } = config;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
  let rects = await platform.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x,
    y
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i = 0; i < validMiddleware.length; i++) {
    const {
      name,
      fn
    } = validMiddleware[i];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform,
      elements: {
        reference,
        floating
      }
    });
    x = nextX != null ? nextX : x;
    y = nextY != null ? nextY : y;
    middlewareData = {
      ...middlewareData,
      [name]: {
        ...middlewareData[name],
        ...data
      }
    };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === 'object') {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x,
          y
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
      continue;
    }
  }
  return {
    x,
    y,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};

/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */
async function detectOverflow(state, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x,
    y,
    platform,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = 'clippingAncestors',
    rootBoundary = 'viewport',
    elementContext = 'floating',
    altBoundary = false,
    padding = 0
  } = evaluate(options, state);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext === 'floating' ? 'reference' : 'floating';
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform.getClippingRect({
    element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || (await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating))),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === 'floating' ? {
    ...rects.floating,
    x,
    y
  } : rects.reference;
  const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
  const offsetScale = (await (platform.isElement == null ? void 0 : platform.isElement(offsetParent))) ? (await (platform.getScale == null ? void 0 : platform.getScale(offsetParent))) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow$1 = options => ({
  name: 'arrow',
  options,
  async fn(state) {
    const {
      x,
      y,
      placement,
      rects,
      platform,
      elements
    } = state;
    // Since `element` is required, we don't Partial<> the type.
    const {
      element,
      padding = 0
    } = evaluate(options, state) || {};
    if (element == null) {
      return {};
    }
    const paddingObject = getPaddingObject(padding);
    const coords = {
      x,
      y
    };
    const axis = getAlignmentAxis(placement);
    const length = getAxisLength(axis);
    const arrowDimensions = await platform.getDimensions(element);
    const isYAxis = axis === 'y';
    const minProp = isYAxis ? 'top' : 'left';
    const maxProp = isYAxis ? 'bottom' : 'right';
    const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
    const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
    let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;

    // DOM platform can return `window` as the `offsetParent`.
    if (!clientSize || !(await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent)))) {
      clientSize = elements.floating[clientProp] || rects.floating[length];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;

    // If the padding is large enough that it causes the arrow to no longer be
    // centered, modify the padding so that it is centered.
    const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
    const minPadding = min$1(paddingObject[minProp], largestPossiblePadding);
    const maxPadding = min$1(paddingObject[maxProp], largestPossiblePadding);

    // Make sure the arrow doesn't overflow the floating element if the center
    // point is outside the floating element's bounds.
    const min$1$1 = minPadding;
    const max = clientSize - arrowDimensions[length] - maxPadding;
    const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
    const offset = clamp$1(min$1$1, center, max);

    // If the reference is small enough that the arrow's padding causes it to
    // to point to nothing for an aligned placement, adjust the offset of the
    // floating element itself. This stops `shift()` from taking action, but can
    // be worked around by calling it again after the `arrow()` if desired.
    const shouldAddOffset = getAlignment(placement) != null && center != offset && rects.reference[length] / 2 - (center < min$1$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
    const alignmentOffset = shouldAddOffset ? center < min$1$1 ? min$1$1 - center : max - center : 0;
    return {
      [axis]: coords[axis] - alignmentOffset,
      data: {
        [axis]: offset,
        centerOffset: center - offset + alignmentOffset
      }
    };
  }
});

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const flip = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'flip',
    options,
    async fn(state) {
      var _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform,
        elements
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = 'bestFit',
        fallbackAxisSideDirection = 'none',
        flipAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);
      const side = getSide(placement);
      const isBasePlacement = getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== 'none') {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides[0]], overflow[sides[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];

      // One or more sides is overflowing.
      if (!overflows.every(side => side <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements[nextIndex];
        if (nextPlacement) {
          // Try next placement and re-run the lifecycle.
          return {
            data: {
              index: nextIndex,
              overflows: overflowsData
            },
            reset: {
              placement: nextPlacement
            }
          };
        }

        // First, find the candidates that fit on the mainAxis side of overflow,
        // then find the placement that fits the best on the main crossAxis side.
        let resetPlacement = (_overflowsData$filter = overflowsData.filter(d => d.overflows[0] <= 0).sort((a, b) => a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;

        // Otherwise fallback.
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case 'bestFit':
              {
                var _overflowsData$map$so;
                const placement = (_overflowsData$map$so = overflowsData.map(d => [d.placement, d.overflows.filter(overflow => overflow > 0).reduce((acc, overflow) => acc + overflow, 0)]).sort((a, b) => a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                if (placement) {
                  resetPlacement = placement;
                }
                break;
              }
            case 'initialPlacement':
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};

// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function convertValueToCoords(state, options) {
  const {
    placement,
    platform,
    elements
  } = state;
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
  const side = getSide(placement);
  const alignment = getAlignment(placement);
  const isVertical = getSideAxis(placement) === 'y';
  const mainAxisMulti = ['left', 'top'].includes(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = evaluate(options, state);

  // eslint-disable-next-line prefer-const
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === 'number' ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...rawValue
  };
  if (alignment && typeof alignmentAxis === 'number') {
    crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
const offset = function (options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: 'offset',
    options,
    async fn(state) {
      const {
        x,
        y
      } = state;
      const diffCoords = await convertValueToCoords(state, options);
      return {
        x: x + diffCoords.x,
        y: y + diffCoords.y,
        data: diffCoords
      };
    }
  };
};

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const shift = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'shift',
    options,
    async fn(state) {
      const {
        x,
        y,
        placement
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: _ref => {
            let {
              x,
              y
            } = _ref;
            return {
              x,
              y
            };
          }
        },
        ...detectOverflowOptions
      } = evaluate(options, state);
      const coords = {
        x,
        y
      };
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const crossAxis = getSideAxis(getSide(placement));
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === 'y' ? 'top' : 'left';
        const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
        const min = mainAxisCoord + overflow[minSide];
        const max = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = clamp$1(min, mainAxisCoord, max);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === 'y' ? 'top' : 'left';
        const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
        const min = crossAxisCoord + overflow[minSide];
        const max = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = clamp$1(min, crossAxisCoord, max);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x,
          y: limitedCoords.y - y
        }
      };
    }
  };
};

/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */
const size = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'size',
    options,
    async fn(state) {
      const {
        placement,
        rects,
        platform,
        elements
      } = state;
      const {
        apply = () => {},
        ...detectOverflowOptions
      } = evaluate(options, state);
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const side = getSide(placement);
      const alignment = getAlignment(placement);
      const isYAxis = getSideAxis(placement) === 'y';
      const {
        width,
        height
      } = rects.floating;
      let heightSide;
      let widthSide;
      if (side === 'top' || side === 'bottom') {
        heightSide = side;
        widthSide = alignment === ((await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating))) ? 'start' : 'end') ? 'left' : 'right';
      } else {
        widthSide = side;
        heightSide = alignment === 'end' ? 'top' : 'bottom';
      }
      const overflowAvailableHeight = height - overflow[heightSide];
      const overflowAvailableWidth = width - overflow[widthSide];
      const noShift = !state.middlewareData.shift;
      let availableHeight = overflowAvailableHeight;
      let availableWidth = overflowAvailableWidth;
      if (isYAxis) {
        const maximumClippingWidth = width - overflow.left - overflow.right;
        availableWidth = alignment || noShift ? min$1(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
      } else {
        const maximumClippingHeight = height - overflow.top - overflow.bottom;
        availableHeight = alignment || noShift ? min$1(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
      }
      if (noShift && !alignment) {
        const xMin = max$1(overflow.left, 0);
        const xMax = max$1(overflow.right, 0);
        const yMin = max$1(overflow.top, 0);
        const yMax = max$1(overflow.bottom, 0);
        if (isYAxis) {
          availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : max$1(overflow.left, overflow.right));
        } else {
          availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : max$1(overflow.top, overflow.bottom));
        }
      }
      await apply({
        ...state,
        availableWidth,
        availableHeight
      });
      const nextDimensions = await platform.getDimensions(elements.floating);
      if (width !== nextDimensions.width || height !== nextDimensions.height) {
        return {
          reset: {
            rects: true
          }
        };
      }
      return {};
    }
  };
};

const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = v => ({
  x: v,
  y: v
});

function getNodeName(node) {
  if (isNode$1(node)) {
    return (node.nodeName || '').toLowerCase();
  }
  // Mocked nodes in testing environments may not be instances of Node. By
  // returning `#document` an infinite loop won't occur.
  // https://github.com/floating-ui/floating-ui/issues/2317
  return '#document';
}
function getWindow$2(node) {
  var _node$ownerDocument;
  return (node == null ? void 0 : (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode$1(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode$1(value) {
  return value instanceof Node || value instanceof getWindow$2(value).Node;
}
function isElement$1(value) {
  return value instanceof Element || value instanceof getWindow$2(value).Element;
}
function isHTMLElement$1(value) {
  return value instanceof HTMLElement || value instanceof getWindow$2(value).HTMLElement;
}
function isShadowRoot$1(value) {
  // Browsers without `ShadowRoot` support.
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow$2(value).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle$3(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !['inline', 'contents'].includes(display);
}
function isTableElement(element) {
  return ['table', 'td', 'th'].includes(getNodeName(element));
}
function isContainingBlock(element) {
  const webkit = isWebKit();
  const css = getComputedStyle$3(element);

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || ['transform', 'perspective', 'filter'].some(value => (css.willChange || '').includes(value)) || ['paint', 'layout', 'strict', 'content'].some(value => (css.contain || '').includes(value));
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement$1(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else {
      currentNode = getParentNode(currentNode);
    }
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === 'undefined' || !CSS.supports) return false;
  return CSS.supports('-webkit-backdrop-filter', 'none');
}
function isLastTraversableNode(node) {
  return ['html', 'body', '#document'].includes(getNodeName(node));
}
function getComputedStyle$3(element) {
  return getWindow$2(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement$1(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.pageXOffset,
    scrollTop: element.pageYOffset
  };
}
function getParentNode(node) {
  if (getNodeName(node) === 'html') {
    return node;
  }
  const result =
  // Step into the shadow DOM of the parent of a slotted node.
  node.assignedSlot ||
  // DOM Element detected.
  node.parentNode ||
  // ShadowRoot detected.
  isShadowRoot$1(node) && node.host ||
  // Fallback.
  getDocumentElement(node);
  return isShadowRoot$1(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement$1(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow$2(scrollableAncestor);
  if (isBody) {
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor));
}

function getCssDimensions(element) {
  const css = getComputedStyle$3(element);
  // In testing environments, the `width` and `height` properties are empty
  // strings for SVG elements, returning NaN. Fallback to `0` in this case.
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement$1(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}

function unwrapElement(element) {
  return !isElement$1(element) ? element.contextElement : element;
}

function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement$1(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $
  } = getCssDimensions(domElement);
  let x = ($ ? round(rect.width) : rect.width) / width;
  let y = ($ ? round(rect.height) : rect.height) / height;

  // 0, NaN, or Infinity should always fallback to 1.

  if (!x || !Number.isFinite(x)) {
    x = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x,
    y
  };
}

const noOffsets = /*#__PURE__*/createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow$2(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow$2(element)) {
    return false;
  }
  return isFixed;
}

function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement$1(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x = (clientRect.left + visualOffsets.x) / scale.x;
  let y = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow$2(domElement);
    const offsetWin = offsetParent && isElement$1(offsetParent) ? getWindow$2(offsetParent) : offsetParent;
    let currentIFrame = win.frameElement;
    while (currentIFrame && offsetParent && offsetWin !== win) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = getComputedStyle$3(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += left;
      y += top;
      currentIFrame = getWindow$2(currentIFrame).frameElement;
    }
  }
  return rectToClientRect({
    width,
    height,
    x,
    y
  });
}

function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isOffsetParentAnElement = isHTMLElement$1(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  if (offsetParent === documentElement) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== 'fixed') {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement$1(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
  };
}

function getClientRects(element) {
  return Array.from(element.getClientRects());
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  return getBoundingClientRect(getDocumentElement(element)).left + getNodeScroll(element).scrollLeft;
}

// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function getDocumentRect(element) {
  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = element.ownerDocument.body;
  const width = max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y = -scroll.scrollTop;
  if (getComputedStyle$3(body).direction === 'rtl') {
    x += max(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}

function getViewportRect(element, strategy) {
  const win = getWindow$2(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x = 0;
  let y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x,
    y
  };
}

// Returns the inner client rect, subtracting scrollbars if present.
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === 'fixed');
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = isHTMLElement$1(element) ? getScale(element) : createCoords(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x = left * scale.x;
  const y = top * scale.y;
  return {
    width,
    height,
    x,
    y
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === 'viewport') {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === 'document') {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement$1(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      ...clippingAncestor,
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y
    };
  }
  return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = getParentNode(element);
  if (parentNode === stopNode || !isElement$1(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return getComputedStyle$3(parentNode).position === 'fixed' || hasFixedPositionAncestor(parentNode, stopNode);
}

// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element).filter(el => isElement$1(el) && getNodeName(el) !== 'body');
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle$3(element).position === 'fixed';
  let currentNode = elementIsFixed ? getParentNode(element) : element;

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  while (isElement$1(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle$3(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === 'fixed') {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && ['absolute', 'fixed'].includes(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      // Drop non-containing blocks.
      result = result.filter(ancestor => ancestor !== currentNode);
    } else {
      // Record last containing block for next iteration.
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element, result);
  return result;
}

// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === 'clippingAncestors' ? getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}

function getDimensions(element) {
  return getCssDimensions(element);
}

function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement$1(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === 'fixed';
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function getTrueOffsetParent(element, polyfill) {
  if (!isHTMLElement$1(element) || getComputedStyle$3(element).position === 'fixed') {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  return element.offsetParent;
}

// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent(element, polyfill) {
  const window = getWindow$2(element);
  if (!isHTMLElement$1(element)) {
    return window;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$3(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$3(offsetParent).position === 'static' && !isContainingBlock(offsetParent))) {
    return window;
  }
  return offsetParent || getContainingBlock(element) || window;
}

const getElementRects = async function (_ref) {
  let {
    reference,
    floating,
    strategy
  } = _ref;
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  return {
    reference: getRectRelativeToOffsetParent(reference, await getOffsetParentFn(floating), strategy),
    floating: {
      x: 0,
      y: 0,
      ...(await getDimensionsFn(floating))
    }
  };
};

function isRTL(element) {
  return getComputedStyle$3(element).direction === 'rtl';
}

const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement: isElement$1,
  isRTL
};

// https://samthor.au/2021/observing-dom/
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root = getDocumentElement(element);
  function cleanup() {
    clearTimeout(timeoutId);
    io && io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const {
      left,
      top,
      width,
      height
    } = element.getBoundingClientRect();
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top);
    const insetRight = floor(root.clientWidth - (left + width));
    const insetBottom = floor(root.clientHeight - (top + height));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: max(0, min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 100);
        } else {
          refresh(false, ratio);
        }
      }
      isFirstUpdate = false;
    }

    // Older browsers don't support a `document` as the root and will throw an
    // error.
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options,
        // Handle <iframe>s
        root: root.ownerDocument
      });
    } catch (e) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}

/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */
function autoUpdate(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === 'function',
    layoutShift = typeof IntersectionObserver === 'function',
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...(referenceEl ? getOverflowAncestors(referenceEl) : []), ...getOverflowAncestors(floating)] : [];
  ancestors.forEach(ancestor => {
    ancestorScroll && ancestor.addEventListener('scroll', update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener('resize', update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver(_ref => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        // Prevent update loops when using the `size` middleware.
        // https://github.com/floating-ui/floating-ui/issues/1740
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          resizeObserver && resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    ancestors.forEach(ancestor => {
      ancestorScroll && ancestor.removeEventListener('scroll', update);
      ancestorResize && ancestor.removeEventListener('resize', update);
    });
    cleanupIo && cleanupIo();
    resizeObserver && resizeObserver.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain CSS positioning
 * strategy.
 */
const computePosition = (reference, floating, options) => {
  // This caches the expensive `getClippingElementAncestors` function so that
  // multiple lifecycle resets re-use the same result. It only lives for a
  // single call. If other functions become expensive, we can add them as well.
  const cache = new Map();
  const mergedOptions = {
    platform,
    ...options
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition$1(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow = options => {
  function isRef(value) {
    return {}.hasOwnProperty.call(value, 'current');
  }
  return {
    name: 'arrow',
    options,
    fn(state) {
      const {
        element,
        padding
      } = typeof options === 'function' ? options(state) : options;
      if (element && isRef(element)) {
        if (element.current != null) {
          return arrow$1({
            element: element.current,
            padding
          }).fn(state);
        }
        return {};
      } else if (element) {
        return arrow$1({
          element,
          padding
        }).fn(state);
      }
      return {};
    }
  };
};

var index$1 = typeof document !== 'undefined' ? React.useLayoutEffect : React.useEffect;

// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function deepEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (typeof a !== typeof b) {
    return false;
  }
  if (typeof a === 'function' && a.toString() === b.toString()) {
    return true;
  }
  let length, i, keys;
  if (a && b && typeof a == 'object') {
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;) {
        if (!deepEqual(a[i], b[i])) {
          return false;
        }
      }
      return true;
    }
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) {
      return false;
    }
    for (i = length; i-- !== 0;) {
      if (!{}.hasOwnProperty.call(b, keys[i])) {
        return false;
      }
    }
    for (i = length; i-- !== 0;) {
      const key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        continue;
      }
      if (!deepEqual(a[key], b[key])) {
        return false;
      }
    }
    return true;
  }
  return a !== a && b !== b;
}

function getDPR(element) {
  if (typeof window === 'undefined') {
    return 1;
  }
  const win = element.ownerDocument.defaultView || window;
  return win.devicePixelRatio || 1;
}

function roundByDPR(element, value) {
  const dpr = getDPR(element);
  return Math.round(value * dpr) / dpr;
}

function useLatestRef$1(value) {
  const ref = React__namespace.useRef(value);
  index$1(() => {
    ref.current = value;
  });
  return ref;
}

/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/react
 */
function useFloating$1(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform,
    elements: {
      reference: externalReference,
      floating: externalFloating
    } = {},
    transform = true,
    whileElementsMounted,
    open
  } = options;
  const [data, setData] = React__namespace.useState({
    x: 0,
    y: 0,
    strategy,
    placement,
    middlewareData: {},
    isPositioned: false
  });
  const [latestMiddleware, setLatestMiddleware] = React__namespace.useState(middleware);
  if (!deepEqual(latestMiddleware, middleware)) {
    setLatestMiddleware(middleware);
  }
  const [_reference, _setReference] = React__namespace.useState(null);
  const [_floating, _setFloating] = React__namespace.useState(null);
  const setReference = React__namespace.useCallback(node => {
    if (node != referenceRef.current) {
      referenceRef.current = node;
      _setReference(node);
    }
  }, [_setReference]);
  const setFloating = React__namespace.useCallback(node => {
    if (node !== floatingRef.current) {
      floatingRef.current = node;
      _setFloating(node);
    }
  }, [_setFloating]);
  const referenceEl = externalReference || _reference;
  const floatingEl = externalFloating || _floating;
  const referenceRef = React__namespace.useRef(null);
  const floatingRef = React__namespace.useRef(null);
  const dataRef = React__namespace.useRef(data);
  const whileElementsMountedRef = useLatestRef$1(whileElementsMounted);
  const platformRef = useLatestRef$1(platform);
  const update = React__namespace.useCallback(() => {
    if (!referenceRef.current || !floatingRef.current) {
      return;
    }
    const config = {
      placement,
      strategy,
      middleware: latestMiddleware
    };
    if (platformRef.current) {
      config.platform = platformRef.current;
    }
    computePosition(referenceRef.current, floatingRef.current, config).then(data => {
      const fullData = {
        ...data,
        isPositioned: true
      };
      if (isMountedRef.current && !deepEqual(dataRef.current, fullData)) {
        dataRef.current = fullData;
        ReactDOM__namespace.flushSync(() => {
          setData(fullData);
        });
      }
    });
  }, [latestMiddleware, placement, strategy, platformRef]);
  index$1(() => {
    if (open === false && dataRef.current.isPositioned) {
      dataRef.current.isPositioned = false;
      setData(data => ({
        ...data,
        isPositioned: false
      }));
    }
  }, [open]);
  const isMountedRef = React__namespace.useRef(false);
  index$1(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  index$1(() => {
    if (referenceEl) referenceRef.current = referenceEl;
    if (floatingEl) floatingRef.current = floatingEl;
    if (referenceEl && floatingEl) {
      if (whileElementsMountedRef.current) {
        return whileElementsMountedRef.current(referenceEl, floatingEl, update);
      } else {
        update();
      }
    }
  }, [referenceEl, floatingEl, update, whileElementsMountedRef]);
  const refs = React__namespace.useMemo(() => ({
    reference: referenceRef,
    floating: floatingRef,
    setReference,
    setFloating
  }), [setReference, setFloating]);
  const elements = React__namespace.useMemo(() => ({
    reference: referenceEl,
    floating: floatingEl
  }), [referenceEl, floatingEl]);
  const floatingStyles = React__namespace.useMemo(() => {
    const initialStyles = {
      position: strategy,
      left: 0,
      top: 0
    };
    if (!elements.floating) {
      return initialStyles;
    }
    const x = roundByDPR(elements.floating, data.x);
    const y = roundByDPR(elements.floating, data.y);
    if (transform) {
      return {
        ...initialStyles,
        transform: "translate(" + x + "px, " + y + "px)",
        ...(getDPR(elements.floating) >= 1.5 && {
          willChange: 'transform'
        })
      };
    }
    return {
      position: strategy,
      left: x,
      top: y
    };
  }, [strategy, transform, elements.floating, data.x, data.y]);
  return React__namespace.useMemo(() => ({
    ...data,
    update,
    refs,
    elements,
    floatingStyles
  }), [data, update, refs, elements, floatingStyles]);
}

/*!
* tabbable 6.1.2
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
// NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var candidateSelectors = ['input:not([inert])', 'select:not([inert])', 'textarea:not([inert])', 'a[href]:not([inert])', 'button:not([inert])', '[tabindex]:not(slot):not([inert])', 'audio[controls]:not([inert])', 'video[controls]:not([inert])', '[contenteditable]:not([contenteditable="false"]):not([inert])', 'details>summary:first-of-type:not([inert])', 'details:not([inert])'];
var candidateSelector = /* #__PURE__ */candidateSelectors.join(',');
var NoElement = typeof Element === 'undefined';
var matches = NoElement ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode = !NoElement && Element.prototype.getRootNode ? function (element) {
  var _element$getRootNode;
  return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function (element) {
  return element === null || element === void 0 ? void 0 : element.ownerDocument;
};

/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */
var isInert = function isInert(node, lookUp) {
  var _node$getAttribute;
  if (lookUp === void 0) {
    lookUp = true;
  }
  // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
  //  JS API property; we have to check the attribute, which can either be empty or 'true';
  //  if it's `null` (not specified) or 'false', it's an active element
  var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'inert');
  var inert = inertAtt === '' || inertAtt === 'true';

  // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
  //  if it weren't for `matches()` not being a function on shadow roots; the following
  //  code works for any kind of node
  // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
  //  so it likely would not support `:is([inert] *)` either...
  var result = inert || lookUp && node && isInert(node.parentNode); // recursive

  return result;
};

/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */
var isContentEditable = function isContentEditable(node) {
  var _node$getAttribute2;
  // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
  //  to use the attribute directly to check for this, which can either be empty or 'true';
  //  if it's `null` (not specified) or 'false', it's a non-editable element
  var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, 'contenteditable');
  return attValue === '' || attValue === 'true';
};

/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */
var getCandidates = function getCandidates(el, includeContainer, filter) {
  // even if `includeContainer=false`, we still have to check it for inertness because
  //  if it's inert, all its children are inert
  if (isInert(el)) {
    return [];
  }
  var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
  if (includeContainer && matches.call(el, candidateSelector)) {
    candidates.unshift(el);
  }
  candidates = candidates.filter(filter);
  return candidates;
};

/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */

/**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */

/**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */

/**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */

/**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */
var getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
  var candidates = [];
  var elementsToCheck = Array.from(elements);
  while (elementsToCheck.length) {
    var element = elementsToCheck.shift();
    if (isInert(element, false)) {
      // no need to look up since we're drilling down
      // anything inside this container will also be inert
      continue;
    }
    if (element.tagName === 'SLOT') {
      // add shadow dom slot scope (slot itself cannot be focusable)
      var assigned = element.assignedElements();
      var content = assigned.length ? assigned : element.children;
      var nestedCandidates = getCandidatesIteratively(content, true, options);
      if (options.flatten) {
        candidates.push.apply(candidates, nestedCandidates);
      } else {
        candidates.push({
          scopeParent: element,
          candidates: nestedCandidates
        });
      }
    } else {
      // check candidate element
      var validCandidate = matches.call(element, candidateSelector);
      if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) {
        candidates.push(element);
      }

      // iterate over shadow content if possible
      var shadowRoot = element.shadowRoot ||
      // check for an undisclosed shadow
      typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);

      // no inert look up because we're already drilling down and checking for inertness
      //  on the way down, so all containers to this root node should have already been
      //  vetted as non-inert
      var validShadowRoot = !isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
      if (shadowRoot && validShadowRoot) {
        // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
        //  shadow exists, so look at light dom children as fallback BUT create a scope for any
        //  child candidates found because they're likely slotted elements (elements that are
        //  children of the web component element (which has the shadow), in the light dom, but
        //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
        //  _after_ we return from this recursive call
        var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
        if (options.flatten) {
          candidates.push.apply(candidates, _nestedCandidates);
        } else {
          candidates.push({
            scopeParent: element,
            candidates: _nestedCandidates
          });
        }
      } else {
        // there's not shadow so just dig into the element's (light dom) children
        //  __without__ giving the element special scope treatment
        elementsToCheck.unshift.apply(elementsToCheck, element.children);
      }
    }
  }
  return candidates;
};
var getTabindex = function getTabindex(node, isScope) {
  if (node.tabIndex < 0) {
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    // yet they are still part of the regular tab order; in FF, they get a default
    // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    // order, consider their tab index to be 0.
    // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    //
    // isScope is positive for custom element with shadow root or slot that by default
    // have tabIndex -1, but need to be sorted by document order in order for their
    // content to be inserted in the correct position
    if ((isScope || /^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || isContentEditable(node)) && isNaN(parseInt(node.getAttribute('tabindex'), 10))) {
      return 0;
    }
  }
  return node.tabIndex;
};
var sortOrderedTabbables = function sortOrderedTabbables(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var isInput = function isInput(node) {
  return node.tagName === 'INPUT';
};
var isHiddenInput = function isHiddenInput(node) {
  return isInput(node) && node.type === 'hidden';
};
var isDetailsWithSummary = function isDetailsWithSummary(node) {
  var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function (child) {
    return child.tagName === 'SUMMARY';
  });
  return r;
};
var getCheckedRadio = function getCheckedRadio(nodes, form) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked && nodes[i].form === form) {
      return nodes[i];
    }
  }
};
var isTabbableRadio = function isTabbableRadio(node) {
  if (!node.name) {
    return true;
  }
  var radioScope = node.form || getRootNode(node);
  var queryRadios = function queryRadios(name) {
    return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
  };
  var radioSet;
  if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') {
    radioSet = queryRadios(window.CSS.escape(node.name));
  } else {
    try {
      radioSet = queryRadios(node.name);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
      return false;
    }
  }
  var checked = getCheckedRadio(radioSet, node.form);
  return !checked || checked === node;
};
var isRadio = function isRadio(node) {
  return isInput(node) && node.type === 'radio';
};
var isNonTabbableRadio = function isNonTabbableRadio(node) {
  return isRadio(node) && !isTabbableRadio(node);
};

// determines if a node is ultimately attached to the window's document
var isNodeAttached = function isNodeAttached(node) {
  var _nodeRoot;
  // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
  //  (but NOT _the_ document; see second 'If' comment below for more).
  // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
  //  is attached, and the one we need to check if it's in the document or not (because the
  //  shadow, and all nodes it contains, is never considered in the document since shadows
  //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
  //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
  //  visibility, including all the nodes it contains). The host could be any normal node,
  //  or a custom element (i.e. web component). Either way, that's the one that is considered
  //  part of the document, not the shadow root, nor any of its children (i.e. the node being
  //  tested).
  // To further complicate things, we have to look all the way up until we find a shadow HOST
  //  that is attached (or find none) because the node might be in nested shadows...
  // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
  //  document (per the docs) and while it's a Document-type object, that document does not
  //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
  //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
  //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
  //  node is actually detached.
  // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
  //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
  //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
  //  `ownerDocument` will be `null`, hence the optional chaining on it.
  var nodeRoot = node && getRootNode(node);
  var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;

  // in some cases, a detached node will return itself as the root instead of a document or
  //  shadow root object, in which case, we shouldn't try to look further up the host chain
  var attached = false;
  if (nodeRoot && nodeRoot !== node) {
    var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
    attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
    while (!attached && nodeRootHost) {
      var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
      // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
      //  which means we need to get the host's host and check if that parent host is contained
      //  in (i.e. attached to) the document
      nodeRoot = getRootNode(nodeRootHost);
      nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
      attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
    }
  }
  return attached;
};
var isZeroArea = function isZeroArea(node) {
  var _node$getBoundingClie = node.getBoundingClientRect(),
    width = _node$getBoundingClie.width,
    height = _node$getBoundingClie.height;
  return width === 0 && height === 0;
};
var isHidden = function isHidden(node, _ref) {
  var displayCheck = _ref.displayCheck,
    getShadowRoot = _ref.getShadowRoot;
  // NOTE: visibility will be `undefined` if node is detached from the document
  //  (see notes about this further down), which means we will consider it visible
  //  (this is legacy behavior from a very long way back)
  // NOTE: we check this regardless of `displayCheck="none"` because this is a
  //  _visibility_ check, not a _display_ check
  if (getComputedStyle(node).visibility === 'hidden') {
    return true;
  }
  var isDirectSummary = matches.call(node, 'details>summary:first-of-type');
  var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
  if (matches.call(nodeUnderDetails, 'details:not([open]) *')) {
    return true;
  }
  if (!displayCheck || displayCheck === 'full' || displayCheck === 'legacy-full') {
    if (typeof getShadowRoot === 'function') {
      // figure out if we should consider the node to be in an undisclosed shadow and use the
      //  'non-zero-area' fallback
      var originalNode = node;
      while (node) {
        var parentElement = node.parentElement;
        var rootNode = getRootNode(node);
        if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
        ) {
          // node has an undisclosed shadow which means we can only treat it as a black box, so we
          //  fall back to a non-zero-area test
          return isZeroArea(node);
        } else if (node.assignedSlot) {
          // iterate up slot
          node = node.assignedSlot;
        } else if (!parentElement && rootNode !== node.ownerDocument) {
          // cross shadow boundary
          node = rootNode.host;
        } else {
          // iterate up normal dom
          node = parentElement;
        }
      }
      node = originalNode;
    }
    // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
    //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
    //  it might be a falsy value, which means shadow DOM support is disabled

    // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
    //  now we can just test to see if it would normally be visible or not, provided it's
    //  attached to the main document.
    // NOTE: We must consider case where node is inside a shadow DOM and given directly to
    //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.

    if (isNodeAttached(node)) {
      // this works wherever the node is: if there's at least one client rect, it's
      //  somehow displayed; it also covers the CSS 'display: contents' case where the
      //  node itself is hidden in place of its contents; and there's no need to search
      //  up the hierarchy either
      return !node.getClientRects().length;
    }

    // Else, the node isn't attached to the document, which means the `getClientRects()`
    //  API will __always__ return zero rects (this can happen, for example, if React
    //  is used to render nodes onto a detached tree, as confirmed in this thread:
    //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
    //
    // It also means that even window.getComputedStyle(node).display will return `undefined`
    //  because styles are only computed for nodes that are in the document.
    //
    // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
    //  somehow. Though it was never stated officially, anyone who has ever used tabbable
    //  APIs on nodes in detached containers has actually implicitly used tabbable in what
    //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
    //  considering __everything__ to be visible because of the innability to determine styles.
    //
    // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
    //  nodes as visible with the 'none' fallback.__
    if (displayCheck !== 'legacy-full') {
      return true; // hidden
    }
    // else, fallback to 'none' mode and consider the node visible
  } else if (displayCheck === 'non-zero-area') {
    // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return isZeroArea(node);
  }

  // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
  //  it's visible
  return false;
};

// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var isDisabledFromFieldset = function isDisabledFromFieldset(node) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
    var parentNode = node.parentElement;
    // check if `node` is contained in a disabled <fieldset>
    while (parentNode) {
      if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
        // look for the first <legend> among the children of the disabled <fieldset>
        for (var i = 0; i < parentNode.children.length; i++) {
          var child = parentNode.children.item(i);
          // when the first <legend> (in document order) is found
          if (child.tagName === 'LEGEND') {
            // if its parent <fieldset> is not nested in another disabled <fieldset>,
            // return whether `node` is a descendant of its first <legend>
            return matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
          }
        }
        // the disabled <fieldset> containing `node` has no <legend>
        return true;
      }
      parentNode = parentNode.parentElement;
    }
  }

  // else, node's tabbable/focusable state should not be affected by a fieldset's
  //  enabled/disabled state
  return false;
};
var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
  if (node.disabled ||
  // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  isInert(node) || isHiddenInput(node) || isHidden(node, options) ||
  // For a details element with a summary, the summary element gets the focus
  isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
    return false;
  }
  return true;
};
var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
  if (isNonTabbableRadio(node) || getTabindex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) {
    return false;
  }
  return true;
};
var isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
  var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
  if (isNaN(tabIndex) || tabIndex >= 0) {
    return true;
  }
  // If a custom element has an explicit negative tabindex,
  // browsers will not allow tab targeting said element's children.
  return false;
};

/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */
var sortByOrder = function sortByOrder(candidates) {
  var regularTabbables = [];
  var orderedTabbables = [];
  candidates.forEach(function (item, i) {
    var isScope = !!item.scopeParent;
    var element = isScope ? item.scopeParent : item;
    var candidateTabindex = getTabindex(element, isScope);
    var elements = isScope ? sortByOrder(item.candidates) : element;
    if (candidateTabindex === 0) {
      isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        item: item,
        isScope: isScope,
        content: elements
      });
    }
  });
  return orderedTabbables.sort(sortOrderedTabbables).reduce(function (acc, sortable) {
    sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
    return acc;
  }, []).concat(regularTabbables);
};
var tabbable = function tabbable(el, options) {
  options = options || {};
  var candidates;
  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([el], options.includeContainer, {
      filter: isNodeMatchingSelectorTabbable.bind(null, options),
      flatten: false,
      getShadowRoot: options.getShadowRoot,
      shadowRootFilter: isValidShadowRootTabbable
    });
  } else {
    candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
  }
  return sortByOrder(candidates);
};

function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}

var index = typeof document !== 'undefined' ? React.useLayoutEffect : React.useEffect;

let serverHandoffComplete = false;
let count = 0;
const genId = () => "floating-ui-" + count++;
function useFloatingId() {
  const [id, setId] = React__namespace.useState(() => serverHandoffComplete ? genId() : undefined);
  index(() => {
    if (id == null) {
      setId(genId());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  React__namespace.useEffect(() => {
    if (!serverHandoffComplete) {
      serverHandoffComplete = true;
    }
  }, []);
  return id;
}

// `toString()` prevents bundlers from trying to `import { useId } from 'react'`
const useReactId = React__namespace[/*#__PURE__*/'useId'.toString()];

/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/useId
 */
const useId = useReactId || useFloatingId;

function createPubSub() {
  const map = new Map();
  return {
    emit(event, data) {
      var _map$get;
      (_map$get = map.get(event)) == null ? void 0 : _map$get.forEach(handler => handler(data));
    },
    on(event, listener) {
      map.set(event, [...(map.get(event) || []), listener]);
    },
    off(event, listener) {
      var _map$get2;
      map.set(event, ((_map$get2 = map.get(event)) == null ? void 0 : _map$get2.filter(l => l !== listener)) || []);
    }
  };
}

const FloatingNodeContext = /*#__PURE__*/React__namespace.createContext(null);
const FloatingTreeContext = /*#__PURE__*/React__namespace.createContext(null);
const useFloatingParentNodeId = () => {
  var _React$useContext;
  return ((_React$useContext = React__namespace.useContext(FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
const useFloatingTree = () => React__namespace.useContext(FloatingTreeContext);

function getDocument$1(node) {
  return (node == null ? void 0 : node.ownerDocument) || document;
}

// Avoid Chrome DevTools blue warning.
function getPlatform() {
  const uaData = navigator.userAgentData;
  if (uaData != null && uaData.platform) {
    return uaData.platform;
  }
  return navigator.platform;
}
function getUserAgent() {
  const uaData = navigator.userAgentData;
  if (uaData && Array.isArray(uaData.brands)) {
    return uaData.brands.map(_ref => {
      let {
        brand,
        version
      } = _ref;
      return brand + "/" + version;
    }).join(' ');
  }
  return navigator.userAgent;
}

function getWindow$1(value) {
  return getDocument$1(value).defaultView || window;
}
function isElement(value) {
  return value ? value instanceof Element || value instanceof getWindow$1(value).Element : false;
}
function isHTMLElement(value) {
  return value ? value instanceof HTMLElement || value instanceof getWindow$1(value).HTMLElement : false;
}
function isShadowRoot(node) {
  // Browsers without `ShadowRoot` support
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }
  const OwnElement = getWindow$1(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function isVirtualClick(event) {
  if (event.mozInputSource === 0 && event.isTrusted) {
    return true;
  }
  const androidRe = /Android/i;
  if ((androidRe.test(getPlatform()) || androidRe.test(getUserAgent())) && event.pointerType) {
    return event.type === 'click' && event.buttons === 1;
  }
  return event.detail === 0 && !event.pointerType;
}
function isVirtualPointerEvent(event) {
  return event.width === 0 && event.height === 0 || event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType !== 'mouse' ||
  // iOS VoiceOver returns 0.333• for width/height.
  event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0;
}
function isSafari() {
  // Chrome DevTools does not complain about navigator.vendor
  return /apple/i.test(navigator.vendor);
}
function isMouseLikePointerType(pointerType, strict) {
  // On some Linux machines with Chromium, mouse inputs return a `pointerType`
  // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
  const values = ['mouse', 'pen'];
  if (!strict) {
    values.push('', undefined);
  }
  return values.includes(pointerType);
}
function isReactEvent(event) {
  return 'nativeEvent' in event;
}

function contains(parent, child) {
  if (!parent || !child) {
    return false;
  }
  const rootNode = child.getRootNode && child.getRootNode();

  // First, attempt with faster native method
  if (parent.contains(child)) {
    return true;
  }

  // then fallback to custom implementation with Shadow DOM support
  if (rootNode && isShadowRoot(rootNode)) {
    let next = child;
    while (next) {
      if (parent === next) {
        return true;
      }
      // @ts-ignore
      next = next.parentNode || next.host;
    }
  }

  // Give up, the result is false
  return false;
}

function createAttribute(name) {
  return "data-floating-ui-" + name;
}

function useLatestRef(value) {
  const ref = React.useRef(value);
  index(() => {
    ref.current = value;
  });
  return ref;
}

const safePolygonIdentifier = /*#__PURE__*/createAttribute('safe-polygon');
function getDelay(value, prop, pointerType) {
  if (pointerType && !isMouseLikePointerType(pointerType)) {
    return 0;
  }
  if (typeof value === 'number') {
    return value;
  }
  return value == null ? void 0 : value[prop];
}
/**
 * Opens the floating element while hovering over the reference element, like
 * CSS `:hover`.
 * @see https://floating-ui.com/docs/useHover
 */
function useHover(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    dataRef,
    events,
    elements: {
      domReference,
      floating
    },
    refs
  } = context;
  const {
    enabled = true,
    delay = 0,
    handleClose = null,
    mouseOnly = false,
    restMs = 0,
    move = true
  } = props;
  const tree = useFloatingTree();
  const parentId = useFloatingParentNodeId();
  const handleCloseRef = useLatestRef(handleClose);
  const delayRef = useLatestRef(delay);
  const pointerTypeRef = React__namespace.useRef();
  const timeoutRef = React__namespace.useRef();
  const handlerRef = React__namespace.useRef();
  const restTimeoutRef = React__namespace.useRef();
  const blockMouseMoveRef = React__namespace.useRef(true);
  const performedPointerEventsMutationRef = React__namespace.useRef(false);
  const unbindMouseMoveRef = React__namespace.useRef(() => {});
  const isHoverOpen = React__namespace.useCallback(() => {
    var _dataRef$current$open;
    const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
    return (type == null ? void 0 : type.includes('mouse')) && type !== 'mousedown';
  }, [dataRef]);

  // When dismissing before opening, clear the delay timeouts to cancel it
  // from showing.
  React__namespace.useEffect(() => {
    if (!enabled) {
      return;
    }
    function onDismiss() {
      clearTimeout(timeoutRef.current);
      clearTimeout(restTimeoutRef.current);
      blockMouseMoveRef.current = true;
    }
    events.on('dismiss', onDismiss);
    return () => {
      events.off('dismiss', onDismiss);
    };
  }, [enabled, events]);
  React__namespace.useEffect(() => {
    if (!enabled || !handleCloseRef.current || !open) {
      return;
    }
    function onLeave(event) {
      if (isHoverOpen()) {
        onOpenChange(false, event);
      }
    }
    const html = getDocument$1(floating).documentElement;
    html.addEventListener('mouseleave', onLeave);
    return () => {
      html.removeEventListener('mouseleave', onLeave);
    };
  }, [floating, open, onOpenChange, enabled, handleCloseRef, dataRef, isHoverOpen]);
  const closeWithDelay = React__namespace.useCallback(function (event, runElseBranch) {
    if (runElseBranch === void 0) {
      runElseBranch = true;
    }
    const closeDelay = getDelay(delayRef.current, 'close', pointerTypeRef.current);
    if (closeDelay && !handlerRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => onOpenChange(false, event), closeDelay);
    } else if (runElseBranch) {
      clearTimeout(timeoutRef.current);
      onOpenChange(false, event);
    }
  }, [delayRef, onOpenChange]);
  const cleanupMouseMoveHandler = React__namespace.useCallback(() => {
    unbindMouseMoveRef.current();
    handlerRef.current = undefined;
  }, []);
  const clearPointerEvents = React__namespace.useCallback(() => {
    if (performedPointerEventsMutationRef.current) {
      const body = getDocument$1(refs.floating.current).body;
      body.style.pointerEvents = '';
      body.removeAttribute(safePolygonIdentifier);
      performedPointerEventsMutationRef.current = false;
    }
  }, [refs]);

  // Registering the mouse events on the reference directly to bypass React's
  // delegation system. If the cursor was on a disabled element and then entered
  // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
  React__namespace.useEffect(() => {
    if (!enabled) {
      return;
    }
    function isClickLikeOpenEvent() {
      return dataRef.current.openEvent ? ['click', 'mousedown'].includes(dataRef.current.openEvent.type) : false;
    }
    function onMouseEnter(event) {
      clearTimeout(timeoutRef.current);
      blockMouseMoveRef.current = false;
      if (mouseOnly && !isMouseLikePointerType(pointerTypeRef.current) || restMs > 0 && getDelay(delayRef.current, 'open') === 0) {
        return;
      }
      const openDelay = getDelay(delayRef.current, 'open', pointerTypeRef.current);
      if (openDelay) {
        timeoutRef.current = setTimeout(() => {
          onOpenChange(true, event);
        }, openDelay);
      } else {
        onOpenChange(true, event);
      }
    }
    function onMouseLeave(event) {
      if (isClickLikeOpenEvent()) {
        return;
      }
      unbindMouseMoveRef.current();
      const doc = getDocument$1(floating);
      clearTimeout(restTimeoutRef.current);
      if (handleCloseRef.current) {
        // Prevent clearing `onScrollMouseLeave` timeout.
        if (!open) {
          clearTimeout(timeoutRef.current);
        }
        handlerRef.current = handleCloseRef.current({
          ...context,
          tree,
          x: event.clientX,
          y: event.clientY,
          onClose() {
            clearPointerEvents();
            cleanupMouseMoveHandler();
            // Should the event expose that it was closed by `safePolygon`?
            closeWithDelay(event);
          }
        });
        const handler = handlerRef.current;
        doc.addEventListener('mousemove', handler);
        unbindMouseMoveRef.current = () => {
          doc.removeEventListener('mousemove', handler);
        };
        return;
      }

      // Allow interactivity without `safePolygon` on touch devices. With a
      // pointer, a short close delay is an alternative, so it should work
      // consistently.
      const shouldClose = pointerTypeRef.current === 'touch' ? !contains(floating, event.relatedTarget) : true;
      if (shouldClose) {
        closeWithDelay(event);
      }
    }

    // Ensure the floating element closes after scrolling even if the pointer
    // did not move.
    // https://github.com/floating-ui/floating-ui/discussions/1692
    function onScrollMouseLeave(event) {
      if (isClickLikeOpenEvent()) {
        return;
      }
      handleCloseRef.current == null ? void 0 : handleCloseRef.current({
        ...context,
        tree,
        x: event.clientX,
        y: event.clientY,
        onClose() {
          clearPointerEvents();
          cleanupMouseMoveHandler();
          closeWithDelay(event);
        }
      })(event);
    }
    if (isElement(domReference)) {
      const ref = domReference;
      open && ref.addEventListener('mouseleave', onScrollMouseLeave);
      floating == null ? void 0 : floating.addEventListener('mouseleave', onScrollMouseLeave);
      move && ref.addEventListener('mousemove', onMouseEnter, {
        once: true
      });
      ref.addEventListener('mouseenter', onMouseEnter);
      ref.addEventListener('mouseleave', onMouseLeave);
      return () => {
        open && ref.removeEventListener('mouseleave', onScrollMouseLeave);
        floating == null ? void 0 : floating.removeEventListener('mouseleave', onScrollMouseLeave);
        move && ref.removeEventListener('mousemove', onMouseEnter);
        ref.removeEventListener('mouseenter', onMouseEnter);
        ref.removeEventListener('mouseleave', onMouseLeave);
      };
    }
  }, [domReference, floating, enabled, context, mouseOnly, restMs, move, closeWithDelay, cleanupMouseMoveHandler, clearPointerEvents, onOpenChange, open, tree, delayRef, handleCloseRef, dataRef]);

  // Block pointer-events of every element other than the reference and floating
  // while the floating element is open and has a `handleClose` handler. Also
  // handles nested floating elements.
  // https://github.com/floating-ui/floating-ui/issues/1722
  index(() => {
    var _handleCloseRef$curre;
    if (!enabled) {
      return;
    }
    if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && _handleCloseRef$curre.__options.blockPointerEvents && isHoverOpen()) {
      const body = getDocument$1(floating).body;
      body.setAttribute(safePolygonIdentifier, '');
      body.style.pointerEvents = 'none';
      performedPointerEventsMutationRef.current = true;
      if (isElement(domReference) && floating) {
        var _tree$nodesRef$curren, _tree$nodesRef$curren2;
        const ref = domReference;
        const parentFloating = tree == null ? void 0 : (_tree$nodesRef$curren = tree.nodesRef.current.find(node => node.id === parentId)) == null ? void 0 : (_tree$nodesRef$curren2 = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren2.elements.floating;
        if (parentFloating) {
          parentFloating.style.pointerEvents = '';
        }
        ref.style.pointerEvents = 'auto';
        floating.style.pointerEvents = 'auto';
        return () => {
          ref.style.pointerEvents = '';
          floating.style.pointerEvents = '';
        };
      }
    }
  }, [enabled, open, parentId, floating, domReference, tree, handleCloseRef, dataRef, isHoverOpen]);
  index(() => {
    if (!open) {
      pointerTypeRef.current = undefined;
      cleanupMouseMoveHandler();
      clearPointerEvents();
    }
  }, [open, cleanupMouseMoveHandler, clearPointerEvents]);
  React__namespace.useEffect(() => {
    return () => {
      cleanupMouseMoveHandler();
      clearTimeout(timeoutRef.current);
      clearTimeout(restTimeoutRef.current);
      clearPointerEvents();
    };
  }, [enabled, cleanupMouseMoveHandler, clearPointerEvents]);
  return React__namespace.useMemo(() => {
    if (!enabled) {
      return {};
    }
    function setPointerRef(event) {
      pointerTypeRef.current = event.pointerType;
    }
    return {
      reference: {
        onPointerDown: setPointerRef,
        onPointerEnter: setPointerRef,
        onMouseMove(event) {
          if (open || restMs === 0) {
            return;
          }
          clearTimeout(restTimeoutRef.current);
          restTimeoutRef.current = setTimeout(() => {
            if (!blockMouseMoveRef.current) {
              onOpenChange(true, event.nativeEvent);
            }
          }, restMs);
        }
      },
      floating: {
        onMouseEnter() {
          clearTimeout(timeoutRef.current);
        },
        onMouseLeave(event) {
          events.emit('dismiss', {
            type: 'mouseLeave',
            data: {
              returnFocus: false
            }
          });
          closeWithDelay(event.nativeEvent, false);
        }
      }
    };
  }, [events, enabled, restMs, open, onOpenChange, closeWithDelay]);
}

/**
 * Find the real active element. Traverses into shadowRoots.
 */
function activeElement(doc) {
  let activeElement = doc.activeElement;
  while (((_activeElement = activeElement) == null ? void 0 : (_activeElement$shadow = _activeElement.shadowRoot) == null ? void 0 : _activeElement$shadow.activeElement) != null) {
    var _activeElement, _activeElement$shadow;
    activeElement = activeElement.shadowRoot.activeElement;
  }
  return activeElement;
}

function getChildren$1(nodes, id) {
  let allChildren = nodes.filter(node => {
    var _node$context;
    return node.parentId === id && ((_node$context = node.context) == null ? void 0 : _node$context.open);
  });
  let currentChildren = allChildren;
  while (currentChildren.length) {
    currentChildren = nodes.filter(node => {
      var _currentChildren;
      return (_currentChildren = currentChildren) == null ? void 0 : _currentChildren.some(n => {
        var _node$context2;
        return node.parentId === n.id && ((_node$context2 = node.context) == null ? void 0 : _node$context2.open);
      });
    });
    allChildren = allChildren.concat(currentChildren);
  }
  return allChildren;
}

function getTarget(event) {
  if ('composedPath' in event) {
    return event.composedPath()[0];
  }

  // TS thinks `event` is of type never as it assumes all browsers support
  // `composedPath()`, but browsers without shadow DOM don't.
  return event.target;
}

const TYPEABLE_SELECTOR = "input:not([type='hidden']):not([disabled])," + "[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function isTypeableElement(element) {
  return isHTMLElement(element) && element.matches(TYPEABLE_SELECTOR);
}

const getTabbableOptions = () => ({
  getShadowRoot: true,
  displayCheck:
  // JSDOM does not support the `tabbable` library. To solve this we can
  // check if `ResizeObserver` is a real function (not polyfilled), which
  // determines if the current environment is JSDOM-like.
  typeof ResizeObserver === 'function' && ResizeObserver.toString().includes('[native code]') ? 'full' : 'none'
});
function getTabbableIn(container, direction) {
  const allTabbable = tabbable(container, getTabbableOptions());
  if (direction === 'prev') {
    allTabbable.reverse();
  }
  const activeIndex = allTabbable.indexOf(activeElement(getDocument$1(container)));
  const nextTabbableElements = allTabbable.slice(activeIndex + 1);
  return nextTabbableElements[0];
}
function getNextTabbable() {
  return getTabbableIn(document.body, 'next');
}
function getPreviousTabbable() {
  return getTabbableIn(document.body, 'prev');
}
function isOutsideEvent(event, container) {
  const containerElement = container || event.currentTarget;
  const relatedTarget = event.relatedTarget;
  return !relatedTarget || !contains(containerElement, relatedTarget);
}
function disableFocusInside(container) {
  const tabbableElements = tabbable(container, getTabbableOptions());
  tabbableElements.forEach(element => {
    element.dataset.tabindex = element.getAttribute('tabindex') || '';
    element.setAttribute('tabindex', '-1');
  });
}
function enableFocusInside(container) {
  const elements = container.querySelectorAll('[data-tabindex]');
  elements.forEach(element => {
    const tabindex = element.dataset.tabindex;
    delete element.dataset.tabindex;
    if (tabindex) {
      element.setAttribute('tabindex', tabindex);
    } else {
      element.removeAttribute('tabindex');
    }
  });
}

// See Diego Haz's Sandbox for making this logic work well on Safari/iOS:
// https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/FocusTrap.tsx

const HIDDEN_STYLES = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'fixed',
  whiteSpace: 'nowrap',
  width: '1px',
  top: 0,
  left: 0
};
let timeoutId;
function setActiveElementOnTab(event) {
  if (event.key === 'Tab') {
    event.target;
    clearTimeout(timeoutId);
  }
}
const FocusGuard = /*#__PURE__*/React__namespace.forwardRef(function FocusGuard(props, ref) {
  const [role, setRole] = React__namespace.useState();
  index(() => {
    if (isSafari()) {
      // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
      // on VoiceOver does trigger the onFocus event, so we can use the focus
      // trap element. On Safari, only buttons trigger the onFocus event.
      // NB: "group" role in the Sandbox no longer appears to work, must be a
      // button role.
      setRole('button');
    }
    document.addEventListener('keydown', setActiveElementOnTab);
    return () => {
      document.removeEventListener('keydown', setActiveElementOnTab);
    };
  }, []);
  const restProps = {
    ref,
    tabIndex: 0,
    // Role is only for VoiceOver
    role,
    'aria-hidden': role ? undefined : true,
    [createAttribute('focus-guard')]: '',
    style: HIDDEN_STYLES
  };
  return /*#__PURE__*/React__namespace.createElement("span", _extends$1({}, props, restProps));
});

const PortalContext = /*#__PURE__*/React__namespace.createContext(null);
function useFloatingPortalNode(_temp) {
  let {
    id,
    root
  } = _temp === void 0 ? {} : _temp;
  const [portalNode, setPortalNode] = React__namespace.useState(null);
  const uniqueId = useId();
  const portalContext = usePortalContext();
  const data = React__namespace.useMemo(() => ({
    id,
    root,
    portalContext,
    uniqueId
  }), [id, root, portalContext, uniqueId]);
  const dataRef = React__namespace.useRef();
  index(() => {
    return () => {
      portalNode == null ? void 0 : portalNode.remove();
    };
  }, [portalNode, data]);
  index(() => {
    if (dataRef.current === data) return;
    dataRef.current = data;
    const {
      id,
      root,
      portalContext,
      uniqueId
    } = data;
    const existingIdRoot = id ? document.getElementById(id) : null;
    const attr = createAttribute('portal');
    if (existingIdRoot) {
      const subRoot = document.createElement('div');
      subRoot.id = uniqueId;
      subRoot.setAttribute(attr, '');
      existingIdRoot.appendChild(subRoot);
      setPortalNode(subRoot);
    } else {
      let container = root || (portalContext == null ? void 0 : portalContext.portalNode);
      if (container && !isElement(container)) container = container.current;
      container = container || document.body;
      let idWrapper = null;
      if (id) {
        idWrapper = document.createElement('div');
        idWrapper.id = id;
        container.appendChild(idWrapper);
      }
      const subRoot = document.createElement('div');
      subRoot.id = uniqueId;
      subRoot.setAttribute(attr, '');
      container = idWrapper || container;
      container.appendChild(subRoot);
      setPortalNode(subRoot);
    }
  }, [data]);
  return portalNode;
}
/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * @see https://floating-ui.com/docs/FloatingPortal
 */
function FloatingPortal(_ref) {
  let {
    children,
    id,
    root = null,
    preserveTabOrder = true
  } = _ref;
  const portalNode = useFloatingPortalNode({
    id,
    root
  });
  const [focusManagerState, setFocusManagerState] = React__namespace.useState(null);
  const beforeOutsideRef = React__namespace.useRef(null);
  const afterOutsideRef = React__namespace.useRef(null);
  const beforeInsideRef = React__namespace.useRef(null);
  const afterInsideRef = React__namespace.useRef(null);
  const shouldRenderGuards =
  // The FocusManager and therefore floating element are currently open/
  // rendered.
  !!focusManagerState &&
  // Guards are only for non-modal focus management.
  !focusManagerState.modal &&
  // Don't render if unmount is transitioning.
  focusManagerState.open && preserveTabOrder && !!(root || portalNode);

  // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
  React__namespace.useEffect(() => {
    if (!portalNode || !preserveTabOrder || focusManagerState != null && focusManagerState.modal) {
      return;
    }

    // Make sure elements inside the portal element are tabbable only when the
    // portal has already been focused, either by tabbing into a focus trap
    // element outside or using the mouse.
    function onFocus(event) {
      if (portalNode && isOutsideEvent(event)) {
        const focusing = event.type === 'focusin';
        const manageFocus = focusing ? enableFocusInside : disableFocusInside;
        manageFocus(portalNode);
      }
    }
    // Listen to the event on the capture phase so they run before the focus
    // trap elements onFocus prop is called.
    portalNode.addEventListener('focusin', onFocus, true);
    portalNode.addEventListener('focusout', onFocus, true);
    return () => {
      portalNode.removeEventListener('focusin', onFocus, true);
      portalNode.removeEventListener('focusout', onFocus, true);
    };
  }, [portalNode, preserveTabOrder, focusManagerState == null ? void 0 : focusManagerState.modal]);
  return /*#__PURE__*/React__namespace.createElement(PortalContext.Provider, {
    value: React__namespace.useMemo(() => ({
      preserveTabOrder,
      beforeOutsideRef,
      afterOutsideRef,
      beforeInsideRef,
      afterInsideRef,
      portalNode,
      setFocusManagerState
    }), [preserveTabOrder, portalNode])
  }, shouldRenderGuards && portalNode && /*#__PURE__*/React__namespace.createElement(FocusGuard, {
    "data-type": "outside",
    ref: beforeOutsideRef,
    onFocus: event => {
      if (isOutsideEvent(event, portalNode)) {
        var _beforeInsideRef$curr;
        (_beforeInsideRef$curr = beforeInsideRef.current) == null ? void 0 : _beforeInsideRef$curr.focus();
      } else {
        const prevTabbable = getPreviousTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
        prevTabbable == null ? void 0 : prevTabbable.focus();
      }
    }
  }), shouldRenderGuards && portalNode && /*#__PURE__*/React__namespace.createElement("span", {
    "aria-owns": portalNode.id,
    style: HIDDEN_STYLES
  }), portalNode && /*#__PURE__*/ReactDOM.createPortal(children, portalNode), shouldRenderGuards && portalNode && /*#__PURE__*/React__namespace.createElement(FocusGuard, {
    "data-type": "outside",
    ref: afterOutsideRef,
    onFocus: event => {
      if (isOutsideEvent(event, portalNode)) {
        var _afterInsideRef$curre;
        (_afterInsideRef$curre = afterInsideRef.current) == null ? void 0 : _afterInsideRef$curre.focus();
      } else {
        const nextTabbable = getNextTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
        nextTabbable == null ? void 0 : nextTabbable.focus();
        (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null ? void 0 : focusManagerState.onOpenChange(false, event.nativeEvent));
      }
    }
  }));
}
const usePortalContext = () => React__namespace.useContext(PortalContext);

function isButtonTarget(event) {
  return isHTMLElement(event.target) && event.target.tagName === 'BUTTON';
}
function isSpaceIgnored(element) {
  return isTypeableElement(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */
function useClick(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    dataRef,
    elements: {
      domReference
    }
  } = context;
  const {
    enabled = true,
    event: eventOption = 'click',
    toggle = true,
    ignoreMouse = false,
    keyboardHandlers = true
  } = props;
  const pointerTypeRef = React__namespace.useRef();
  const didKeyDownRef = React__namespace.useRef(false);
  return React__namespace.useMemo(() => {
    if (!enabled) return {};
    return {
      reference: {
        onPointerDown(event) {
          pointerTypeRef.current = event.pointerType;
        },
        onMouseDown(event) {
          // Ignore all buttons except for the "main" button.
          // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
          if (event.button !== 0) {
            return;
          }
          if (isMouseLikePointerType(pointerTypeRef.current, true) && ignoreMouse) {
            return;
          }
          if (eventOption === 'click') {
            return;
          }
          if (open && toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === 'mousedown' : true)) {
            onOpenChange(false, event.nativeEvent);
          } else {
            // Prevent stealing focus from the floating element
            event.preventDefault();
            onOpenChange(true, event.nativeEvent);
          }
        },
        onClick(event) {
          if (eventOption === 'mousedown' && pointerTypeRef.current) {
            pointerTypeRef.current = undefined;
            return;
          }
          if (isMouseLikePointerType(pointerTypeRef.current, true) && ignoreMouse) {
            return;
          }
          if (open && toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === 'click' : true)) {
            onOpenChange(false, event.nativeEvent);
          } else {
            onOpenChange(true, event.nativeEvent);
          }
        },
        onKeyDown(event) {
          pointerTypeRef.current = undefined;
          if (event.defaultPrevented || !keyboardHandlers || isButtonTarget(event)) {
            return;
          }
          if (event.key === ' ' && !isSpaceIgnored(domReference)) {
            // Prevent scrolling
            event.preventDefault();
            didKeyDownRef.current = true;
          }
          if (event.key === 'Enter') {
            if (open && toggle) {
              onOpenChange(false, event.nativeEvent);
            } else {
              onOpenChange(true, event.nativeEvent);
            }
          }
        },
        onKeyUp(event) {
          if (event.defaultPrevented || !keyboardHandlers || isButtonTarget(event) || isSpaceIgnored(domReference)) {
            return;
          }
          if (event.key === ' ' && didKeyDownRef.current) {
            didKeyDownRef.current = false;
            if (open && toggle) {
              onOpenChange(false, event.nativeEvent);
            } else {
              onOpenChange(true, event.nativeEvent);
            }
          }
        }
      }
    };
  }, [enabled, dataRef, eventOption, ignoreMouse, keyboardHandlers, domReference, toggle, open, onOpenChange]);
}

// `toString()` prevents bundlers from trying to `import { useInsertionEffect } from 'react'`
const useInsertionEffect = React__namespace[/*#__PURE__*/'useInsertionEffect'.toString()];
const useSafeInsertionEffect = useInsertionEffect || (fn => fn());
function useEffectEvent(callback) {
  const ref = React__namespace.useRef(() => {
    if (process.env.NODE_ENV !== "production") {
      throw new Error('Cannot call an event handler while rendering.');
    }
  });
  useSafeInsertionEffect(() => {
    ref.current = callback;
  });
  return React__namespace.useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return ref.current == null ? void 0 : ref.current(...args);
  }, []);
}

/**
 * Check whether the event.target is within the provided node. Uses event.composedPath if available for custom element support.
 *
 * @param event The event whose target/composedPath to check
 * @param node The node to check against
 * @returns Whether the event.target/composedPath is within the node.
 */
function isEventTargetWithin(event, node) {
  if (node == null) {
    return false;
  }
  if ('composedPath' in event) {
    return event.composedPath().includes(node);
  }

  // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
  const e = event;
  return e.target != null && node.contains(e.target);
}

const bubbleHandlerKeys = {
  pointerdown: 'onPointerDown',
  mousedown: 'onMouseDown',
  click: 'onClick'
};
const captureHandlerKeys = {
  pointerdown: 'onPointerDownCapture',
  mousedown: 'onMouseDownCapture',
  click: 'onClickCapture'
};
const normalizeBubblesProp = bubbles => {
  var _bubbles$escapeKey, _bubbles$outsidePress;
  return {
    escapeKeyBubbles: typeof bubbles === 'boolean' ? bubbles : (_bubbles$escapeKey = bubbles == null ? void 0 : bubbles.escapeKey) != null ? _bubbles$escapeKey : false,
    outsidePressBubbles: typeof bubbles === 'boolean' ? bubbles : (_bubbles$outsidePress = bubbles == null ? void 0 : bubbles.outsidePress) != null ? _bubbles$outsidePress : true
  };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */
function useDismiss(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    events,
    nodeId,
    elements: {
      reference,
      domReference,
      floating
    },
    dataRef
  } = context;
  const {
    enabled = true,
    escapeKey = true,
    outsidePress: unstable_outsidePress = true,
    outsidePressEvent = 'pointerdown',
    referencePress = false,
    referencePressEvent = 'pointerdown',
    ancestorScroll = false,
    bubbles
  } = props;
  const tree = useFloatingTree();
  const nested = useFloatingParentNodeId() != null;
  const outsidePressFn = useEffectEvent(typeof unstable_outsidePress === 'function' ? unstable_outsidePress : () => false);
  const outsidePress = typeof unstable_outsidePress === 'function' ? outsidePressFn : unstable_outsidePress;
  const insideReactTreeRef = React__namespace.useRef(false);
  const {
    escapeKeyBubbles,
    outsidePressBubbles
  } = normalizeBubblesProp(bubbles);
  const closeOnEscapeKeyDown = useEffectEvent(event => {
    if (!open || !enabled || !escapeKey || event.key !== 'Escape') {
      return;
    }
    const children = tree ? getChildren$1(tree.nodesRef.current, nodeId) : [];
    if (!escapeKeyBubbles) {
      event.stopPropagation();
      if (children.length > 0) {
        let shouldDismiss = true;
        children.forEach(child => {
          var _child$context;
          if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
            shouldDismiss = false;
            return;
          }
        });
        if (!shouldDismiss) {
          return;
        }
      }
    }
    events.emit('dismiss', {
      type: 'escapeKey',
      data: {
        returnFocus: {
          preventScroll: false
        }
      }
    });
    onOpenChange(false, isReactEvent(event) ? event.nativeEvent : event);
  });
  const closeOnPressOutside = useEffectEvent(event => {
    // Given developers can stop the propagation of the synthetic event,
    // we can only be confident with a positive value.
    const insideReactTree = insideReactTreeRef.current;
    insideReactTreeRef.current = false;
    if (insideReactTree) {
      return;
    }
    if (typeof outsidePress === 'function' && !outsidePress(event)) {
      return;
    }
    const target = getTarget(event);

    // Check if the click occurred on the scrollbar
    if (isHTMLElement(target) && floating) {
      // In Firefox, `target.scrollWidth > target.clientWidth` for inline
      // elements.
      const canScrollX = target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
      const canScrollY = target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
      let xCond = canScrollY && event.offsetX > target.clientWidth;

      // In some browsers it is possible to change the <body> (or window)
      // scrollbar to the left side, but is very rare and is difficult to
      // check for. Plus, for modal dialogs with backdrops, it is more
      // important that the backdrop is checked but not so much the window.
      if (canScrollY) {
        const isRTL = getWindow$1(floating).getComputedStyle(target).direction === 'rtl';
        if (isRTL) {
          xCond = event.offsetX <= target.offsetWidth - target.clientWidth;
        }
      }
      if (xCond || canScrollX && event.offsetY > target.clientHeight) {
        return;
      }
    }
    const targetIsInsideChildren = tree && getChildren$1(tree.nodesRef.current, nodeId).some(node => {
      var _node$context;
      return isEventTargetWithin(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
    });
    if (isEventTargetWithin(event, floating) || isEventTargetWithin(event, domReference) || targetIsInsideChildren) {
      return;
    }
    const children = tree ? getChildren$1(tree.nodesRef.current, nodeId) : [];
    if (children.length > 0) {
      let shouldDismiss = true;
      children.forEach(child => {
        var _child$context2;
        if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
          shouldDismiss = false;
          return;
        }
      });
      if (!shouldDismiss) {
        return;
      }
    }
    events.emit('dismiss', {
      type: 'outsidePress',
      data: {
        returnFocus: nested ? {
          preventScroll: true
        } : isVirtualClick(event) || isVirtualPointerEvent(event)
      }
    });
    onOpenChange(false, event);
  });
  React__namespace.useEffect(() => {
    if (!open || !enabled) {
      return;
    }
    dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
    dataRef.current.__outsidePressBubbles = outsidePressBubbles;
    function onScroll(event) {
      onOpenChange(false, event);
    }
    const doc = getDocument$1(floating);
    escapeKey && doc.addEventListener('keydown', closeOnEscapeKeyDown);
    outsidePress && doc.addEventListener(outsidePressEvent, closeOnPressOutside);
    let ancestors = [];
    if (ancestorScroll) {
      if (isElement(domReference)) {
        ancestors = getOverflowAncestors(domReference);
      }
      if (isElement(floating)) {
        ancestors = ancestors.concat(getOverflowAncestors(floating));
      }
      if (!isElement(reference) && reference && reference.contextElement) {
        ancestors = ancestors.concat(getOverflowAncestors(reference.contextElement));
      }
    }

    // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
    ancestors = ancestors.filter(ancestor => {
      var _doc$defaultView;
      return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
    });
    ancestors.forEach(ancestor => {
      ancestor.addEventListener('scroll', onScroll, {
        passive: true
      });
    });
    return () => {
      escapeKey && doc.removeEventListener('keydown', closeOnEscapeKeyDown);
      outsidePress && doc.removeEventListener(outsidePressEvent, closeOnPressOutside);
      ancestors.forEach(ancestor => {
        ancestor.removeEventListener('scroll', onScroll);
      });
    };
  }, [dataRef, floating, domReference, reference, escapeKey, outsidePress, outsidePressEvent, open, onOpenChange, ancestorScroll, enabled, escapeKeyBubbles, outsidePressBubbles, closeOnEscapeKeyDown, closeOnPressOutside]);
  React__namespace.useEffect(() => {
    insideReactTreeRef.current = false;
  }, [outsidePress, outsidePressEvent]);
  return React__namespace.useMemo(() => {
    if (!enabled) {
      return {};
    }
    return {
      reference: {
        onKeyDown: closeOnEscapeKeyDown,
        [bubbleHandlerKeys[referencePressEvent]]: event => {
          if (referencePress) {
            events.emit('dismiss', {
              type: 'referencePress',
              data: {
                returnFocus: false
              }
            });
            onOpenChange(false, event.nativeEvent);
          }
        }
      },
      floating: {
        onKeyDown: closeOnEscapeKeyDown,
        [captureHandlerKeys[outsidePressEvent]]: () => {
          insideReactTreeRef.current = true;
        }
      }
    };
  }, [enabled, events, referencePress, outsidePressEvent, referencePressEvent, onOpenChange, closeOnEscapeKeyDown]);
}

/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/react
 */
function useFloating(options) {
  var _options$elements;
  if (options === void 0) {
    options = {};
  }
  const {
    open = false,
    onOpenChange: unstable_onOpenChange,
    nodeId
  } = options;
  const [_domReference, setDomReference] = React__namespace.useState(null);
  const domReference = ((_options$elements = options.elements) == null ? void 0 : _options$elements.reference) || _domReference;
  const position = useFloating$1(options);
  const tree = useFloatingTree();
  const onOpenChange = useEffectEvent((open, event) => {
    if (open) {
      dataRef.current.openEvent = event;
    }
    unstable_onOpenChange == null ? void 0 : unstable_onOpenChange(open, event);
  });
  const domReferenceRef = React__namespace.useRef(null);
  const dataRef = React__namespace.useRef({});
  const events = React__namespace.useState(() => createPubSub())[0];
  const floatingId = useId();
  const setPositionReference = React__namespace.useCallback(node => {
    const positionReference = isElement(node) ? {
      getBoundingClientRect: () => node.getBoundingClientRect(),
      contextElement: node
    } : node;
    position.refs.setReference(positionReference);
  }, [position.refs]);
  const setReference = React__namespace.useCallback(node => {
    if (isElement(node) || node === null) {
      domReferenceRef.current = node;
      setDomReference(node);
    }

    // Backwards-compatibility for passing a virtual element to `reference`
    // after it has set the DOM reference.
    if (isElement(position.refs.reference.current) || position.refs.reference.current === null ||
    // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    node !== null && !isElement(node)) {
      position.refs.setReference(node);
    }
  }, [position.refs]);
  const refs = React__namespace.useMemo(() => ({
    ...position.refs,
    setReference,
    setPositionReference,
    domReference: domReferenceRef
  }), [position.refs, setReference, setPositionReference]);
  const elements = React__namespace.useMemo(() => ({
    ...position.elements,
    domReference: domReference
  }), [position.elements, domReference]);
  const context = React__namespace.useMemo(() => ({
    ...position,
    refs,
    elements,
    dataRef,
    nodeId,
    floatingId,
    events,
    open,
    onOpenChange
  }), [position, nodeId, floatingId, events, open, onOpenChange, refs, elements]);
  index(() => {
    const node = tree == null ? void 0 : tree.nodesRef.current.find(node => node.id === nodeId);
    if (node) {
      node.context = context;
    }
  });
  return React__namespace.useMemo(() => ({
    ...position,
    context,
    refs,
    elements
  }), [position, refs, elements, context]);
}

/**
 * Opens the floating element while the reference element has focus, like CSS
 * `:focus`.
 * @see https://floating-ui.com/docs/useFocus
 */
function useFocus(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    dataRef,
    events,
    refs,
    elements: {
      floating,
      domReference
    }
  } = context;
  const {
    enabled = true,
    keyboardOnly = true
  } = props;
  const pointerTypeRef = React__namespace.useRef('');
  const blockFocusRef = React__namespace.useRef(false);
  const timeoutRef = React__namespace.useRef();
  React__namespace.useEffect(() => {
    if (!enabled) {
      return;
    }
    const doc = getDocument$1(floating);
    const win = doc.defaultView || window;

    // If the reference was focused and the user left the tab/window, and the
    // floating element was not open, the focus should be blocked when they
    // return to the tab/window.
    function onBlur() {
      if (!open && isHTMLElement(domReference) && domReference === activeElement(getDocument$1(domReference))) {
        blockFocusRef.current = true;
      }
    }
    win.addEventListener('blur', onBlur);
    return () => {
      win.removeEventListener('blur', onBlur);
    };
  }, [floating, domReference, open, enabled]);
  React__namespace.useEffect(() => {
    if (!enabled) {
      return;
    }
    function onDismiss(payload) {
      if (payload.type === 'referencePress' || payload.type === 'escapeKey') {
        blockFocusRef.current = true;
      }
    }
    events.on('dismiss', onDismiss);
    return () => {
      events.off('dismiss', onDismiss);
    };
  }, [events, enabled]);
  React__namespace.useEffect(() => {
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, []);
  return React__namespace.useMemo(() => {
    if (!enabled) {
      return {};
    }
    return {
      reference: {
        onPointerDown(_ref) {
          let {
            pointerType
          } = _ref;
          pointerTypeRef.current = pointerType;
          blockFocusRef.current = !!(pointerType && keyboardOnly);
        },
        onMouseLeave() {
          blockFocusRef.current = false;
        },
        onFocus(event) {
          var _dataRef$current$open;
          if (blockFocusRef.current) {
            return;
          }

          // Dismiss with click should ignore the subsequent `focus` trigger,
          // but only if the click originated inside the reference element.
          if (event.type === 'focus' && ((_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type) === 'mousedown' && isEventTargetWithin(dataRef.current.openEvent, domReference)) {
            return;
          }
          onOpenChange(true, event.nativeEvent);
        },
        onBlur(event) {
          blockFocusRef.current = false;
          const relatedTarget = event.relatedTarget;

          // Hit the non-modal focus management portal guard. Focus will be
          // moved into the floating element immediately after.
          const movedToFocusGuard = isElement(relatedTarget) && relatedTarget.hasAttribute(createAttribute('focus-guard')) && relatedTarget.getAttribute('data-type') === 'outside';

          // Wait for the window blur listener to fire.
          timeoutRef.current = setTimeout(() => {
            // When focusing the reference element (e.g. regular click), then
            // clicking into the floating element, prevent it from hiding.
            // Note: it must be focusable, e.g. `tabindex="-1"`.
            if (contains(refs.floating.current, relatedTarget) || contains(domReference, relatedTarget) || movedToFocusGuard) {
              return;
            }
            onOpenChange(false, event.nativeEvent);
          });
        }
      }
    };
  }, [enabled, keyboardOnly, domReference, refs, dataRef, onOpenChange]);
}

function mergeProps(userProps, propsList, elementKey) {
  const map = new Map();
  return {
    ...(elementKey === 'floating' && {
      tabIndex: -1
    }),
    ...userProps,
    ...propsList.map(value => value ? value[elementKey] : null).concat(userProps).reduce((acc, props) => {
      if (!props) {
        return acc;
      }
      Object.entries(props).forEach(_ref => {
        let [key, value] = _ref;
        if (key.indexOf('on') === 0) {
          if (!map.has(key)) {
            map.set(key, []);
          }
          if (typeof value === 'function') {
            var _map$get;
            (_map$get = map.get(key)) == null ? void 0 : _map$get.push(value);
            acc[key] = function () {
              var _map$get2;
              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }
              return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map(fn => fn(...args)).find(val => val !== undefined);
            };
          }
        } else {
          acc[key] = value;
        }
      });
      return acc;
    }, {})
  };
}

/**
 * Merges an array of interaction hooks' props into prop getters, allowing
 * event handler functions to be composed together without overwriting one
 * another.
 * @see https://floating-ui.com/docs/react#interaction-hooks
 */
function useInteractions(propsList) {
  if (propsList === void 0) {
    propsList = [];
  }
  // The dependencies are a dynamic array, so we can't use the linter's
  // suggestion to add it to the deps array.
  const deps = propsList;
  const getReferenceProps = React__namespace.useCallback(userProps => mergeProps(userProps, propsList, 'reference'),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  deps);
  const getFloatingProps = React__namespace.useCallback(userProps => mergeProps(userProps, propsList, 'floating'),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  deps);
  const getItemProps = React__namespace.useCallback(userProps => mergeProps(userProps, propsList, 'item'),
  // Granularly check for `item` changes, because the `getItemProps` getter
  // should be as referentially stable as possible since it may be passed as
  // a prop to many components. All `item` key values must therefore be
  // memoized.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  propsList.map(key => key == null ? void 0 : key.item));
  return React__namespace.useMemo(() => ({
    getReferenceProps,
    getFloatingProps,
    getItemProps
  }), [getReferenceProps, getFloatingProps, getItemProps]);
}

/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 * @see https://floating-ui.com/docs/useMergeRefs
 */
function useMergeRefs(refs) {
  return React__namespace.useMemo(() => {
    if (refs.every(ref => ref == null)) {
      return null;
    }
    return value => {
      refs.forEach(ref => {
        if (typeof ref === 'function') {
          ref(value);
        } else if (ref != null) {
          ref.current = value;
        }
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, refs);
}

/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */
function useRole(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    floatingId
  } = context;
  const {
    enabled = true,
    role = 'dialog'
  } = props;
  const referenceId = useId();
  return React__namespace.useMemo(() => {
    const floatingProps = {
      id: floatingId,
      role
    };
    if (!enabled) {
      return {};
    }
    if (role === 'tooltip') {
      return {
        reference: {
          'aria-describedby': open ? floatingId : undefined
        },
        floating: floatingProps
      };
    }
    return {
      reference: {
        'aria-expanded': open ? 'true' : 'false',
        'aria-haspopup': role === 'alertdialog' ? 'dialog' : role,
        'aria-controls': open ? floatingId : undefined,
        ...(role === 'listbox' && {
          role: 'combobox'
        }),
        ...(role === 'menu' && {
          id: referenceId
        })
      },
      floating: {
        ...floatingProps,
        ...(role === 'menu' && {
          'aria-labelledby': referenceId
        })
      }
    };
  }, [enabled, role, open, floatingId, referenceId]);
}

function useTooltip(_a) {
    var _b, _c;
    var _d = _a === void 0 ? {} : _a, _e = _d.initialOpen, initialOpen = _e === void 0 ? false : _e, _f = _d.placement, placement = _f === void 0 ? 'top' : _f, controlledOpen = _d.open, setControlledOpen = _d.onOpenChange, _g = _d.enableClick, enableClick = _g === void 0 ? true : _g;
    var arrowRef = React__namespace.useRef(null);
    var _h = _tslib.__read(React__namespace.useState(initialOpen), 2), uncontrolledOpen = _h[0], setUncontrolledOpen = _h[1];
    var open = controlledOpen !== null && controlledOpen !== void 0 ? controlledOpen : uncontrolledOpen;
    var setOpen = setControlledOpen !== null && setControlledOpen !== void 0 ? setControlledOpen : setUncontrolledOpen;
    var arrowLength = (_c = (_b = arrowRef.current) === null || _b === void 0 ? void 0 : _b.offsetWidth) !== null && _c !== void 0 ? _c : 0;
    var floatingOffset = Math.sqrt(2 * Math.pow(arrowLength, 2)) / 2;
    var data = useFloating({
        placement: placement,
        open: open,
        onOpenChange: setOpen,
        whileElementsMounted: autoUpdate,
        middleware: [
            offset(floatingOffset + 8),
            flip(),
            size({
                padding: 8,
            }),
            shift(),
            arrow({ element: arrowRef }),
        ],
    });
    var context = data.context;
    var hover = useHover(context, {
        move: false,
        enabled: controlledOpen == null,
    });
    var click = useClick(context, { enabled: controlledOpen == null && enableClick });
    var focus = useFocus(context, {
        enabled: controlledOpen == null,
    });
    var dismiss = useDismiss(context);
    var role = useRole(context, { role: 'tooltip' });
    var interactions = useInteractions([hover, focus, dismiss, role, click]);
    return React__namespace.useMemo(function () { return (_tslib.__assign(_tslib.__assign(_tslib.__assign({ open: open, setOpen: setOpen }, interactions), data), { arrowRef: arrowRef })); }, [open, setOpen, interactions, data]);
}
var TooltipContext = React__namespace.createContext(null);
var useTooltipContext = function () {
    var context = React__namespace.useContext(TooltipContext);
    if (context == null) {
        throw new Error('Tooltip components must be wrapped in <Tooltip />');
    }
    return context;
};
function Tooltip(_a) {
    var children = _a.children, options = _tslib.__rest(_a, ["children"]);
    // This can accept any props as options, e.g. `placement`,
    // or other positioning options.
    var tooltip = useTooltip(options);
    return React__namespace.createElement(TooltipContext.Provider, { value: tooltip }, children);
}
var TooltipTrigger = React__namespace.forwardRef(function TooltipTrigger(_a, propRef) {
    var children = _a.children, _b = _a.asChild, asChild = _b === void 0 ? false : _b, props = _tslib.__rest(_a, ["children", "asChild"]);
    var context = useTooltipContext();
    var childrenRef = children.ref;
    var ref = useMergeRefs([context.refs.setReference, propRef, childrenRef]);
    // `asChild` allows the user to pass any element as the anchor
    if (asChild && React__namespace.isValidElement(children)) {
        return React__namespace.cloneElement(children, context.getReferenceProps(_tslib.__assign(_tslib.__assign(_tslib.__assign({ ref: ref }, props), children.props), { 'data-state': context.open ? 'open' : 'closed' })));
    }
    return (React__namespace.createElement(UnstyledButton, _tslib.__assign({ ref: ref, "data-state": context.open ? 'open' : 'closed' }, context.getReferenceProps(props)), children));
});
var TooltipContent = React__namespace.forwardRef(function TooltipContent(props, propRef) {
    var _a;
    var _b, _c, _d, _e;
    var context = useTooltipContext();
    var ref = useMergeRefs([context.refs.setFloating, propRef]);
    if (!context.open)
        return null;
    var side = context.placement.split('-')[0];
    var staticSides = {
        top: 'bottom',
        right: 'left',
        bottom: 'top',
        left: 'right',
    };
    var staticSide = staticSides[side];
    var arrow = context.middlewareData.arrow;
    var arrowLength = (_c = (_b = context.arrowRef.current) === null || _b === void 0 ? void 0 : _b.offsetWidth) !== null && _c !== void 0 ? _c : 0;
    var borderRadius = Object.keys(staticSides)
        .map(function (it) { return (it === staticSide ? '2px' : 0); })
        .join(' ');
    return (React__namespace.createElement(FloatingPortal, null,
        React__namespace.createElement(Floating, _tslib.__assign({ ref: ref, style: context.floatingStyles }, context.getFloatingProps(props)),
            props.children,
            React__namespace.createElement(Arrow, { ref: context.arrowRef, style: (_a = {
                        left: (_d = arrow === null || arrow === void 0 ? void 0 : arrow.x) !== null && _d !== void 0 ? _d : 'unset',
                        top: (_e = arrow === null || arrow === void 0 ? void 0 : arrow.y) !== null && _e !== void 0 ? _e : 'unset',
                        right: 'unset',
                        bottom: 'unset'
                    },
                    _a[staticSide] = -arrowLength / 2,
                    _a.borderRadius = borderRadius,
                    _a) }))));
});
var UnstyledButton = styled__default.default.button.withConfig({ displayName: "UnstyledButton", componentId: "-b238gk" })(templateObject_1$1G || (templateObject_1$1G = _tslib.__makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: none;\n  background: transparent;\n  padding: 0;\n  margin: 0;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: none;\n  background: transparent;\n  padding: 0;\n  margin: 0;\n"])));
var Floating = styled__default.default.div.withConfig({ displayName: "Floating", componentId: "-fcx6qk" })(templateObject_2$1i || (templateObject_2$1i = _tslib.__makeTemplateObject(["\n  color: ", ";\n  background: ", ";\n  padding: 4px 8px;\n  border-radius: 4px;\n  box-sizing: border-box;\n  z-index: 1000;\n  max-width: 200px;\n"], ["\n  color: ", ";\n  background: ", ";\n  padding: 4px 8px;\n  border-radius: 4px;\n  box-sizing: border-box;\n  z-index: 1000;\n  max-width: 200px;\n"])), styles.themeColors.gray[20], styles.themeColors.gray[80]);
var Arrow = styled__default.default.div.withConfig({ displayName: "Arrow", componentId: "-dn1s57" })(templateObject_3$T || (templateObject_3$T = _tslib.__makeTemplateObject(["\n  position: absolute;\n  width: 12px;\n  height: 12px;\n  background: ", ";\n  z-index: -1;\n  pointer-events: none;\n  transform: rotate(45deg);\n"], ["\n  position: absolute;\n  width: 12px;\n  height: 12px;\n  background: ", ";\n  z-index: -1;\n  pointer-events: none;\n  transform: rotate(45deg);\n"])), styles.themeColors.gray[80]);
var templateObject_1$1G, templateObject_2$1i, templateObject_3$T;

var SMALL_ICON_SIZE = 18;
var MEDIUM_ICON_SIZE = 24;
var getIconSize = function (size) { return ({
    height: size,
    width: size,
}); };
var PillWithoutTooltip = function (_a) {
    var text = _a.text, _b = _a.size, size = _b === void 0 ? 'small' : _b, icon = _a.icon, _c = _a.iconSide, iconSide = _c === void 0 ? 'left' : _c, iconSize = _a.iconSize;
    var iconSizeProps = iconSize !== null && iconSize !== void 0 ? iconSize : getIconSize(size === 'small' ? SMALL_ICON_SIZE : MEDIUM_ICON_SIZE);
    return (React__namespace.createElement(PillContainer, { size: size },
        iconSide === 'left' && icon && React__namespace.createElement(Icon, _tslib.__assign({ name: icon }, iconSizeProps)),
        React__namespace.createElement(Hyperlink.Text, { useCompact: true, type: "subtitle", fontWeight: 700 },
            React__namespace.createElement(SingleLineText$1, null, text)),
        iconSide === 'right' && icon && React__namespace.createElement(Icon, _tslib.__assign({ name: icon }, iconSizeProps))));
};
var PillWithTooltip = function (props) { return (React__namespace.createElement(Tooltip, { placement: "bottom" },
    React__namespace.createElement(TooltipTrigger, { as: "div" },
        React__namespace.createElement(PillWithoutTooltip, _tslib.__assign({}, props))),
    React__namespace.createElement(TooltipContent, null, props.tooltipContent))); };
var Pill = function (props) {
    if (props.tooltipContent && props.iconSide === 'right') {
        return React__namespace.createElement(PillWithTooltip, _tslib.__assign({}, props));
    }
    return React__namespace.createElement(PillWithoutTooltip, _tslib.__assign({}, props));
};
var PillContainer = styled__default.default.div.withConfig({ displayName: "PillContainer", componentId: "-17gcrz7" })(templateObject_2$1h || (templateObject_2$1h = _tslib.__makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 8px;\n  border: ", ";\n  border-radius: 9999px;\n\n  ", "\n"], ["\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 8px;\n  border: ", ";\n  border-radius: 9999px;\n\n  ", "\n"])), styles.themeBorder.default, function (_a) {
    var size = _a.size;
    return size === 'medium' && styled.css(templateObject_1$1F || (templateObject_1$1F = _tslib.__makeTemplateObject(["\n      padding: 8px 16px;\n    "], ["\n      padding: 8px 16px;\n    "])));
});
var SingleLineText$1 = styled__default.default.span.withConfig({ displayName: "SingleLineText", componentId: "-e95yaq" })(templateObject_3$S || (templateObject_3$S = _tslib.__makeTemplateObject(["\n  white-space: nowrap;\n"], ["\n  white-space: nowrap;\n"])));
var templateObject_1$1F, templateObject_2$1h, templateObject_3$S;

var icons = [
    'achievement',
    'add',
    'alert_check',
    'alert_error',
    'android',
    'apple',
    'arrow_tip_down',
    'arrow_tip_left',
    'arrow_tip_right',
    'arrow_tip_up',
    'attention',
    'calendar',
    'capslock',
    'check_round',
    'check',
    'chevron_down',
    'chevron_left',
    'chevron_right',
    'chevron_up',
    'close',
    'community',
    'content_delivery',
    'copy',
    'credits_yellow',
    'devices',
    'discord',
    'docker',
    'dollar',
    'download',
    'edit',
    'error',
    'ethical_cb',
    'external_link',
    'eye_hide',
    'eye_show',
    'facebook',
    'feature_request',
    'feedback',
    'gift',
    'globe',
    'google',
    'hamburger',
    'help',
    'hexagon_overview',
    'honeygain',
    'info',
    'instagram',
    'key',
    'last_updated',
    'link',
    'linkedin',
    'loading',
    'lock',
    'logout',
    'lucky_pot',
    'macos',
    'mail',
    'message',
    'minus',
    'more',
    'no_connection',
    'notifications_none',
    'open',
    'phone',
    'play_circle_filled',
    'play',
    'preferences',
    'Ic_progress',
    'qr_code',
    'quit',
    'reddit',
    'referrals',
    'search',
    'share_filled',
    'share_old',
    'share',
    'stat',
    'support',
    'tag',
    'text_area_handle',
    'tiktok',
    'timer',
    'transactions',
    'trash',
    'twitter',
    'upload',
    'user',
    'volunteer',
    'wallet',
    'windows',
    'youtube',
];

var CopyButton = function (_a) {
    var _b = _a.copyText, copyText = _b === void 0 ? 'Copied!' : _b, _c = _a.variant, variant = _c === void 0 ? 'copy' : _c, props = _tslib.__rest(_a, ["copyText", "variant"]);
    var _d = _tslib.__read(React.useState(false), 2), showCopy = _d[0], setShowCopy = _d[1];
    var handleCopyLink = hooks_index.useShare({
        url: props.children,
        facebookAppId: '',
    }).handleCopyLink;
    var handleClick = function (event) { return _tslib.__awaiter(void 0, void 0, void 0, function () {
        var error_1;
        var _a, _b;
        return _tslib.__generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!!showCopy) return [3 /*break*/, 4];
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, handleCopyLink()];
                case 2:
                    _c.sent();
                    setShowCopy(true);
                    setTimeout(function () {
                        setShowCopy(false);
                    }, 3000);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _c.sent();
                    console.error('Error copying link:', error_1);
                    return [3 /*break*/, 4];
                case 4:
                    (_b = (_a = props.buttonProps).onClick) === null || _b === void 0 ? void 0 : _b.call(_a, event);
                    return [2 /*return*/];
            }
        });
    }); };
    return (React__namespace.default.createElement(Button$2, _tslib.__assign({}, props.buttonProps, { icon: "copy", variant: variant, onClick: function (e) {
            handleClick(e).catch(function (error) {
                console.error('Error in handleClick:', error);
            });
        } }), showCopy ? copyText : props.children));
};

var CardHeader = function (props) { return (React__namespace.createElement(React__namespace.Fragment, null,
    React__namespace.createElement(Spacing.Flex, { className: props.className, justify: Spacing.FlexJustify.SPACE_BETWEEN, align: Spacing.FlexAlign.CENTER },
        props.header,
        React__namespace.createElement(RightHeader, { component: props.rightHeader })),
    props.subHeader && (React__namespace.createElement(Spacing.Flex, { justify: Spacing.FlexJustify.FLEX_START, align: Spacing.FlexAlign.CENTER },
        React__namespace.createElement(Hyperlink.Text, { type: Hyperlink.TextType.SUBTITLE },
            React__namespace.createElement("div", null, props.subHeader)))))); };
var RightHeader = function (props) {
    if (props.component) {
        if (typeof props.component === 'string') {
            return (React__namespace.createElement(Hyperlink.Text, { type: Hyperlink.TextType.SUBTITLE, color: styles.themeColors.slate[20] },
                React__namespace.createElement("div", null, props.component)));
        }
        return props.component;
    }
    return null;
};

var StatusCard = function (_a) {
    var title = _a.title, _b = _a.status, status = _b === void 0 ? 'neutral' : _b, statusText = _a.statusText, _c = _a.active, active = _c === void 0 ? true : _c, time = _a.time, children = _a.children;
    return (React__namespace.createElement(StyledStatusCard, { flexDir: "row", active: active },
        React__namespace.createElement(VerticalLine, { status: status }),
        React__namespace.createElement(Spacing.Flex, { flex: 1, flexDir: "column" },
            React__namespace.createElement(Spacing.Flex, { justify: "space-between", align: "center" },
                React__namespace.createElement(Badge, { variant: status, text: statusText }),
                React__namespace.createElement(Hyperlink.Text, { type: "subtitle", color: styles.themeColors.gray[80], useCompact: true },
                    React__namespace.createElement("span", null, time))),
            React__namespace.createElement(Spacing.Spacing, { vertical: 1 },
                React__namespace.createElement(Hyperlink.Text, { type: "body_medium_bold", useCompact: true },
                    React__namespace.createElement("span", null, title))),
            children)));
};
var getVerticalLineColor = function (status) {
    if (status === 'success' || status === 'warning') {
        return styles.themeColors.blue[50];
    }
    return ShouldDisplay.getColors(status).color;
};
var VerticalLineColor = styled.css(templateObject_1$1E || (templateObject_1$1E = _tslib.__makeTemplateObject(["\n  background-color: ", ";\n"], ["\n  background-color: ", ";\n"])), function (_a) {
    var status = _a.status;
    return getVerticalLineColor(status);
});
var VerticalLine = styled__default.default.div.withConfig({ displayName: "VerticalLine", componentId: "-1lj0kt" })(templateObject_2$1g || (templateObject_2$1g = _tslib.__makeTemplateObject(["\n  ", ";\n  width: 1px;\n  position: relative;\n  margin: 8px 4px 0;\n\n  &:after {\n    ", ";\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    border-radius: 50%;\n    width: 9px;\n    height: 9px;\n  }\n"], ["\n  ", ";\n  width: 1px;\n  position: relative;\n  margin: 8px 4px 0;\n\n  &:after {\n    ", ";\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    border-radius: 50%;\n    width: 9px;\n    height: 9px;\n  }\n"])), VerticalLineColor, VerticalLineColor);
var StyledStatusCard = styled__default.default(Spacing.Flex).withConfig({ displayName: "StyledStatusCard", componentId: "-1upx6mv" })(templateObject_4$z || (templateObject_4$z = _tslib.__makeTemplateObject(["\n  border-radius: ", "px;\n  background-color: ", ";\n  padding: 16px;\n  gap: 16px;\n  opacity: 0.3;\n\n  ", "\n"], ["\n  border-radius: ", "px;\n  background-color: ", ";\n  padding: 16px;\n  gap: 16px;\n  opacity: 0.3;\n\n  ", "\n"])), function () { return styles.themeBorder.radius.default; }, function () { return styles.themeColors.gray[10]; }, function (props) {
    return props.active && styled.css(templateObject_3$R || (templateObject_3$R = _tslib.__makeTemplateObject(["\n      opacity: unset;\n    "], ["\n      opacity: unset;\n    "])));
});
var templateObject_1$1E, templateObject_2$1g, templateObject_3$R, templateObject_4$z;

var ActiveMark = styled__default.default.span.withConfig({ componentId: "-xe9lem" })(templateObject_1$1D || (templateObject_1$1D = _tslib.__makeTemplateObject(["\n  width: ", "px;\n  height: ", "px;\n  background-color: ", ";\n  margin: ", " auto 0 !important;\n"], ["\n  width: ", "px;\n  height: ", "px;\n  background-color: ", ";\n  margin: ", " auto 0 !important;\n"])), function (props) { return (props.mobile ? 48 : 32); }, function (props) { return (props.mobile ? 3 : 2); }, styles.themeColors.gray['90'], function (props) { return (props.mobile ? '2px' : 0); });
var templateObject_1$1D;

var Burger = function (props) {
    return (React__namespace.createElement(MobileNavView, { onClick: props.onClick },
        React__namespace.createElement(MenuIcon, { className: classNames__default.default({ active: props.opened }) })));
};
var MobileNavView = styled__default.default.div.withConfig({ displayName: "MobileNavView", componentId: "-1vzmzsh" })(templateObject_1$1C || (templateObject_1$1C = _tslib.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n\n  @media ", ", ", " {\n    display: none;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n\n  @media ", ", ", " {\n    display: none;\n  }\n"])), ResponsiveSizes.media[ResponsiveSizes.BreakpointType.LARGE_DESKTOP], ResponsiveSizes.media[ResponsiveSizes.BreakpointType.DESKTOP]);
var MenuIcon = styled__default.default.div.withConfig({ displayName: "MenuIcon", componentId: "-1o3ybmk" })(templateObject_2$1f || (templateObject_2$1f = _tslib.__makeTemplateObject(["\n  position: relative;\n  border-radius: 2px;\n  width: 20px;\n  height: 2px;\n  background-color: ", ";\n  transition-duration: 0.3s;\n  &.active {\n    background-color: transparent;\n\n    &:before {\n      transform: translateY(7px) rotate(45deg);\n    }\n    &:after {\n      transform: translateY(-7px) rotate(-45deg);\n    }\n  }\n  &::after,\n  &::before {\n    border-radius: 2px;\n    content: '';\n    position: absolute;\n    width: inherit;\n    height: inherit;\n    transition-duration: inherit;\n    background-color: ", ";\n  }\n  &::before {\n    bottom: 7px;\n  }\n  &::after {\n    top: 7px;\n  }\n"], ["\n  position: relative;\n  border-radius: 2px;\n  width: 20px;\n  height: 2px;\n  background-color: ", ";\n  transition-duration: 0.3s;\n  &.active {\n    background-color: transparent;\n\n    &:before {\n      transform: translateY(7px) rotate(45deg);\n    }\n    &:after {\n      transform: translateY(-7px) rotate(-45deg);\n    }\n  }\n  &::after,\n  &::before {\n    border-radius: 2px;\n    content: '';\n    position: absolute;\n    width: inherit;\n    height: inherit;\n    transition-duration: inherit;\n    background-color: ", ";\n  }\n  &::before {\n    bottom: 7px;\n  }\n  &::after {\n    top: 7px;\n  }\n"])), styles.themeColors.gray['60'], styles.themeColors.gray['60']);
var templateObject_1$1C, templateObject_2$1f;

var renderMenuItem$1 = function (item, idx) {
    if (item.classes && item.classes.includes('menu-item-secondary-small')) {
        return (React__namespace.createElement("li", { key: idx },
            React__namespace.createElement(LinkButton, { className: classNames__default.default(item.classes), type: "secondary", size: "regular", width: 256, href: item.url, target: item.target }, item.name)));
    }
    return (React__namespace.createElement("li", { key: idx },
        React__namespace.createElement(Hyperlink.Text, { type: "heading_medium" },
            React__namespace.createElement("a", { href: item.url, target: item.target, rel: "noopener", className: classNames__default.default(item.classes) },
                React__namespace.createElement("span", { className: "menu-item-label" }, item.name),
                item.active && React__namespace.createElement(ActiveMark, { mobile: true })))));
};
var MobileMenu = function (props) { return (React__namespace.createElement(WrapperView$7, { className: classNames__default.default({ fadeIn: props.opened === true, fadeOut: props.opened === false }), opened: props.opened },
    React__namespace.createElement(Container$t, null,
        React__namespace.createElement(MenuListWrapper, null, props.items.map(renderMenuItem$1))))); };
var MenuListWrapper = styled__default.default.ul.withConfig({ displayName: "MenuListWrapper", componentId: "-9o3bdg" })(templateObject_1$1B || (templateObject_1$1B = _tslib.__makeTemplateObject(["\n  list-style-type: none;\n  margin: 60px 0;\n  padding: 0px;\n\n  li {\n    text-align: center;\n    margin: 32px 0;\n\n    a:hover .menu-item-label {\n      color: ", ";\n    }\n\n    a:active .menu-item-label {\n      color: ", ";\n    }\n  }\n"], ["\n  list-style-type: none;\n  margin: 60px 0;\n  padding: 0px;\n\n  li {\n    text-align: center;\n    margin: 32px 0;\n\n    a:hover .menu-item-label {\n      color: ", ";\n    }\n\n    a:active .menu-item-label {\n      color: ", ";\n    }\n  }\n"])), styles.themeColors.gray['60'], styles.themeColors.gray['100']);
var WrapperView$7 = styled__default.default.div.withConfig({ shouldForwardProp: Spacing.isPropValid })(templateObject_2$1e || (templateObject_2$1e = _tslib.__makeTemplateObject(["\n  visibility: hidden;\n  position: fixed;\n  width: 100%;\n  background-color: white;\n  top: 64px;\n  z-index: 1000;\n  box-shadow: 0px 4px 4px 0 rgba(35, 68, 101, 0.1), 0px 4px 4px 0 rgba(35, 68, 101, 0.1);\n\n  ", "\n  ", "\n\n  @media ", ", ", " {\n    display: none;\n  }\n"], ["\n  visibility: hidden;\n  position: fixed;\n  width: 100%;\n  background-color: white;\n  top: 64px;\n  z-index: 1000;\n  box-shadow: 0px 4px 4px 0 rgba(35, 68, 101, 0.1), 0px 4px 4px 0 rgba(35, 68, 101, 0.1);\n\n  ", "\n  ", "\n\n  @media ", ", ", " {\n    display: none;\n  }\n"])), function (props) { return (props.opened !== true ? animations_index.fadeOut : undefined); }, function (props) { return (props.opened ? animations_index.fadeIn : undefined); }, ResponsiveSizes.media[ResponsiveSizes.BreakpointType.LARGE_DESKTOP], ResponsiveSizes.media[ResponsiveSizes.BreakpointType.DESKTOP]);
var templateObject_1$1B, templateObject_2$1e;

var renderMenuItem = function (item, idx) {
    if (item.classes && item.classes.includes('menu-item-secondary-small')) {
        return (React__namespace.createElement(LinkButton, { className: classNames__default.default.apply(void 0, _tslib.__spreadArray([], _tslib.__read((item.classes || [])), false)), type: "secondary", size: "small", width: 131, key: idx, href: item.url, target: item.target }, item.name));
    }
    return (React__namespace.createElement(Hyperlink.Text, { key: idx, type: Hyperlink.TextType.LABEL },
        React__namespace.createElement("a", { href: item.url, target: item.target, className: classNames__default.default.apply(void 0, _tslib.__spreadArray([], _tslib.__read((item.classes || [])), false)) },
            React__namespace.createElement("span", { className: "menu-item-label" }, item.name),
            item.active && React__namespace.createElement(ActiveMark, null))));
};
var TopMenu = function (props) { return (React__namespace.createElement(React__namespace.Fragment, null,
    React__namespace.createElement(WrapperView$6, { scrolled: props.scrolled },
        React__namespace.createElement(Container$t, null,
            React__namespace.createElement(MenuWrapper$1, null,
                React__namespace.createElement(LogoLinkView, { href: "/", rel: "noopener" },
                    React__namespace.createElement(LogoView, null, props.isXmas ? React__namespace.createElement(AchievementStar.LogoXmas, null) : React__namespace.createElement(AchievementStar.Logo, null))),
                React__namespace.createElement(NavView, null, props.items.map(renderMenuItem)),
                React__namespace.createElement(Burger, { opened: Boolean(props.opened), onClick: props.onMenuToggle })))),
    React__namespace.createElement(MobileMenu, { items: props.items, opened: props.opened }))); };
var NavView = styled__default.default.nav.withConfig({ displayName: "NavView", componentId: "-1xcg5db" })(templateObject_1$1A || (templateObject_1$1A = _tslib.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n\n  a,\n  button {\n    margin-left: 40px;\n  }\n\n  a {\n    &:hover .menu-item-label {\n      color: ", ";\n    }\n\n    &:active .menu-item-label {\n      color: ", ";\n    }\n  }\n\n  @media ", ", ", " {\n    display: none;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n\n  a,\n  button {\n    margin-left: 40px;\n  }\n\n  a {\n    &:hover .menu-item-label {\n      color: ", ";\n    }\n\n    &:active .menu-item-label {\n      color: ", ";\n    }\n  }\n\n  @media ", ", ", " {\n    display: none;\n  }\n"])), styles.themeColors.gray['60'], styles.themeColors.gray['100'], ResponsiveSizes.media.tablet, ResponsiveSizes.media.mobile);
var MenuWrapper$1 = styled__default.default(Spacing.Flex).withConfig({ displayName: "MenuWrapper", componentId: "-1nzd7vl" })(templateObject_2$1d || (templateObject_2$1d = _tslib.__makeTemplateObject(["\n  height: 64px;\n  justify-content: space-between;\n"], ["\n  height: 64px;\n  justify-content: space-between;\n"])));
var LogoLinkView = styled__default.default.a.withConfig({ displayName: "LogoLinkView", componentId: "-3l5mgi" })(templateObject_3$Q || (templateObject_3$Q = _tslib.__makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));
var LogoView = styled__default.default.div.withConfig({ displayName: "LogoView", componentId: "-oow14a" })(templateObject_4$y || (templateObject_4$y = _tslib.__makeTemplateObject(["\n  width: 195px !important;\n"], ["\n  width: 195px !important;\n"])));
var WrapperView$6 = styled__default.default.div.withConfig({ shouldForwardProp: Spacing.isPropValid })(templateObject_5$n || (templateObject_5$n = _tslib.__makeTemplateObject(["\n  position: fixed;\n  top: 0;\n  width: 100%;\n  background-color: #fff;\n  z-index: 1000;\n  ", "\n"], ["\n  position: fixed;\n  top: 0;\n  width: 100%;\n  background-color: #fff;\n  z-index: 1000;\n  ", "\n"])), function (props) {
    return props.scrolled ? "box-shadow: 0px 4px 4px rgba(35, 68, 101, 0.1), 0px 4px 16px rgba(35, 68, 101, 0.1);" : '';
});
var templateObject_1$1A, templateObject_2$1d, templateObject_3$Q, templateObject_4$y, templateObject_5$n;

var arrowSize = {
    small: 18,
    regular: 16,
    large: 24,
};
var ArrowView$2 = styled__default.default(ArrowDown.ArrowDown).withConfig({ shouldForwardProp: Spacing.isPropValid })(templateObject_1$1z || (templateObject_1$1z = _tslib.__makeTemplateObject(["\n  ", "\n  width: ", "px;\n  height: ", "px;\n  ", "\n  fill: ", ";\n"], ["\n  ", "\n  width: ", "px;\n  height: ", "px;\n  ", "\n  fill: ", ";\n"])), function (props) { return (props.opened ? 'transform: rotate(180deg);' : undefined); }, function (props) { return arrowSize[props.size]; }, function (props) { return arrowSize[props.size]; }, function (props) { return (props.mode === 'inline' ? 'margin-left: auto;' : undefined); }, function (props) { return (props.color ? props.color : undefined); });
var templateObject_1$1z;

var CardTab = function (props) { return (React__namespace.createElement(TabPill, _tslib.__assign({}, props, { onClick: props.onClick }),
    React__namespace.createElement(Hyperlink.Text, { useCompact: true, type: "body", color: !props.enabled ? styles.themeColors.slate['20'] : styles.themeColors.blue['50'] },
        React__namespace.createElement("span", null, props.children)),
    props.isDropdown && (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement(Spacing.Spacing, { left: 0.5 }),
        React__namespace.createElement(ArrowView$2, { mode: "dropdown", opened: !!props.isOpened, size: "regular", color: !props.enabled ? styles.themeColors.slate['20'] : styles.themeColors.blue['50'] }))))); };
var TabPill = styled__default.default(Spacing.InlineFlex).withConfig({ displayName: "TabPill", componentId: "-1mgm179" })(templateObject_1$1y || (templateObject_1$1y = _tslib.__makeTemplateObject(["\n  justify-content: center;\n  align-items: center;\n  padding: 8px;\n  border-radius: 8px;\n  background-color: ", ";\n  ", "\n\n  svg {\n    color: ", ";\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n"], ["\n  justify-content: center;\n  align-items: center;\n  padding: 8px;\n  border-radius: 8px;\n  background-color: ", ";\n  ", "\n\n  svg {\n    color: ", ";\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n"])), function (props) { return (props.enabled ? styles.themeColors.blue['5'] : 'transparent'); }, function (props) { return (props.onClick ? 'cursor: pointer;' : undefined); }, function (props) { return (!props.enabled || props.isDropdown ? styles.themeColors.slate['20'] : styles.themeColors.blue['50']); }, function (props) { return (props.disableHover ? undefined : styles.themeColors.blue['5']); });
var templateObject_1$1y;

var CardTabContainer = function (props) {
    if (!(props.size === ResponsiveSizes.BreakpointType.MOBILE)) {
        return (React__namespace.createElement(TabContainerView, null, Object.keys(props.tabs).map(function (key) { return (React__namespace.createElement(CardTab, { key: key, onClick: function () { return props.onSelect(key); }, enabled: props.selected === key }, props.tabs[key])); })));
    }
    if (!props.opened) {
        return (React__namespace.createElement(CardTab, { enabled: true, isDropdown: true, onClick: props.onOpen }, props.tabs[props.selected]));
    }
    var _a = props.tabs, _b = props.selected; _a[_b]; var dropdownTabs = _tslib.__rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
    return (React__namespace.createElement("div", { style: { position: 'relative', width: 'fit-content' } },
        React__namespace.createElement(CardTab, { enabled: true, isDropdown: true, isOpened: true, onClick: function () { return props.onSelect(props.selected); } }, props.tabs[props.selected]),
        React__namespace.createElement(DropdownContainer, null, Object.keys(dropdownTabs).map(function (value, idx) { return (React__namespace.createElement(DropdownItem, { key: idx, onClick: function () { return props.onSelect(value); } },
            React__namespace.createElement(Hyperlink.Text, { useCompact: true, type: Hyperlink.TextType.BODY_SMALL, color: styles.themeColors.slate['20'] },
                React__namespace.createElement("span", null, dropdownTabs[value])))); }))));
};
var TabContainerView = styled__default.default(Spacing.Flex).withConfig({ displayName: "TabContainerView", componentId: "-10c8c13" })(templateObject_1$1x || (templateObject_1$1x = _tslib.__makeTemplateObject(["\n  gap: 8px;\n"], ["\n  gap: 8px;\n"])));
var DropdownContainer = styled__default.default.div.withConfig({ displayName: "DropdownContainer", componentId: "-1h4w498" })(templateObject_2$1c || (templateObject_2$1c = _tslib.__makeTemplateObject(["\n  position: absolute;\n  background-color: ", ";\n  border-radius: 8px;\n  width: 100%;\n"], ["\n  position: absolute;\n  background-color: ", ";\n  border-radius: 8px;\n  width: 100%;\n"])), styles.themeColors.blue['5']);
var DropdownItem = styled__default.default.div.withConfig({ displayName: "DropdownItem", componentId: "-mj6lbs" })(templateObject_3$P || (templateObject_3$P = _tslib.__makeTemplateObject(["\n  cursor: pointer;\n  padding: 8px;\n\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n  }\n"], ["\n  cursor: pointer;\n  padding: 8px;\n\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n  }\n"])), styles.themeColors.blue['10'], styles.themeColors.slate['30']);
var CardTabContainer$1 = ResponsiveSizes.withSizes(ResponsiveSizes.mapSizesToProps)(CardTabContainer);
var templateObject_1$1x, templateObject_2$1c, templateObject_3$P;

var CardWithAuthor = function (props) { return (React__namespace.createElement(CardBase, { padding: "large" },
    React__namespace.createElement(Spacing.Flex, { flexDir: "column" },
        React__namespace.createElement(Spacing.Spacing, { bottom: 2 },
            React__namespace.createElement(Spacing.Flex, null,
                React__namespace.createElement(AchievementStar.AvatarIcon, null),
                React__namespace.createElement(Spacing.Spacing, { left: 2 }),
                React__namespace.createElement(Spacing.Flex, { flexDir: "column" },
                    React__namespace.createElement(Hyperlink.Text, { type: "heading_medium" },
                        React__namespace.createElement("h4", null, props.author)),
                    React__namespace.createElement(Hyperlink.Text, { type: "body", color: styles.themeColors.gray['40'] },
                        React__namespace.createElement("small", null, props.subtitle))))),
        React__namespace.createElement(Hyperlink.Text, { type: "body" },
            React__namespace.createElement("p", null, props.children))))); };

var Card$6 = function (props) { return (React__namespace.createElement(CardView, { className: props.className, withoutPadding: props.withoutPadding, contentDir: props.contentDir ? props.contentDir : 'column' },
    props.tabs && (React__namespace.createElement(Spacing.Flex, { style: { width: '100%' } }, Object.keys(props.tabs).map(function (item, nr) { return (React__namespace.createElement(TabView, { nr: nr, tabsCount: Object.keys(props.tabs).length, key: item, active: props.selectedTab === item, disabled: props.tabs[item].disabled, onClick: function () {
            if (props.selectedTab !== item && !props.tabs[item].disabled) {
                props.onTabChange(item);
            }
        } }, props.tabs[item].tabView)); }))),
    React__namespace.createElement(CardContentView, { withoutPadding: props.withoutPadding, contentWidth: props.contentWidth }, props.tabs && props.selectedTab ? props.tabs[props.selectedTab].contentView : props.children))); };
var TabView = styled__default.default(Spacing.Flex).withConfig({ displayName: "TabView", componentId: "-iz8vgv" })(templateObject_1$1w || (templateObject_1$1w = _tslib.__makeTemplateObject(["\n  cursor: ", ";\n  justify-content: center;\n  box-shadow: ", ";\n  width: calc(100% / ", ");\n  padding: 16px;\n  background-color: ", ";\n  border-radius: ", "\n    ", " 0 0;\n"], ["\n  cursor: ", ";\n  justify-content: center;\n  box-shadow: ", ";\n  width: calc(100% / ", ");\n  padding: 16px;\n  background-color: ", ";\n  border-radius: ", "\n    ", " 0 0;\n"])), function (props) { return (!props.active && !props.disabled ? 'pointer' : undefined); }, function (props) { return (props.active ? "inset 0 2px 0 ".concat(styles.themeColors.blue['50']) : undefined); }, function (props) { return props.tabsCount; }, function (props) { return (props.active ? styles.themeColors.white : styles.themeColors.gray['5']); }, function (props) { return (props.nr === 0 ? '8px' : 0); }, function (props) { return (props.nr === props.tabsCount - 1 ? '8px' : 0); });
var CardContentView = styled__default.default.div.withConfig({ shouldForwardProp: Spacing.isPropValid })(templateObject_2$1b || (templateObject_2$1b = _tslib.__makeTemplateObject(["\n  box-sizing: border-box;\n  width: ", ";\n\n  @media ", ", ", " {\n    padding: ", "px;\n  }\n\n  @media ", ", ", " {\n    padding: ", "px;\n  }\n"], ["\n  box-sizing: border-box;\n  width: ", ";\n\n  @media ", ", ", " {\n    padding: ", "px;\n  }\n\n  @media ", ", ", " {\n    padding: ", "px;\n  }\n"])), function (props) { return props.contentWidth; }, ResponsiveSizes.media['largeDesktop'], ResponsiveSizes.media['desktop'], function (props) { return (props.withoutPadding ? 0 : 24); }, ResponsiveSizes.media['tablet'], ResponsiveSizes.media['mobile'], function (props) { return (props.withoutPadding ? 0 : 16); });
var CardView = styled__default.default.div.withConfig({ shouldForwardProp: Spacing.isPropValid })(templateObject_3$O || (templateObject_3$O = _tslib.__makeTemplateObject(["\n  width: 100%;\n  border-radius: 8px;\n  box-shadow:\n    0px 4px 16px rgba(35, 68, 101, 0.05),\n    0px 4px 4px rgba(35, 68, 101, 0.05);\n  background-color: #fff;\n  margin-bottom: 24px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: ", ";\n  justify-content: center;\n  align-items: center;\n  @media ", ", ", " {\n    padding: ", "px;\n  }\n"], ["\n  width: 100%;\n  border-radius: 8px;\n  box-shadow:\n    0px 4px 16px rgba(35, 68, 101, 0.05),\n    0px 4px 4px rgba(35, 68, 101, 0.05);\n  background-color: #fff;\n  margin-bottom: 24px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: ", ";\n  justify-content: center;\n  align-items: center;\n  @media ", ", ", " {\n    padding: ", "px;\n  }\n"])), function (props) { return props.contentDir; }, ResponsiveSizes.media['mobile'], ResponsiveSizes.media['tablet'], function (props) { return (props.withoutPadding ? 0 : 16); });
var templateObject_1$1w, templateObject_2$1b, templateObject_3$O;

var ContentContainer$3 = styled__default.default.div.withConfig({ displayName: "ContentContainer", componentId: "-1m2wwye" })(templateObject_1$1v || (templateObject_1$1v = _tslib.__makeTemplateObject(["\n  max-width: 480px;\n  width: 100%;\n"], ["\n  max-width: 480px;\n  width: 100%;\n"])));
var IconContainer$2 = styled__default.default.div.withConfig({ displayName: "IconContainer", componentId: "-104cfj0" })(templateObject_2$1a || (templateObject_2$1a = _tslib.__makeTemplateObject(["\n  overflow: hidden;\n"], ["\n  overflow: hidden;\n"])));
var CardWithTopic = function (_a) {
    var icon = _a.icon, heading = _a.heading, body = _a.body, children = _a.children;
    return (React__namespace.createElement(Card$6, null,
        React__namespace.createElement(ContentContainer$3, null,
            React__namespace.createElement(Spacing.Flex, { flexDir: "column", align: "center" },
                React__namespace.createElement(IconContainer$2, null, icon),
                React__namespace.createElement(Spacing.Spacing, { vertical: 1 },
                    React__namespace.createElement(CardHeader, { header: React__namespace.createElement(Hyperlink.Text, { type: "heading_small_bold", useCompact: true },
                            React__namespace.createElement("span", null, heading)) })),
                React__namespace.createElement(Hyperlink.Text, { type: "body", color: styles.themeColors.gray[50], align: "center", useCompact: true },
                    React__namespace.createElement("span", null, body))),
            children)));
};
var templateObject_1$1v, templateObject_2$1a;

var CopyTextField = function (props) {
    var _a;
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement("label", { htmlFor: props.id, className: props.className },
            props.label && (React__namespace.createElement(React__namespace.Fragment, null,
                React__namespace.createElement(Hyperlink.Text, { display: "inline", type: "body_small", color: (_a = props.labelColor) !== null && _a !== void 0 ? _a : styles.themeColors.gray[5] },
                    React__namespace.createElement("span", null, props.label),
                    " ",
                    React__namespace.createElement("br", null)))),
            React__namespace.createElement(Spacing.Flex, { align: Spacing.FlexAlign.CENTER },
                React__namespace.createElement(InputView$2, { disabled: true, id: props.id, value: props.value }),
                props.button))));
};
var InputView$2 = styled__default.default.input.withConfig({ displayName: "InputView", componentId: "-1xpb5q4" })(templateObject_1$1u || (templateObject_1$1u = _tslib.__makeTemplateObject(["\n  display: flex;\n  flex-basis: 100%;\n  padding: 8px 16px;\n  height: 32px;\n  font-size: 12px;\n  border-radius: 8px;\n  box-sizing: border-box;\n\n  &,\n  &:disabled {\n    border: 1px solid ", ";\n    background: ", ";\n    color: ", ";\n  }\n\n  &:focus {\n    border: 1px solid ", ";\n  }\n\n  &:hover {\n    border: 1px solid ", ";\n  }\n"], ["\n  display: flex;\n  flex-basis: 100%;\n  padding: 8px 16px;\n  height: 32px;\n  font-size: 12px;\n  border-radius: 8px;\n  box-sizing: border-box;\n\n  &,\n  &:disabled {\n    border: 1px solid ", ";\n    background: ", ";\n    color: ", ";\n  }\n\n  &:focus {\n    border: 1px solid ", ";\n  }\n\n  &:hover {\n    border: 1px solid ", ";\n  }\n"])), styles.themeColors.gray[30], styles.themeColors.gray[5], styles.themeColors.gray[90], styles.themeColors.blue[50], styles.themeColors.gray[40]);
var templateObject_1$1u;

var InfoBlock = function (props) { return (React__namespace.createElement(WrapperView$5, null,
    React__namespace.createElement(IconView$2, null, props.icon),
    React__namespace.createElement(Spacing.Spacing, { left: 2 }),
    React__namespace.createElement(Hyperlink.Text, { type: Hyperlink.TextType.HEADING_MEDIUM, useCompact: true },
        React__namespace.createElement("h3", null, props.children)))); };
var IconView$2 = styled__default.default.div.withConfig({ displayName: "IconView", componentId: "-1ytlkjn" })(templateObject_1$1t || (templateObject_1$1t = _tslib.__makeTemplateObject(["\n  width: 96px;\n  height: 96px;\n\n  svg,\n  img {\n    width: 100%;\n    height: 100%;\n  }\n\n  @media ", ", ", " {\n    width: 64px;\n    height: 64px;\n  }\n"], ["\n  width: 96px;\n  height: 96px;\n\n  svg,\n  img {\n    width: 100%;\n    height: 100%;\n  }\n\n  @media ", ", ", " {\n    width: 64px;\n    height: 64px;\n  }\n"])), ResponsiveSizes.media[ResponsiveSizes.BreakpointType.DESKTOP], ResponsiveSizes.media[ResponsiveSizes.BreakpointType.MOBILE]);
var WrapperView$5 = styled__default.default(Spacing.Flex).withConfig({ displayName: "WrapperView", componentId: "-6wseni" })(templateObject_2$19 || (templateObject_2$19 = _tslib.__makeTemplateObject(["\n  width: 100%;\n  padding: 32px;\n  background-color: transparent;\n  border-radius: 16px;\n  border: 1px solid ", ";\n  align-items: center;\n\n  @media ", ", ", " {\n    padding: 24px;\n  }\n"], ["\n  width: 100%;\n  padding: 32px;\n  background-color: transparent;\n  border-radius: 16px;\n  border: 1px solid ", ";\n  align-items: center;\n\n  @media ", ", ", " {\n    padding: 24px;\n  }\n"])), styles.themeColors.gray['30'], ResponsiveSizes.media[ResponsiveSizes.BreakpointType.DESKTOP], ResponsiveSizes.media[ResponsiveSizes.BreakpointType.MOBILE]);
var templateObject_1$1t, templateObject_2$19;

var InputField = function (props) { return (React__namespace.createElement("label", { htmlFor: props.id, className: props.className },
    props.label && (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement(LabelView, null, props.label),
        " ",
        React__namespace.createElement("br", null))),
    React__namespace.createElement(InputView$1, { id: props.id, fullWidth: props.fullWidth, onChange: props.onChange, error: props.error, maxLength: props.maxLength, placeholder: props.placeholder }),
    props.error && (React__namespace.createElement(Hyperlink.Text, { type: Hyperlink.TextType.SUBTITLE, color: styles.themeColors.red['50'], align: props.errorAlign },
        React__namespace.createElement("small", null, props.error))))); };
var LabelView = styled__default.default.span.withConfig({ displayName: "LabelView", componentId: "-hzjynu" })(templateObject_1$1s || (templateObject_1$1s = _tslib.__makeTemplateObject(["\n  font-weight: ", ";\n  font-size: 16px;\n  line-height: 32px;\n  color: ", ";\n"], ["\n  font-weight: ", ";\n  font-size: 16px;\n  line-height: 32px;\n  color: ", ";\n"])), styles.FONT_WEIGHT.REGULAR, styles.themeColors.gray['90']);
var InputView$1 = styled__default.default.input.withConfig({ displayName: "InputView", componentId: "-1bs22ky" })(templateObject_2$18 || (templateObject_2$18 = _tslib.__makeTemplateObject(["\n  padding: 12px 16px;\n  outline: 0;\n  max-width: ", ";\n  width: ", ";\n  height: 24px;\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: 8px;\n\n  &:focus {\n    border: 1px solid ", ";\n  }\n\n  &:hover {\n    border: 1px solid ", ";\n  }\n"], ["\n  padding: 12px 16px;\n  outline: 0;\n  max-width: ", ";\n  width: ", ";\n  height: 24px;\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: 8px;\n\n  &:focus {\n    border: 1px solid ", ";\n  }\n\n  &:hover {\n    border: 1px solid ", ";\n  }\n"])), function (props) { return (props.fullWidth ? undefined : '256px'); }, function (props) { return (props.fullWidth ? 'calc(100% - 32px)' : '100%'); }, styles.themeColors.gray['5'], function (props) { return (props.error ? styles.themeColors.red['50'] : styles.themeColors.gray['30']); }, styles.themeColors.blue['50'], styles.themeColors.gray['40']);
var templateObject_1$1s, templateObject_2$18;

var InputFieldWithButton = function (props) { return (React__namespace.createElement(Wrapper$2, null,
    React__namespace.createElement(IconView$1, null,
        React__namespace.createElement(AchievementStar.MailIcon, null)),
    React__namespace.createElement(InputView, { id: props.id, onChange: props.onChange, error: props.error, maxLength: props.maxLength }),
    props.error && (React__namespace.createElement(Hyperlink.Text, { type: Hyperlink.TextType.SUBTITLE, color: styles.themeColors.red['50'] },
        React__namespace.createElement("small", null, props.error))),
    React__namespace.createElement(ButtonView$1, { type: "primary" }, "OKs"))); };
var IconView$1 = styled__default.default.div.withConfig({ displayName: "IconView", componentId: "-29ucxp" })(templateObject_1$1r || (templateObject_1$1r = _tslib.__makeTemplateObject(["\n  position: absolute;\n  left: 28px;\n  transform: translateY(-50%);\n  top: 50%;\n"], ["\n  position: absolute;\n  left: 28px;\n  transform: translateY(-50%);\n  top: 50%;\n"])));
var ButtonView$1 = styled__default.default(Button$3).withConfig({ displayName: "ButtonView", componentId: "-1h6lnbo" })(templateObject_2$17 || (templateObject_2$17 = _tslib.__makeTemplateObject(["\n  position: absolute;\n  width: 148px;\n  height: 48px;\n  right: 8px;\n  top: 8px;\n"], ["\n  position: absolute;\n  width: 148px;\n  height: 48px;\n  right: 8px;\n  top: 8px;\n"])));
var Wrapper$2 = styled__default.default.div.withConfig({ displayName: "Wrapper", componentId: "-1bouqfg" })(templateObject_3$N || (templateObject_3$N = _tslib.__makeTemplateObject(["\n  position: relative;\n  max-width: 552px;\n"], ["\n  position: relative;\n  max-width: 552px;\n"])));
var InputView = styled__default.default.input.withConfig({ displayName: "InputView", componentId: "-ztc84n" })(templateObject_4$x || (templateObject_4$x = _tslib.__makeTemplateObject(["\n  padding: 20px 16px;\n  padding-right: 164px;\n  outline: 0;\n  width: calc(100% - 180px);\n  height: 24px;\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: 8px;\n\n  &:focus {\n    border: 1px solid ", ";\n  }\n\n  &:hover {\n    border: 1px solid ", ";\n  }\n"], ["\n  padding: 20px 16px;\n  padding-right: 164px;\n  outline: 0;\n  width: calc(100% - 180px);\n  height: 24px;\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: 8px;\n\n  &:focus {\n    border: 1px solid ", ";\n  }\n\n  &:hover {\n    border: 1px solid ", ";\n  }\n"])), styles.themeColors.gray['5'], function (props) { return (props.error ? styles.themeColors.red['50'] : styles.themeColors.gray['30']); }, styles.themeColors.blue['50'], styles.themeColors.gray['40']);
var templateObject_1$1r, templateObject_2$17, templateObject_3$N, templateObject_4$x;

/**
 * @public
 */
const MotionConfigContext = React.createContext({
    transformPagePoint: (p) => p,
    isStatic: false,
    reducedMotion: "never",
});

const MotionContext = React.createContext({});

/**
 * @public
 */
const PresenceContext = React.createContext(null);

const isBrowser = typeof document !== "undefined";

const useIsomorphicLayoutEffect$1 = isBrowser ? React.useLayoutEffect : React.useEffect;

const LazyContext = React.createContext({ strict: false });

function useVisualElement(Component, visualState, props, createVisualElement) {
    const { visualElement: parent } = React.useContext(MotionContext);
    const lazyContext = React.useContext(LazyContext);
    const presenceContext = React.useContext(PresenceContext);
    const reducedMotionConfig = React.useContext(MotionConfigContext).reducedMotion;
    const visualElementRef = React.useRef();
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */
    createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) {
        visualElementRef.current = createVisualElement(Component, {
            visualState,
            parent,
            props,
            presenceContext,
            blockInitialAnimation: presenceContext
                ? presenceContext.initial === false
                : false,
            reducedMotionConfig,
        });
    }
    const visualElement = visualElementRef.current;
    React.useInsertionEffect(() => {
        visualElement && visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */
    const canHandoff = React.useRef(Boolean(window.HandoffAppearAnimations));
    useIsomorphicLayoutEffect$1(() => {
        if (!visualElement)
            return;
        visualElement.render();
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */
        if (canHandoff.current && visualElement.animationState) {
            visualElement.animationState.animateChanges();
        }
    });
    React.useEffect(() => {
        if (!visualElement)
            return;
        visualElement.updateFeatures();
        if (!canHandoff.current && visualElement.animationState) {
            visualElement.animationState.animateChanges();
        }
        /**
         * Once we've handed off animations we can delete HandoffAppearAnimations
         * so components added after the initial render can animate changes
         * in useEffect vs useLayoutEffect.
         */
        window.HandoffAppearAnimations = undefined;
        canHandoff.current = false;
    });
    return visualElement;
}

function isRefObject(ref) {
    return (typeof ref === "object" &&
        Object.prototype.hasOwnProperty.call(ref, "current"));
}

/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */
function useMotionRef(visualState, visualElement, externalRef) {
    return React.useCallback((instance) => {
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) {
            instance
                ? visualElement.mount(instance)
                : visualElement.unmount();
        }
        if (externalRef) {
            if (typeof externalRef === "function") {
                externalRef(instance);
            }
            else if (isRefObject(externalRef)) {
                externalRef.current = instance;
            }
        }
    }, 
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [visualElement]);
}

/**
 * Decides if the supplied variable is variant label
 */
function isVariantLabel(v) {
    return typeof v === "string" || Array.isArray(v);
}

function isAnimationControls(v) {
    return typeof v === "object" && typeof v.start === "function";
}

const variantPriorityOrder = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit",
];
const variantProps = ["initial", ...variantPriorityOrder];

function isControllingVariants(props) {
    return (isAnimationControls(props.animate) ||
        variantProps.some((name) => isVariantLabel(props[name])));
}
function isVariantNode(props) {
    return Boolean(isControllingVariants(props) || props.variants);
}

function getCurrentTreeVariants(props, context) {
    if (isControllingVariants(props)) {
        const { initial, animate } = props;
        return {
            initial: initial === false || isVariantLabel(initial)
                ? initial
                : undefined,
            animate: isVariantLabel(animate) ? animate : undefined,
        };
    }
    return props.inherit !== false ? context : {};
}

function useCreateMotionContext(props) {
    const { initial, animate } = getCurrentTreeVariants(props, React.useContext(MotionContext));
    return React.useMemo(() => ({ initial, animate }), [variantLabelsAsDependency(initial), variantLabelsAsDependency(animate)]);
}
function variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}

const featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag",
    ],
    exit: ["exit"],
    drag: ["drag", "dragControls"],
    focus: ["whileFocus"],
    hover: ["whileHover", "onHoverStart", "onHoverEnd"],
    tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
    pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
    inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
    layout: ["layout", "layoutId"],
};
const featureDefinitions = {};
for (const key in featureProps) {
    featureDefinitions[key] = {
        isEnabled: (props) => featureProps[key].some((name) => !!props[name]),
    };
}

function loadFeatures(features) {
    for (const key in features) {
        featureDefinitions[key] = {
            ...featureDefinitions[key],
            ...features[key],
        };
    }
}

const LayoutGroupContext = React.createContext({});

/**
 * Internal, exported only for usage in Framer
 */
const SwitchLayoutGroupContext = React.createContext({});

const motionComponentSymbol = Symbol.for("motionComponentSymbol");

/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */
function createMotionComponent({ preloadedFeatures, createVisualElement, useRender, useVisualState, Component, }) {
    preloadedFeatures && loadFeatures(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */
        let MeasureLayout;
        const configAndProps = {
            ...React.useContext(MotionConfigContext),
            ...props,
            layoutId: useLayoutId(props),
        };
        const { isStatic } = configAndProps;
        const context = useCreateMotionContext(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && isBrowser) {
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */
            context.visualElement = useVisualElement(Component, visualState, configAndProps, createVisualElement);
            /**
             * Load Motion gesture and animation features. These are rendered as renderless
             * components so each feature can optionally make use of React lifecycle methods.
             */
            const initialLayoutGroupConfig = React.useContext(SwitchLayoutGroupContext);
            const isStrict = React.useContext(LazyContext).strict;
            if (context.visualElement) {
                MeasureLayout = context.visualElement.loadFeatures(
                // Note: Pass the full new combined props to correctly re-render dynamic feature components.
                configAndProps, isStrict, preloadedFeatures, initialLayoutGroupConfig);
            }
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */
        return (React__namespace.createElement(MotionContext.Provider, { value: context },
            MeasureLayout && context.visualElement ? (React__namespace.createElement(MeasureLayout, { visualElement: context.visualElement, ...configAndProps })) : null,
            useRender(Component, props, useMotionRef(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement)));
    }
    const ForwardRefComponent = React.forwardRef(MotionComponent);
    ForwardRefComponent[motionComponentSymbol] = Component;
    return ForwardRefComponent;
}
function useLayoutId({ layoutId }) {
    const layoutGroupId = React.useContext(LayoutGroupContext).id;
    return layoutGroupId && layoutId !== undefined
        ? layoutGroupId + "-" + layoutId
        : layoutId;
}

/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */
function createMotionProxy(createConfig) {
    function custom(Component, customMotionComponentConfig = {}) {
        return createMotionComponent(createConfig(Component, customMotionComponentConfig));
    }
    if (typeof Proxy === "undefined") {
        return custom;
    }
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */
    const componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */
        get: (_target, key) => {
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */
            if (!componentCache.has(key)) {
                componentCache.set(key, custom(key));
            }
            return componentCache.get(key);
        },
    });
}

/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */
const lowercaseSVGElements = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view",
];

function isSVGComponent(Component) {
    if (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof Component !== "string" ||
        /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */
        Component.includes("-")) {
        return false;
    }
    else if (
    /**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */
    lowercaseSVGElements.indexOf(Component) > -1 ||
        /**
         * If it contains a capital letter, it's an SVG component
         */
        /[A-Z]/.test(Component)) {
        return true;
    }
    return false;
}

const scaleCorrectors = {};
function addScaleCorrector(correctors) {
    Object.assign(scaleCorrectors, correctors);
}

/**
 * Generate a list of every possible transform key.
 */
const transformPropOrder = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY",
];
/**
 * A quick lookup for transform props.
 */
const transformProps = new Set(transformPropOrder);

function isForcedMotionValue(key, { layout, layoutId }) {
    return (transformProps.has(key) ||
        key.startsWith("origin") ||
        ((layout || layoutId !== undefined) &&
            (!!scaleCorrectors[key] || key === "opacity")));
}

const isMotionValue = (value) => Boolean(value && value.getVelocity);

const translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective",
};
const numTransforms = transformPropOrder.length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */
function buildTransform(transform, { enableHardwareAcceleration = true, allowTransformNone = true, }, transformIsDefault, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */
    for (let i = 0; i < numTransforms; i++) {
        const key = transformPropOrder[i];
        if (transform[key] !== undefined) {
            const transformName = translateAlias[key] || key;
            transformString += `${transformName}(${transform[key]}) `;
        }
    }
    if (enableHardwareAcceleration && !transform.z) {
        transformString += "translateZ(0)";
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) {
        transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    }
    else if (allowTransformNone && transformIsDefault) {
        transformString = "none";
    }
    return transformString;
}

const checkStringStartsWith = (token) => (key) => typeof key === "string" && key.startsWith(token);
const isCSSVariableName = checkStringStartsWith("--");
const isCSSVariableToken = checkStringStartsWith("var(--");
const cssVariableRegex = /var\s*\(\s*--[\w-]+(\s*,\s*(?:(?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)+)?\s*\)/g;

/**
 * Provided a value and a ValueType, returns the value as that value type.
 */
const getValueAsType = (value, type) => {
    return type && typeof value === "number"
        ? type.transform(value)
        : value;
};

const clamp = (min, max, v) => Math.min(Math.max(v, min), max);

const number = {
    test: (v) => typeof v === "number",
    parse: parseFloat,
    transform: (v) => v,
};
const alpha = {
    ...number,
    transform: (v) => clamp(0, 1, v),
};
const scale = {
    ...number,
    default: 1,
};

/**
 * TODO: When we move from string as a source of truth to data models
 * everything in this folder should probably be referred to as models vs types
 */
// If this number is a decimal, make it just five decimal places
// to avoid exponents
const sanitize = (v) => Math.round(v * 100000) / 100000;
const floatRegex = /(-)?([\d]*\.?[\d])+/g;
const colorRegex = /(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi;
const singleColorRegex = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function isString(v) {
    return typeof v === "string";
}

const createUnitType = (unit) => ({
    test: (v) => isString(v) && v.endsWith(unit) && v.split(" ").length === 1,
    parse: parseFloat,
    transform: (v) => `${v}${unit}`,
});
const degrees = createUnitType("deg");
const percent = createUnitType("%");
const px = createUnitType("px");
const vh = createUnitType("vh");
const vw = createUnitType("vw");
const progressPercentage = {
    ...percent,
    parse: (v) => percent.parse(v) / 100,
    transform: (v) => percent.transform(v * 100),
};

const int = {
    ...number,
    transform: Math.round,
};

const numberValueTypes = {
    // Border props
    borderWidth: px,
    borderTopWidth: px,
    borderRightWidth: px,
    borderBottomWidth: px,
    borderLeftWidth: px,
    borderRadius: px,
    radius: px,
    borderTopLeftRadius: px,
    borderTopRightRadius: px,
    borderBottomRightRadius: px,
    borderBottomLeftRadius: px,
    // Positioning props
    width: px,
    maxWidth: px,
    height: px,
    maxHeight: px,
    size: px,
    top: px,
    right: px,
    bottom: px,
    left: px,
    // Spacing props
    padding: px,
    paddingTop: px,
    paddingRight: px,
    paddingBottom: px,
    paddingLeft: px,
    margin: px,
    marginTop: px,
    marginRight: px,
    marginBottom: px,
    marginLeft: px,
    // Transform props
    rotate: degrees,
    rotateX: degrees,
    rotateY: degrees,
    rotateZ: degrees,
    scale,
    scaleX: scale,
    scaleY: scale,
    scaleZ: scale,
    skew: degrees,
    skewX: degrees,
    skewY: degrees,
    distance: px,
    translateX: px,
    translateY: px,
    translateZ: px,
    x: px,
    y: px,
    z: px,
    perspective: px,
    transformPerspective: px,
    opacity: alpha,
    originX: progressPercentage,
    originY: progressPercentage,
    originZ: px,
    // Misc
    zIndex: int,
    // SVG
    fillOpacity: alpha,
    strokeOpacity: alpha,
    numOctaves: int,
};

function buildHTMLStyles(state, latestValues, options, transformTemplate) {
    const { style, vars, transform, transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    let transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */
    for (const key in latestValues) {
        const value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */
        if (isCSSVariableName(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        const valueType = numberValueTypes[key];
        const valueAsType = getValueAsType(value, valueType);
        if (transformProps.has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            // If we already know we have a non-default transform, early return
            if (!transformIsNone)
                continue;
            // Otherwise check to see if this is a default transform
            if (value !== (valueType.default || 0))
                transformIsNone = false;
        }
        else if (key.startsWith("origin")) {
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
            transformOrigin[key] = valueAsType;
        }
        else {
            style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) {
            style.transform = buildTransform(state.transform, options, transformIsNone, transformTemplate);
        }
        else if (style.transform) {
            /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */
            style.transform = "none";
        }
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */
    if (hasTransformOrigin) {
        const { originX = "50%", originY = "50%", originZ = 0, } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}

const createHtmlRenderState = () => ({
    style: {},
    transform: {},
    transformOrigin: {},
    vars: {},
});

function copyRawValuesOnly(target, source, props) {
    for (const key in source) {
        if (!isMotionValue(source[key]) && !isForcedMotionValue(key, props)) {
            target[key] = source[key];
        }
    }
}
function useInitialMotionValues({ transformTemplate }, visualState, isStatic) {
    return React.useMemo(() => {
        const state = createHtmlRenderState();
        buildHTMLStyles(state, visualState, { enableHardwareAcceleration: !isStatic }, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [visualState]);
}
function useStyle(props, visualState, isStatic) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */
    copyRawValuesOnly(style, styleProp, props);
    Object.assign(style, useInitialMotionValues(props, visualState, isStatic));
    return props.transformValues ? props.transformValues(style) : style;
}
function useHTMLProps(props, visualState, isStatic) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = useStyle(props, visualState, isStatic);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect =
            style.WebkitUserSelect =
                style.WebkitTouchCallout =
                    "none";
        // Disable scrolling on the draggable direction
        style.touchAction =
            props.drag === true
                ? "none"
                : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined &&
        (props.onTap || props.onTapStart || props.whileTap)) {
        htmlProps.tabIndex = 0;
    }
    htmlProps.style = style;
    return htmlProps;
}

/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */
const validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "transformValues",
    "custom",
    "inherit",
    "onLayoutAnimationStart",
    "onLayoutAnimationComplete",
    "onLayoutMeasure",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "ignoreStrict",
    "viewport",
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */
function isValidMotionProp(key) {
    return (key.startsWith("while") ||
        (key.startsWith("drag") && key !== "draggable") ||
        key.startsWith("layout") ||
        key.startsWith("onTap") ||
        key.startsWith("onPan") ||
        validMotionProps.has(key));
}

let shouldForward = (key) => !isValidMotionProp(key);
function loadExternalIsValidProp(isValidProp) {
    if (!isValidProp)
        return;
    // Explicitly filter our events
    shouldForward = (key) => key.startsWith("on") ? !isValidMotionProp(key) : isValidProp(key);
}
/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */
try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */
    loadExternalIsValidProp(require("@emotion/is-prop-valid").default);
}
catch (_a) {
    // We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function filterProps(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for (const key in props) {
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */
        if (key === "values" && typeof props.values === "object")
            continue;
        if (shouldForward(key) ||
            (forwardMotionProps === true && isValidMotionProp(key)) ||
            (!isDom && !isValidMotionProp(key)) ||
            // If trying to use native HTML drag events, forward drag listeners
            (props["draggable"] && key.startsWith("onDrag"))) {
            filteredProps[key] = props[key];
        }
    }
    return filteredProps;
}

function calcOrigin$1(origin, offset, size) {
    return typeof origin === "string"
        ? origin
        : px.transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */
function calcSVGTransformOrigin(dimensions, originX, originY) {
    const pxOriginX = calcOrigin$1(originX, dimensions.x, dimensions.width);
    const pxOriginY = calcOrigin$1(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}

const dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray",
};
const camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray",
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */
function buildSVGPath(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? dashKeys : camelKeys;
    // Build the dash offset
    attrs[keys.offset] = px.transform(-offset);
    // Build the dash array
    const pathLength = px.transform(length);
    const pathSpacing = px.transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}

/**
 * Build SVG visual attrbutes, like cx and style.transform
 */
function buildSVGAttrs(state, { attrX, attrY, attrScale, originX, originY, pathLength, pathSpacing = 1, pathOffset = 0, 
// This is object creation, which we try to avoid per-frame.
...latest }, options, isSVGTag, transformTemplate) {
    buildHTMLStyles(state, latest, options, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */
    if (isSVGTag) {
        if (state.style.viewBox) {
            state.attrs.viewBox = state.style.viewBox;
        }
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs, style, dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */
    if (attrs.transform) {
        if (dimensions)
            style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions &&
        (originX !== undefined || originY !== undefined || style.transform)) {
        style.transformOrigin = calcSVGTransformOrigin(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    }
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined)
        attrs.x = attrX;
    if (attrY !== undefined)
        attrs.y = attrY;
    if (attrScale !== undefined)
        attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) {
        buildSVGPath(attrs, pathLength, pathSpacing, pathOffset, false);
    }
}

const createSvgRenderState = () => ({
    ...createHtmlRenderState(),
    attrs: {},
});

const isSVGTag = (tag) => typeof tag === "string" && tag.toLowerCase() === "svg";

function useSVGProps(props, visualState, _isStatic, Component) {
    const visualProps = React.useMemo(() => {
        const state = createSvgRenderState();
        buildSVGAttrs(state, visualState, { enableHardwareAcceleration: false }, isSVGTag(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: { ...state.style },
        };
    }, [visualState]);
    if (props.style) {
        const rawStyles = {};
        copyRawValuesOnly(rawStyles, props.style, props);
        visualProps.style = { ...rawStyles, ...visualProps.style };
    }
    return visualProps;
}

function createUseRender(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues }, isStatic) => {
        const useVisualProps = isSVGComponent(Component)
            ? useSVGProps
            : useHTMLProps;
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = filterProps(props, typeof Component === "string", forwardMotionProps);
        const elementProps = {
            ...filteredProps,
            ...visualProps,
            ref,
        };
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */
        const { children } = props;
        const renderedChildren = React.useMemo(() => (isMotionValue(children) ? children.get() : children), [children]);
        return React.createElement(Component, {
            ...elementProps,
            children: renderedChildren,
        });
    };
    return useRender;
}

/**
 * Convert camelCase to dash-case properties.
 */
const camelToDash = (str) => str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();

function renderHTML(element, { style, vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for (const key in vars) {
        element.style.setProperty(key, vars[key]);
    }
}

/**
 * A set of attribute names that are always read/written as camel case.
 */
const camelCaseAttributes = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust",
]);

function renderSVG(element, renderState, _styleProp, projection) {
    renderHTML(element, renderState, undefined, projection);
    for (const key in renderState.attrs) {
        element.setAttribute(!camelCaseAttributes.has(key) ? camelToDash(key) : key, renderState.attrs[key]);
    }
}

function scrapeMotionValuesFromProps$1(props, prevProps) {
    const { style } = props;
    const newValues = {};
    for (const key in style) {
        if (isMotionValue(style[key]) ||
            (prevProps.style && isMotionValue(prevProps.style[key])) ||
            isForcedMotionValue(key, props)) {
            newValues[key] = style[key];
        }
    }
    return newValues;
}

function scrapeMotionValuesFromProps(props, prevProps) {
    const newValues = scrapeMotionValuesFromProps$1(props, prevProps);
    for (const key in props) {
        if (isMotionValue(props[key]) || isMotionValue(prevProps[key])) {
            const targetKey = transformPropOrder.indexOf(key) !== -1
                ? "attr" + key.charAt(0).toUpperCase() + key.substring(1)
                : key;
            newValues[targetKey] = props[key];
        }
    }
    return newValues;
}

function resolveVariantFromProps(props, definition, custom, currentValues = {}, currentVelocity = {}) {
    /**
     * If the variant definition is a function, resolve.
     */
    if (typeof definition === "function") {
        definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */
    if (typeof definition === "string") {
        definition = props.variants && props.variants[definition];
    }
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */
    if (typeof definition === "function") {
        definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    }
    return definition;
}

/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */
function useConstant(init) {
    const ref = React.useRef(null);
    if (ref.current === null) {
        ref.current = init();
    }
    return ref.current;
}

const isKeyframesTarget = (v) => {
    return Array.isArray(v);
};

const isCustomValue = (v) => {
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const resolveFinalValueInKeyframes = (v) => {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return isKeyframesTarget(v) ? v[v.length - 1] || 0 : v;
};

/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */
function resolveMotionValue(value) {
    const unwrappedValue = isMotionValue(value) ? value.get() : value;
    return isCustomValue(unwrappedValue)
        ? unwrappedValue.toValue()
        : unwrappedValue;
}

function makeState({ scrapeMotionValuesFromProps, createRenderState, onMount, }, props, context, presenceContext) {
    const state = {
        latestValues: makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState(),
    };
    if (onMount) {
        state.mount = (instance) => onMount(props, instance, state);
    }
    return state;
}
const makeUseVisualState = (config) => (props, isStatic) => {
    const context = React.useContext(MotionContext);
    const presenceContext = React.useContext(PresenceContext);
    const make = () => makeState(config, props, context, presenceContext);
    return isStatic ? make() : useConstant(make);
};
function makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for (const key in motionValues) {
        values[key] = resolveMotionValue(motionValues[key]);
    }
    let { initial, animate } = props;
    const isControllingVariants$1 = isControllingVariants(props);
    const isVariantNode$1 = isVariantNode(props);
    if (context &&
        isVariantNode$1 &&
        !isControllingVariants$1 &&
        props.inherit !== false) {
        if (initial === undefined)
            initial = context.initial;
        if (animate === undefined)
            animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext
        ? presenceContext.initial === false
        : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet &&
        typeof variantToSet !== "boolean" &&
        !isAnimationControls(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [variantToSet];
        list.forEach((definition) => {
            const resolved = resolveVariantFromProps(props, definition);
            if (!resolved)
                return;
            const { transitionEnd, transition, ...target } = resolved;
            for (const key in target) {
                let valueTarget = target[key];
                if (Array.isArray(valueTarget)) {
                    /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */
                    const index = isInitialAnimationBlocked
                        ? valueTarget.length - 1
                        : 0;
                    valueTarget = valueTarget[index];
                }
                if (valueTarget !== null) {
                    values[key] = valueTarget;
                }
            }
            for (const key in transitionEnd)
                values[key] = transitionEnd[key];
        });
    }
    return values;
}

const noop = (any) => any;

class Queue {
    constructor() {
        this.order = [];
        this.scheduled = new Set();
    }
    add(process) {
        if (!this.scheduled.has(process)) {
            this.scheduled.add(process);
            this.order.push(process);
            return true;
        }
    }
    remove(process) {
        const index = this.order.indexOf(process);
        if (index !== -1) {
            this.order.splice(index, 1);
            this.scheduled.delete(process);
        }
    }
    clear() {
        this.order.length = 0;
        this.scheduled.clear();
    }
}
function createRenderStep(runNextFrame) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */
    let thisFrame = new Queue();
    let nextFrame = new Queue();
    let numToRun = 0;
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */
    let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */
    const toKeepAlive = new WeakSet();
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */
        schedule: (callback, keepAlive = false, immediate = false) => {
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive)
                toKeepAlive.add(callback);
            if (queue.add(callback) && addToCurrentFrame && isProcessing) {
                // If we're adding it to the currently running queue, update its measured size
                numToRun = thisFrame.order.length;
            }
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */
        cancel: (callback) => {
            nextFrame.remove(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */
        process: (frameData) => {
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */
            if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [nextFrame, thisFrame];
            // Clear the next frame queue
            nextFrame.clear();
            // Execute this frame
            numToRun = thisFrame.order.length;
            if (numToRun) {
                for (let i = 0; i < numToRun; i++) {
                    const callback = thisFrame.order[i];
                    callback(frameData);
                    if (toKeepAlive.has(callback)) {
                        step.schedule(callback);
                        runNextFrame();
                    }
                }
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        },
    };
    return step;
}

const stepsOrder = [
    "prepare",
    "read",
    "update",
    "preRender",
    "render",
    "postRender",
];
const maxElapsed = 40;
function createRenderBatcher(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0,
        timestamp: 0,
        isProcessing: false,
    };
    const steps = stepsOrder.reduce((acc, key) => {
        acc[key] = createRenderStep(() => (runNextFrame = true));
        return acc;
    }, {});
    const processStep = (stepId) => steps[stepId].process(state);
    const processBatch = () => {
        const timestamp = performance.now();
        runNextFrame = false;
        state.delta = useDefaultElapsed
            ? 1000 / 60
            : Math.max(Math.min(timestamp - state.timestamp, maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        stepsOrder.forEach(processStep);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = () => {
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) {
            scheduleNextBatch(processBatch);
        }
    };
    const schedule = stepsOrder.reduce((acc, key) => {
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false) => {
            if (!runNextFrame)
                wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process) => stepsOrder.forEach((key) => steps[key].cancel(process));
    return { schedule, cancel, state, steps };
}

const { schedule: frame, cancel: cancelFrame, state: frameData, steps, } = createRenderBatcher(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : noop, true);

const svgMotionConfig = {
    useVisualState: makeUseVisualState({
        scrapeMotionValuesFromProps: scrapeMotionValuesFromProps,
        createRenderState: createSvgRenderState,
        onMount: (props, instance, { renderState, latestValues }) => {
            frame.read(() => {
                try {
                    renderState.dimensions =
                        typeof instance.getBBox ===
                            "function"
                            ? instance.getBBox()
                            : instance.getBoundingClientRect();
                }
                catch (e) {
                    // Most likely trying to measure an unrendered element under Firefox
                    renderState.dimensions = {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0,
                    };
                }
            });
            frame.render(() => {
                buildSVGAttrs(renderState, latestValues, { enableHardwareAcceleration: false }, isSVGTag(instance.tagName), props.transformTemplate);
                renderSVG(instance, renderState);
            });
        },
    }),
};

const htmlMotionConfig = {
    useVisualState: makeUseVisualState({
        scrapeMotionValuesFromProps: scrapeMotionValuesFromProps$1,
        createRenderState: createHtmlRenderState,
    }),
};

function createDomMotionConfig(Component, { forwardMotionProps = false }, preloadedFeatures, createVisualElement) {
    const baseConfig = isSVGComponent(Component)
        ? svgMotionConfig
        : htmlMotionConfig;
    return {
        ...baseConfig,
        preloadedFeatures,
        useRender: createUseRender(forwardMotionProps),
        createVisualElement,
        Component,
    };
}

function addDomEvent(target, eventName, handler, options = { passive: true }) {
    target.addEventListener(eventName, handler, options);
    return () => target.removeEventListener(eventName, handler);
}

const isPrimaryPointer = (event) => {
    if (event.pointerType === "mouse") {
        return typeof event.button !== "number" || event.button <= 0;
    }
    else {
        /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */
        return event.isPrimary !== false;
    }
};

function extractEventInfo(event, pointType = "page") {
    return {
        point: {
            x: event[pointType + "X"],
            y: event[pointType + "Y"],
        },
    };
}
const addPointerInfo = (handler) => {
    return (event) => isPrimaryPointer(event) && handler(event, extractEventInfo(event));
};

function addPointerEvent(target, eventName, handler, options) {
    return addDomEvent(target, eventName, addPointerInfo(handler), options);
}

/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */
const combineFunctions = (a, b) => (v) => b(a(v));
const pipe = (...transformers) => transformers.reduce(combineFunctions);

function createLock(name) {
    let lock = null;
    return () => {
        const openLock = () => {
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
const globalHorizontalLock = createLock("dragHorizontal");
const globalVerticalLock = createLock("dragVertical");
function getGlobalLock(drag) {
    let lock = false;
    if (drag === "y") {
        lock = globalVerticalLock();
    }
    else if (drag === "x") {
        lock = globalHorizontalLock();
    }
    else {
        const openHorizontal = globalHorizontalLock();
        const openVertical = globalVerticalLock();
        if (openHorizontal && openVertical) {
            lock = () => {
                openHorizontal();
                openVertical();
            };
        }
        else {
            // Release the locks because we don't use them
            if (openHorizontal)
                openHorizontal();
            if (openVertical)
                openVertical();
        }
    }
    return lock;
}
function isDragActive() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    const openGestureLock = getGlobalLock(true);
    if (!openGestureLock)
        return true;
    openGestureLock();
    return false;
}

class Feature {
    constructor(node) {
        this.isMounted = false;
        this.node = node;
    }
    update() { }
}

function addHoverEvent(node, isActive) {
    const eventName = "pointer" + (isActive ? "enter" : "leave");
    const callbackName = "onHover" + (isActive ? "Start" : "End");
    const handleEvent = (event, info) => {
        if (event.type === "touch" || isDragActive())
            return;
        const props = node.getProps();
        if (node.animationState && props.whileHover) {
            node.animationState.setActive("whileHover", isActive);
        }
        if (props[callbackName]) {
            frame.update(() => props[callbackName](event, info));
        }
    };
    return addPointerEvent(node.current, eventName, handleEvent, {
        passive: !node.getProps()[callbackName],
    });
}
class HoverGesture extends Feature {
    mount() {
        this.unmount = pipe(addHoverEvent(this.node, true), addHoverEvent(this.node, false));
    }
    unmount() { }
}

class FocusGesture extends Feature {
    constructor() {
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */
        try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        }
        catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState)
            return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState)
            return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = pipe(addDomEvent(this.node.current, "focus", () => this.onFocus()), addDomEvent(this.node.current, "blur", () => this.onBlur()));
    }
    unmount() { }
}

/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */
const isNodeOrChild = (parent, child) => {
    if (!child) {
        return false;
    }
    else if (parent === child) {
        return true;
    }
    else {
        return isNodeOrChild(parent, child.parentElement);
    }
};

function fireSyntheticPointerEvent(name, handler) {
    if (!handler)
        return;
    const syntheticPointerEvent = new PointerEvent("pointer" + name);
    handler(syntheticPointerEvent, extractEventInfo(syntheticPointerEvent));
}
class PressGesture extends Feature {
    constructor() {
        super(...arguments);
        this.removeStartListeners = noop;
        this.removeEndListeners = noop;
        this.removeAccessibleListeners = noop;
        this.startPointerPress = (startEvent, startInfo) => {
            this.removeEndListeners();
            if (this.isPressing)
                return;
            const props = this.node.getProps();
            const endPointerPress = (endEvent, endInfo) => {
                if (!this.checkPressEnd())
                    return;
                const { onTap, onTapCancel } = this.node.getProps();
                frame.update(() => {
                    /**
                     * We only count this as a tap gesture if the event.target is the same
                     * as, or a child of, this component's element
                     */
                    !isNodeOrChild(this.node.current, endEvent.target)
                        ? onTapCancel && onTapCancel(endEvent, endInfo)
                        : onTap && onTap(endEvent, endInfo);
                });
            };
            const removePointerUpListener = addPointerEvent(window, "pointerup", endPointerPress, { passive: !(props.onTap || props["onPointerUp"]) });
            const removePointerCancelListener = addPointerEvent(window, "pointercancel", (cancelEvent, cancelInfo) => this.cancelPress(cancelEvent, cancelInfo), { passive: !(props.onTapCancel || props["onPointerCancel"]) });
            this.removeEndListeners = pipe(removePointerUpListener, removePointerCancelListener);
            this.startPress(startEvent, startInfo);
        };
        this.startAccessiblePress = () => {
            const handleKeydown = (keydownEvent) => {
                if (keydownEvent.key !== "Enter" || this.isPressing)
                    return;
                const handleKeyup = (keyupEvent) => {
                    if (keyupEvent.key !== "Enter" || !this.checkPressEnd())
                        return;
                    fireSyntheticPointerEvent("up", (event, info) => {
                        const { onTap } = this.node.getProps();
                        if (onTap) {
                            frame.update(() => onTap(event, info));
                        }
                    });
                };
                this.removeEndListeners();
                this.removeEndListeners = addDomEvent(this.node.current, "keyup", handleKeyup);
                fireSyntheticPointerEvent("down", (event, info) => {
                    this.startPress(event, info);
                });
            };
            const removeKeydownListener = addDomEvent(this.node.current, "keydown", handleKeydown);
            const handleBlur = () => {
                if (!this.isPressing)
                    return;
                fireSyntheticPointerEvent("cancel", (cancelEvent, cancelInfo) => this.cancelPress(cancelEvent, cancelInfo));
            };
            const removeBlurListener = addDomEvent(this.node.current, "blur", handleBlur);
            this.removeAccessibleListeners = pipe(removeKeydownListener, removeBlurListener);
        };
    }
    startPress(event, info) {
        this.isPressing = true;
        const { onTapStart, whileTap } = this.node.getProps();
        /**
         * Ensure we trigger animations before firing event callback
         */
        if (whileTap && this.node.animationState) {
            this.node.animationState.setActive("whileTap", true);
        }
        if (onTapStart) {
            frame.update(() => onTapStart(event, info));
        }
    }
    checkPressEnd() {
        this.removeEndListeners();
        this.isPressing = false;
        const props = this.node.getProps();
        if (props.whileTap && this.node.animationState) {
            this.node.animationState.setActive("whileTap", false);
        }
        return !isDragActive();
    }
    cancelPress(event, info) {
        if (!this.checkPressEnd())
            return;
        const { onTapCancel } = this.node.getProps();
        if (onTapCancel) {
            frame.update(() => onTapCancel(event, info));
        }
    }
    mount() {
        const props = this.node.getProps();
        const removePointerListener = addPointerEvent(this.node.current, "pointerdown", this.startPointerPress, { passive: !(props.onTapStart || props["onPointerStart"]) });
        const removeFocusListener = addDomEvent(this.node.current, "focus", this.startAccessiblePress);
        this.removeStartListeners = pipe(removePointerListener, removeFocusListener);
    }
    unmount() {
        this.removeStartListeners();
        this.removeEndListeners();
        this.removeAccessibleListeners();
    }
}

/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */
const observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */
const observers = new WeakMap();
const fireObserverCallback = (entry) => {
    const callback = observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const fireAllObserverCallbacks = (entries) => {
    entries.forEach(fireObserverCallback);
};
function initIntersectionObserver({ root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */
    if (!observers.has(lookupRoot)) {
        observers.set(lookupRoot, {});
    }
    const rootObservers = observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */
    if (!rootObservers[key]) {
        rootObservers[key] = new IntersectionObserver(fireAllObserverCallbacks, { root, ...options });
    }
    return rootObservers[key];
}
function observeIntersection(element, options, callback) {
    const rootInteresectionObserver = initIntersectionObserver(options);
    observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return () => {
        observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}

const thresholdNames = {
    some: 0,
    all: 1,
};
class InViewFeature extends Feature {
    constructor() {
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport = {} } = this.node.getProps();
        const { root, margin: rootMargin, amount = "some", once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin,
            threshold: typeof amount === "number" ? amount : thresholdNames[amount],
        };
        const onIntersectionUpdate = (entry) => {
            const { isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */
            if (this.isInView === isIntersecting)
                return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */
            if (once && !isIntersecting && this.hasEnteredView) {
                return;
            }
            else if (isIntersecting) {
                this.hasEnteredView = true;
            }
            if (this.node.animationState) {
                this.node.animationState.setActive("whileInView", isIntersecting);
            }
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */
            const { onViewportEnter, onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return observeIntersection(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined")
            return;
        const { props, prevProps } = this.node;
        const hasOptionsChanged = ["amount", "margin", "root"].some(hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) {
            this.startObserver();
        }
    }
    unmount() { }
}
function hasViewportOptionChanged({ viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name) => viewport[name] !== prevViewport[name];
}

const gestureAnimations = {
    inView: {
        Feature: InViewFeature,
    },
    tap: {
        Feature: PressGesture,
    },
    focus: {
        Feature: FocusGesture,
    },
    hover: {
        Feature: HoverGesture,
    },
};

function shallowCompare(next, prev) {
    if (!Array.isArray(prev))
        return false;
    const prevLength = prev.length;
    if (prevLength !== next.length)
        return false;
    for (let i = 0; i < prevLength; i++) {
        if (prev[i] !== next[i])
            return false;
    }
    return true;
}

/**
 * Creates an object containing the latest state of every MotionValue on a VisualElement
 */
function getCurrent(visualElement) {
    const current = {};
    visualElement.values.forEach((value, key) => (current[key] = value.get()));
    return current;
}
/**
 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
 */
function getVelocity$1(visualElement) {
    const velocity = {};
    visualElement.values.forEach((value, key) => (velocity[key] = value.getVelocity()));
    return velocity;
}
function resolveVariant(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return resolveVariantFromProps(props, definition, custom !== undefined ? custom : props.custom, getCurrent(visualElement), getVelocity$1(visualElement));
}

const optimizedAppearDataId = "framerAppearId";
const optimizedAppearDataAttribute = "data-" + camelToDash(optimizedAppearDataId);

let warning = noop;
let invariant = noop;
if (process.env.NODE_ENV !== "production") {
    warning = (check, message) => {
        if (!check && typeof console !== "undefined") {
            console.warn(message);
        }
    };
    invariant = (check, message) => {
        if (!check) {
            throw new Error(message);
        }
    };
}

/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */
const secondsToMilliseconds = (seconds) => seconds * 1000;
const millisecondsToSeconds = (milliseconds) => milliseconds / 1000;

const instantAnimationState = {
    current: false,
};

const isBezierDefinition = (easing) => Array.isArray(easing) && typeof easing[0] === "number";

function isWaapiSupportedEasing(easing) {
    return Boolean(!easing ||
        (typeof easing === "string" && supportedWaapiEasing[easing]) ||
        isBezierDefinition(easing) ||
        (Array.isArray(easing) && easing.every(isWaapiSupportedEasing)));
}
const cubicBezierAsString = ([a, b, c, d]) => `cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const supportedWaapiEasing = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: cubicBezierAsString([0, 0.65, 0.55, 1]),
    circOut: cubicBezierAsString([0.55, 0, 1, 0.45]),
    backIn: cubicBezierAsString([0.31, 0.01, 0.66, -0.59]),
    backOut: cubicBezierAsString([0.33, 1.53, 0.69, 0.99]),
};
function mapEasingToNativeEasing(easing) {
    if (!easing)
        return undefined;
    return isBezierDefinition(easing)
        ? cubicBezierAsString(easing)
        : Array.isArray(easing)
            ? easing.map(mapEasingToNativeEasing)
            : supportedWaapiEasing[easing];
}

function animateStyle(element, valueName, keyframes, { delay = 0, duration, repeat = 0, repeatType = "loop", ease, times, } = {}) {
    const keyframeOptions = { [valueName]: keyframes };
    if (times)
        keyframeOptions.offset = times;
    const easing = mapEasingToNativeEasing(ease);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */
    if (Array.isArray(easing))
        keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay,
        duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal",
    });
}

function getFinalKeyframe(keyframes, { repeat, repeatType = "loop" }) {
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1
        ? 0
        : keyframes.length - 1;
    return keyframes[index];
}

/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/
// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const calcBezier = (t, a1, a2) => (((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) *
    t;
const subdivisionPrecision = 0.0000001;
const subdivisionMaxIterations = 12;
function binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) {
            upperBound = currentT;
        }
        else {
            lowerBound = currentT;
        }
    } while (Math.abs(currentX) > subdivisionPrecision &&
        ++i < subdivisionMaxIterations);
    return currentT;
}
function cubicBezier(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2)
        return noop;
    const getTForX = (aX) => binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t) => t === 0 || t === 1 ? t : calcBezier(getTForX(t), mY1, mY2);
}

const easeIn = cubicBezier(0.42, 0, 1, 1);
const easeOut = cubicBezier(0, 0, 0.58, 1);
const easeInOut = cubicBezier(0.42, 0, 0.58, 1);

const isEasingArray = (ease) => {
    return Array.isArray(ease) && typeof ease[0] !== "number";
};

// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const mirrorEasing = (easing) => (p) => p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;

// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const reverseEasing = (easing) => (p) => 1 - easing(1 - p);

const circIn = (p) => 1 - Math.sin(Math.acos(p));
const circOut = reverseEasing(circIn);
const circInOut = mirrorEasing(circOut);

const backOut = cubicBezier(0.33, 1.53, 0.69, 0.99);
const backIn = reverseEasing(backOut);
const backInOut = mirrorEasing(backIn);

const anticipate = (p) => (p *= 2) < 1 ? 0.5 * backIn(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));

const easingLookup = {
    linear: noop,
    easeIn,
    easeInOut,
    easeOut,
    circIn,
    circInOut,
    circOut,
    backIn,
    backInOut,
    backOut,
    anticipate,
};
const easingDefinitionToFunction = (definition) => {
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        invariant(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return cubicBezier(x1, y1, x2, y2);
    }
    else if (typeof definition === "string") {
        // Else lookup from table
        invariant(easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return easingLookup[definition];
    }
    return definition;
};

/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */
const isColorString = (type, testProp) => (v) => {
    return Boolean((isString(v) && singleColorRegex.test(v) && v.startsWith(type)) ||
        (testProp && Object.prototype.hasOwnProperty.call(v, testProp)));
};
const splitColor = (aName, bName, cName) => (v) => {
    if (!isString(v))
        return v;
    const [a, b, c, alpha] = v.match(floatRegex);
    return {
        [aName]: parseFloat(a),
        [bName]: parseFloat(b),
        [cName]: parseFloat(c),
        alpha: alpha !== undefined ? parseFloat(alpha) : 1,
    };
};

const clampRgbUnit = (v) => clamp(0, 255, v);
const rgbUnit = {
    ...number,
    transform: (v) => Math.round(clampRgbUnit(v)),
};
const rgba = {
    test: isColorString("rgb", "red"),
    parse: splitColor("red", "green", "blue"),
    transform: ({ red, green, blue, alpha: alpha$1 = 1 }) => "rgba(" +
        rgbUnit.transform(red) +
        ", " +
        rgbUnit.transform(green) +
        ", " +
        rgbUnit.transform(blue) +
        ", " +
        sanitize(alpha.transform(alpha$1)) +
        ")",
};

function parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
        // Or we have 3 characters, ie #F00
    }
    else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1,
    };
}
const hex = {
    test: isColorString("#"),
    parse: parseHex,
    transform: rgba.transform,
};

const hsla = {
    test: isColorString("hsl", "hue"),
    parse: splitColor("hue", "saturation", "lightness"),
    transform: ({ hue, saturation, lightness, alpha: alpha$1 = 1 }) => {
        return ("hsla(" +
            Math.round(hue) +
            ", " +
            percent.transform(sanitize(saturation)) +
            ", " +
            percent.transform(sanitize(lightness)) +
            ", " +
            sanitize(alpha.transform(alpha$1)) +
            ")");
    },
};

const color = {
    test: (v) => rgba.test(v) || hex.test(v) || hsla.test(v),
    parse: (v) => {
        if (rgba.test(v)) {
            return rgba.parse(v);
        }
        else if (hsla.test(v)) {
            return hsla.parse(v);
        }
        else {
            return hex.parse(v);
        }
    },
    transform: (v) => {
        return isString(v)
            ? v
            : v.hasOwnProperty("red")
                ? rgba.transform(v)
                : hsla.transform(v);
    },
};

/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/
const mix = (from, to, progress) => -progress * from + progress * to + from;

// Adapted from https://gist.github.com/mjackson/5311256
function hueToRgb(p, q, t) {
    if (t < 0)
        t += 1;
    if (t > 1)
        t -= 1;
    if (t < 1 / 6)
        return p + (q - p) * 6 * t;
    if (t < 1 / 2)
        return q;
    if (t < 2 / 3)
        return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function hslaToRgba({ hue, saturation, lightness, alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) {
        red = green = blue = lightness;
    }
    else {
        const q = lightness < 0.5
            ? lightness * (1 + saturation)
            : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = hueToRgb(p, q, hue + 1 / 3);
        green = hueToRgb(p, q, hue);
        blue = hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha,
    };
}

// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const mixLinearColor = (from, to, v) => {
    const fromExpo = from * from;
    return Math.sqrt(Math.max(0, v * (to * to - fromExpo) + fromExpo));
};
const colorTypes = [hex, rgba, hsla];
const getColorType = (v) => colorTypes.find((type) => type.test(v));
function asRGBA(color) {
    const type = getColorType(color);
    invariant(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    let model = type.parse(color);
    if (type === hsla) {
        // TODO Remove this cast - needed since Framer Motion's stricter typing
        model = hslaToRgba(model);
    }
    return model;
}
const mixColor = (from, to) => {
    const fromRGBA = asRGBA(from);
    const toRGBA = asRGBA(to);
    const blended = { ...fromRGBA };
    return (v) => {
        blended.red = mixLinearColor(fromRGBA.red, toRGBA.red, v);
        blended.green = mixLinearColor(fromRGBA.green, toRGBA.green, v);
        blended.blue = mixLinearColor(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = mix(fromRGBA.alpha, toRGBA.alpha, v);
        return rgba.transform(blended);
    };
};

function test(v) {
    var _a, _b;
    return (isNaN(v) &&
        isString(v) &&
        (((_a = v.match(floatRegex)) === null || _a === void 0 ? void 0 : _a.length) || 0) +
            (((_b = v.match(colorRegex)) === null || _b === void 0 ? void 0 : _b.length) || 0) >
            0);
}
const cssVarTokeniser = {
    regex: cssVariableRegex,
    countKey: "Vars",
    token: "${v}",
    parse: noop,
};
const colorTokeniser = {
    regex: colorRegex,
    countKey: "Colors",
    token: "${c}",
    parse: color.parse,
};
const numberTokeniser = {
    regex: floatRegex,
    countKey: "Numbers",
    token: "${n}",
    parse: number.parse,
};
function tokenise(info, { regex, countKey, token, parse }) {
    const matches = info.tokenised.match(regex);
    if (!matches)
        return;
    info["num" + countKey] = matches.length;
    info.tokenised = info.tokenised.replace(regex, token);
    info.values.push(...matches.map(parse));
}
function analyseComplexValue(value) {
    const originalValue = value.toString();
    const info = {
        value: originalValue,
        tokenised: originalValue,
        values: [],
        numVars: 0,
        numColors: 0,
        numNumbers: 0,
    };
    if (info.value.includes("var(--"))
        tokenise(info, cssVarTokeniser);
    tokenise(info, colorTokeniser);
    tokenise(info, numberTokeniser);
    return info;
}
function parseComplexValue(v) {
    return analyseComplexValue(v).values;
}
function createTransformer(source) {
    const { values, numColors, numVars, tokenised } = analyseComplexValue(source);
    const numValues = values.length;
    return (v) => {
        let output = tokenised;
        for (let i = 0; i < numValues; i++) {
            if (i < numVars) {
                output = output.replace(cssVarTokeniser.token, v[i]);
            }
            else if (i < numVars + numColors) {
                output = output.replace(colorTokeniser.token, color.transform(v[i]));
            }
            else {
                output = output.replace(numberTokeniser.token, sanitize(v[i]));
            }
        }
        return output;
    };
}
const convertNumbersToZero = (v) => typeof v === "number" ? 0 : v;
function getAnimatableNone$1(v) {
    const parsed = parseComplexValue(v);
    const transformer = createTransformer(v);
    return transformer(parsed.map(convertNumbersToZero));
}
const complex = {
    test,
    parse: parseComplexValue,
    createTransformer,
    getAnimatableNone: getAnimatableNone$1,
};

const mixImmediate = (origin, target) => (p) => `${p > 0 ? target : origin}`;
function getMixer(origin, target) {
    if (typeof origin === "number") {
        return (v) => mix(origin, target, v);
    }
    else if (color.test(origin)) {
        return mixColor(origin, target);
    }
    else {
        return origin.startsWith("var(")
            ? mixImmediate(origin, target)
            : mixComplex(origin, target);
    }
}
const mixArray = (from, to) => {
    const output = [...from];
    const numValues = output.length;
    const blendValue = from.map((fromThis, i) => getMixer(fromThis, to[i]));
    return (v) => {
        for (let i = 0; i < numValues; i++) {
            output[i] = blendValue[i](v);
        }
        return output;
    };
};
const mixObject = (origin, target) => {
    const output = { ...origin, ...target };
    const blendValue = {};
    for (const key in output) {
        if (origin[key] !== undefined && target[key] !== undefined) {
            blendValue[key] = getMixer(origin[key], target[key]);
        }
    }
    return (v) => {
        for (const key in blendValue) {
            output[key] = blendValue[key](v);
        }
        return output;
    };
};
const mixComplex = (origin, target) => {
    const template = complex.createTransformer(target);
    const originStats = analyseComplexValue(origin);
    const targetStats = analyseComplexValue(target);
    const canInterpolate = originStats.numVars === targetStats.numVars &&
        originStats.numColors === targetStats.numColors &&
        originStats.numNumbers >= targetStats.numNumbers;
    if (canInterpolate) {
        return pipe(mixArray(originStats.values, targetStats.values), template);
    }
    else {
        warning(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return mixImmediate(origin, target);
    }
};

/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/
const progress = (from, to, value) => {
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};

const mixNumber = (from, to) => (p) => mix(from, to, p);
function detectMixerFactory(v) {
    if (typeof v === "number") {
        return mixNumber;
    }
    else if (typeof v === "string") {
        return color.test(v) ? mixColor : mixComplex;
    }
    else if (Array.isArray(v)) {
        return mixArray;
    }
    else if (typeof v === "object") {
        return mixObject;
    }
    return mixNumber;
}
function createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || detectMixerFactory(output[0]);
    const numMixers = output.length - 1;
    for (let i = 0; i < numMixers; i++) {
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || noop : ease;
            mixer = pipe(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */
function interpolate(input, output, { clamp: isClamp = true, ease, mixer } = {}) {
    const inputLength = input.length;
    invariant(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */
    if (inputLength === 1)
        return () => output[0];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [...input].reverse();
        output = [...output].reverse();
    }
    const mixers = createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v) => {
        let i = 0;
        if (numMixers > 1) {
            for (; i < input.length - 2; i++) {
                if (v < input[i + 1])
                    break;
            }
        }
        const progressInRange = progress(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp
        ? (v) => interpolator(clamp(input[0], input[inputLength - 1], v))
        : interpolator;
}

function fillOffset(offset, remaining) {
    const min = offset[offset.length - 1];
    for (let i = 1; i <= remaining; i++) {
        const offsetProgress = progress(0, remaining, i);
        offset.push(mix(min, 1, offsetProgress));
    }
}

function defaultOffset(arr) {
    const offset = [0];
    fillOffset(offset, arr.length - 1);
    return offset;
}

function convertOffsetToTimes(offset, duration) {
    return offset.map((o) => o * duration);
}

function defaultEasing(values, easing) {
    return values.map(() => easing || easeInOut).splice(0, values.length - 1);
}
function keyframes({ duration = 300, keyframes: keyframeValues, times, ease = "easeInOut", }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */
    const easingFunctions = isEasingArray(ease)
        ? ease.map(easingDefinitionToFunction)
        : easingDefinitionToFunction(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */
    const state = {
        done: false,
        value: keyframeValues[0],
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */
    const absoluteTimes = convertOffsetToTimes(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length
        ? times
        : defaultOffset(keyframeValues), duration);
    const mapTimeToKeyframe = interpolate(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions)
            ? easingFunctions
            : defaultEasing(keyframeValues, easingFunctions),
    });
    return {
        calculatedDuration: duration,
        next: (t) => {
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        },
    };
}

/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/
function velocityPerSecond(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}

const velocitySampleDuration = 5; // ms
function calcGeneratorVelocity(resolveValue, t, current) {
    const prevT = Math.max(t - velocitySampleDuration, 0);
    return velocityPerSecond(current - resolveValue(prevT), t - prevT);
}

const safeMin = 0.001;
const minDuration = 0.01;
const maxDuration$1 = 10.0;
const minDamping = 0.05;
const maxDamping = 1;
function findSpring({ duration = 800, bounce = 0.25, velocity = 0, mass = 1, }) {
    let envelope;
    let derivative;
    warning(duration <= secondsToMilliseconds(maxDuration$1), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */
    dampingRatio = clamp(minDamping, maxDamping, dampingRatio);
    duration = clamp(minDuration, maxDuration$1, millisecondsToSeconds(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */
        envelope = (undampedFreq) => {
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = calcAngularFreq(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return safeMin - (a / b) * c;
        };
        derivative = (undampedFreq) => {
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = calcAngularFreq(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + safeMin > 0 ? -1 : 1;
            return (factor * ((d - e) * f)) / g;
        };
    }
    else {
        /**
         * Critically-damped spring
         */
        envelope = (undampedFreq) => {
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -safeMin + a * b;
        };
        derivative = (undampedFreq) => {
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = approximateRoot(envelope, derivative, initialGuess);
    duration = secondsToMilliseconds(duration);
    if (isNaN(undampedFreq)) {
        return {
            stiffness: 100,
            damping: 10,
            duration,
        };
    }
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration,
        };
    }
}
const rootIterations = 12;
function approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for (let i = 1; i < rootIterations; i++) {
        result = result - envelope(result) / derivative(result);
    }
    return result;
}
function calcAngularFreq(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}

const durationKeys = ["duration", "bounce"];
const physicsKeys = ["stiffness", "damping", "mass"];
function isSpringType(options, keys) {
    return keys.some((key) => options[key] !== undefined);
}
function getSpringOptions(options) {
    let springOptions = {
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false,
        ...options,
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!isSpringType(options, physicsKeys) &&
        isSpringType(options, durationKeys)) {
        const derived = findSpring(options);
        springOptions = {
            ...springOptions,
            ...derived,
            velocity: 0.0,
            mass: 1.0,
        };
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function spring({ keyframes, restDelta, restSpeed, ...options }) {
    const origin = keyframes[0];
    const target = keyframes[keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */
    const state = { done: false, value: origin };
    const { stiffness, damping, mass, velocity, duration, isResolvedFromDuration, } = getSpringOptions(options);
    const initialVelocity = velocity ? -millisecondsToSeconds(velocity) : 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = millisecondsToSeconds(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */
    const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
    restDelta || (restDelta = isGranularScale ? 0.005 : 0.5);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = calcAngularFreq(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t) => {
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return (target -
                envelope *
                    (((initialVelocity +
                        dampingRatio * undampedAngularFreq * initialDelta) /
                        angularFreq) *
                        Math.sin(angularFreq * t) +
                        initialDelta * Math.cos(angularFreq * t)));
        };
    }
    else if (dampingRatio === 1) {
        // Critically damped spring
        resolveSpring = (t) => target -
            Math.exp(-undampedAngularFreq * t) *
                (initialDelta +
                    (initialVelocity + undampedAngularFreq * initialDelta) * t);
    }
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t) => {
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return (target -
                (envelope *
                    ((initialVelocity +
                        dampingRatio * undampedAngularFreq * initialDelta) *
                        Math.sinh(freqForT) +
                        dampedAngularFreq *
                            initialDelta *
                            Math.cosh(freqForT))) /
                    dampedAngularFreq);
        };
    }
    return {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t) => {
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = initialVelocity;
                if (t !== 0) {
                    /**
                     * We only need to calculate velocity for under-damped springs
                     * as over- and critically-damped springs can't overshoot, so
                     * checking only for displacement is enough.
                     */
                    if (dampingRatio < 1) {
                        currentVelocity = calcGeneratorVelocity(resolveSpring, t, current);
                    }
                    else {
                        currentVelocity = 0;
                    }
                }
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done =
                    isBelowVelocityThreshold && isBelowDisplacementThreshold;
            }
            else {
                state.done = t >= duration;
            }
            state.value = state.done ? target : current;
            return state;
        },
    };
}

function inertia({ keyframes, velocity = 0.0, power = 0.8, timeConstant = 325, bounceDamping = 10, bounceStiffness = 500, modifyTarget, min, max, restDelta = 0.5, restSpeed, }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin,
    };
    const isOutOfBounds = (v) => (min !== undefined && v < min) || (max !== undefined && v > max);
    const nearestBoundary = (v) => {
        if (min === undefined)
            return max;
        if (max === undefined)
            return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */
    if (target !== ideal)
        amplitude = target - origin;
    const calcDelta = (t) => -amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t) => target + calcDelta(t);
    const applyFriction = (t) => {
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */
    let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t) => {
        if (!isOutOfBounds(state.value))
            return;
        timeReachedBoundary = t;
        spring$1 = spring({
            keyframes: [state.value, nearestBoundary(state.value)],
            velocity: calcGeneratorVelocity(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta,
            restSpeed,
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t) => {
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */
            let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */
            if (timeReachedBoundary !== undefined && t > timeReachedBoundary) {
                return spring$1.next(t - timeReachedBoundary);
            }
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        },
    };
}

const frameloopDriver = (update) => {
    const passTimestamp = ({ timestamp }) => update(timestamp);
    return {
        start: () => frame.update(passTimestamp, true),
        stop: () => cancelFrame(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */
        now: () => frameData.isProcessing ? frameData.timestamp : performance.now(),
    };
};

/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */
const maxGeneratorDuration = 20000;
function calcGeneratorDuration(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while (!state.done && duration < maxGeneratorDuration) {
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= maxGeneratorDuration ? Infinity : duration;
}

const types = {
    decay: inertia,
    inertia,
    tween: keyframes,
    keyframes: keyframes,
    spring,
};
/**
 * Animate a single value on the main thread.
 *
 * This function is written, where functionality overlaps,
 * to be largely spec-compliant with WAAPI to allow fungibility
 * between the two.
 */
function animateValue({ autoplay = true, delay = 0, driver = frameloopDriver, keyframes: keyframes$1, type = "keyframes", repeat = 0, repeatDelay = 0, repeatType = "loop", onPlay, onStop, onComplete, onUpdate, ...options }) {
    let speed = 1;
    let hasStopped = false;
    let resolveFinishedPromise;
    let currentFinishedPromise;
    /**
     * Resolve the current Promise every time we enter the
     * finished state. This is WAAPI-compatible behaviour.
     */
    const updateFinishedPromise = () => {
        currentFinishedPromise = new Promise((resolve) => {
            resolveFinishedPromise = resolve;
        });
    };
    // Create the first finished promise
    updateFinishedPromise();
    let animationDriver;
    const generatorFactory = types[type] || keyframes;
    /**
     * If this isn't the keyframes generator and we've been provided
     * strings as keyframes, we need to interpolate these.
     * TODO: Support velocity for units and complex value types/
     */
    let mapNumbersToKeyframes;
    if (generatorFactory !== keyframes &&
        typeof keyframes$1[0] !== "number") {
        mapNumbersToKeyframes = interpolate([0, 100], keyframes$1, {
            clamp: false,
        });
        keyframes$1 = [0, 100];
    }
    const generator = generatorFactory({ ...options, keyframes: keyframes$1 });
    let mirroredGenerator;
    if (repeatType === "mirror") {
        mirroredGenerator = generatorFactory({
            ...options,
            keyframes: [...keyframes$1].reverse(),
            velocity: -(options.velocity || 0),
        });
    }
    let playState = "idle";
    let holdTime = null;
    let startTime = null;
    let cancelTime = null;
    /**
     * If duration is undefined and we have repeat options,
     * we need to calculate a duration from the generator.
     *
     * We set it to the generator itself to cache the duration.
     * Any timeline resolver will need to have already precalculated
     * the duration by this step.
     */
    if (generator.calculatedDuration === null && repeat) {
        generator.calculatedDuration = calcGeneratorDuration(generator);
    }
    const { calculatedDuration } = generator;
    let resolvedDuration = Infinity;
    let totalDuration = Infinity;
    if (calculatedDuration !== null) {
        resolvedDuration = calculatedDuration + repeatDelay;
        totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
    }
    let currentTime = 0;
    const tick = (timestamp) => {
        if (startTime === null)
            return;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */
        if (speed > 0)
            startTime = Math.min(startTime, timestamp);
        if (speed < 0)
            startTime = Math.min(timestamp - totalDuration / speed, startTime);
        if (holdTime !== null) {
            currentTime = holdTime;
        }
        else {
            // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
            // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
            // example.
            currentTime = Math.round(timestamp - startTime) * speed;
        }
        // Rebase on delay
        const timeWithoutDelay = currentTime - delay * (speed >= 0 ? 1 : -1);
        const isInDelayPhase = speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        currentTime = Math.max(timeWithoutDelay, 0);
        /**
         * If this animation has finished, set the current time
         * to the total duration.
         */
        if (playState === "finished" && holdTime === null) {
            currentTime = totalDuration;
        }
        let elapsed = currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */
            const progress = currentTime / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */
            let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */
            let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */
            if (!iterationProgress && progress >= 1) {
                iterationProgress = 1;
            }
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */
            const iterationIsOdd = Boolean(currentIteration % 2);
            if (iterationIsOdd) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) {
                        iterationProgress -= repeatDelay / resolvedDuration;
                    }
                }
                else if (repeatType === "mirror") {
                    frameGenerator = mirroredGenerator;
                }
            }
            let p = clamp(0, 1, iterationProgress);
            if (currentTime > totalDuration) {
                p = repeatType === "reverse" && iterationIsOdd ? 1 : 0;
            }
            elapsed = p * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */
        const state = isInDelayPhase
            ? { done: false, value: keyframes$1[0] }
            : frameGenerator.next(elapsed);
        if (mapNumbersToKeyframes) {
            state.value = mapNumbersToKeyframes(state.value);
        }
        let { done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) {
            done = speed >= 0 ? currentTime >= totalDuration : currentTime <= 0;
        }
        const isAnimationFinished = holdTime === null &&
            (playState === "finished" || (playState === "running" && done));
        if (onUpdate) {
            onUpdate(state.value);
        }
        if (isAnimationFinished) {
            finish();
        }
        return state;
    };
    const stopAnimationDriver = () => {
        animationDriver && animationDriver.stop();
        animationDriver = undefined;
    };
    const cancel = () => {
        playState = "idle";
        stopAnimationDriver();
        resolveFinishedPromise();
        updateFinishedPromise();
        startTime = cancelTime = null;
    };
    const finish = () => {
        playState = "finished";
        onComplete && onComplete();
        stopAnimationDriver();
        resolveFinishedPromise();
    };
    const play = () => {
        if (hasStopped)
            return;
        if (!animationDriver)
            animationDriver = driver(tick);
        const now = animationDriver.now();
        onPlay && onPlay();
        if (holdTime !== null) {
            startTime = now - holdTime;
        }
        else if (!startTime || playState === "finished") {
            startTime = now;
        }
        if (playState === "finished") {
            updateFinishedPromise();
        }
        cancelTime = startTime;
        holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */
        playState = "running";
        animationDriver.start();
    };
    if (autoplay) {
        play();
    }
    const controls = {
        then(resolve, reject) {
            return currentFinishedPromise.then(resolve, reject);
        },
        get time() {
            return millisecondsToSeconds(currentTime);
        },
        set time(newTime) {
            newTime = secondsToMilliseconds(newTime);
            currentTime = newTime;
            if (holdTime !== null || !animationDriver || speed === 0) {
                holdTime = newTime;
            }
            else {
                startTime = animationDriver.now() - newTime / speed;
            }
        },
        get duration() {
            const duration = generator.calculatedDuration === null
                ? calcGeneratorDuration(generator)
                : generator.calculatedDuration;
            return millisecondsToSeconds(duration);
        },
        get speed() {
            return speed;
        },
        set speed(newSpeed) {
            if (newSpeed === speed || !animationDriver)
                return;
            speed = newSpeed;
            controls.time = millisecondsToSeconds(currentTime);
        },
        get state() {
            return playState;
        },
        play,
        pause: () => {
            playState = "paused";
            holdTime = currentTime;
        },
        stop: () => {
            hasStopped = true;
            if (playState === "idle")
                return;
            playState = "idle";
            onStop && onStop();
            cancel();
        },
        cancel: () => {
            if (cancelTime !== null)
                tick(cancelTime);
            cancel();
        },
        complete: () => {
            playState = "finished";
        },
        sample: (elapsed) => {
            startTime = 0;
            return tick(elapsed);
        },
    };
    return controls;
}

function memo(callback) {
    let result;
    return () => {
        if (result === undefined)
            result = callback();
        return result;
    };
}

const supportsWaapi = memo(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
/**
 * A list of values that can be hardware-accelerated.
 */
const acceleratedValues = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform",
    "backgroundColor",
]);
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */
const sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */
const maxDuration = 20000;
const requiresPregeneratedKeyframes = (valueName, options) => options.type === "spring" ||
    valueName === "backgroundColor" ||
    !isWaapiSupportedEasing(options.ease);
function createAcceleratedAnimation(value, valueName, { onUpdate, onComplete, ...options }) {
    const canAccelerateAnimation = supportsWaapi() &&
        acceleratedValues.has(valueName) &&
        !options.repeatDelay &&
        options.repeatType !== "mirror" &&
        options.damping !== 0 &&
        options.type !== "inertia";
    if (!canAccelerateAnimation)
        return false;
    /**
     * TODO: Unify with js/index
     */
    let hasStopped = false;
    let resolveFinishedPromise;
    let currentFinishedPromise;
    /**
     * Resolve the current Promise every time we enter the
     * finished state. This is WAAPI-compatible behaviour.
     */
    const updateFinishedPromise = () => {
        currentFinishedPromise = new Promise((resolve) => {
            resolveFinishedPromise = resolve;
        });
    };
    // Create the first finished promise
    updateFinishedPromise();
    let { keyframes, duration = 300, ease, times } = options;
    /**
     * If this animation needs pre-generated keyframes then generate.
     */
    if (requiresPregeneratedKeyframes(valueName, options)) {
        const sampleAnimation = animateValue({
            ...options,
            repeat: 0,
            delay: 0,
        });
        let state = { done: false, value: keyframes[0] };
        const pregeneratedKeyframes = [];
        /**
         * Bail after 20 seconds of pre-generated keyframes as it's likely
         * we're heading for an infinite loop.
         */
        let t = 0;
        while (!state.done && t < maxDuration) {
            state = sampleAnimation.sample(t);
            pregeneratedKeyframes.push(state.value);
            t += sampleDelta;
        }
        times = undefined;
        keyframes = pregeneratedKeyframes;
        duration = t - sampleDelta;
        ease = "linear";
    }
    const animation = animateStyle(value.owner.current, valueName, keyframes, {
        ...options,
        duration,
        /**
         * This function is currently not called if ease is provided
         * as a function so the cast is safe.
         *
         * However it would be possible for a future refinement to port
         * in easing pregeneration from Motion One for browsers that
         * support the upcoming `linear()` easing function.
         */
        ease: ease,
        times,
    });
    /**
     * WAAPI animations don't resolve startTime synchronously. But a blocked
     * thread could delay the startTime resolution by a noticeable amount.
     * For synching handoff animations with the new Motion animation we want
     * to ensure startTime is synchronously set.
     */
    if (options.syncStart) {
        animation.startTime = frameData.isProcessing
            ? frameData.timestamp
            : document.timeline
                ? document.timeline.currentTime
                : performance.now();
    }
    const cancelAnimation = () => animation.cancel();
    const safeCancel = () => {
        frame.update(cancelAnimation);
        resolveFinishedPromise();
        updateFinishedPromise();
    };
    /**
     * Prefer the `onfinish` prop as it's more widely supported than
     * the `finished` promise.
     *
     * Here, we synchronously set the provided MotionValue to the end
     * keyframe. If we didn't, when the WAAPI animation is finished it would
     * be removed from the element which would then revert to its old styles.
     */
    animation.onfinish = () => {
        value.set(getFinalKeyframe(keyframes, options));
        onComplete && onComplete();
        safeCancel();
    };
    /**
     * Animation interrupt callback.
     */
    const controls = {
        then(resolve, reject) {
            return currentFinishedPromise.then(resolve, reject);
        },
        attachTimeline(timeline) {
            animation.timeline = timeline;
            animation.onfinish = null;
            return noop;
        },
        get time() {
            return millisecondsToSeconds(animation.currentTime || 0);
        },
        set time(newTime) {
            animation.currentTime = secondsToMilliseconds(newTime);
        },
        get speed() {
            return animation.playbackRate;
        },
        set speed(newSpeed) {
            animation.playbackRate = newSpeed;
        },
        get duration() {
            return millisecondsToSeconds(duration);
        },
        play: () => {
            if (hasStopped)
                return;
            animation.play();
            /**
             * Cancel any pending cancel tasks
             */
            cancelFrame(cancelAnimation);
        },
        pause: () => animation.pause(),
        stop: () => {
            hasStopped = true;
            if (animation.playState === "idle")
                return;
            /**
             * WAAPI doesn't natively have any interruption capabilities.
             *
             * Rather than read commited styles back out of the DOM, we can
             * create a renderless JS animation and sample it twice to calculate
             * its current value, "previous" value, and therefore allow
             * Motion to calculate velocity for any subsequent animation.
             */
            const { currentTime } = animation;
            if (currentTime) {
                const sampleAnimation = animateValue({
                    ...options,
                    autoplay: false,
                });
                value.setWithVelocity(sampleAnimation.sample(currentTime - sampleDelta).value, sampleAnimation.sample(currentTime).value, sampleDelta);
            }
            safeCancel();
        },
        complete: () => animation.finish(),
        cancel: safeCancel,
    };
    return controls;
}

function createInstantAnimation({ keyframes, delay, onUpdate, onComplete, }) {
    const setValue = () => {
        onUpdate && onUpdate(keyframes[keyframes.length - 1]);
        onComplete && onComplete();
        /**
         * TODO: As this API grows it could make sense to always return
         * animateValue. This will be a bigger project as animateValue
         * is frame-locked whereas this function resolves instantly.
         * This is a behavioural change and also has ramifications regarding
         * assumptions within tests.
         */
        return {
            time: 0,
            speed: 1,
            duration: 0,
            play: (noop),
            pause: (noop),
            stop: (noop),
            then: (resolve) => {
                resolve();
                return Promise.resolve();
            },
            cancel: (noop),
            complete: (noop),
        };
    };
    return delay
        ? animateValue({
            keyframes: [0, 1],
            duration: 0,
            delay,
            onComplete: setValue,
        })
        : setValue();
}

const underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10,
};
const criticallyDampedSpring = (target) => ({
    type: "spring",
    stiffness: 550,
    damping: target === 0 ? 2 * Math.sqrt(550) : 30,
    restSpeed: 10,
});
const keyframesTransition = {
    type: "keyframes",
    duration: 0.8,
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */
const ease = {
    type: "keyframes",
    ease: [0.25, 0.1, 0.35, 1],
    duration: 0.3,
};
const getDefaultTransition = (valueKey, { keyframes }) => {
    if (keyframes.length > 2) {
        return keyframesTransition;
    }
    else if (transformProps.has(valueKey)) {
        return valueKey.startsWith("scale")
            ? criticallyDampedSpring(keyframes[1])
            : underDampedSpring;
    }
    return ease;
};

/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */
const isAnimatable = (key, value) => {
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (key === "zIndex")
        return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value))
        return true;
    if (typeof value === "string" && // It's animatable if we have a string
        (complex.test(value) || value === "0") && // And it contains numbers and/or colors
        !value.startsWith("url(") // Unless it starts with "url("
    ) {
        return true;
    }
    return false;
};

/**
 * Properties that should default to 1 or 100%
 */
const maxDefaults = new Set(["brightness", "contrast", "saturate", "opacity"]);
function applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow")
        return v;
    const [number] = value.match(floatRegex) || [];
    if (!number)
        return v;
    const unit = value.replace(number, "");
    let defaultValue = maxDefaults.has(name) ? 1 : 0;
    if (number !== value)
        defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const functionRegex = /([a-z-]*)\(.*?\)/g;
const filter = {
    ...complex,
    getAnimatableNone: (v) => {
        const functions = v.match(functionRegex);
        return functions ? functions.map(applyDefaultFilter).join(" ") : v;
    },
};

/**
 * A map of default value types for common values
 */
const defaultValueTypes = {
    ...numberValueTypes,
    // Color props
    color,
    backgroundColor: color,
    outlineColor: color,
    fill: color,
    stroke: color,
    // Border props
    borderColor: color,
    borderTopColor: color,
    borderRightColor: color,
    borderBottomColor: color,
    borderLeftColor: color,
    filter,
    WebkitFilter: filter,
};
/**
 * Gets the default ValueType for the provided value key
 */
const getDefaultValueType = (key) => defaultValueTypes[key];

function getAnimatableNone(key, value) {
    let defaultValueType = getDefaultValueType(key);
    if (defaultValueType !== filter)
        defaultValueType = complex;
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone
        ? defaultValueType.getAnimatableNone(value)
        : undefined;
}

/**
 * Check if the value is a zero value string like "0px" or "0%"
 */
const isZeroValueString = (v) => /^0[^.\s]+$/.test(v);

function isNone(value) {
    if (typeof value === "number") {
        return value === 0;
    }
    else if (value !== null) {
        return value === "none" || value === "0" || isZeroValueString(value);
    }
}

function getKeyframes(value, valueName, target, transition) {
    const isTargetAnimatable = isAnimatable(valueName, target);
    let keyframes;
    if (Array.isArray(target)) {
        keyframes = [...target];
    }
    else {
        keyframes = [null, target];
    }
    const defaultOrigin = transition.from !== undefined ? transition.from : value.get();
    let animatableTemplateValue = undefined;
    const noneKeyframeIndexes = [];
    for (let i = 0; i < keyframes.length; i++) {
        /**
         * Fill null/wildcard keyframes
         */
        if (keyframes[i] === null) {
            keyframes[i] = i === 0 ? defaultOrigin : keyframes[i - 1];
        }
        if (isNone(keyframes[i])) {
            noneKeyframeIndexes.push(i);
        }
        // TODO: Clean this conditional, it works for now
        if (typeof keyframes[i] === "string" &&
            keyframes[i] !== "none" &&
            keyframes[i] !== "0") {
            animatableTemplateValue = keyframes[i];
        }
    }
    if (isTargetAnimatable &&
        noneKeyframeIndexes.length &&
        animatableTemplateValue) {
        for (let i = 0; i < noneKeyframeIndexes.length; i++) {
            const index = noneKeyframeIndexes[i];
            keyframes[index] = getAnimatableNone(valueName, animatableTemplateValue);
        }
    }
    return keyframes;
}

/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */
function isTransitionDefined({ when, delay: _delay, delayChildren, staggerChildren, staggerDirection, repeat, repeatType, repeatDelay, from, elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}
function getValueTransition(transition, key) {
    return transition[key] || transition["default"] || transition;
}

const animateMotionValue = (valueName, value, target, transition = {}) => {
    return (onComplete) => {
        const valueTransition = getValueTransition(transition, valueName) || {};
        /**
         * Most transition values are currently completely overwritten by value-specific
         * transitions. In the future it'd be nicer to blend these transitions. But for now
         * delay actually does inherit from the root transition if not value-specific.
         */
        const delay = valueTransition.delay || transition.delay || 0;
        /**
         * Elapsed isn't a public transition option but can be passed through from
         * optimized appear effects in milliseconds.
         */
        let { elapsed = 0 } = transition;
        elapsed = elapsed - secondsToMilliseconds(delay);
        const keyframes = getKeyframes(value, valueName, target, valueTransition);
        /**
         * Check if we're able to animate between the start and end keyframes,
         * and throw a warning if we're attempting to animate between one that's
         * animatable and another that isn't.
         */
        const originKeyframe = keyframes[0];
        const targetKeyframe = keyframes[keyframes.length - 1];
        const isOriginAnimatable = isAnimatable(valueName, originKeyframe);
        const isTargetAnimatable = isAnimatable(valueName, targetKeyframe);
        warning(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${valueName} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
        let options = {
            keyframes,
            velocity: value.getVelocity(),
            ease: "easeOut",
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v) => {
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: () => {
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
        };
        /**
         * If there's no transition defined for this value, we can generate
         * unqiue transition settings for this value.
         */
        if (!isTransitionDefined(valueTransition)) {
            options = {
                ...options,
                ...getDefaultTransition(valueName, options),
            };
        }
        /**
         * Both WAAPI and our internal animation functions use durations
         * as defined by milliseconds, while our external API defines them
         * as seconds.
         */
        if (options.duration) {
            options.duration = secondsToMilliseconds(options.duration);
        }
        if (options.repeatDelay) {
            options.repeatDelay = secondsToMilliseconds(options.repeatDelay);
        }
        if (!isOriginAnimatable ||
            !isTargetAnimatable ||
            instantAnimationState.current ||
            valueTransition.type === false) {
            /**
             * If we can't animate this value, or the global instant animation flag is set,
             * or this is simply defined as an instant transition, return an instant transition.
             */
            return createInstantAnimation(options);
        }
        /**
         * Animate via WAAPI if possible.
         */
        if (value.owner &&
            value.owner.current instanceof HTMLElement &&
            !value.owner.getProps().onUpdate) {
            const acceleratedAnimation = createAcceleratedAnimation(value, valueName, options);
            if (acceleratedAnimation)
                return acceleratedAnimation;
        }
        /**
         * If we didn't create an accelerated animation, create a JS animation
         */
        return animateValue(options);
    };
};

function isWillChangeMotionValue(value) {
    return Boolean(isMotionValue(value) && value.add);
}

/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */
const isNumericalString = (v) => /^\-?\d*\.?\d+$/.test(v);

function addUniqueItem(arr, item) {
    if (arr.indexOf(item) === -1)
        arr.push(item);
}
function removeItem(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1)
        arr.splice(index, 1);
}

class SubscriptionManager {
    constructor() {
        this.subscriptions = [];
    }
    add(handler) {
        addUniqueItem(this.subscriptions, handler);
        return () => removeItem(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions)
            return;
        if (numSubscriptions === 1) {
            /**
             * If there's only a single handler we can just call it without invoking a loop.
             */
            this.subscriptions[0](a, b, c);
        }
        else {
            for (let i = 0; i < numSubscriptions; i++) {
                /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */
                const handler = this.subscriptions[i];
                handler && handler(a, b, c);
            }
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}

const warned = new Set();
function warnOnce(condition, message, element) {
    if (condition || warned.has(message))
        return;
    console.warn(message);
    if (element)
        console.warn(element);
    warned.add(message);
}

const isFloat = (value) => {
    return !isNaN(parseFloat(value));
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */
class MotionValue {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */
    constructor(init, options = {}) {
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */
        this.version = "10.16.4";
        /**
         * Duration, in milliseconds, since last updating frame.
         *
         * @internal
         */
        this.timeDelta = 0;
        /**
         * Timestamp of the last time this `MotionValue` was updated.
         *
         * @internal
         */
        this.lastUpdated = 0;
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */
        this.canTrackVelocity = false;
        /**
         * An object containing a SubscriptionManager for each active event.
         */
        this.events = {};
        this.updateAndNotify = (v, render = true) => {
            this.prev = this.current;
            this.current = v;
            // Update timestamp
            const { delta, timestamp } = frameData;
            if (this.lastUpdated !== timestamp) {
                this.timeDelta = delta;
                this.lastUpdated = timestamp;
                frame.postRender(this.scheduleVelocityCheck);
            }
            // Update update subscribers
            if (this.prev !== this.current && this.events.change) {
                this.events.change.notify(this.current);
            }
            // Update velocity subscribers
            if (this.events.velocityChange) {
                this.events.velocityChange.notify(this.getVelocity());
            }
            // Update render subscribers
            if (render && this.events.renderRequest) {
                this.events.renderRequest.notify(this.current);
            }
        };
        /**
         * Schedule a velocity check for the next frame.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */
        this.scheduleVelocityCheck = () => frame.postRender(this.velocityCheck);
        /**
         * Updates `prev` with `current` if the value hasn't been updated this frame.
         * This ensures velocity calculations return `0`.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */
        this.velocityCheck = ({ timestamp }) => {
            if (timestamp !== this.lastUpdated) {
                this.prev = this.current;
                if (this.events.velocityChange) {
                    this.events.velocityChange.notify(this.getVelocity());
                }
            }
        };
        this.hasAnimated = false;
        this.prev = this.current = init;
        this.canTrackVelocity = isFloat(this.current);
        this.owner = options.owner;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */
    onChange(subscription) {
        if (process.env.NODE_ENV !== "production") {
            warnOnce(false, `value.onChange(callback) is deprecated. Switch to value.on("change", callback).`);
        }
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) {
            this.events[eventName] = new SubscriptionManager();
        }
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") {
            return () => {
                unsubscribe();
                /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */
                frame.read(() => {
                    if (!this.events.change.getSize()) {
                        this.stop();
                    }
                });
            };
        }
        return unsubscribe;
    }
    clearListeners() {
        for (const eventManagers in this.events) {
            this.events[eventManagers].clear();
        }
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */
    attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */
    set(v, render = true) {
        if (!render || !this.passiveEffect) {
            this.updateAndNotify(v, render);
        }
        else {
            this.passiveEffect(v, this.updateAndNotify);
        }
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = prev;
        this.timeDelta = delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */
    jump(v) {
        this.updateAndNotify(v);
        this.prev = v;
        this.stop();
        if (this.stopPassiveEffect)
            this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */
    get() {
        return this.current;
    }
    /**
     * @public
     */
    getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */
    getVelocity() {
        // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
        return this.canTrackVelocity
            ? // These casts could be avoided if parseFloat would be typed better
                velocityPerSecond(parseFloat(this.current) -
                    parseFloat(this.prev), this.timeDelta)
            : 0;
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */
    start(startAnimation) {
        this.stop();
        return new Promise((resolve) => {
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) {
                this.events.animationStart.notify();
            }
        }).then(() => {
            if (this.events.animationComplete) {
                this.events.animationComplete.notify();
            }
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */
    stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) {
                this.events.animationCancel.notify();
            }
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */
    isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */
    destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) {
            this.stopPassiveEffect();
        }
    }
}
function motionValue(init, options) {
    return new MotionValue(init, options);
}

/**
 * Tests a provided value against a ValueType
 */
const testValueType = (v) => (type) => type.test(v);

/**
 * ValueType for "auto"
 */
const auto = {
    test: (v) => v === "auto",
    parse: (v) => v,
};

/**
 * A list of value types commonly used for dimensions
 */
const dimensionValueTypes = [number, px, percent, degrees, vw, vh, auto];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */
const findDimensionValueType = (v) => dimensionValueTypes.find(testValueType(v));

/**
 * A list of all ValueTypes
 */
const valueTypes = [...dimensionValueTypes, color, complex];
/**
 * Tests a value against the list of ValueTypes
 */
const findValueType = (v) => valueTypes.find(testValueType(v));

/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */
function setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) {
        visualElement.getValue(key).set(value);
    }
    else {
        visualElement.addValue(key, motionValue(value));
    }
}
function setTarget(visualElement, definition) {
    const resolved = resolveVariant(visualElement, definition);
    let { transitionEnd = {}, transition = {}, ...target } = resolved ? visualElement.makeTargetAnimatable(resolved, false) : {};
    target = { ...target, ...transitionEnd };
    for (const key in target) {
        const value = resolveFinalValueInKeyframes(target[key]);
        setMotionValue(visualElement, key, value);
    }
}
function checkTargetForNewValues(visualElement, target, origin) {
    var _a, _b;
    const newValueKeys = Object.keys(target).filter((key) => !visualElement.hasValue(key));
    const numNewValues = newValueKeys.length;
    if (!numNewValues)
        return;
    for (let i = 0; i < numNewValues; i++) {
        const key = newValueKeys[i];
        const targetValue = target[key];
        let value = null;
        /**
         * If the target is a series of keyframes, we can use the first value
         * in the array. If this first value is null, we'll still need to read from the DOM.
         */
        if (Array.isArray(targetValue)) {
            value = targetValue[0];
        }
        /**
         * If the target isn't keyframes, or the first keyframe was null, we need to
         * first check if an origin value was explicitly defined in the transition as "from",
         * if not read the value from the DOM. As an absolute fallback, take the defined target value.
         */
        if (value === null) {
            value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
        }
        /**
         * If value is still undefined or null, ignore it. Preferably this would throw,
         * but this was causing issues in Framer.
         */
        if (value === undefined || value === null)
            continue;
        if (typeof value === "string" &&
            (isNumericalString(value) || isZeroValueString(value))) {
            // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
        }
        else if (!findValueType(value) && complex.test(targetValue)) {
            value = getAnimatableNone(key, targetValue);
        }
        visualElement.addValue(key, motionValue(value, { owner: visualElement }));
        if (origin[key] === undefined) {
            origin[key] = value;
        }
        if (value !== null)
            visualElement.setBaseTarget(key, value);
    }
}
function getOriginFromTransition(key, transition) {
    if (!transition)
        return;
    const valueTransition = transition[key] || transition["default"] || transition;
    return valueTransition.from;
}
function getOrigin(target, transition, visualElement) {
    const origin = {};
    for (const key in target) {
        const transitionOrigin = getOriginFromTransition(key, transition);
        if (transitionOrigin !== undefined) {
            origin[key] = transitionOrigin;
        }
        else {
            const value = visualElement.getValue(key);
            if (value) {
                origin[key] = value.get();
            }
        }
    }
    return origin;
}

/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */
function shouldBlockAnimation({ protectedKeys, needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function animateTarget(visualElement, definition, { delay = 0, transitionOverride, type } = {}) {
    let { transition = visualElement.getDefaultTransition(), transitionEnd, ...target } = visualElement.makeTargetAnimatable(definition);
    const willChange = visualElement.getValue("willChange");
    if (transitionOverride)
        transition = transitionOverride;
    const animations = [];
    const animationTypeState = type &&
        visualElement.animationState &&
        visualElement.animationState.getState()[type];
    for (const key in target) {
        const value = visualElement.getValue(key);
        const valueTarget = target[key];
        if (!value ||
            valueTarget === undefined ||
            (animationTypeState &&
                shouldBlockAnimation(animationTypeState, key))) {
            continue;
        }
        const valueTransition = {
            delay,
            elapsed: 0,
            ...transition,
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */
        if (window.HandoffAppearAnimations && !value.hasAnimated) {
            const appearId = visualElement.getProps()[optimizedAppearDataAttribute];
            if (appearId) {
                valueTransition.elapsed = window.HandoffAppearAnimations(appearId, key, value, frame);
                valueTransition.syncStart = true;
            }
        }
        value.start(animateMotionValue(key, value, valueTarget, visualElement.shouldReduceMotion && transformProps.has(key)
            ? { type: false }
            : valueTransition));
        const animation = value.animation;
        if (isWillChangeMotionValue(willChange)) {
            willChange.add(key);
            animation.then(() => willChange.remove(key));
        }
        animations.push(animation);
    }
    if (transitionEnd) {
        Promise.all(animations).then(() => {
            transitionEnd && setTarget(visualElement, transitionEnd);
        });
    }
    return animations;
}

function animateVariant(visualElement, variant, options = {}) {
    const resolved = resolveVariant(visualElement, variant, options.custom);
    let { transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) {
        transition = options.transitionOverride;
    }
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */
    const getAnimation = resolved
        ? () => Promise.all(animateTarget(visualElement, resolved, options))
        : () => Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */
    const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size
        ? (forwardDelay = 0) => {
            const { delayChildren = 0, staggerChildren, staggerDirection, } = transition;
            return animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
        }
        : () => Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */
    const { when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren"
            ? [getAnimation, getChildAnimations]
            : [getChildAnimations, getAnimation];
        return first().then(() => last());
    }
    else {
        return Promise.all([getAnimation(), getChildAnimations(options.delay)]);
    }
}
function animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1
        ? (i = 0) => i * staggerChildren
        : (i = 0) => maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren)
        .sort(sortByTreeOrder)
        .forEach((child, i) => {
        child.notify("AnimationStart", variant);
        animations.push(animateVariant(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i),
        }).then(() => child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function sortByTreeOrder(a, b) {
    return a.sortNodePosition(b);
}

function animateVisualElement(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant) => animateVariant(visualElement, variant, options));
        animation = Promise.all(animations);
    }
    else if (typeof definition === "string") {
        animation = animateVariant(visualElement, definition, options);
    }
    else {
        const resolvedDefinition = typeof definition === "function"
            ? resolveVariant(visualElement, definition, options.custom)
            : definition;
        animation = Promise.all(animateTarget(visualElement, resolvedDefinition, options));
    }
    return animation.then(() => visualElement.notify("AnimationComplete", definition));
}

const reversePriorityOrder = [...variantPriorityOrder].reverse();
const numAnimationTypes = variantPriorityOrder.length;
function animateList(visualElement) {
    return (animations) => Promise.all(animations.map(({ animation, options }) => animateVisualElement(visualElement, animation, options)));
}
function createAnimationState(visualElement) {
    let animate = animateList(visualElement);
    const state = createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */
    const buildResolvedTypeValues = (acc, definition) => {
        const resolved = resolveVariant(visualElement, definition);
        if (resolved) {
            const { transition, transitionEnd, ...target } = resolved;
            acc = { ...acc, ...target, ...transitionEnd };
        }
        return acc;
    };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */
    function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */
    function animateChanges(options, changedActiveType) {
        const props = visualElement.getProps();
        const context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */
        const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */
        const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */
        let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */
        let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */
        for (let i = 0; i < numAnimationTypes; i++) {
            const type = reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = isVariantLabel(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */
            const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false)
                removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */
            let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */
            if (isInherited &&
                isInitialRender &&
                visualElement.manuallyAnimateOnMount) {
                isInherited = false;
            }
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */
            typeState.protectedKeys = { ...encounteredKeys };
            // Check if we can skip analysing this prop early
            if (
            // If it isn't active and hasn't *just* been set as inactive
            (!typeState.isActive && activeDelta === null) ||
                // If we didn't and don't have any defined prop for this animation type
                (!prop && !typeState.prevProp) ||
                // Or if the prop doesn't define an animation
                isAnimationControls(prop) ||
                typeof prop === "boolean") {
                continue;
            }
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */
            const variantDidChange = checkVariantsDidChange(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange ||
                // If we're making this variant active, we want to always make it active
                (type === changedActiveType &&
                    typeState.isActive &&
                    !isInherited &&
                    propIsVariant) ||
                // If we removed a higher-priority variant (i is in reverse order)
                (i > removedVariantIndex && propIsVariant);
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */
            const definitionList = Array.isArray(prop) ? prop : [prop];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */
            let resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
            if (activeDelta === false)
                resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */
            const { prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues,
            };
            const markToAnimate = (key) => {
                shouldAnimateType = true;
                removedKeys.delete(key);
                typeState.needsAnimating[key] = true;
            };
            for (const key in allKeys) {
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key))
                    continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */
                if (next !== prev) {
                    /**
                     * If both values are keyframes, we need to shallow compare them to
                     * detect whether any value has changed. If it has, we animate it.
                     */
                    if (isKeyframesTarget(next) && isKeyframesTarget(prev)) {
                        if (!shallowCompare(next, prev) || variantDidChange) {
                            markToAnimate(key);
                        }
                        else {
                            /**
                             * If it hasn't changed, we want to ensure it doesn't animate by
                             * adding it to the list of protected keys.
                             */
                            typeState.protectedKeys[key] = true;
                        }
                    }
                    else if (next !== undefined) {
                        // If next is defined and doesn't equal prev, it needs animating
                        markToAnimate(key);
                    }
                    else {
                        // If it's undefined, it's been removed.
                        removedKeys.add(key);
                    }
                }
                else if (next !== undefined && removedKeys.has(key)) {
                    /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */
                    markToAnimate(key);
                }
                else {
                    /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */
                    typeState.protectedKeys[key] = true;
                }
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */
            typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */
            if (typeState.isActive) {
                encounteredKeys = { ...encounteredKeys, ...resolvedValues };
            }
            if (isInitialRender && visualElement.blockInitialAnimation) {
                shouldAnimateType = false;
            }
            /**
             * If this is an inherited prop we want to hard-block animations
             * TODO: Test as this should probably still handle animations triggered
             * by removed values?
             */
            if (shouldAnimateType && !isInherited) {
                animations.push(...definitionList.map((animation) => ({
                    animation: animation,
                    options: { type, ...options },
                })));
            }
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */
        if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key) => {
                const fallbackTarget = visualElement.getBaseTarget(key);
                if (fallbackTarget !== undefined) {
                    fallbackAnimation[key] = fallbackTarget;
                }
            });
            animations.push({ animation: fallbackAnimation });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender &&
            props.initial === false &&
            !visualElement.manuallyAnimateOnMount) {
            shouldAnimate = false;
        }
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */
    function setActive(type, isActive, options) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive)
            return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.forEach((child) => { var _a; return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive); });
        state[type].isActive = isActive;
        const animations = animateChanges(options, type);
        for (const key in state) {
            state[key].protectedKeys = {};
        }
        return animations;
    }
    return {
        animateChanges,
        setActive,
        setAnimateFunction,
        getState: () => state,
    };
}
function checkVariantsDidChange(prev, next) {
    if (typeof next === "string") {
        return next !== prev;
    }
    else if (Array.isArray(next)) {
        return !shallowCompare(next, prev);
    }
    return false;
}
function createTypeState(isActive = false) {
    return {
        isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {},
    };
}
function createState() {
    return {
        animate: createTypeState(true),
        whileInView: createTypeState(),
        whileHover: createTypeState(),
        whileTap: createTypeState(),
        whileDrag: createTypeState(),
        whileFocus: createTypeState(),
        exit: createTypeState(),
    };
}

class AnimationFeature extends Feature {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */
    constructor(node) {
        super(node);
        node.animationState || (node.animationState = createAnimationState(node));
    }
    updateAnimationControlsSubscription() {
        const { animate } = this.node.getProps();
        this.unmount();
        if (isAnimationControls(animate)) {
            this.unmount = animate.subscribe(this.node);
        }
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */
    mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) {
            this.updateAnimationControlsSubscription();
        }
    }
    unmount() { }
}

let id$1 = 0;
class ExitAnimationFeature extends Feature {
    constructor() {
        super(...arguments);
        this.id = id$1++;
    }
    update() {
        if (!this.node.presenceContext)
            return;
        const { isPresent, onExitComplete, custom } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) {
            return;
        }
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent, { custom: custom !== null && custom !== void 0 ? custom : this.node.getProps().custom });
        if (onExitComplete && !isPresent) {
            exitAnimation.then(() => onExitComplete(this.id));
        }
    }
    mount() {
        const { register } = this.node.presenceContext || {};
        if (register) {
            this.unmount = register(this.id);
        }
    }
    unmount() { }
}

const animations = {
    animation: {
        Feature: AnimationFeature,
    },
    exit: {
        Feature: ExitAnimationFeature,
    },
};

const distance = (a, b) => Math.abs(a - b);
function distance2D(a, b) {
    // Multi-dimensional
    const xDelta = distance(a.x, b.x);
    const yDelta = distance(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}

/**
 * @internal
 */
class PanSession {
    constructor(event, handlers, { transformPagePoint } = {}) {
        /**
         * @internal
         */
        this.startEvent = null;
        /**
         * @internal
         */
        this.lastMoveEvent = null;
        /**
         * @internal
         */
        this.lastMoveEventInfo = null;
        /**
         * @internal
         */
        this.handlers = {};
        this.updatePoint = () => {
            if (!(this.lastMoveEvent && this.lastMoveEventInfo))
                return;
            const info = getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = distance2D(info.offset, { x: 0, y: 0 }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold)
                return;
            const { point } = info;
            const { timestamp } = frameData;
            this.history.push({ ...point, timestamp });
            const { onStart, onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info) => {
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            frame.update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info) => {
            this.end();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo))
                return;
            const { onEnd, onSessionEnd } = this.handlers;
            const panInfo = getPanInfo(event.type === "pointercancel"
                ? this.lastMoveEventInfo
                : transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) {
                onEnd(event, panInfo);
            }
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!isPrimaryPointer(event))
            return;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        const info = extractEventInfo(event);
        const initialInfo = transformPoint(info, this.transformPagePoint);
        const { point } = initialInfo;
        const { timestamp } = frameData;
        this.history = [{ ...point, timestamp }];
        const { onSessionStart } = handlers;
        onSessionStart &&
            onSessionStart(event, getPanInfo(initialInfo, this.history));
        this.removeListeners = pipe(addPointerEvent(window, "pointermove", this.handlePointerMove), addPointerEvent(window, "pointerup", this.handlePointerUp), addPointerEvent(window, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        cancelFrame(this.updatePoint);
    }
}
function transformPoint(info, transformPagePoint) {
    return transformPagePoint ? { point: transformPagePoint(info.point) } : info;
}
function subtractPoint(a, b) {
    return { x: a.x - b.x, y: a.y - b.y };
}
function getPanInfo({ point }, history) {
    return {
        point,
        delta: subtractPoint(point, lastDevicePoint(history)),
        offset: subtractPoint(point, startDevicePoint(history)),
        velocity: getVelocity(history, 0.1),
    };
}
function startDevicePoint(history) {
    return history[0];
}
function lastDevicePoint(history) {
    return history[history.length - 1];
}
function getVelocity(history, timeDelta) {
    if (history.length < 2) {
        return { x: 0, y: 0 };
    }
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = lastDevicePoint(history);
    while (i >= 0) {
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp >
            secondsToMilliseconds(timeDelta)) {
            break;
        }
        i--;
    }
    if (!timestampedPoint) {
        return { x: 0, y: 0 };
    }
    const time = millisecondsToSeconds(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) {
        return { x: 0, y: 0 };
    }
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time,
    };
    if (currentVelocity.x === Infinity) {
        currentVelocity.x = 0;
    }
    if (currentVelocity.y === Infinity) {
        currentVelocity.y = 0;
    }
    return currentVelocity;
}

function calcLength(axis) {
    return axis.max - axis.min;
}
function isNear(value, target = 0, maxDistance = 0.01) {
    return Math.abs(value - target) <= maxDistance;
}
function calcAxisDelta(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = mix(source.min, source.max, delta.origin);
    delta.scale = calcLength(target) / calcLength(source);
    if (isNear(delta.scale, 1, 0.0001) || isNaN(delta.scale))
        delta.scale = 1;
    delta.translate =
        mix(target.min, target.max, delta.origin) - delta.originPoint;
    if (isNear(delta.translate) || isNaN(delta.translate))
        delta.translate = 0;
}
function calcBoxDelta(delta, source, target, origin) {
    calcAxisDelta(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    calcAxisDelta(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function calcRelativeAxis(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + calcLength(relative);
}
function calcRelativeBox(target, relative, parent) {
    calcRelativeAxis(target.x, relative.x, parent.x);
    calcRelativeAxis(target.y, relative.y, parent.y);
}
function calcRelativeAxisPosition(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + calcLength(layout);
}
function calcRelativePosition(target, layout, parent) {
    calcRelativeAxisPosition(target.x, layout.x, parent.x);
    calcRelativeAxisPosition(target.y, layout.y, parent.y);
}

/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */
function applyConstraints(point, { min, max }, elastic) {
    if (min !== undefined && point < min) {
        // If we have a min point defined, and this is outside of that, constrain
        point = elastic ? mix(min, point, elastic.min) : Math.max(point, min);
    }
    else if (max !== undefined && point > max) {
        // If we have a max point defined, and this is outside of that, constrain
        point = elastic ? mix(max, point, elastic.max) : Math.min(point, max);
    }
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */
function calcRelativeAxisConstraints(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined
            ? axis.max + max - (axis.max - axis.min)
            : undefined,
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */
function calcRelativeConstraints(layoutBox, { top, left, bottom, right }) {
    return {
        x: calcRelativeAxisConstraints(layoutBox.x, left, right),
        y: calcRelativeAxisConstraints(layoutBox.y, top, bottom),
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */
function calcViewportAxisConstraints(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min <
        layoutAxis.max - layoutAxis.min) {
        [min, max] = [max, min];
    }
    return { min, max };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */
function calcViewportConstraints(layoutBox, constraintsBox) {
    return {
        x: calcViewportAxisConstraints(layoutBox.x, constraintsBox.x),
        y: calcViewportAxisConstraints(layoutBox.y, constraintsBox.y),
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */
function calcOrigin(source, target) {
    let origin = 0.5;
    const sourceLength = calcLength(source);
    const targetLength = calcLength(target);
    if (targetLength > sourceLength) {
        origin = progress(target.min, target.max - sourceLength, source.min);
    }
    else if (sourceLength > targetLength) {
        origin = progress(source.min, source.max - targetLength, target.min);
    }
    return clamp(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */
function rebaseAxisConstraints(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) {
        relativeConstraints.min = constraints.min - layout.min;
    }
    if (constraints.max !== undefined) {
        relativeConstraints.max = constraints.max - layout.min;
    }
    return relativeConstraints;
}
const defaultElastic = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */
function resolveDragElastic(dragElastic = defaultElastic) {
    if (dragElastic === false) {
        dragElastic = 0;
    }
    else if (dragElastic === true) {
        dragElastic = defaultElastic;
    }
    return {
        x: resolveAxisElastic(dragElastic, "left", "right"),
        y: resolveAxisElastic(dragElastic, "top", "bottom"),
    };
}
function resolveAxisElastic(dragElastic, minLabel, maxLabel) {
    return {
        min: resolvePointElastic(dragElastic, minLabel),
        max: resolvePointElastic(dragElastic, maxLabel),
    };
}
function resolvePointElastic(dragElastic, label) {
    return typeof dragElastic === "number"
        ? dragElastic
        : dragElastic[label] || 0;
}

const createAxisDelta = () => ({
    translate: 0,
    scale: 1,
    origin: 0,
    originPoint: 0,
});
const createDelta = () => ({
    x: createAxisDelta(),
    y: createAxisDelta(),
});
const createAxis = () => ({ min: 0, max: 0 });
const createBox = () => ({
    x: createAxis(),
    y: createAxis(),
});

function eachAxis(callback) {
    return [callback("x"), callback("y")];
}

/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */
function convertBoundingBoxToBox({ top, left, right, bottom, }) {
    return {
        x: { min: left, max: right },
        y: { min: top, max: bottom },
    };
}
function convertBoxToBoundingBox({ x, y }) {
    return { top: y.min, right: x.max, bottom: y.max, left: x.min };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */
function transformBoxPoints(point, transformPoint) {
    if (!transformPoint)
        return point;
    const topLeft = transformPoint({ x: point.left, y: point.top });
    const bottomRight = transformPoint({ x: point.right, y: point.bottom });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x,
    };
}

function isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function hasScale({ scale, scaleX, scaleY }) {
    return (!isIdentityScale(scale) ||
        !isIdentityScale(scaleX) ||
        !isIdentityScale(scaleY));
}
function hasTransform(values) {
    return (hasScale(values) ||
        has2DTranslate(values) ||
        values.z ||
        values.rotate ||
        values.rotateX ||
        values.rotateY);
}
function has2DTranslate(values) {
    return is2DTranslate(values.x) || is2DTranslate(values.y);
}
function is2DTranslate(value) {
    return value && value !== "0%";
}

/**
 * Scales a point based on a factor and an originPoint
 */
function scalePoint(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */
function applyPointDelta(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) {
        point = scalePoint(point, boxScale, originPoint);
    }
    return scalePoint(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */
function applyAxisDelta(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = applyPointDelta(axis.min, translate, scale, originPoint, boxScale);
    axis.max = applyPointDelta(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */
function applyBoxDelta(box, { x, y }) {
    applyAxisDelta(box.x, x.translate, x.scale, x.originPoint);
    applyAxisDelta(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */
function applyTreeDeltas(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength)
        return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for (let i = 0; i < treeLength; i++) {
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */
        const instance = node.instance;
        if (instance &&
            instance.style &&
            instance.style.display === "contents") {
            continue;
        }
        if (isSharedTransition &&
            node.options.layoutScroll &&
            node.scroll &&
            node !== node.root) {
            transformBox(box, {
                x: -node.scroll.offset.x,
                y: -node.scroll.offset.y,
            });
        }
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            applyBoxDelta(box, delta);
        }
        if (isSharedTransition && hasTransform(node.latestValues)) {
            transformBox(box, node.latestValues);
        }
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */
    treeScale.x = snapToDefault(treeScale.x);
    treeScale.y = snapToDefault(treeScale.y);
}
function snapToDefault(scale) {
    if (Number.isInteger(scale))
        return scale;
    return scale > 1.0000000000001 || scale < 0.999999999999 ? scale : 1;
}
function translateAxis(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */
function transformAxis(axis, transforms, [key, scaleKey, originKey]) {
    const axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    const originPoint = mix(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    applyAxisDelta(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */
const xKeys$1 = ["x", "scaleX", "originX"];
const yKeys$1 = ["y", "scaleY", "originY"];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */
function transformBox(box, transform) {
    transformAxis(box.x, transform, xKeys$1);
    transformAxis(box.y, transform, yKeys$1);
}

function measureViewportBox(instance, transformPoint) {
    return convertBoundingBoxToBox(transformBoxPoints(instance.getBoundingClientRect(), transformPoint));
}
function measurePageBox(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = measureViewportBox(element, transformPagePoint);
    const { scroll } = rootProjectionNode;
    if (scroll) {
        translateAxis(viewportBox.x, scroll.offset.x);
        translateAxis(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}

const elementDragControls = new WeakMap();
/**
 *
 */
// let latestPointerEvent: PointerEvent
class VisualElementDragControls {
    constructor(visualElement) {
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = { x: 0, y: 0 };
        /**
         * The permitted boundaries of travel, in pixels.
         */
        this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */
        this.elastic = createBox();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */
        const { presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false)
            return;
        const onSessionStart = (event) => {
            // Stop any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            this.stopAnimation();
            if (snapToCursor) {
                this.snapToCursor(extractEventInfo(event, "page").point);
            }
        };
        const onStart = (event, info) => {
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag, dragPropagation, onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openGlobalLock)
                    this.openGlobalLock();
                this.openGlobalLock = getGlobalLock(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openGlobalLock)
                    return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */
            eachAxis((axis) => {
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */
                if (percent.test(current)) {
                    const { projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = calcLength(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) {
                frame.update(() => onDragStart(event, info), false, true);
            }
            const { animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info) => {
            // latestPointerEvent = event
            const { dragPropagation, dragDirectionLock, onDirectionLock, onDrag, } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openGlobalLock)
                return;
            const { offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) {
                    onDirectionLock && onDirectionLock(this.currentDirection);
                }
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */
            this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */
            onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info) => this.stop(event, info);
        this.panSession = new PanSession(originEvent, {
            onSessionStart,
            onStart,
            onMove,
            onSessionEnd,
        }, { transformPagePoint: this.visualElement.getTransformPagePoint() });
    }
    stop(event, info) {
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging)
            return;
        const { velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd } = this.getProps();
        if (onDragEnd) {
            frame.update(() => onDragEnd(event, info));
        }
    }
    cancel() {
        this.isDragging = false;
        const { projection, animationState } = this.visualElement;
        if (projection) {
            projection.isAnimationBlocked = false;
        }
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation } = this.getProps();
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !shouldDrag(axis, drag, this.currentDirection))
            return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) {
            next = applyConstraints(next, this.constraints[axis], this.elastic[axis]);
        }
        axisValue.set(next);
    }
    resolveConstraints() {
        const { dragConstraints, dragElastic } = this.getProps();
        const { layout } = this.visualElement.projection || {};
        const prevConstraints = this.constraints;
        if (dragConstraints && isRefObject(dragConstraints)) {
            if (!this.constraints) {
                this.constraints = this.resolveRefConstraints();
            }
        }
        else {
            if (dragConstraints && layout) {
                this.constraints = calcRelativeConstraints(layout.layoutBox, dragConstraints);
            }
            else {
                this.constraints = false;
            }
        }
        this.elastic = resolveDragElastic(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */
        if (prevConstraints !== this.constraints &&
            layout &&
            this.constraints &&
            !this.hasMutatedConstraints) {
            eachAxis((axis) => {
                if (this.getAxisMotionValue(axis)) {
                    this.constraints[axis] = rebaseAxisConstraints(layout.layoutBox[axis], this.constraints[axis]);
                }
            });
        }
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints } = this.getProps();
        if (!constraints || !isRefObject(constraints))
            return false;
        const constraintsElement = constraints.current;
        invariant(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout)
            return false;
        const constraintsBox = measurePageBox(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = calcViewportConstraints(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */
        if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints(convertBoxToBoundingBox(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) {
                measuredConstraints = convertBoundingBoxToBox(userConstraints);
            }
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag, dragMomentum, dragElastic, dragTransition, dragSnapToOrigin, onDragTransitionEnd, } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = eachAxis((axis) => {
            if (!shouldDrag(axis, drag, this.currentDirection)) {
                return;
            }
            let transition = (constraints && constraints[axis]) || {};
            if (dragSnapToOrigin)
                transition = { min: 0, max: 0 };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */
            const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness,
                bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition,
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        return axisValue.start(animateMotionValue(axis, axisValue, 0, transition));
    }
    stopAnimation() {
        eachAxis((axis) => this.getAxisMotionValue(axis).stop());
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */
    getAxisMotionValue(axis) {
        const dragKey = "_drag" + axis.toUpperCase();
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue
            ? externalMotionValue
            : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        eachAxis((axis) => {
            const { drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!shouldDrag(axis, drag, this.currentDirection))
                return;
            const { projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min, max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - mix(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */
    scalePositionWithinConstraints() {
        if (!this.visualElement.current)
            return;
        const { drag, dragConstraints } = this.getProps();
        const { projection } = this.visualElement;
        if (!isRefObject(dragConstraints) || !projection || !this.constraints)
            return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */
        this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */
        const boxProgress = { x: 0, y: 0 };
        eachAxis((axis) => {
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue) {
                const latest = axisValue.get();
                boxProgress[axis] = calcOrigin({ min: latest, max: latest }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */
        const { transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate
            ? transformTemplate({}, "")
            : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */
        eachAxis((axis) => {
            if (!shouldDrag(axis, drag, null))
                return;
            /**
             * Calculate a new transform based on the previous box progress
             */
            const axisValue = this.getAxisMotionValue(axis);
            const { min, max } = this.constraints[axis];
            axisValue.set(mix(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current)
            return;
        elementDragControls.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */
        const stopPointerListener = addPointerEvent(element, "pointerdown", (event) => {
            const { drag, dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = () => {
            const { dragConstraints } = this.getProps();
            if (isRefObject(dragConstraints)) {
                this.constraints = this.resolveRefConstraints();
            }
        };
        const { projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        measureDragConstraints();
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */
        const stopResizeListener = addDomEvent(window, "resize", () => this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */
        const stopLayoutUpdateListener = projection.addEventListener("didUpdate", (({ delta, hasLayoutChanged }) => {
            if (this.isDragging && hasLayoutChanged) {
                eachAxis((axis) => {
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue)
                        return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        }));
        return () => {
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag = false, dragDirectionLock = false, dragPropagation = false, dragConstraints = false, dragElastic = defaultElastic, dragMomentum = true, } = props;
        return {
            ...props,
            drag,
            dragDirectionLock,
            dragPropagation,
            dragConstraints,
            dragElastic,
            dragMomentum,
        };
    }
}
function shouldDrag(direction, drag, currentDirection) {
    return ((drag === true || drag === direction) &&
        (currentDirection === null || currentDirection === direction));
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */
function getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) {
        direction = "y";
    }
    else if (Math.abs(offset.x) > lockThreshold) {
        direction = "x";
    }
    return direction;
}

class DragGesture extends Feature {
    constructor(node) {
        super(node);
        this.removeGroupControls = noop;
        this.removeListeners = noop;
        this.controls = new VisualElementDragControls(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls } = this.node.getProps();
        if (dragControls) {
            this.removeGroupControls = dragControls.subscribe(this.controls);
        }
        this.removeListeners = this.controls.addListeners() || noop;
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}

const asyncHandler = (handler) => (event, info) => {
    if (handler) {
        frame.update(() => handler(event, info));
    }
};
class PanGesture extends Feature {
    constructor() {
        super(...arguments);
        this.removePointerDownListener = noop;
    }
    onPointerDown(pointerDownEvent) {
        this.session = new PanSession(pointerDownEvent, this.createPanHandlers(), { transformPagePoint: this.node.getTransformPagePoint() });
    }
    createPanHandlers() {
        const { onPanSessionStart, onPanStart, onPan, onPanEnd } = this.node.getProps();
        return {
            onSessionStart: asyncHandler(onPanSessionStart),
            onStart: asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info) => {
                delete this.session;
                if (onPanEnd) {
                    frame.update(() => onPanEnd(event, info));
                }
            },
        };
    }
    mount() {
        this.removePointerDownListener = addPointerEvent(this.node.current, "pointerdown", (event) => this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}

/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */
function usePresence() {
    const context = React.useContext(PresenceContext);
    if (context === null)
        return [true, null];
    const { isPresent, onExitComplete, register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = React.useId();
    React.useEffect(() => register(id), []);
    const safeToRemove = () => onExitComplete && onExitComplete(id);
    return !isPresent && onExitComplete ? [false, safeToRemove] : [true];
}

/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */
const globalProjectionState = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */
    hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */
    hasEverUpdated: false,
};

function pixelsToPercent(pixels, axis) {
    if (axis.max === axis.min)
        return 0;
    return (pixels / (axis.max - axis.min)) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */
const correctBorderRadius = {
    correct: (latest, node) => {
        if (!node.target)
            return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */
        if (typeof latest === "string") {
            if (px.test(latest)) {
                latest = parseFloat(latest);
            }
            else {
                return latest;
            }
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */
        const x = pixelsToPercent(latest, node.target.x);
        const y = pixelsToPercent(latest, node.target.y);
        return `${x}% ${y}%`;
    },
};

const correctBoxShadow = {
    correct: (latest, { treeScale, projectionDelta }) => {
        const original = latest;
        const shadow = complex.parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5)
            return original;
        const template = complex.createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */
        const averageScale = mix(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number")
            shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number")
            shadow[3 + offset] /= averageScale;
        return template(shadow);
    },
};

class MeasureLayoutWithContext extends React__namespace.default.Component {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */
    componentDidMount() {
        const { visualElement, layoutGroup, switchLayoutGroup, layoutId } = this.props;
        const { projection } = visualElement;
        addScaleCorrector(defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group)
                layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) {
                switchLayoutGroup.register(projection);
            }
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", () => {
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: () => this.safeToRemove(),
            });
        }
        globalProjectionState.hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency, visualElement, drag, isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection)
            return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */
        projection.isPresent = isPresent;
        if (drag ||
            prevProps.layoutDependency !== layoutDependency ||
            layoutDependency === undefined) {
            projection.willUpdate();
        }
        else {
            this.safeToRemove();
        }
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) {
                projection.promote();
            }
            else if (!projection.relegate()) {
                /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */
                frame.postRender(() => {
                    const stack = projection.getStack();
                    if (!stack || !stack.members.length) {
                        this.safeToRemove();
                    }
                });
            }
        }
        return null;
    }
    componentDidUpdate() {
        const { projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            queueMicrotask(() => {
                if (!projection.currentAnimation && projection.isLead()) {
                    this.safeToRemove();
                }
            });
        }
    }
    componentWillUnmount() {
        const { visualElement, layoutGroup, switchLayoutGroup: promoteContext, } = this.props;
        const { projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group)
                layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister)
                promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function MeasureLayout(props) {
    const [isPresent, safeToRemove] = usePresence();
    const layoutGroup = React.useContext(LayoutGroupContext);
    return (React__namespace.default.createElement(MeasureLayoutWithContext, { ...props, layoutGroup: layoutGroup, switchLayoutGroup: React.useContext(SwitchLayoutGroupContext), isPresent: isPresent, safeToRemove: safeToRemove }));
}
const defaultScaleCorrectors = {
    borderRadius: {
        ...correctBorderRadius,
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius",
        ],
    },
    borderTopLeftRadius: correctBorderRadius,
    borderTopRightRadius: correctBorderRadius,
    borderBottomLeftRadius: correctBorderRadius,
    borderBottomRightRadius: correctBorderRadius,
    boxShadow: correctBoxShadow,
};

const borders = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"];
const numBorders = borders.length;
const asNumber = (value) => typeof value === "string" ? parseFloat(value) : value;
const isPx = (value) => typeof value === "number" || px.test(value);
function mixValues(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = mix(0, 
        // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, easeCrossfadeIn(progress));
        target.opacityExit = mix(follow.opacity !== undefined ? follow.opacity : 1, 0, easeCrossfadeOut(progress));
    }
    else if (isOnlyMember) {
        target.opacity = mix(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    }
    /**
     * Mix border radius
     */
    for (let i = 0; i < numBorders; i++) {
        const borderLabel = `border${borders[i]}Radius`;
        let followRadius = getRadius(follow, borderLabel);
        let leadRadius = getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined)
            continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 ||
            leadRadius === 0 ||
            isPx(followRadius) === isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max(mix(asNumber(followRadius), asNumber(leadRadius), progress), 0);
            if (percent.test(leadRadius) || percent.test(followRadius)) {
                target[borderLabel] += "%";
            }
        }
        else {
            target[borderLabel] = leadRadius;
        }
    }
    /**
     * Mix rotation
     */
    if (follow.rotate || lead.rotate) {
        target.rotate = mix(follow.rotate || 0, lead.rotate || 0, progress);
    }
}
function getRadius(values, radiusName) {
    return values[radiusName] !== undefined
        ? values[radiusName]
        : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const easeCrossfadeIn = compress(0, 0.5, circOut);
const easeCrossfadeOut = compress(0.5, 0.95, noop);
function compress(min, max, easing) {
    return (p) => {
        // Could replace ifs with clamp
        if (p < min)
            return 0;
        if (p > max)
            return 1;
        return easing(progress(min, max, p));
    };
}

/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */
function copyAxisInto(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */
function copyBoxInto(box, originBox) {
    copyAxisInto(box.x, originBox.x);
    copyAxisInto(box.y, originBox.y);
}

/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */
function removePointDelta(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = scalePoint(point, 1 / scale, originPoint);
    if (boxScale !== undefined) {
        point = scalePoint(point, 1 / boxScale, originPoint);
    }
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */
function removeAxisDelta(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if (percent.test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = mix(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number")
        return;
    let originPoint = mix(originAxis.min, originAxis.max, origin);
    if (axis === originAxis)
        originPoint -= translate;
    axis.min = removePointDelta(axis.min, translate, scale, originPoint, boxScale);
    axis.max = removePointDelta(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */
function removeAxisTransforms(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    removeAxisDelta(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */
const xKeys = ["x", "scaleX", "originX"];
const yKeys = ["y", "scaleY", "originY"];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */
function removeBoxTransforms(box, transforms, originBox, sourceBox) {
    removeAxisTransforms(box.x, transforms, xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    removeAxisTransforms(box.y, transforms, yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}

function isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function isDeltaZero(delta) {
    return isAxisDeltaZero(delta.x) && isAxisDeltaZero(delta.y);
}
function boxEquals(a, b) {
    return (a.x.min === b.x.min &&
        a.x.max === b.x.max &&
        a.y.min === b.y.min &&
        a.y.max === b.y.max);
}
function boxEqualsRounded(a, b) {
    return (Math.round(a.x.min) === Math.round(b.x.min) &&
        Math.round(a.x.max) === Math.round(b.x.max) &&
        Math.round(a.y.min) === Math.round(b.y.min) &&
        Math.round(a.y.max) === Math.round(b.y.max));
}
function aspectRatio(box) {
    return calcLength(box.x) / calcLength(box.y);
}

class NodeStack {
    constructor() {
        this.members = [];
    }
    add(node) {
        addUniqueItem(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        removeItem(this.members, node);
        if (node === this.prevLead) {
            this.prevLead = undefined;
        }
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) {
                this.promote(prevLead);
            }
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member) => node === member);
        if (indexOfNode === 0)
            return false;
        /**
         * Find the next projection node that is present
         */
        let prevLead;
        for (let i = indexOfNode; i >= 0; i--) {
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        }
        else {
            return false;
        }
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead)
            return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) {
                node.resumeFrom.preserveOpacity = true;
            }
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues =
                    prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) {
                node.isLayoutDirty = true;
            }
            const { crossfade } = node.options;
            if (crossfade === false) {
                prevLead.hide();
            }
            /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */
        }
    }
    exitAnimationComplete() {
        this.members.forEach((node) => {
            const { options, resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) {
                resumingFrom.options.onExitComplete &&
                    resumingFrom.options.onExitComplete();
            }
        });
    }
    scheduleRender() {
        this.members.forEach((node) => {
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */
    removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) {
            this.lead.snapshot = undefined;
        }
    }
}

function buildProjectionTransform(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */
    const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    if (xTranslate || yTranslate) {
        transform = `translate3d(${xTranslate}px, ${yTranslate}px, 0) `;
    }
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */
    if (treeScale.x !== 1 || treeScale.y !== 1) {
        transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    }
    if (latestTransform) {
        const { rotate, rotateX, rotateY } = latestTransform;
        if (rotate)
            transform += `rotate(${rotate}deg) `;
        if (rotateX)
            transform += `rotateX(${rotateX}deg) `;
        if (rotateY)
            transform += `rotateY(${rotateY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */
    const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) {
        transform += `scale(${elementScaleX}, ${elementScaleY})`;
    }
    return transform || "none";
}

const compareByDepth = (a, b) => a.depth - b.depth;

class FlatTree {
    constructor() {
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        addUniqueItem(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        removeItem(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort(compareByDepth);
        this.isDirty = false;
        this.children.forEach(callback);
    }
}

/**
 * Timeout defined in ms
 */
function delay(callback, timeout) {
    const start = performance.now();
    const checkElapsed = ({ timestamp }) => {
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            cancelFrame(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    frame.read(checkElapsed, true);
    return () => cancelFrame(checkElapsed);
}

function record(data) {
    if (window.MotionDebug) {
        window.MotionDebug.record(data);
    }
}

function isSVGElement(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}

function animateSingleValue(value, keyframes, options) {
    const motionValue$1 = isMotionValue(value) ? value : motionValue(value);
    motionValue$1.start(animateMotionValue("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}

const transformAxes = ["", "X", "Y", "Z"];
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */
const animationTarget = 1000;
let id = 0;
/**
 * Use a mutable data object for debug data so as to not create a new
 * object every frame.
 */
const projectionFrameData = {
    type: "projectionFrame",
    totalNodes: 0,
    resolvedTargetDeltas: 0,
    recalculatedProjection: 0,
};
function createProjectionNode({ attachResizeListener, defaultParent, measureScroll, checkIsScrollRoot, resetTransform, }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()) {
            /**
             * A unique ID generated for every projection node.
             */
            this.id = id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */
            this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */
            this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */
            this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */
            this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */
            this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */
            this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */
            this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */
            this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */
            this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */
            this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */
            this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */
            this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */
            this.shouldResetTransform = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */
            this.treeScale = { x: 1, y: 1 };
            /**
             *
             */
            this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.checkUpdateFailed = () => {
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */
            this.updateProjection = () => {
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */
                projectionFrameData.totalNodes =
                    projectionFrameData.resolvedTargetDeltas =
                        projectionFrameData.recalculatedProjection =
                            0;
                this.nodes.forEach(propagateDirtyNodes);
                this.nodes.forEach(resolveTargetDelta);
                this.nodes.forEach(calcProjection);
                this.nodes.forEach(cleanDirtyNodes);
                record(projectionFrameData);
            };
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */
            // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [...parent.path, parent] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for (let i = 0; i < this.path.length; i++) {
                this.path[i].shouldResetTransform = true;
            }
            if (this.root === this)
                this.nodes = new FlatTree();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) {
                this.eventHandlers.set(name, new SubscriptionManager());
            }
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */
        mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
            if (this.instance)
                return;
            this.isSVG = isSVGElement(instance);
            this.instance = instance;
            const { layoutId, layout, visualElement } = this.options;
            if (visualElement && !visualElement.current) {
                visualElement.mount(instance);
            }
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (isLayoutDirty && (layout || layoutId)) {
                this.isLayoutDirty = true;
            }
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = () => (this.root.updateBlockedByResize = false);
                attachResizeListener(instance, () => {
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = delay(resizeUnblockUpdate, 250);
                    if (globalProjectionState.hasAnimatedSinceResize) {
                        globalProjectionState.hasAnimatedSinceResize = false;
                        this.nodes.forEach(finishAnimation);
                    }
                });
            }
            if (layoutId) {
                this.root.registerSharedNode(layoutId, this);
            }
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false &&
                visualElement &&
                (layoutId || layout)) {
                this.addEventListener("didUpdate", ({ delta, hasLayoutChanged, hasRelativeTargetChanged, layout: newLayout, }) => {
                    if (this.isTreeAnimationBlocked()) {
                        this.target = undefined;
                        this.relativeTarget = undefined;
                        return;
                    }
                    // TODO: Check here if an animation exists
                    const layoutTransition = this.options.transition ||
                        visualElement.getDefaultTransition() ||
                        defaultLayoutTransition;
                    const { onLayoutAnimationStart, onLayoutAnimationComplete, } = visualElement.getProps();
                    /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */
                    const targetChanged = !this.targetLayout ||
                        !boxEqualsRounded(this.targetLayout, newLayout) ||
                        hasRelativeTargetChanged;
                    /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */
                    const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                    if (this.options.layoutRoot ||
                        (this.resumeFrom && this.resumeFrom.instance) ||
                        hasOnlyRelativeTargetChanged ||
                        (hasLayoutChanged &&
                            (targetChanged || !this.currentAnimation))) {
                        if (this.resumeFrom) {
                            this.resumingFrom = this.resumeFrom;
                            this.resumingFrom.resumingFrom = undefined;
                        }
                        this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                        const animationOptions = {
                            ...getValueTransition(layoutTransition, "layout"),
                            onPlay: onLayoutAnimationStart,
                            onComplete: onLayoutAnimationComplete,
                        };
                        if (visualElement.shouldReduceMotion ||
                            this.options.layoutRoot) {
                            animationOptions.delay = 0;
                            animationOptions.type = false;
                        }
                        this.startAnimation(animationOptions);
                    }
                    else {
                        /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */
                        if (!hasLayoutChanged) {
                            finishAnimation(this);
                        }
                        if (this.isLead() && this.options.onExitComplete) {
                            this.options.onExitComplete();
                        }
                    }
                    this.targetLayout = newLayout;
                });
            }
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            cancelFrame(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return (this.isAnimationBlocked ||
                (this.parent && this.parent.isTreeAnimationBlocked()) ||
                false);
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked())
                return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach(resetRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty)
                return;
            this.isLayoutDirty = true;
            for (let i = 0; i < this.path.length; i++) {
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) {
                    node.willUpdate(false);
                }
            }
            const { layoutId, layout } = this.options;
            if (layoutId === undefined && !layout)
                return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate
                ? transformTemplate(this.latestValues, "")
                : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach(clearMeasurements);
                return;
            }
            if (!this.isUpdating) {
                this.nodes.forEach(clearIsLayoutDirty);
            }
            this.isUpdating = false;
            /**
             * Write
             */
            this.nodes.forEach(resetTransformStyle);
            /**
             * Read ==================
             */
            // Update layout measurements of updated children
            this.nodes.forEach(updateLayout);
            /**
             * Write
             */
            // Notify listeners that the layout is updated
            this.nodes.forEach(notifyLayoutUpdate);
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */
            const now = performance.now();
            frameData.delta = clamp(0, 1000 / 60, now - frameData.timestamp);
            frameData.timestamp = now;
            frameData.isProcessing = true;
            steps.update.process(frameData);
            steps.preRender.process(frameData);
            steps.render.process(frameData);
            frameData.isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                queueMicrotask(() => this.update());
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach(clearSnapshot);
            this.sharedNodes.forEach(removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            frame.preRender(this.updateProjection, false, true);
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */
            frame.postRender(() => {
                if (this.isLayoutDirty) {
                    this.root.didUpdate();
                }
                else {
                    this.root.checkUpdateFailed();
                }
            });
        }
        /**
         * Update measurements
         */
        updateSnapshot() {
            if (this.snapshot || !this.instance)
                return;
            this.snapshot = this.measure();
        }
        updateLayout() {
            if (!this.instance)
                return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) &&
                !this.isLayoutDirty) {
                return;
            }
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */
            if (this.resumeFrom && !this.resumeFrom.instance) {
                for (let i = 0; i < this.path.length; i++) {
                    const node = this.path[i];
                    node.updateScroll();
                }
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = createBox();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement } = this.options;
            visualElement &&
                visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll &&
                this.scroll.animationId === this.root.animationId &&
                this.scroll.phase === phase) {
                needsMeasurement = false;
            }
            if (needsMeasurement) {
                this.scroll = {
                    animationId: this.root.animationId,
                    phase,
                    isRoot: checkIsScrollRoot(this.instance),
                    offset: measureScroll(this.instance),
                };
            }
        }
        resetTransform() {
            if (!resetTransform)
                return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
            const hasProjection = this.projectionDelta && !isDeltaZero(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate
                ? transformTemplate(this.latestValues, "")
                : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested &&
                (hasProjection ||
                    hasTransform(this.latestValues) ||
                    transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */
            if (removeTransform) {
                layoutBox = this.removeTransform(layoutBox);
            }
            roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox,
                latestValues: {},
                source: this.id,
            };
        }
        measurePageBox() {
            const { visualElement } = this.options;
            if (!visualElement)
                return createBox();
            const box = visualElement.measureViewportBox();
            // Remove viewport scroll to give page-relative coordinates
            const { scroll } = this.root;
            if (scroll) {
                translateAxis(box.x, scroll.offset.x);
                translateAxis(box.y, scroll.offset.y);
            }
            return box;
        }
        removeElementScroll(box) {
            const boxWithoutScroll = createBox();
            copyBoxInto(boxWithoutScroll, box);
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */
            for (let i = 0; i < this.path.length; i++) {
                const node = this.path[i];
                const { scroll, options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */
                    if (scroll.isRoot) {
                        copyBoxInto(boxWithoutScroll, box);
                        const { scroll: rootScroll } = this.root;
                        /**
                         * Undo the application of page scroll that was originally added
                         * to the measured bounding box.
                         */
                        if (rootScroll) {
                            translateAxis(boxWithoutScroll.x, -rootScroll.offset.x);
                            translateAxis(boxWithoutScroll.y, -rootScroll.offset.y);
                        }
                    }
                    translateAxis(boxWithoutScroll.x, scroll.offset.x);
                    translateAxis(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = createBox();
            copyBoxInto(withTransforms, box);
            for (let i = 0; i < this.path.length; i++) {
                const node = this.path[i];
                if (!transformOnly &&
                    node.options.layoutScroll &&
                    node.scroll &&
                    node !== node.root) {
                    transformBox(withTransforms, {
                        x: -node.scroll.offset.x,
                        y: -node.scroll.offset.y,
                    });
                }
                if (!hasTransform(node.latestValues))
                    continue;
                transformBox(withTransforms, node.latestValues);
            }
            if (hasTransform(this.latestValues)) {
                transformBox(withTransforms, this.latestValues);
            }
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = createBox();
            copyBoxInto(boxWithoutTransform, box);
            for (let i = 0; i < this.path.length; i++) {
                const node = this.path[i];
                if (!node.instance)
                    continue;
                if (!hasTransform(node.latestValues))
                    continue;
                hasScale(node.latestValues) && node.updateSnapshot();
                const sourceBox = createBox();
                const nodeBox = node.measurePageBox();
                copyBoxInto(sourceBox, nodeBox);
                removeBoxTransforms(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if (hasTransform(this.latestValues)) {
                removeBoxTransforms(boxWithoutTransform, this.latestValues);
            }
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true,
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent)
                return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */
            if (this.relativeParent.resolvedRelativeTargetAt !==
                frameData.timestamp) {
                this.relativeParent.resolveTargetDelta(true);
            }
        }
        resolveTargetDelta(forceRecalculation = false) {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */
            const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */
            const canSkip = !(forceRecalculation ||
                (isShared && this.isSharedProjectionDirty) ||
                this.isProjectionDirty ||
                ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) ||
                this.attemptToResolveRelativeTarget);
            if (canSkip)
                return;
            const { layout, layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */
            if (!this.layout || !(layout || layoutId))
                return;
            this.resolvedRelativeTargetAt = frameData.timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */
            // TODO If this is unsuccessful this currently happens every frame
            if (!this.targetDelta && !this.relativeTarget) {
                // TODO: This is a semi-repetition of further down this function, make DRY
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent &&
                    relativeParent.layout &&
                    this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = createBox();
                    this.relativeTargetOrigin = createBox();
                    calcRelativePosition(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    copyBoxInto(this.relativeTarget, this.relativeTargetOrigin);
                }
                else {
                    this.relativeParent = this.relativeTarget = undefined;
                }
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */
            if (!this.relativeTarget && !this.targetDelta)
                return;
            /**
             * Lazy-init target data structure
             */
            if (!this.target) {
                this.target = createBox();
                this.targetWithTransforms = createBox();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */
            if (this.relativeTarget &&
                this.relativeTargetOrigin &&
                this.relativeParent &&
                this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                calcRelativeBox(this.target, this.relativeTarget, this.relativeParent.target);
                /**
                 * If we've only got a targetDelta, resolve it into a target
                 */
            }
            else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) {
                    // TODO: This is creating a new object every frame
                    this.target = this.applyTransform(this.layout.layoutBox);
                }
                else {
                    copyBoxInto(this.target, this.layout.layoutBox);
                }
                applyBoxDelta(this.target, this.targetDelta);
            }
            else {
                /**
                 * If no target, use own layout as target
                 */
                copyBoxInto(this.target, this.layout.layoutBox);
            }
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */
            if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent &&
                    Boolean(relativeParent.resumingFrom) ===
                        Boolean(this.resumingFrom) &&
                    !relativeParent.options.layoutScroll &&
                    relativeParent.target &&
                    this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = createBox();
                    this.relativeTargetOrigin = createBox();
                    calcRelativePosition(this.relativeTargetOrigin, this.target, relativeParent.target);
                    copyBoxInto(this.relativeTarget, this.relativeTargetOrigin);
                }
                else {
                    this.relativeParent = this.relativeTarget = undefined;
                }
            }
            /**
             * Increase debug counter for resolved target deltas
             */
            projectionFrameData.resolvedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent ||
                hasScale(this.parent.latestValues) ||
                has2DTranslate(this.parent.latestValues)) {
                return undefined;
            }
            if (this.parent.isProjecting()) {
                return this.parent;
            }
            else {
                return this.parent.getClosestProjectingParent();
            }
        }
        isProjecting() {
            return Boolean((this.relativeTarget ||
                this.targetDelta ||
                this.options.layoutRoot) &&
                this.layout);
        }
        calcProjection() {
            var _a;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */
            if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) {
                canSkip = false;
            }
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */
            if (isShared &&
                (this.isSharedProjectionDirty || this.isTransformDirty)) {
                canSkip = false;
            }
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */
            if (this.resolvedRelativeTargetAt === frameData.timestamp) {
                canSkip = false;
            }
            if (canSkip)
                return;
            const { layout, layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */
            this.isTreeAnimating = Boolean((this.parent && this.parent.isTreeAnimating) ||
                this.currentAnimation ||
                this.pendingAnimation);
            if (!this.isTreeAnimating) {
                this.targetDelta = this.relativeTarget = undefined;
            }
            if (!this.layout || !(layout || layoutId))
                return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */
            copyBoxInto(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */
            const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */
            applyTreeDeltas(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */
            if (lead.layout &&
                !lead.target &&
                (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                lead.target = lead.layout.layoutBox;
            }
            const { target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */
                if (this.projectionTransform) {
                    this.projectionDelta = createDelta();
                    this.projectionTransform = "none";
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta) {
                this.projectionDelta = createDelta();
                this.projectionDeltaWithTransform = createDelta();
            }
            const prevProjectionTransform = this.projectionTransform;
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */
            calcBoxDelta(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            this.projectionTransform = buildProjectionTransform(this.projectionDelta, this.treeScale);
            if (this.projectionTransform !== prevProjectionTransform ||
                this.treeScale.x !== prevTreeScaleX ||
                this.treeScale.y !== prevTreeScaleY) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */
            projectionFrameData.recalculatedProjection++;
        }
        hide() {
            this.isVisible = false;
            // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
            // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            this.options.scheduleRender && this.options.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) {
                this.resumingFrom = undefined;
            }
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot
                ? snapshot.latestValues
                : {};
            const mixedValues = { ...this.latestValues };
            const targetDelta = createDelta();
            if (!this.relativeParent ||
                !this.relativeParent.options.layoutRoot) {
                this.relativeTarget = this.relativeTargetOrigin = undefined;
            }
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = createBox();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation &&
                !isOnlyMember &&
                this.options.crossfade === true &&
                !this.path.some(hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest) => {
                const progress = latest / 1000;
                mixAxisDelta(targetDelta.x, delta.x, progress);
                mixAxisDelta(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget &&
                    this.relativeTargetOrigin &&
                    this.layout &&
                    this.relativeParent &&
                    this.relativeParent.layout) {
                    calcRelativePosition(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    mixBox(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */
                    if (prevRelativeTarget &&
                        boxEquals(this.relativeTarget, prevRelativeTarget)) {
                        this.isProjectionDirty = false;
                    }
                    if (!prevRelativeTarget)
                        prevRelativeTarget = createBox();
                    copyBoxInto(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    mixValues(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation && this.currentAnimation.stop();
            if (this.resumingFrom && this.resumingFrom.currentAnimation) {
                this.resumingFrom.currentAnimation.stop();
            }
            if (this.pendingAnimation) {
                cancelFrame(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */
            this.pendingAnimation = frame.update(() => {
                globalProjectionState.hasAnimatedSinceResize = true;
                this.currentAnimation = animateSingleValue(0, animationTarget, {
                    ...options,
                    onUpdate: (latest) => {
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onComplete: () => {
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    },
                });
                if (this.resumingFrom) {
                    this.resumingFrom.currentAnimation = this.currentAnimation;
                }
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom =
                this.currentAnimation =
                    this.animationValues =
                        undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta(animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms, target, layout, latestValues } = lead;
            if (!targetWithTransforms || !target || !layout)
                return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */
            if (this !== lead &&
                this.layout &&
                layout &&
                shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || createBox();
                const xLength = calcLength(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = calcLength(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            copyBoxInto(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */
            transformBox(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */
            calcBoxDelta(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) {
                this.sharedNodes.set(layoutId, new NodeStack());
            }
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity
                    ? config.shouldPreserveFollowOpacity(node)
                    : undefined,
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId } = this.options;
            if (layoutId)
                return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset, transition, preserveFollowOpacity, } = {}) {
            const stack = this.getStack();
            if (stack)
                stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition)
                this.setOptions({ transition });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) {
                return stack.relegate(this);
            }
            else {
                return false;
            }
        }
        resetRotation() {
            const { visualElement } = this.options;
            if (!visualElement)
                return;
            // If there's no detected rotation values, we can early return without a forced render.
            let hasRotate = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */
            const { latestValues } = visualElement;
            if (latestValues.rotate ||
                latestValues.rotateX ||
                latestValues.rotateY ||
                latestValues.rotateZ) {
                hasRotate = true;
            }
            // If there's no rotation values, we don't need to do any more.
            if (!hasRotate)
                return;
            const resetValues = {};
            // Check the rotate value of all axes and reset to 0
            for (let i = 0; i < transformAxes.length; i++) {
                const key = "rotate" + transformAxes[i];
                // Record the rotation and then temporarily set it to 0
                if (latestValues[key]) {
                    resetValues[key] = latestValues[key];
                    visualElement.setStaticValue(key, 0);
                }
            }
            // Force a render of this element to apply the transform with all rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for (const key in resetValues) {
                visualElement.setStaticValue(key, resetValues[key]);
            }
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp = {}) {
            var _a, _b;
            // TODO: Return lifecycle-persistent object
            const styles = {};
            if (!this.instance || this.isSVG)
                return styles;
            if (!this.isVisible) {
                return { visibility: "hidden" };
            }
            else {
                styles.visibility = "";
            }
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents =
                    resolveMotionValue(styleProp.pointerEvents) || "";
                styles.transform = transformTemplate
                    ? transformTemplate(this.latestValues, "")
                    : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity =
                        this.latestValues.opacity !== undefined
                            ? this.latestValues.opacity
                            : 1;
                    emptyStyles.pointerEvents =
                        resolveMotionValue(styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !hasTransform(this.latestValues)) {
                    emptyStyles.transform = transformTemplate
                        ? transformTemplate({}, "")
                        : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = buildProjectionTransform(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) {
                styles.transform = transformTemplate(valuesToRender, styles.transform);
            }
            const { x, y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) {
                /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */
                styles.opacity =
                    lead === this
                        ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1
                        : this.preserveOpacity
                            ? this.latestValues.opacity
                            : valuesToRender.opacityExit;
            }
            else {
                /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */
                styles.opacity =
                    lead === this
                        ? valuesToRender.opacity !== undefined
                            ? valuesToRender.opacity
                            : ""
                        : valuesToRender.opacityExit !== undefined
                            ? valuesToRender.opacityExit
                            : 0;
            }
            /**
             * Apply scale correction
             */
            for (const key in scaleCorrectors) {
                if (valuesToRender[key] === undefined)
                    continue;
                const { correct, applyTo } = scaleCorrectors[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */
                const corrected = styles.transform === "none"
                    ? valuesToRender[key]
                    : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for (let i = 0; i < num; i++) {
                        styles[applyTo[i]] = corrected;
                    }
                }
                else {
                    styles[key] = corrected;
                }
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */
            if (this.options.layoutId) {
                styles.pointerEvents =
                    lead === this
                        ? resolveMotionValue(styleProp.pointerEvents) || ""
                        : "none";
            }
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node) => { var _a; return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop(); });
            this.root.nodes.forEach(clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function updateLayout(node) {
    node.updateLayout();
}
function notifyLayoutUpdate(node) {
    var _a;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() &&
        node.layout &&
        snapshot &&
        node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") {
            eachAxis((axis) => {
                const axisSnapshot = isShared
                    ? snapshot.measuredBox[axis]
                    : snapshot.layoutBox[axis];
                const length = calcLength(axisSnapshot);
                axisSnapshot.min = layout[axis].min;
                axisSnapshot.max = axisSnapshot.min + length;
            });
        }
        else if (shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) {
            eachAxis((axis) => {
                const axisSnapshot = isShared
                    ? snapshot.measuredBox[axis]
                    : snapshot.layoutBox[axis];
                const length = calcLength(layout[axis]);
                axisSnapshot.max = axisSnapshot.min + length;
                /**
                 * Ensure relative target gets resized and rerendererd
                 */
                if (node.relativeTarget && !node.currentAnimation) {
                    node.isProjectionDirty = true;
                    node.relativeTarget[axis].max =
                        node.relativeTarget[axis].min + length;
                }
            });
        }
        const layoutDelta = createDelta();
        calcBoxDelta(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = createDelta();
        if (isShared) {
            calcBoxDelta(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        }
        else {
            calcBoxDelta(visualDelta, layout, snapshot.layoutBox);
        }
        const hasLayoutChanged = !isDeltaZero(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */
            if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = createBox();
                    calcRelativePosition(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = createBox();
                    calcRelativePosition(relativeLayout, layout, parentLayout.layoutBox);
                    if (!boxEqualsRounded(relativeSnapshot, relativeLayout)) {
                        hasRelativeTargetChanged = true;
                    }
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout,
            snapshot,
            delta: visualDelta,
            layoutDelta,
            hasLayoutChanged,
            hasRelativeTargetChanged,
        });
    }
    else if (node.isLead()) {
        const { onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */
    node.options.transition = undefined;
}
function propagateDirtyNodes(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */
    projectionFrameData.totalNodes++;
    if (!node.parent)
        return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */
    if (!node.isProjecting()) {
        node.isProjectionDirty = node.parent.isProjectionDirty;
    }
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */
    node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty ||
        node.parent.isProjectionDirty ||
        node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function cleanDirtyNodes(node) {
    node.isProjectionDirty =
        node.isSharedProjectionDirty =
            node.isTransformDirty =
                false;
}
function clearSnapshot(node) {
    node.clearSnapshot();
}
function clearMeasurements(node) {
    node.clearMeasurements();
}
function clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function resetTransformStyle(node) {
    const { visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) {
        visualElement.notify("BeforeLayoutMeasure");
    }
    node.resetTransform();
}
function finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function calcProjection(node) {
    node.calcProjection();
}
function resetRotation(node) {
    node.resetRotation();
}
function removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function mixAxisDelta(output, delta, p) {
    output.translate = mix(delta.translate, 0, p);
    output.scale = mix(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function mixAxis(output, from, to, p) {
    output.min = mix(from.min, to.min, p);
    output.max = mix(from.max, to.max, p);
}
function mixBox(output, from, to, p) {
    mixAxis(output.x, from.x, to.x, p);
    mixAxis(output.y, from.y, to.y, p);
}
function hasOpacityCrossfade(node) {
    return (node.animationValues && node.animationValues.opacityExit !== undefined);
}
const defaultLayoutTransition = {
    duration: 0.45,
    ease: [0.4, 0, 0.1, 1],
};
const userAgentContains = (string) => typeof navigator !== "undefined" &&
    navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */
const roundPoint = userAgentContains("applewebkit/") && !userAgentContains("chrome/")
    ? Math.round
    : noop;
function roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = roundPoint(axis.min);
    axis.max = roundPoint(axis.max);
}
function roundBox(box) {
    roundAxis(box.x);
    roundAxis(box.y);
}
function shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return (animationType === "position" ||
        (animationType === "preserve-aspect" &&
            !isNear(aspectRatio(snapshot), aspectRatio(layout), 0.2)));
}

const DocumentProjectionNode = createProjectionNode({
    attachResizeListener: (ref, notify) => addDomEvent(ref, "resize", notify),
    measureScroll: () => ({
        x: document.documentElement.scrollLeft || document.body.scrollLeft,
        y: document.documentElement.scrollTop || document.body.scrollTop,
    }),
    checkIsScrollRoot: () => true,
});

const rootProjectionNode = {
    current: undefined,
};
const HTMLProjectionNode = createProjectionNode({
    measureScroll: (instance) => ({
        x: instance.scrollLeft,
        y: instance.scrollTop,
    }),
    defaultParent: () => {
        if (!rootProjectionNode.current) {
            const documentNode = new DocumentProjectionNode({});
            documentNode.mount(window);
            documentNode.setOptions({ layoutScroll: true });
            rootProjectionNode.current = documentNode;
        }
        return rootProjectionNode.current;
    },
    resetTransform: (instance, value) => {
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance) => Boolean(window.getComputedStyle(instance).position === "fixed"),
});

const drag = {
    pan: {
        Feature: PanGesture,
    },
    drag: {
        Feature: DragGesture,
        ProjectionNode: HTMLProjectionNode,
        MeasureLayout,
    },
};

/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */
const splitCSSVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function parseCSSVariable(current) {
    const match = splitCSSVariableRegex.exec(current);
    if (!match)
        return [,];
    const [, token, fallback] = match;
    return [token, fallback];
}
const maxDepth = 4;
function getVariableValue(current, element, depth = 1) {
    invariant(depth <= maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = parseCSSVariable(current);
    // No CSS variable detected
    if (!token)
        return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return isNumericalString(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    else if (isCSSVariableToken(fallback)) {
        // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
        return getVariableValue(fallback, element, depth + 1);
    }
    else {
        return fallback;
    }
}
/**
 * Resolve CSS variables from
 *
 * @internal
 */
function resolveCSSVariables(visualElement, { ...target }, transitionEnd) {
    const element = visualElement.current;
    if (!(element instanceof Element))
        return { target, transitionEnd };
    // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
    // only if they change but I think this reads clearer and this isn't a performance-critical path.
    if (transitionEnd) {
        transitionEnd = { ...transitionEnd };
    }
    // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
    visualElement.values.forEach((value) => {
        const current = value.get();
        if (!isCSSVariableToken(current))
            return;
        const resolved = getVariableValue(current, element);
        if (resolved)
            value.set(resolved);
    });
    // Cycle through every target property and resolve CSS variables. Currently
    // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
    for (const key in target) {
        const current = target[key];
        if (!isCSSVariableToken(current))
            continue;
        const resolved = getVariableValue(current, element);
        if (!resolved)
            continue;
        // Clone target if it hasn't already been
        target[key] = resolved;
        if (!transitionEnd)
            transitionEnd = {};
        // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
        // CSS variable. This will ensure that after the animation the component will reflect
        // changes in the value of the CSS variable.
        if (transitionEnd[key] === undefined) {
            transitionEnd[key] = current;
        }
    }
    return { target, transitionEnd };
}

const positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
    "translateX",
    "translateY",
]);
const isPositionalKey = (key) => positionalKeys.has(key);
const hasPositionalKey = (target) => {
    return Object.keys(target).some(isPositionalKey);
};
const isNumOrPxType = (v) => v === number || v === px;
const getPosFromMatrix = (matrix, pos) => parseFloat(matrix.split(", ")[pos]);
const getTranslateFromMatrix = (pos2, pos3) => (_bbox, { transform }) => {
    if (transform === "none" || !transform)
        return 0;
    const matrix3d = transform.match(/^matrix3d\((.+)\)$/);
    if (matrix3d) {
        return getPosFromMatrix(matrix3d[1], pos3);
    }
    else {
        const matrix = transform.match(/^matrix\((.+)\)$/);
        if (matrix) {
            return getPosFromMatrix(matrix[1], pos2);
        }
        else {
            return 0;
        }
    }
};
const transformKeys = new Set(["x", "y", "z"]);
const nonTranslationalTransformKeys = transformPropOrder.filter((key) => !transformKeys.has(key));
function removeNonTranslationalTransform(visualElement) {
    const removedTransforms = [];
    nonTranslationalTransformKeys.forEach((key) => {
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([key, value.get()]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    // Apply changes to element before measurement
    if (removedTransforms.length)
        visualElement.render();
    return removedTransforms;
}
const positionalValues = {
    // Dimensions
    width: ({ x }, { paddingLeft = "0", paddingRight = "0" }) => x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y }, { paddingTop = "0", paddingBottom = "0" }) => y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top }) => parseFloat(top),
    left: (_bbox, { left }) => parseFloat(left),
    bottom: ({ y }, { top }) => parseFloat(top) + (y.max - y.min),
    right: ({ x }, { left }) => parseFloat(left) + (x.max - x.min),
    // Transform
    x: getTranslateFromMatrix(4, 13),
    y: getTranslateFromMatrix(5, 14),
};
// Alias translate longform names
positionalValues.translateX = positionalValues.x;
positionalValues.translateY = positionalValues.y;
const convertChangedValueTypes = (target, visualElement, changedKeys) => {
    const originBbox = visualElement.measureViewportBox();
    const element = visualElement.current;
    const elementComputedStyle = getComputedStyle(element);
    const { display } = elementComputedStyle;
    const origin = {};
    // If the element is currently set to display: "none", make it visible before
    // measuring the target bounding box
    if (display === "none") {
        visualElement.setStaticValue("display", target.display || "block");
    }
    /**
     * Record origins before we render and update styles
     */
    changedKeys.forEach((key) => {
        origin[key] = positionalValues[key](originBbox, elementComputedStyle);
    });
    // Apply the latest values (as set in checkAndConvertChangedValueTypes)
    visualElement.render();
    const targetBbox = visualElement.measureViewportBox();
    changedKeys.forEach((key) => {
        // Restore styles to their **calculated computed style**, not their actual
        // originally set style. This allows us to animate between equivalent pixel units.
        const value = visualElement.getValue(key);
        value && value.jump(origin[key]);
        target[key] = positionalValues[key](targetBbox, elementComputedStyle);
    });
    return target;
};
const checkAndConvertChangedValueTypes = (visualElement, target, origin = {}, transitionEnd = {}) => {
    target = { ...target };
    transitionEnd = { ...transitionEnd };
    const targetPositionalKeys = Object.keys(target).filter(isPositionalKey);
    // We want to remove any transform values that could affect the element's bounding box before
    // it's measured. We'll reapply these later.
    let removedTransformValues = [];
    let hasAttemptedToRemoveTransformValues = false;
    const changedValueTypeKeys = [];
    targetPositionalKeys.forEach((key) => {
        const value = visualElement.getValue(key);
        if (!visualElement.hasValue(key))
            return;
        let from = origin[key];
        let fromType = findDimensionValueType(from);
        const to = target[key];
        let toType;
        // TODO: The current implementation of this basically throws an error
        // if you try and do value conversion via keyframes. There's probably
        // a way of doing this but the performance implications would need greater scrutiny,
        // as it'd be doing multiple resize-remeasure operations.
        if (isKeyframesTarget(to)) {
            const numKeyframes = to.length;
            const fromIndex = to[0] === null ? 1 : 0;
            from = to[fromIndex];
            fromType = findDimensionValueType(from);
            for (let i = fromIndex; i < numKeyframes; i++) {
                /**
                 * Don't allow wildcard keyframes to be used to detect
                 * a difference in value types.
                 */
                if (to[i] === null)
                    break;
                if (!toType) {
                    toType = findDimensionValueType(to[i]);
                    invariant(toType === fromType ||
                        (isNumOrPxType(fromType) && isNumOrPxType(toType)), "Keyframes must be of the same dimension as the current value");
                }
                else {
                    invariant(findDimensionValueType(to[i]) === toType, "All keyframes must be of the same type");
                }
            }
        }
        else {
            toType = findDimensionValueType(to);
        }
        if (fromType !== toType) {
            // If they're both just number or px, convert them both to numbers rather than
            // relying on resize/remeasure to convert (which is wasteful in this situation)
            if (isNumOrPxType(fromType) && isNumOrPxType(toType)) {
                const current = value.get();
                if (typeof current === "string") {
                    value.set(parseFloat(current));
                }
                if (typeof to === "string") {
                    target[key] = parseFloat(to);
                }
                else if (Array.isArray(to) && toType === px) {
                    target[key] = to.map(parseFloat);
                }
            }
            else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) &&
                (toType === null || toType === void 0 ? void 0 : toType.transform) &&
                (from === 0 || to === 0)) {
                // If one or the other value is 0, it's safe to coerce it to the
                // type of the other without measurement
                if (from === 0) {
                    value.set(toType.transform(from));
                }
                else {
                    target[key] = fromType.transform(to);
                }
            }
            else {
                // If we're going to do value conversion via DOM measurements, we first
                // need to remove non-positional transform values that could affect the bbox measurements.
                if (!hasAttemptedToRemoveTransformValues) {
                    removedTransformValues =
                        removeNonTranslationalTransform(visualElement);
                    hasAttemptedToRemoveTransformValues = true;
                }
                changedValueTypeKeys.push(key);
                transitionEnd[key] =
                    transitionEnd[key] !== undefined
                        ? transitionEnd[key]
                        : target[key];
                value.jump(to);
            }
        }
    });
    if (changedValueTypeKeys.length) {
        const scrollY = changedValueTypeKeys.indexOf("height") >= 0
            ? window.pageYOffset
            : null;
        const convertedTarget = convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
        // If we removed transform values, reapply them before the next render
        if (removedTransformValues.length) {
            removedTransformValues.forEach(([key, value]) => {
                visualElement.getValue(key).set(value);
            });
        }
        // Reapply original values
        visualElement.render();
        // Restore scroll position
        if (isBrowser && scrollY !== null) {
            window.scrollTo({ top: scrollY });
        }
        return { target: convertedTarget, transitionEnd };
    }
    else {
        return { target, transitionEnd };
    }
};
/**
 * Convert value types for x/y/width/height/top/left/bottom/right
 *
 * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
 *
 * @internal
 */
function unitConversion(visualElement, target, origin, transitionEnd) {
    return hasPositionalKey(target)
        ? checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd)
        : { target, transitionEnd };
}

/**
 * Parse a DOM variant to make it animatable. This involves resolving CSS variables
 * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
 */
const parseDomVariant = (visualElement, target, origin, transitionEnd) => {
    const resolved = resolveCSSVariables(visualElement, target, transitionEnd);
    target = resolved.target;
    transitionEnd = resolved.transitionEnd;
    return unitConversion(visualElement, target, origin, transitionEnd);
};

// Does this device prefer reduced motion? Returns `null` server-side.
const prefersReducedMotion = { current: null };
const hasReducedMotionListener = { current: false };

function initPrefersReducedMotion() {
    hasReducedMotionListener.current = true;
    if (!isBrowser)
        return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = () => (prefersReducedMotion.current = motionMediaQuery.matches);
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    }
    else {
        prefersReducedMotion.current = false;
    }
}

function updateMotionValuesFromProps(element, next, prev) {
    const { willChange } = next;
    for (const key in next) {
        const nextValue = next[key];
        const prevValue = prev[key];
        if (isMotionValue(nextValue)) {
            /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */
            element.addValue(key, nextValue);
            if (isWillChangeMotionValue(willChange)) {
                willChange.add(key);
            }
            /**
             * Check the version of the incoming motion value with this version
             * and warn against mismatches.
             */
            if (process.env.NODE_ENV === "development") {
                warnOnce(nextValue.version === "10.16.4", `Attempting to mix Framer Motion versions ${nextValue.version} with 10.16.4 may not work as expected.`);
            }
        }
        else if (isMotionValue(prevValue)) {
            /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */
            element.addValue(key, motionValue(nextValue, { owner: element }));
            if (isWillChangeMotionValue(willChange)) {
                willChange.remove(key);
            }
        }
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */
            if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                // TODO: Only update values that aren't being animated or even looked at
                !existingValue.hasAnimated && existingValue.set(nextValue);
            }
            else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, motionValue(latestValue !== undefined ? latestValue : nextValue, { owner: element }));
            }
        }
    }
    // Handle removed values
    for (const key in prev) {
        if (next[key] === undefined)
            element.removeValue(key);
    }
    return next;
}

const visualElementStore = new WeakMap();

const featureNames = Object.keys(featureDefinitions);
const numFeatures = featureNames.length;
const propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete",
];
const numVariantProps = variantProps.length;
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */
class VisualElement {
    constructor({ parent, props, presenceContext, reducedMotionConfig, visualState, }, options = {}) {
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */
        this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */
        this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */
        this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */
        this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */
        this.values = new Map();
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */
        this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */
        this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */
        this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */
        this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */
        this.propEventSubscriptions = {};
        this.notifyUpdate = () => this.notify("Update", this.latestValues);
        this.render = () => {
            if (!this.current)
                return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.scheduleRender = () => frame.render(this.render, false, true);
        const { latestValues, renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = { ...latestValues };
        this.initialValues = props.initial ? { ...latestValues } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.isControllingVariants = isControllingVariants(props);
        this.isVariantNode = isVariantNode(props);
        if (this.isVariantNode) {
            this.variantChildren = new Set();
        }
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */
        const { willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {});
        for (const key in initialMotionValues) {
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && isMotionValue(value)) {
                value.set(latestValues[key], false);
                if (isWillChangeMotionValue(willChange)) {
                    willChange.add(key);
                }
            }
        }
    }
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */
    scrapeMotionValuesFromProps(_props, _prevProps) {
        return {};
    }
    mount(instance) {
        this.current = instance;
        visualElementStore.set(instance, this);
        if (this.projection && !this.projection.instance) {
            this.projection.mount(instance);
        }
        if (this.parent && this.isVariantNode && !this.isControllingVariants) {
            this.removeFromVariantTree = this.parent.addVariantChild(this);
        }
        this.values.forEach((value, key) => this.bindToMotionValue(key, value));
        if (!hasReducedMotionListener.current) {
            initPrefersReducedMotion();
        }
        this.shouldReduceMotion =
            this.reducedMotionConfig === "never"
                ? false
                : this.reducedMotionConfig === "always"
                    ? true
                    : prefersReducedMotion.current;
        if (process.env.NODE_ENV !== "production") {
            warnOnce(this.shouldReduceMotion !== true, "You have Reduced Motion enabled on your device. Animations may not appear as expected.");
        }
        if (this.parent)
            this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        visualElementStore.delete(this.current);
        this.projection && this.projection.unmount();
        cancelFrame(this.notifyUpdate);
        cancelFrame(this.render);
        this.valueSubscriptions.forEach((remove) => remove());
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for (const key in this.events) {
            this.events[key].clear();
        }
        for (const key in this.features) {
            this.features[key].unmount();
        }
        this.current = null;
    }
    bindToMotionValue(key, value) {
        const valueIsTransform = transformProps.has(key);
        const removeOnChange = value.on("change", (latestValue) => {
            this.latestValues[key] = latestValue;
            this.props.onUpdate &&
                frame.update(this.notifyUpdate, false, true);
            if (valueIsTransform && this.projection) {
                this.projection.isTransformDirty = true;
            }
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        this.valueSubscriptions.set(key, () => {
            removeOnChange();
            removeOnRenderRequest();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */
        if (!this.current ||
            !this.sortInstanceNodePosition ||
            this.type !== other.type) {
            return 0;
        }
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    loadFeatures({ children, ...renderedProps }, isStrict, preloadedFeatures, initialLayoutGroupConfig) {
        let ProjectionNodeConstructor;
        let MeasureLayout;
        /**
         * If we're in development mode, check to make sure we're not rendering a motion component
         * as a child of LazyMotion, as this will break the file-size benefits of using it.
         */
        if (process.env.NODE_ENV !== "production" &&
            preloadedFeatures &&
            isStrict) {
            const strictMessage = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
            renderedProps.ignoreStrict
                ? warning(false, strictMessage)
                : invariant(false, strictMessage);
        }
        for (let i = 0; i < numFeatures; i++) {
            const name = featureNames[i];
            const { isEnabled, Feature: FeatureConstructor, ProjectionNode, MeasureLayout: MeasureLayoutComponent, } = featureDefinitions[name];
            if (ProjectionNode)
                ProjectionNodeConstructor = ProjectionNode;
            if (isEnabled(renderedProps)) {
                if (!this.features[name] && FeatureConstructor) {
                    this.features[name] = new FeatureConstructor(this);
                }
                if (MeasureLayoutComponent) {
                    MeasureLayout = MeasureLayoutComponent;
                }
            }
        }
        if (!this.projection && ProjectionNodeConstructor) {
            this.projection = new ProjectionNodeConstructor(this.latestValues, this.parent && this.parent.projection);
            const { layoutId, layout, drag, dragConstraints, layoutScroll, layoutRoot, } = renderedProps;
            this.projection.setOptions({
                layoutId,
                layout,
                alwaysMeasureLayout: Boolean(drag) ||
                    (dragConstraints && isRefObject(dragConstraints)),
                visualElement: this,
                scheduleRender: () => this.scheduleRender(),
                /**
                 * TODO: Update options in an effect. This could be tricky as it'll be too late
                 * to update by the time layout animations run.
                 * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
                 * ensuring it gets called if there's no potential layout animations.
                 *
                 */
                animationType: typeof layout === "string" ? layout : "both",
                initialPromotionConfig: initialLayoutGroupConfig,
                layoutScroll,
                layoutRoot,
            });
        }
        return MeasureLayout;
    }
    updateFeatures() {
        for (const key in this.features) {
            const feature = this.features[key];
            if (feature.isMounted) {
                feature.update();
            }
            else {
                feature.mount();
                feature.isMounted = true;
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.options, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */
    measureViewportBox() {
        return this.current
            ? this.measureInstanceViewportBox(this.current, this.props)
            : createBox();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Make a target animatable by Popmotion. For instance, if we're
     * trying to animate width from 100px to 100vw we need to measure 100vw
     * in pixels to determine what we really need to animate to. This is also
     * pluggable to support Framer's custom value types like Color,
     * and CSS variables.
     */
    makeTargetAnimatable(target, canMutate = true) {
        return this.makeTargetAnimatableFromInstance(target, this.props, canMutate);
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */
    update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) {
            this.scheduleRender();
        }
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */
        for (let i = 0; i < propEventHandlers.length; i++) {
            const key = propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listener = props["on" + key];
            if (listener) {
                this.propEventSubscriptions[key] = this.on(key, listener);
            }
        }
        this.prevMotionValues = updateMotionValuesFromProps(this, this.scrapeMotionValuesFromProps(props, this.prevProps), this.prevMotionValues);
        if (this.handleChildMotionValue) {
            this.handleChildMotionValue();
        }
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */
    getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */
    getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode
            ? this
            : this.parent
                ? this.parent.getClosestVariantNode()
                : undefined;
    }
    getVariantContext(startAtParent = false) {
        if (startAtParent) {
            return this.parent ? this.parent.getVariantContext() : undefined;
        }
        if (!this.isControllingVariants) {
            const context = this.parent
                ? this.parent.getVariantContext() || {}
                : {};
            if (this.props.initial !== undefined) {
                context.initial = this.props.initial;
            }
            return context;
        }
        const context = {};
        for (let i = 0; i < numVariantProps; i++) {
            const name = variantProps[i];
            const prop = this.props[name];
            if (isVariantLabel(prop) || prop === false) {
                context[name] = prop;
            }
        }
        return context;
    }
    /**
     * Add a child visual element to our set of children.
     */
    addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren &&
                closestVariantNode.variantChildren.add(child);
            return () => closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */
    addValue(key, value) {
        // Remove existing value if it exists
        if (value !== this.values.get(key)) {
            this.removeValue(key);
            this.bindToMotionValue(key, value);
        }
        this.values.set(key, value);
        this.latestValues[key] = value.get();
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */
    removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */
    hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) {
            return this.props.values[key];
        }
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = motionValue(defaultValue, { owner: this });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */
    readValue(key) {
        var _a;
        return this.latestValues[key] !== undefined || !this.current
            ? this.latestValues[key]
            : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */
    setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */
    getBaseTarget(key) {
        var _a;
        const { initial } = this.props;
        const valueFromInitial = typeof initial === "string" || typeof initial === "object"
            ? (_a = resolveVariantFromProps(this.props, initial)) === null || _a === void 0 ? void 0 : _a[key]
            : undefined;
        /**
         * If this value still exists in the current initial variant, read that.
         */
        if (initial && valueFromInitial !== undefined) {
            return valueFromInitial;
        }
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */
        const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !isMotionValue(target))
            return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */
        return this.initialValues[key] !== undefined &&
            valueFromInitial === undefined
            ? undefined
            : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) {
            this.events[eventName] = new SubscriptionManager();
        }
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) {
            this.events[eventName].notify(...args);
        }
    }
}

class DOMVisualElement extends VisualElement {
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */
        return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars, style }) {
        delete vars[key];
        delete style[key];
    }
    makeTargetAnimatableFromInstance({ transition, transitionEnd, ...target }, { transformValues }, isMounted) {
        let origin = getOrigin(target, transition || {}, this);
        /**
         * If Framer has provided a function to convert `Color` etc value types, convert them
         */
        if (transformValues) {
            if (transitionEnd)
                transitionEnd = transformValues(transitionEnd);
            if (target)
                target = transformValues(target);
            if (origin)
                origin = transformValues(origin);
        }
        if (isMounted) {
            checkTargetForNewValues(this, target, origin);
            const parsed = parseDomVariant(this, target, origin, transitionEnd);
            transitionEnd = parsed.transitionEnd;
            target = parsed.target;
        }
        return {
            transition,
            transitionEnd,
            ...target,
        };
    }
}

function getComputedStyle$2(element) {
    return window.getComputedStyle(element);
}
class HTMLVisualElement extends DOMVisualElement {
    readValueFromInstance(instance, key) {
        if (transformProps.has(key)) {
            const defaultType = getDefaultValueType(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        else {
            const computedStyle = getComputedStyle$2(instance);
            const value = (isCSSVariableName(key)
                ? computedStyle.getPropertyValue(key)
                : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint }) {
        return measureViewportBox(instance, transformPagePoint);
    }
    build(renderState, latestValues, options, props) {
        buildHTMLStyles(renderState, latestValues, options, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps) {
        return scrapeMotionValuesFromProps$1(props, prevProps);
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children } = this.props;
        if (isMotionValue(children)) {
            this.childSubscription = children.on("change", (latest) => {
                if (this.current)
                    this.current.textContent = `${latest}`;
            });
        }
    }
    renderInstance(instance, renderState, styleProp, projection) {
        renderHTML(instance, renderState, styleProp, projection);
    }
}

class SVGVisualElement extends DOMVisualElement {
    constructor() {
        super(...arguments);
        this.isSVGTag = false;
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if (transformProps.has(key)) {
            const defaultType = getDefaultValueType(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !camelCaseAttributes.has(key) ? camelToDash(key) : key;
        return instance.getAttribute(key);
    }
    measureInstanceViewportBox() {
        return createBox();
    }
    scrapeMotionValuesFromProps(props, prevProps) {
        return scrapeMotionValuesFromProps(props, prevProps);
    }
    build(renderState, latestValues, options, props) {
        buildSVGAttrs(renderState, latestValues, options, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        renderSVG(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = isSVGTag(instance.tagName);
        super.mount(instance);
    }
}

const createDomVisualElement = (Component, options) => {
    return isSVGComponent(Component)
        ? new SVGVisualElement(options, { enableHardwareAcceleration: false })
        : new HTMLVisualElement(options, { enableHardwareAcceleration: true });
};

const layout = {
    layout: {
        ProjectionNode: HTMLProjectionNode,
        MeasureLayout,
    },
};

const preloadedFeatures = {
    ...animations,
    ...gestureAnimations,
    ...drag,
    ...layout,
};
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */
const motion = /*@__PURE__*/ createMotionProxy((Component, config) => createDomMotionConfig(Component, config, preloadedFeatures, createDomVisualElement));

function useIsMounted() {
    const isMounted = React.useRef(false);
    useIsomorphicLayoutEffect$1(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);
    return isMounted;
}

function useForceUpdate() {
    const isMounted = useIsMounted();
    const [forcedRenderCount, setForcedRenderCount] = React.useState(0);
    const forceRender = React.useCallback(() => {
        isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [forcedRenderCount]);
    /**
     * Defer this to the end of the next animation frame in case there are multiple
     * synchronous calls.
     */
    const deferredForceRender = React.useCallback(() => frame.postRender(forceRender), [forceRender]);
    return [deferredForceRender, forcedRenderCount];
}

/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */
class PopChildMeasure extends React__namespace.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */
    componentDidUpdate() { }
    render() {
        return this.props.children;
    }
}
function PopChild({ children, isPresent }) {
    const id = React.useId();
    const ref = React.useRef(null);
    const size = React.useRef({
        width: 0,
        height: 0,
        top: 0,
        left: 0,
    });
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */
    React.useInsertionEffect(() => {
        const { width, height, top, left } = size.current;
        if (isPresent || !ref.current || !width || !height)
            return;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        document.head.appendChild(style);
        if (style.sheet) {
            style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            top: ${top}px !important;
            left: ${left}px !important;
          }
        `);
        }
        return () => {
            document.head.removeChild(style);
        };
    }, [isPresent]);
    return (React__namespace.createElement(PopChildMeasure, { isPresent: isPresent, childRef: ref, sizeRef: size }, React__namespace.cloneElement(children, { ref })));
}

const PresenceChild = ({ children, initial, isPresent, onExitComplete, custom, presenceAffectsLayout, mode, }) => {
    const presenceChildren = useConstant(newChildrenMap);
    const id = React.useId();
    const context = React.useMemo(() => ({
        id,
        initial,
        isPresent,
        custom,
        onExitComplete: (childId) => {
            presenceChildren.set(childId, true);
            for (const isComplete of presenceChildren.values()) {
                if (!isComplete)
                    return; // can stop searching when any is incomplete
            }
            onExitComplete && onExitComplete();
        },
        register: (childId) => {
            presenceChildren.set(childId, false);
            return () => presenceChildren.delete(childId);
        },
    }), 
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    presenceAffectsLayout ? undefined : [isPresent]);
    React.useMemo(() => {
        presenceChildren.forEach((_, key) => presenceChildren.set(key, false));
    }, [isPresent]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */
    React__namespace.useEffect(() => {
        !isPresent &&
            !presenceChildren.size &&
            onExitComplete &&
            onExitComplete();
    }, [isPresent]);
    if (mode === "popLayout") {
        children = React__namespace.createElement(PopChild, { isPresent: isPresent }, children);
    }
    return (React__namespace.createElement(PresenceContext.Provider, { value: context }, children));
};
function newChildrenMap() {
    return new Map();
}

function useUnmountEffect(callback) {
    return React.useEffect(() => () => callback(), []);
}

const getChildKey = (child) => child.key || "";
function updateChildLookup(children, allChildren) {
    children.forEach((child) => {
        const key = getChildKey(child);
        allChildren.set(key, child);
    });
}
function onlyElements(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    React.Children.forEach(children, (child) => {
        if (React.isValidElement(child))
            filtered.push(child);
    });
    return filtered;
}
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */
const AnimatePresence = ({ children, custom, initial = true, onExitComplete, exitBeforeEnter, presenceAffectsLayout = true, mode = "sync", }) => {
    invariant(!exitBeforeEnter, "Replace exitBeforeEnter with mode='wait'");
    // We want to force a re-render once all exiting animations have finished. We
    // either use a local forceRender function, or one from a parent context if it exists.
    const forceRender = React.useContext(LayoutGroupContext).forceRender || useForceUpdate()[0];
    const isMounted = useIsMounted();
    // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
    const filteredChildren = onlyElements(children);
    let childrenToRender = filteredChildren;
    const exitingChildren = React.useRef(new Map()).current;
    // Keep a living record of the children we're actually rendering so we
    // can diff to figure out which are entering and exiting
    const presentChildren = React.useRef(childrenToRender);
    // A lookup table to quickly reference components by key
    const allChildren = React.useRef(new Map()).current;
    // If this is the initial component render, just deal with logic surrounding whether
    // we play onMount animations or not.
    const isInitialRender = React.useRef(true);
    useIsomorphicLayoutEffect$1(() => {
        isInitialRender.current = false;
        updateChildLookup(filteredChildren, allChildren);
        presentChildren.current = childrenToRender;
    });
    useUnmountEffect(() => {
        isInitialRender.current = true;
        allChildren.clear();
        exitingChildren.clear();
    });
    if (isInitialRender.current) {
        return (React__namespace.createElement(React__namespace.Fragment, null, childrenToRender.map((child) => (React__namespace.createElement(PresenceChild, { key: getChildKey(child), isPresent: true, initial: initial ? undefined : false, presenceAffectsLayout: presenceAffectsLayout, mode: mode }, child)))));
    }
    // If this is a subsequent render, deal with entering and exiting children
    childrenToRender = [...childrenToRender];
    // Diff the keys of the currently-present and target children to update our
    // exiting list.
    const presentKeys = presentChildren.current.map(getChildKey);
    const targetKeys = filteredChildren.map(getChildKey);
    // Diff the present children with our target children and mark those that are exiting
    const numPresent = presentKeys.length;
    for (let i = 0; i < numPresent; i++) {
        const key = presentKeys[i];
        if (targetKeys.indexOf(key) === -1 && !exitingChildren.has(key)) {
            exitingChildren.set(key, undefined);
        }
    }
    // If we currently have exiting children, and we're deferring rendering incoming children
    // until after all current children have exiting, empty the childrenToRender array
    if (mode === "wait" && exitingChildren.size) {
        childrenToRender = [];
    }
    // Loop through all currently exiting components and clone them to overwrite `animate`
    // with any `exit` prop they might have defined.
    exitingChildren.forEach((component, key) => {
        // If this component is actually entering again, early return
        if (targetKeys.indexOf(key) !== -1)
            return;
        const child = allChildren.get(key);
        if (!child)
            return;
        const insertionIndex = presentKeys.indexOf(key);
        let exitingComponent = component;
        if (!exitingComponent) {
            const onExit = () => {
                allChildren.delete(key);
                exitingChildren.delete(key);
                // Remove this child from the present children
                const removeIndex = presentChildren.current.findIndex((presentChild) => presentChild.key === key);
                presentChildren.current.splice(removeIndex, 1);
                // Defer re-rendering until all exiting children have indeed left
                if (!exitingChildren.size) {
                    presentChildren.current = filteredChildren;
                    if (isMounted.current === false)
                        return;
                    forceRender();
                    onExitComplete && onExitComplete();
                }
            };
            exitingComponent = (React__namespace.createElement(PresenceChild, { key: getChildKey(child), isPresent: false, onExitComplete: onExit, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode }, child));
            exitingChildren.set(key, exitingComponent);
        }
        childrenToRender.splice(insertionIndex, 0, exitingComponent);
    });
    // Add `MotionContext` even to children that don't need it to ensure we're rendering
    // the same tree between renders
    childrenToRender = childrenToRender.map((child) => {
        const key = child.key;
        return exitingChildren.has(key) ? (child) : (React__namespace.createElement(PresenceChild, { key: getChildKey(child), isPresent: true, presenceAffectsLayout: presenceAffectsLayout, mode: mode }, child));
    });
    if (process.env.NODE_ENV !== "production" &&
        mode === "wait" &&
        childrenToRender.length > 1) {
        console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`);
    }
    return (React__namespace.createElement(React__namespace.Fragment, null, exitingChildren.size
        ? childrenToRender
        : childrenToRender.map((child) => React.cloneElement(child))));
};

var OpenableCard = function (props) {
    var _a, _b;
    var _c = _tslib.__read(React__namespace.useState(false), 2), isUncontrolledOpen = _c[0], setUncontrolledOpen = _c[1];
    var isOpen = (_a = props.opened) !== null && _a !== void 0 ? _a : isUncontrolledOpen;
    var handleToggle = (_b = props.onToggle) !== null && _b !== void 0 ? _b : (function () { return setUncontrolledOpen(function (prev) { return !prev; }); });
    return (React__namespace.createElement(Card$5, { background: props.background, className: props.className, hoverEffect: true },
        React__namespace.createElement(TitleView, { onClick: handleToggle },
            React__namespace.createElement(Spacing.Flex, { justify: "space-between", align: "center" },
                React__namespace.createElement(Hyperlink.Text, { type: "heading_small", useCompact: true, style: { flex: 1 } },
                    React__namespace.createElement("h3", null, props.title)),
                React__namespace.createElement(ArrowView$1, { opened: isOpen }))),
        React__namespace.createElement(AnimatePresence, { initial: false }, isOpen && (React__namespace.createElement(motion.div, { key: "content", initial: { height: 0 }, animate: { height: 'auto' }, exit: { height: 0 }, transition: { duration: 0.3, easings: ['easeIn'] } },
            React__namespace.createElement(ContentView$4, null, props.children))))));
};
var Card$5 = styled__default.default(CardBase).withConfig({ displayName: "Card", componentId: "-1lnhwpv" })(templateObject_1$1q || (templateObject_1$1q = _tslib.__makeTemplateObject(["\n  overflow: hidden;\n  padding-bottom: 8px;\n"], ["\n  overflow: hidden;\n  padding-bottom: 8px;\n"])));
var TitleView = styled__default.default(CardContentView).attrs({ contentWidth: '100%' }).withConfig({ displayName: "TitleView", componentId: "-4p1iqc" })(templateObject_2$16 || (templateObject_2$16 = _tslib.__makeTemplateObject(["\n  box-sizing: border-box;\n  cursor: pointer;\n  padding-bottom: 16px !important;\n"], ["\n  box-sizing: border-box;\n  cursor: pointer;\n  padding-bottom: 16px !important;\n"])));
var ContentView$4 = styled__default.default(CardContentView).attrs({ contentWidth: '100%' }).withConfig({ displayName: "ContentView", componentId: "-lyyyas" })(templateObject_3$M || (templateObject_3$M = _tslib.__makeTemplateObject(["\n  box-sizing: border-box;\n  padding-top: 0 !important;\n  padding-bottom: 16px !important;\n  overflow: hidden;\n"], ["\n  box-sizing: border-box;\n  padding-top: 0 !important;\n  padding-bottom: 16px !important;\n  overflow: hidden;\n"])));
var ArrowView$1 = styled__default.default(ArrowDown.ArrowDown).withConfig({ shouldForwardProp: Spacing.isPropValid })(templateObject_4$w || (templateObject_4$w = _tslib.__makeTemplateObject(["\n  cursor: pointer;\n  min-width: 24px;\n  ", "\n"], ["\n  cursor: pointer;\n  min-width: 24px;\n  ", "\n"])), function (props) { return (props.opened ? 'transform: rotate(180deg);' : undefined); });
var templateObject_1$1q, templateObject_2$16, templateObject_3$M, templateObject_4$w;

var PriceBox = function (props) { return (React__namespace.createElement(WrapperView$4, null,
    React__namespace.createElement(BackgroundView$2, null),
    React__namespace.createElement(Spacing.Flex, { flexDir: Spacing.FlexDirection.COLUMN, align: Spacing.FlexAlign.CENTER, justify: Spacing.FlexJustify.CENTER, style: { height: '100%', position: 'relative' } },
        React__namespace.createElement(Spacing.Flex, { align: Spacing.FlexAlign.BASELINE },
            React__namespace.createElement(Hyperlink.Text, { type: Hyperlink.TextType.HEADING_XXLARGE, useCompact: true },
                React__namespace.createElement("span", null, ShouldDisplay.formatMoney(props.price, 0))),
            React__namespace.createElement(Hyperlink.Text, { type: Hyperlink.TextType.HEADING_MEDIUM, useCompact: true },
                React__namespace.createElement("span", null,
                    "/",
                    props.period))),
        React__namespace.createElement(Hyperlink.Text, { type: Hyperlink.TextType.HEADING_SMALL, useCompact: true },
            React__namespace.createElement("span", null, props.footer))))); };
var WrapperView$4 = styled__default.default.div.withConfig({ displayName: "WrapperView", componentId: "-eiuwh1" })(templateObject_1$1p || (templateObject_1$1p = _tslib.__makeTemplateObject(["\n  max-width: 272px;\n  width: 100%;\n  position: relative;\n  height: 152px;\n"], ["\n  max-width: 272px;\n  width: 100%;\n  position: relative;\n  height: 152px;\n"])));
var BackgroundView$2 = styled__default.default(AchievementStar.BackgroundBlob3).withConfig({ displayName: "BackgroundView", componentId: "-1aashqn" })(templateObject_2$15 || (templateObject_2$15 = _tslib.__makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: auto;\n"], ["\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: auto;\n"])));
var templateObject_1$1p, templateObject_2$15;

var Accordion = function (_a) {
    var title = _a.title, _b = _a.icon, icon = _b === void 0 ? React__namespace.createElement(ArrowDown.ArrowDown, null) : _b, _c = _a.initialOpen, initialOpen = _c === void 0 ? false : _c, isControlledOpen = _a.isOpen, setControlledOpen = _a.onClick, children = _a.children, _d = _a.noBorders, noBorders = _d === void 0 ? false : _d;
    var _e = _tslib.__read(React__namespace.useState(initialOpen), 2), isUncontrolledOpen = _e[0], setUncontrolledOpen = _e[1];
    var isOpen = isControlledOpen !== null && isControlledOpen !== void 0 ? isControlledOpen : isUncontrolledOpen;
    var setOpen = setControlledOpen !== null && setControlledOpen !== void 0 ? setControlledOpen : setUncontrolledOpen;
    return (React__namespace.createElement(Container$s, { noBorders: noBorders },
        React__namespace.createElement(Title$3, { onClick: function () { return setOpen(!isOpen); }, noBorders: noBorders },
            React__namespace.createElement(TitleBottomSpacing, { initial: false, animate: { paddingBottom: isOpen || noBorders ? 0 : 16 } },
                title,
                icon && React__namespace.createElement(IconWrapper$4, { animate: { rotateX: isOpen ? 180 : 0 } }, icon))),
        React__namespace.createElement(AnimatePresence, { initial: false }, isOpen && (React__namespace.createElement(Content$3, { key: "content", initial: "collapsed", animate: "open", exit: "collapsed", variants: {
                open: { height: 'auto' },
                collapsed: { height: 0 },
            } }, noBorders ? (children) : (React__namespace.createElement(Spacing.Spacing, { top: 1, all: 2 }, children)))))));
};
var Container$s = styled__default.default.div.withConfig({ shouldForwardProp: Spacing.isPropValid })(templateObject_2$14 || (templateObject_2$14 = _tslib.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  background-color: ", ";\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow:\n    0px 4px 16px rgba(35, 68, 101, 0.05),\n    0px 4px 4px rgba(35, 68, 101, 0.05);\n\n  &:hover {\n    box-shadow:\n      0px 6px 24px rgba(35, 68, 101, 0.15),\n      0px 6px 8px rgba(35, 68, 101, 0.15);\n  }\n\n  ", "\n"], ["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  background-color: ", ";\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow:\n    0px 4px 16px rgba(35, 68, 101, 0.05),\n    0px 4px 4px rgba(35, 68, 101, 0.05);\n\n  &:hover {\n    box-shadow:\n      0px 6px 24px rgba(35, 68, 101, 0.15),\n      0px 6px 8px rgba(35, 68, 101, 0.15);\n  }\n\n  ", "\n"])), styles.themeColors.white, function (_a) {
    var noBorders = _a.noBorders;
    return !!noBorders && styled.css(templateObject_1$1o || (templateObject_1$1o = _tslib.__makeTemplateObject(["\n      box-shadow: unset;\n      border-radius: unset;\n\n      &:hover {\n        box-shadow: unset;\n      }\n    "], ["\n      box-shadow: unset;\n      border-radius: unset;\n\n      &:hover {\n        box-shadow: unset;\n      }\n    "])));
});
var Title$3 = styled__default.default.div.withConfig({ shouldForwardProp: Spacing.isPropValid })(templateObject_4$v || (templateObject_4$v = _tslib.__makeTemplateObject(["\n  cursor: pointer;\n  padding: 16px 16px 0 16px;\n\n  ", "\n"], ["\n  cursor: pointer;\n  padding: 16px 16px 0 16px;\n\n  ", "\n"])), function (_a) {
    var noBorders = _a.noBorders;
    return !!noBorders && styled.css(templateObject_3$L || (templateObject_3$L = _tslib.__makeTemplateObject(["\n      padding: 8px 0;\n    "], ["\n      padding: 8px 0;\n    "])));
});
var TitleBottomSpacing = styled__default.default(motion.div).withConfig({ displayName: "TitleBottomSpacing", componentId: "-1f7pagd" })(templateObject_5$m || (templateObject_5$m = _tslib.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"])));
var Content$3 = styled__default.default(motion.div).withConfig({ displayName: "Content", componentId: "-1wrxc3k" })(templateObject_6$h || (templateObject_6$h = _tslib.__makeTemplateObject(["\n  overflow: hidden;\n"], ["\n  overflow: hidden;\n"])));
var IconWrapper$4 = styled__default.default(motion.div).withConfig({ displayName: "IconWrapper", componentId: "-1u6n0ne" })(templateObject_7$a || (templateObject_7$a = _tslib.__makeTemplateObject(["\n  width: 24px;\n  height: 24px;\n  pointer-events: none;\n  cursor: pointer;\n"], ["\n  width: 24px;\n  height: 24px;\n  pointer-events: none;\n  cursor: pointer;\n"])));
var templateObject_1$1o, templateObject_2$14, templateObject_3$L, templateObject_4$v, templateObject_5$m, templateObject_6$h, templateObject_7$a;

var FeatureCard = function (_a) {
    var icon = _a.icon, title = _a.title, body = _a.body, linkText = _a.linkText, _b = _a.linkUrl, linkUrl = _b === void 0 ? '' : _b, linkToExternal = _a.linkToExternal, linkClassName = _a.linkClassName, props = _tslib.__rest(_a, ["icon", "title", "body", "linkText", "linkUrl", "linkToExternal", "linkClassName"]);
    return (React__namespace.createElement(Card$4, _tslib.__assign({}, props, { gap: "16px", align: body ? 'top' : 'center', padding: "large" }),
        React__namespace.createElement(IconWrapper$3, null, icon),
        React__namespace.createElement(Spacing.Flex, { flexDir: "column", gap: "8px" },
            React__namespace.createElement(Hyperlink.Text, { type: "heading_small_bold", useCompact: true },
                React__namespace.createElement("h4", null, title)),
            body && (React__namespace.createElement(Hyperlink.Text, { type: "body", useCompact: true },
                React__namespace.createElement("p", null, body))),
            linkText && (React__namespace.createElement(Hyperlink.Hyperlink, { href: linkUrl, variant: "navigation", inNewWindow: linkToExternal, className: linkClassName }, linkText)))));
};
var Card$4 = styled__default.default(Spacing.Flex).withConfig({ displayName: "Card", componentId: "-wjhf6h" })(templateObject_1$1n || (templateObject_1$1n = _tslib.__makeTemplateObject(["\n  ", ";\n  background-color: transparent;\n"], ["\n  ", ";\n  background-color: transparent;\n"])), CardBaseStyles);
var IconWrapper$3 = styled__default.default.div.withConfig({ displayName: "IconWrapper", componentId: "-1kaqfgp" })(templateObject_2$13 || (templateObject_2$13 = _tslib.__makeTemplateObject(["\n  min-width: 48px;\n  min-height: 48px;\n  width: 48px;\n  height: 48px;\n\n  @media ", " {\n    min-width: 56px;\n    min-height: 56px;\n    width: 56px;\n    height: 56px;\n  }\n"], ["\n  min-width: 48px;\n  min-height: 48px;\n  width: 48px;\n  height: 48px;\n\n  @media ", " {\n    min-width: 56px;\n    min-height: 56px;\n    width: 56px;\n    height: 56px;\n  }\n"])), ResponsiveSizes.desktop);
var templateObject_1$1n, templateObject_2$13;

var InfoCard = function (_a) {
    var iconPosition = _a.iconPosition, icon = _a.icon, title = _a.title, body = _a.body, linkText = _a.linkText, _b = _a.linkUrl, linkUrl = _b === void 0 ? '' : _b, _c = _a.linkToExternal, linkToExternal = _c === void 0 ? false : _c, linkClassName = _a.linkClassName, props = _tslib.__rest(_a, ["iconPosition", "icon", "title", "body", "linkText", "linkUrl", "linkToExternal", "linkClassName"]);
    return (React__namespace.createElement(CardBase, _tslib.__assign({ padding: "large" }, props),
        React__namespace.createElement(Spacing.Flex, { flexDir: iconPosition === 'side' ? 'row' : 'column', gap: iconPosition === 'side' ? '8px' : '16px' },
            React__namespace.createElement(IconWrapper$2, null, icon),
            React__namespace.createElement(Hyperlink.Text, { type: "heading_small_bold", useCompact: true },
                React__namespace.createElement(H4, null, title))),
        React__namespace.createElement(Spacing.Spacing, { top: 2 },
            React__namespace.createElement(Hyperlink.Text, { type: "body", useCompact: true },
                React__namespace.createElement("p", null, body))),
        linkText && (React__namespace.createElement(Spacing.Spacing, { top: 2 },
            React__namespace.createElement(Hyperlink.Hyperlink, { href: linkUrl, variant: "navigation", inNewWindow: linkToExternal, className: linkClassName }, linkText)))));
};
var IconWrapper$2 = styled__default.default.div.withConfig({ displayName: "IconWrapper", componentId: "-a6p1zt" })(templateObject_1$1m || (templateObject_1$1m = _tslib.__makeTemplateObject(["\n  min-width: 48px;\n  min-height: 48px;\n  width: 48px;\n  height: 48px;\n\n  @media ", " {\n    min-width: 64px;\n    min-height: 64px;\n    width: 64px;\n    height: 64px;\n  }\n"], ["\n  min-width: 48px;\n  min-height: 48px;\n  width: 48px;\n  height: 48px;\n\n  @media ", " {\n    min-width: 64px;\n    min-height: 64px;\n    width: 64px;\n    height: 64px;\n  }\n"])), ResponsiveSizes.regular);
var H4 = styled__default.default.h4.withConfig({ displayName: "H4", componentId: "-a5a3zi" })(templateObject_2$12 || (templateObject_2$12 = _tslib.__makeTemplateObject(["\n  && {\n    height: 100%;\n    display: flex;\n    align-items: center;\n  }\n"], ["\n  && {\n    height: 100%;\n    display: flex;\n    align-items: center;\n  }\n"])));
var templateObject_1$1m, templateObject_2$12;

var InfoCardCompact = function (_a) {
    var icon = _a.icon, title = _a.title, body = _a.body, props = _tslib.__rest(_a, ["icon", "title", "body"]);
    return (React__namespace.createElement(Card$3, _tslib.__assign({}, props),
        React__namespace.createElement(Spacing.Flex, { align: "flex-start", gap: "16px" },
            React__namespace.createElement(IconWrapper$1, null, icon),
            React__namespace.createElement(Hyperlink.Text, { type: "heading_small_bold", useCompact: true },
                React__namespace.createElement("h4", null, title))),
        React__namespace.createElement(Spacing.Spacing, { top: 2 },
            React__namespace.createElement(Hyperlink.Text, { type: "body", useCompact: true },
                React__namespace.createElement("p", null, body)))));
};
var Card$3 = styled__default.default.div.withConfig({ displayName: "Card", componentId: "-1n8yde0" })(templateObject_1$1l || (templateObject_1$1l = _tslib.__makeTemplateObject(["\n  background-color: transparent;\n"], ["\n  background-color: transparent;\n"])));
var IconWrapper$1 = styled__default.default.div.withConfig({ displayName: "IconWrapper", componentId: "-1i5ryet" })(templateObject_2$11 || (templateObject_2$11 = _tslib.__makeTemplateObject(["\n  width: 32px;\n  height: 32px;\n  overflow: hidden;\n  position: relative;\n"], ["\n  width: 32px;\n  height: 32px;\n  overflow: hidden;\n  position: relative;\n"])));
var templateObject_1$1l, templateObject_2$11;

var InfoCardIllustrative = function (props) {
    return (React__namespace.createElement(Card$2, _tslib.__assign({ flexDir: "column", gap: "4px" }, props),
        React__namespace.createElement(IconWrapper, null, props.icon),
        React__namespace.createElement(Hyperlink.Text, { type: "heading_medium", useCompact: true },
            React__namespace.createElement("h4", null, props.title)),
        React__namespace.createElement(Hyperlink.Text, { type: "body", useCompact: true },
            React__namespace.createElement("p", null, props.body))));
};
var Card$2 = styled__default.default(Spacing.Flex).withConfig({ displayName: "Card", componentId: "-aznivw" })(templateObject_1$1k || (templateObject_1$1k = _tslib.__makeTemplateObject(["\n  text-align: center;\n  background-color: transparent;\n"], ["\n  text-align: center;\n  background-color: transparent;\n"])));
var IconWrapper = styled__default.default.div.withConfig({ displayName: "IconWrapper", componentId: "-hq0tr5" })(templateObject_2$10 || (templateObject_2$10 = _tslib.__makeTemplateObject(["\n  margin: 0 auto;\n  max-width: 272px;\n  height: 194px;\n  overflow: hidden;\n\n  @media ", " {\n    height: 272px;\n  }\n"], ["\n  margin: 0 auto;\n  max-width: 272px;\n  height: 194px;\n  overflow: hidden;\n\n  @media ", " {\n    height: 272px;\n  }\n"])), ResponsiveSizes.desktop);
var templateObject_1$1k, templateObject_2$10;

var Sublabel = function (_a) {
    var children = _a.children, icon = _a.icon, color = _a.color, props = _tslib.__rest(_a, ["children", "icon", "color"]);
    return (React__namespace.createElement(Container$r, _tslib.__assign({}, props),
        icon,
        React__namespace.createElement(Hyperlink.Text, { type: "body_small", color: color, align: "center" },
            React__namespace.createElement("p", null, children))));
};
var Container$r = styled__default.default.div.withConfig({ displayName: "Container", componentId: "-1r15aen" })(templateObject_1$1j || (templateObject_1$1j = _tslib.__makeTemplateObject(["\n  display: inline-flex;\n  gap: 8px;\n  align-items: center;\n  justify-content: center;\n"], ["\n  display: inline-flex;\n  gap: 8px;\n  align-items: center;\n  justify-content: center;\n"])));
var templateObject_1$1j;

var SectionFooter = function (_a) {
    var disclaimer = _a.disclaimer, callToAction = _a.callToAction, sublabel = _a.sublabel, secondaryCallToAction = _a.secondaryCallToAction, _b = _a.align, align = _b === void 0 ? 'center' : _b;
    return (React__namespace.createElement(Spacing.Flex, { flexDir: "column" },
        (callToAction || secondaryCallToAction) && (React__namespace.createElement(Actions, { align: align },
            callToAction && (React__namespace.createElement(LinkButton, { fullWidth: { default: true, desktop: false }, type: "primary", href: callToAction.url, target: callToAction.target, rel: callToAction.rel, className: callToAction.className }, callToAction.text)),
            secondaryCallToAction && (React__namespace.createElement(LinkButton, { fullWidth: { default: true, desktop: false }, type: "secondary", href: secondaryCallToAction.url, target: secondaryCallToAction.target, rel: secondaryCallToAction.rel, className: secondaryCallToAction.className }, secondaryCallToAction.text)))),
        sublabel && React__namespace.createElement(ButtonSublabel, { align: align }, sublabel),
        disclaimer && (React__namespace.createElement(Disclaimer$1, null,
            React__namespace.createElement(Hyperlink.Text, { type: "body", useCompact: true, align: "center", color: styles.themeColors.gray[60] },
                React__namespace.createElement("p", null, disclaimer))))));
};
var Actions = styled__default.default.div.withConfig({ displayName: "Actions", componentId: "-14osc0a" })(templateObject_1$1i || (templateObject_1$1i = _tslib.__makeTemplateObject(["\n  display: flex;\n  justify-content: ", ";\n  flex-direction: column;\n  gap: 24px;\n  margin-top: 32px;\n\n  @media ", " {\n    flex-direction: row;\n  }\n"], ["\n  display: flex;\n  justify-content: ", ";\n  flex-direction: column;\n  gap: 24px;\n  margin-top: 32px;\n\n  @media ", " {\n    flex-direction: row;\n  }\n"])), function (_a) {
    var align = _a.align;
    return align;
}, ResponsiveSizes.desktop);
var ButtonSublabel = styled__default.default(Sublabel).withConfig({ displayName: "ButtonSublabel", componentId: "-1ymf7q6" })(templateObject_2$$ || (templateObject_2$$ = _tslib.__makeTemplateObject(["\n  display: flex;\n  margin-top: 8px;\n  justify-content: center;\n\n  @media ", " {\n    justify-content: ", ";\n  }\n"], ["\n  display: flex;\n  margin-top: 8px;\n  justify-content: center;\n\n  @media ", " {\n    justify-content: ", ";\n  }\n"])), ResponsiveSizes.desktop, function (_a) {
    var align = _a.align;
    return align;
});
var Disclaimer$1 = styled__default.default.div.withConfig({ displayName: "Disclaimer", componentId: "-u7k8z4" })(templateObject_3$K || (templateObject_3$K = _tslib.__makeTemplateObject(["\n  margin: 24px auto 0;\n  max-width: 616px;\n\n  @media ", " {\n    margin-top: 32px;\n  }\n"], ["\n  margin: 24px auto 0;\n  max-width: 616px;\n\n  @media ", " {\n    margin-top: 32px;\n  }\n"])), ResponsiveSizes.desktop);
var templateObject_1$1i, templateObject_2$$, templateObject_3$K;

var BlobNumbersColumnDesktopLayout = function (props) { return (React__namespace.createElement(React__namespace.Fragment, null,
    React__namespace.createElement(ContainerView$1, null,
        React__namespace.createElement(BlobView, null, props.blob),
        React__namespace.createElement(NumbersContainerView, { flexDir: Spacing.FlexDirection.COLUMN, align: Spacing.FlexAlign.CENTER },
            React__namespace.createElement(Spacing.Spacing, { top: 2 }),
            props.topContent,
            React__namespace.createElement(Spacing.Spacing, { top: 7, compactTop: 6 }),
            props.bottomContent,
            React__namespace.createElement(Spacing.Spacing, { top: 2 }))))); };
var BlobNumbersColumnMobileLayout = function (props) { return (React__namespace.createElement(React__namespace.Fragment, null,
    React__namespace.createElement(ContainerView$1, null,
        React__namespace.createElement(BlobView, null, props.blob),
        React__namespace.createElement(NumbersContainerView, { flexDir: Spacing.FlexDirection.COLUMN, align: Spacing.FlexAlign.CENTER },
            React__namespace.createElement(Spacing.Spacing, { top: 2 }),
            props.topContent,
            React__namespace.createElement(Spacing.Spacing, { top: 7, compactTop: 6 }),
            props.bottomContent,
            React__namespace.createElement(Spacing.Spacing, { top: 2 }))))); };
var BlobNumbersColumnLayout = function (props) { return (React__namespace.createElement(ResponsiveSizes.ResponsiveSizes, { largeDesktop: React__namespace.createElement(BlobNumbersColumnDesktopLayout, _tslib.__assign({}, props)), desktop: React__namespace.createElement(BlobNumbersColumnDesktopLayout, _tslib.__assign({}, props)), tablet: React__namespace.createElement(BlobNumbersColumnMobileLayout, _tslib.__assign({}, props)), mobile: React__namespace.createElement(BlobNumbersColumnMobileLayout, _tslib.__assign({}, props)) })); };
var BlobView = styled__default.default.div.withConfig({ displayName: "BlobView", componentId: "-qjf6vt" })(templateObject_1$1h || (templateObject_1$1h = _tslib.__makeTemplateObject(["\n  position: absolute;\n  width: 453px;\n\n  @media ", " {\n    width: 378px;\n  }\n\n  @media ", ", ", " {\n    display: none;\n  }\n"], ["\n  position: absolute;\n  width: 453px;\n\n  @media ", " {\n    width: 378px;\n  }\n\n  @media ", ", ", " {\n    display: none;\n  }\n"])), ResponsiveSizes.media.desktop, ResponsiveSizes.media.tablet, ResponsiveSizes.media.mobile);
var NumbersContainerView = styled__default.default(Spacing.Flex).withConfig({ displayName: "NumbersContainerView", componentId: "-ar009c" })(templateObject_2$_ || (templateObject_2$_ = _tslib.__makeTemplateObject(["\n  z-index: 10;\n  position: relative;\n"], ["\n  z-index: 10;\n  position: relative;\n"])));
var ContainerView$1 = styled__default.default(Spacing.Flex).withConfig({ displayName: "ContainerView", componentId: "-733bmt" })(templateObject_3$J || (templateObject_3$J = _tslib.__makeTemplateObject(["\n  flex: 6;\n  position: relative;\n  justify-content: center;\n"], ["\n  flex: 6;\n  position: relative;\n  justify-content: center;\n"])));
var templateObject_1$1h, templateObject_2$_, templateObject_3$J;

var BlobNumbersLayout = function (props) { return (React__namespace.createElement(ContainerView, null,
    React__namespace.createElement(MobileBlobView, null, props.mobileBlob),
    props.numberColumnLeft,
    props.numberColumnRight)); };
var MobileBlobView = styled__default.default.div.withConfig({ displayName: "MobileBlobView", componentId: "-odfeoi" })(templateObject_1$1g || (templateObject_1$1g = _tslib.__makeTemplateObject(["\n  position: absolute;\n  display: none;\n  text-align: center;\n  z-index: -100;\n\n  @media ", ", ", " {\n    display: block;\n    width: 100%;\n    overflow: hidden;\n  }\n"], ["\n  position: absolute;\n  display: none;\n  text-align: center;\n  z-index: -100;\n\n  @media ", ", ", " {\n    display: block;\n    width: 100%;\n    overflow: hidden;\n  }\n"])), ResponsiveSizes.media.tablet, ResponsiveSizes.media.mobile);
var ContainerView = styled__default.default(Spacing.Flex).withConfig({ displayName: "ContainerView", componentId: "-15jbj47" })(templateObject_2$Z || (templateObject_2$Z = _tslib.__makeTemplateObject(["\n  position: relative;\n\n  @media ", ", ", " {\n    flex-direction: column;\n    align-items: center;\n  }\n"], ["\n  position: relative;\n\n  @media ", ", ", " {\n    flex-direction: column;\n    align-items: center;\n  }\n"])), ResponsiveSizes.media.tablet, ResponsiveSizes.media.mobile);
var templateObject_1$1g, templateObject_2$Z;

var NumbersLayout = function (props) { return (React__namespace.createElement(Spacing.Flex, { flexDir: Spacing.FlexDirection.COLUMN, align: Spacing.FlexAlign.CENTER },
    React__namespace.createElement(Hyperlink.Text, { type: Hyperlink.TextType.HEADING_XXLARGE, useCompact: true },
        React__namespace.createElement("h3", null, props.number)),
    React__namespace.createElement(Hyperlink.Text, { type: Hyperlink.TextType.HEADING_SMALL, useCompact: true },
        React__namespace.createElement("small", null, props.subNumberText)))); };

var SequenceLayoutItem = function (props) { return (React__namespace.createElement(React__namespace.Fragment, null,
    React__namespace.createElement(ItemView$1, { flexDir: Spacing.FlexDirection.COLUMN },
        React__namespace.createElement(ImageView$1, null, props.image),
        React__namespace.createElement(Spacing.Spacing, { top: true }),
        React__namespace.createElement(Hyperlink.Text, { type: Hyperlink.TextType.HEADING_SMALL },
            React__namespace.createElement("h3", null,
                React__namespace.createElement(ShouldDisplay.StringReactElement, { data: props.title })))),
    !props.isLast && React__namespace.createElement(ArrowView, null))); };
var ImageView$1 = styled__default.default.div.withConfig({ displayName: "ImageView", componentId: "-12j2daf" })(templateObject_1$1f || (templateObject_1$1f = _tslib.__makeTemplateObject(["\n  padding: 8px;\n  width: calc(100% - 16px);\n\n  img {\n    width: 100%;\n  }\n"], ["\n  padding: 8px;\n  width: calc(100% - 16px);\n\n  img {\n    width: 100%;\n  }\n"])));
var ArrowView = styled__default.default(AchievementStar.SequenceArrow).withConfig({ displayName: "ArrowView", componentId: "-2kzs68" })(templateObject_2$Y || (templateObject_2$Y = _tslib.__makeTemplateObject(["\n  align-self: center;\n\n  @media ", ", ", " {\n    transform: rotate(90deg);\n    margin: 50px 0;\n  }\n"], ["\n  align-self: center;\n\n  @media ", ", ", " {\n    transform: rotate(90deg);\n    margin: 50px 0;\n  }\n"])), ResponsiveSizes.media[ResponsiveSizes.BreakpointType.TABLET], ResponsiveSizes.media[ResponsiveSizes.BreakpointType.MOBILE]);
var ItemView$1 = styled__default.default(Spacing.Flex).withConfig({ displayName: "ItemView", componentId: "-btw899" })(templateObject_3$I || (templateObject_3$I = _tslib.__makeTemplateObject(["\n  max-width: 300px;\n  align-items: center;\n"], ["\n  max-width: 300px;\n  align-items: center;\n"])));
var templateObject_1$1f, templateObject_2$Y, templateObject_3$I;

var dayjs_min = {exports: {}};

(function (module, exports) {
	!function(t,e){module.exports=e();}(ResponsiveSizes.commonjsGlobal,(function(){var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",c="month",f="quarter",h="year",d="date",l="Invalid Date",$=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),ordinal:function(t){var e=["th","st","nd","rd"],n=t%100;return "["+t+(e[(n-20)%10]||e[n]||e[0])+"]"}},m=function(t,e,n){var r=String(t);return !r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},v={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return (e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return -t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,c),s=n-i<0,u=e.clone().add(r+(s?-1:1),c);return +(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return {M:c,y:h,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:f}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},g="en",D={};D[g]=M;var p="$isDayjsObject",S=function(t){return t instanceof _||!(!t||!t[p])},w=function t(e,n,r){var i;if(!e)return g;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else {var a=e.name;D[a]=e,i=a;}return !r&&i&&(g=i),i||!r&&g},O=function(t,e){if(S(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},b=v;b.l=w,b.i=S,b.w=function(t,e){return O(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=w(t.locale,null,!0),this.parse(t),this.$x=this.$x||t.x||{},this[p]=!0;}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(b.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match($);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.init();},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds();},m.$utils=function(){return b},m.isValid=function(){return !(this.$d.toString()===l)},m.isSame=function(t,e){var n=O(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return O(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<O(t)},m.$g=function(t,e,n){return b.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!b.u(e)||e,f=b.p(t),l=function(t,e){var i=b.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},$=function(t,e){return b.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,v="set"+(this.$u?"UTC":"");switch(f){case h:return r?l(1,0):l(31,11);case c:return r?l(1,M):l(0,M+1);case o:var g=this.$locale().weekStart||0,D=(y<g?y+7:y)-g;return l(r?m-D:m+(6-D),M);case a:case d:return $(v+"Hours",0);case u:return $(v+"Minutes",1);case s:return $(v+"Seconds",2);case i:return $(v+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=b.p(t),f="set"+(this.$u?"UTC":""),l=(n={},n[a]=f+"Date",n[d]=f+"Date",n[c]=f+"Month",n[h]=f+"FullYear",n[u]=f+"Hours",n[s]=f+"Minutes",n[i]=f+"Seconds",n[r]=f+"Milliseconds",n)[o],$=o===a?this.$D+(e-this.$W):e;if(o===c||o===h){var y=this.clone().set(d,1);y.$d[l]($),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d;}else l&&this.$d[l]($);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[b.p(t)]()},m.add=function(r,f){var d,l=this;r=Number(r);var $=b.p(f),y=function(t){var e=O(l);return b.w(e.date(e.date()+Math.round(t*r)),l)};if($===c)return this.set(c,this.$M+r);if($===h)return this.set(h,this.$y+r);if($===a)return y(1);if($===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[$]||1,m=this.$d.getTime()+r*M;return b.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||l;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=b.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,c=n.months,f=n.meridiem,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},d=function(t){return b.s(s%12||12,t,"0")},$=f||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r};return r.replace(y,(function(t,r){return r||function(t){switch(t){case"YY":return String(e.$y).slice(-2);case"YYYY":return b.s(e.$y,4,"0");case"M":return a+1;case"MM":return b.s(a+1,2,"0");case"MMM":return h(n.monthsShort,a,c,3);case"MMMM":return h(c,a);case"D":return e.$D;case"DD":return b.s(e.$D,2,"0");case"d":return String(e.$W);case"dd":return h(n.weekdaysMin,e.$W,o,2);case"ddd":return h(n.weekdaysShort,e.$W,o,3);case"dddd":return o[e.$W];case"H":return String(s);case"HH":return b.s(s,2,"0");case"h":return d(1);case"hh":return d(2);case"a":return $(s,u,!0);case"A":return $(s,u,!1);case"m":return String(u);case"mm":return b.s(u,2,"0");case"s":return String(e.$s);case"ss":return b.s(e.$s,2,"0");case"SSS":return b.s(e.$ms,3,"0");case"Z":return i}return null}(t)||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,l){var $,y=this,M=b.p(d),m=O(r),v=(m.utcOffset()-this.utcOffset())*e,g=this-m,D=function(){return b.m(y,m)};switch(M){case h:$=D()/12;break;case c:$=D();break;case f:$=D()/3;break;case o:$=(g-v)/6048e5;break;case a:$=(g-v)/864e5;break;case u:$=g/n;break;case s:$=g/e;break;case i:$=g/t;break;default:$=g;}return l?$:b.a($)},m.daysInMonth=function(){return this.endOf(c).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=w(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return b.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),k=_.prototype;return O.prototype=k,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",c],["$y",h],["$D",d]].forEach((function(t){k[t[1]]=function(e){return this.$g(e,t[0],t[1])};})),O.extend=function(t,e){return t.$i||(t(e,_,O),t.$i=!0),O},O.locale=w,O.isDayjs=S,O.unix=function(t){return O(1e3*t)},O.en=D[g],O.Ls=D,O.p={},O})); 
} (dayjs_min));

var dayjs_minExports = dayjs_min.exports;
var dayjs = /*@__PURE__*/ResponsiveSizes.getDefaultExportFromCjs(dayjs_minExports);

var duration$1 = {exports: {}};

(function (module, exports) {
	!function(t,s){module.exports=s();}(ResponsiveSizes.commonjsGlobal,(function(){var t,s,n=1e3,i=6e4,e=36e5,r=864e5,o=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,u=31536e6,d=2628e6,a=/^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/,h={years:u,months:d,days:r,hours:e,minutes:i,seconds:n,milliseconds:1,weeks:6048e5},c=function(t){return t instanceof g},f=function(t,s,n){return new g(t,n,s.$l)},m=function(t){return s.p(t)+"s"},l=function(t){return t<0},$=function(t){return l(t)?Math.ceil(t):Math.floor(t)},y=function(t){return Math.abs(t)},v=function(t,s){return t?l(t)?{negative:!0,format:""+y(t)+s}:{negative:!1,format:""+t+s}:{negative:!1,format:""}},g=function(){function l(t,s,n){var i=this;if(this.$d={},this.$l=n,void 0===t&&(this.$ms=0,this.parseFromMilliseconds()),s)return f(t*h[m(s)],this);if("number"==typeof t)return this.$ms=t,this.parseFromMilliseconds(),this;if("object"==typeof t)return Object.keys(t).forEach((function(s){i.$d[m(s)]=t[s];})),this.calMilliseconds(),this;if("string"==typeof t){var e=t.match(a);if(e){var r=e.slice(2).map((function(t){return null!=t?Number(t):0}));return this.$d.years=r[0],this.$d.months=r[1],this.$d.weeks=r[2],this.$d.days=r[3],this.$d.hours=r[4],this.$d.minutes=r[5],this.$d.seconds=r[6],this.calMilliseconds(),this}}return this}var y=l.prototype;return y.calMilliseconds=function(){var t=this;this.$ms=Object.keys(this.$d).reduce((function(s,n){return s+(t.$d[n]||0)*h[n]}),0);},y.parseFromMilliseconds=function(){var t=this.$ms;this.$d.years=$(t/u),t%=u,this.$d.months=$(t/d),t%=d,this.$d.days=$(t/r),t%=r,this.$d.hours=$(t/e),t%=e,this.$d.minutes=$(t/i),t%=i,this.$d.seconds=$(t/n),t%=n,this.$d.milliseconds=t;},y.toISOString=function(){var t=v(this.$d.years,"Y"),s=v(this.$d.months,"M"),n=+this.$d.days||0;this.$d.weeks&&(n+=7*this.$d.weeks);var i=v(n,"D"),e=v(this.$d.hours,"H"),r=v(this.$d.minutes,"M"),o=this.$d.seconds||0;this.$d.milliseconds&&(o+=this.$d.milliseconds/1e3,o=Math.round(1e3*o)/1e3);var u=v(o,"S"),d=t.negative||s.negative||i.negative||e.negative||r.negative||u.negative,a=e.format||r.format||u.format?"T":"",h=(d?"-":"")+"P"+t.format+s.format+i.format+a+e.format+r.format+u.format;return "P"===h||"-P"===h?"P0D":h},y.toJSON=function(){return this.toISOString()},y.format=function(t){var n=t||"YYYY-MM-DDTHH:mm:ss",i={Y:this.$d.years,YY:s.s(this.$d.years,2,"0"),YYYY:s.s(this.$d.years,4,"0"),M:this.$d.months,MM:s.s(this.$d.months,2,"0"),D:this.$d.days,DD:s.s(this.$d.days,2,"0"),H:this.$d.hours,HH:s.s(this.$d.hours,2,"0"),m:this.$d.minutes,mm:s.s(this.$d.minutes,2,"0"),s:this.$d.seconds,ss:s.s(this.$d.seconds,2,"0"),SSS:s.s(this.$d.milliseconds,3,"0")};return n.replace(o,(function(t,s){return s||String(i[t])}))},y.as=function(t){return this.$ms/h[m(t)]},y.get=function(t){var s=this.$ms,n=m(t);return "milliseconds"===n?s%=1e3:s="weeks"===n?$(s/h[n]):this.$d[n],s||0},y.add=function(t,s,n){var i;return i=s?t*h[m(s)]:c(t)?t.$ms:f(t,this).$ms,f(this.$ms+i*(n?-1:1),this)},y.subtract=function(t,s){return this.add(t,s,!0)},y.locale=function(t){var s=this.clone();return s.$l=t,s},y.clone=function(){return f(this.$ms,this)},y.humanize=function(s){return t().add(this.$ms,"ms").locale(this.$l).fromNow(!s)},y.valueOf=function(){return this.asMilliseconds()},y.milliseconds=function(){return this.get("milliseconds")},y.asMilliseconds=function(){return this.as("milliseconds")},y.seconds=function(){return this.get("seconds")},y.asSeconds=function(){return this.as("seconds")},y.minutes=function(){return this.get("minutes")},y.asMinutes=function(){return this.as("minutes")},y.hours=function(){return this.get("hours")},y.asHours=function(){return this.as("hours")},y.days=function(){return this.get("days")},y.asDays=function(){return this.as("days")},y.weeks=function(){return this.get("weeks")},y.asWeeks=function(){return this.as("weeks")},y.months=function(){return this.get("months")},y.asMonths=function(){return this.as("months")},y.years=function(){return this.get("years")},y.asYears=function(){return this.as("years")},l}(),p=function(t,s,n){return t.add(s.years()*n,"y").add(s.months()*n,"M").add(s.days()*n,"d").add(s.hours()*n,"h").add(s.minutes()*n,"m").add(s.seconds()*n,"s").add(s.milliseconds()*n,"ms")};return function(n,i,e){t=e,s=e().$utils(),e.duration=function(t,s){var n=e.locale();return f(t,{$l:n},s)},e.isDuration=c;var r=i.prototype.add,o=i.prototype.subtract;i.prototype.add=function(t,s){return c(t)?p(this,t,1):r.bind(this)(t,s)},i.prototype.subtract=function(t,s){return c(t)?p(this,t,-1):o.bind(this)(t,s)};}})); 
} (duration$1));

var durationExports = duration$1.exports;
var duration = /*@__PURE__*/ResponsiveSizes.getDefaultExportFromCjs(durationExports);

dayjs.extend(duration);
var timerUnits = ['second', 'minute', 'hour', 'day', 'month', 'year'];
var getStartEndDates = function (countdown) {
    if (typeof countdown === 'number' || typeof countdown === 'string') {
        return [dayjs(), dayjs(countdown)];
    }
    var startDate = dayjs();
    var endDate = dayjs(countdown.startDate).add(countdown.duration, countdown.unit);
    if (endDate.isBefore(startDate)) {
        var diff = startDate.diff(endDate, countdown.unit);
        var count = Math.ceil(diff / countdown.duration);
        endDate = endDate.add(count * countdown.duration, countdown.unit);
    }
    return [startDate, endDate];
};
var calculateTimeRemaining = function (_a) {
    var _b = _tslib.__read(_a, 2), now = _b[0], target = _b[1];
    return dayjs.duration(target.diff(now));
};
var Timer = function (_a) {
    var countdown = _a.countdown, compact = _a.compact;
    var dates = getStartEndDates(countdown);
    var _b = _tslib.__read(React__namespace.useState(calculateTimeRemaining(dates)), 2), timeRemaining = _b[0], setTimeRemaining = _b[1];
    React__namespace.useEffect(function () {
        var timerInterval = setInterval(function () {
            setTimeRemaining(calculateTimeRemaining(dates));
        }, 1000);
        return function () { return clearInterval(timerInterval); };
    }, [dates]);
    if (timeRemaining.asMilliseconds() <= 0) {
        return null;
    }
    var timeByUnits = timeRemaining.format('DD:HH:mm:ss').split(':');
    return (React__namespace.createElement(Container$q, null,
        React__namespace.createElement(TimerItem, { duration: timeByUnits[0], unit: "days", compact: compact }),
        React__namespace.createElement(Hyperlink.Text, { type: "subtitle", fontWeight: 700, color: styles.themeColors.white },
            React__namespace.createElement("span", null, ":")),
        React__namespace.createElement(TimerItem, { duration: timeByUnits[1], unit: "hrs", compact: compact }),
        React__namespace.createElement(Hyperlink.Text, { type: "subtitle", fontWeight: 700, color: styles.themeColors.white },
            React__namespace.createElement("span", null, ":")),
        React__namespace.createElement(TimerItem, { duration: timeByUnits[2], unit: "min", compact: compact }),
        React__namespace.createElement(Hyperlink.Text, { type: "subtitle", fontWeight: 700, color: styles.themeColors.white },
            React__namespace.createElement("span", null, ":")),
        React__namespace.createElement(TimerItem, { duration: timeByUnits[3], unit: "sec", compact: compact })));
};
var Container$q = styled__default.default.div.withConfig({ displayName: "Container", componentId: "-f6djmh" })(templateObject_1$1e || (templateObject_1$1e = _tslib.__makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  color: ", ";\n"], ["\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  color: ", ";\n"])), styles.themeColors.white);
var TimerItem = function (_a) {
    var duration = _a.duration, unit = _a.unit, compact = _a.compact;
    return (React__namespace.createElement(Wrapper$1, { "$compact": compact },
        React__namespace.createElement(Hyperlink.Text, { type: compact ? 'body_small' : 'body', fontWeight: 700, color: styles.themeColors.yellow[50] },
            React__namespace.createElement("span", null, duration)),
        React__namespace.createElement(Hyperlink.Text, { type: "microtext", color: styles.themeColors.gray[5], style: { marginTop: -4, opacity: 0.6 } },
            React__namespace.createElement("span", null, unit.toUpperCase()))));
};
var Wrapper$1 = styled__default.default.div.withConfig({ displayName: "Wrapper", componentId: "-c0xfbp" })(templateObject_2$X || (templateObject_2$X = _tslib.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: ", "33;\n  border-radius: 8px;\n  width: ", ";\n  height: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: ", "33;\n  border-radius: 8px;\n  width: ", ";\n  height: ", ";\n"])), styles.themeColors.yellow[50], function (_a) {
    var $compact = _a.$compact;
    return ($compact ? '32px' : '40px');
}, function (_a) {
    var $compact = _a.$compact;
    return ($compact ? '30px' : '40px');
});
var templateObject_1$1e, templateObject_2$X;

var HelloBar = function (_a) {
    var title = _a.title, callToAction = _a.callToAction, buttonAction = _a.buttonAction, timer = _a.timer, onClose = _a.onClose, alternativeColors = _a.alternativeColors, className = _a.className;
    return (React__namespace.createElement(Background$5, { alternativeColors: alternativeColors, className: className },
        React__namespace.createElement(Spacing.Flex, { justify: "center", align: "center", gap: { default: '16px', desktop: '24px' } },
            onClose && (React__namespace.createElement(IconButton$2, { onClick: onClose },
                React__namespace.createElement(AchievementStar.ModalCloseIcon, { size: 16 }))),
            React__namespace.createElement(Hyperlink.InlineText, { type: "body", fontWeight: 700, color: styles.themeColors.gray[5] },
                React__namespace.createElement("p", null, title)),
            React__namespace.createElement(Spacing.Flex, { flexDir: { default: 'column', tablet: 'row' }, gap: "16px 24px" },
                timer && React__namespace.createElement(Timer, { countdown: timer, compact: true }),
                callToAction && !buttonAction && (React__namespace.createElement(StyledLinkButton, { type: "accent", size: "small", href: callToAction.url, target: callToAction.target, rel: callToAction.rel, className: callToAction.className, "$withTimer": !!timer },
                    React__namespace.createElement(Hyperlink.Text, { type: "label", color: styles.themeColors.gray[90] },
                        React__namespace.createElement(NonWrappingText, null, callToAction.text)))),
                buttonAction && !callToAction && (React__namespace.createElement(StyledButton, { onClick: buttonAction.onClick, variant: "primary", color: "accent", size: "small", className: buttonAction.className },
                    React__namespace.createElement(Hyperlink.Text, { type: "label", size: 14, color: styles.themeColors.gray[90] },
                        React__namespace.createElement(NonWrappingText, null, buttonAction.text))))))));
};
var Background$5 = styled__default.default.div.withConfig({ shouldForwardProp: Spacing.isPropValid })(templateObject_1$1d || (templateObject_1$1d = _tslib.__makeTemplateObject(["\n  box-sizing: border-box;\n  position: sticky;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  background-color: ", ";\n  padding: 16px 12px;\n  z-index: 1000;\n\n  @media ", " {\n    padding: 16px 24px;\n    top: 0;\n    bottom: auto;\n  }\n"], ["\n  box-sizing: border-box;\n  position: sticky;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  background-color: ", ";\n  padding: 16px 12px;\n  z-index: 1000;\n\n  @media ", " {\n    padding: 16px 24px;\n    top: 0;\n    bottom: auto;\n  }\n"])), function (_a) {
    var alternativeColors = _a.alternativeColors;
    return (alternativeColors ? styles.themeColors.indigo[70] : styles.themeColors.gray[100]);
}, ResponsiveSizes.desktop);
var StyledLinkButton = styled__default.default(LinkButton).withConfig({ displayName: "StyledLinkButton", componentId: "-18cql5u" })(templateObject_3$H || (templateObject_3$H = _tslib.__makeTemplateObject(["\n  box-sizing: border-box;\n  max-width: 128px;\n  padding: 0 8px;\n\n  ", "\n\n  @media ", " {\n    width: auto;\n    max-width: 100%;\n  }\n"], ["\n  box-sizing: border-box;\n  max-width: 128px;\n  padding: 0 8px;\n\n  ", "\n\n  @media ", " {\n    width: auto;\n    max-width: 100%;\n  }\n"])), function (_a) {
    var $withTimer = _a.$withTimer;
    return $withTimer && styled.css(templateObject_2$W || (templateObject_2$W = _tslib.__makeTemplateObject(["\n      min-width: min-content;\n      white-space: nowrap;\n      max-width: 100%;\n      width: 100%;\n    "], ["\n      min-width: min-content;\n      white-space: nowrap;\n      max-width: 100%;\n      width: 100%;\n    "])));
}, ResponsiveSizes.desktop);
var StyledButton = styled__default.default(Button$2).withConfig({ displayName: "StyledButton", componentId: "-917iil" })(templateObject_4$u || (templateObject_4$u = _tslib.__makeTemplateObject(["\n  padding: 3px 24px;\n\n  @media ", " {\n    padding: 3px 8px;\n  }\n"], ["\n  padding: 3px 24px;\n\n  @media ", " {\n    padding: 3px 8px;\n  }\n"])), ResponsiveSizes.desktop);
var IconButton$2 = styled__default.default.button.withConfig({ displayName: "IconButton", componentId: "-c85kru" })(templateObject_5$l || (templateObject_5$l = _tslib.__makeTemplateObject(["\n  all: unset;\n  font-family: inherit;\n  border-radius: 4px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n\n  svg {\n    stroke: ", ";\n  }\n\n  &:hover,\n  &:active {\n    background-color: #33232836;\n  }\n\n  &:focus {\n    box-shadow: 0 0 0 4px ", ";\n  }\n\n  &:active {\n    svg {\n      stroke: ", ";\n    }\n  }\n\n  @media ", " {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    right: 32px;\n  }\n"], ["\n  all: unset;\n  font-family: inherit;\n  border-radius: 4px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n\n  svg {\n    stroke: ", ";\n  }\n\n  &:hover,\n  &:active {\n    background-color: #33232836;\n  }\n\n  &:focus {\n    box-shadow: 0 0 0 4px ", ";\n  }\n\n  &:active {\n    svg {\n      stroke: ", ";\n    }\n  }\n\n  @media ", " {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    right: 32px;\n  }\n"])), styles.themeColors.gray[40], styles.themeColors.blue[30], styles.themeColors.gray[50], ResponsiveSizes.desktop);
var NonWrappingText = styled__default.default.span.withConfig({ displayName: "NonWrappingText", componentId: "-47dvwx" })(templateObject_6$g || (templateObject_6$g = _tslib.__makeTemplateObject(["\n  white-space: nowrap;\n"], ["\n  white-space: nowrap;\n"])));
var templateObject_1$1d, templateObject_2$W, templateObject_3$H, templateObject_4$u, templateObject_5$l, templateObject_6$g;

var GalleryCard = function (_a) {
    var title = _a.title, description = _a.description, _b = _a.size, size = _b === void 0 ? 'small' : _b, pills = _a.pills, image = _a.image, props = _tslib.__rest(_a, ["title", "description", "size", "pills", "image"]);
    return (React__namespace.createElement(Card$1, _tslib.__assign({}, props),
        React__namespace.createElement(ImageContainer$4, null, image),
        React__namespace.createElement(Spacing.Spacing, { all: 2 },
            pills && pills.length > 0 && (React__namespace.createElement(Pills$1, null, pills.map(function (pill, index) { return (React__namespace.createElement(Pill, _tslib.__assign({ key: "".concat(pill.text).concat(index) }, pill))); }))),
            React__namespace.createElement(Hyperlink.Text, { useCompact: true, type: size === 'medium' ? 'heading_medium' : 'heading_small_bold', fontWeight: 700 },
                React__namespace.createElement("span", null, title)),
            description && (React__namespace.createElement(Spacing.Spacing, { top: true },
                React__namespace.createElement(Hyperlink.Text, { useCompact: true, type: "body_small" },
                    React__namespace.createElement("span", null, description)))))));
};
var Card$1 = styled__default.default(CardBase).withConfig({ displayName: "Card", componentId: "-nkkec2" })(templateObject_1$1c || (templateObject_1$1c = _tslib.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  min-width: 200px;\n  overflow: hidden;\n"], ["\n  display: flex;\n  flex-direction: column;\n  min-width: 200px;\n  overflow: hidden;\n"])));
var Pills$1 = styled__default.default.div.withConfig({ displayName: "Pills", componentId: "-1ubgu56" })(templateObject_2$V || (templateObject_2$V = _tslib.__makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 8px;\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 8px;\n"])));
var ImageContainer$4 = styled__default.default.div.withConfig({ displayName: "ImageContainer", componentId: "-13qruc3" })(templateObject_3$G || (templateObject_3$G = _tslib.__makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n\n  & img {\n    object-fit: cover;\n    object-position: center;\n  }\n"], ["\n  display: flex;\n  justify-content: center;\n\n  & img {\n    object-fit: cover;\n    object-position: center;\n  }\n"])));
var templateObject_1$1c, templateObject_2$V, templateObject_3$G;

var INTERSECTION_THRESHOLD = 0.8;
var translateField = function (field, defaultValue, translations) {
    return translations && field in translations ? translations[field] : defaultValue;
};
var CardToggle = React__namespace.forwardRef(function (_a, forwardedRef) {
    var className = _a.className, heading = _a.heading, subheading = _a.subheading, label = _a.label, body = _a.body, enabled = _a.enabled, onSwitch = _a.onSwitch, _b = _a.watchIntersection, watchIntersection = _b === void 0 ? false : _b, _c = _a.intersectionThreshold, intersectionThreshold = _c === void 0 ? INTERSECTION_THRESHOLD : _c, translations = _a.translations;
    var isDesktop = UseSize.useSizes().isDesktop;
    var cardRef = React__namespace.useRef(null);
    var handleVisibility = React__namespace.useCallback(function (_a) {
        var _b = _tslib.__read(_a, 1), entry = _b[0];
        if (entry.intersectionRatio > intersectionThreshold) {
            onSwitch(true);
        }
        else {
            onSwitch(false);
        }
    }, []);
    React__namespace.useEffect(function () {
        var observer = new IntersectionObserver(handleVisibility, { threshold: intersectionThreshold });
        if (cardRef.current && watchIntersection) {
            observer.observe(cardRef.current);
        }
        return function () { return observer.disconnect(); };
    }, [handleVisibility, cardRef, watchIntersection]);
    return (React__namespace.createElement(Spacing.Flex, { ref: forwardedRef, className: className },
        React__namespace.createElement(CardBase, { ref: cardRef, padding: "small", backgroundColor: enabled ? styles.themeColors.indigo[5] : styles.backgrounds.white },
            React__namespace.createElement(Spacing.Flex, { flexDir: "row", align: "center", justify: "space-between" },
                React__namespace.createElement(Hyperlink.Text, { type: "heading_small", size: 20 },
                    React__namespace.createElement("span", null, translateField('heading', heading, translations))),
                isDesktop && React__namespace.createElement(Switch, { onSwitch: onSwitch, checked: enabled })),
            React__namespace.createElement(Spacing.Spacing, { top: 1 / 2, bottom: 1 },
                React__namespace.createElement(Spacing.Flex, { align: "baseline", gap: "8px", wrap: "wrap" },
                    React__namespace.createElement(Hyperlink.Text, { type: "heading_large", size: 38 },
                        React__namespace.createElement("span", { style: { wordBreak: 'keep-all' } }, subheading)),
                    React__namespace.createElement(Hyperlink.Text, { type: "body", color: styles.themeColors.gray[60], size: 16 },
                        React__namespace.createElement("span", { style: { lineHeight: 0 } }, translateField('label', label, translations))))),
            React__namespace.createElement(Hyperlink.Text, { type: "body_small", color: styles.themeColors.gray[80] },
                React__namespace.createElement("span", null, translateField('body', body, translations))))));
});
CardToggle.displayName = 'CardToggle';

var Action = function (_a) {
    var leftButton = _a.leftButton, rightButton = _a.rightButton, sublabel = _a.sublabel, sublabelIcon = _a.sublabelIcon, _b = _a.align, align = _b === void 0 ? 'center' : _b, _c = _a.sublabelColor, sublabelColor = _c === void 0 ? 'light' : _c, _d = _a.reverseOnMobile, reverseOnMobile = _d === void 0 ? false : _d;
    var sublabelColors = {
        light: styles.themeColors.gray[20],
        dark: styles.themeColors.gray[80],
    };
    return (React__namespace.createElement(Spacing.Flex, { flexDir: "column", align: align },
        React__namespace.createElement(Spacing.Flex, { flexDir: { default: 'row', tablet: 'row', mobile: reverseOnMobile ? 'column-reverse' : 'column' }, align: align, justify: align, gap: "24px", style: { width: '100%' } },
            leftButton,
            rightButton),
        sublabel && (React__namespace.createElement(Spacing.Spacing, { top: true },
            React__namespace.createElement(Sublabel, { color: sublabelColors[sublabelColor], icon: sublabelIcon ? React__namespace.createElement(Icon, { name: sublabelIcon, width: 16, height: 16 }) : null }, sublabel)))));
};

var MediaGallery = function (_a) {
    var children = _a.children;
    return React__namespace.createElement(Container$p, null, children);
};
var Container$p = styled__default.default.div.withConfig({ displayName: "Container", componentId: "-1n8k1kk" })(templateObject_1$1b || (templateObject_1$1b = _tslib.__makeTemplateObject(["\n  display: flex;\n  gap: 16px;\n  padding: 16px;\n  overflow-x: scroll;\n\n  @media ", " {\n    flex-wrap: wrap;\n    overflow-x: hidden;\n  }\n"], ["\n  display: flex;\n  gap: 16px;\n  padding: 16px;\n  overflow-x: scroll;\n\n  @media ", " {\n    flex-wrap: wrap;\n    overflow-x: hidden;\n  }\n"])), ResponsiveSizes.tablet);
var templateObject_1$1b;

var Tag = function (_a) {
    var text = _a.text, _b = _a.size, size = _b === void 0 ? 'small' : _b, indicator = _a.indicator;
    return (React__namespace.createElement(TagContainer, { size: size },
        indicator && React__namespace.createElement(Circle$1, null),
        React__namespace.createElement(Hyperlink.Text, { type: size === 'medium' ? 'body_small' : 'subtitle', fontWeight: 700, color: styles.themeColors.blue[60] },
            React__namespace.createElement(SingleLineText, null, text))));
};
var TagContainer = styled__default.default.div.withConfig({ displayName: "TagContainer", componentId: "-6wrcx3" })(templateObject_2$U || (templateObject_2$U = _tslib.__makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border-radius: 9999px;\n  background-color: ", ";\n\n  ", "\n"], ["\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border-radius: 9999px;\n  background-color: ", ";\n\n  ", "\n"])), styles.themeColors.blue[10], function (_a) {
    var size = _a.size;
    return size === 'medium' && styled.css(templateObject_1$1a || (templateObject_1$1a = _tslib.__makeTemplateObject(["\n      padding: 4px 8px;\n    "], ["\n      padding: 4px 8px;\n    "])));
});
var SingleLineText = styled__default.default.span.withConfig({ displayName: "SingleLineText", componentId: "-1y8ra01" })(templateObject_3$F || (templateObject_3$F = _tslib.__makeTemplateObject(["\n  white-space: nowrap;\n"], ["\n  white-space: nowrap;\n"])));
var Circle$1 = styled__default.default.div.withConfig({ displayName: "Circle", componentId: "-1an8bt2" })(templateObject_4$t || (templateObject_4$t = _tslib.__makeTemplateObject(["\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background-color: ", ";\n"], ["\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background-color: ", ";\n"])), styles.themeColors.blue[60]);
var templateObject_1$1a, templateObject_2$U, templateObject_3$F, templateObject_4$t;

var defaultRenderPercentage = function (percentage) { return (React__namespace.createElement(Hyperlink.Text, { type: "body_small" },
    React__namespace.createElement("span", null, percentage))); };
var ContributionProgress = function (_a) {
    var currentAmount = _a.currentAmount, targetAmount = _a.targetAmount, goal = _a.goal, contributors = _a.contributors, _b = _a.renderPercentage, renderPercentage = _b === void 0 ? defaultRenderPercentage : _b, tag = _a.tag;
    var progress = (currentAmount / targetAmount) * 100;
    var percentage = "".concat(Math.floor(progress), "%");
    var width = "".concat(Math.min(progress, 100), "%");
    var isCompleted = progress >= 100;
    return (React__namespace.createElement(Spacing.Flex, { flexDir: "column", gap: "16px" },
        React__namespace.createElement(Spacing.Flex, { flexDir: "column", gap: "8px" },
            React__namespace.createElement(Spacing.Flex, { justify: "space-between" },
                React__namespace.createElement(Spacing.Flex, { gap: "4px" },
                    React__namespace.createElement(Hyperlink.InlineText, { type: "body_small" },
                        React__namespace.createElement("span", null, goal)),
                    tag && React__namespace.createElement(Tag, _tslib.__assign({}, tag))),
                renderPercentage(percentage)),
            React__namespace.createElement(Container$o, null,
                React__namespace.createElement(Bar, { "$isCompleted": isCompleted },
                    React__namespace.createElement(Progress, { "$width": width, "$isCompleted": isCompleted })))),
        React__namespace.createElement(Spacing.Flex, { align: "center", gap: "8px" },
            React__namespace.createElement(Icon, { width: 18, height: 18, name: "volunteer", color: styles.themeColors.gray['80'] }),
            React__namespace.createElement(Hyperlink.InlineText, { type: "body_small" },
                React__namespace.createElement("span", null, contributors)))));
};
var Container$o = styled__default.default.div.withConfig({ displayName: "Container", componentId: "-2ejug9" })(templateObject_1$19 || (templateObject_1$19 = _tslib.__makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var Bar = styled__default.default.div.withConfig({ displayName: "Bar", componentId: "-gkhkis" })(templateObject_2$T || (templateObject_2$T = _tslib.__makeTemplateObject(["\n  height: 10px;\n  width: 100%;\n  background-color: ", ";\n  border-radius: 30px;\n  overflow: hidden;\n"], ["\n  height: 10px;\n  width: 100%;\n  background-color: ", ";\n  border-radius: 30px;\n  overflow: hidden;\n"])), function (props) { return (props.$isCompleted ? styles.themeColors.green[80] : styles.themeColors.gray[20]); });
var Progress = styled__default.default.div.withConfig({ displayName: "Progress", componentId: "-1rlvbru" })(templateObject_3$E || (templateObject_3$E = _tslib.__makeTemplateObject(["\n  height: 100%;\n  width: ", ";\n  max-width: 100%;\n  background-color: ", ";\n"], ["\n  height: 100%;\n  width: ", ";\n  max-width: 100%;\n  background-color: ", ";\n"])), function (props) { return props.$width; }, function (props) { return (props.$isCompleted ? styles.themeColors.green[70] : '#016acc'); });
var templateObject_1$19, templateObject_2$T, templateObject_3$E;

var Stepper = function (_a) {
    var title = _a.title, steps = _a.steps, _b = _a.circleBackgroundColor, circleBackgroundColor = _b === void 0 ? styles.themeColors.white : _b;
    return (React__namespace.default.createElement("div", null,
        React__namespace.default.createElement(Hyperlink.Text, { type: "body_large", fontWeight: 700 },
            React__namespace.default.createElement("p", null, title)),
        steps.map(function (step, index) {
            var _a;
            return (React__namespace.default.createElement(Step, { key: index },
                React__namespace.default.createElement("div", { style: { position: 'relative' } },
                    React__namespace.default.createElement(Circle, { "$backgroundColor": circleBackgroundColor }, (_a = step.step) !== null && _a !== void 0 ? _a : (React__namespace.default.createElement(Hyperlink.Text, { type: "body_large", fontWeight: 700, color: styles.themeColors.blue[50] },
                        React__namespace.default.createElement("span", null, index + 1)))),
                    index < steps.length - 1 && React__namespace.default.createElement(Line, null)),
                React__namespace.default.createElement(Content$2, null,
                    React__namespace.default.createElement(Hyperlink.Text, { type: "body", fontWeight: 700 },
                        React__namespace.default.createElement("p", null, step.title)),
                    step.content)));
        })));
};
var Step = styled.styled.div.withConfig({ displayName: "Step", componentId: "-1loewfl" })(templateObject_1$18 || (templateObject_1$18 = _tslib.__makeTemplateObject(["\n  padding: 10px;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n"], ["\n  padding: 10px;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n"])));
var Circle = styled.styled.div.withConfig({ displayName: "Circle", componentId: "-k289x" })(templateObject_2$S || (templateObject_2$S = _tslib.__makeTemplateObject(["\n  box-sizing: border-box;\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: 999px;\n  width: 32px;\n  height: 32px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  box-sizing: border-box;\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: 999px;\n  width: 32px;\n  height: 32px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n"])), function (_a) {
    var $backgroundColor = _a.$backgroundColor;
    return $backgroundColor;
}, styles.themeColors.blue[50]);
var Line = styled.styled.div.withConfig({ displayName: "Line", componentId: "-8ntoeb" })(templateObject_3$D || (templateObject_3$D = _tslib.__makeTemplateObject(["\n  top: 32px;\n  left: 15px;\n  height: 100%;\n  position: absolute;\n  border-left: 1px solid ", ";\n"], ["\n  top: 32px;\n  left: 15px;\n  height: 100%;\n  position: absolute;\n  border-left: 1px solid ", ";\n"])), styles.themeColors.blue[50]);
var Content$2 = styled.styled.div.withConfig({ displayName: "Content", componentId: "-yjk6rv" })(templateObject_4$s || (templateObject_4$s = _tslib.__makeTemplateObject(["\n  margin-left: 16px;\n  width: 100%;\n"], ["\n  margin-left: 16px;\n  width: 100%;\n"])));
var templateObject_1$18, templateObject_2$S, templateObject_3$D, templateObject_4$s;

var VideoOverlay$2 = function (_a) {
    var isOpen = _a.isOpen, videoUrl = _a.videoUrl, onClose = _a.onClose, isPortrait = _a.isPortrait;
    return (React__namespace.createElement(Overlay, { "$opened": isOpen, onClick: onClose },
        React__namespace.createElement(IframeWrapper$2, { "$isPortrait": isPortrait },
            React__namespace.createElement("iframe", { src: isOpen ? videoUrl !== null && videoUrl !== void 0 ? videoUrl : '' : '', allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true, style: { border: 'none' } }),
            React__namespace.createElement(IconButton$1, { onClick: onClose },
                React__namespace.createElement(AchievementStar.ModalCloseIcon, { size: 20 })))));
};
var IframeWrapper$2 = styled__default.default.div.withConfig({ displayName: "IframeWrapper", componentId: "-1fclkpx" })(templateObject_2$R || (templateObject_2$R = _tslib.__makeTemplateObject(["\n  margin: 0 auto;\n  width: 100%;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-50%);\n\n  aspect-ratio: 16 / 9;\n  max-width: 90%;\n\n  @media ", " {\n    max-width: 60%;\n  }\n\n  ", "\n\n  iframe {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n"], ["\n  margin: 0 auto;\n  width: 100%;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-50%);\n\n  aspect-ratio: 16 / 9;\n  max-width: 90%;\n\n  @media ", " {\n    max-width: 60%;\n  }\n\n  ", "\n\n  iframe {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n"])), ResponsiveSizes.desktop, function (props) {
    return props.$isPortrait && styled.css(templateObject_1$17 || (templateObject_1$17 = _tslib.__makeTemplateObject(["\n      aspect-ratio: 9 / 16;\n      max-height: 80%;\n\n      @media ", " {\n        width: auto;\n        height: 100%;\n      }\n    "], ["\n      aspect-ratio: 9 / 16;\n      max-height: 80%;\n\n      @media ", " {\n        width: auto;\n        height: 100%;\n      }\n    "])), ResponsiveSizes.desktop);
});
var Overlay = styled__default.default.div.withConfig({ displayName: "Overlay", componentId: "-1vvva7z" })(templateObject_3$C || (templateObject_3$C = _tslib.__makeTemplateObject(["\n  position: fixed;\n  z-index: ", ";\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: rgba(0, 0, 0, 0.5);\n  opacity: ", ";\n  transition: all ease 500ms;\n"], ["\n  position: fixed;\n  z-index: ", ";\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: rgba(0, 0, 0, 0.5);\n  opacity: ", ";\n  transition: all ease 500ms;\n"])), function (props) { return (props.$opened ? 1000 : -1); }, function (props) { return (props.$opened ? 1 : 0); });
var IconButton$1 = styled__default.default.button.withConfig({ displayName: "IconButton", componentId: "-1ozc7af" })(templateObject_4$r || (templateObject_4$r = _tslib.__makeTemplateObject(["\n  all: unset;\n  font-family: inherit;\n  height: 20px;\n  width: 20px;\n  border-radius: 4px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  cursor: pointer;\n  top: -20px;\n  right: 0;\n\n  @media ", " {\n    right: -20px;\n  }\n\n  &:focus {\n    box-shadow: 0 0 0 4px ", ";\n  }\n\n  svg {\n    stroke: ", ";\n  }\n"], ["\n  all: unset;\n  font-family: inherit;\n  height: 20px;\n  width: 20px;\n  border-radius: 4px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  cursor: pointer;\n  top: -20px;\n  right: 0;\n\n  @media ", " {\n    right: -20px;\n  }\n\n  &:focus {\n    box-shadow: 0 0 0 4px ", ";\n  }\n\n  svg {\n    stroke: ", ";\n  }\n"])), ResponsiveSizes.desktop, styles.themeColors.blue[30], styles.themeColors.white);
var templateObject_1$17, templateObject_2$R, templateObject_3$C, templateObject_4$r;

var DropdownPanel = function (_a) {
    var _b = _a.side, side = _b === void 0 ? 'auto' : _b, props = _tslib.__rest(_a, ["side"]);
    var ref = React__namespace.useRef(null);
    var _c = _tslib.__read(React__namespace.useState(0), 2), panelHeight = _c[0], setPanelHeight = _c[1];
    var documentHeight = UseSize.useDocumentHeight();
    React__namespace.useEffect(function () {
        var _a;
        setPanelHeight(((_a = ref.current) === null || _a === void 0 ? void 0 : _a.clientHeight) || 0);
    }, []);
    var pixelsFromTop = React__namespace.useMemo(function () {
        var _a;
        return ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().y) || 0;
    }, [ref.current]);
    var isPanelDirectionInverted = React__namespace.useMemo(function () {
        if (panelHeight && pixelsFromTop && documentHeight) {
            if (pixelsFromTop > 0) {
                return documentHeight - pixelsFromTop < panelHeight;
            }
            return true;
        }
        return false;
    }, [documentHeight, pixelsFromTop, panelHeight]);
    var sideToInverted = {
        auto: isPanelDirectionInverted,
        top: true,
        bottom: false,
    };
    var inverted = sideToInverted[side];
    var renderPanelItem = function (item, i) {
        var panelContent = (React__namespace.createElement(PanelItemView$1, { key: i, className: classNames__default.default({ selected: item.selected }), onClick: item.onClick },
            item.icon && (React__namespace.createElement(React__namespace.Fragment, null,
                item.icon,
                React__namespace.createElement(Spacing.Spacing, { left: true }))),
            React__namespace.createElement(Hyperlink.Text, { type: "item", useCompact: true },
                React__namespace.createElement("span", { style: { whiteSpace: 'nowrap' } }, item.text))));
        if (props.renderPanelItem) {
            return React__namespace.createElement(React__namespace.Fragment, { key: i }, props.renderPanelItem(item, panelContent));
        }
        return panelContent;
    };
    return (React__namespace.createElement(PanelContainerView, { className: props.className, visible: props.visible, inverted: inverted, ref: ref },
        React__namespace.createElement(PanelView, { vertical: 2, ref: props.panelRef },
            React__namespace.createElement(Spacing.Flex, { flexDir: "column" }, props.items.map(renderPanelItem)))));
};
var PanelContainerView = styled__default.default.div.withConfig({ shouldForwardProp: Spacing.isPropValid })(templateObject_1$16 || (templateObject_1$16 = _tslib.__makeTemplateObject(["\n  visibility: ", ";\n  position: absolute;\n  right: 0;\n  z-index: ", ";\n  top: ", ";\n  bottom: ", ";\n"], ["\n  visibility: ", ";\n  position: absolute;\n  right: 0;\n  z-index: ", ";\n  top: ", ";\n  bottom: ", ";\n"])), function (_a) {
    var visible = _a.visible;
    return (visible ? 'visible' : 'hidden');
}, function (_a) {
    var zIndex = _a.zIndex;
    return zIndex !== null && zIndex !== void 0 ? zIndex : 11;
}, function (_a) {
    var inverted = _a.inverted;
    return (inverted ? 'unset' : '100%');
}, function (_a) {
    var inverted = _a.inverted;
    return (inverted ? '100%' : 'unset');
});
var PanelView = styled__default.default(Spacing.Spacing).withConfig({ displayName: "PanelView", componentId: "-e8dmu3" })(templateObject_2$Q || (templateObject_2$Q = _tslib.__makeTemplateObject(["\n  background-color: ", ";\n  border-radius: ", "px;\n  box-shadow:\n    0 6px 24px rgba(35, 68, 101, 0.15),\n    0 6px 8px rgba(35, 68, 101, 0.15);\n  margin: 8px 0;\n"], ["\n  background-color: ", ";\n  border-radius: ", "px;\n  box-shadow:\n    0 6px 24px rgba(35, 68, 101, 0.15),\n    0 6px 8px rgba(35, 68, 101, 0.15);\n  margin: 8px 0;\n"])), styles.themeColors.white, styles.themeBorder.radius.default);
var PanelItemView$1 = styled__default.default(Spacing.Flex).withConfig({ displayName: "PanelItemView", componentId: "-17cwmhy" })(templateObject_3$B || (templateObject_3$B = _tslib.__makeTemplateObject(["\n  cursor: pointer;\n  padding: 8px 24px;\n  align-items: center;\n  text-decoration: none;\n  color: inherit;\n  display: flex;\n\n  svg {\n    fill: ", ";\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n  &:active {\n    background-color: ", ";\n  }\n\n  &.selected {\n    ", " {\n      color: ", ";\n    }\n\n    svg {\n      fill: ", ";\n    }\n  }\n"], ["\n  cursor: pointer;\n  padding: 8px 24px;\n  align-items: center;\n  text-decoration: none;\n  color: inherit;\n  display: flex;\n\n  svg {\n    fill: ", ";\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n  &:active {\n    background-color: ", ";\n  }\n\n  &.selected {\n    ", " {\n      color: ", ";\n    }\n\n    svg {\n      fill: ", ";\n    }\n  }\n"])), styles.themeColors.gray['80'], styles.themeColors.gray['10'], styles.themeColors.gray['20'], Hyperlink.textSelectors, styles.themeColors.blue['50'], styles.themeColors.blue['50']);
var templateObject_1$16, templateObject_2$Q, templateObject_3$B;

var InlinePanel = function (props) {
    var renderPanelItem = function (item, i) {
        var panelContent = (React__namespace.createElement(Spacing.Spacing, { bottom: 3, key: i },
            React__namespace.createElement(PanelItemView, { className: classNames__default.default({ selected: item.selected }), onClick: item.onClick },
                React__namespace.createElement(Spacing.Spacing, { left: 4 }),
                item.icon && (React__namespace.createElement(React__namespace.Fragment, null,
                    item.icon,
                    React__namespace.createElement(Spacing.Spacing, { left: true }))),
                React__namespace.createElement(Hyperlink.Text, { type: "heading_small", useCompact: true },
                    React__namespace.createElement("span", { style: { whiteSpace: 'nowrap' } }, item.text)))));
        if (props.renderPanelItem) {
            return React__namespace.createElement(React__namespace.Fragment, { key: i }, props.renderPanelItem(item, panelContent));
        }
        return panelContent;
    };
    return (React__namespace.createElement(Spacing.Spacing, { top: 3, style: { width: '100%' } },
        React__namespace.createElement(Spacing.Flex, { flexDir: "column" }, props.items.map(renderPanelItem))));
};
var PanelItemView = styled__default.default(Spacing.Flex).withConfig({ displayName: "PanelItemView", componentId: "-6q3mc0" })(templateObject_1$15 || (templateObject_1$15 = _tslib.__makeTemplateObject(["\n  cursor: pointer;\n  padding: 8px 0;\n  align-items: center;\n\n  svg {\n    fill: ", ";\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n  &:active {\n    background-color: ", ";\n  }\n\n  &.selected {\n    ", " {\n      color: ", ";\n    }\n\n    svg {\n      fill: ", ";\n    }\n  }\n"], ["\n  cursor: pointer;\n  padding: 8px 0;\n  align-items: center;\n\n  svg {\n    fill: ", ";\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n  &:active {\n    background-color: ", ";\n  }\n\n  &.selected {\n    ", " {\n      color: ", ";\n    }\n\n    svg {\n      fill: ", ";\n    }\n  }\n"])), styles.themeColors.gray['80'], styles.themeColors.gray['10'], styles.themeColors.gray['20'], Hyperlink.textSelectors, styles.themeColors.blue['50'], styles.themeColors.blue['50']);
var templateObject_1$15;

var textType = {
    small: 'body_small',
    regular: 'label',
    large: 'heading_small',
};
var showLeftIcon = function (type) { return type === 'left' || type === 'both'; };
var showRightIcon = function (type) { return type === 'right' || type === 'both'; };
var Dropdown = function (props) {
    var _a = _tslib.__read(React__namespace.useState(false), 2), opened = _a[0], setOpened = _a[1];
    var _b = _tslib.__read(ShouldDisplay.useHandleClickOutside(setOpened, props.variants.mode !== 'inline'), 4), indicatorRef = _b[0], panelRef = _b[1], onEnter = _b[2], onLeave = _b[3];
    props.onOpened && opened && props.onOpened();
    props.onClosed && !opened && props.onClosed();
    return (React__namespace.createElement(ShouldDisplay.OnLifecycle, { onEnter: onEnter, onLeave: onLeave },
        React__namespace.createElement(Spacing.Flex, { style: { position: 'relative' }, wrap: "wrap" },
            React__namespace.createElement(DropdownView, { ref: indicatorRef, align: "center", alignSelf: "flex-start", style: { cursor: 'pointer' }, onClick: function () { return setOpened(function (v) { return !v; }); }, mode: props.variants.mode, className: props.className },
                React__namespace.createElement(IndicatorView, { align: "center", className: "dropdown-indicator", ref: props.indicatorRef },
                    showLeftIcon(props.variants.type) && props.icon,
                    React__namespace.createElement(Spacing.Spacing, { horizontal: true },
                        React__namespace.createElement(Hyperlink.Text, { type: textType[props.variants.size], useCompact: true },
                            React__namespace.createElement("span", null, props.label))),
                    showRightIcon(props.variants.type) && (React__namespace.createElement(ArrowView$2, { mode: props.variants.mode, opened: opened, size: props.variants.size })),
                    props.children),
                React__namespace.createElement(DropdownPanel, { className: "dropdown-panel", visible: opened && props.variants.mode === 'dropdown', items: props.items, panelRef: panelRef, side: props.side, renderPanelItem: props.renderPanelItem })),
            opened && props.variants.mode === 'inline' && (React__namespace.createElement(InlinePanel, { items: props.items.map(function (it) { return (_tslib.__assign(_tslib.__assign({}, it), { onClick: function () {
                        var _a;
                        (_a = it.onClick) === null || _a === void 0 ? void 0 : _a.call(it);
                        setOpened(false);
                    } })); }), renderPanelItem: props.renderPanelItem, panelRef: panelRef })))));
};
var IndicatorView = styled__default.default(Spacing.Flex).withConfig({ displayName: "IndicatorView", componentId: "-8ioyv0" })(templateObject_1$14 || (templateObject_1$14 = _tslib.__makeTemplateObject(["\n  svg {\n    fill: ", ";\n  }\n\n  &:hover {\n    ", " {\n      color: ", ";\n    }\n    svg {\n      fill: ", ";\n    }\n  }\n"], ["\n  svg {\n    fill: ", ";\n  }\n\n  &:hover {\n    ", " {\n      color: ", ";\n    }\n    svg {\n      fill: ", ";\n    }\n  }\n"])), styles.themeColors.gray['80'], Hyperlink.textSelectors, styles.themeColors.gray['60'], styles.themeColors.gray['60']);
var DropdownView = styled__default.default(Spacing.Flex).withConfig({ displayName: "DropdownView", componentId: "-9x70co" })(templateObject_2$P || (templateObject_2$P = _tslib.__makeTemplateObject(["\n  position: relative;\n  ", "\n"], ["\n  position: relative;\n  ", "\n"])), function (props) { return (props.mode === 'inline' ? 'min-width: 100%;' : undefined); });
var templateObject_1$14, templateObject_2$P;

var Stores = function (props) {
    if (!props.stores) {
        return React__namespace.createElement(Spacing.Spacing, { top: 5 });
    }
    return (React__namespace.createElement(Spacing.Spacing, { vertical: 5 },
        React__namespace.createElement(Spacing.Flex, { gap: "16px" }, props.stores.map(function (item, index) { return (React__namespace.createElement("a", { href: item.downloadUrl, key: item.downloadUrl + String(index), target: item.target, rel: item.rel, className: item.className },
            React__namespace.createElement("img", { src: item.imageUrl }))); }))));
};

var Copyright = function (props) { return (React__namespace.createElement(React__namespace.Fragment, null,
    React__namespace.createElement(SeparatorView, { "$background": props.background }),
    React__namespace.createElement(Hyperlink.Text, { type: "compact_subtitle", color: "white" },
        React__namespace.createElement("span", null, props.copyright)))); };
var backgrounds$1 = {
    slate: styles.themeColors.slate[40],
    outerSpace: styles.themeColors.other.sdk.background,
};
var SeparatorView = styled__default.default.div.withConfig({ displayName: "SeparatorView", componentId: "-fx3uis" })(templateObject_1$13 || (templateObject_1$13 = _tslib.__makeTemplateObject(["\n  height: 1px;\n  width: 100%;\n  background-color: ", ";\n  margin: 16px 0;\n"], ["\n  height: 1px;\n  width: 100%;\n  background-color: ", ";\n  margin: 16px 0;\n"])), function (_a) {
    var $background = _a.$background;
    return ($background ? backgrounds$1[$background] : backgrounds$1.slate);
});
var templateObject_1$13;

var DescriptionColumn = function (_a) {
    var description = _a.description, _b = _a.product, product = _b === void 0 ? 'honeygain' : _b;
    return (React__namespace.createElement(TextColumn$1, { flexDir: "column" },
        logos[product],
        React__namespace.createElement(Spacing.Spacing, { top: 3 }),
        React__namespace.createElement(Hyperlink.Text, { type: "compact_body", color: "white" },
            React__namespace.createElement(Description, null, description))));
};
var logos = {
    honeygain: React__namespace.createElement(HoneygainLogoSdk.HoneygainLogoSecondary, { fill: "#fff", width: 136, height: "auto" }),
    carebuzz: React__namespace.createElement(HoneygainLogoSdk.CareBuzzLogoSecondaryLight, { width: 136, height: 23 }),
    sdk: React__namespace.createElement(HoneygainLogoSdk.HoneygainLogoSdk, { fill: "#fff", width: 176, height: 22 }),
};
var TextColumn$1 = styled__default.default(Spacing.Flex).withConfig({ displayName: "TextColumn", componentId: "-11ng8qf" })(templateObject_1$12 || (templateObject_1$12 = _tslib.__makeTemplateObject(["\n  max-width: 400px;\n"], ["\n  max-width: 400px;\n"])));
var Description = styled__default.default.p.withConfig({ displayName: "Description", componentId: "-1fb9def" })(templateObject_2$O || (templateObject_2$O = _tslib.__makeTemplateObject(["\n  @media ", " {\n    width: 90%;\n  }\n"], ["\n  @media ", " {\n    width: 90%;\n  }\n"])), ResponsiveSizes.desktop);
var templateObject_1$12, templateObject_2$O;

var Menu = function (props) {
    var _a;
    return (React__namespace.createElement(MenuColumnWrapper, null,
        React__namespace.createElement(MenuItemList, { menu: props.footerMenu.firstMenu }),
        React__namespace.createElement(MenuItemList, { menu: props.footerMenu.secondMenu }),
        React__namespace.createElement(MenuItemList, { menu: props.footerMenu.thirdMenu }),
        !!((_a = props.footerMenu.fourthMenu) === null || _a === void 0 ? void 0 : _a.length) && React__namespace.createElement(MenuItemList, { menu: props.footerMenu.fourthMenu })));
};
var MenuItemList = function (props) {
    return (React__namespace.createElement(MenuColumn, null, props.menu.map(function (item, idx) { return (React__namespace.createElement(MenuItem, { key: idx, url: item.url, target: item.target, className: item.classes ? classNames__default.default.apply(void 0, _tslib.__spreadArray([], _tslib.__read(item.classes), false)) : undefined }, item.name)); })));
};
var MenuItem = function (props) {
    if (!props.url || props.url === '#') {
        return (React__namespace.createElement("li", null,
            React__namespace.createElement(Hyperlink.Text, { type: "label", color: styles.themeColors.gray[40] },
                React__namespace.createElement("span", null, props.children))));
    }
    return (React__namespace.createElement("li", null,
        React__namespace.createElement(Hyperlink.Text, { type: "label", color: "white" },
            React__namespace.createElement("a", { href: props.url, target: props.target, className: props.className, rel: "noopener" }, props.children))));
};
var MenuColumnWrapper = styled__default.default.div.withConfig({ displayName: "MenuColumnWrapper", componentId: "-1kzmsuh" })(templateObject_1$11 || (templateObject_1$11 = _tslib.__makeTemplateObject(["\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-row-gap: 24px;\n  grid-column-gap: 16px;\n\n  @media ", " {\n    grid-auto-flow: column;\n    grid-auto-columns: 1fr;\n  }\n"], ["\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-row-gap: 24px;\n  grid-column-gap: 16px;\n\n  @media ", " {\n    grid-auto-flow: column;\n    grid-auto-columns: 1fr;\n  }\n"])), ResponsiveSizes.tablet);
var MenuColumn = styled__default.default.ul.withConfig({ displayName: "MenuColumn", componentId: "-1qvmsi7" })(templateObject_2$N || (templateObject_2$N = _tslib.__makeTemplateObject(["\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n\n  & > li + li {\n    margin-top: 8px;\n  }\n"], ["\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n\n  & > li + li {\n    margin-top: 8px;\n  }\n"])));
var templateObject_1$11, templateObject_2$N;

var toSocialObject = function (socialUrl) {
    if (!socialUrl) {
        return null;
    }
    if (typeof socialUrl === 'string') {
        return { url: socialUrl };
    }
    return socialUrl;
};
var Socials$1 = function (_a) {
    var socials = _a.socials;
    var facebook = toSocialObject(socials.facebookUrl);
    var instagram = toSocialObject(socials.instagramUrl);
    var twitter = toSocialObject(socials.twitterUrl);
    var discord = toSocialObject(socials.discordUrl);
    var tiktok = toSocialObject(socials.tiktokUrl);
    var youtube = toSocialObject(socials.youtubeUrl);
    return (React__namespace.createElement(SocialWrapper, null,
        React__namespace.createElement(SocialIconsWrapper, null,
            facebook && (React__namespace.createElement("a", { href: facebook.url, target: facebook.target, rel: "noopener" },
                React__namespace.createElement(AchievementStar.SocialFacebookRoundIcon, null))),
            instagram && (React__namespace.createElement("a", { href: instagram.url, target: instagram.target, rel: "noopener" },
                React__namespace.createElement(AchievementStar.SocialInstagramRoundIcon, null))),
            twitter && (React__namespace.createElement("a", { href: twitter.url, target: twitter.target, rel: "noopener" },
                React__namespace.createElement(AchievementStar.SocialTwitterRoundIcon, null))),
            discord && (React__namespace.createElement("a", { href: discord.url, target: discord.target, rel: "noopener" },
                React__namespace.createElement(AchievementStar.SocialDiscordRoundIcon, null))),
            tiktok && (React__namespace.createElement("a", { href: tiktok.url, target: tiktok.target, rel: "noopener" },
                React__namespace.createElement(AchievementStar.SocialTiktokRoundIcon, null))),
            youtube && (React__namespace.createElement("a", { href: youtube.url, target: youtube.target, rel: "noopener" },
                React__namespace.createElement(AchievementStar.SocialYoutubeRoundIcon, null))))));
};
var SocialWrapper = styled__default.default(Spacing.Flex).withConfig({ displayName: "SocialWrapper", componentId: "-jbhmoe" })(templateObject_1$10 || (templateObject_1$10 = _tslib.__makeTemplateObject(["\n  width: 100%;\n\n  @media ", " {\n    width: 50%;\n  }\n"], ["\n  width: 100%;\n\n  @media ", " {\n    width: 50%;\n  }\n"])), ResponsiveSizes.tablet);
var SocialIconsWrapper = styled__default.default(Spacing.Flex).withConfig({ displayName: "SocialIconsWrapper", componentId: "-1g073be" })(templateObject_2$M || (templateObject_2$M = _tslib.__makeTemplateObject(["\n  justify-content: space-between;\n\n  & > * + * {\n    margin-left: 16px;\n  }\n"], ["\n  justify-content: space-between;\n\n  & > * + * {\n    margin-left: 16px;\n  }\n"])));
var templateObject_1$10, templateObject_2$M;

var Footer = function (_a) {
    var _b = _a.product, product = _b === void 0 ? 'honeygain' : _b, props = _tslib.__rest(_a, ["product"]);
    var productBackground = product === 'sdk' ? 'outerSpace' : 'slate';
    return (React__namespace.createElement(WrapperView$3, { "$background": productBackground },
        React__namespace.createElement(Spacing.Spacing, { top: 6 }),
        React__namespace.createElement(Container$t, null,
            React__namespace.createElement(Grid$4, null,
                React__namespace.createElement(GridArea, { "$area": "description" },
                    React__namespace.createElement(DescriptionColumn, { description: props.description, product: product })),
                React__namespace.createElement(MenuWrapper, null,
                    React__namespace.createElement(Menu, { footerMenu: props.footerMenu })),
                React__namespace.createElement(GridArea, { "$area": "stores" },
                    React__namespace.createElement(Stores, { stores: props.stores })),
                React__namespace.createElement(GridArea, { "$area": "socials" },
                    React__namespace.createElement(Socials$1, { socials: props.socials })),
                React__namespace.createElement(GridArea, { "$area": "copy" },
                    React__namespace.createElement(Copyright, { copyright: props.copyright, background: productBackground })))),
        React__namespace.createElement(Spacing.Spacing, { top: 2 })));
};
var Grid$4 = styled__default.default.div.withConfig({ displayName: "Grid", componentId: "-18lqok4" })(templateObject_1$$ || (templateObject_1$$ = _tslib.__makeTemplateObject(["\n  display: grid;\n  grid-template-areas:\n    'description'\n    'stores'\n    'socials'\n    'menu'\n    'copy';\n\n  @media ", " {\n    grid-template-areas:\n      'description menu'\n      'stores menu'\n      'socials menu'\n      'copy copy';\n    grid-template-columns: minmax(auto, 450px) 1fr;\n  }\n"], ["\n  display: grid;\n  grid-template-areas:\n    'description'\n    'stores'\n    'socials'\n    'menu'\n    'copy';\n\n  @media ", " {\n    grid-template-areas:\n      'description menu'\n      'stores menu'\n      'socials menu'\n      'copy copy';\n    grid-template-columns: minmax(auto, 450px) 1fr;\n  }\n"])), ResponsiveSizes.desktop);
var GridArea = styled__default.default.div.withConfig({ displayName: "GridArea", componentId: "-jytqb1" })(templateObject_2$L || (templateObject_2$L = _tslib.__makeTemplateObject(["\n  grid-area: ", ";\n"], ["\n  grid-area: ", ";\n"])), function (_a) {
    var $area = _a.$area;
    return $area;
});
var MenuWrapper = styled__default.default.div.withConfig({ displayName: "MenuWrapper", componentId: "-7700cl" })(templateObject_3$A || (templateObject_3$A = _tslib.__makeTemplateObject(["\n  grid-area: menu;\n  margin-top: 80px;\n\n  @media ", " {\n    margin-top: 40px;\n  }\n\n  @media ", " {\n    margin-top: 0;\n  }\n"], ["\n  grid-area: menu;\n  margin-top: 80px;\n\n  @media ", " {\n    margin-top: 40px;\n  }\n\n  @media ", " {\n    margin-top: 0;\n  }\n"])), ResponsiveSizes.tablet, ResponsiveSizes.desktop);
var backgrounds = {
    slate: styles.themeColors.slate[50],
    outerSpace: styles.themeColors.other.sdk.background,
};
var WrapperView$3 = styled__default.default.footer.withConfig({ displayName: "WrapperView", componentId: "-jm660i" })(templateObject_4$q || (templateObject_4$q = _tslib.__makeTemplateObject(["\n  background-color: ", ";\n  color: white;\n"], ["\n  background-color: ", ";\n  color: white;\n"])), function (_a) {
    var $background = _a.$background;
    return ($background ? backgrounds[$background] : backgrounds.slate);
});
var templateObject_1$$, templateObject_2$L, templateObject_3$A, templateObject_4$q;

var sizeByMode = {
    dropdown: 'regular',
    inline: 'large',
};
var LanguageSwitcher = function (props) { return (React__namespace.createElement(Dropdown, { variants: { type: 'both', size: sizeByMode[props.mode], mode: props.mode }, icon: React__namespace.createElement(AchievementStar.LanguageIcon, null), label: React__namespace.createElement(React__namespace.Fragment, null, props.selectedLanguage.label), items: props.languages.map(function (item) { return ({
        text: "".concat(item.label, " (").concat(item.abbreviation, ")"),
        selected: item.isSelected,
        onClick: item.onClick,
        href: item.href,
    }); }), renderPanelItem: props.renderPanelItem })); };

var defaultSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10000,
    fade: true,
    cssEase: 'ease-in-out',
};
var Carousel = function (props) { return (React__namespace.createElement(CarouselView, null,
    React__namespace.createElement(SlickSlider__default.default, _tslib.__assign({}, _tslib.__assign(_tslib.__assign({}, defaultSettings), props.settings)), props.children))); };
var CarouselView = styled__default.default.div.withConfig({ displayName: "CarouselView", componentId: "-3o5ugv" })(templateObject_1$_ || (templateObject_1$_ = _tslib.__makeTemplateObject(["\n  .slick-dots {\n    position: relative;\n    bottom: initial;\n    padding-top: 24px;\n    height: 8px;\n    font-size: 0;\n\n    @media ", ", ", " {\n      padding-top: 16px;\n    }\n\n    li {\n      margin: 0 2px;\n      width: 8px;\n      height: 8px;\n\n      button {\n        width: 8px;\n        height: 8px;\n        border: 1px solid ", ";\n        border-radius: 50%;\n        padding: 0;\n\n        &:before {\n          content: '';\n          position: static;\n        }\n      }\n\n      &.slick-active {\n        button {\n          background-color: ", ";\n        }\n      }\n    }\n  }\n"], ["\n  .slick-dots {\n    position: relative;\n    bottom: initial;\n    padding-top: 24px;\n    height: 8px;\n    font-size: 0;\n\n    @media ", ", ", " {\n      padding-top: 16px;\n    }\n\n    li {\n      margin: 0 2px;\n      width: 8px;\n      height: 8px;\n\n      button {\n        width: 8px;\n        height: 8px;\n        border: 1px solid ", ";\n        border-radius: 50%;\n        padding: 0;\n\n        &:before {\n          content: '';\n          position: static;\n        }\n      }\n\n      &.slick-active {\n        button {\n          background-color: ", ";\n        }\n      }\n    }\n  }\n"])), ResponsiveSizes.media[ResponsiveSizes.BreakpointType.TABLET], ResponsiveSizes.media[ResponsiveSizes.BreakpointType.MOBILE], styles.themeColors.blue['50'], styles.themeColors.blue['50']);
var templateObject_1$_;

var CookieConsent = function (props) { return (React__namespace.createElement(Card$6, null,
    React__namespace.createElement(Wrapper, null,
        React__namespace.createElement(ImageView, { src: props.illustrationUrl, alt: "cookie consent" }),
        React__namespace.createElement(Spacing.Flex, { flexDir: Spacing.FlexDirection.COLUMN },
            React__namespace.createElement(Hyperlink.Text, { type: Hyperlink.TextType.HEADING_XSMALL, spacingType: Hyperlink.TextSpacingType.SMALLEST },
                React__namespace.createElement("h5", null, props.heading)),
            React__namespace.createElement(Hyperlink.Text, { type: Hyperlink.TextType.COMPACT_BODY }, props.content),
            React__namespace.createElement(CheckboxesWrapper, null,
                React__namespace.createElement(InputCheckbox, { checked: props.basicData.state, disabled: true }, props.basicData.label),
                React__namespace.createElement(InputCheckbox, { checked: props.usageStats.state, onChange: function (val) { return props.usageStats.setState(val); } }, props.usageStats.label),
                React__namespace.createElement(InputCheckbox, { checked: props.audienceData.state, onChange: function (val) { return props.audienceData.setState(val); } }, props.audienceData.label))),
        React__namespace.createElement(ButtonContainer$2, null,
            React__namespace.createElement(Button$3, { type: "primary", onClick: props.onPrimarySubmit }, props.primaryButtonText),
            React__namespace.createElement(Button$3, { type: "secondary", onClick: props.onSecondarySubmit }, props.secondaryButtonText))))); };
var Wrapper = styled__default.default.div.withConfig({ displayName: "Wrapper", componentId: "-79xwtm" })(templateObject_1$Z || (templateObject_1$Z = _tslib.__makeTemplateObject(["\n  display: flex;\n\n  @media ", ", ", " {\n    flex-direction: column;\n\n    h5 {\n      text-align: center;\n    }\n  }\n"], ["\n  display: flex;\n\n  @media ", ", ", " {\n    flex-direction: column;\n\n    h5 {\n      text-align: center;\n    }\n  }\n"])), ResponsiveSizes.media.tablet, ResponsiveSizes.media.mobile);
var CheckboxesWrapper = styled__default.default.div.withConfig({ displayName: "CheckboxesWrapper", componentId: "-13qi3ig" })(templateObject_2$K || (templateObject_2$K = _tslib.__makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: 8px;\n\n  label {\n    margin-top: 16px;\n    min-width: 140px;\n  }\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: 8px;\n\n  label {\n    margin-top: 16px;\n    min-width: 140px;\n  }\n"])));
var ImageView = styled__default.default.img.withConfig({ displayName: "ImageView", componentId: "-y449l4" })(templateObject_3$z || (templateObject_3$z = _tslib.__makeTemplateObject(["\n  margin-right: 24px;\n  flex-wrap: wrap;\n  align-self: center;\n\n  @media ", ", ", " {\n    display: none;\n  }\n"], ["\n  margin-right: 24px;\n  flex-wrap: wrap;\n  align-self: center;\n\n  @media ", ", ", " {\n    display: none;\n  }\n"])), ResponsiveSizes.media.tablet, ResponsiveSizes.media.mobile);
var ButtonContainer$2 = styled__default.default.div.withConfig({ displayName: "ButtonContainer", componentId: "-q71i88" })(templateObject_4$p || (templateObject_4$p = _tslib.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 192px;\n  margin-left: 24px;\n  height: 106px;\n  justify-content: space-between;\n  align-self: center;\n\n  button {\n    width: 100%;\n  }\n\n  @media ", ", ", " {\n    margin: 32px auto 0;\n    max-width: 256px;\n    width: 100%;\n    min-width: 100%;\n\n    button {\n      width: 256px;\n    }\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 192px;\n  margin-left: 24px;\n  height: 106px;\n  justify-content: space-between;\n  align-self: center;\n\n  button {\n    width: 100%;\n  }\n\n  @media ", ", ", " {\n    margin: 32px auto 0;\n    max-width: 256px;\n    width: 100%;\n    min-width: 100%;\n\n    button {\n      width: 256px;\n    }\n  }\n"])), ResponsiveSizes.media.tablet, ResponsiveSizes.media.mobile);
var templateObject_1$Z, templateObject_2$K, templateObject_3$z, templateObject_4$p;

var buildClassNames = function (base) { return ({
    afterOpen: "".concat(base, "__afterOpen"),
    base: base,
    beforeClose: "".concat(base, "__beforeClose"),
}); };
var Modal = function (_a) {
    var _b;
    var className = _a.className, onRequestClose = _a.onRequestClose, closeOnOverlayClick = _a.closeOnOverlayClick, closeOnEsc = _a.closeOnEsc, maxWidth = _a.maxWidth, children = _a.children, renderCloseButton = _a.renderCloseButton, closeButtonClassName = _a.closeButtonClassName;
    return (React__namespace.createElement(ModalContentView, { className: className, bodyOpenClassName: "Modal__bodyOpen", portalClassName: "Modal", isOpen: true, onRequestClose: onRequestClose, shouldReturnFocusAfterClose: false, overlayClassName: buildClassNames('ModalOverlay'), shouldCloseOnOverlayClick: closeOnOverlayClick, shouldCloseOnEsc: closeOnEsc, maxWidth: maxWidth },
        React__namespace.createElement(ContentView$3, { flexDir: "column", align: "center" }, (_b = renderCloseButton === null || renderCloseButton === void 0 ? void 0 : renderCloseButton(onRequestClose)) !== null && _b !== void 0 ? _b : (React__namespace.createElement(ExitIconView$1, null,
            React__namespace.createElement(FullSizeFlex$1, { align: "center", justify: "center" },
                React__namespace.createElement(AchievementStar.ModalCloseIcon, { className: closeButtonClassName, size: 40, onClick: onRequestClose })))),
            children)));
};
var ModalContentView = styled__default.default(ReactModal__default.default).withConfig({ displayName: "ModalContentView", componentId: "-e1ms7y" })(templateObject_1$Y || (templateObject_1$Y = _tslib.__makeTemplateObject(["\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow:\n    0 2px 10px 0 rgba(0, 0, 0, 0.05),\n    0 3px 1px -2px rgba(0, 0, 0, 0.05),\n    0 1px 15px 0 rgba(0, 0, 0, 0.2);\n  outline: none;\n  box-sizing: border-box;\n  overflow-y: auto;\n  max-height: 100%;\n  min-width: 320px;\n  max-width: ", ";\n  position: relative;\n"], ["\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow:\n    0 2px 10px 0 rgba(0, 0, 0, 0.05),\n    0 3px 1px -2px rgba(0, 0, 0, 0.05),\n    0 1px 15px 0 rgba(0, 0, 0, 0.2);\n  outline: none;\n  box-sizing: border-box;\n  overflow-y: auto;\n  max-height: 100%;\n  min-width: 320px;\n  max-width: ", ";\n  position: relative;\n"])), function (props) { return (props.maxWidth ? props.maxWidth : '555px'); });
var ContentView$3 = styled__default.default(Spacing.Flex).withConfig({ displayName: "ContentView", componentId: "-1mhuirl" })(templateObject_2$J || (templateObject_2$J = _tslib.__makeTemplateObject(["\n  overflow-y: auto;\n  margin: 0;\n"], ["\n  overflow-y: auto;\n  margin: 0;\n"])));
var ExitIconView$1 = styled__default.default.div.withConfig({ displayName: "ExitIconView", componentId: "-1kdsnzx" })(templateObject_3$y || (templateObject_3$y = _tslib.__makeTemplateObject(["\n  position: absolute;\n  right: 8px;\n  top: 8px;\n  height: 48px;\n  width: 48px;\n  z-index: 10;\n  &:hover {\n    background-color: ", ";\n    border-radius: 4px;\n  }\n  &:focus,\n  &:active {\n    background-color: ", ";\n    border-radius: 4px;\n    svg {\n      stroke: ", ";\n    }\n  }\n"], ["\n  position: absolute;\n  right: 8px;\n  top: 8px;\n  height: 48px;\n  width: 48px;\n  z-index: 10;\n  &:hover {\n    background-color: ", ";\n    border-radius: 4px;\n  }\n  &:focus,\n  &:active {\n    background-color: ", ";\n    border-radius: 4px;\n    svg {\n      stroke: ", ";\n    }\n  }\n"])), styles.themeColors.gray[20], styles.themeColors.gray[20], styles.themeColors.gray[70]);
var FullSizeFlex$1 = styled__default.default(Spacing.Flex).withConfig({ displayName: "FullSizeFlex", componentId: "-156d70" })(templateObject_4$o || (templateObject_4$o = _tslib.__makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n"], ["\n  width: 100%;\n  height: 100%;\n"])));
var templateObject_1$Y, templateObject_2$J, templateObject_3$y, templateObject_4$o;

var Popup = function (_a) {
    var title = _a.title, description = _a.description, leftRightButtons = _a.leftRightButtons, showAsBlock = _a.showAsBlock, leftImageUrl = _a.leftImageUrl, rightImageUrl = _a.rightImageUrl, mobileImageUrl = _a.mobileImageUrl, popupIsOpen = _a.popupIsOpen, biggerTitle = _a.biggerTitle, onPopupToggle = _a.onPopupToggle;
    var closeModal = function () {
        onPopupToggle(false);
    };
    var customStyles = {
        overlay: {
            background: 'rgba(60, 58, 58, 0.6)',
            zIndex: 1000,
        },
        content: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 'calc(100% - 54px)',
        },
    };
    var content = (React__namespace.default.createElement(React__namespace.default.Fragment, null,
        React__namespace.default.createElement(IconLeftContainer, null,
            React__namespace.default.createElement(Image$1, { src: leftImageUrl, alt: "", width: "100%", height: "100%" })),
        React__namespace.default.createElement(IconRightContainer, null,
            React__namespace.default.createElement(Image$1, { src: rightImageUrl, alt: "", width: "100%", height: "100%" })),
        React__namespace.default.createElement(IconMobileContainer, null,
            React__namespace.default.createElement("img", { src: mobileImageUrl, alt: "", width: "100%", height: "100%" })),
        React__namespace.default.createElement(PopupContent, null,
            React__namespace.default.createElement(ExitIconView, null,
                React__namespace.default.createElement(FullSizeFlex, { align: "center", justify: "center" },
                    React__namespace.default.createElement(AchievementStar.ModalCloseIcon, { size: 40, onClick: closeModal }))),
            React__namespace.default.createElement("div", null,
                React__namespace.default.createElement(Hyperlink.Text, { type: biggerTitle ? 'heading_large' : 'heading_medium', color: styles.themeColors.gray[90], align: "center" },
                    React__namespace.default.createElement("span", null, title))),
            !biggerTitle && (React__namespace.default.createElement("div", null,
                React__namespace.default.createElement(Spacing.Spacing, { top: 1 }),
                React__namespace.default.createElement(Hyperlink.Text, { type: "body", color: styles.themeColors.gray[90] },
                    React__namespace.default.createElement("span", null, description)))),
            React__namespace.default.createElement(Spacing.Spacing, { top: 4 }),
            leftRightButtons)));
    return (React__namespace.default.createElement(React__namespace.default.Fragment, null, showAsBlock ? (React__namespace.default.createElement(BlockContainer, null, content)) : (React__namespace.default.createElement(ModalContainer, { style: customStyles, isOpen: popupIsOpen, onRequestClose: closeModal, ariaHideApp: false }, content))));
};
var ContainerStyles = styled.css(templateObject_1$X || (templateObject_1$X = _tslib.__makeTemplateObject(["\n  max-width: 535px;\n  background-color: #fff;\n  border-radius: 8px;\n  outline: none;\n  box-shadow:\n    0 2px 10px 0 rgba(0, 0, 0, 0.05),\n    0 3px 1px -2px rgba(0, 0, 0, 0.05),\n    0 1px 15px 0 rgba(0, 0, 0, 0.2);\n"], ["\n  max-width: 535px;\n  background-color: #fff;\n  border-radius: 8px;\n  outline: none;\n  box-shadow:\n    0 2px 10px 0 rgba(0, 0, 0, 0.05),\n    0 3px 1px -2px rgba(0, 0, 0, 0.05),\n    0 1px 15px 0 rgba(0, 0, 0, 0.2);\n"])));
var ModalContainer = styled__default.default(ReactModal__default.default).withConfig({ displayName: "ModalContainer", componentId: "-1k6bdnk" })(templateObject_2$I || (templateObject_2$I = _tslib.__makeTemplateObject(["\n  position: absolute;\n\n  ", "\n"], ["\n  position: absolute;\n\n  ", "\n"])), ContainerStyles);
var BlockContainer = styled__default.default.div.withConfig({ displayName: "BlockContainer", componentId: "-ctemui" })(templateObject_3$x || (templateObject_3$x = _tslib.__makeTemplateObject(["\n  position: relative;\n  margin-right: auto;\n  margin-left: auto;\n  ", "\n"], ["\n  position: relative;\n  margin-right: auto;\n  margin-left: auto;\n  ", "\n"])), ContainerStyles);
var IconLeftContainer = styled__default.default.div.withConfig({ displayName: "IconLeftContainer", componentId: "-13pg94c" })(templateObject_4$n || (templateObject_4$n = _tslib.__makeTemplateObject(["\n  position: absolute;\n  left: -50px;\n  top: -30px;\n  @media ", " {\n    display: none;\n  }\n"], ["\n  position: absolute;\n  left: -50px;\n  top: -30px;\n  @media ", " {\n    display: none;\n  }\n"])), ResponsiveSizes.media.mobile);
var IconRightContainer = styled__default.default.div.withConfig({ displayName: "IconRightContainer", componentId: "-olhpzb" })(templateObject_5$k || (templateObject_5$k = _tslib.__makeTemplateObject(["\n  position: absolute;\n  right: -50px;\n  top: 80px;\n  @media ", " {\n    display: none;\n  }\n"], ["\n  position: absolute;\n  right: -50px;\n  top: 80px;\n  @media ", " {\n    display: none;\n  }\n"])), ResponsiveSizes.media.mobile);
var IconMobileContainer = styled__default.default.div.withConfig({ displayName: "IconMobileContainer", componentId: "-1hzhinv" })(templateObject_6$f || (templateObject_6$f = _tslib.__makeTemplateObject(["\n  display: none;\n  @media ", " {\n    display: block;\n    position: absolute;\n    left: 10px;\n    top: -40px;\n  }\n"], ["\n  display: none;\n  @media ", " {\n    display: block;\n    position: absolute;\n    left: 10px;\n    top: -40px;\n  }\n"])), ResponsiveSizes.media.mobile);
var Image$1 = styled__default.default.img.withConfig({ displayName: "Image", componentId: "-19atkng" })(templateObject_7$9 || (templateObject_7$9 = _tslib.__makeTemplateObject(["\n  width: 95px;\n"], ["\n  width: 95px;\n"])));
var PopupContent = styled__default.default.div.withConfig({ displayName: "PopupContent", componentId: "-1sg1mwl" })(templateObject_8$7 || (templateObject_8$7 = _tslib.__makeTemplateObject(["\n  padding: 64px;\n\n  @media ", " {\n    padding: 64px 24px;\n  }\n"], ["\n  padding: 64px;\n\n  @media ", " {\n    padding: 64px 24px;\n  }\n"])), ResponsiveSizes.media.mobile);
var ExitIconView = styled__default.default.div.withConfig({ displayName: "ExitIconView", componentId: "-brvri" })(templateObject_9$6 || (templateObject_9$6 = _tslib.__makeTemplateObject(["\n  position: absolute;\n  right: 8px;\n  top: 8px;\n  height: 48px;\n  width: 48px;\n  z-index: 10;\n  &:hover {\n    background-color: ", ";\n    border-radius: 4px;\n  }\n  &:focus,\n  &:active {\n    background-color: ", ";\n    border-radius: 4px;\n    svg {\n      stroke: ", ";\n    }\n  }\n"], ["\n  position: absolute;\n  right: 8px;\n  top: 8px;\n  height: 48px;\n  width: 48px;\n  z-index: 10;\n  &:hover {\n    background-color: ", ";\n    border-radius: 4px;\n  }\n  &:focus,\n  &:active {\n    background-color: ", ";\n    border-radius: 4px;\n    svg {\n      stroke: ", ";\n    }\n  }\n"])), styles.themeColors.gray[20], styles.themeColors.gray[20], styles.themeColors.gray[70]);
var FullSizeFlex = styled__default.default(Spacing.Flex).withConfig({ displayName: "FullSizeFlex", componentId: "-h1vfp7" })(templateObject_10$6 || (templateObject_10$6 = _tslib.__makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n"], ["\n  width: 100%;\n  height: 100%;\n"])));
var templateObject_1$X, templateObject_2$I, templateObject_3$x, templateObject_4$n, templateObject_5$k, templateObject_6$f, templateObject_7$9, templateObject_8$7, templateObject_9$6, templateObject_10$6;

var CustomInput = React__namespace.forwardRef(function (_a, ref) {
    _a.value; var onClick = _a.onClick, children = _a.children;
    return (React__namespace.createElement("div", { onClick: onClick, ref: ref, style: { cursor: 'pointer' } }, children));
});
CustomInput.displayName = 'CustomInput';
var MonthPicker = function (props) {
    var isMobile = props.size === ResponsiveSizes.BreakpointType.MOBILE || props.size === ResponsiveSizes.BreakpointType.TABLET;
    return (React__namespace.createElement(React__namespace.Fragment, null,
        props.withBackdrop && React__namespace.createElement(BackdropView, null),
        React__namespace.createElement(DatePickerView, null,
            React__namespace.createElement("div", { ref: props.pickerRef },
                React__namespace.createElement(DatePicker__default.default, { onCalendarClose: props.onClose, onCalendarOpen: props.onOpen, selected: props.selectedDate, onChange: props.onChange, showMonthYearPicker: true, maxDate: new Date(), minDate: props.minDate, showPopperArrow: false, popperPlacement: "top-start", inline: !props.toggleComponent && isMobile, customInput: React__namespace.createElement(CustomInput, null, props.toggleComponent), withPortal: !!props.toggleComponent && isMobile })))));
};
var BackdropView = styled__default.default.div.withConfig({ displayName: "BackdropView", componentId: "-1nsxdht" })(templateObject_1$W || (templateObject_1$W = _tslib.__makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.25);\n  width: 100vw;\n  height: 100vh;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.25);\n  width: 100vw;\n  height: 100vh;\n"])));
var DatePickerView = styled__default.default.div.withConfig({ displayName: "DatePickerView", componentId: "-1j3v80e" })(templateObject_2$H || (templateObject_2$H = _tslib.__makeTemplateObject(["\n  .react-datepicker {\n    background: ", ";\n    box-shadow:\n      0 4px 16px rgba(35, 68, 101, 0.05),\n      0 4px 4px rgba(35, 68, 101, 0.05);\n    border-radius: 8px;\n    width: 216px;\n    height: 208px;\n    border: none;\n\n    &__portal {\n      background-color: rgba(0, 0, 0, 0.25);\n    }\n\n    @media ", ", ", " {\n      position: fixed;\n      z-index: 1000;\n      width: 100%;\n      bottom: 0;\n      left: 0;\n    }\n  }\n\n  .react-datepicker__header {\n    border-bottom: none;\n    background-color: transparent;\n    color: ", ";\n    font-size: 16px;\n    font-family:\n      'Manrope',\n      -apple-system,\n      Helvetica Neue,\n      Arial,\n      Segoe UI,\n      sans-serif;\n    font-weight: 400;\n  }\n\n  .react-datepicker__navigation {\n    height: 51px;\n    width: 72px;\n  }\n\n  .react-datepicker__navigation-icon--previous::before,\n  .react-datepicker__navigation-icon--next::before {\n    border-color: ", ";\n    border-width: 2px 2px 0 0;\n    top: 19px;\n    width: 7px;\n    height: 7px;\n  }\n\n  .react-datepicker__month-container {\n    margin-top: 19px;\n    width: 100%;\n  }\n\n  .react-datepicker__month {\n    margin: 8px;\n\n    &--selected {\n      color: ", ";\n      background-color: ", "!important;\n      border-radius: 8px;\n    }\n\n    .react-datepicker__month-text {\n      width: 33%;\n      height: 33px;\n      margin: 0;\n      display: inline-flex;\n      justify-content: center;\n      align-items: center;\n      color: ", ";\n      font-family:\n        'Manrope',\n        -apple-system,\n        Helvetica Neue,\n        Arial,\n        Segoe UI,\n        sans-serif;\n      font-weight: 400;\n      font-size: 14px;\n\n      &--keyboard-selected {\n        background-color: transparent;\n      }\n\n      &--disabled {\n        color: ", ";\n        opacity: 0.6;\n      }\n\n      &:hover {\n        background-color: ", ";\n        border-radius: 8px;\n      }\n    }\n  }\n"], ["\n  .react-datepicker {\n    background: ", ";\n    box-shadow:\n      0 4px 16px rgba(35, 68, 101, 0.05),\n      0 4px 4px rgba(35, 68, 101, 0.05);\n    border-radius: 8px;\n    width: 216px;\n    height: 208px;\n    border: none;\n\n    &__portal {\n      background-color: rgba(0, 0, 0, 0.25);\n    }\n\n    @media ", ", ", " {\n      position: fixed;\n      z-index: 1000;\n      width: 100%;\n      bottom: 0;\n      left: 0;\n    }\n  }\n\n  .react-datepicker__header {\n    border-bottom: none;\n    background-color: transparent;\n    color: ", ";\n    font-size: 16px;\n    font-family:\n      'Manrope',\n      -apple-system,\n      Helvetica Neue,\n      Arial,\n      Segoe UI,\n      sans-serif;\n    font-weight: 400;\n  }\n\n  .react-datepicker__navigation {\n    height: 51px;\n    width: 72px;\n  }\n\n  .react-datepicker__navigation-icon--previous::before,\n  .react-datepicker__navigation-icon--next::before {\n    border-color: ", ";\n    border-width: 2px 2px 0 0;\n    top: 19px;\n    width: 7px;\n    height: 7px;\n  }\n\n  .react-datepicker__month-container {\n    margin-top: 19px;\n    width: 100%;\n  }\n\n  .react-datepicker__month {\n    margin: 8px;\n\n    &--selected {\n      color: ", ";\n      background-color: ", "!important;\n      border-radius: 8px;\n    }\n\n    .react-datepicker__month-text {\n      width: 33%;\n      height: 33px;\n      margin: 0;\n      display: inline-flex;\n      justify-content: center;\n      align-items: center;\n      color: ", ";\n      font-family:\n        'Manrope',\n        -apple-system,\n        Helvetica Neue,\n        Arial,\n        Segoe UI,\n        sans-serif;\n      font-weight: 400;\n      font-size: 14px;\n\n      &--keyboard-selected {\n        background-color: transparent;\n      }\n\n      &--disabled {\n        color: ", ";\n        opacity: 0.6;\n      }\n\n      &:hover {\n        background-color: ", ";\n        border-radius: 8px;\n      }\n    }\n  }\n"])), styles.themeColors.white, ResponsiveSizes.media.tablet, ResponsiveSizes.media.mobile, styles.themeColors.gray['90'], styles.themeColors.gray['50'], styles.themeColors.blue['50'], styles.themeColors.gray['10'], styles.themeColors.gray['90'], styles.themeColors.slate['20'], styles.themeColors.gray['10']);
var MonthPicker$1 = ResponsiveSizes.withSizes(ResponsiveSizes.mapSizesToProps)(MonthPicker);
var templateObject_1$W, templateObject_2$H;

var mapMarks = function (marks) {
    if (!marks) {
        return [];
    }
    var mappedMarks = {};
    for (var key in marks) {
        // eslint-disable-next-line security/detect-object-injection
        mappedMarks[key] = (React__namespace.createElement(Hyperlink.Text, { key: key, type: Hyperlink.TextType.SUBTITLE, color: styles.themeColors.gray['40'] },
            React__namespace.createElement(SliderMarkLabel, null, marks[key])));
    }
    return mappedMarks;
};
var Slider = function (props) {
    var _a;
    return (React__namespace.createElement("div", null,
        React__namespace.createElement(Spacing.Flex, { align: Spacing.FlexAlign.CENTER },
            React__namespace.createElement(Hyperlink.Text, { type: Hyperlink.TextType.HEADING_XSMALL, useCompact: true },
                React__namespace.createElement("span", null, props.label)),
            React__namespace.createElement(Spacing.Spacing, { left: 2 }),
            " ",
            props.onSwitch && React__namespace.createElement(Switch, { checked: (_a = props === null || props === void 0 ? void 0 : props.checked) !== null && _a !== void 0 ? _a : true, onSwitch: props.onSwitch })),
        React__namespace.createElement(Spacing.Spacing, { top: true }),
        React__namespace.createElement(SliderView, null,
            React__namespace.createElement(RCSlider__default.default, { disabled: props.disabled, onChange: props.onChange, min: props.min, max: props.max, defaultValue: props.defaultValue, marks: mapMarks(props.marks) })),
        React__namespace.createElement(Spacing.Flex, { justify: Spacing.FlexJustify.CENTER }, props.linkText && (React__namespace.createElement(Hyperlink.Hyperlink, { href: (props === null || props === void 0 ? void 0 : props.linkUrl) || '/', inNewWindow: true },
            React__namespace.createElement("span", null, props.linkText))))));
};
var SliderMarkLabel = styled__default.default.span.withConfig({ displayName: "SliderMarkLabel", componentId: "-49ibtk" })(templateObject_1$V || (templateObject_1$V = _tslib.__makeTemplateObject(["\n  user-select: none;\n"], ["\n  user-select: none;\n"])));
var SliderView = styled__default.default.div.withConfig({ displayName: "SliderView", componentId: "-6yg4am" })(templateObject_2$G || (templateObject_2$G = _tslib.__makeTemplateObject(["\n  .rc-slider {\n    position: relative;\n    height: 30px;\n    padding: 6px 0;\n    width: 100%;\n    border-radius: 4px;\n  }\n  .rc-slider * {\n    box-sizing: border-box;\n  }\n  .rc-slider-rail {\n    position: absolute;\n    width: 100%;\n    background-color: ", ";\n    height: 4px;\n    border-radius: 4px;\n  }\n  .rc-slider-disabled .rc-slider-rail {\n    background-color: ", ";\n  }\n\n  .rc-slider-track {\n    position: absolute;\n    left: 0;\n    height: 4px;\n    border-radius: 4px;\n    background-color: ", ";\n  }\n  .rc-slider-disabled .rc-slider-track {\n    background-color: ", ";\n  }\n\n  .rc-slider-handle {\n    position: absolute;\n    width: 16px;\n    height: 16px;\n    cursor: pointer;\n    margin-top: -6px;\n    border-radius: 50%;\n    background-color: ", ";\n  }\n  .rc-slider-disabled .rc-slider-handle {\n    background-color: ", ";\n    cursor: default;\n  }\n\n  .rc-slider-handle:focus {\n    outline: none;\n    box-shadow: 0 0 0 4px ", ";\n  }\n\n  .rc-slider-handle:hover {\n    background-color: ", ";\n  }\n\n  .rc-slider-handle:active {\n    background-color: ", ";\n  }\n\n  .rc-slider-disabled .rc-slider-handle:active {\n    background-color: ", ";\n  }\n\n  .rc-slider-disabled .rc-slider-handle:focus {\n    outline: none;\n    box-shadow: 0;\n  }\n\n  .rc-slider-disabled .rc-slider-handle:hover {\n    background-color: ", ";\n  }\n\n  .rc-slider-mark {\n    position: absolute;\n    top: 18px;\n    left: 0;\n    width: 100%;\n  }\n\n  .rc-slider-mark-text {\n    position: absolute;\n    display: inline-block;\n    vertical-align: middle;\n    text-align: center;\n    cursor: default;\n  }\n\n  .rc-slider-step {\n    position: absolute;\n    width: 100%;\n    height: 4px;\n    background: transparent;\n  }\n\n  .rc-slider-dot {\n    position: absolute;\n    bottom: -4px;\n    margin-left: -1px;\n    height: 3px;\n    width: 1px;\n    background-color: ", ";\n    cursor: pointer;\n  }\n"], ["\n  .rc-slider {\n    position: relative;\n    height: 30px;\n    padding: 6px 0;\n    width: 100%;\n    border-radius: 4px;\n  }\n  .rc-slider * {\n    box-sizing: border-box;\n  }\n  .rc-slider-rail {\n    position: absolute;\n    width: 100%;\n    background-color: ", ";\n    height: 4px;\n    border-radius: 4px;\n  }\n  .rc-slider-disabled .rc-slider-rail {\n    background-color: ", ";\n  }\n\n  .rc-slider-track {\n    position: absolute;\n    left: 0;\n    height: 4px;\n    border-radius: 4px;\n    background-color: ", ";\n  }\n  .rc-slider-disabled .rc-slider-track {\n    background-color: ", ";\n  }\n\n  .rc-slider-handle {\n    position: absolute;\n    width: 16px;\n    height: 16px;\n    cursor: pointer;\n    margin-top: -6px;\n    border-radius: 50%;\n    background-color: ", ";\n  }\n  .rc-slider-disabled .rc-slider-handle {\n    background-color: ", ";\n    cursor: default;\n  }\n\n  .rc-slider-handle:focus {\n    outline: none;\n    box-shadow: 0 0 0 4px ", ";\n  }\n\n  .rc-slider-handle:hover {\n    background-color: ", ";\n  }\n\n  .rc-slider-handle:active {\n    background-color: ", ";\n  }\n\n  .rc-slider-disabled .rc-slider-handle:active {\n    background-color: ", ";\n  }\n\n  .rc-slider-disabled .rc-slider-handle:focus {\n    outline: none;\n    box-shadow: 0;\n  }\n\n  .rc-slider-disabled .rc-slider-handle:hover {\n    background-color: ", ";\n  }\n\n  .rc-slider-mark {\n    position: absolute;\n    top: 18px;\n    left: 0;\n    width: 100%;\n  }\n\n  .rc-slider-mark-text {\n    position: absolute;\n    display: inline-block;\n    vertical-align: middle;\n    text-align: center;\n    cursor: default;\n  }\n\n  .rc-slider-step {\n    position: absolute;\n    width: 100%;\n    height: 4px;\n    background: transparent;\n  }\n\n  .rc-slider-dot {\n    position: absolute;\n    bottom: -4px;\n    margin-left: -1px;\n    height: 3px;\n    width: 1px;\n    background-color: ", ";\n    cursor: pointer;\n  }\n"])), styles.themeColors.gray['20'], styles.themeColors.gray['30'], styles.themeColors.blue['50'], styles.themeColors.gray['40'], styles.themeColors.blue['50'], styles.themeColors.gray['40'], styles.themeColors.blue['30'], styles.themeColors.blue['40'], styles.themeColors.blue['60'], styles.themeColors.gray['40'], styles.themeColors.gray['40'], styles.themeColors.gray['40']);
var templateObject_1$V, templateObject_2$G;

var ShareDropdown = function (_a) {
    var renderButton = _a.renderButton, shareParams = _tslib.__rest(_a, ["renderButton"]);
    var _b = hooks_index.useShare(shareParams), canShare = _b.canShare, handleShare = _b.handleShare, handleCopyLink = _b.handleCopyLink, handleShareFacebook = _b.handleShareFacebook, handleShareTwitter = _b.handleShareTwitter;
    return canShare ? (React__namespace.createElement(React__namespace.Fragment, null, renderButton({ onClick: handleShare }))) : (React__namespace.createElement(Dropdown, { side: "bottom", label: renderButton({}), variants: { mode: 'dropdown', size: 'regular', type: 'left' }, items: [
            {
                icon: React__namespace.createElement(AchievementStar.SocialFacebookRoundIcon, { width: 18, height: 18, fill: styles.themeColors.gray[80] }),
                text: 'Facebook',
                onClick: handleShareFacebook,
            },
            {
                icon: React__namespace.createElement(AchievementStar.SocialTwitterRoundIcon, { width: 18, height: 18, fill: styles.themeColors.gray[80] }),
                text: 'Twitter/X',
                onClick: handleShareTwitter,
            },
            {
                icon: React__namespace.createElement(Icon, { name: "share_filled", width: 18, height: 18, color: styles.themeColors.gray[80] }),
                text: 'Copy link',
                onClick: handleCopyLink,
            },
        ] }));
};

var Dialog = function (_a) {
    var trigger = _a.trigger, children = _a.children, renderCloseButton = _a.renderCloseButton, _b = _a.interactOutside, interactOutside = _b === void 0 ? true : _b, fullScreen = _a.fullScreen, props = _tslib.__rest(_a, ["trigger", "children", "renderCloseButton", "interactOutside", "fullScreen"]);
    return (React__namespace.createElement(RadixDialog__namespace.Root, _tslib.__assign({}, props),
        React__namespace.createElement(RadixDialog__namespace.Trigger, { asChild: true }, trigger),
        React__namespace.createElement(RadixDialog__namespace.Portal, { container: props.portalContainer },
            React__namespace.createElement(DialogOverlay, null),
            React__namespace.createElement(DialogContent, { "$fullScreen": fullScreen, style: { zIndex: 3 }, onInteractOutside: function (event) {
                    return interactOutside ? undefined : event.preventDefault();
                } },
                children,
                renderCloseButton != null ? (renderCloseButton()) : (React__namespace.createElement(RadixDialog__namespace.Close, { asChild: true },
                    React__namespace.createElement(IconButton, { "aria-label": "Close" },
                        React__namespace.createElement(AchievementStar.ModalCloseIcon, { size: 40 }))))))));
};
var overlayShow = styled.keyframes(templateObject_1$U || (templateObject_1$U = _tslib.__makeTemplateObject(["\n  0% { opacity: 0 }\n  100% { opacity: 1 }\n"], ["\n  0% { opacity: 0 }\n  100% { opacity: 1 }\n"])));
var contentShow = styled.keyframes(templateObject_2$F || (templateObject_2$F = _tslib.__makeTemplateObject(["\n  0% { opacity: 0; transform: translate(-50%, -48%) scale(.96); }\n  100% { opacity: 1; transform: translate(-50%, -50%) scale(1); }\n"], ["\n  0% { opacity: 0; transform: translate(-50%, -48%) scale(.96); }\n  100% { opacity: 1; transform: translate(-50%, -50%) scale(1); }\n"])));
var DialogOverlay = styled__default.default(RadixDialog__namespace.Overlay).withConfig({ displayName: "DialogOverlay", componentId: "-1hbrn18" })(templateObject_3$w || (templateObject_3$w = _tslib.__makeTemplateObject(["\n  background-color: rgba(0, 0, 0, 0.4);\n  position: fixed;\n  inset: 0;\n  animation: ", " 150ms cubic-bezier(0.16, 1, 0.3, 1);\n"], ["\n  background-color: rgba(0, 0, 0, 0.4);\n  position: fixed;\n  inset: 0;\n  animation: ", " 150ms cubic-bezier(0.16, 1, 0.3, 1);\n"])), overlayShow);
var DialogContent = styled__default.default(RadixDialog__namespace.Content).withConfig({ displayName: "DialogContent", componentId: "-181q0rl" })(templateObject_5$j || (templateObject_5$j = _tslib.__makeTemplateObject(["\n  overflow: auto;\n  box-sizing: border-box;\n  background-color: ", ";\n  border-radius: 8px;\n  box-shadow:\n    0 2px 10px 0 rgba(0, 0, 0, 0.05),\n    0 3px 1px -2px rgba(0, 0, 0, 0.05),\n    0 1px 15px 0 rgba(0, 0, 0, 0.2);\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  max-width: 555px;\n  max-height: 100%;\n  min-width: 320px;\n  animation: ", " 150ms cubic-bezier(0.16, 1, 0.3, 1);\n\n  ", "}\n"], ["\n  overflow: auto;\n  box-sizing: border-box;\n  background-color: ", ";\n  border-radius: 8px;\n  box-shadow:\n    0 2px 10px 0 rgba(0, 0, 0, 0.05),\n    0 3px 1px -2px rgba(0, 0, 0, 0.05),\n    0 1px 15px 0 rgba(0, 0, 0, 0.2);\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  max-width: 555px;\n  max-height: 100%;\n  min-width: 320px;\n  animation: ", " 150ms cubic-bezier(0.16, 1, 0.3, 1);\n\n  ", "}\n"])), styles.themeColors.white, contentShow, function (_a) {
    var $fullScreen = _a.$fullScreen;
    return $fullScreen && styled.css(templateObject_4$m || (templateObject_4$m = _tslib.__makeTemplateObject(["\n      width: 100%;\n      max-width: 100%;\n\n      @media ", " {\n        width: unset;\n        max-width: 555px;\n      }\n    "], ["\n      width: 100%;\n      max-width: 100%;\n\n      @media ", " {\n        width: unset;\n        max-width: 555px;\n      }\n    "])), ResponsiveSizes.desktop);
});
var IconButton = styled__default.default.button.withConfig({ displayName: "IconButton", componentId: "-1wxxgyq" })(templateObject_6$e || (templateObject_6$e = _tslib.__makeTemplateObject(["\n  all: unset;\n  font-family: inherit;\n  height: 40px;\n  width: 40px;\n  border-radius: 4px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 8px;\n  right: 8px;\n\n  &:hover,\n  &:active {\n    background-color: ", ";\n  }\n\n  &:focus {\n    box-shadow: 0 0 0 4px ", ";\n  }\n\n  &:active {\n    svg {\n      stroke: ", ";\n    }\n  }\n"], ["\n  all: unset;\n  font-family: inherit;\n  height: 40px;\n  width: 40px;\n  border-radius: 4px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 8px;\n  right: 8px;\n\n  &:hover,\n  &:active {\n    background-color: ", ";\n  }\n\n  &:focus {\n    box-shadow: 0 0 0 4px ", ";\n  }\n\n  &:active {\n    svg {\n      stroke: ", ";\n    }\n  }\n"])), styles.themeColors.gray[20], styles.themeColors.blue[30], styles.themeColors.gray[70]);
var templateObject_1$U, templateObject_2$F, templateObject_3$w, templateObject_4$m, templateObject_5$j, templateObject_6$e;

/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */
/* eslint-disable no-param-reassign */
function isObject$2(obj) {
  return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
}
function extend$2(target, src) {
  if (target === void 0) {
    target = {};
  }
  if (src === void 0) {
    src = {};
  }
  Object.keys(src).forEach(key => {
    if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject$2(src[key]) && isObject$2(target[key]) && Object.keys(src[key]).length > 0) {
      extend$2(target[key], src[key]);
    }
  });
}
const ssrDocument = {
  body: {},
  addEventListener() {},
  removeEventListener() {},
  activeElement: {
    blur() {},
    nodeName: ''
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {}
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {},
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: ''
  }
};
function getDocument() {
  const doc = typeof document !== 'undefined' ? document : {};
  extend$2(doc, ssrDocument);
  return doc;
}
const ssrWindow = {
  document: ssrDocument,
  navigator: {
    userAgent: ''
  },
  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: ''
  },
  history: {
    replaceState() {},
    pushState() {},
    go() {},
    back() {}
  },
  CustomEvent: function CustomEvent() {
    return this;
  },
  addEventListener() {},
  removeEventListener() {},
  getComputedStyle() {
    return {
      getPropertyValue() {
        return '';
      }
    };
  },
  Image() {},
  Date() {},
  screen: {},
  setTimeout() {},
  clearTimeout() {},
  matchMedia() {
    return {};
  },
  requestAnimationFrame(callback) {
    if (typeof setTimeout === 'undefined') {
      callback();
      return null;
    }
    return setTimeout(callback, 0);
  },
  cancelAnimationFrame(id) {
    if (typeof setTimeout === 'undefined') {
      return;
    }
    clearTimeout(id);
  }
};
function getWindow() {
  const win = typeof window !== 'undefined' ? window : {};
  extend$2(win, ssrWindow);
  return win;
}

function deleteProps(obj) {
  const object = obj;
  Object.keys(object).forEach(key => {
    try {
      object[key] = null;
    } catch (e) {
      // no getter for object
    }
    try {
      delete object[key];
    } catch (e) {
      // something got wrong
    }
  });
}
function nextTick(callback, delay) {
  if (delay === void 0) {
    delay = 0;
  }
  return setTimeout(callback, delay);
}
function now() {
  return Date.now();
}
function getComputedStyle$1(el) {
  const window = getWindow();
  let style;
  if (window.getComputedStyle) {
    style = window.getComputedStyle(el, null);
  }
  if (!style && el.currentStyle) {
    style = el.currentStyle;
  }
  if (!style) {
    style = el.style;
  }
  return style;
}
function getTranslate(el, axis) {
  if (axis === void 0) {
    axis = 'x';
  }
  const window = getWindow();
  let matrix;
  let curTransform;
  let transformMatrix;
  const curStyle = getComputedStyle$1(el);
  if (window.WebKitCSSMatrix) {
    curTransform = curStyle.transform || curStyle.webkitTransform;
    if (curTransform.split(',').length > 6) {
      curTransform = curTransform.split(', ').map(a => a.replace(',', '.')).join(', ');
    }
    // Some old versions of Webkit choke when 'none' is passed; pass
    // empty string instead in this case
    transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
  } else {
    transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
    matrix = transformMatrix.toString().split(',');
  }
  if (axis === 'x') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41;
    // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
    // Normal Browsers
    else curTransform = parseFloat(matrix[4]);
  }
  if (axis === 'y') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42;
    // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
    // Normal Browsers
    else curTransform = parseFloat(matrix[5]);
  }
  return curTransform || 0;
}
function isObject$1(o) {
  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}
function isNode(node) {
  // eslint-disable-next-line
  if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') {
    return node instanceof HTMLElement;
  }
  return node && (node.nodeType === 1 || node.nodeType === 11);
}
function extend$1() {
  const to = Object(arguments.length <= 0 ? undefined : arguments[0]);
  const noExtend = ['__proto__', 'constructor', 'prototype'];
  for (let i = 1; i < arguments.length; i += 1) {
    const nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];
    if (nextSource !== undefined && nextSource !== null && !isNode(nextSource)) {
      const keysArray = Object.keys(Object(nextSource)).filter(key => noExtend.indexOf(key) < 0);
      for (let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
        const nextKey = keysArray[nextIndex];
        const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
        if (desc !== undefined && desc.enumerable) {
          if (isObject$1(to[nextKey]) && isObject$1(nextSource[nextKey])) {
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend$1(to[nextKey], nextSource[nextKey]);
            }
          } else if (!isObject$1(to[nextKey]) && isObject$1(nextSource[nextKey])) {
            to[nextKey] = {};
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend$1(to[nextKey], nextSource[nextKey]);
            }
          } else {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
  }
  return to;
}
function setCSSProperty(el, varName, varValue) {
  el.style.setProperty(varName, varValue);
}
function animateCSSModeScroll(_ref) {
  let {
    swiper,
    targetPosition,
    side
  } = _ref;
  const window = getWindow();
  const startPosition = -swiper.translate;
  let startTime = null;
  let time;
  const duration = swiper.params.speed;
  swiper.wrapperEl.style.scrollSnapType = 'none';
  window.cancelAnimationFrame(swiper.cssModeFrameID);
  const dir = targetPosition > startPosition ? 'next' : 'prev';
  const isOutOfBound = (current, target) => {
    return dir === 'next' && current >= target || dir === 'prev' && current <= target;
  };
  const animate = () => {
    time = new Date().getTime();
    if (startTime === null) {
      startTime = time;
    }
    const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
    const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
    let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
    if (isOutOfBound(currentPosition, targetPosition)) {
      currentPosition = targetPosition;
    }
    swiper.wrapperEl.scrollTo({
      [side]: currentPosition
    });
    if (isOutOfBound(currentPosition, targetPosition)) {
      swiper.wrapperEl.style.overflow = 'hidden';
      swiper.wrapperEl.style.scrollSnapType = '';
      setTimeout(() => {
        swiper.wrapperEl.style.overflow = '';
        swiper.wrapperEl.scrollTo({
          [side]: currentPosition
        });
      });
      window.cancelAnimationFrame(swiper.cssModeFrameID);
      return;
    }
    swiper.cssModeFrameID = window.requestAnimationFrame(animate);
  };
  animate();
}
function elementChildren(element, selector) {
  if (selector === void 0) {
    selector = '';
  }
  return [...element.children].filter(el => el.matches(selector));
}
function createElement(tag, classes) {
  if (classes === void 0) {
    classes = [];
  }
  const el = document.createElement(tag);
  el.classList.add(...(Array.isArray(classes) ? classes : [classes]));
  return el;
}
function elementPrevAll(el, selector) {
  const prevEls = [];
  while (el.previousElementSibling) {
    const prev = el.previousElementSibling; // eslint-disable-line
    if (selector) {
      if (prev.matches(selector)) prevEls.push(prev);
    } else prevEls.push(prev);
    el = prev;
  }
  return prevEls;
}
function elementNextAll(el, selector) {
  const nextEls = [];
  while (el.nextElementSibling) {
    const next = el.nextElementSibling; // eslint-disable-line
    if (selector) {
      if (next.matches(selector)) nextEls.push(next);
    } else nextEls.push(next);
    el = next;
  }
  return nextEls;
}
function elementStyle(el, prop) {
  const window = getWindow();
  return window.getComputedStyle(el, null).getPropertyValue(prop);
}
function elementIndex(el) {
  let child = el;
  let i;
  if (child) {
    i = 0;
    // eslint-disable-next-line
    while ((child = child.previousSibling) !== null) {
      if (child.nodeType === 1) i += 1;
    }
    return i;
  }
  return undefined;
}
function elementParents(el, selector) {
  const parents = []; // eslint-disable-line
  let parent = el.parentElement; // eslint-disable-line
  while (parent) {
    if (selector) {
      if (parent.matches(selector)) parents.push(parent);
    } else {
      parents.push(parent);
    }
    parent = parent.parentElement;
  }
  return parents;
}
function elementTransitionEnd(el, callback) {
  function fireCallBack(e) {
    if (e.target !== el) return;
    callback.call(el, e);
    el.removeEventListener('transitionend', fireCallBack);
  }
  if (callback) {
    el.addEventListener('transitionend', fireCallBack);
  }
}
function elementOuterSize(el, size, includeMargins) {
  const window = getWindow();
  if (includeMargins) {
    return el[size === 'width' ? 'offsetWidth' : 'offsetHeight'] + parseFloat(window.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-right' : 'margin-top')) + parseFloat(window.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-left' : 'margin-bottom'));
  }
  return el.offsetWidth;
}

/* eslint-disable consistent-return */
function Mousewheel(_ref) {
  let {
    swiper,
    extendParams,
    on,
    emit
  } = _ref;
  const window = getWindow();
  extendParams({
    mousewheel: {
      enabled: false,
      releaseOnEdges: false,
      invert: false,
      forceToAxis: false,
      sensitivity: 1,
      eventsTarget: 'container',
      thresholdDelta: null,
      thresholdTime: null,
      noMousewheelClass: 'swiper-no-mousewheel'
    }
  });
  swiper.mousewheel = {
    enabled: false
  };
  let timeout;
  let lastScrollTime = now();
  let lastEventBeforeSnap;
  const recentWheelEvents = [];
  function normalize(e) {
    // Reasonable defaults
    const PIXEL_STEP = 10;
    const LINE_HEIGHT = 40;
    const PAGE_HEIGHT = 800;
    let sX = 0;
    let sY = 0; // spinX, spinY
    let pX = 0;
    let pY = 0; // pixelX, pixelY

    // Legacy
    if ('detail' in e) {
      sY = e.detail;
    }
    if ('wheelDelta' in e) {
      sY = -e.wheelDelta / 120;
    }
    if ('wheelDeltaY' in e) {
      sY = -e.wheelDeltaY / 120;
    }
    if ('wheelDeltaX' in e) {
      sX = -e.wheelDeltaX / 120;
    }

    // side scrolling on FF with DOMMouseScroll
    if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
      sX = sY;
      sY = 0;
    }
    pX = sX * PIXEL_STEP;
    pY = sY * PIXEL_STEP;
    if ('deltaY' in e) {
      pY = e.deltaY;
    }
    if ('deltaX' in e) {
      pX = e.deltaX;
    }
    if (e.shiftKey && !pX) {
      // if user scrolls with shift he wants horizontal scroll
      pX = pY;
      pY = 0;
    }
    if ((pX || pY) && e.deltaMode) {
      if (e.deltaMode === 1) {
        // delta in LINE units
        pX *= LINE_HEIGHT;
        pY *= LINE_HEIGHT;
      } else {
        // delta in PAGE units
        pX *= PAGE_HEIGHT;
        pY *= PAGE_HEIGHT;
      }
    }

    // Fall-back if spin cannot be determined
    if (pX && !sX) {
      sX = pX < 1 ? -1 : 1;
    }
    if (pY && !sY) {
      sY = pY < 1 ? -1 : 1;
    }
    return {
      spinX: sX,
      spinY: sY,
      pixelX: pX,
      pixelY: pY
    };
  }
  function handleMouseEnter() {
    if (!swiper.enabled) return;
    swiper.mouseEntered = true;
  }
  function handleMouseLeave() {
    if (!swiper.enabled) return;
    swiper.mouseEntered = false;
  }
  function animateSlider(newEvent) {
    if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) {
      // Prevent if delta of wheel scroll delta is below configured threshold
      return false;
    }
    if (swiper.params.mousewheel.thresholdTime && now() - lastScrollTime < swiper.params.mousewheel.thresholdTime) {
      // Prevent if time between scrolls is below configured threshold
      return false;
    }

    // If the movement is NOT big enough and
    // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
    //   Don't go any further (avoid insignificant scroll movement).
    if (newEvent.delta >= 6 && now() - lastScrollTime < 60) {
      // Return false as a default
      return true;
    }
    // If user is scrolling towards the end:
    //   If the slider hasn't hit the latest slide or
    //   if the slider is a loop and
    //   if the slider isn't moving right now:
    //     Go to next slide and
    //     emit a scroll event.
    // Else (the user is scrolling towards the beginning) and
    // if the slider hasn't hit the first slide or
    // if the slider is a loop and
    // if the slider isn't moving right now:
    //   Go to prev slide and
    //   emit a scroll event.
    if (newEvent.direction < 0) {
      if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
        swiper.slideNext();
        emit('scroll', newEvent.raw);
      }
    } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
      swiper.slidePrev();
      emit('scroll', newEvent.raw);
    }
    // If you got here is because an animation has been triggered so store the current time
    lastScrollTime = new window.Date().getTime();
    // Return false as a default
    return false;
  }
  function releaseScroll(newEvent) {
    const params = swiper.params.mousewheel;
    if (newEvent.direction < 0) {
      if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) {
        // Return true to animate scroll on edges
        return true;
      }
    } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) {
      // Return true to animate scroll on edges
      return true;
    }
    return false;
  }
  function handle(event) {
    let e = event;
    let disableParentSwiper = true;
    if (!swiper.enabled) return;

    // Ignore event if the target or its parents have the swiper-no-mousewheel class
    if (event.target.closest(`.${swiper.params.mousewheel.noMousewheelClass}`)) return;
    const params = swiper.params.mousewheel;
    if (swiper.params.cssMode) {
      e.preventDefault();
    }
    let targetEl = swiper.el;
    if (swiper.params.mousewheel.eventsTarget !== 'container') {
      targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
    }
    const targetElContainsTarget = targetEl && targetEl.contains(e.target);
    if (!swiper.mouseEntered && !targetElContainsTarget && !params.releaseOnEdges) return true;
    if (e.originalEvent) e = e.originalEvent; // jquery fix
    let delta = 0;
    const rtlFactor = swiper.rtlTranslate ? -1 : 1;
    const data = normalize(e);
    if (params.forceToAxis) {
      if (swiper.isHorizontal()) {
        if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;else return true;
      } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;else return true;
    } else {
      delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
    }
    if (delta === 0) return true;
    if (params.invert) delta = -delta;

    // Get the scroll positions
    let positions = swiper.getTranslate() + delta * params.sensitivity;
    if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
    if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate();

    // When loop is true:
    //     the disableParentSwiper will be true.
    // When loop is false:
    //     if the scroll positions is not on edge,
    //     then the disableParentSwiper will be true.
    //     if the scroll on edge positions,
    //     then the disableParentSwiper will be false.
    disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
    if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
    if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
      // Register the new event in a variable which stores the relevant data
      const newEvent = {
        time: now(),
        delta: Math.abs(delta),
        direction: Math.sign(delta),
        raw: event
      };

      // Keep the most recent events
      if (recentWheelEvents.length >= 2) {
        recentWheelEvents.shift(); // only store the last N events
      }

      const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
      recentWheelEvents.push(newEvent);

      // If there is at least one previous recorded event:
      //   If direction has changed or
      //   if the scroll is quicker than the previous one:
      //     Animate the slider.
      // Else (this is the first time the wheel is moved):
      //     Animate the slider.
      if (prevEvent) {
        if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) {
          animateSlider(newEvent);
        }
      } else {
        animateSlider(newEvent);
      }

      // If it's time to release the scroll:
      //   Return now so you don't hit the preventDefault.
      if (releaseScroll(newEvent)) {
        return true;
      }
    } else {
      // Freemode or scrollContainer:

      // If we recently snapped after a momentum scroll, then ignore wheel events
      // to give time for the deceleration to finish. Stop ignoring after 500 msecs
      // or if it's a new scroll (larger delta or inverse sign as last event before
      // an end-of-momentum snap).
      const newEvent = {
        time: now(),
        delta: Math.abs(delta),
        direction: Math.sign(delta)
      };
      const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
      if (!ignoreWheelEvents) {
        lastEventBeforeSnap = undefined;
        let position = swiper.getTranslate() + delta * params.sensitivity;
        const wasBeginning = swiper.isBeginning;
        const wasEnd = swiper.isEnd;
        if (position >= swiper.minTranslate()) position = swiper.minTranslate();
        if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
        swiper.setTransition(0);
        swiper.setTranslate(position);
        swiper.updateProgress();
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
        if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) {
          swiper.updateSlidesClasses();
        }
        if (swiper.params.loop) {
          swiper.loopFix({
            direction: newEvent.direction < 0 ? 'next' : 'prev',
            byMousewheel: true
          });
        }
        if (swiper.params.freeMode.sticky) {
          // When wheel scrolling starts with sticky (aka snap) enabled, then detect
          // the end of a momentum scroll by storing recent (N=15?) wheel events.
          // 1. do all N events have decreasing or same (absolute value) delta?
          // 2. did all N events arrive in the last M (M=500?) msecs?
          // 3. does the earliest event have an (absolute value) delta that's
          //    at least P (P=1?) larger than the most recent event's delta?
          // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
          // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
          // Snap immediately and ignore remaining wheel events in this scroll.
          // See comment above for "remaining wheel events in this scroll" determination.
          // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
          clearTimeout(timeout);
          timeout = undefined;
          if (recentWheelEvents.length >= 15) {
            recentWheelEvents.shift(); // only store the last N events
          }

          const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
          const firstEvent = recentWheelEvents[0];
          recentWheelEvents.push(newEvent);
          if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) {
            // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
            recentWheelEvents.splice(0);
          } else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
            // We're at the end of the deceleration of a momentum scroll, so there's no need
            // to wait for more events. Snap ASAP on the next tick.
            // Also, because there's some remaining momentum we'll bias the snap in the
            // direction of the ongoing scroll because it's better UX for the scroll to snap
            // in the same direction as the scroll instead of reversing to snap.  Therefore,
            // if it's already scrolled more than 20% in the current direction, keep going.
            const snapToThreshold = delta > 0 ? 0.8 : 0.2;
            lastEventBeforeSnap = newEvent;
            recentWheelEvents.splice(0);
            timeout = nextTick(() => {
              swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
            }, 0); // no delay; move on next tick
          }

          if (!timeout) {
            // if we get here, then we haven't detected the end of a momentum scroll, so
            // we'll consider a scroll "complete" when there haven't been any wheel events
            // for 500ms.
            timeout = nextTick(() => {
              const snapToThreshold = 0.5;
              lastEventBeforeSnap = newEvent;
              recentWheelEvents.splice(0);
              swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
            }, 500);
          }
        }

        // Emit event
        if (!ignoreWheelEvents) emit('scroll', e);

        // Stop autoplay
        if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop();
        // Return page scroll on edge positions
        if (params.releaseOnEdges && (position === swiper.minTranslate() || position === swiper.maxTranslate())) {
          return true;
        }
      }
    }
    if (e.preventDefault) e.preventDefault();else e.returnValue = false;
    return false;
  }
  function events(method) {
    let targetEl = swiper.el;
    if (swiper.params.mousewheel.eventsTarget !== 'container') {
      targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
    }
    targetEl[method]('mouseenter', handleMouseEnter);
    targetEl[method]('mouseleave', handleMouseLeave);
    targetEl[method]('wheel', handle);
  }
  function enable() {
    if (swiper.params.cssMode) {
      swiper.wrapperEl.removeEventListener('wheel', handle);
      return true;
    }
    if (swiper.mousewheel.enabled) return false;
    events('addEventListener');
    swiper.mousewheel.enabled = true;
    return true;
  }
  function disable() {
    if (swiper.params.cssMode) {
      swiper.wrapperEl.addEventListener(event, handle);
      return true;
    }
    if (!swiper.mousewheel.enabled) return false;
    events('removeEventListener');
    swiper.mousewheel.enabled = false;
    return true;
  }
  on('init', () => {
    if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) {
      disable();
    }
    if (swiper.params.mousewheel.enabled) enable();
  });
  on('destroy', () => {
    if (swiper.params.cssMode) {
      enable();
    }
    if (swiper.mousewheel.enabled) disable();
  });
  Object.assign(swiper.mousewheel, {
    enable,
    disable
  });
}

function createElementIfNotDefined(swiper, originalParams, params, checkProps) {
  if (swiper.params.createElements) {
    Object.keys(checkProps).forEach(key => {
      if (!params[key] && params.auto === true) {
        let element = elementChildren(swiper.el, `.${checkProps[key]}`)[0];
        if (!element) {
          element = createElement('div', checkProps[key]);
          element.className = checkProps[key];
          swiper.el.append(element);
        }
        params[key] = element;
        originalParams[key] = element;
      }
    });
  }
  return params;
}

function classesToSelector(classes) {
  if (classes === void 0) {
    classes = '';
  }
  return `.${classes.trim().replace(/([\.:!+\/])/g, '\\$1') // eslint-disable-line
  .replace(/ /g, '.')}`;
}

function Pagination(_ref) {
  let {
    swiper,
    extendParams,
    on,
    emit
  } = _ref;
  const pfx = 'swiper-pagination';
  extendParams({
    pagination: {
      el: null,
      bulletElement: 'span',
      clickable: false,
      hideOnClick: false,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: false,
      type: 'bullets',
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: false,
      dynamicMainBullets: 1,
      formatFractionCurrent: number => number,
      formatFractionTotal: number => number,
      bulletClass: `${pfx}-bullet`,
      bulletActiveClass: `${pfx}-bullet-active`,
      modifierClass: `${pfx}-`,
      currentClass: `${pfx}-current`,
      totalClass: `${pfx}-total`,
      hiddenClass: `${pfx}-hidden`,
      progressbarFillClass: `${pfx}-progressbar-fill`,
      progressbarOppositeClass: `${pfx}-progressbar-opposite`,
      clickableClass: `${pfx}-clickable`,
      lockClass: `${pfx}-lock`,
      horizontalClass: `${pfx}-horizontal`,
      verticalClass: `${pfx}-vertical`,
      paginationDisabledClass: `${pfx}-disabled`
    }
  });
  swiper.pagination = {
    el: null,
    bullets: []
  };
  let bulletSize;
  let dynamicBulletIndex = 0;
  const makeElementsArray = el => (Array.isArray(el) ? el : [el]).filter(e => !!e);
  function isPaginationDisabled() {
    return !swiper.params.pagination.el || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
  }
  function setSideBullets(bulletEl, position) {
    const {
      bulletActiveClass
    } = swiper.params.pagination;
    if (!bulletEl) return;
    bulletEl = bulletEl[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
    if (bulletEl) {
      bulletEl.classList.add(`${bulletActiveClass}-${position}`);
      bulletEl = bulletEl[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
      if (bulletEl) {
        bulletEl.classList.add(`${bulletActiveClass}-${position}-${position}`);
      }
    }
  }
  function onBulletClick(e) {
    const bulletEl = e.target.closest(classesToSelector(swiper.params.pagination.bulletClass));
    if (!bulletEl) {
      return;
    }
    e.preventDefault();
    const index = elementIndex(bulletEl) * swiper.params.slidesPerGroup;
    if (swiper.params.loop) {
      if (swiper.realIndex === index) return;
      const realIndex = swiper.realIndex;
      const newSlideIndex = swiper.getSlideIndexByData(index);
      const currentSlideIndex = swiper.getSlideIndexByData(swiper.realIndex);
      const loopFix = dir => {
        const indexBeforeLoopFix = swiper.activeIndex;
        swiper.loopFix({
          direction: dir,
          activeSlideIndex: newSlideIndex,
          slideTo: false
        });
        const indexAfterFix = swiper.activeIndex;
        if (indexBeforeLoopFix === indexAfterFix) {
          swiper.slideToLoop(realIndex, 0, false, true);
        }
      };
      if (newSlideIndex > swiper.slides.length - swiper.loopedSlides) {
        loopFix(newSlideIndex > currentSlideIndex ? 'next' : 'prev');
      } else if (swiper.params.centeredSlides) {
        const slidesPerView = swiper.params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(swiper.params.slidesPerView, 10));
        if (newSlideIndex < Math.floor(slidesPerView / 2)) {
          loopFix('prev');
        }
      }
      swiper.slideToLoop(index);
    } else {
      swiper.slideTo(index);
    }
  }
  function update() {
    // Render || Update Pagination bullets/items
    const rtl = swiper.rtl;
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    let el = swiper.pagination.el;
    el = makeElementsArray(el);
    // Current/Total
    let current;
    let previousIndex;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    const total = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
    if (swiper.params.loop) {
      previousIndex = swiper.previousRealIndex || 0;
      current = swiper.params.slidesPerGroup > 1 ? Math.floor(swiper.realIndex / swiper.params.slidesPerGroup) : swiper.realIndex;
    } else if (typeof swiper.snapIndex !== 'undefined') {
      current = swiper.snapIndex;
      previousIndex = swiper.previousSnapIndex;
    } else {
      previousIndex = swiper.previousIndex || 0;
      current = swiper.activeIndex || 0;
    }
    // Types
    if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
      const bullets = swiper.pagination.bullets;
      let firstIndex;
      let lastIndex;
      let midIndex;
      if (params.dynamicBullets) {
        bulletSize = elementOuterSize(bullets[0], swiper.isHorizontal() ? 'width' : 'height', true);
        el.forEach(subEl => {
          subEl.style[swiper.isHorizontal() ? 'width' : 'height'] = `${bulletSize * (params.dynamicMainBullets + 4)}px`;
        });
        if (params.dynamicMainBullets > 1 && previousIndex !== undefined) {
          dynamicBulletIndex += current - (previousIndex || 0);
          if (dynamicBulletIndex > params.dynamicMainBullets - 1) {
            dynamicBulletIndex = params.dynamicMainBullets - 1;
          } else if (dynamicBulletIndex < 0) {
            dynamicBulletIndex = 0;
          }
        }
        firstIndex = Math.max(current - dynamicBulletIndex, 0);
        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
        midIndex = (lastIndex + firstIndex) / 2;
      }
      bullets.forEach(bulletEl => {
        const classesToRemove = [...['', '-next', '-next-next', '-prev', '-prev-prev', '-main'].map(suffix => `${params.bulletActiveClass}${suffix}`)].map(s => typeof s === 'string' && s.includes(' ') ? s.split(' ') : s).flat();
        bulletEl.classList.remove(...classesToRemove);
      });
      if (el.length > 1) {
        bullets.forEach(bullet => {
          const bulletIndex = elementIndex(bullet);
          if (bulletIndex === current) {
            bullet.classList.add(...params.bulletActiveClass.split(' '));
          } else if (swiper.isElement) {
            bullet.setAttribute('part', 'bullet');
          }
          if (params.dynamicBullets) {
            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
              bullet.classList.add(...`${params.bulletActiveClass}-main`.split(' '));
            }
            if (bulletIndex === firstIndex) {
              setSideBullets(bullet, 'prev');
            }
            if (bulletIndex === lastIndex) {
              setSideBullets(bullet, 'next');
            }
          }
        });
      } else {
        const bullet = bullets[current];
        if (bullet) {
          bullet.classList.add(...params.bulletActiveClass.split(' '));
        }
        if (swiper.isElement) {
          bullets.forEach((bulletEl, bulletIndex) => {
            bulletEl.setAttribute('part', bulletIndex === current ? 'bullet-active' : 'bullet');
          });
        }
        if (params.dynamicBullets) {
          const firstDisplayedBullet = bullets[firstIndex];
          const lastDisplayedBullet = bullets[lastIndex];
          for (let i = firstIndex; i <= lastIndex; i += 1) {
            if (bullets[i]) {
              bullets[i].classList.add(...`${params.bulletActiveClass}-main`.split(' '));
            }
          }
          setSideBullets(firstDisplayedBullet, 'prev');
          setSideBullets(lastDisplayedBullet, 'next');
        }
      }
      if (params.dynamicBullets) {
        const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
        const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
        const offsetProp = rtl ? 'right' : 'left';
        bullets.forEach(bullet => {
          bullet.style[swiper.isHorizontal() ? offsetProp : 'top'] = `${bulletsOffset}px`;
        });
      }
    }
    el.forEach((subEl, subElIndex) => {
      if (params.type === 'fraction') {
        subEl.querySelectorAll(classesToSelector(params.currentClass)).forEach(fractionEl => {
          fractionEl.textContent = params.formatFractionCurrent(current + 1);
        });
        subEl.querySelectorAll(classesToSelector(params.totalClass)).forEach(totalEl => {
          totalEl.textContent = params.formatFractionTotal(total);
        });
      }
      if (params.type === 'progressbar') {
        let progressbarDirection;
        if (params.progressbarOpposite) {
          progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
        } else {
          progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
        }
        const scale = (current + 1) / total;
        let scaleX = 1;
        let scaleY = 1;
        if (progressbarDirection === 'horizontal') {
          scaleX = scale;
        } else {
          scaleY = scale;
        }
        subEl.querySelectorAll(classesToSelector(params.progressbarFillClass)).forEach(progressEl => {
          progressEl.style.transform = `translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`;
          progressEl.style.transitionDuration = `${swiper.params.speed}ms`;
        });
      }
      if (params.type === 'custom' && params.renderCustom) {
        subEl.innerHTML = params.renderCustom(swiper, current + 1, total);
        if (subElIndex === 0) emit('paginationRender', subEl);
      } else {
        if (subElIndex === 0) emit('paginationRender', subEl);
        emit('paginationUpdate', subEl);
      }
      if (swiper.params.watchOverflow && swiper.enabled) {
        subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
      }
    });
  }
  function render() {
    // Render Container
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    let el = swiper.pagination.el;
    el = makeElementsArray(el);
    let paginationHTML = '';
    if (params.type === 'bullets') {
      let numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
      if (swiper.params.freeMode && swiper.params.freeMode.enabled && numberOfBullets > slidesLength) {
        numberOfBullets = slidesLength;
      }
      for (let i = 0; i < numberOfBullets; i += 1) {
        if (params.renderBullet) {
          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
        } else {
          // prettier-ignore
          paginationHTML += `<${params.bulletElement} ${swiper.isElement ? 'part="bullet"' : ''} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
      }
    }
    if (params.type === 'fraction') {
      if (params.renderFraction) {
        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
      } else {
        paginationHTML = `<span class="${params.currentClass}"></span>` + ' / ' + `<span class="${params.totalClass}"></span>`;
      }
    }
    if (params.type === 'progressbar') {
      if (params.renderProgressbar) {
        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
      } else {
        paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
      }
    }
    swiper.pagination.bullets = [];
    el.forEach(subEl => {
      if (params.type !== 'custom') {
        subEl.innerHTML = paginationHTML || '';
      }
      if (params.type === 'bullets') {
        swiper.pagination.bullets.push(...subEl.querySelectorAll(classesToSelector(params.bulletClass)));
      }
    });
    if (params.type !== 'custom') {
      emit('paginationRender', el[0]);
    }
  }
  function init() {
    swiper.params.pagination = createElementIfNotDefined(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
      el: 'swiper-pagination'
    });
    const params = swiper.params.pagination;
    if (!params.el) return;
    let el;
    if (typeof params.el === 'string' && swiper.isElement) {
      el = swiper.el.querySelector(params.el);
    }
    if (!el && typeof params.el === 'string') {
      el = [...document.querySelectorAll(params.el)];
    }
    if (!el) {
      el = params.el;
    }
    if (!el || el.length === 0) return;
    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && Array.isArray(el) && el.length > 1) {
      el = [...swiper.el.querySelectorAll(params.el)];
      // check if it belongs to another nested Swiper
      if (el.length > 1) {
        el = el.filter(subEl => {
          if (elementParents(subEl, '.swiper')[0] !== swiper.el) return false;
          return true;
        })[0];
      }
    }
    if (Array.isArray(el) && el.length === 1) el = el[0];
    Object.assign(swiper.pagination, {
      el
    });
    el = makeElementsArray(el);
    el.forEach(subEl => {
      if (params.type === 'bullets' && params.clickable) {
        subEl.classList.add(...(params.clickableClass || '').split(' '));
      }
      subEl.classList.add(params.modifierClass + params.type);
      subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
      if (params.type === 'bullets' && params.dynamicBullets) {
        subEl.classList.add(`${params.modifierClass}${params.type}-dynamic`);
        dynamicBulletIndex = 0;
        if (params.dynamicMainBullets < 1) {
          params.dynamicMainBullets = 1;
        }
      }
      if (params.type === 'progressbar' && params.progressbarOpposite) {
        subEl.classList.add(params.progressbarOppositeClass);
      }
      if (params.clickable) {
        subEl.addEventListener('click', onBulletClick);
      }
      if (!swiper.enabled) {
        subEl.classList.add(params.lockClass);
      }
    });
  }
  function destroy() {
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    let el = swiper.pagination.el;
    if (el) {
      el = makeElementsArray(el);
      el.forEach(subEl => {
        subEl.classList.remove(params.hiddenClass);
        subEl.classList.remove(params.modifierClass + params.type);
        subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        if (params.clickable) {
          subEl.classList.remove(...(params.clickableClass || '').split(' '));
          subEl.removeEventListener('click', onBulletClick);
        }
      });
    }
    if (swiper.pagination.bullets) swiper.pagination.bullets.forEach(subEl => subEl.classList.remove(...params.bulletActiveClass.split(' ')));
  }
  on('changeDirection', () => {
    if (!swiper.pagination || !swiper.pagination.el) return;
    const params = swiper.params.pagination;
    let {
      el
    } = swiper.pagination;
    el = makeElementsArray(el);
    el.forEach(subEl => {
      subEl.classList.remove(params.horizontalClass, params.verticalClass);
      subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    });
  });
  on('init', () => {
    if (swiper.params.pagination.enabled === false) {
      // eslint-disable-next-line
      disable();
    } else {
      init();
      render();
      update();
    }
  });
  on('activeIndexChange', () => {
    if (typeof swiper.snapIndex === 'undefined') {
      update();
    }
  });
  on('snapIndexChange', () => {
    update();
  });
  on('snapGridLengthChange', () => {
    render();
    update();
  });
  on('destroy', () => {
    destroy();
  });
  on('enable disable', () => {
    let {
      el
    } = swiper.pagination;
    if (el) {
      el = makeElementsArray(el);
      el.forEach(subEl => subEl.classList[swiper.enabled ? 'remove' : 'add'](swiper.params.pagination.lockClass));
    }
  });
  on('lock unlock', () => {
    update();
  });
  on('click', (_s, e) => {
    const targetEl = e.target;
    const el = makeElementsArray(swiper.pagination.el);
    if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && el && el.length > 0 && !targetEl.classList.contains(swiper.params.pagination.bulletClass)) {
      if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
      const isHidden = el[0].classList.contains(swiper.params.pagination.hiddenClass);
      if (isHidden === true) {
        emit('paginationShow');
      } else {
        emit('paginationHide');
      }
      el.forEach(subEl => subEl.classList.toggle(swiper.params.pagination.hiddenClass));
    }
  });
  const enable = () => {
    swiper.el.classList.remove(swiper.params.pagination.paginationDisabledClass);
    let {
      el
    } = swiper.pagination;
    if (el) {
      el = makeElementsArray(el);
      el.forEach(subEl => subEl.classList.remove(swiper.params.pagination.paginationDisabledClass));
    }
    init();
    render();
    update();
  };
  const disable = () => {
    swiper.el.classList.add(swiper.params.pagination.paginationDisabledClass);
    let {
      el
    } = swiper.pagination;
    if (el) {
      el = makeElementsArray(el);
      el.forEach(subEl => subEl.classList.add(swiper.params.pagination.paginationDisabledClass));
    }
    destroy();
  };
  Object.assign(swiper.pagination, {
    enable,
    disable,
    render,
    update,
    init,
    destroy
  });
}

function freeMode(_ref) {
  let {
    swiper,
    extendParams,
    emit,
    once
  } = _ref;
  extendParams({
    freeMode: {
      enabled: false,
      momentum: true,
      momentumRatio: 1,
      momentumBounce: true,
      momentumBounceRatio: 1,
      momentumVelocityRatio: 1,
      sticky: false,
      minimumVelocity: 0.02
    }
  });
  function onTouchStart() {
    if (swiper.params.cssMode) return;
    const translate = swiper.getTranslate();
    swiper.setTranslate(translate);
    swiper.setTransition(0);
    swiper.touchEventsData.velocities.length = 0;
    swiper.freeMode.onTouchEnd({
      currentPos: swiper.rtl ? swiper.translate : -swiper.translate
    });
  }
  function onTouchMove() {
    if (swiper.params.cssMode) return;
    const {
      touchEventsData: data,
      touches
    } = swiper;
    // Velocity
    if (data.velocities.length === 0) {
      data.velocities.push({
        position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
        time: data.touchStartTime
      });
    }
    data.velocities.push({
      position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
      time: now()
    });
  }
  function onTouchEnd(_ref2) {
    let {
      currentPos
    } = _ref2;
    if (swiper.params.cssMode) return;
    const {
      params,
      wrapperEl,
      rtlTranslate: rtl,
      snapGrid,
      touchEventsData: data
    } = swiper;
    // Time diff
    const touchEndTime = now();
    const timeDiff = touchEndTime - data.touchStartTime;
    if (currentPos < -swiper.minTranslate()) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    if (currentPos > -swiper.maxTranslate()) {
      if (swiper.slides.length < snapGrid.length) {
        swiper.slideTo(snapGrid.length - 1);
      } else {
        swiper.slideTo(swiper.slides.length - 1);
      }
      return;
    }
    if (params.freeMode.momentum) {
      if (data.velocities.length > 1) {
        const lastMoveEvent = data.velocities.pop();
        const velocityEvent = data.velocities.pop();
        const distance = lastMoveEvent.position - velocityEvent.position;
        const time = lastMoveEvent.time - velocityEvent.time;
        swiper.velocity = distance / time;
        swiper.velocity /= 2;
        if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) {
          swiper.velocity = 0;
        }
        // this implies that the user stopped moving a finger then released.
        // There would be no events with distance zero, so the last event is stale.
        if (time > 150 || now() - lastMoveEvent.time > 300) {
          swiper.velocity = 0;
        }
      } else {
        swiper.velocity = 0;
      }
      swiper.velocity *= params.freeMode.momentumVelocityRatio;
      data.velocities.length = 0;
      let momentumDuration = 1000 * params.freeMode.momentumRatio;
      const momentumDistance = swiper.velocity * momentumDuration;
      let newPosition = swiper.translate + momentumDistance;
      if (rtl) newPosition = -newPosition;
      let doBounce = false;
      let afterBouncePosition;
      const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
      let needsLoopFix;
      if (newPosition < swiper.maxTranslate()) {
        if (params.freeMode.momentumBounce) {
          if (newPosition + swiper.maxTranslate() < -bounceAmount) {
            newPosition = swiper.maxTranslate() - bounceAmount;
          }
          afterBouncePosition = swiper.maxTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.maxTranslate();
        }
        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (newPosition > swiper.minTranslate()) {
        if (params.freeMode.momentumBounce) {
          if (newPosition - swiper.minTranslate() > bounceAmount) {
            newPosition = swiper.minTranslate() + bounceAmount;
          }
          afterBouncePosition = swiper.minTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.minTranslate();
        }
        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (params.freeMode.sticky) {
        let nextSlide;
        for (let j = 0; j < snapGrid.length; j += 1) {
          if (snapGrid[j] > -newPosition) {
            nextSlide = j;
            break;
          }
        }
        if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
          newPosition = snapGrid[nextSlide];
        } else {
          newPosition = snapGrid[nextSlide - 1];
        }
        newPosition = -newPosition;
      }
      if (needsLoopFix) {
        once('transitionEnd', () => {
          swiper.loopFix();
        });
      }
      // Fix duration
      if (swiper.velocity !== 0) {
        if (rtl) {
          momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
        } else {
          momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
        }
        if (params.freeMode.sticky) {
          // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
          // event, then durations can be 20+ seconds to slide one (or zero!) slides.
          // It's easy to see this when simulating touch with mouse events. To fix this,
          // limit single-slide swipes to the default slide duration. This also has the
          // nice side effect of matching slide speed if the user stopped moving before
          // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
          // For faster swipes, also apply limits (albeit higher ones).
          const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
          const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
          if (moveDistance < currentSlideSize) {
            momentumDuration = params.speed;
          } else if (moveDistance < 2 * currentSlideSize) {
            momentumDuration = params.speed * 1.5;
          } else {
            momentumDuration = params.speed * 2.5;
          }
        }
      } else if (params.freeMode.sticky) {
        swiper.slideToClosest();
        return;
      }
      if (params.freeMode.momentumBounce && doBounce) {
        swiper.updateProgress(afterBouncePosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);
        swiper.animating = true;
        elementTransitionEnd(wrapperEl, () => {
          if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
          emit('momentumBounce');
          swiper.setTransition(params.speed);
          setTimeout(() => {
            swiper.setTranslate(afterBouncePosition);
            elementTransitionEnd(wrapperEl, () => {
              if (!swiper || swiper.destroyed) return;
              swiper.transitionEnd();
            });
          }, 0);
        });
      } else if (swiper.velocity) {
        emit('_freeModeNoMomentumRelease');
        swiper.updateProgress(newPosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);
        if (!swiper.animating) {
          swiper.animating = true;
          elementTransitionEnd(wrapperEl, () => {
            if (!swiper || swiper.destroyed) return;
            swiper.transitionEnd();
          });
        }
      } else {
        swiper.updateProgress(newPosition);
      }
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    } else if (params.freeMode.sticky) {
      swiper.slideToClosest();
      return;
    } else if (params.freeMode) {
      emit('_freeModeNoMomentumRelease');
    }
    if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
      swiper.updateProgress();
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
  }
  Object.assign(swiper, {
    freeMode: {
      onTouchStart,
      onTouchMove,
      onTouchEnd
    }
  });
}

let support;
function calcSupport() {
  const window = getWindow();
  const document = getDocument();
  return {
    smoothScroll: document.documentElement && document.documentElement.style && 'scrollBehavior' in document.documentElement.style,
    touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch)
  };
}
function getSupport() {
  if (!support) {
    support = calcSupport();
  }
  return support;
}

let deviceCached;
function calcDevice(_temp) {
  let {
    userAgent
  } = _temp === void 0 ? {} : _temp;
  const support = getSupport();
  const window = getWindow();
  const platform = window.navigator.platform;
  const ua = userAgent || window.navigator.userAgent;
  const device = {
    ios: false,
    android: false
  };
  const screenWidth = window.screen.width;
  const screenHeight = window.screen.height;
  const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
  let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
  const windows = platform === 'Win32';
  let macos = platform === 'MacIntel';

  // iPadOs 13 fix
  const iPadScreens = ['1024x1366', '1366x1024', '834x1194', '1194x834', '834x1112', '1112x834', '768x1024', '1024x768', '820x1180', '1180x820', '810x1080', '1080x810'];
  if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
    ipad = ua.match(/(Version)\/([\d.]+)/);
    if (!ipad) ipad = [0, 1, '13_0_0'];
    macos = false;
  }

  // Android
  if (android && !windows) {
    device.os = 'android';
    device.android = true;
  }
  if (ipad || iphone || ipod) {
    device.os = 'ios';
    device.ios = true;
  }

  // Export object
  return device;
}
function getDevice(overrides) {
  if (overrides === void 0) {
    overrides = {};
  }
  if (!deviceCached) {
    deviceCached = calcDevice(overrides);
  }
  return deviceCached;
}

let browser;
function calcBrowser() {
  const window = getWindow();
  let needPerspectiveFix = false;
  function isSafari() {
    const ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
  }
  if (isSafari()) {
    const ua = String(window.navigator.userAgent);
    if (ua.includes('Version/')) {
      const [major, minor] = ua.split('Version/')[1].split(' ')[0].split('.').map(num => Number(num));
      needPerspectiveFix = major < 16 || major === 16 && minor < 2;
    }
  }
  return {
    isSafari: needPerspectiveFix || isSafari(),
    needPerspectiveFix,
    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
  };
}
function getBrowser() {
  if (!browser) {
    browser = calcBrowser();
  }
  return browser;
}

function Resize(_ref) {
  let {
    swiper,
    on,
    emit
  } = _ref;
  const window = getWindow();
  let observer = null;
  let animationFrame = null;
  const resizeHandler = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit('beforeResize');
    emit('resize');
  };
  const createObserver = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    observer = new ResizeObserver(entries => {
      animationFrame = window.requestAnimationFrame(() => {
        const {
          width,
          height
        } = swiper;
        let newWidth = width;
        let newHeight = height;
        entries.forEach(_ref2 => {
          let {
            contentBoxSize,
            contentRect,
            target
          } = _ref2;
          if (target && target !== swiper.el) return;
          newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
          newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
        });
        if (newWidth !== width || newHeight !== height) {
          resizeHandler();
        }
      });
    });
    observer.observe(swiper.el);
  };
  const removeObserver = () => {
    if (animationFrame) {
      window.cancelAnimationFrame(animationFrame);
    }
    if (observer && observer.unobserve && swiper.el) {
      observer.unobserve(swiper.el);
      observer = null;
    }
  };
  const orientationChangeHandler = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit('orientationchange');
  };
  on('init', () => {
    if (swiper.params.resizeObserver && typeof window.ResizeObserver !== 'undefined') {
      createObserver();
      return;
    }
    window.addEventListener('resize', resizeHandler);
    window.addEventListener('orientationchange', orientationChangeHandler);
  });
  on('destroy', () => {
    removeObserver();
    window.removeEventListener('resize', resizeHandler);
    window.removeEventListener('orientationchange', orientationChangeHandler);
  });
}

function Observer(_ref) {
  let {
    swiper,
    extendParams,
    on,
    emit
  } = _ref;
  const observers = [];
  const window = getWindow();
  const attach = function (target, options) {
    if (options === void 0) {
      options = {};
    }
    const ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
    const observer = new ObserverFunc(mutations => {
      // The observerUpdate event should only be triggered
      // once despite the number of mutations.  Additional
      // triggers are redundant and are very costly
      if (swiper.__preventObserver__) return;
      if (mutations.length === 1) {
        emit('observerUpdate', mutations[0]);
        return;
      }
      const observerUpdate = function observerUpdate() {
        emit('observerUpdate', mutations[0]);
      };
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(observerUpdate);
      } else {
        window.setTimeout(observerUpdate, 0);
      }
    });
    observer.observe(target, {
      attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
      childList: typeof options.childList === 'undefined' ? true : options.childList,
      characterData: typeof options.characterData === 'undefined' ? true : options.characterData
    });
    observers.push(observer);
  };
  const init = () => {
    if (!swiper.params.observer) return;
    if (swiper.params.observeParents) {
      const containerParents = elementParents(swiper.hostEl);
      for (let i = 0; i < containerParents.length; i += 1) {
        attach(containerParents[i]);
      }
    }
    // Observe container
    attach(swiper.hostEl, {
      childList: swiper.params.observeSlideChildren
    });

    // Observe wrapper
    attach(swiper.wrapperEl, {
      attributes: false
    });
  };
  const destroy = () => {
    observers.forEach(observer => {
      observer.disconnect();
    });
    observers.splice(0, observers.length);
  };
  extendParams({
    observer: false,
    observeParents: false,
    observeSlideChildren: false
  });
  on('init', init);
  on('destroy', destroy);
}

/* eslint-disable no-underscore-dangle */

var eventsEmitter = {
  on(events, handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;
    const method = priority ? 'unshift' : 'push';
    events.split(' ').forEach(event => {
      if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
      self.eventsListeners[event][method](handler);
    });
    return self;
  },
  once(events, handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;
    function onceHandler() {
      self.off(events, onceHandler);
      if (onceHandler.__emitterProxy) {
        delete onceHandler.__emitterProxy;
      }
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      handler.apply(self, args);
    }
    onceHandler.__emitterProxy = handler;
    return self.on(events, onceHandler, priority);
  },
  onAny(handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;
    const method = priority ? 'unshift' : 'push';
    if (self.eventsAnyListeners.indexOf(handler) < 0) {
      self.eventsAnyListeners[method](handler);
    }
    return self;
  },
  offAny(handler) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsAnyListeners) return self;
    const index = self.eventsAnyListeners.indexOf(handler);
    if (index >= 0) {
      self.eventsAnyListeners.splice(index, 1);
    }
    return self;
  },
  off(events, handler) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsListeners) return self;
    events.split(' ').forEach(event => {
      if (typeof handler === 'undefined') {
        self.eventsListeners[event] = [];
      } else if (self.eventsListeners[event]) {
        self.eventsListeners[event].forEach((eventHandler, index) => {
          if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
            self.eventsListeners[event].splice(index, 1);
          }
        });
      }
    });
    return self;
  },
  emit() {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsListeners) return self;
    let events;
    let data;
    let context;
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
      events = args[0];
      data = args.slice(1, args.length);
      context = self;
    } else {
      events = args[0].events;
      data = args[0].data;
      context = args[0].context || self;
    }
    data.unshift(context);
    const eventsArray = Array.isArray(events) ? events : events.split(' ');
    eventsArray.forEach(event => {
      if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
        self.eventsAnyListeners.forEach(eventHandler => {
          eventHandler.apply(context, [event, ...data]);
        });
      }
      if (self.eventsListeners && self.eventsListeners[event]) {
        self.eventsListeners[event].forEach(eventHandler => {
          eventHandler.apply(context, data);
        });
      }
    });
    return self;
  }
};

function updateSize() {
  const swiper = this;
  let width;
  let height;
  const el = swiper.el;
  if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) {
    width = swiper.params.width;
  } else {
    width = el.clientWidth;
  }
  if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) {
    height = swiper.params.height;
  } else {
    height = el.clientHeight;
  }
  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
    return;
  }

  // Subtract paddings
  width = width - parseInt(elementStyle(el, 'padding-left') || 0, 10) - parseInt(elementStyle(el, 'padding-right') || 0, 10);
  height = height - parseInt(elementStyle(el, 'padding-top') || 0, 10) - parseInt(elementStyle(el, 'padding-bottom') || 0, 10);
  if (Number.isNaN(width)) width = 0;
  if (Number.isNaN(height)) height = 0;
  Object.assign(swiper, {
    width,
    height,
    size: swiper.isHorizontal() ? width : height
  });
}

function updateSlides() {
  const swiper = this;
  function getDirectionLabel(property) {
    if (swiper.isHorizontal()) {
      return property;
    }
    // prettier-ignore
    return {
      'width': 'height',
      'margin-top': 'margin-left',
      'margin-bottom ': 'margin-right',
      'margin-left': 'margin-top',
      'margin-right': 'margin-bottom',
      'padding-left': 'padding-top',
      'padding-right': 'padding-bottom',
      'marginRight': 'marginBottom'
    }[property];
  }
  function getDirectionPropertyValue(node, label) {
    return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
  }
  const params = swiper.params;
  const {
    wrapperEl,
    slidesEl,
    size: swiperSize,
    rtlTranslate: rtl,
    wrongRTL
  } = swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
  const slides = elementChildren(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
  const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
  let snapGrid = [];
  const slidesGrid = [];
  const slidesSizesGrid = [];
  let offsetBefore = params.slidesOffsetBefore;
  if (typeof offsetBefore === 'function') {
    offsetBefore = params.slidesOffsetBefore.call(swiper);
  }
  let offsetAfter = params.slidesOffsetAfter;
  if (typeof offsetAfter === 'function') {
    offsetAfter = params.slidesOffsetAfter.call(swiper);
  }
  const previousSnapGridLength = swiper.snapGrid.length;
  const previousSlidesGridLength = swiper.slidesGrid.length;
  let spaceBetween = params.spaceBetween;
  let slidePosition = -offsetBefore;
  let prevSlideSize = 0;
  let index = 0;
  if (typeof swiperSize === 'undefined') {
    return;
  }
  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
  } else if (typeof spaceBetween === 'string') {
    spaceBetween = parseFloat(spaceBetween);
  }
  swiper.virtualSize = -spaceBetween;

  // reset margins
  slides.forEach(slideEl => {
    if (rtl) {
      slideEl.style.marginLeft = '';
    } else {
      slideEl.style.marginRight = '';
    }
    slideEl.style.marginBottom = '';
    slideEl.style.marginTop = '';
  });

  // reset cssMode offsets
  if (params.centeredSlides && params.cssMode) {
    setCSSProperty(wrapperEl, '--swiper-centered-offset-before', '');
    setCSSProperty(wrapperEl, '--swiper-centered-offset-after', '');
  }
  const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
  if (gridEnabled) {
    swiper.grid.initSlides(slidesLength);
  }

  // Calc slides
  let slideSize;
  const shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter(key => {
    return typeof params.breakpoints[key].slidesPerView !== 'undefined';
  }).length > 0;
  for (let i = 0; i < slidesLength; i += 1) {
    slideSize = 0;
    let slide;
    if (slides[i]) slide = slides[i];
    if (gridEnabled) {
      swiper.grid.updateSlide(i, slide, slidesLength, getDirectionLabel);
    }
    if (slides[i] && elementStyle(slide, 'display') === 'none') continue; // eslint-disable-line

    if (params.slidesPerView === 'auto') {
      if (shouldResetSlideSize) {
        slides[i].style[getDirectionLabel('width')] = ``;
      }
      const slideStyles = getComputedStyle(slide);
      const currentTransform = slide.style.transform;
      const currentWebKitTransform = slide.style.webkitTransform;
      if (currentTransform) {
        slide.style.transform = 'none';
      }
      if (currentWebKitTransform) {
        slide.style.webkitTransform = 'none';
      }
      if (params.roundLengths) {
        slideSize = swiper.isHorizontal() ? elementOuterSize(slide, 'width', true) : elementOuterSize(slide, 'height', true);
      } else {
        // eslint-disable-next-line
        const width = getDirectionPropertyValue(slideStyles, 'width');
        const paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
        const paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
        const marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
        const marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
        const boxSizing = slideStyles.getPropertyValue('box-sizing');
        if (boxSizing && boxSizing === 'border-box') {
          slideSize = width + marginLeft + marginRight;
        } else {
          const {
            clientWidth,
            offsetWidth
          } = slide;
          slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
        }
      }
      if (currentTransform) {
        slide.style.transform = currentTransform;
      }
      if (currentWebKitTransform) {
        slide.style.webkitTransform = currentWebKitTransform;
      }
      if (params.roundLengths) slideSize = Math.floor(slideSize);
    } else {
      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
      if (params.roundLengths) slideSize = Math.floor(slideSize);
      if (slides[i]) {
        slides[i].style[getDirectionLabel('width')] = `${slideSize}px`;
      }
    }
    if (slides[i]) {
      slides[i].swiperSlideSize = slideSize;
    }
    slidesSizesGrid.push(slideSize);
    if (params.centeredSlides) {
      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
      if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
    } else {
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
      slidePosition = slidePosition + slideSize + spaceBetween;
    }
    swiper.virtualSize += slideSize + spaceBetween;
    prevSlideSize = slideSize;
    index += 1;
  }
  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
  if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
    wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
  }
  if (params.setWrapperSize) {
    wrapperEl.style[getDirectionLabel('width')] = `${swiper.virtualSize + spaceBetween}px`;
  }
  if (gridEnabled) {
    swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
  }

  // Remove last grid elements depending on width
  if (!params.centeredSlides) {
    const newSlidesGrid = [];
    for (let i = 0; i < snapGrid.length; i += 1) {
      let slidesGridItem = snapGrid[i];
      if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
      if (snapGrid[i] <= swiper.virtualSize - swiperSize) {
        newSlidesGrid.push(slidesGridItem);
      }
    }
    snapGrid = newSlidesGrid;
    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
      snapGrid.push(swiper.virtualSize - swiperSize);
    }
  }
  if (isVirtual && params.loop) {
    const size = slidesSizesGrid[0] + spaceBetween;
    if (params.slidesPerGroup > 1) {
      const groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
      const groupSize = size * params.slidesPerGroup;
      for (let i = 0; i < groups; i += 1) {
        snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
      }
    }
    for (let i = 0; i < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i += 1) {
      if (params.slidesPerGroup === 1) {
        snapGrid.push(snapGrid[snapGrid.length - 1] + size);
      }
      slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
      swiper.virtualSize += size;
    }
  }
  if (snapGrid.length === 0) snapGrid = [0];
  if (spaceBetween !== 0) {
    const key = swiper.isHorizontal() && rtl ? 'marginLeft' : getDirectionLabel('marginRight');
    slides.filter((_, slideIndex) => {
      if (!params.cssMode || params.loop) return true;
      if (slideIndex === slides.length - 1) {
        return false;
      }
      return true;
    }).forEach(slideEl => {
      slideEl.style[key] = `${spaceBetween}px`;
    });
  }
  if (params.centeredSlides && params.centeredSlidesBounds) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach(slideSizeValue => {
      allSlidesSize += slideSizeValue + (spaceBetween || 0);
    });
    allSlidesSize -= spaceBetween;
    const maxSnap = allSlidesSize - swiperSize;
    snapGrid = snapGrid.map(snap => {
      if (snap <= 0) return -offsetBefore;
      if (snap > maxSnap) return maxSnap + offsetAfter;
      return snap;
    });
  }
  if (params.centerInsufficientSlides) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach(slideSizeValue => {
      allSlidesSize += slideSizeValue + (spaceBetween || 0);
    });
    allSlidesSize -= spaceBetween;
    if (allSlidesSize < swiperSize) {
      const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
      snapGrid.forEach((snap, snapIndex) => {
        snapGrid[snapIndex] = snap - allSlidesOffset;
      });
      slidesGrid.forEach((snap, snapIndex) => {
        slidesGrid[snapIndex] = snap + allSlidesOffset;
      });
    }
  }
  Object.assign(swiper, {
    slides,
    snapGrid,
    slidesGrid,
    slidesSizesGrid
  });
  if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
    setCSSProperty(wrapperEl, '--swiper-centered-offset-before', `${-snapGrid[0]}px`);
    setCSSProperty(wrapperEl, '--swiper-centered-offset-after', `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
    const addToSnapGrid = -swiper.snapGrid[0];
    const addToSlidesGrid = -swiper.slidesGrid[0];
    swiper.snapGrid = swiper.snapGrid.map(v => v + addToSnapGrid);
    swiper.slidesGrid = swiper.slidesGrid.map(v => v + addToSlidesGrid);
  }
  if (slidesLength !== previousSlidesLength) {
    swiper.emit('slidesLengthChange');
  }
  if (snapGrid.length !== previousSnapGridLength) {
    if (swiper.params.watchOverflow) swiper.checkOverflow();
    swiper.emit('snapGridLengthChange');
  }
  if (slidesGrid.length !== previousSlidesGridLength) {
    swiper.emit('slidesGridLengthChange');
  }
  if (params.watchSlidesProgress) {
    swiper.updateSlidesOffset();
  }
  if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
    const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
    const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
    if (slidesLength <= params.maxBackfaceHiddenSlides) {
      if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
    } else if (hasClassBackfaceClassAdded) {
      swiper.el.classList.remove(backFaceHiddenClass);
    }
  }
}

function updateAutoHeight(speed) {
  const swiper = this;
  const activeSlides = [];
  const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  let newHeight = 0;
  let i;
  if (typeof speed === 'number') {
    swiper.setTransition(speed);
  } else if (speed === true) {
    swiper.setTransition(swiper.params.speed);
  }
  const getSlideByIndex = index => {
    if (isVirtual) {
      return swiper.slides[swiper.getSlideIndexByData(index)];
    }
    return swiper.slides[index];
  };
  // Find slides currently in view
  if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
    if (swiper.params.centeredSlides) {
      (swiper.visibleSlides || []).forEach(slide => {
        activeSlides.push(slide);
      });
    } else {
      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
        const index = swiper.activeIndex + i;
        if (index > swiper.slides.length && !isVirtual) break;
        activeSlides.push(getSlideByIndex(index));
      }
    }
  } else {
    activeSlides.push(getSlideByIndex(swiper.activeIndex));
  }

  // Find new height from highest slide in view
  for (i = 0; i < activeSlides.length; i += 1) {
    if (typeof activeSlides[i] !== 'undefined') {
      const height = activeSlides[i].offsetHeight;
      newHeight = height > newHeight ? height : newHeight;
    }
  }

  // Update Height
  if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = `${newHeight}px`;
}

function updateSlidesOffset() {
  const swiper = this;
  const slides = swiper.slides;
  // eslint-disable-next-line
  const minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
  for (let i = 0; i < slides.length; i += 1) {
    slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
  }
}

function updateSlidesProgress(translate) {
  if (translate === void 0) {
    translate = this && this.translate || 0;
  }
  const swiper = this;
  const params = swiper.params;
  const {
    slides,
    rtlTranslate: rtl,
    snapGrid
  } = swiper;
  if (slides.length === 0) return;
  if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
  let offsetCenter = -translate;
  if (rtl) offsetCenter = translate;

  // Visible Slides
  slides.forEach(slideEl => {
    slideEl.classList.remove(params.slideVisibleClass);
  });
  swiper.visibleSlidesIndexes = [];
  swiper.visibleSlides = [];
  let spaceBetween = params.spaceBetween;
  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
  } else if (typeof spaceBetween === 'string') {
    spaceBetween = parseFloat(spaceBetween);
  }
  for (let i = 0; i < slides.length; i += 1) {
    const slide = slides[i];
    let slideOffset = slide.swiperSlideOffset;
    if (params.cssMode && params.centeredSlides) {
      slideOffset -= slides[0].swiperSlideOffset;
    }
    const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
    const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
    const slideBefore = -(offsetCenter - slideOffset);
    const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
    const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
    if (isVisible) {
      swiper.visibleSlides.push(slide);
      swiper.visibleSlidesIndexes.push(i);
      slides[i].classList.add(params.slideVisibleClass);
    }
    slide.progress = rtl ? -slideProgress : slideProgress;
    slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
  }
}

function updateProgress(translate) {
  const swiper = this;
  if (typeof translate === 'undefined') {
    const multiplier = swiper.rtlTranslate ? -1 : 1;
    // eslint-disable-next-line
    translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
  }
  const params = swiper.params;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  let {
    progress,
    isBeginning,
    isEnd,
    progressLoop
  } = swiper;
  const wasBeginning = isBeginning;
  const wasEnd = isEnd;
  if (translatesDiff === 0) {
    progress = 0;
    isBeginning = true;
    isEnd = true;
  } else {
    progress = (translate - swiper.minTranslate()) / translatesDiff;
    const isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
    const isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
    isBeginning = isBeginningRounded || progress <= 0;
    isEnd = isEndRounded || progress >= 1;
    if (isBeginningRounded) progress = 0;
    if (isEndRounded) progress = 1;
  }
  if (params.loop) {
    const firstSlideIndex = swiper.getSlideIndexByData(0);
    const lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
    const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
    const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
    const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
    const translateAbs = Math.abs(translate);
    if (translateAbs >= firstSlideTranslate) {
      progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
    } else {
      progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
    }
    if (progressLoop > 1) progressLoop -= 1;
  }
  Object.assign(swiper, {
    progress,
    progressLoop,
    isBeginning,
    isEnd
  });
  if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
  if (isBeginning && !wasBeginning) {
    swiper.emit('reachBeginning toEdge');
  }
  if (isEnd && !wasEnd) {
    swiper.emit('reachEnd toEdge');
  }
  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
    swiper.emit('fromEdge');
  }
  swiper.emit('progress', progress);
}

function updateSlidesClasses() {
  const swiper = this;
  const {
    slides,
    params,
    slidesEl,
    activeIndex
  } = swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  const getFilteredSlide = selector => {
    return elementChildren(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
  };
  slides.forEach(slideEl => {
    slideEl.classList.remove(params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
  });
  let activeSlide;
  if (isVirtual) {
    if (params.loop) {
      let slideIndex = activeIndex - swiper.virtual.slidesBefore;
      if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
      if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
      activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
    } else {
      activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
    }
  } else {
    activeSlide = slides[activeIndex];
  }
  if (activeSlide) {
    // Active classes
    activeSlide.classList.add(params.slideActiveClass);

    // Next Slide
    let nextSlide = elementNextAll(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
    if (params.loop && !nextSlide) {
      nextSlide = slides[0];
    }
    if (nextSlide) {
      nextSlide.classList.add(params.slideNextClass);
    }
    // Prev Slide
    let prevSlide = elementPrevAll(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
    if (params.loop && !prevSlide === 0) {
      prevSlide = slides[slides.length - 1];
    }
    if (prevSlide) {
      prevSlide.classList.add(params.slidePrevClass);
    }
  }
  swiper.emitSlidesClasses();
}

const processLazyPreloader = (swiper, imageEl) => {
  if (!swiper || swiper.destroyed || !swiper.params) return;
  const slideSelector = () => swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
  const slideEl = imageEl.closest(slideSelector());
  if (slideEl) {
    let lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
    if (!lazyEl && swiper.isElement) {
      if (slideEl.shadowRoot) {
        lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
      } else {
        // init later
        requestAnimationFrame(() => {
          if (slideEl.shadowRoot) {
            lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
            if (lazyEl) lazyEl.remove();
          }
        });
      }
    }
    if (lazyEl) lazyEl.remove();
  }
};
const unlazy = (swiper, index) => {
  if (!swiper.slides[index]) return;
  const imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
  if (imageEl) imageEl.removeAttribute('loading');
};
const preload = swiper => {
  if (!swiper || swiper.destroyed || !swiper.params) return;
  let amount = swiper.params.lazyPreloadPrevNext;
  const len = swiper.slides.length;
  if (!len || !amount || amount < 0) return;
  amount = Math.min(amount, len);
  const slidesPerView = swiper.params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
  const activeIndex = swiper.activeIndex;
  if (swiper.params.grid && swiper.params.grid.rows > 1) {
    const activeColumn = activeIndex;
    const preloadColumns = [activeColumn - amount];
    preloadColumns.push(...Array.from({
      length: amount
    }).map((_, i) => {
      return activeColumn + slidesPerView + i;
    }));
    swiper.slides.forEach((slideEl, i) => {
      if (preloadColumns.includes(slideEl.column)) unlazy(swiper, i);
    });
    return;
  }
  const slideIndexLastInView = activeIndex + slidesPerView - 1;
  if (swiper.params.rewind || swiper.params.loop) {
    for (let i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1) {
      const realIndex = (i % len + len) % len;
      if (realIndex < activeIndex || realIndex > slideIndexLastInView) unlazy(swiper, realIndex);
    }
  } else {
    for (let i = Math.max(activeIndex - amount, 0); i <= Math.min(slideIndexLastInView + amount, len - 1); i += 1) {
      if (i !== activeIndex && (i > slideIndexLastInView || i < activeIndex)) {
        unlazy(swiper, i);
      }
    }
  }
};

function getActiveIndexByTranslate(swiper) {
  const {
    slidesGrid,
    params
  } = swiper;
  const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  let activeIndex;
  for (let i = 0; i < slidesGrid.length; i += 1) {
    if (typeof slidesGrid[i + 1] !== 'undefined') {
      if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
        activeIndex = i;
      } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
        activeIndex = i + 1;
      }
    } else if (translate >= slidesGrid[i]) {
      activeIndex = i;
    }
  }
  // Normalize slideIndex
  if (params.normalizeSlideIndex) {
    if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
  }
  return activeIndex;
}
function updateActiveIndex(newActiveIndex) {
  const swiper = this;
  const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  const {
    snapGrid,
    params,
    activeIndex: previousIndex,
    realIndex: previousRealIndex,
    snapIndex: previousSnapIndex
  } = swiper;
  let activeIndex = newActiveIndex;
  let snapIndex;
  const getVirtualRealIndex = aIndex => {
    let realIndex = aIndex - swiper.virtual.slidesBefore;
    if (realIndex < 0) {
      realIndex = swiper.virtual.slides.length + realIndex;
    }
    if (realIndex >= swiper.virtual.slides.length) {
      realIndex -= swiper.virtual.slides.length;
    }
    return realIndex;
  };
  if (typeof activeIndex === 'undefined') {
    activeIndex = getActiveIndexByTranslate(swiper);
  }
  if (snapGrid.indexOf(translate) >= 0) {
    snapIndex = snapGrid.indexOf(translate);
  } else {
    const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
    snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
  }
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
  if (activeIndex === previousIndex) {
    if (snapIndex !== previousSnapIndex) {
      swiper.snapIndex = snapIndex;
      swiper.emit('snapIndexChange');
    }
    if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
      swiper.realIndex = getVirtualRealIndex(activeIndex);
    }
    return;
  }
  // Get real index
  let realIndex;
  if (swiper.virtual && params.virtual.enabled && params.loop) {
    realIndex = getVirtualRealIndex(activeIndex);
  } else if (swiper.slides[activeIndex]) {
    realIndex = parseInt(swiper.slides[activeIndex].getAttribute('data-swiper-slide-index') || activeIndex, 10);
  } else {
    realIndex = activeIndex;
  }
  Object.assign(swiper, {
    previousSnapIndex,
    snapIndex,
    previousRealIndex,
    realIndex,
    previousIndex,
    activeIndex
  });
  if (swiper.initialized) {
    preload(swiper);
  }
  swiper.emit('activeIndexChange');
  swiper.emit('snapIndexChange');
  if (swiper.initialized || swiper.params.runCallbacksOnInit) {
    if (previousRealIndex !== realIndex) {
      swiper.emit('realIndexChange');
    }
    swiper.emit('slideChange');
  }
}

function updateClickedSlide(el, path) {
  const swiper = this;
  const params = swiper.params;
  let slide = el.closest(`.${params.slideClass}, swiper-slide`);
  if (!slide && swiper.isElement && path && path.length > 1 && path.includes(el)) {
    [...path.slice(path.indexOf(el) + 1, path.length)].forEach(pathEl => {
      if (!slide && pathEl.matches && pathEl.matches(`.${params.slideClass}, swiper-slide`)) {
        slide = pathEl;
      }
    });
  }
  let slideFound = false;
  let slideIndex;
  if (slide) {
    for (let i = 0; i < swiper.slides.length; i += 1) {
      if (swiper.slides[i] === slide) {
        slideFound = true;
        slideIndex = i;
        break;
      }
    }
  }
  if (slide && slideFound) {
    swiper.clickedSlide = slide;
    if (swiper.virtual && swiper.params.virtual.enabled) {
      swiper.clickedIndex = parseInt(slide.getAttribute('data-swiper-slide-index'), 10);
    } else {
      swiper.clickedIndex = slideIndex;
    }
  } else {
    swiper.clickedSlide = undefined;
    swiper.clickedIndex = undefined;
    return;
  }
  if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
    swiper.slideToClickedSlide();
  }
}

var update = {
  updateSize,
  updateSlides,
  updateAutoHeight,
  updateSlidesOffset,
  updateSlidesProgress,
  updateProgress,
  updateSlidesClasses,
  updateActiveIndex,
  updateClickedSlide
};

function getSwiperTranslate(axis) {
  if (axis === void 0) {
    axis = this.isHorizontal() ? 'x' : 'y';
  }
  const swiper = this;
  const {
    params,
    rtlTranslate: rtl,
    translate,
    wrapperEl
  } = swiper;
  if (params.virtualTranslate) {
    return rtl ? -translate : translate;
  }
  if (params.cssMode) {
    return translate;
  }
  let currentTranslate = getTranslate(wrapperEl, axis);
  currentTranslate += swiper.cssOverflowAdjustment();
  if (rtl) currentTranslate = -currentTranslate;
  return currentTranslate || 0;
}

function setTranslate(translate, byController) {
  const swiper = this;
  const {
    rtlTranslate: rtl,
    params,
    wrapperEl,
    progress
  } = swiper;
  let x = 0;
  let y = 0;
  const z = 0;
  if (swiper.isHorizontal()) {
    x = rtl ? -translate : translate;
  } else {
    y = translate;
  }
  if (params.roundLengths) {
    x = Math.floor(x);
    y = Math.floor(y);
  }
  swiper.previousTranslate = swiper.translate;
  swiper.translate = swiper.isHorizontal() ? x : y;
  if (params.cssMode) {
    wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
  } else if (!params.virtualTranslate) {
    if (swiper.isHorizontal()) {
      x -= swiper.cssOverflowAdjustment();
    } else {
      y -= swiper.cssOverflowAdjustment();
    }
    wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z}px)`;
  }

  // Check if we need to update progress
  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (translate - swiper.minTranslate()) / translatesDiff;
  }
  if (newProgress !== progress) {
    swiper.updateProgress(translate);
  }
  swiper.emit('setTranslate', swiper.translate, byController);
}

function minTranslate() {
  return -this.snapGrid[0];
}

function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}

function translateTo(translate, speed, runCallbacks, translateBounds, internal) {
  if (translate === void 0) {
    translate = 0;
  }
  if (speed === void 0) {
    speed = this.params.speed;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  if (translateBounds === void 0) {
    translateBounds = true;
  }
  const swiper = this;
  const {
    params,
    wrapperEl
  } = swiper;
  if (swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }
  const minTranslate = swiper.minTranslate();
  const maxTranslate = swiper.maxTranslate();
  let newTranslate;
  if (translateBounds && translate > minTranslate) newTranslate = minTranslate;else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;else newTranslate = translate;

  // Update progress
  swiper.updateProgress(newTranslate);
  if (params.cssMode) {
    const isH = swiper.isHorizontal();
    if (speed === 0) {
      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
    } else {
      if (!swiper.support.smoothScroll) {
        animateCSSModeScroll({
          swiper,
          targetPosition: -newTranslate,
          side: isH ? 'left' : 'top'
        });
        return true;
      }
      wrapperEl.scrollTo({
        [isH ? 'left' : 'top']: -newTranslate,
        behavior: 'smooth'
      });
    }
    return true;
  }
  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(newTranslate);
    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionEnd');
    }
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(newTranslate);
    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionStart');
    }
    if (!swiper.animating) {
      swiper.animating = true;
      if (!swiper.onTranslateToWrapperTransitionEnd) {
        swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.wrapperEl.removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
          swiper.onTranslateToWrapperTransitionEnd = null;
          delete swiper.onTranslateToWrapperTransitionEnd;
          if (runCallbacks) {
            swiper.emit('transitionEnd');
          }
        };
      }
      swiper.wrapperEl.addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
    }
  }
  return true;
}

var translate = {
  getTranslate: getSwiperTranslate,
  setTranslate,
  minTranslate,
  maxTranslate,
  translateTo
};

function setTransition(duration, byController) {
  const swiper = this;
  if (!swiper.params.cssMode) {
    swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
    swiper.wrapperEl.style.transitionDelay = duration === 0 ? `0ms` : '';
  }
  swiper.emit('setTransition', duration, byController);
}

function transitionEmit(_ref) {
  let {
    swiper,
    runCallbacks,
    direction,
    step
  } = _ref;
  const {
    activeIndex,
    previousIndex
  } = swiper;
  let dir = direction;
  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
  }
  swiper.emit(`transition${step}`);
  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit(`slideResetTransition${step}`);
      return;
    }
    swiper.emit(`slideChangeTransition${step}`);
    if (dir === 'next') {
      swiper.emit(`slideNextTransition${step}`);
    } else {
      swiper.emit(`slidePrevTransition${step}`);
    }
  }
}

function transitionStart(runCallbacks, direction) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  const swiper = this;
  const {
    params
  } = swiper;
  if (params.cssMode) return;
  if (params.autoHeight) {
    swiper.updateAutoHeight();
  }
  transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: 'Start'
  });
}

function transitionEnd(runCallbacks, direction) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  const swiper = this;
  const {
    params
  } = swiper;
  swiper.animating = false;
  if (params.cssMode) return;
  swiper.setTransition(0);
  transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: 'End'
  });
}

var transition = {
  setTransition,
  transitionStart,
  transitionEnd
};

function slideTo(index, speed, runCallbacks, internal, initial) {
  if (index === void 0) {
    index = 0;
  }
  if (speed === void 0) {
    speed = this.params.speed;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  if (typeof index === 'string') {
    index = parseInt(index, 10);
  }
  const swiper = this;
  let slideIndex = index;
  if (slideIndex < 0) slideIndex = 0;
  const {
    params,
    snapGrid,
    slidesGrid,
    previousIndex,
    activeIndex,
    rtlTranslate: rtl,
    wrapperEl,
    enabled
  } = swiper;
  if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) {
    return false;
  }
  const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
  let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
  const translate = -snapGrid[snapIndex];
  // Normalize slideIndex
  if (params.normalizeSlideIndex) {
    for (let i = 0; i < slidesGrid.length; i += 1) {
      const normalizedTranslate = -Math.floor(translate * 100);
      const normalizedGrid = Math.floor(slidesGrid[i] * 100);
      const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) {
          slideIndex = i;
        } else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) {
          slideIndex = i + 1;
        }
      } else if (normalizedTranslate >= normalizedGrid) {
        slideIndex = i;
      }
    }
  }
  // Directions locks
  if (swiper.initialized && slideIndex !== activeIndex) {
    if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) {
      return false;
    }
    if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
      if ((activeIndex || 0) !== slideIndex) {
        return false;
      }
    }
  }
  if (slideIndex !== (previousIndex || 0) && runCallbacks) {
    swiper.emit('beforeSlideChangeStart');
  }

  // Update progress
  swiper.updateProgress(translate);
  let direction;
  if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset';

  // Update Index
  if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
    swiper.updateActiveIndex(slideIndex);
    // Update Height
    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }
    swiper.updateSlidesClasses();
    if (params.effect !== 'slide') {
      swiper.setTranslate(translate);
    }
    if (direction !== 'reset') {
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    }
    return false;
  }
  if (params.cssMode) {
    const isH = swiper.isHorizontal();
    const t = rtl ? translate : -translate;
    if (speed === 0) {
      const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
      if (isVirtual) {
        swiper.wrapperEl.style.scrollSnapType = 'none';
        swiper._immediateVirtual = true;
      }
      if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
        swiper._cssModeVirtualInitialSet = true;
        requestAnimationFrame(() => {
          wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
        });
      } else {
        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
      }
      if (isVirtual) {
        requestAnimationFrame(() => {
          swiper.wrapperEl.style.scrollSnapType = '';
          swiper._immediateVirtual = false;
        });
      }
    } else {
      if (!swiper.support.smoothScroll) {
        animateCSSModeScroll({
          swiper,
          targetPosition: t,
          side: isH ? 'left' : 'top'
        });
        return true;
      }
      wrapperEl.scrollTo({
        [isH ? 'left' : 'top']: t,
        behavior: 'smooth'
      });
    }
    return true;
  }
  swiper.setTransition(speed);
  swiper.setTranslate(translate);
  swiper.updateActiveIndex(slideIndex);
  swiper.updateSlidesClasses();
  swiper.emit('beforeTransitionStart', speed, internal);
  swiper.transitionStart(runCallbacks, direction);
  if (speed === 0) {
    swiper.transitionEnd(runCallbacks, direction);
  } else if (!swiper.animating) {
    swiper.animating = true;
    if (!swiper.onSlideToWrapperTransitionEnd) {
      swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
        if (!swiper || swiper.destroyed) return;
        if (e.target !== this) return;
        swiper.wrapperEl.removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
        swiper.onSlideToWrapperTransitionEnd = null;
        delete swiper.onSlideToWrapperTransitionEnd;
        swiper.transitionEnd(runCallbacks, direction);
      };
    }
    swiper.wrapperEl.addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
  }
  return true;
}

function slideToLoop(index, speed, runCallbacks, internal) {
  if (index === void 0) {
    index = 0;
  }
  if (speed === void 0) {
    speed = this.params.speed;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  if (typeof index === 'string') {
    const indexAsNumber = parseInt(index, 10);
    index = indexAsNumber;
  }
  const swiper = this;
  let newIndex = index;
  if (swiper.params.loop) {
    if (swiper.virtual && swiper.params.virtual.enabled) {
      // eslint-disable-next-line
      newIndex = newIndex + swiper.virtual.slidesBefore;
    } else {
      newIndex = swiper.getSlideIndexByData(newIndex);
    }
  }
  return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideNext(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  const swiper = this;
  const {
    enabled,
    params,
    animating
  } = swiper;
  if (!enabled) return swiper;
  let perGroup = params.slidesPerGroup;
  if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
    perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
  }
  const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  if (params.loop) {
    if (animating && !isVirtual && params.loopPreventsSliding) return false;
    swiper.loopFix({
      direction: 'next'
    });
    // eslint-disable-next-line
    swiper._clientLeft = swiper.wrapperEl.clientLeft;
    if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
      requestAnimationFrame(() => {
        swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
      });
      return true;
    }
  }
  if (params.rewind && swiper.isEnd) {
    return swiper.slideTo(0, speed, runCallbacks, internal);
  }
  return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slidePrev(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  const swiper = this;
  const {
    params,
    snapGrid,
    slidesGrid,
    rtlTranslate,
    enabled,
    animating
  } = swiper;
  if (!enabled) return swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  if (params.loop) {
    if (animating && !isVirtual && params.loopPreventsSliding) return false;
    swiper.loopFix({
      direction: 'prev'
    });
    // eslint-disable-next-line
    swiper._clientLeft = swiper.wrapperEl.clientLeft;
  }
  const translate = rtlTranslate ? swiper.translate : -swiper.translate;
  function normalize(val) {
    if (val < 0) return -Math.floor(Math.abs(val));
    return Math.floor(val);
  }
  const normalizedTranslate = normalize(translate);
  const normalizedSnapGrid = snapGrid.map(val => normalize(val));
  let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
  if (typeof prevSnap === 'undefined' && params.cssMode) {
    let prevSnapIndex;
    snapGrid.forEach((snap, snapIndex) => {
      if (normalizedTranslate >= snap) {
        // prevSnap = snap;
        prevSnapIndex = snapIndex;
      }
    });
    if (typeof prevSnapIndex !== 'undefined') {
      prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
  }
  let prevIndex = 0;
  if (typeof prevSnap !== 'undefined') {
    prevIndex = slidesGrid.indexOf(prevSnap);
    if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
      prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
      prevIndex = Math.max(prevIndex, 0);
    }
  }
  if (params.rewind && swiper.isBeginning) {
    const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
  } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
    requestAnimationFrame(() => {
      swiper.slideTo(prevIndex, speed, runCallbacks, internal);
    });
    return true;
  }
  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideReset(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  const swiper = this;
  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideToClosest(speed, runCallbacks, internal, threshold) {
  if (speed === void 0) {
    speed = this.params.speed;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  if (threshold === void 0) {
    threshold = 0.5;
  }
  const swiper = this;
  let index = swiper.activeIndex;
  const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
  const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
  const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  if (translate >= swiper.snapGrid[snapIndex]) {
    // The current translate is on or after the current snap index, so the choice
    // is between the current index and the one after it.
    const currentSnap = swiper.snapGrid[snapIndex];
    const nextSnap = swiper.snapGrid[snapIndex + 1];
    if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
      index += swiper.params.slidesPerGroup;
    }
  } else {
    // The current translate is before the current snap index, so the choice
    // is between the current index and the one before it.
    const prevSnap = swiper.snapGrid[snapIndex - 1];
    const currentSnap = swiper.snapGrid[snapIndex];
    if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) {
      index -= swiper.params.slidesPerGroup;
    }
  }
  index = Math.max(index, 0);
  index = Math.min(index, swiper.slidesGrid.length - 1);
  return swiper.slideTo(index, speed, runCallbacks, internal);
}

function slideToClickedSlide() {
  const swiper = this;
  const {
    params,
    slidesEl
  } = swiper;
  const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
  let slideToIndex = swiper.clickedIndex;
  let realIndex;
  const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
  if (params.loop) {
    if (swiper.animating) return;
    realIndex = parseInt(swiper.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
    if (params.centeredSlides) {
      if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
        swiper.loopFix();
        slideToIndex = swiper.getSlideIndex(elementChildren(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
        nextTick(() => {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
      swiper.loopFix();
      slideToIndex = swiper.getSlideIndex(elementChildren(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
      nextTick(() => {
        swiper.slideTo(slideToIndex);
      });
    } else {
      swiper.slideTo(slideToIndex);
    }
  } else {
    swiper.slideTo(slideToIndex);
  }
}

var slide = {
  slideTo,
  slideToLoop,
  slideNext,
  slidePrev,
  slideReset,
  slideToClosest,
  slideToClickedSlide
};

function loopCreate(slideRealIndex) {
  const swiper = this;
  const {
    params,
    slidesEl
  } = swiper;
  if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
  const slides = elementChildren(slidesEl, `.${params.slideClass}, swiper-slide`);
  slides.forEach((el, index) => {
    el.setAttribute('data-swiper-slide-index', index);
  });
  swiper.loopFix({
    slideRealIndex,
    direction: params.centeredSlides ? undefined : 'next'
  });
}

function loopFix(_temp) {
  let {
    slideRealIndex,
    slideTo = true,
    direction,
    setTranslate,
    activeSlideIndex,
    byController,
    byMousewheel
  } = _temp === void 0 ? {} : _temp;
  const swiper = this;
  if (!swiper.params.loop) return;
  swiper.emit('beforeLoopFix');
  const {
    slides,
    allowSlidePrev,
    allowSlideNext,
    slidesEl,
    params
  } = swiper;
  swiper.allowSlidePrev = true;
  swiper.allowSlideNext = true;
  if (swiper.virtual && params.virtual.enabled) {
    if (slideTo) {
      if (!params.centeredSlides && swiper.snapIndex === 0) {
        swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
      } else if (params.centeredSlides && swiper.snapIndex < params.slidesPerView) {
        swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
      } else if (swiper.snapIndex === swiper.snapGrid.length - 1) {
        swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
      }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    swiper.emit('loopFix');
    return;
  }
  const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10));
  let loopedSlides = params.loopedSlides || slidesPerView;
  if (loopedSlides % params.slidesPerGroup !== 0) {
    loopedSlides += params.slidesPerGroup - loopedSlides % params.slidesPerGroup;
  }
  swiper.loopedSlides = loopedSlides;
  const prependSlidesIndexes = [];
  const appendSlidesIndexes = [];
  let activeIndex = swiper.activeIndex;
  if (typeof activeSlideIndex === 'undefined') {
    activeSlideIndex = swiper.getSlideIndex(swiper.slides.filter(el => el.classList.contains(params.slideActiveClass))[0]);
  } else {
    activeIndex = activeSlideIndex;
  }
  const isNext = direction === 'next' || !direction;
  const isPrev = direction === 'prev' || !direction;
  let slidesPrepended = 0;
  let slidesAppended = 0;
  // prepend last slides before start
  if (activeSlideIndex < loopedSlides) {
    slidesPrepended = Math.max(loopedSlides - activeSlideIndex, params.slidesPerGroup);
    for (let i = 0; i < loopedSlides - activeSlideIndex; i += 1) {
      const index = i - Math.floor(i / slides.length) * slides.length;
      prependSlidesIndexes.push(slides.length - index - 1);
    }
  } else if (activeSlideIndex /* + slidesPerView */ > swiper.slides.length - loopedSlides * 2) {
    slidesAppended = Math.max(activeSlideIndex - (swiper.slides.length - loopedSlides * 2), params.slidesPerGroup);
    for (let i = 0; i < slidesAppended; i += 1) {
      const index = i - Math.floor(i / slides.length) * slides.length;
      appendSlidesIndexes.push(index);
    }
  }
  if (isPrev) {
    prependSlidesIndexes.forEach(index => {
      swiper.slides[index].swiperLoopMoveDOM = true;
      slidesEl.prepend(swiper.slides[index]);
      swiper.slides[index].swiperLoopMoveDOM = false;
    });
  }
  if (isNext) {
    appendSlidesIndexes.forEach(index => {
      swiper.slides[index].swiperLoopMoveDOM = true;
      slidesEl.append(swiper.slides[index]);
      swiper.slides[index].swiperLoopMoveDOM = false;
    });
  }
  swiper.recalcSlides();
  if (params.slidesPerView === 'auto') {
    swiper.updateSlides();
  }
  if (params.watchSlidesProgress) {
    swiper.updateSlidesOffset();
  }
  if (slideTo) {
    if (prependSlidesIndexes.length > 0 && isPrev) {
      if (typeof slideRealIndex === 'undefined') {
        const currentSlideTranslate = swiper.slidesGrid[activeIndex];
        const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
        const diff = newSlideTranslate - currentSlideTranslate;
        if (byMousewheel) {
          swiper.setTranslate(swiper.translate - diff);
        } else {
          swiper.slideTo(activeIndex + slidesPrepended, 0, false, true);
          if (setTranslate) {
            swiper.touches[swiper.isHorizontal() ? 'startX' : 'startY'] += diff;
            swiper.touchEventsData.currentTranslate = swiper.translate;
          }
        }
      } else {
        if (setTranslate) {
          swiper.slideToLoop(slideRealIndex, 0, false, true);
          swiper.touchEventsData.currentTranslate = swiper.translate;
        }
      }
    } else if (appendSlidesIndexes.length > 0 && isNext) {
      if (typeof slideRealIndex === 'undefined') {
        const currentSlideTranslate = swiper.slidesGrid[activeIndex];
        const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
        const diff = newSlideTranslate - currentSlideTranslate;
        if (byMousewheel) {
          swiper.setTranslate(swiper.translate - diff);
        } else {
          swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
          if (setTranslate) {
            swiper.touches[swiper.isHorizontal() ? 'startX' : 'startY'] += diff;
            swiper.touchEventsData.currentTranslate = swiper.translate;
          }
        }
      } else {
        swiper.slideToLoop(slideRealIndex, 0, false, true);
      }
    }
  }
  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  if (swiper.controller && swiper.controller.control && !byController) {
    const loopParams = {
      slideRealIndex,
      direction,
      setTranslate,
      activeSlideIndex,
      byController: true
    };
    if (Array.isArray(swiper.controller.control)) {
      swiper.controller.control.forEach(c => {
        if (!c.destroyed && c.params.loop) c.loopFix({
          ...loopParams,
          slideTo: c.params.slidesPerView === params.slidesPerView ? slideTo : false
        });
      });
    } else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) {
      swiper.controller.control.loopFix({
        ...loopParams,
        slideTo: swiper.controller.control.params.slidesPerView === params.slidesPerView ? slideTo : false
      });
    }
  }
  swiper.emit('loopFix');
}

function loopDestroy() {
  const swiper = this;
  const {
    params,
    slidesEl
  } = swiper;
  if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
  swiper.recalcSlides();
  const newSlidesOrder = [];
  swiper.slides.forEach(slideEl => {
    const index = typeof slideEl.swiperSlideIndex === 'undefined' ? slideEl.getAttribute('data-swiper-slide-index') * 1 : slideEl.swiperSlideIndex;
    newSlidesOrder[index] = slideEl;
  });
  swiper.slides.forEach(slideEl => {
    slideEl.removeAttribute('data-swiper-slide-index');
  });
  newSlidesOrder.forEach(slideEl => {
    slidesEl.append(slideEl);
  });
  swiper.recalcSlides();
  swiper.slideTo(swiper.realIndex, 0);
}

var loop = {
  loopCreate,
  loopFix,
  loopDestroy
};

function setGrabCursor(moving) {
  const swiper = this;
  if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
  const el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
  if (swiper.isElement) {
    swiper.__preventObserver__ = true;
  }
  el.style.cursor = 'move';
  el.style.cursor = moving ? 'grabbing' : 'grab';
  if (swiper.isElement) {
    requestAnimationFrame(() => {
      swiper.__preventObserver__ = false;
    });
  }
}

function unsetGrabCursor() {
  const swiper = this;
  if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
    return;
  }
  if (swiper.isElement) {
    swiper.__preventObserver__ = true;
  }
  swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
  if (swiper.isElement) {
    requestAnimationFrame(() => {
      swiper.__preventObserver__ = false;
    });
  }
}

var grabCursor = {
  setGrabCursor,
  unsetGrabCursor
};

// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function closestElement(selector, base) {
  if (base === void 0) {
    base = this;
  }
  function __closestFrom(el) {
    if (!el || el === getDocument() || el === getWindow()) return null;
    if (el.assignedSlot) el = el.assignedSlot;
    const found = el.closest(selector);
    if (!found && !el.getRootNode) {
      return null;
    }
    return found || __closestFrom(el.getRootNode().host);
  }
  return __closestFrom(base);
}
function onTouchStart(event) {
  const swiper = this;
  const document = getDocument();
  const window = getWindow();
  const data = swiper.touchEventsData;
  data.evCache.push(event);
  const {
    params,
    touches,
    enabled
  } = swiper;
  if (!enabled) return;
  if (!params.simulateTouch && event.pointerType === 'mouse') return;
  if (swiper.animating && params.preventInteractionOnTransition) {
    return;
  }
  if (!swiper.animating && params.cssMode && params.loop) {
    swiper.loopFix();
  }
  let e = event;
  if (e.originalEvent) e = e.originalEvent;
  let targetEl = e.target;
  if (params.touchEventsTarget === 'wrapper') {
    if (!swiper.wrapperEl.contains(targetEl)) return;
  }
  if ('which' in e && e.which === 3) return;
  if ('button' in e && e.button > 0) return;
  if (data.isTouched && data.isMoved) return;

  // change target el for shadow root component
  const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';
  // eslint-disable-next-line
  const eventPath = event.composedPath ? event.composedPath() : event.path;
  if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) {
    targetEl = eventPath[0];
  }
  const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
  const isTargetShadow = !!(e.target && e.target.shadowRoot);

  // use closestElement for shadow root element to get the actual closest for nested shadow root element
  if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
    swiper.allowClick = true;
    return;
  }
  if (params.swipeHandler) {
    if (!targetEl.closest(params.swipeHandler)) return;
  }
  touches.currentX = e.pageX;
  touches.currentY = e.pageY;
  const startX = touches.currentX;
  const startY = touches.currentY;

  // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore

  const edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
  const edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
    if (edgeSwipeDetection === 'prevent') {
      event.preventDefault();
    } else {
      return;
    }
  }
  Object.assign(data, {
    isTouched: true,
    isMoved: false,
    allowTouchCallbacks: true,
    isScrolling: undefined,
    startMoving: undefined
  });
  touches.startX = startX;
  touches.startY = startY;
  data.touchStartTime = now();
  swiper.allowClick = true;
  swiper.updateSize();
  swiper.swipeDirection = undefined;
  if (params.threshold > 0) data.allowThresholdMove = false;
  let preventDefault = true;
  if (targetEl.matches(data.focusableElements)) {
    preventDefault = false;
    if (targetEl.nodeName === 'SELECT') {
      data.isTouched = false;
    }
  }
  if (document.activeElement && document.activeElement.matches(data.focusableElements) && document.activeElement !== targetEl) {
    document.activeElement.blur();
  }
  const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
  if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) {
    e.preventDefault();
  }
  if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) {
    swiper.freeMode.onTouchStart();
  }
  swiper.emit('touchStart', e);
}

function onTouchMove(event) {
  const document = getDocument();
  const swiper = this;
  const data = swiper.touchEventsData;
  const {
    params,
    touches,
    rtlTranslate: rtl,
    enabled
  } = swiper;
  if (!enabled) return;
  if (!params.simulateTouch && event.pointerType === 'mouse') return;
  let e = event;
  if (e.originalEvent) e = e.originalEvent;
  if (!data.isTouched) {
    if (data.startMoving && data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }
    return;
  }
  const pointerIndex = data.evCache.findIndex(cachedEv => cachedEv.pointerId === e.pointerId);
  if (pointerIndex >= 0) data.evCache[pointerIndex] = e;
  const targetTouch = data.evCache.length > 1 ? data.evCache[0] : e;
  const pageX = targetTouch.pageX;
  const pageY = targetTouch.pageY;
  if (e.preventedByNestedSwiper) {
    touches.startX = pageX;
    touches.startY = pageY;
    return;
  }
  if (!swiper.allowTouchMove) {
    if (!e.target.matches(data.focusableElements)) {
      swiper.allowClick = false;
    }
    if (data.isTouched) {
      Object.assign(touches, {
        startX: pageX,
        startY: pageY,
        prevX: swiper.touches.currentX,
        prevY: swiper.touches.currentY,
        currentX: pageX,
        currentY: pageY
      });
      data.touchStartTime = now();
    }
    return;
  }
  if (params.touchReleaseOnEdges && !params.loop) {
    if (swiper.isVertical()) {
      // Vertical
      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
        data.isTouched = false;
        data.isMoved = false;
        return;
      }
    } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
      return;
    }
  }
  if (document.activeElement) {
    if (e.target === document.activeElement && e.target.matches(data.focusableElements)) {
      data.isMoved = true;
      swiper.allowClick = false;
      return;
    }
  }
  if (data.allowTouchCallbacks) {
    swiper.emit('touchMove', e);
  }
  if (e.targetTouches && e.targetTouches.length > 1) return;
  touches.currentX = pageX;
  touches.currentY = pageY;
  const diffX = touches.currentX - touches.startX;
  const diffY = touches.currentY - touches.startY;
  if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
  if (typeof data.isScrolling === 'undefined') {
    let touchAngle;
    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
      data.isScrolling = false;
    } else {
      // eslint-disable-next-line
      if (diffX * diffX + diffY * diffY >= 25) {
        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
      }
    }
  }
  if (data.isScrolling) {
    swiper.emit('touchMoveOpposite', e);
  }
  if (typeof data.startMoving === 'undefined') {
    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
      data.startMoving = true;
    }
  }
  if (data.isScrolling || swiper.zoom && swiper.params.zoom && swiper.params.zoom.enabled && data.evCache.length > 1) {
    data.isTouched = false;
    return;
  }
  if (!data.startMoving) {
    return;
  }
  swiper.allowClick = false;
  if (!params.cssMode && e.cancelable) {
    e.preventDefault();
  }
  if (params.touchMoveStopPropagation && !params.nested) {
    e.stopPropagation();
  }
  let diff = swiper.isHorizontal() ? diffX : diffY;
  let touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
  if (params.oneWayMovement) {
    diff = Math.abs(diff) * (rtl ? 1 : -1);
    touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
  }
  touches.diff = diff;
  diff *= params.touchRatio;
  if (rtl) {
    diff = -diff;
    touchesDiff = -touchesDiff;
  }
  const prevTouchesDirection = swiper.touchesDirection;
  swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
  swiper.touchesDirection = touchesDiff > 0 ? 'prev' : 'next';
  const isLoop = swiper.params.loop && !params.cssMode;
  const allowLoopFix = swiper.swipeDirection === 'next' && swiper.allowSlideNext || swiper.swipeDirection === 'prev' && swiper.allowSlidePrev;
  if (!data.isMoved) {
    if (isLoop && allowLoopFix) {
      swiper.loopFix({
        direction: swiper.swipeDirection
      });
    }
    data.startTranslate = swiper.getTranslate();
    swiper.setTransition(0);
    if (swiper.animating) {
      const evt = new window.CustomEvent('transitionend', {
        bubbles: true,
        cancelable: true
      });
      swiper.wrapperEl.dispatchEvent(evt);
    }
    data.allowMomentumBounce = false;
    // Grab Cursor
    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(true);
    }
    swiper.emit('sliderFirstMove', e);
  }
  let loopFixed;
  if (data.isMoved && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
    // need another loop fix
    swiper.loopFix({
      direction: swiper.swipeDirection,
      setTranslate: true
    });
    loopFixed = true;
  }
  swiper.emit('sliderMove', e);
  data.isMoved = true;
  data.currentTranslate = diff + data.startTranslate;
  let disableParentSwiper = true;
  let resistanceRatio = params.resistanceRatio;
  if (params.touchReleaseOnEdges) {
    resistanceRatio = 0;
  }
  if (diff > 0) {
    if (isLoop && allowLoopFix && !loopFixed && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.size / 2 : swiper.minTranslate())) {
      swiper.loopFix({
        direction: 'prev',
        setTranslate: true,
        activeSlideIndex: 0
      });
    }
    if (data.currentTranslate > swiper.minTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) {
        data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
      }
    }
  } else if (diff < 0) {
    if (isLoop && allowLoopFix && !loopFixed && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.size / 2 : swiper.maxTranslate())) {
      swiper.loopFix({
        direction: 'next',
        setTranslate: true,
        activeSlideIndex: swiper.slides.length - (params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
      });
    }
    if (data.currentTranslate < swiper.maxTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) {
        data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
      }
    }
  }
  if (disableParentSwiper) {
    e.preventedByNestedSwiper = true;
  }

  // Directions locks
  if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }
  if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }
  if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
    data.currentTranslate = data.startTranslate;
  }

  // Threshold
  if (params.threshold > 0) {
    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
      if (!data.allowThresholdMove) {
        data.allowThresholdMove = true;
        touches.startX = touches.currentX;
        touches.startY = touches.currentY;
        data.currentTranslate = data.startTranslate;
        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
        return;
      }
    } else {
      data.currentTranslate = data.startTranslate;
      return;
    }
  }
  if (!params.followFinger || params.cssMode) return;

  // Update active index in free mode
  if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }
  if (params.freeMode && params.freeMode.enabled && swiper.freeMode) {
    swiper.freeMode.onTouchMove();
  }
  // Update progress
  swiper.updateProgress(data.currentTranslate);
  // Update translate
  swiper.setTranslate(data.currentTranslate);
}

function onTouchEnd(event) {
  const swiper = this;
  const data = swiper.touchEventsData;
  const pointerIndex = data.evCache.findIndex(cachedEv => cachedEv.pointerId === event.pointerId);
  if (pointerIndex >= 0) {
    data.evCache.splice(pointerIndex, 1);
  }
  if (['pointercancel', 'pointerout', 'pointerleave', 'contextmenu'].includes(event.type)) {
    const proceed = ['pointercancel', 'contextmenu'].includes(event.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
    if (!proceed) {
      return;
    }
  }
  const {
    params,
    touches,
    rtlTranslate: rtl,
    slidesGrid,
    enabled
  } = swiper;
  if (!enabled) return;
  if (!params.simulateTouch && event.pointerType === 'mouse') return;
  let e = event;
  if (e.originalEvent) e = e.originalEvent;
  if (data.allowTouchCallbacks) {
    swiper.emit('touchEnd', e);
  }
  data.allowTouchCallbacks = false;
  if (!data.isTouched) {
    if (data.isMoved && params.grabCursor) {
      swiper.setGrabCursor(false);
    }
    data.isMoved = false;
    data.startMoving = false;
    return;
  }
  // Return Grab Cursor
  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
    swiper.setGrabCursor(false);
  }

  // Time diff
  const touchEndTime = now();
  const timeDiff = touchEndTime - data.touchStartTime;

  // Tap, doubleTap, Click
  if (swiper.allowClick) {
    const pathTree = e.path || e.composedPath && e.composedPath();
    swiper.updateClickedSlide(pathTree && pathTree[0] || e.target, pathTree);
    swiper.emit('tap click', e);
    if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
      swiper.emit('doubleTap doubleClick', e);
    }
  }
  data.lastClickTime = now();
  nextTick(() => {
    if (!swiper.destroyed) swiper.allowClick = true;
  });
  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    return;
  }
  data.isTouched = false;
  data.isMoved = false;
  data.startMoving = false;
  let currentPos;
  if (params.followFinger) {
    currentPos = rtl ? swiper.translate : -swiper.translate;
  } else {
    currentPos = -data.currentTranslate;
  }
  if (params.cssMode) {
    return;
  }
  if (params.freeMode && params.freeMode.enabled) {
    swiper.freeMode.onTouchEnd({
      currentPos
    });
    return;
  }

  // Find current slide
  let stopIndex = 0;
  let groupSize = swiper.slidesSizesGrid[0];
  for (let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
    const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (typeof slidesGrid[i + increment] !== 'undefined') {
      if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
        stopIndex = i;
        groupSize = slidesGrid[i + increment] - slidesGrid[i];
      }
    } else if (currentPos >= slidesGrid[i]) {
      stopIndex = i;
      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
    }
  }
  let rewindFirstIndex = null;
  let rewindLastIndex = null;
  if (params.rewind) {
    if (swiper.isBeginning) {
      rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    } else if (swiper.isEnd) {
      rewindFirstIndex = 0;
    }
  }
  // Find current slide size
  const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
  const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
  if (timeDiff > params.longSwipesMs) {
    // Long touches
    if (!params.longSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    if (swiper.swipeDirection === 'next') {
      if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);else swiper.slideTo(stopIndex);
    }
    if (swiper.swipeDirection === 'prev') {
      if (ratio > 1 - params.longSwipesRatio) {
        swiper.slideTo(stopIndex + increment);
      } else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) {
        swiper.slideTo(rewindLastIndex);
      } else {
        swiper.slideTo(stopIndex);
      }
    }
  } else {
    // Short swipes
    if (!params.shortSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
    if (!isNavButtonTarget) {
      if (swiper.swipeDirection === 'next') {
        swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
      }
      if (swiper.swipeDirection === 'prev') {
        swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
      }
    } else if (e.target === swiper.navigation.nextEl) {
      swiper.slideTo(stopIndex + increment);
    } else {
      swiper.slideTo(stopIndex);
    }
  }
}

function onResize() {
  const swiper = this;
  const {
    params,
    el
  } = swiper;
  if (el && el.offsetWidth === 0) return;

  // Breakpoints
  if (params.breakpoints) {
    swiper.setBreakpoint();
  }

  // Save locks
  const {
    allowSlideNext,
    allowSlidePrev,
    snapGrid
  } = swiper;
  const isVirtual = swiper.virtual && swiper.params.virtual.enabled;

  // Disable locks on resize
  swiper.allowSlideNext = true;
  swiper.allowSlidePrev = true;
  swiper.updateSize();
  swiper.updateSlides();
  swiper.updateSlidesClasses();
  const isVirtualLoop = isVirtual && params.loop;
  if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) {
    swiper.slideTo(swiper.slides.length - 1, 0, false, true);
  } else {
    if (swiper.params.loop && !isVirtual) {
      swiper.slideToLoop(swiper.realIndex, 0, false, true);
    } else {
      swiper.slideTo(swiper.activeIndex, 0, false, true);
    }
  }
  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
    clearTimeout(swiper.autoplay.resizeTimeout);
    swiper.autoplay.resizeTimeout = setTimeout(() => {
      if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        swiper.autoplay.resume();
      }
    }, 500);
  }
  // Return locks after resize
  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
    swiper.checkOverflow();
  }
}

function onClick(e) {
  const swiper = this;
  if (!swiper.enabled) return;
  if (!swiper.allowClick) {
    if (swiper.params.preventClicks) e.preventDefault();
    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }
}

function onScroll() {
  const swiper = this;
  const {
    wrapperEl,
    rtlTranslate,
    enabled
  } = swiper;
  if (!enabled) return;
  swiper.previousTranslate = swiper.translate;
  if (swiper.isHorizontal()) {
    swiper.translate = -wrapperEl.scrollLeft;
  } else {
    swiper.translate = -wrapperEl.scrollTop;
  }
  // eslint-disable-next-line
  if (swiper.translate === 0) swiper.translate = 0;
  swiper.updateActiveIndex();
  swiper.updateSlidesClasses();
  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
  }
  if (newProgress !== swiper.progress) {
    swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
  }
  swiper.emit('setTranslate', swiper.translate, false);
}

function onLoad(e) {
  const swiper = this;
  processLazyPreloader(swiper, e.target);
  if (swiper.params.cssMode || swiper.params.slidesPerView !== 'auto' && !swiper.params.autoHeight) {
    return;
  }
  swiper.update();
}

let dummyEventAttached = false;
function dummyEventListener() {}
const events = (swiper, method) => {
  const document = getDocument();
  const {
    params,
    el,
    wrapperEl,
    device
  } = swiper;
  const capture = !!params.nested;
  const domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
  const swiperMethod = method;

  // Touch Events
  el[domMethod]('pointerdown', swiper.onTouchStart, {
    passive: false
  });
  document[domMethod]('pointermove', swiper.onTouchMove, {
    passive: false,
    capture
  });
  document[domMethod]('pointerup', swiper.onTouchEnd, {
    passive: true
  });
  document[domMethod]('pointercancel', swiper.onTouchEnd, {
    passive: true
  });
  document[domMethod]('pointerout', swiper.onTouchEnd, {
    passive: true
  });
  document[domMethod]('pointerleave', swiper.onTouchEnd, {
    passive: true
  });
  document[domMethod]('contextmenu', swiper.onTouchEnd, {
    passive: true
  });

  // Prevent Links Clicks
  if (params.preventClicks || params.preventClicksPropagation) {
    el[domMethod]('click', swiper.onClick, true);
  }
  if (params.cssMode) {
    wrapperEl[domMethod]('scroll', swiper.onScroll);
  }

  // Resize handler
  if (params.updateOnWindowResize) {
    swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
  } else {
    swiper[swiperMethod]('observerUpdate', onResize, true);
  }

  // Images loader
  el[domMethod]('load', swiper.onLoad, {
    capture: true
  });
};
function attachEvents() {
  const swiper = this;
  const document = getDocument();
  const {
    params
  } = swiper;
  swiper.onTouchStart = onTouchStart.bind(swiper);
  swiper.onTouchMove = onTouchMove.bind(swiper);
  swiper.onTouchEnd = onTouchEnd.bind(swiper);
  if (params.cssMode) {
    swiper.onScroll = onScroll.bind(swiper);
  }
  swiper.onClick = onClick.bind(swiper);
  swiper.onLoad = onLoad.bind(swiper);
  if (!dummyEventAttached) {
    document.addEventListener('touchstart', dummyEventListener);
    dummyEventAttached = true;
  }
  events(swiper, 'on');
}
function detachEvents() {
  const swiper = this;
  events(swiper, 'off');
}
var events$1 = {
  attachEvents,
  detachEvents
};

const isGridEnabled = (swiper, params) => {
  return swiper.grid && params.grid && params.grid.rows > 1;
};
function setBreakpoint() {
  const swiper = this;
  const {
    realIndex,
    initialized,
    params,
    el
  } = swiper;
  const breakpoints = params.breakpoints;
  if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;

  // Get breakpoint for window width and update parameters
  const breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
  if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
  const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
  const breakpointParams = breakpointOnlyParams || swiper.originalParams;
  const wasMultiRow = isGridEnabled(swiper, params);
  const isMultiRow = isGridEnabled(swiper, breakpointParams);
  const wasEnabled = params.enabled;
  if (wasMultiRow && !isMultiRow) {
    el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
    swiper.emitContainerClasses();
  } else if (!wasMultiRow && isMultiRow) {
    el.classList.add(`${params.containerModifierClass}grid`);
    if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') {
      el.classList.add(`${params.containerModifierClass}grid-column`);
    }
    swiper.emitContainerClasses();
  }

  // Toggle navigation, pagination, scrollbar
  ['navigation', 'pagination', 'scrollbar'].forEach(prop => {
    if (typeof breakpointParams[prop] === 'undefined') return;
    const wasModuleEnabled = params[prop] && params[prop].enabled;
    const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
    if (wasModuleEnabled && !isModuleEnabled) {
      swiper[prop].disable();
    }
    if (!wasModuleEnabled && isModuleEnabled) {
      swiper[prop].enable();
    }
  });
  const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
  const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
  const wasLoop = params.loop;
  if (directionChanged && initialized) {
    swiper.changeDirection();
  }
  extend$1(swiper.params, breakpointParams);
  const isEnabled = swiper.params.enabled;
  const hasLoop = swiper.params.loop;
  Object.assign(swiper, {
    allowTouchMove: swiper.params.allowTouchMove,
    allowSlideNext: swiper.params.allowSlideNext,
    allowSlidePrev: swiper.params.allowSlidePrev
  });
  if (wasEnabled && !isEnabled) {
    swiper.disable();
  } else if (!wasEnabled && isEnabled) {
    swiper.enable();
  }
  swiper.currentBreakpoint = breakpoint;
  swiper.emit('_beforeBreakpoint', breakpointParams);
  if (initialized) {
    if (needsReLoop) {
      swiper.loopDestroy();
      swiper.loopCreate(realIndex);
      swiper.updateSlides();
    } else if (!wasLoop && hasLoop) {
      swiper.loopCreate(realIndex);
      swiper.updateSlides();
    } else if (wasLoop && !hasLoop) {
      swiper.loopDestroy();
    }
  }
  swiper.emit('breakpoint', breakpointParams);
}

function getBreakpoint(breakpoints, base, containerEl) {
  if (base === void 0) {
    base = 'window';
  }
  if (!breakpoints || base === 'container' && !containerEl) return undefined;
  let breakpoint = false;
  const window = getWindow();
  const currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
  const points = Object.keys(breakpoints).map(point => {
    if (typeof point === 'string' && point.indexOf('@') === 0) {
      const minRatio = parseFloat(point.substr(1));
      const value = currentHeight * minRatio;
      return {
        value,
        point
      };
    }
    return {
      value: point,
      point
    };
  });
  points.sort((a, b) => parseInt(a.value, 10) - parseInt(b.value, 10));
  for (let i = 0; i < points.length; i += 1) {
    const {
      point,
      value
    } = points[i];
    if (base === 'window') {
      if (window.matchMedia(`(min-width: ${value}px)`).matches) {
        breakpoint = point;
      }
    } else if (value <= containerEl.clientWidth) {
      breakpoint = point;
    }
  }
  return breakpoint || 'max';
}

var breakpoints = {
  setBreakpoint,
  getBreakpoint
};

function prepareClasses(entries, prefix) {
  const resultClasses = [];
  entries.forEach(item => {
    if (typeof item === 'object') {
      Object.keys(item).forEach(classNames => {
        if (item[classNames]) {
          resultClasses.push(prefix + classNames);
        }
      });
    } else if (typeof item === 'string') {
      resultClasses.push(prefix + item);
    }
  });
  return resultClasses;
}
function addClasses() {
  const swiper = this;
  const {
    classNames,
    params,
    rtl,
    el,
    device
  } = swiper;
  // prettier-ignore
  const suffixes = prepareClasses(['initialized', params.direction, {
    'free-mode': swiper.params.freeMode && params.freeMode.enabled
  }, {
    'autoheight': params.autoHeight
  }, {
    'rtl': rtl
  }, {
    'grid': params.grid && params.grid.rows > 1
  }, {
    'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
  }, {
    'android': device.android
  }, {
    'ios': device.ios
  }, {
    'css-mode': params.cssMode
  }, {
    'centered': params.cssMode && params.centeredSlides
  }, {
    'watch-progress': params.watchSlidesProgress
  }], params.containerModifierClass);
  classNames.push(...suffixes);
  el.classList.add(...classNames);
  swiper.emitContainerClasses();
}

function removeClasses() {
  const swiper = this;
  const {
    el,
    classNames
  } = swiper;
  el.classList.remove(...classNames);
  swiper.emitContainerClasses();
}

var classes = {
  addClasses,
  removeClasses
};

function checkOverflow() {
  const swiper = this;
  const {
    isLocked: wasLocked,
    params
  } = swiper;
  const {
    slidesOffsetBefore
  } = params;
  if (slidesOffsetBefore) {
    const lastSlideIndex = swiper.slides.length - 1;
    const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
    swiper.isLocked = swiper.size > lastSlideRightEdge;
  } else {
    swiper.isLocked = swiper.snapGrid.length === 1;
  }
  if (params.allowSlideNext === true) {
    swiper.allowSlideNext = !swiper.isLocked;
  }
  if (params.allowSlidePrev === true) {
    swiper.allowSlidePrev = !swiper.isLocked;
  }
  if (wasLocked && wasLocked !== swiper.isLocked) {
    swiper.isEnd = false;
  }
  if (wasLocked !== swiper.isLocked) {
    swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
  }
}
var checkOverflow$1 = {
  checkOverflow
};

var defaults = {
  init: true,
  direction: 'horizontal',
  oneWayMovement: false,
  touchEventsTarget: 'wrapper',
  initialSlide: 0,
  speed: 300,
  cssMode: false,
  updateOnWindowResize: true,
  resizeObserver: true,
  nested: false,
  createElements: false,
  enabled: true,
  focusableElements: 'input, select, option, textarea, button, video, label',
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: false,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: false,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: false,
  // Set wrapper width
  setWrapperSize: false,
  // Virtual Translate
  virtualTranslate: false,
  // Effects
  effect: 'slide',
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'

  // Breakpoints
  breakpoints: undefined,
  breakpointsBase: 'window',
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: false,
  centeredSlides: false,
  centeredSlidesBounds: false,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: true,
  centerInsufficientSlides: false,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: true,
  // Round length
  roundLengths: false,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: true,
  shortSwipes: true,
  longSwipes: true,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: true,
  allowTouchMove: true,
  threshold: 5,
  touchMoveStopPropagation: false,
  touchStartPreventDefault: true,
  touchStartForcePreventDefault: false,
  touchReleaseOnEdges: false,
  // Unique Navigation Elements
  uniqueNavElements: true,
  // Resistance
  resistance: true,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: false,
  // Cursor
  grabCursor: false,
  // Clicks
  preventClicks: true,
  preventClicksPropagation: true,
  slideToClickedSlide: false,
  // loop
  loop: false,
  loopedSlides: null,
  loopPreventsSliding: true,
  // rewind
  rewind: false,
  // Swiping/no swiping
  allowSlidePrev: true,
  allowSlideNext: true,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: true,
  noSwipingClass: 'swiper-no-swiping',
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: true,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: 'swiper-',
  // NEW
  slideClass: 'swiper-slide',
  slideActiveClass: 'swiper-slide-active',
  slideVisibleClass: 'swiper-slide-visible',
  slideNextClass: 'swiper-slide-next',
  slidePrevClass: 'swiper-slide-prev',
  wrapperClass: 'swiper-wrapper',
  lazyPreloaderClass: 'swiper-lazy-preloader',
  lazyPreloadPrevNext: 0,
  // Callbacks
  runCallbacksOnInit: true,
  // Internals
  _emitClasses: false
};

function moduleExtendParams(params, allModulesParams) {
  return function extendParams(obj) {
    if (obj === void 0) {
      obj = {};
    }
    const moduleParamName = Object.keys(obj)[0];
    const moduleParams = obj[moduleParamName];
    if (typeof moduleParams !== 'object' || moduleParams === null) {
      extend$1(allModulesParams, obj);
      return;
    }
    if (params[moduleParamName] === true) {
      params[moduleParamName] = {
        enabled: true
      };
    }
    if (moduleParamName === 'navigation' && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) {
      params[moduleParamName].auto = true;
    }
    if (['pagination', 'scrollbar'].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) {
      params[moduleParamName].auto = true;
    }
    if (!(moduleParamName in params && 'enabled' in moduleParams)) {
      extend$1(allModulesParams, obj);
      return;
    }
    if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) {
      params[moduleParamName].enabled = true;
    }
    if (!params[moduleParamName]) params[moduleParamName] = {
      enabled: false
    };
    extend$1(allModulesParams, obj);
  };
}

/* eslint no-param-reassign: "off" */
const prototypes = {
  eventsEmitter,
  update,
  translate,
  transition,
  slide,
  loop,
  grabCursor,
  events: events$1,
  breakpoints,
  checkOverflow: checkOverflow$1,
  classes
};
const extendedDefaults = {};
let Swiper$1 = class Swiper {
  constructor() {
    let el;
    let params;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') {
      params = args[0];
    } else {
      [el, params] = args;
    }
    if (!params) params = {};
    params = extend$1({}, params);
    if (el && !params.el) params.el = el;
    const document = getDocument();
    if (params.el && typeof params.el === 'string' && document.querySelectorAll(params.el).length > 1) {
      const swipers = [];
      document.querySelectorAll(params.el).forEach(containerEl => {
        const newParams = extend$1({}, params, {
          el: containerEl
        });
        swipers.push(new Swiper(newParams));
      });
      // eslint-disable-next-line no-constructor-return
      return swipers;
    }

    // Swiper Instance
    const swiper = this;
    swiper.__swiper__ = true;
    swiper.support = getSupport();
    swiper.device = getDevice({
      userAgent: params.userAgent
    });
    swiper.browser = getBrowser();
    swiper.eventsListeners = {};
    swiper.eventsAnyListeners = [];
    swiper.modules = [...swiper.__modules__];
    if (params.modules && Array.isArray(params.modules)) {
      swiper.modules.push(...params.modules);
    }
    const allModulesParams = {};
    swiper.modules.forEach(mod => {
      mod({
        params,
        swiper,
        extendParams: moduleExtendParams(params, allModulesParams),
        on: swiper.on.bind(swiper),
        once: swiper.once.bind(swiper),
        off: swiper.off.bind(swiper),
        emit: swiper.emit.bind(swiper)
      });
    });

    // Extend defaults with modules params
    const swiperParams = extend$1({}, defaults, allModulesParams);

    // Extend defaults with passed params
    swiper.params = extend$1({}, swiperParams, extendedDefaults, params);
    swiper.originalParams = extend$1({}, swiper.params);
    swiper.passedParams = extend$1({}, params);

    // add event listeners
    if (swiper.params && swiper.params.on) {
      Object.keys(swiper.params.on).forEach(eventName => {
        swiper.on(eventName, swiper.params.on[eventName]);
      });
    }
    if (swiper.params && swiper.params.onAny) {
      swiper.onAny(swiper.params.onAny);
    }

    // Extend Swiper
    Object.assign(swiper, {
      enabled: swiper.params.enabled,
      el,
      // Classes
      classNames: [],
      // Slides
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return swiper.params.direction === 'horizontal';
      },
      isVertical() {
        return swiper.params.direction === 'vertical';
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: true,
      isEnd: false,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: false,
      cssOverflowAdjustment() {
        // Returns 0 unless `translate` is > 2**23
        // Should be subtracted from css values to prevent overflow
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
      },
      // Locks
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev,
      // Touch Events
      touchEventsData: {
        isTouched: undefined,
        isMoved: undefined,
        allowTouchCallbacks: undefined,
        touchStartTime: undefined,
        isScrolling: undefined,
        currentTranslate: undefined,
        startTranslate: undefined,
        allowThresholdMove: undefined,
        // Form elements to match
        focusableElements: swiper.params.focusableElements,
        // Last click time
        lastClickTime: 0,
        clickTimeout: undefined,
        // Velocities
        velocities: [],
        allowMomentumBounce: undefined,
        startMoving: undefined,
        evCache: []
      },
      // Clicks
      allowClick: true,
      // Touches
      allowTouchMove: swiper.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    });
    swiper.emit('_swiper');

    // Init
    if (swiper.params.init) {
      swiper.init();
    }

    // Return app instance
    // eslint-disable-next-line no-constructor-return
    return swiper;
  }
  getSlideIndex(slideEl) {
    const {
      slidesEl,
      params
    } = this;
    const slides = elementChildren(slidesEl, `.${params.slideClass}, swiper-slide`);
    const firstSlideIndex = elementIndex(slides[0]);
    return elementIndex(slideEl) - firstSlideIndex;
  }
  getSlideIndexByData(index) {
    return this.getSlideIndex(this.slides.filter(slideEl => slideEl.getAttribute('data-swiper-slide-index') * 1 === index)[0]);
  }
  recalcSlides() {
    const swiper = this;
    const {
      slidesEl,
      params
    } = swiper;
    swiper.slides = elementChildren(slidesEl, `.${params.slideClass}, swiper-slide`);
  }
  enable() {
    const swiper = this;
    if (swiper.enabled) return;
    swiper.enabled = true;
    if (swiper.params.grabCursor) {
      swiper.setGrabCursor();
    }
    swiper.emit('enable');
  }
  disable() {
    const swiper = this;
    if (!swiper.enabled) return;
    swiper.enabled = false;
    if (swiper.params.grabCursor) {
      swiper.unsetGrabCursor();
    }
    swiper.emit('disable');
  }
  setProgress(progress, speed) {
    const swiper = this;
    progress = Math.min(Math.max(progress, 0), 1);
    const min = swiper.minTranslate();
    const max = swiper.maxTranslate();
    const current = (max - min) * progress + min;
    swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }
  emitContainerClasses() {
    const swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    const cls = swiper.el.className.split(' ').filter(className => {
      return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
    });
    swiper.emit('_containerClasses', cls.join(' '));
  }
  getSlideClasses(slideEl) {
    const swiper = this;
    if (swiper.destroyed) return '';
    return slideEl.className.split(' ').filter(className => {
      return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
    }).join(' ');
  }
  emitSlidesClasses() {
    const swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    const updates = [];
    swiper.slides.forEach(slideEl => {
      const classNames = swiper.getSlideClasses(slideEl);
      updates.push({
        slideEl,
        classNames
      });
      swiper.emit('_slideClass', slideEl, classNames);
    });
    swiper.emit('_slideClasses', updates);
  }
  slidesPerViewDynamic(view, exact) {
    if (view === void 0) {
      view = 'current';
    }
    if (exact === void 0) {
      exact = false;
    }
    const swiper = this;
    const {
      params,
      slides,
      slidesGrid,
      slidesSizesGrid,
      size: swiperSize,
      activeIndex
    } = swiper;
    let spv = 1;
    if (typeof params.slidesPerView === 'number') return params.slidesPerView;
    if (params.centeredSlides) {
      let slideSize = slides[activeIndex] ? slides[activeIndex].swiperSlideSize : 0;
      let breakLoop;
      for (let i = activeIndex + 1; i < slides.length; i += 1) {
        if (slides[i] && !breakLoop) {
          slideSize += slides[i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }
      for (let i = activeIndex - 1; i >= 0; i -= 1) {
        if (slides[i] && !breakLoop) {
          slideSize += slides[i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }
    } else {
      // eslint-disable-next-line
      if (view === 'current') {
        for (let i = activeIndex + 1; i < slides.length; i += 1) {
          const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
          if (slideInView) {
            spv += 1;
          }
        }
      } else {
        // previous
        for (let i = activeIndex - 1; i >= 0; i -= 1) {
          const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
          if (slideInView) {
            spv += 1;
          }
        }
      }
    }
    return spv;
  }
  update() {
    const swiper = this;
    if (!swiper || swiper.destroyed) return;
    const {
      snapGrid,
      params
    } = swiper;
    // Breakpoints
    if (params.breakpoints) {
      swiper.setBreakpoint();
    }
    [...swiper.el.querySelectorAll('[loading="lazy"]')].forEach(imageEl => {
      if (imageEl.complete) {
        processLazyPreloader(swiper, imageEl);
      }
    });
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateProgress();
    swiper.updateSlidesClasses();
    function setTranslate() {
      const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
      const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
      swiper.setTranslate(newTranslate);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
    let translated;
    if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
      setTranslate();
      if (params.autoHeight) {
        swiper.updateAutoHeight();
      }
    } else {
      if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
        const slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
        translated = swiper.slideTo(slides.length - 1, 0, false, true);
      } else {
        translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
      }
      if (!translated) {
        setTranslate();
      }
    }
    if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }
    swiper.emit('update');
  }
  changeDirection(newDirection, needUpdate) {
    if (needUpdate === void 0) {
      needUpdate = true;
    }
    const swiper = this;
    const currentDirection = swiper.params.direction;
    if (!newDirection) {
      // eslint-disable-next-line
      newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
    }
    if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
      return swiper;
    }
    swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
    swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
    swiper.emitContainerClasses();
    swiper.params.direction = newDirection;
    swiper.slides.forEach(slideEl => {
      if (newDirection === 'vertical') {
        slideEl.style.width = '';
      } else {
        slideEl.style.height = '';
      }
    });
    swiper.emit('changeDirection');
    if (needUpdate) swiper.update();
    return swiper;
  }
  changeLanguageDirection(direction) {
    const swiper = this;
    if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
    swiper.rtl = direction === 'rtl';
    swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;
    if (swiper.rtl) {
      swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
      swiper.el.dir = 'rtl';
    } else {
      swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
      swiper.el.dir = 'ltr';
    }
    swiper.update();
  }
  mount(element) {
    const swiper = this;
    if (swiper.mounted) return true;

    // Find el
    let el = element || swiper.params.el;
    if (typeof el === 'string') {
      el = document.querySelector(el);
    }
    if (!el) {
      return false;
    }
    el.swiper = swiper;
    if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === 'SWIPER-CONTAINER') {
      swiper.isElement = true;
    }
    const getWrapperSelector = () => {
      return `.${(swiper.params.wrapperClass || '').trim().split(' ').join('.')}`;
    };
    const getWrapper = () => {
      if (el && el.shadowRoot && el.shadowRoot.querySelector) {
        const res = el.shadowRoot.querySelector(getWrapperSelector());
        // Children needs to return slot items
        return res;
      }
      return elementChildren(el, getWrapperSelector())[0];
    };
    // Find Wrapper
    let wrapperEl = getWrapper();
    if (!wrapperEl && swiper.params.createElements) {
      wrapperEl = createElement('div', swiper.params.wrapperClass);
      el.append(wrapperEl);
      elementChildren(el, `.${swiper.params.slideClass}`).forEach(slideEl => {
        wrapperEl.append(slideEl);
      });
    }
    Object.assign(swiper, {
      el,
      wrapperEl,
      slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
      hostEl: swiper.isElement ? el.parentNode.host : el,
      mounted: true,
      // RTL
      rtl: el.dir.toLowerCase() === 'rtl' || elementStyle(el, 'direction') === 'rtl',
      rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || elementStyle(el, 'direction') === 'rtl'),
      wrongRTL: elementStyle(wrapperEl, 'display') === '-webkit-box'
    });
    return true;
  }
  init(el) {
    const swiper = this;
    if (swiper.initialized) return swiper;
    const mounted = swiper.mount(el);
    if (mounted === false) return swiper;
    swiper.emit('beforeInit');

    // Set breakpoint
    if (swiper.params.breakpoints) {
      swiper.setBreakpoint();
    }

    // Add Classes
    swiper.addClasses();

    // Update size
    swiper.updateSize();

    // Update slides
    swiper.updateSlides();
    if (swiper.params.watchOverflow) {
      swiper.checkOverflow();
    }

    // Set Grab Cursor
    if (swiper.params.grabCursor && swiper.enabled) {
      swiper.setGrabCursor();
    }

    // Slide To Initial Slide
    if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
      swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
    } else {
      swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
    }

    // Create loop
    if (swiper.params.loop) {
      swiper.loopCreate();
    }

    // Attach events
    swiper.attachEvents();
    const lazyElements = [...swiper.el.querySelectorAll('[loading="lazy"]')];
    if (swiper.isElement) {
      lazyElements.push(...swiper.hostEl.querySelectorAll('[loading="lazy"]'));
    }
    lazyElements.forEach(imageEl => {
      if (imageEl.complete) {
        processLazyPreloader(swiper, imageEl);
      } else {
        imageEl.addEventListener('load', e => {
          processLazyPreloader(swiper, e.target);
        });
      }
    });
    preload(swiper);

    // Init Flag
    swiper.initialized = true;
    preload(swiper);

    // Emit
    swiper.emit('init');
    swiper.emit('afterInit');
    return swiper;
  }
  destroy(deleteInstance, cleanStyles) {
    if (deleteInstance === void 0) {
      deleteInstance = true;
    }
    if (cleanStyles === void 0) {
      cleanStyles = true;
    }
    const swiper = this;
    const {
      params,
      el,
      wrapperEl,
      slides
    } = swiper;
    if (typeof swiper.params === 'undefined' || swiper.destroyed) {
      return null;
    }
    swiper.emit('beforeDestroy');

    // Init Flag
    swiper.initialized = false;

    // Detach events
    swiper.detachEvents();

    // Destroy loop
    if (params.loop) {
      swiper.loopDestroy();
    }

    // Cleanup styles
    if (cleanStyles) {
      swiper.removeClasses();
      el.removeAttribute('style');
      wrapperEl.removeAttribute('style');
      if (slides && slides.length) {
        slides.forEach(slideEl => {
          slideEl.classList.remove(params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
          slideEl.removeAttribute('style');
          slideEl.removeAttribute('data-swiper-slide-index');
        });
      }
    }
    swiper.emit('destroy');

    // Detach emitter events
    Object.keys(swiper.eventsListeners).forEach(eventName => {
      swiper.off(eventName);
    });
    if (deleteInstance !== false) {
      swiper.el.swiper = null;
      deleteProps(swiper);
    }
    swiper.destroyed = true;
    return null;
  }
  static extendDefaults(newDefaults) {
    extend$1(extendedDefaults, newDefaults);
  }
  static get extendedDefaults() {
    return extendedDefaults;
  }
  static get defaults() {
    return defaults;
  }
  static installModule(mod) {
    if (!Swiper.prototype.__modules__) Swiper.prototype.__modules__ = [];
    const modules = Swiper.prototype.__modules__;
    if (typeof mod === 'function' && modules.indexOf(mod) < 0) {
      modules.push(mod);
    }
  }
  static use(module) {
    if (Array.isArray(module)) {
      module.forEach(m => Swiper.installModule(m));
      return Swiper;
    }
    Swiper.installModule(module);
    return Swiper;
  }
};
Object.keys(prototypes).forEach(prototypeGroup => {
  Object.keys(prototypes[prototypeGroup]).forEach(protoMethod => {
    Swiper$1.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
  });
});
Swiper$1.use([Resize, Observer]);

/* underscore in name -> watch for changes */
const paramsList = ['eventsPrefix', 'injectStyles', 'injectStylesUrls', 'modules', 'init', '_direction', 'oneWayMovement', 'touchEventsTarget', 'initialSlide', '_speed', 'cssMode', 'updateOnWindowResize', 'resizeObserver', 'nested', 'focusableElements', '_enabled', '_width', '_height', 'preventInteractionOnTransition', 'userAgent', 'url', '_edgeSwipeDetection', '_edgeSwipeThreshold', '_freeMode', '_autoHeight', 'setWrapperSize', 'virtualTranslate', '_effect', 'breakpoints', 'breakpointsBase', '_spaceBetween', '_slidesPerView', 'maxBackfaceHiddenSlides', '_grid', '_slidesPerGroup', '_slidesPerGroupSkip', '_slidesPerGroupAuto', '_centeredSlides', '_centeredSlidesBounds', '_slidesOffsetBefore', '_slidesOffsetAfter', 'normalizeSlideIndex', '_centerInsufficientSlides', '_watchOverflow', 'roundLengths', 'touchRatio', 'touchAngle', 'simulateTouch', '_shortSwipes', '_longSwipes', 'longSwipesRatio', 'longSwipesMs', '_followFinger', 'allowTouchMove', '_threshold', 'touchMoveStopPropagation', 'touchStartPreventDefault', 'touchStartForcePreventDefault', 'touchReleaseOnEdges', 'uniqueNavElements', '_resistance', '_resistanceRatio', '_watchSlidesProgress', '_grabCursor', 'preventClicks', 'preventClicksPropagation', '_slideToClickedSlide', '_loop', 'loopedSlides', 'loopPreventsSliding', '_rewind', '_allowSlidePrev', '_allowSlideNext', '_swipeHandler', '_noSwiping', 'noSwipingClass', 'noSwipingSelector', 'passiveListeners', 'containerModifierClass', 'slideClass', 'slideActiveClass', 'slideVisibleClass', 'slideNextClass', 'slidePrevClass', 'wrapperClass', 'lazyPreloaderClass', 'lazyPreloadPrevNext', 'runCallbacksOnInit', 'observer', 'observeParents', 'observeSlideChildren',
// modules
'a11y', '_autoplay', '_controller', 'coverflowEffect', 'cubeEffect', 'fadeEffect', 'flipEffect', 'creativeEffect', 'cardsEffect', 'hashNavigation', 'history', 'keyboard', 'mousewheel', '_navigation', '_pagination', 'parallax', '_scrollbar', '_thumbs', 'virtual', 'zoom', 'control'];

function isObject(o) {
  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object' && !o.__swiper__;
}
function extend(target, src) {
  const noExtend = ['__proto__', 'constructor', 'prototype'];
  Object.keys(src).filter(key => noExtend.indexOf(key) < 0).forEach(key => {
    if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
      if (src[key].__swiper__) target[key] = src[key];else extend(target[key], src[key]);
    } else {
      target[key] = src[key];
    }
  });
}
function needsNavigation(params) {
  if (params === void 0) {
    params = {};
  }
  return params.navigation && typeof params.navigation.nextEl === 'undefined' && typeof params.navigation.prevEl === 'undefined';
}
function needsPagination(params) {
  if (params === void 0) {
    params = {};
  }
  return params.pagination && typeof params.pagination.el === 'undefined';
}
function needsScrollbar(params) {
  if (params === void 0) {
    params = {};
  }
  return params.scrollbar && typeof params.scrollbar.el === 'undefined';
}
function uniqueClasses(classNames) {
  if (classNames === void 0) {
    classNames = '';
  }
  const classes = classNames.split(' ').map(c => c.trim()).filter(c => !!c);
  const unique = [];
  classes.forEach(c => {
    if (unique.indexOf(c) < 0) unique.push(c);
  });
  return unique.join(' ');
}
function wrapperClass(className) {
  if (className === void 0) {
    className = '';
  }
  if (!className) return 'swiper-wrapper';
  if (!className.includes('swiper-wrapper')) return `swiper-wrapper ${className}`;
  return className;
}

function updateSwiper(_ref) {
  let {
    swiper,
    slides,
    passedParams,
    changedParams,
    nextEl,
    prevEl,
    scrollbarEl,
    paginationEl
  } = _ref;
  const updateParams = changedParams.filter(key => key !== 'children' && key !== 'direction' && key !== 'wrapperClass');
  const {
    params: currentParams,
    pagination,
    navigation,
    scrollbar,
    virtual,
    thumbs
  } = swiper;
  let needThumbsInit;
  let needControllerInit;
  let needPaginationInit;
  let needScrollbarInit;
  let needNavigationInit;
  let loopNeedDestroy;
  let loopNeedEnable;
  let loopNeedReloop;
  if (changedParams.includes('thumbs') && passedParams.thumbs && passedParams.thumbs.swiper && currentParams.thumbs && !currentParams.thumbs.swiper) {
    needThumbsInit = true;
  }
  if (changedParams.includes('controller') && passedParams.controller && passedParams.controller.control && currentParams.controller && !currentParams.controller.control) {
    needControllerInit = true;
  }
  if (changedParams.includes('pagination') && passedParams.pagination && (passedParams.pagination.el || paginationEl) && (currentParams.pagination || currentParams.pagination === false) && pagination && !pagination.el) {
    needPaginationInit = true;
  }
  if (changedParams.includes('scrollbar') && passedParams.scrollbar && (passedParams.scrollbar.el || scrollbarEl) && (currentParams.scrollbar || currentParams.scrollbar === false) && scrollbar && !scrollbar.el) {
    needScrollbarInit = true;
  }
  if (changedParams.includes('navigation') && passedParams.navigation && (passedParams.navigation.prevEl || prevEl) && (passedParams.navigation.nextEl || nextEl) && (currentParams.navigation || currentParams.navigation === false) && navigation && !navigation.prevEl && !navigation.nextEl) {
    needNavigationInit = true;
  }
  const destroyModule = mod => {
    if (!swiper[mod]) return;
    swiper[mod].destroy();
    if (mod === 'navigation') {
      if (swiper.isElement) {
        swiper[mod].prevEl.remove();
        swiper[mod].nextEl.remove();
      }
      currentParams[mod].prevEl = undefined;
      currentParams[mod].nextEl = undefined;
      swiper[mod].prevEl = undefined;
      swiper[mod].nextEl = undefined;
    } else {
      if (swiper.isElement) {
        swiper[mod].el.remove();
      }
      currentParams[mod].el = undefined;
      swiper[mod].el = undefined;
    }
  };
  if (changedParams.includes('loop') && swiper.isElement) {
    if (currentParams.loop && !passedParams.loop) {
      loopNeedDestroy = true;
    } else if (!currentParams.loop && passedParams.loop) {
      loopNeedEnable = true;
    } else {
      loopNeedReloop = true;
    }
  }
  updateParams.forEach(key => {
    if (isObject(currentParams[key]) && isObject(passedParams[key])) {
      extend(currentParams[key], passedParams[key]);
      if ((key === 'navigation' || key === 'pagination' || key === 'scrollbar') && 'enabled' in passedParams[key] && !passedParams[key].enabled) {
        destroyModule(key);
      }
    } else {
      const newValue = passedParams[key];
      if ((newValue === true || newValue === false) && (key === 'navigation' || key === 'pagination' || key === 'scrollbar')) {
        if (newValue === false) {
          destroyModule(key);
        }
      } else {
        currentParams[key] = passedParams[key];
      }
    }
  });
  if (updateParams.includes('controller') && !needControllerInit && swiper.controller && swiper.controller.control && currentParams.controller && currentParams.controller.control) {
    swiper.controller.control = currentParams.controller.control;
  }
  if (changedParams.includes('children') && slides && virtual && currentParams.virtual.enabled) {
    virtual.slides = slides;
    virtual.update(true);
  }
  if (changedParams.includes('children') && slides && currentParams.loop) {
    loopNeedReloop = true;
  }
  if (needThumbsInit) {
    const initialized = thumbs.init();
    if (initialized) thumbs.update(true);
  }
  if (needControllerInit) {
    swiper.controller.control = currentParams.controller.control;
  }
  if (needPaginationInit) {
    if (swiper.isElement && (!paginationEl || typeof paginationEl === 'string')) {
      paginationEl = document.createElement('div');
      paginationEl.classList.add('swiper-pagination');
      paginationEl.part.add('pagination');
      swiper.el.appendChild(paginationEl);
    }
    if (paginationEl) currentParams.pagination.el = paginationEl;
    pagination.init();
    pagination.render();
    pagination.update();
  }
  if (needScrollbarInit) {
    if (swiper.isElement && (!scrollbarEl || typeof scrollbarEl === 'string')) {
      scrollbarEl = document.createElement('div');
      scrollbarEl.classList.add('swiper-scrollbar');
      scrollbarEl.part.add('scrollbar');
      swiper.el.appendChild(scrollbarEl);
    }
    if (scrollbarEl) currentParams.scrollbar.el = scrollbarEl;
    scrollbar.init();
    scrollbar.updateSize();
    scrollbar.setTranslate();
  }
  if (needNavigationInit) {
    if (swiper.isElement) {
      if (!nextEl || typeof nextEl === 'string') {
        nextEl = document.createElement('div');
        nextEl.classList.add('swiper-button-next');
        nextEl.innerHTML = swiper.hostEl.constructor.nextButtonSvg;
        nextEl.part.add('button-next');
        swiper.el.appendChild(nextEl);
      }
      if (!prevEl || typeof prevEl === 'string') {
        prevEl = document.createElement('div');
        prevEl.classList.add('swiper-button-prev');
        prevEl.innerHTML = swiper.hostEl.constructor.prevButtonSvg;
        prevEl.part.add('button-prev');
        swiper.el.appendChild(prevEl);
      }
    }
    if (nextEl) currentParams.navigation.nextEl = nextEl;
    if (prevEl) currentParams.navigation.prevEl = prevEl;
    navigation.init();
    navigation.update();
  }
  if (changedParams.includes('allowSlideNext')) {
    swiper.allowSlideNext = passedParams.allowSlideNext;
  }
  if (changedParams.includes('allowSlidePrev')) {
    swiper.allowSlidePrev = passedParams.allowSlidePrev;
  }
  if (changedParams.includes('direction')) {
    swiper.changeDirection(passedParams.direction, false);
  }
  if (loopNeedDestroy || loopNeedReloop) {
    swiper.loopDestroy();
  }
  if (loopNeedEnable || loopNeedReloop) {
    swiper.loopCreate();
  }
  swiper.update();
}

function getParams(obj, splitEvents) {
  if (obj === void 0) {
    obj = {};
  }
  if (splitEvents === void 0) {
    splitEvents = true;
  }
  const params = {
    on: {}
  };
  const events = {};
  const passedParams = {};
  extend(params, defaults);
  params._emitClasses = true;
  params.init = false;
  const rest = {};
  const allowedParams = paramsList.map(key => key.replace(/_/, ''));
  const plainObj = Object.assign({}, obj);
  Object.keys(plainObj).forEach(key => {
    if (typeof obj[key] === 'undefined') return;
    if (allowedParams.indexOf(key) >= 0) {
      if (isObject(obj[key])) {
        params[key] = {};
        passedParams[key] = {};
        extend(params[key], obj[key]);
        extend(passedParams[key], obj[key]);
      } else {
        params[key] = obj[key];
        passedParams[key] = obj[key];
      }
    } else if (key.search(/on[A-Z]/) === 0 && typeof obj[key] === 'function') {
      if (splitEvents) {
        events[`${key[2].toLowerCase()}${key.substr(3)}`] = obj[key];
      } else {
        params.on[`${key[2].toLowerCase()}${key.substr(3)}`] = obj[key];
      }
    } else {
      rest[key] = obj[key];
    }
  });
  ['navigation', 'pagination', 'scrollbar'].forEach(key => {
    if (params[key] === true) params[key] = {};
    if (params[key] === false) delete params[key];
  });
  return {
    params,
    passedParams,
    rest,
    events
  };
}

function mountSwiper(_ref, swiperParams) {
  let {
    el,
    nextEl,
    prevEl,
    paginationEl,
    scrollbarEl,
    swiper
  } = _ref;
  if (needsNavigation(swiperParams) && nextEl && prevEl) {
    swiper.params.navigation.nextEl = nextEl;
    swiper.originalParams.navigation.nextEl = nextEl;
    swiper.params.navigation.prevEl = prevEl;
    swiper.originalParams.navigation.prevEl = prevEl;
  }
  if (needsPagination(swiperParams) && paginationEl) {
    swiper.params.pagination.el = paginationEl;
    swiper.originalParams.pagination.el = paginationEl;
  }
  if (needsScrollbar(swiperParams) && scrollbarEl) {
    swiper.params.scrollbar.el = scrollbarEl;
    swiper.originalParams.scrollbar.el = scrollbarEl;
  }
  swiper.init(el);
}

function getChangedParams(swiperParams, oldParams, children, oldChildren, getKey) {
  const keys = [];
  if (!oldParams) return keys;
  const addKey = key => {
    if (keys.indexOf(key) < 0) keys.push(key);
  };
  if (children && oldChildren) {
    const oldChildrenKeys = oldChildren.map(getKey);
    const childrenKeys = children.map(getKey);
    if (oldChildrenKeys.join('') !== childrenKeys.join('')) addKey('children');
    if (oldChildren.length !== children.length) addKey('children');
  }
  const watchParams = paramsList.filter(key => key[0] === '_').map(key => key.replace(/_/, ''));
  watchParams.forEach(key => {
    if (key in swiperParams && key in oldParams) {
      if (isObject(swiperParams[key]) && isObject(oldParams[key])) {
        const newKeys = Object.keys(swiperParams[key]);
        const oldKeys = Object.keys(oldParams[key]);
        if (newKeys.length !== oldKeys.length) {
          addKey(key);
        } else {
          newKeys.forEach(newKey => {
            if (swiperParams[key][newKey] !== oldParams[key][newKey]) {
              addKey(key);
            }
          });
          oldKeys.forEach(oldKey => {
            if (swiperParams[key][oldKey] !== oldParams[key][oldKey]) addKey(key);
          });
        }
      } else if (swiperParams[key] !== oldParams[key]) {
        addKey(key);
      }
    }
  });
  return keys;
}

const updateOnVirtualData = swiper => {
  if (!swiper || swiper.destroyed || !swiper.params.virtual || swiper.params.virtual && !swiper.params.virtual.enabled) return;
  swiper.updateSlides();
  swiper.updateProgress();
  swiper.updateSlidesClasses();
  if (swiper.parallax && swiper.params.parallax && swiper.params.parallax.enabled) {
    swiper.parallax.setTranslate();
  }
};

/**
 * Swiper React 10.3.1
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2023 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: September 28, 2023
 */


function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

function isChildSwiperSlide(child) {
  return child.type && child.type.displayName && child.type.displayName.includes('SwiperSlide');
}
function processChildren(c) {
  const slides = [];
  React__namespace.default.Children.toArray(c).forEach(child => {
    if (isChildSwiperSlide(child)) {
      slides.push(child);
    } else if (child.props && child.props.children) {
      processChildren(child.props.children).forEach(slide => slides.push(slide));
    }
  });
  return slides;
}
function getChildren(c) {
  const slides = [];
  const slots = {
    'container-start': [],
    'container-end': [],
    'wrapper-start': [],
    'wrapper-end': []
  };
  React__namespace.default.Children.toArray(c).forEach(child => {
    if (isChildSwiperSlide(child)) {
      slides.push(child);
    } else if (child.props && child.props.slot && slots[child.props.slot]) {
      slots[child.props.slot].push(child);
    } else if (child.props && child.props.children) {
      const foundSlides = processChildren(child.props.children);
      if (foundSlides.length > 0) {
        foundSlides.forEach(slide => slides.push(slide));
      } else {
        slots['container-end'].push(child);
      }
    } else {
      slots['container-end'].push(child);
    }
  });
  return {
    slides,
    slots
  };
}

function renderVirtual(swiper, slides, virtualData) {
  if (!virtualData) return null;
  const getSlideIndex = index => {
    let slideIndex = index;
    if (index < 0) {
      slideIndex = slides.length + index;
    } else if (slideIndex >= slides.length) {
      // eslint-disable-next-line
      slideIndex = slideIndex - slides.length;
    }
    return slideIndex;
  };
  const style = swiper.isHorizontal() ? {
    [swiper.rtlTranslate ? 'right' : 'left']: `${virtualData.offset}px`
  } : {
    top: `${virtualData.offset}px`
  };
  const {
    from,
    to
  } = virtualData;
  const loopFrom = swiper.params.loop ? -slides.length : 0;
  const loopTo = swiper.params.loop ? slides.length * 2 : slides.length;
  const slidesToRender = [];
  for (let i = loopFrom; i < loopTo; i += 1) {
    if (i >= from && i <= to) {
      slidesToRender.push(slides[getSlideIndex(i)]);
    }
  }
  return slidesToRender.map((child, index) => {
    return /*#__PURE__*/React__namespace.default.cloneElement(child, {
      swiper,
      style,
      key: `slide-${index}`
    });
  });
}

function useIsomorphicLayoutEffect(callback, deps) {
  // eslint-disable-next-line
  if (typeof window === 'undefined') return React.useEffect(callback, deps);
  return React.useLayoutEffect(callback, deps);
}

const SwiperSlideContext = /*#__PURE__*/React.createContext(null);
const SwiperContext = /*#__PURE__*/React.createContext(null);

const Swiper = /*#__PURE__*/React.forwardRef(function (_temp, externalElRef) {
  let {
    className,
    tag: Tag = 'div',
    wrapperTag: WrapperTag = 'div',
    children,
    onSwiper,
    ...rest
  } = _temp === void 0 ? {} : _temp;
  let eventsAssigned = false;
  const [containerClasses, setContainerClasses] = React.useState('swiper');
  const [virtualData, setVirtualData] = React.useState(null);
  const [breakpointChanged, setBreakpointChanged] = React.useState(false);
  const initializedRef = React.useRef(false);
  const swiperElRef = React.useRef(null);
  const swiperRef = React.useRef(null);
  const oldPassedParamsRef = React.useRef(null);
  const oldSlides = React.useRef(null);
  const nextElRef = React.useRef(null);
  const prevElRef = React.useRef(null);
  const paginationElRef = React.useRef(null);
  const scrollbarElRef = React.useRef(null);
  const {
    params: swiperParams,
    passedParams,
    rest: restProps,
    events
  } = getParams(rest);
  const {
    slides,
    slots
  } = getChildren(children);
  const onBeforeBreakpoint = () => {
    setBreakpointChanged(!breakpointChanged);
  };
  Object.assign(swiperParams.on, {
    _containerClasses(swiper, classes) {
      setContainerClasses(classes);
    }
  });
  const initSwiper = () => {
    // init swiper
    Object.assign(swiperParams.on, events);
    eventsAssigned = true;
    const passParams = {
      ...swiperParams
    };
    delete passParams.wrapperClass;
    swiperRef.current = new Swiper$1(passParams);
    if (swiperRef.current.virtual && swiperRef.current.params.virtual.enabled) {
      swiperRef.current.virtual.slides = slides;
      const extendWith = {
        cache: false,
        slides,
        renderExternal: setVirtualData,
        renderExternalUpdate: false
      };
      extend(swiperRef.current.params.virtual, extendWith);
      extend(swiperRef.current.originalParams.virtual, extendWith);
    }
  };
  if (!swiperElRef.current) {
    initSwiper();
  }

  // Listen for breakpoints change
  if (swiperRef.current) {
    swiperRef.current.on('_beforeBreakpoint', onBeforeBreakpoint);
  }
  const attachEvents = () => {
    if (eventsAssigned || !events || !swiperRef.current) return;
    Object.keys(events).forEach(eventName => {
      swiperRef.current.on(eventName, events[eventName]);
    });
  };
  const detachEvents = () => {
    if (!events || !swiperRef.current) return;
    Object.keys(events).forEach(eventName => {
      swiperRef.current.off(eventName, events[eventName]);
    });
  };
  React.useEffect(() => {
    return () => {
      if (swiperRef.current) swiperRef.current.off('_beforeBreakpoint', onBeforeBreakpoint);
    };
  });

  // set initialized flag
  React.useEffect(() => {
    if (!initializedRef.current && swiperRef.current) {
      swiperRef.current.emitSlidesClasses();
      initializedRef.current = true;
    }
  });

  // mount swiper
  useIsomorphicLayoutEffect(() => {
    if (externalElRef) {
      externalElRef.current = swiperElRef.current;
    }
    if (!swiperElRef.current) return;
    if (swiperRef.current.destroyed) {
      initSwiper();
    }
    mountSwiper({
      el: swiperElRef.current,
      nextEl: nextElRef.current,
      prevEl: prevElRef.current,
      paginationEl: paginationElRef.current,
      scrollbarEl: scrollbarElRef.current,
      swiper: swiperRef.current
    }, swiperParams);
    if (onSwiper) onSwiper(swiperRef.current);
    // eslint-disable-next-line
    return () => {
      if (swiperRef.current && !swiperRef.current.destroyed) {
        swiperRef.current.destroy(true, false);
      }
    };
  }, []);

  // watch for params change
  useIsomorphicLayoutEffect(() => {
    attachEvents();
    const changedParams = getChangedParams(passedParams, oldPassedParamsRef.current, slides, oldSlides.current, c => c.key);
    oldPassedParamsRef.current = passedParams;
    oldSlides.current = slides;
    if (changedParams.length && swiperRef.current && !swiperRef.current.destroyed) {
      updateSwiper({
        swiper: swiperRef.current,
        slides,
        passedParams,
        changedParams,
        nextEl: nextElRef.current,
        prevEl: prevElRef.current,
        scrollbarEl: scrollbarElRef.current,
        paginationEl: paginationElRef.current
      });
    }
    return () => {
      detachEvents();
    };
  });

  // update on virtual update
  useIsomorphicLayoutEffect(() => {
    updateOnVirtualData(swiperRef.current);
  }, [virtualData]);

  // bypass swiper instance to slides
  function renderSlides() {
    if (swiperParams.virtual) {
      return renderVirtual(swiperRef.current, slides, virtualData);
    }
    return slides.map((child, index) => {
      return /*#__PURE__*/React__namespace.default.cloneElement(child, {
        swiper: swiperRef.current,
        swiperSlideIndex: index
      });
    });
  }
  return /*#__PURE__*/React__namespace.default.createElement(Tag, _extends({
    ref: swiperElRef,
    className: uniqueClasses(`${containerClasses}${className ? ` ${className}` : ''}`)
  }, restProps), /*#__PURE__*/React__namespace.default.createElement(SwiperContext.Provider, {
    value: swiperRef.current
  }, slots['container-start'], /*#__PURE__*/React__namespace.default.createElement(WrapperTag, {
    className: wrapperClass(swiperParams.wrapperClass)
  }, slots['wrapper-start'], renderSlides(), slots['wrapper-end']), needsNavigation(swiperParams) && /*#__PURE__*/React__namespace.default.createElement(React__namespace.default.Fragment, null, /*#__PURE__*/React__namespace.default.createElement("div", {
    ref: prevElRef,
    className: "swiper-button-prev"
  }), /*#__PURE__*/React__namespace.default.createElement("div", {
    ref: nextElRef,
    className: "swiper-button-next"
  })), needsScrollbar(swiperParams) && /*#__PURE__*/React__namespace.default.createElement("div", {
    ref: scrollbarElRef,
    className: "swiper-scrollbar"
  }), needsPagination(swiperParams) && /*#__PURE__*/React__namespace.default.createElement("div", {
    ref: paginationElRef,
    className: "swiper-pagination"
  }), slots['container-end']));
});
Swiper.displayName = 'Swiper';

const SwiperSlide = /*#__PURE__*/React.forwardRef(function (_temp, externalRef) {
  let {
    tag: Tag = 'div',
    children,
    className = '',
    swiper,
    zoom,
    lazy,
    virtualIndex,
    swiperSlideIndex,
    ...rest
  } = _temp === void 0 ? {} : _temp;
  const slideElRef = React.useRef(null);
  const [slideClasses, setSlideClasses] = React.useState('swiper-slide');
  const [lazyLoaded, setLazyLoaded] = React.useState(false);
  function updateClasses(_s, el, classNames) {
    if (el === slideElRef.current) {
      setSlideClasses(classNames);
    }
  }
  useIsomorphicLayoutEffect(() => {
    if (typeof swiperSlideIndex !== 'undefined') {
      slideElRef.current.swiperSlideIndex = swiperSlideIndex;
    }
    if (externalRef) {
      externalRef.current = slideElRef.current;
    }
    if (!slideElRef.current || !swiper) {
      return;
    }
    if (swiper.destroyed) {
      if (slideClasses !== 'swiper-slide') {
        setSlideClasses('swiper-slide');
      }
      return;
    }
    swiper.on('_slideClass', updateClasses);
    // eslint-disable-next-line
    return () => {
      if (!swiper) return;
      swiper.off('_slideClass', updateClasses);
    };
  });
  useIsomorphicLayoutEffect(() => {
    if (swiper && slideElRef.current && !swiper.destroyed) {
      setSlideClasses(swiper.getSlideClasses(slideElRef.current));
    }
  }, [swiper]);
  const slideData = {
    isActive: slideClasses.indexOf('swiper-slide-active') >= 0,
    isVisible: slideClasses.indexOf('swiper-slide-visible') >= 0,
    isPrev: slideClasses.indexOf('swiper-slide-prev') >= 0,
    isNext: slideClasses.indexOf('swiper-slide-next') >= 0
  };
  const renderChildren = () => {
    return typeof children === 'function' ? children(slideData) : children;
  };
  const onLoad = () => {
    setLazyLoaded(true);
  };
  return /*#__PURE__*/React__namespace.default.createElement(Tag, _extends({
    ref: slideElRef,
    className: uniqueClasses(`${slideClasses}${className ? ` ${className}` : ''}`),
    "data-swiper-slide-index": virtualIndex,
    onLoad: onLoad
  }, rest), zoom && /*#__PURE__*/React__namespace.default.createElement(SwiperSlideContext.Provider, {
    value: slideData
  }, /*#__PURE__*/React__namespace.default.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof zoom === 'number' ? zoom : undefined
  }, renderChildren(), lazy && !lazyLoaded && /*#__PURE__*/React__namespace.default.createElement("div", {
    className: "swiper-lazy-preloader"
  }))), !zoom && /*#__PURE__*/React__namespace.default.createElement(SwiperSlideContext.Provider, {
    value: slideData
  }, renderChildren(), lazy && !lazyLoaded && /*#__PURE__*/React__namespace.default.createElement("div", {
    className: "swiper-lazy-preloader"
  })));
});
SwiperSlide.displayName = 'SwiperSlide';

var SliderArrow = function (_a) {
    var direction = _a.direction, swiper = _a.swiper;
    var handleClick = function () {
        if (direction === 'left') {
            swiper === null || swiper === void 0 ? void 0 : swiper.slidePrev();
            return;
        }
        swiper === null || swiper === void 0 ? void 0 : swiper.slideNext();
    };
    return React__namespace.createElement(StyledArrowLeft, { direction: direction, onClick: handleClick });
};
var StyledArrowLeft = styled__default.default(ArrowDown.ArrowDown).withConfig({ displayName: "StyledArrowLeft", componentId: "-17fr24t" })(templateObject_2$E || (templateObject_2$E = _tslib.__makeTemplateObject(["\n  display: none;\n  cursor: pointer;\n  position: absolute;\n  top: calc(50% - 21px);\n  z-index: 10;\n  transform: translateY(-50%) rotate(90deg);\n  left: -64px;\n\n  ", "\n\n  @media ", " {\n    display: block;\n  }\n"], ["\n  display: none;\n  cursor: pointer;\n  position: absolute;\n  top: calc(50% - 21px);\n  z-index: 10;\n  transform: translateY(-50%) rotate(90deg);\n  left: -64px;\n\n  ", "\n\n  @media ", " {\n    display: block;\n  }\n"])), function (props) {
    return props.direction === 'right' && styled.css(templateObject_1$T || (templateObject_1$T = _tslib.__makeTemplateObject(["\n      transform: translateY(-50%) rotate(-90deg);\n      left: unset;\n      right: -64px;\n    "], ["\n      transform: translateY(-50%) rotate(-90deg);\n      left: unset;\n      right: -64px;\n    "])));
}, ResponsiveSizes.desktop);
var templateObject_1$T, templateObject_2$E;

var AvatarPlaceholder = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 36 : _b, _c = _a.height, height = _c === void 0 ? 37 : _c, props = _tslib.__rest(_a, ["width", "height"]);
    return (React__namespace.createElement("svg", _tslib.__assign({ viewBox: "0 0 61 61", fill: "none", xmlns: "http://www.w3.org/2000/svg", width: width, height: height }, props),
        React__namespace.createElement("circle", { cx: "30.8496", cy: "30.2251", r: "29", fill: "#E3EEF8", stroke: "white", strokeWidth: "2" }),
        React__namespace.createElement("mask", { id: "mask0_2172_384", style: { maskType: 'alpha' }, maskUnits: "userSpaceOnUse", x: "2", y: "2", width: "57", height: "57" },
            React__namespace.createElement("circle", { cx: "30.8496", cy: "30.2251", r: "28", fill: "#7B8694" }),
            React__namespace.createElement("circle", { cx: "30.8496", cy: "30.2251", r: "28", stroke: "#CB5353" })),
        React__namespace.createElement("g", { mask: "url(#mask0_2172_384)" },
            React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M30.8494 35.5886C37.1008 35.5886 42.1685 30.2541 42.1685 23.6737C42.1685 17.0933 37.1008 11.7588 30.8494 11.7588C24.598 11.7588 19.5302 17.0933 19.5302 23.6737C19.5302 30.2541 24.598 35.5886 30.8494 35.5886ZM30.8495 72.5232C41.7072 72.5232 50.5091 64.7882 50.5091 55.2466C50.5091 45.705 41.7072 37.97 30.8495 37.97C19.9918 37.97 11.1899 45.705 11.1899 55.2466C11.1899 64.7882 19.9918 72.5232 30.8495 72.5232Z", fill: "#B5CCE4" }))));
};

var SwiperContainer$3 = styled__default.default.div.withConfig({ shouldForwardProp: Spacing.isPropValid })(templateObject_1$S || (templateObject_1$S = _tslib.__makeTemplateObject(["\n  position: relative;\n\n  @media ", " {\n    max-width: ", ";\n    margin: 0 auto;\n  }\n\n  .reviews-slider {\n    margin: ", ";\n    padding: ", ";\n\n    @media ", " {\n      margin: -8px auto !important;\n      padding: ", ";\n    }\n    .swiper-pagination {\n      display: none;\n      position: unset;\n      margin-top: 24px;\n\n      @media ", " {\n        display: block;\n      }\n    }\n\n    .swiper-pagination-bullet {\n      margin: 0 2px !important;\n      box-sizing: border-box;\n      opacity: 1;\n      background-color: transparent;\n      border: 1px solid ", ";\n    }\n\n    .swiper-pagination-bullet-active {\n      background-color: ", ";\n    }\n\n    .swiper-wrapper {\n      height: auto;\n    }\n\n    .swiper-slide {\n      height: auto;\n    }\n  }\n"], ["\n  position: relative;\n\n  @media ", " {\n    max-width: ", ";\n    margin: 0 auto;\n  }\n\n  .reviews-slider {\n    margin: ", ";\n    padding: ", ";\n\n    @media ", " {\n      margin: -8px auto !important;\n      padding: ", ";\n    }\n    .swiper-pagination {\n      display: none;\n      position: unset;\n      margin-top: 24px;\n\n      @media ", " {\n        display: block;\n      }\n    }\n\n    .swiper-pagination-bullet {\n      margin: 0 2px !important;\n      box-sizing: border-box;\n      opacity: 1;\n      background-color: transparent;\n      border: 1px solid ", ";\n    }\n\n    .swiper-pagination-bullet-active {\n      background-color: ", ";\n    }\n\n    .swiper-wrapper {\n      height: auto;\n    }\n\n    .swiper-slide {\n      height: auto;\n    }\n  }\n"])), ResponsiveSizes.desktop, function (_a) {
    var maxWidth = _a.maxWidth;
    return maxWidth !== null && maxWidth !== void 0 ? maxWidth : '70vw';
}, function (props) { return (props.fullWidth ? '-8px 0 !important' : '-8px -24px !important'); }, function (props) { return (props.fullWidth ? '8px 0 !important' : '8px 24px !important'); }, ResponsiveSizes.desktop, function (props) { return (props.fullWidth ? '8px 0 !important' : ' 8px !important'); }, ResponsiveSizes.tablet, styles.themeColors.blue[50], styles.themeColors.blue[50]);
var templateObject_1$S;

var _a$1;
var ECustomerReviewsMaxWidth;
(function (ECustomerReviewsMaxWidth) {
    ECustomerReviewsMaxWidth["contain"] = "contain";
    ECustomerReviewsMaxWidth["full"] = "full";
})(ECustomerReviewsMaxWidth || (ECustomerReviewsMaxWidth = {}));
var CustomerReviewsMaxWidth = (_a$1 = {},
    _a$1[ECustomerReviewsMaxWidth.contain] = {
        containerPaddingTablet: '96px 24px',
    },
    _a$1[ECustomerReviewsMaxWidth.full] = {
        containerPaddingTablet: '96px 0',
    },
    _a$1);
var REVIEWS = [
    {
        name: 'Andryu Vera',
        review: '“Extraordinary app that allows us to generate income in passive mode, my 100% recommendation.”',
        url: 'https://www.trustpilot.com/users/62b0aac1e373890012377e18',
    },
    {
        name: 'Matthew Talbot-Paine',
        review: '“Simple and best app for passive income by sharing ur internet nd gain some $ or crypto coins.“',
        url: 'https://www.trustpilot.com/users/62b052202bd0db0012a89908',
    },
    {
        name: 'ANNA LISA AGUILA',
        review: '“ Service is excellent. Payout was credited to me instantly. Thank you.😆“',
        url: 'https://www.trustpilot.com/users/629ff259d11c0d00110b8796',
    },
    {
        name: 'Nicolas Ricardo',
        review: '“It is an excellent platform to generate an income, in addition to the fact that they pay on time, I rate them 10/10”',
        url: 'https://www.trustpilot.com/users/62aa989d574a300011984142',
    },
    {
        name: 'Marijan Kuzmanovski',
        review: '“Honeygain is easy to use application to get extra money with just installing the application.”',
        url: 'https://www.trustpilot.com/users/62a8eab231098800117ff350',
    },
    {
        name: 'Boipelo Petros',
        review: "\u201Cthis app has been great. Made two withdrawals in a space of 2 months, and that's impressive.\u201C",
        url: 'https://www.trustpilot.com/users/62a801b645819b001204498e',
    },
];
var AuthorContent = function (_a) {
    var showTrustpilot = _a.showTrustpilot, name = _a.name;
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement(AvatarPlaceholder, null),
        React__namespace.createElement(Spacing.Spacing, { left: true },
            React__namespace.createElement(Hyperlink.Text, { type: "subtitle", color: styles.themeColors.gray[60] },
                React__namespace.createElement("span", null, name)),
            showTrustpilot && React__namespace.createElement(AchievementStar.TrustpilotStars5, { width: 87 }))));
};
var Reviews = function (_a) {
    var _b = _a.title, title = _b === void 0 ? 'Check what our community has to say' : _b, background = _a.background, _c = _a.maxWidth, maxWidth = _c === void 0 ? ECustomerReviewsMaxWidth.contain : _c, showNavigation = _a.showNavigation, _d = _a.reviews, reviews = _d === void 0 ? REVIEWS : _d, showTrustpilot = _a.showTrustpilot;
    var isDesktop = UseSize.useSizes().isDesktop;
    var _e = _tslib.__read(React__namespace.useState(), 2), swiper = _e[0], setSwiper = _e[1];
    return (React__namespace.createElement(Background$4, { background: background },
        React__namespace.createElement(Container$n, { maxWidth: maxWidth },
            React__namespace.createElement(Heading$6, null,
                React__namespace.createElement(Hyperlink.Text, { type: "heading_large", useCompact: true, align: "center" },
                    React__namespace.createElement("h3", null, title))),
            React__namespace.createElement(TrustpilotContainer$2, null, showTrustpilot && (React__namespace.createElement(React__namespace.Fragment, null,
                React__namespace.createElement(ShouldDisplay.ShouldDisplay, { display: { default: 'block', desktop: 'none' } },
                    React__namespace.createElement(TrustpilotMicroStar, null)),
                React__namespace.createElement(ShouldDisplay.ShouldDisplay, { display: { default: 'none', desktop: 'block' } },
                    React__namespace.createElement(TrustpilotMicroCombo, null))))),
            React__namespace.createElement(SwiperContainer$3, { fullWidth: maxWidth === ECustomerReviewsMaxWidth.full },
                React__namespace.createElement(Swiper, { slidesPerView: isDesktop ? 3 : 1.2, slidesPerGroup: 3, spaceBetween: 24, freeMode: !isDesktop, pagination: showNavigation ? { clickable: true } : false, enabled: showNavigation, modules: [freeMode, Pagination], onSwiper: function (newSwiper) { return setSwiper(newSwiper); }, loop: isDesktop, className: "reviews-slider", updateOnWindowResize: true }, reviews.map(function (_a, index) {
                    var name = _a.name, review = _a.review, url = _a.url;
                    return (React__namespace.createElement(SwiperSlide, { key: "".concat(name).concat(index) },
                        React__namespace.createElement(StyledCard, { padding: "small" },
                            React__namespace.createElement(Hyperlink.Text, { type: "body" },
                                React__namespace.createElement("p", null, review)),
                            url ? (React__namespace.createElement(Author$1, { href: url, target: "_blank", rel: "noreferrer", showTrustpilot: showTrustpilot },
                                React__namespace.createElement(AuthorContent, { showTrustpilot: showTrustpilot, name: name }))) : (React__namespace.createElement(Author$1, { as: "div", showTrustpilot: showTrustpilot },
                                React__namespace.createElement(AuthorContent, { showTrustpilot: showTrustpilot, name: name }))))));
                })),
                showNavigation && (React__namespace.createElement(React__namespace.Fragment, null,
                    React__namespace.createElement(SliderArrow, { direction: "left", swiper: swiper }),
                    React__namespace.createElement(SliderArrow, { direction: "right", swiper: swiper })))))));
};
var Background$4 = styled__default.default.div.withConfig({ shouldForwardProp: Spacing.isPropValid })(templateObject_1$R || (templateObject_1$R = _tslib.__makeTemplateObject(["\n  background-color: ", ";\n"], ["\n  background-color: ", ";\n"])), function (props) { var _a; return styles.backgrounds[(_a = props.background) !== null && _a !== void 0 ? _a : 'white']; });
var Container$n = styled__default.default.div.withConfig({ shouldForwardProp: Spacing.isPropValid })(templateObject_2$D || (templateObject_2$D = _tslib.__makeTemplateObject(["\n  padding: 64px 24px;\n  margin: 0 auto;\n  max-width: 1128px;\n\n  @media ", " {\n    padding: ", ";\n  }\n"], ["\n  padding: 64px 24px;\n  margin: 0 auto;\n  max-width: 1128px;\n\n  @media ", " {\n    padding: ", ";\n  }\n"])), ResponsiveSizes.tablet, function (props) { var _a; return (_a = CustomerReviewsMaxWidth[props.maxWidth]) === null || _a === void 0 ? void 0 : _a.containerPaddingTablet; });
var Heading$6 = styled__default.default.div.withConfig({ displayName: "Heading", componentId: "-1nnupbp" })(templateObject_3$v || (templateObject_3$v = _tslib.__makeTemplateObject(["\n  margin: 0 auto;\n  max-width: 552px;\n"], ["\n  margin: 0 auto;\n  max-width: 552px;\n"])));
var TrustpilotContainer$2 = styled__default.default.div.withConfig({ displayName: "TrustpilotContainer", componentId: "-1782o4f" })(templateObject_4$l || (templateObject_4$l = _tslib.__makeTemplateObject(["\n  margin: 24px 0 48px;\n\n  @media ", " {\n    margin-bottom: 72px;\n  }\n"], ["\n  margin: 24px 0 48px;\n\n  @media ", " {\n    margin-bottom: 72px;\n  }\n"])), ResponsiveSizes.tablet);
var StyledCard = styled__default.default(CardBase).withConfig({ displayName: "StyledCard", componentId: "-1we8o3c" })(templateObject_5$i || (templateObject_5$i = _tslib.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n"])));
var Author$1 = styled__default.default.a.withConfig({ shouldForwardProp: Spacing.isPropValid })(templateObject_6$d || (templateObject_6$d = _tslib.__makeTemplateObject(["\n  display: flex;\n  margin-top: 24px;\n  align-items: ", ";\n"], ["\n  display: flex;\n  margin-top: 24px;\n  align-items: ", ";\n"])), function (_a) {
    var showTrustpilot = _a.showTrustpilot;
    return (showTrustpilot ? 'flex-start' : 'center');
});
var templateObject_1$R, templateObject_2$D, templateObject_3$v, templateObject_4$l, templateObject_5$i, templateObject_6$d;

var Buttons$1 = function (props) {
    var buttonCount = [props.leftButton, props.rightButton].filter(function (val) { return val !== undefined; }).length;
    return (React__namespace.createElement(ButtonsView$1, { buttonCount: buttonCount },
        props.leftButton,
        props.rightButton));
};
var ButtonsView$1 = styled__default.default(Spacing.Flex).withConfig({ displayName: "ButtonsView", componentId: "-tckfqu" })(templateObject_1$Q || (templateObject_1$Q = _tslib.__makeTemplateObject(["\n  justify-content: space-between;\n  flex-wrap: wrap;\n  width: 528px;\n\n  & > * {\n    min-width: 256px;\n    margin-bottom: ", "px;\n\n    @media ", ", ", " {\n      margin-bottom: ", "px;\n      min-width: 248px;\n    }\n  }\n\n  @media ", " {\n    flex-direction: column;\n    width: 256px;\n  }\n\n  @media ", " {\n    max-width: 528px;\n    width: 100%;\n    align-self: center;\n  }\n\n  @media ", " {\n    align-self: center;\n    justify-content: center;\n    flex-direction: column;\n    width: 256px;\n  }\n\n  @media ", ", ", " {\n    justify-content: ", ";\n  }\n"], ["\n  justify-content: space-between;\n  flex-wrap: wrap;\n  width: 528px;\n\n  & > * {\n    min-width: 256px;\n    margin-bottom: ", "px;\n\n    @media ", ", ", " {\n      margin-bottom: ", "px;\n      min-width: 248px;\n    }\n  }\n\n  @media ", " {\n    flex-direction: column;\n    width: 256px;\n  }\n\n  @media ", " {\n    max-width: 528px;\n    width: 100%;\n    align-self: center;\n  }\n\n  @media ", " {\n    align-self: center;\n    justify-content: center;\n    flex-direction: column;\n    width: 256px;\n  }\n\n  @media ", ", ", " {\n    justify-content: ", ";\n  }\n"])), Spacing.getSpace(2), ResponsiveSizes.media.tablet, ResponsiveSizes.media.mobile, Spacing.getSpace(1), ResponsiveSizes.media.desktop, ResponsiveSizes.media.tablet, ResponsiveSizes.media.mobile, ResponsiveSizes.media.tablet, ResponsiveSizes.media.mobile, function (props) { return (props.buttonCount === 2 ? 'space-between' : 'center'); });
var templateObject_1$Q;

var ScrollDown = function (props) { return (React__namespace.createElement(ScrollDownView, null,
    React__namespace.createElement(Spacing.CenterText, { color: props.invertedColor ? styles.themeColors.gray[5] : styles.themeColors.gray[90] }, props.children),
    React__namespace.createElement(Spacing.CenterText, null,
        React__namespace.createElement(Spacing.Spacing, { vertical: true },
            React__namespace.createElement(ArrowDown.ArrowDown, null))))); };
var ScrollDownView = styled__default.default.div.withConfig({ displayName: "ScrollDownView", componentId: "-1xvvzxk" })(templateObject_1$P || (templateObject_1$P = _tslib.__makeTemplateObject(["\n  @media ", ", ", " {\n    display: none;\n  }\n"], ["\n  @media ", ", ", " {\n    display: none;\n  }\n"])), ResponsiveSizes.media.tablet, ResponsiveSizes.media.mobile);
var templateObject_1$P;

var HeroSection$1 = function (props) {
    return (React__namespace.createElement(Background$3, { backgroundColor: props === null || props === void 0 ? void 0 : props.backgroundColor, className: props.className },
        React__namespace.createElement(ContentView$2, null,
            React__namespace.createElement(Container$t, null,
                React__namespace.createElement(ColumnsView, null,
                    React__namespace.createElement(HeadingColumnWrapper, { className: "col" },
                        React__namespace.createElement(HeadingWrapper, null,
                            React__namespace.createElement(Hyperlink.Text, { type: Hyperlink.TextType.HEADING_XLARGE, useCompact: true, customSpacing: [56, 32] },
                                React__namespace.createElement("h1", null, props.headingText)),
                            React__namespace.createElement(Hyperlink.Text, { type: Hyperlink.TextType.HEADING_SMALL, useCompact: true, customSpacing: [56, 32] },
                                React__namespace.createElement("small", null, props.subheadingText)),
                            React__namespace.createElement(Buttons$1, { leftButton: props.leftButton, rightButton: props.rightButton })),
                        React__namespace.createElement(BlobsWrapper$2, null,
                            React__namespace.createElement(AchievementStar.BackgroundBlob1, null),
                            React__namespace.createElement(AchievementStar.BackgroundBlob2, null))),
                    React__namespace.createElement(IllustrationView$1, { className: "col" },
                        props.illustration,
                        props.videoUrl && (React__namespace.createElement(PlayView$1, null,
                            React__namespace.createElement(PlayButton, { onClick: props.onVideoPlayClick, width: 124, height: 124 }))))))),
        props.footerText && React__namespace.createElement(ScrollDown, null, props.footerText),
        props.videoUrl && props.videoOpened ? (React__namespace.createElement(VideoOverlay$1, { opened: props.videoOpened, onClick: props.onVideoCloseClick },
            React__namespace.createElement(IframeWrapper$1, null,
                React__namespace.createElement("div", null,
                    React__namespace.createElement("iframe", { width: "966", height: "543", src: props.videoUrl, frameBorder: "0", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true })),
                React__namespace.createElement(CloseIcon$1, { onClick: props.onVideoCloseClick }, "x")))) : undefined));
};
var IllustrationView$1 = styled__default.default.div.withConfig({ displayName: "IllustrationView", componentId: "-okum7x" })(templateObject_1$O || (templateObject_1$O = _tslib.__makeTemplateObject(["\n  position: relative;\n\n  img {\n    width: 100%;\n\n    @media ", " {\n      width: 624px;\n    }\n\n    @media ", ", ", " {\n      min-width: 500px;\n      margin-top: ", "px;\n    }\n\n    @media ", " {\n      position: relative;\n      left: 50%;\n      transform: translateX(-50%);\n      width: auto;\n    }\n  }\n"], ["\n  position: relative;\n\n  img {\n    width: 100%;\n\n    @media ", " {\n      width: 624px;\n    }\n\n    @media ", ", ", " {\n      min-width: 500px;\n      margin-top: ", "px;\n    }\n\n    @media ", " {\n      position: relative;\n      left: 50%;\n      transform: translateX(-50%);\n      width: auto;\n    }\n  }\n"])), ResponsiveSizes.media.largeDesktop, ResponsiveSizes.media.tablet, ResponsiveSizes.media.mobile, Spacing.getSpace(10), ResponsiveSizes.media.mobile);
var CloseIcon$1 = styled__default.default.a.withConfig({ displayName: "CloseIcon", componentId: "-1k183ub" })(templateObject_2$C || (templateObject_2$C = _tslib.__makeTemplateObject(["\n  position: absolute;\n  z-index: 1000;\n  top: -10px;\n  right: 0;\n  font-size: 36px;\n  line-height: 1;\n  font-weight: 400;\n  color: #fff;\n  text-decoration: none;\n  cursor: pointer;\n  transition: all 200ms;\n"], ["\n  position: absolute;\n  z-index: 1000;\n  top: -10px;\n  right: 0;\n  font-size: 36px;\n  line-height: 1;\n  font-weight: 400;\n  color: #fff;\n  text-decoration: none;\n  cursor: pointer;\n  transition: all 200ms;\n"])));
var IframeWrapper$1 = styled__default.default.div.withConfig({ displayName: "IframeWrapper", componentId: "-86zibp" })(templateObject_3$u || (templateObject_3$u = _tslib.__makeTemplateObject(["\n  margin: 0px auto;\n\n  & > div {\n    position: relative;\n    padding-bottom: 56.25%;\n    height: 0px;\n  }\n\n  padding: 24px;\n  max-width: 864px;\n  width: calc(100% - 48px);\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-50%);\n\n  iframe {\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    width: 100%;\n    height: 100%;\n  }\n"], ["\n  margin: 0px auto;\n\n  & > div {\n    position: relative;\n    padding-bottom: 56.25%;\n    height: 0px;\n  }\n\n  padding: 24px;\n  max-width: 864px;\n  width: calc(100% - 48px);\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-50%);\n\n  iframe {\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    width: 100%;\n    height: 100%;\n  }\n"])));
var VideoOverlay$1 = styled__default.default.div.withConfig({ shouldForwardProp: Spacing.isPropValid })(templateObject_4$k || (templateObject_4$k = _tslib.__makeTemplateObject(["\n  position: fixed;\n  z-index: ", ";\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: rgba(0, 0, 0, 0.5);\n  opacity: ", ";\n  transition: all ease 500ms;\n"], ["\n  position: fixed;\n  z-index: ", ";\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: rgba(0, 0, 0, 0.5);\n  opacity: ", ";\n  transition: all ease 500ms;\n"])), function (props) { return (props.opened ? 1000 : -1); }, function (props) { return (props.opened ? 1 : 0); });
var PlayView$1 = styled__default.default.div.withConfig({ displayName: "PlayView", componentId: "-1svotif" })(templateObject_5$h || (templateObject_5$h = _tslib.__makeTemplateObject(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"], ["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"])));
var ColumnsView = styled__default.default(Spacing.Flex).withConfig({ displayName: "ColumnsView", componentId: "-kj1t81" })(templateObject_6$c || (templateObject_6$c = _tslib.__makeTemplateObject(["\n  justify-content: space-between;\n\n  .col {\n    width: 50%;\n  }\n\n  @media ", ", ", " {\n    flex-direction: column;\n\n    .col {\n      width: 100%;\n      position: relative;\n    }\n  }\n"], ["\n  justify-content: space-between;\n\n  .col {\n    width: 50%;\n  }\n\n  @media ", ", ", " {\n    flex-direction: column;\n\n    .col {\n      width: 100%;\n      position: relative;\n    }\n  }\n"])), ResponsiveSizes.media.tablet, ResponsiveSizes.media.mobile);
var ContentView$2 = styled__default.default(Spacing.Flex).withConfig({ displayName: "ContentView", componentId: "-1f37dld" })(templateObject_7$8 || (templateObject_7$8 = _tslib.__makeTemplateObject(["\n  height: 100%;\n  align-items: center;\n  display: flex;\n"], ["\n  height: 100%;\n  align-items: center;\n  display: flex;\n"])));
var HeadingColumnWrapper = styled__default.default(Spacing.Flex).withConfig({ displayName: "HeadingColumnWrapper", componentId: "-1y6s96x" })(templateObject_8$6 || (templateObject_8$6 = _tslib.__makeTemplateObject(["\n  flex-direction: column;\n  position: relative;\n  margin-right: ", "px;\n\n  @media ", " {\n    margin-right: ", "px;\n  }\n\n  @media ", " {\n    margin-top: ", "px;\n  }\n\n  @media ", " {\n    margin-top: ", "px;\n  }\n"], ["\n  flex-direction: column;\n  position: relative;\n  margin-right: ", "px;\n\n  @media ", " {\n    margin-right: ", "px;\n  }\n\n  @media ", " {\n    margin-top: ", "px;\n  }\n\n  @media ", " {\n    margin-top: ", "px;\n  }\n"])), Spacing.getSpace(2), ResponsiveSizes.media.largeDesktop, Spacing.getSpace(5), ResponsiveSizes.media.tablet, Spacing.getSpace(16), ResponsiveSizes.media.mobile, Spacing.getSpace(10));
var HeadingWrapper = styled__default.default(Spacing.Flex).withConfig({ displayName: "HeadingWrapper", componentId: "-nmoqz8" })(templateObject_9$5 || (templateObject_9$5 = _tslib.__makeTemplateObject(["\n  flex-direction: column;\n  justify-content: center;\n  height: 100%;\n  z-index: 10;\n\n  @media ", ", ", " {\n    text-align: center;\n  }\n"], ["\n  flex-direction: column;\n  justify-content: center;\n  height: 100%;\n  z-index: 10;\n\n  @media ", ", ", " {\n    text-align: center;\n  }\n"])), ResponsiveSizes.media.tablet, ResponsiveSizes.media.mobile);
var BlobsWrapper$2 = styled__default.default(Spacing.Flex).withConfig({ displayName: "BlobsWrapper", componentId: "-959v4q" })(templateObject_10$5 || (templateObject_10$5 = _tslib.__makeTemplateObject(["\n  flex-direction: column;\n  justify-content: space-evenly;\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  z-index: 5;\n"], ["\n  flex-direction: column;\n  justify-content: space-evenly;\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  z-index: 5;\n"])));
var Background$3 = styled__default.default(Spacing.Flex).withConfig({ displayName: "Background", componentId: "-umq2th" })(templateObject_11$4 || (templateObject_11$4 = _tslib.__makeTemplateObject(["\n  width: 100%;\n  min-height: 616px;\n  height: 100vh;\n  background-color: ", ";\n  flex-direction: column;\n  justify-content: flex-end;\n  overflow: hidden;\n\n  @media ", ", ", " {\n    height: initial;\n    background: linear-gradient(\n      ", " 0%,\n      ", " 70%,\n      #fff 100%\n    );\n  }\n"], ["\n  width: 100%;\n  min-height: 616px;\n  height: 100vh;\n  background-color: ", ";\n  flex-direction: column;\n  justify-content: flex-end;\n  overflow: hidden;\n\n  @media ", ", ", " {\n    height: initial;\n    background: linear-gradient(\n      ", " 0%,\n      ", " 70%,\n      #fff 100%\n    );\n  }\n"])), function (props) { return props.backgroundColor || styles.themeColors.blue['5']; }, ResponsiveSizes.media.tablet, ResponsiveSizes.media.mobile, function (props) { return props.backgroundColor || styles.themeColors.blue['5']; }, function (props) { return props.backgroundColor || styles.themeColors.blue['5']; });
var templateObject_1$O, templateObject_2$C, templateObject_3$u, templateObject_4$k, templateObject_5$h, templateObject_6$c, templateObject_7$8, templateObject_8$6, templateObject_9$5, templateObject_10$5, templateObject_11$4;

var SectionHeading = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, tagline = _a.tagline;
    var showHeading = !!title || !!subtitle;
    return (React__namespace.createElement(Spacing.Flex, { flexDir: "column", align: "center", gap: "16px" },
        tagline && (React__namespace.createElement(Hyperlink.Text, { type: "tagline", align: "center" },
            React__namespace.createElement("span", null, tagline))),
        showHeading && (React__namespace.createElement(Heading$5, null,
            title && (React__namespace.createElement(Hyperlink.Text, { type: "heading_large", useCompact: true, align: "center" },
                React__namespace.createElement("h3", null, title))),
            subtitle && (React__namespace.createElement(Spacing.Spacing, { top: 2 },
                React__namespace.createElement(Hyperlink.Text, { type: "body", useCompact: true, align: "center" },
                    React__namespace.createElement("h3", null, subtitle))))))));
};
var Heading$5 = styled__default.default.div.withConfig({ displayName: "Heading", componentId: "-5pqx1s" })(templateObject_1$N || (templateObject_1$N = _tslib.__makeTemplateObject(["\n  margin: 0 auto;\n  max-width: 552px;\n"], ["\n  margin: 0 auto;\n  max-width: 552px;\n"])));
var templateObject_1$N;

var SectionContainer = function (_a) {
    var children = _a.children, _b = _a.sidePadding, sidePadding = _b === void 0 ? true : _b, props = _tslib.__rest(_a, ["children", "sidePadding"]);
    return (React__namespace.createElement(Section$7, _tslib.__assign({ sidePadding: sidePadding }, props), children));
};
var Section$7 = styled__default.default.div.withConfig({ shouldForwardProp: Spacing.isPropValid })(templateObject_1$M || (templateObject_1$M = _tslib.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  background-color: ", ";\n  padding: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  background-color: ", ";\n  padding: ", ";\n"])), function (props) { var _a; return styles.backgrounds[(_a = props.background) !== null && _a !== void 0 ? _a : 'white']; }, function (props) { return (props.sidePadding ? '0 24px' : '0'); });
var templateObject_1$M;

var CardsSet = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, background = _a.background, columns = _a.columns, children = _a.children, disclaimer = _a.disclaimer, callToAction = _a.callToAction, secondaryCallToAction = _a.secondaryCallToAction, props = _tslib.__rest(_a, ["title", "subtitle", "background", "columns", "children", "disclaimer", "callToAction", "secondaryCallToAction"]);
    return (React__namespace.createElement(SectionContainer, _tslib.__assign({ background: background }, props),
        React__namespace.createElement(Container$m, null,
            React__namespace.createElement(Spacing.Spacing, { bottom: 4 },
                React__namespace.createElement(SectionHeading, { title: title, subtitle: subtitle })),
            React__namespace.createElement(Grid$3, { columns: columns }, children),
            React__namespace.createElement(SectionFooter, { disclaimer: disclaimer, callToAction: callToAction, secondaryCallToAction: secondaryCallToAction }))));
};
var Container$m = styled__default.default.div.withConfig({ displayName: "Container", componentId: "-1y5j3kd" })(templateObject_1$L || (templateObject_1$L = _tslib.__makeTemplateObject(["\n  margin: 56px auto;\n  flex: 1;\n  max-width: 1096px;\n  width: 100%;\n\n  @media ", " {\n    margin: 80px auto;\n  }\n\n  @media ", " {\n    max-width: 1128px;\n  }\n"], ["\n  margin: 56px auto;\n  flex: 1;\n  max-width: 1096px;\n  width: 100%;\n\n  @media ", " {\n    margin: 80px auto;\n  }\n\n  @media ", " {\n    max-width: 1128px;\n  }\n"])), ResponsiveSizes.desktop, ResponsiveSizes.desktopLarge);
var Grid$3 = styled__default.default.div.withConfig({ displayName: "Grid", componentId: "-1fgxfry" })(templateObject_2$B || (templateObject_2$B = _tslib.__makeTemplateObject(["\n  display: grid;\n  grid-gap: 32px 24px;\n\n  @media ", " {\n    grid-template-columns: ", ";\n    grid-auto-rows: 1fr;\n  }\n"], ["\n  display: grid;\n  grid-gap: 32px 24px;\n\n  @media ", " {\n    grid-template-columns: ", ";\n    grid-auto-rows: 1fr;\n  }\n"])), ResponsiveSizes.desktop, function (props) { return "repeat(".concat(props.columns, ", 1fr)"); });
var templateObject_1$L, templateObject_2$B;

var ClickableSmallCardsSet = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, background = _a.background, cards = _a.cards, props = _tslib.__rest(_a, ["title", "subtitle", "background", "cards"]);
    return (React__namespace.createElement(SectionContainer, _tslib.__assign({ background: background }, props),
        React__namespace.createElement(Container$l, { flexDir: "column", flex: 1, gap: "32px" },
            React__namespace.createElement(Heading$4, null,
                React__namespace.createElement(Hyperlink.Text, { type: "heading_large", useCompact: true, align: "center" },
                    React__namespace.createElement("h3", null, title)),
                subtitle && (React__namespace.createElement(Spacing.Spacing, { top: 2 },
                    React__namespace.createElement(Hyperlink.Text, { type: "body", useCompact: true, align: "center" },
                        React__namespace.createElement("h3", null, subtitle))))),
            React__namespace.createElement(Spacing.Flex, { flexDir: "row", wrap: "wrap", gap: { default: '16px', tablet: '24px' }, justify: "center" }, cards.map(function (cardData, index) { return (React__namespace.createElement(CardContainer, { key: index },
                React__namespace.createElement(CardClickable, { icon: cardData.icon, text: cardData.text, url: cardData.url, className: cardData.className, type: cardData.type }))); })))));
};
var Heading$4 = styled__default.default.div.withConfig({ displayName: "Heading", componentId: "-6fxouu" })(templateObject_1$K || (templateObject_1$K = _tslib.__makeTemplateObject(["\n  margin: 0 auto;\n  max-width: 552px;\n"], ["\n  margin: 0 auto;\n  max-width: 552px;\n"])));
var Container$l = styled__default.default(Spacing.Flex).withConfig({ displayName: "Container", componentId: "-psugak" })(templateObject_2$A || (templateObject_2$A = _tslib.__makeTemplateObject(["\n  margin: 56px auto;\n  max-width: 1096px;\n  width: 100%;\n\n  @media ", " {\n    margin: 80px auto;\n  }\n\n  @media ", " {\n    max-width: 1128px;\n  }\n"], ["\n  margin: 56px auto;\n  max-width: 1096px;\n  width: 100%;\n\n  @media ", " {\n    margin: 80px auto;\n  }\n\n  @media ", " {\n    max-width: 1128px;\n  }\n"])), ResponsiveSizes.desktop, ResponsiveSizes.desktopLarge);
var CardContainer = styled__default.default.div.withConfig({ displayName: "CardContainer", componentId: "-5lm4kh" })(templateObject_3$t || (templateObject_3$t = _tslib.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  width: calc((100% - 16px) / 3);\n\n  @media ", " {\n    width: 128px;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  width: calc((100% - 16px) / 3);\n\n  @media ", " {\n    width: 128px;\n  }\n"])), ResponsiveSizes.tablet);
var templateObject_1$K, templateObject_2$A, templateObject_3$t;

var FeatureCardsSet = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, background = _a.background, disclaimer = _a.disclaimer, callToAction = _a.callToAction, secondaryCallToAction = _a.secondaryCallToAction, children = _a.children, tagline = _a.tagline, sublabel = _a.sublabel, props = _tslib.__rest(_a, ["title", "subtitle", "background", "disclaimer", "callToAction", "secondaryCallToAction", "children", "tagline", "sublabel"]);
    return (React__namespace.createElement(SectionContainer, _tslib.__assign({ background: background }, props),
        React__namespace.createElement(Container$k, null,
            React__namespace.createElement(Heading$3, null,
                tagline && (React__namespace.createElement(Spacing.Spacing, { bottom: 2 },
                    React__namespace.createElement(Hyperlink.Text, { type: "tagline", align: "center" },
                        React__namespace.createElement("p", null, tagline)))),
                React__namespace.createElement(Hyperlink.Text, { type: "heading_large", useCompact: true, align: "center" },
                    React__namespace.createElement("h3", null, title)),
                subtitle && (React__namespace.createElement(Spacing.Spacing, { top: 2 },
                    React__namespace.createElement(Hyperlink.Text, { type: "body", useCompact: true, align: "center" },
                        React__namespace.createElement("h3", null, subtitle))))),
            React__namespace.createElement(Grid$2, null, children),
            React__namespace.createElement(SectionFooter, { disclaimer: disclaimer, callToAction: callToAction, secondaryCallToAction: secondaryCallToAction, sublabel: sublabel }))));
};
var Heading$3 = styled__default.default.div.withConfig({ displayName: "Heading", componentId: "-1gsl143" })(templateObject_1$J || (templateObject_1$J = _tslib.__makeTemplateObject(["\n  margin: 0 auto 32px;\n  max-width: 552px;\n"], ["\n  margin: 0 auto 32px;\n  max-width: 552px;\n"])));
var Container$k = styled__default.default.div.withConfig({ displayName: "Container", componentId: "-1upzm18" })(templateObject_2$z || (templateObject_2$z = _tslib.__makeTemplateObject(["\n  margin: 56px auto;\n  flex: 1;\n  max-width: 1096px;\n  width: 100%;\n\n  @media ", " {\n    margin: 80px auto;\n  }\n\n  @media ", " {\n    max-width: 1128px;\n  }\n"], ["\n  margin: 56px auto;\n  flex: 1;\n  max-width: 1096px;\n  width: 100%;\n\n  @media ", " {\n    margin: 80px auto;\n  }\n\n  @media ", " {\n    max-width: 1128px;\n  }\n"])), ResponsiveSizes.desktop, ResponsiveSizes.desktopLarge);
var Grid$2 = styled__default.default.div.withConfig({ displayName: "Grid", componentId: "-14gm3cw" })(templateObject_3$s || (templateObject_3$s = _tslib.__makeTemplateObject(["\n  display: grid;\n  grid-gap: 24px;\n\n  @media ", " {\n    grid-gap: 32px;\n    grid-template-columns: 1fr 1fr;\n  }\n"], ["\n  display: grid;\n  grid-gap: 24px;\n\n  @media ", " {\n    grid-gap: 32px;\n    grid-template-columns: 1fr 1fr;\n  }\n"])), ResponsiveSizes.desktop);
var templateObject_1$J, templateObject_2$z, templateObject_3$s;

var InfoWithAccordion = function (_a) {
    var reverse = _a.reverse, title = _a.title, paragraph = _a.paragraph, background = _a.background, image = _a.image, callToAction = _a.callToAction, children = _a.children, _b = _a.presentation, presentation = _b === void 0 ? 'image' : _b, tagline = _a.tagline, sublabel = _a.sublabel, props = _tslib.__rest(_a, ["reverse", "title", "paragraph", "background", "image", "callToAction", "children", "presentation", "tagline", "sublabel"]);
    return (React__namespace.createElement(SectionContainer, _tslib.__assign({ background: background }, props),
        React__namespace.createElement(Grid$1, { "$reverse": reverse },
            React__namespace.createElement(Info$1, null,
                React__namespace.createElement(Spacing.Flex, { flexDir: "column", gap: "24px" },
                    presentation === 'tagline' ? (React__namespace.createElement(Hyperlink.Text, { type: "tagline" },
                        React__namespace.createElement("p", null, tagline))) : (image),
                    React__namespace.createElement(Hyperlink.Text, { type: "heading_large", useCompact: true },
                        React__namespace.createElement("h3", null, title)),
                    React__namespace.createElement(Hyperlink.Text, { type: "body", color: styles.themeColors.gray[90], useCompact: true },
                        React__namespace.createElement("div", null, paragraph)))),
            React__namespace.createElement(CallToAction, null,
                callToAction && (React__namespace.createElement(LinkButton, { type: "primary", fullWidth: { default: true, desktop: false }, href: callToAction.url, target: callToAction.target, rel: callToAction.rel, className: callToAction.className },
                    React__namespace.createElement(Hyperlink.Text, { type: "label", color: styles.themeColors.white },
                        React__namespace.createElement("span", null, callToAction.text)))),
                sublabel && React__namespace.createElement(StyledSublabel$1, null, sublabel)),
            React__namespace.createElement(Accordions, null, children))));
};
var Grid$1 = styled__default.default.div.withConfig({ displayName: "Grid", componentId: "-km1an0" })(templateObject_2$y || (templateObject_2$y = _tslib.__makeTemplateObject(["\n  margin: 0 auto;\n  padding: 56px 0;\n  max-width: 1096px;\n  width: 100%;\n\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 32px 72px;\n\n  grid-template-areas:\n    'info'\n    'accordions'\n    'cta';\n\n  @media ", " {\n    padding: 80px 0;\n\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: auto 1fr;\n    gap: 24px 72px;\n    grid-template-areas:\n      'info accordions'\n      'cta accordions';\n\n    ", "\n  }\n\n  @media ", " {\n    max-width: 1128px;\n  }\n"], ["\n  margin: 0 auto;\n  padding: 56px 0;\n  max-width: 1096px;\n  width: 100%;\n\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 32px 72px;\n\n  grid-template-areas:\n    'info'\n    'accordions'\n    'cta';\n\n  @media ", " {\n    padding: 80px 0;\n\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: auto 1fr;\n    gap: 24px 72px;\n    grid-template-areas:\n      'info accordions'\n      'cta accordions';\n\n    ", "\n  }\n\n  @media ", " {\n    max-width: 1128px;\n  }\n"])), ResponsiveSizes.desktop, function (props) {
    return props.$reverse && styled.css(templateObject_1$I || (templateObject_1$I = _tslib.__makeTemplateObject(["\n        grid-template-areas:\n          'accordions info'\n          'accordions cta';\n      "], ["\n        grid-template-areas:\n          'accordions info'\n          'accordions cta';\n      "])));
}, ResponsiveSizes.desktopLarge);
var Info$1 = styled__default.default.div.withConfig({ displayName: "Info", componentId: "-cbyich" })(templateObject_3$r || (templateObject_3$r = _tslib.__makeTemplateObject(["\n  grid-area: info;\n"], ["\n  grid-area: info;\n"])));
var CallToAction = styled__default.default.div.withConfig({ displayName: "CallToAction", componentId: "-vkerdx" })(templateObject_4$j || (templateObject_4$j = _tslib.__makeTemplateObject(["\n  grid-area: cta;\n"], ["\n  grid-area: cta;\n"])));
var Accordions = styled__default.default.div.withConfig({ displayName: "Accordions", componentId: "-1u9xagi" })(templateObject_5$g || (templateObject_5$g = _tslib.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  justify-content: stretch;\n  width: 100%;\n  grid-area: accordions;\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  justify-content: stretch;\n  width: 100%;\n  grid-area: accordions;\n"])));
var StyledSublabel$1 = styled__default.default(Sublabel).withConfig({ displayName: "StyledSublabel", componentId: "-22e00b" })(templateObject_6$b || (templateObject_6$b = _tslib.__makeTemplateObject(["\n  display: flex;\n  margin-top: 8px;\n\n  @media ", " {\n    justify-content: flex-start;\n  }\n"], ["\n  display: flex;\n  margin-top: 8px;\n\n  @media ", " {\n    justify-content: flex-start;\n  }\n"])), ResponsiveSizes.desktop);
var templateObject_1$I, templateObject_2$y, templateObject_3$r, templateObject_4$j, templateObject_5$g, templateObject_6$b;

var InfoWithImage = function (_a) {
    var reverse = _a.reverse, trustpilot = _a.trustpilot, title = _a.title, paragraph = _a.paragraph, background = _a.background, image = _a.image, callToAction = _a.callToAction, children = _a.children, videoUrl = _a.videoUrl, props = _tslib.__rest(_a, ["reverse", "trustpilot", "title", "paragraph", "background", "image", "callToAction", "children", "videoUrl"]);
    var hasVideo = !!videoUrl;
    var _b = _tslib.__read(React__namespace.useState(false), 2), open = _b[0], setOpen = _b[1];
    return (React__namespace.createElement(SectionContainer, _tslib.__assign({ background: background }, props),
        React__namespace.createElement(Container$j, { flex: 1, flexDir: { default: 'column', desktop: reverse ? 'row-reverse' : 'row' }, gap: "24px", align: "center" },
            React__namespace.createElement(Spacing.Flex, { flex: 2 }, hasVideo ? (React__namespace.createElement(ClickableArea, { role: "button", onClick: function () { return setOpen(true); } },
                React__namespace.createElement(PlayButtonWrapper, null,
                    React__namespace.createElement(PlayButton, { width: 124, height: 124 })),
                image,
                React__namespace.createElement(VideoOverlay$2, { videoUrl: videoUrl, isOpen: open, onClose: function (event) {
                        event.stopPropagation();
                        setOpen(false);
                    } }))) : (image)),
            React__namespace.createElement(Spacing.Flex, { flex: 3, flexDir: "column", gap: "48px" },
                React__namespace.createElement(Spacing.Flex, { flexDir: "column", gap: "24px" },
                    trustpilot && (React__namespace.createElement(TrustpilotContainer$1, null,
                        React__namespace.createElement(TrustpilotMicroStar, { width: "auto" }))),
                    React__namespace.createElement(Hyperlink.Text, { type: "heading_large", useCompact: true },
                        React__namespace.createElement("h3", null, title)),
                    React__namespace.createElement(Hyperlink.Text, { type: "body", color: styles.themeColors.gray[90], useCompact: true },
                        React__namespace.createElement("div", null, paragraph))),
                children && React__namespace.createElement(Grid, null, children),
                callToAction && (React__namespace.createElement(LinkButton, { type: callToAction.type || 'primary', fullWidth: { default: true, desktop: false }, href: callToAction.url, target: callToAction.target, rel: callToAction.rel, className: callToAction.className }, callToAction.text))))));
};
var TrustpilotContainer$1 = styled__default.default.div.withConfig({ displayName: "TrustpilotContainer", componentId: "-7jkogw" })(templateObject_1$H || (templateObject_1$H = _tslib.__makeTemplateObject(["\n  width: 100%;\n  max-width: 283px;\n  margin-left: -14px;\n\n  @media ", " {\n    overflow: hidden;\n    max-width: 580px;\n  }\n"], ["\n  width: 100%;\n  max-width: 283px;\n  margin-left: -14px;\n\n  @media ", " {\n    overflow: hidden;\n    max-width: 580px;\n  }\n"])), ResponsiveSizes.desktop);
var Container$j = styled__default.default(Spacing.Flex).withConfig({ displayName: "Container", componentId: "-1kabfje" })(templateObject_2$x || (templateObject_2$x = _tslib.__makeTemplateObject(["\n  margin: 0 auto;\n  padding: 56px 0;\n  max-width: 1096px;\n  width: 100%;\n\n  @media ", " {\n    padding: 80px 0;\n  }\n\n  @media ", " {\n    max-width: 1128px;\n  }\n"], ["\n  margin: 0 auto;\n  padding: 56px 0;\n  max-width: 1096px;\n  width: 100%;\n\n  @media ", " {\n    padding: 80px 0;\n  }\n\n  @media ", " {\n    max-width: 1128px;\n  }\n"])), ResponsiveSizes.desktop, ResponsiveSizes.desktopLarge);
var Grid = styled__default.default.div.withConfig({ displayName: "Grid", componentId: "-1mn0v8a" })(templateObject_3$q || (templateObject_3$q = _tslib.__makeTemplateObject(["\n  display: grid;\n  grid-gap: 32px;\n\n  @media ", " {\n    grid-template-columns: 1fr 1fr;\n  }\n"], ["\n  display: grid;\n  grid-gap: 32px;\n\n  @media ", " {\n    grid-template-columns: 1fr 1fr;\n  }\n"])), ResponsiveSizes.desktop);
var ClickableArea = styled__default.default.div.withConfig({ displayName: "ClickableArea", componentId: "-1q2uns1" })(templateObject_4$i || (templateObject_4$i = _tslib.__makeTemplateObject(["\n  position: relative;\n  cursor: pointer;\n"], ["\n  position: relative;\n  cursor: pointer;\n"])));
var PlayButtonWrapper = styled__default.default.div.withConfig({ displayName: "PlayButtonWrapper", componentId: "-14i3mda" })(templateObject_5$f || (templateObject_5$f = _tslib.__makeTemplateObject(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"], ["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"])));
var templateObject_1$H, templateObject_2$x, templateObject_3$q, templateObject_4$i, templateObject_5$f;

var Steps = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, background = _a.background, disclaimer = _a.disclaimer, callToAction = _a.callToAction, secondaryCallToAction = _a.secondaryCallToAction, children = _a.children, props = _tslib.__rest(_a, ["title", "subtitle", "background", "disclaimer", "callToAction", "secondaryCallToAction", "children"]);
    return (React__namespace.createElement(SectionContainer, _tslib.__assign({ background: background }, props),
        React__namespace.createElement(Container$i, null,
            React__namespace.createElement(React__namespace.Fragment, null,
                React__namespace.createElement(Heading$2, null,
                    React__namespace.createElement(Hyperlink.Text, { type: "heading_large", useCompact: true, align: "center" },
                        React__namespace.createElement("h3", null, title)),
                    subtitle && (React__namespace.createElement(Spacing.Spacing, { top: 2 },
                        React__namespace.createElement(Hyperlink.Text, { type: "body", useCompact: true, align: "center" },
                            React__namespace.createElement("h3", null, subtitle))))),
                React__namespace.createElement(Spacing.Flex, { flexDir: { default: 'column', desktop: 'row' }, wrap: "wrap", gap: "0 56px", justify: "center", align: "center" }, React__namespace.Children.toArray(children).map(function (child, index) { return (React__namespace.createElement(ChildContainer, { key: index }, child)); })),
                React__namespace.createElement(SectionFooter, { disclaimer: disclaimer, callToAction: callToAction, secondaryCallToAction: secondaryCallToAction })))));
};
var Heading$2 = styled__default.default.div.withConfig({ displayName: "Heading", componentId: "-1owxeof" })(templateObject_1$G || (templateObject_1$G = _tslib.__makeTemplateObject(["\n  margin: 0 auto 16px;\n  max-width: 552px;\n"], ["\n  margin: 0 auto 16px;\n  max-width: 552px;\n"])));
var Container$i = styled__default.default.div.withConfig({ displayName: "Container", componentId: "-4zt4na" })(templateObject_2$w || (templateObject_2$w = _tslib.__makeTemplateObject(["\n  margin: 56px auto;\n  flex: 1;\n  max-width: 1096px;\n  width: 100%;\n\n  @media ", " {\n    margin: 80px auto;\n  }\n\n  @media ", " {\n    max-width: 1128px;\n  }\n"], ["\n  margin: 56px auto;\n  flex: 1;\n  max-width: 1096px;\n  width: 100%;\n\n  @media ", " {\n    margin: 80px auto;\n  }\n\n  @media ", " {\n    max-width: 1128px;\n  }\n"])), ResponsiveSizes.desktop, ResponsiveSizes.desktopLarge);
var ChildContainer = styled__default.default.div.withConfig({ displayName: "ChildContainer", componentId: "-1y8cmvj" })(templateObject_3$p || (templateObject_3$p = _tslib.__makeTemplateObject(["\n  padding: 16px 0;\n  width: 272px;\n"], ["\n  padding: 16px 0;\n  width: 272px;\n"])));
var templateObject_1$G, templateObject_2$w, templateObject_3$p;

var FAQ = function (_a) {
    var _b = _a.title, title = _b === void 0 ? 'Frequently asked questions' : _b, background = _a.background, children = _a.children, disclaimer = _a.disclaimer, props = _tslib.__rest(_a, ["title", "background", "children", "disclaimer"]);
    return (React__namespace.createElement(SectionContainer, _tslib.__assign({ background: background }, props),
        React__namespace.createElement(Container$h, null,
            React__namespace.createElement(Hyperlink.Text, { type: "heading_large", useCompact: true, align: "center" },
                React__namespace.createElement("h3", null, title)),
            React__namespace.createElement(Questions, null, children),
            disclaimer && (React__namespace.createElement(Disclaimer, null,
                React__namespace.createElement(Hyperlink.Text, { type: "body", useCompact: true, align: "center", color: styles.themeColors.gray[60] },
                    React__namespace.createElement("p", null, disclaimer)))))));
};
var Container$h = styled__default.default.div.withConfig({ displayName: "Container", componentId: "-1mdou04" })(templateObject_1$F || (templateObject_1$F = _tslib.__makeTemplateObject(["\n  margin: 56px auto;\n  flex: 1;\n  max-width: 744px;\n  width: 100%;\n\n  @media ", " {\n    margin: 80px auto;\n  }\n"], ["\n  margin: 56px auto;\n  flex: 1;\n  max-width: 744px;\n  width: 100%;\n\n  @media ", " {\n    margin: 80px auto;\n  }\n"])), ResponsiveSizes.desktop);
var Questions = styled__default.default.div.withConfig({ displayName: "Questions", componentId: "-kplypn" })(templateObject_2$v || (templateObject_2$v = _tslib.__makeTemplateObject(["\n  margin: 40px auto 0;\n\n  & > * + * {\n    margin-top: 32px;\n  }\n\n  @media ", " {\n    margin-top: 48px;\n  }\n"], ["\n  margin: 40px auto 0;\n\n  & > * + * {\n    margin-top: 32px;\n  }\n\n  @media ", " {\n    margin-top: 48px;\n  }\n"])), ResponsiveSizes.desktop);
var Disclaimer = styled__default.default.div.withConfig({ displayName: "Disclaimer", componentId: "-14ou40s" })(templateObject_3$o || (templateObject_3$o = _tslib.__makeTemplateObject(["\n  margin: 40px auto 0;\n  max-width: 616px;\n\n  @media ", " {\n    margin-top: 48px;\n  }\n\n  && a {\n    color: ", ";\n    text-decoration: none;\n  }\n"], ["\n  margin: 40px auto 0;\n  max-width: 616px;\n\n  @media ", " {\n    margin-top: 48px;\n  }\n\n  && a {\n    color: ", ";\n    text-decoration: none;\n  }\n"])), ResponsiveSizes.desktop, styles.themeColors.blue[50]);
var templateObject_1$F, templateObject_2$v, templateObject_3$o;

var BottomCTA = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, _b = _a.background, background = _b === void 0 ? 'white' : _b, className = _a.className, showImage = _a.showImage, button = _a.button, callToAction = _a.callToAction, secondaryCallToAction = _a.secondaryCallToAction, sublabel = _a.sublabel;
    return (React__namespace.createElement(Section$6, { background: background },
        showImage && (React__namespace.createElement(SofaLaptopContainer, null,
            React__namespace.createElement(SofaLaptopIllustration, null))),
        React__namespace.createElement(Spacing.Flex, { className: className, flexDir: "column", style: { overflowX: 'hidden' } },
            React__namespace.createElement(BackgroundView$1, null,
                React__namespace.createElement(Container$t, null,
                    React__namespace.createElement(Hyperlink.Text, { type: "heading_large", useCompact: true },
                        React__namespace.createElement("h2", null, title)),
                    React__namespace.createElement(Spacing.Spacing, { top: 2 },
                        React__namespace.createElement(Hyperlink.Text, { type: "heading_small", useCompact: true },
                            React__namespace.createElement("small", null, subtitle))),
                    button ? (React__namespace.createElement(ButtonContainer$1, { align: "center", justify: "center", className: "button" }, button)) : (React__namespace.createElement(SectionFooter, { callToAction: callToAction, secondaryCallToAction: secondaryCallToAction, sublabel: sublabel })))))));
};
var Section$6 = styled__default.default(SectionContainer).withConfig({ displayName: "Section", componentId: "-1upblc6" })(templateObject_1$E || (templateObject_1$E = _tslib.__makeTemplateObject(["\n  padding: 0;\n"], ["\n  padding: 0;\n"])));
var SofaLaptopContainer = styled__default.default.div.withConfig({ displayName: "SofaLaptopContainer", componentId: "-1nej0ay" })(templateObject_2$u || (templateObject_2$u = _tslib.__makeTemplateObject(["\n  overflow: hidden;\n  transform: translateY(1px); // removes white-space rendering artefact\n"], ["\n  overflow: hidden;\n  transform: translateY(1px); // removes white-space rendering artefact\n"])));
var SofaLaptopIllustration = styled__default.default(HoneygainLogoSdk.SofaLaptop).withConfig({ displayName: "SofaLaptopIllustration", componentId: "-1hgzll6" })(templateObject_3$n || (templateObject_3$n = _tslib.__makeTemplateObject(["\n  display: block;\n  position: relative;\n  width: 150%;\n  left: -25%;\n\n  @media ", " {\n    width: 100%;\n    left: unset;\n  }\n"], ["\n  display: block;\n  position: relative;\n  width: 150%;\n  left: -25%;\n\n  @media ", " {\n    width: 100%;\n    left: unset;\n  }\n"])), ResponsiveSizes.tablet);
var BackgroundView$1 = styled__default.default.div.withConfig({ displayName: "BackgroundView", componentId: "-1vaefpu" })(templateObject_4$h || (templateObject_4$h = _tslib.__makeTemplateObject(["\n  padding: 32px 24px 56px;\n  text-align: center;\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  background-color: ", ";\n"], ["\n  padding: 32px 24px 56px;\n  text-align: center;\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  background-color: ", ";\n"])), styles.backgrounds.dark);
var ButtonContainer$1 = styled__default.default(Spacing.Flex).withConfig({ displayName: "ButtonContainer", componentId: "-eegu80" })(templateObject_5$e || (templateObject_5$e = _tslib.__makeTemplateObject(["\n  margin: 32px 0 0;\n\n  @media ", " {\n    margin: 24px 0;\n  }\n"], ["\n  margin: 32px 0 0;\n\n  @media ", " {\n    margin: 24px 0;\n  }\n"])), ResponsiveSizes.desktop);
var templateObject_1$E, templateObject_2$u, templateObject_3$n, templateObject_4$h, templateObject_5$e;

var Logos = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, background = _a.background, logos = _a.logos, props = _tslib.__rest(_a, ["title", "subtitle", "background", "logos"]);
    return (React__namespace.createElement(SectionContainer, _tslib.__assign({ background: background }, props),
        React__namespace.createElement(Container$g, { flex: 1, flexDir: "column", align: "center", gap: "32px" },
            React__namespace.createElement(SectionHeading, { title: title, subtitle: subtitle }),
            React__namespace.createElement(Spacing.Flex, { style: { width: '100%' }, flexDir: "row", wrap: "wrap", gap: { default: '24px', tablet: '32px 40px' }, justify: "center" }, logos.map(function (logo, index) { return (React__namespace.createElement(LogoContainer, { key: index }, logo)); })))));
};
var Container$g = styled__default.default(Spacing.Flex).withConfig({ displayName: "Container", componentId: "-1yhz627" })(templateObject_1$D || (templateObject_1$D = _tslib.__makeTemplateObject(["\n  margin: 56px auto;\n  max-width: 1096px;\n  width: 100%;\n\n  @media ", " {\n    margin: 80px auto;\n  }\n\n  @media ", " {\n    max-width: 1128px;\n  }\n"], ["\n  margin: 56px auto;\n  max-width: 1096px;\n  width: 100%;\n\n  @media ", " {\n    margin: 80px auto;\n  }\n\n  @media ", " {\n    max-width: 1128px;\n  }\n"])), ResponsiveSizes.desktop, ResponsiveSizes.desktopLarge);
var LogoContainer = styled__default.default.div.withConfig({ displayName: "LogoContainer", componentId: "-1f3nlrb" })(templateObject_2$t || (templateObject_2$t = _tslib.__makeTemplateObject(["\n  position: relative;\n  height: 40px;\n  width: calc((100% - 48px) / 3);\n\n  @media ", " {\n    height: 60px;\n    width: 130px;\n  }\n"], ["\n  position: relative;\n  height: 40px;\n  width: calc((100% - 48px) / 3);\n\n  @media ", " {\n    height: 60px;\n    width: 130px;\n  }\n"])), ResponsiveSizes.tablet);
var templateObject_1$D, templateObject_2$t;

var VideoReview = function (_a) {
    var name = _a.name, subtitle = _a.subtitle, review = _a.review, url = _a.url, avatarUrl = _a.avatarUrl;
    return (React__namespace.createElement(Container$f, { flexDir: "column", gap: "24px", flex: 1, padding: "large" },
        React__namespace.createElement(Author, null,
            React__namespace.createElement(AvatarContainer, null, avatarUrl ? React__namespace.createElement(Avatar, { src: avatarUrl }) : React__namespace.createElement(AvatarPlaceholder, { width: "100%", height: "100%" })),
            React__namespace.createElement(Spacing.Spacing, { left: 2 },
                React__namespace.createElement(Hyperlink.Text, { type: "body_medium_bold", useCompact: true },
                    React__namespace.createElement("span", null, name)),
                React__namespace.createElement(Hyperlink.Text, { type: "subtitle", useCompact: true, color: styles.themeColors.gray[60] },
                    React__namespace.createElement("p", null, subtitle)))),
        React__namespace.createElement(Spacing.Flex, { flexDir: "column", flex: 1 },
            React__namespace.createElement(Hyperlink.Text, { type: "body", useCompact: true },
                React__namespace.createElement("p", null,
                    "\u201C",
                    review,
                    "\u201D"))),
        React__namespace.createElement(Hyperlink.Hyperlink, { href: url, variant: "navigation", icon: React__namespace.createElement(AchievementStar.Youtube, null), inNewWindow: true }, "Watch on YouTube")));
};
var Container$f = styled__default.default(Spacing.Flex).withConfig({ displayName: "Container", componentId: "-a5k3s0" })(templateObject_1$C || (templateObject_1$C = _tslib.__makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), CardBaseStyles);
var AvatarContainer = styled__default.default.div.withConfig({ displayName: "AvatarContainer", componentId: "-j65o7p" })(templateObject_2$s || (templateObject_2$s = _tslib.__makeTemplateObject(["\n  height: 56px;\n  min-height: 56px;\n  width: 56px;\n  min-width: 56px;\n"], ["\n  height: 56px;\n  min-height: 56px;\n  width: 56px;\n  min-width: 56px;\n"])));
var Author = styled__default.default(Spacing.Flex).withConfig({ displayName: "Author", componentId: "-11qf66i" })(templateObject_3$m || (templateObject_3$m = _tslib.__makeTemplateObject(["\n  align-items: center;\n"], ["\n  align-items: center;\n"])));
var Avatar = styled__default.default.img.withConfig({ displayName: "Avatar", componentId: "-289w2z" })(templateObject_4$g || (templateObject_4$g = _tslib.__makeTemplateObject(["\n  height: 56px;\n  width: 56px;\n  border-radius: 9999px;\n  object-fit: cover;\n  overflow: hidden;\n"], ["\n  height: 56px;\n  width: 56px;\n  border-radius: 9999px;\n  object-fit: cover;\n  overflow: hidden;\n"])));
var templateObject_1$C, templateObject_2$s, templateObject_3$m, templateObject_4$g;

var VideoReviews = function (_a) {
    var title = _a.title, background = _a.background, reviews = _a.reviews, props = _tslib.__rest(_a, ["title", "background", "reviews"]);
    var _b = UseSize.useSizes(), isDesktop = _b.isDesktop, isTablet = _b.isTablet;
    var _c = _tslib.__read(React__namespace.useState(), 2), swiper = _c[0], setSwiper = _c[1];
    var slidesPerView = isDesktop ? 3 : isTablet ? 2 : 1.2;
    var shouldPaginate = reviews.length > slidesPerView;
    return (React__namespace.createElement(SectionContainer, _tslib.__assign({ background: background }, props),
        React__namespace.createElement(Container$e, { flexDir: "column", flex: 1, gap: "64px" },
            React__namespace.createElement(SectionHeading, { title: title }),
            React__namespace.createElement(SwiperContainer$3, null,
                React__namespace.createElement(Swiper, { slidesPerView: slidesPerView, slidesPerGroup: 3, spaceBetween: 24, freeMode: !isDesktop, pagination: isDesktop && shouldPaginate ? { clickable: true } : false, enabled: shouldPaginate, modules: [freeMode, Pagination], onSwiper: function (swiper) { return setSwiper(swiper); }, loop: isDesktop, className: "reviews-slider", updateOnWindowResize: true }, reviews.map(function (_a, index) {
                    var name = _a.name, review = _a.review, subtitle = _a.subtitle, url = _a.url, avatarUrl = _a.avatarUrl;
                    return (React__namespace.createElement(SwiperSlide, { key: index, style: { display: 'flex' } },
                        React__namespace.createElement(VideoReview, { name: name, review: review, subtitle: subtitle, url: url, avatarUrl: avatarUrl })));
                })),
                isDesktop && shouldPaginate && (React__namespace.createElement(React__namespace.Fragment, null,
                    React__namespace.createElement(SliderArrow, { direction: "left", swiper: swiper }),
                    React__namespace.createElement(SliderArrow, { direction: "right", swiper: swiper })))))));
};
var Container$e = styled__default.default(Spacing.Flex).withConfig({ displayName: "Container", componentId: "-r2qdkj" })(templateObject_1$B || (templateObject_1$B = _tslib.__makeTemplateObject(["\n  margin: 64px auto;\n  max-width: 1096px;\n  width: 100%;\n\n  @media ", " {\n    margin: 96px auto;\n  }\n\n  @media ", " {\n    max-width: 1128px;\n  }\n"], ["\n  margin: 64px auto;\n  max-width: 1096px;\n  width: 100%;\n\n  @media ", " {\n    margin: 96px auto;\n  }\n\n  @media ", " {\n    max-width: 1128px;\n  }\n"])), ResponsiveSizes.desktop, ResponsiveSizes.desktopLarge);
var templateObject_1$B;

var _a;
var EPromoMaxWidth;
(function (EPromoMaxWidth) {
    EPromoMaxWidth["contain"] = "contain";
    EPromoMaxWidth["full"] = "full";
})(EPromoMaxWidth || (EPromoMaxWidth = {}));
var MaxWidthPromoStyles = (_a = {},
    _a[EPromoMaxWidth.contain] = {
        desktopMaxWidth: '1096px',
        desktopLargeMaxWidth: '1128px',
    },
    _a[EPromoMaxWidth.full] = {
        desktopMaxWidth: '100%',
        desktopLargeMaxWidth: '100%',
    },
    _a);
var Promo = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, linkText = _a.linkText, linkUrl = _a.linkUrl, linkToExternal = _a.linkToExternal, linkClassName = _a.linkClassName, _b = _a.maxWidth, maxWidth = _b === void 0 ? EPromoMaxWidth.contain : _b, props = _tslib.__rest(_a, ["title", "subtitle", "linkText", "linkUrl", "linkToExternal", "linkClassName", "maxWidth"]);
    return (React__namespace.createElement(SectionContainer, _tslib.__assign({}, props, { sidePadding: maxWidth !== 'full' }),
        React__namespace.createElement(Container$d, { justify: "center", maxWidth: maxWidth },
            React__namespace.createElement(BeeLeft$1, null),
            React__namespace.createElement(BlobLeft, null),
            React__namespace.createElement(ContentContainer$2, { flexDir: "column", align: "center", gap: { default: '32px', tablet: '24px' } },
                React__namespace.createElement(Spacing.Flex, { flexDir: "column", gap: "8px" },
                    React__namespace.createElement(Hyperlink.Text, { type: "heading_large", align: "center", useCompact: true },
                        React__namespace.createElement("span", null, title)),
                    subtitle && (React__namespace.createElement(Hyperlink.Text, { type: "body", align: "center", useCompact: true }, subtitle))),
                React__namespace.createElement(LinkButton, { type: "primary", href: linkUrl, fullWidth: { default: true, tablet: false }, className: linkClassName, target: linkToExternal ? '_blank' : '_self' }, linkText)),
            React__namespace.createElement(BeeRight$1, null),
            React__namespace.createElement(BlobRight, null))));
};
var Container$d = styled__default.default(Spacing.Flex).withConfig({ displayName: "Container", componentId: "-f8irpj" })(templateObject_1$A || (templateObject_1$A = _tslib.__makeTemplateObject(["\n  width: 100%;\n  box-sizing: border-box;\n  padding: 120px 16px 40px;\n  background-color: ", ";\n  border: ", ";\n  border-radius: ", "px;\n  position: relative;\n  overflow: hidden;\n  margin: 56px auto;\n\n  @media ", " {\n    padding: 32px 160px;\n    margin: 80px auto;\n  }\n\n  @media ", " {\n    max-width: ", ";\n    padding: 64px 160px;\n  }\n\n  @media ", " {\n    max-width: ", ";\n  }\n"], ["\n  width: 100%;\n  box-sizing: border-box;\n  padding: 120px 16px 40px;\n  background-color: ", ";\n  border: ", ";\n  border-radius: ", "px;\n  position: relative;\n  overflow: hidden;\n  margin: 56px auto;\n\n  @media ", " {\n    padding: 32px 160px;\n    margin: 80px auto;\n  }\n\n  @media ", " {\n    max-width: ", ";\n    padding: 64px 160px;\n  }\n\n  @media ", " {\n    max-width: ", ";\n  }\n"])), styles.backgrounds.dark, styles.themeBorder.default, styles.themeBorder.radius.default, ResponsiveSizes.tablet, ResponsiveSizes.desktop, function (props) { var _a; return (_a = MaxWidthPromoStyles[props.maxWidth]) === null || _a === void 0 ? void 0 : _a.desktopMaxWidth; }, ResponsiveSizes.desktopLarge, function (props) { var _a; return (_a = MaxWidthPromoStyles[props.maxWidth]) === null || _a === void 0 ? void 0 : _a.desktopLargeMaxWidth; });
var ContentContainer$2 = styled__default.default(Spacing.Flex).withConfig({ displayName: "ContentContainer", componentId: "-tta6vr" })(templateObject_2$r || (templateObject_2$r = _tslib.__makeTemplateObject(["\n  position: relative;\n  z-index: 1;\n"], ["\n  position: relative;\n  z-index: 1;\n"])));
var BeeLeft$1 = styled__default.default(HoneygainLogoSdk.Bee3).withConfig({ displayName: "BeeLeft", componentId: "-1bipp3s" })(templateObject_3$l || (templateObject_3$l = _tslib.__makeTemplateObject(["\n  z-index: 2;\n  display: none;\n  height: 85px;\n  position: absolute;\n  top: 55%;\n  left: 5%;\n  transform: translateY(-50%);\n\n  @media ", " {\n    left: 32px;\n    display: block;\n  }\n\n  @media ", " {\n    height: 140px;\n  }\n"], ["\n  z-index: 2;\n  display: none;\n  height: 85px;\n  position: absolute;\n  top: 55%;\n  left: 5%;\n  transform: translateY(-50%);\n\n  @media ", " {\n    left: 32px;\n    display: block;\n  }\n\n  @media ", " {\n    height: 140px;\n  }\n"])), ResponsiveSizes.tablet, ResponsiveSizes.desktop);
var BeeRight$1 = styled__default.default(HoneygainLogoSdk.Bee4).withConfig({ displayName: "BeeRight", componentId: "-z19ido" })(templateObject_4$f || (templateObject_4$f = _tslib.__makeTemplateObject(["\n  z-index: 2;\n  position: absolute;\n  height: 85px;\n  top: 16px;\n  right: 20%;\n\n  @media ", " {\n    right: 5%;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  @media ", " {\n    height: 140px;\n    right: 24px;\n  }\n"], ["\n  z-index: 2;\n  position: absolute;\n  height: 85px;\n  top: 16px;\n  right: 20%;\n\n  @media ", " {\n    right: 5%;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  @media ", " {\n    height: 140px;\n    right: 24px;\n  }\n"])), ResponsiveSizes.tablet, ResponsiveSizes.desktop);
var StyledBlob = styled__default.default(HoneygainLogoSdk.Blob).withConfig({ displayName: "StyledBlob", componentId: "-q0vh2b" })(templateObject_5$d || (templateObject_5$d = _tslib.__makeTemplateObject(["\n  position: absolute;\n  z-index: 1;\n"], ["\n  position: absolute;\n  z-index: 1;\n"])));
var BlobLeft = styled__default.default(StyledBlob).withConfig({ displayName: "BlobLeft", componentId: "-1y6kmvc" })(templateObject_6$a || (templateObject_6$a = _tslib.__makeTemplateObject(["\n  display: none;\n  height: 260px;\n  width: 260px;\n\n  @media ", " {\n    display: block;\n    top: 100%;\n    left: 0;\n    transform: translate(-50%, -45%);\n  }\n\n  @media ", " {\n    height: 350px;\n    width: 350px;\n    transform: translate(-45%, -45%);\n  }\n"], ["\n  display: none;\n  height: 260px;\n  width: 260px;\n\n  @media ", " {\n    display: block;\n    top: 100%;\n    left: 0;\n    transform: translate(-50%, -45%);\n  }\n\n  @media ", " {\n    height: 350px;\n    width: 350px;\n    transform: translate(-45%, -45%);\n  }\n"])), ResponsiveSizes.tablet, ResponsiveSizes.desktop);
var BlobRight = styled__default.default(StyledBlob).withConfig({ displayName: "BlobRight", componentId: "-10xew8a" })(templateObject_7$7 || (templateObject_7$7 = _tslib.__makeTemplateObject(["\n  height: 260px;\n  width: 260px;\n  right: 0;\n  top: 0;\n  transform: translate(55%, -55%);\n\n  @media ", " {\n    top: 50%;\n    transform: translate(55%, -50%);\n  }\n\n  @media ", " {\n    height: 350px;\n    width: 350px;\n    transform: translate(50%, -70%);\n  }\n"], ["\n  height: 260px;\n  width: 260px;\n  right: 0;\n  top: 0;\n  transform: translate(55%, -55%);\n\n  @media ", " {\n    top: 50%;\n    transform: translate(55%, -50%);\n  }\n\n  @media ", " {\n    height: 350px;\n    width: 350px;\n    transform: translate(50%, -70%);\n  }\n"])), ResponsiveSizes.tablet, ResponsiveSizes.desktop);
var templateObject_1$A, templateObject_2$r, templateObject_3$l, templateObject_4$f, templateObject_5$d, templateObject_6$a, templateObject_7$7;

var Socials = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, background = _a.background, socials = _a.socials, props = _tslib.__rest(_a, ["title", "subtitle", "background", "socials"]);
    return (React__namespace.createElement(StyledSectionContainer, _tslib.__assign({ background: background }, props),
        React__namespace.createElement(BeeLeft, null),
        React__namespace.createElement(Container$c, { flexDir: "column", align: "center", flex: 1, gap: "32px" },
            React__namespace.createElement(SectionHeading, { title: title, subtitle: subtitle }),
            React__namespace.createElement(Spacing.Flex, { flexDir: "row", wrap: "wrap", gap: "24px", justify: "center" }, socials.map(function (social, index) { return (React__namespace.createElement(CircleButton, { key: index, href: social.url, target: "_blank", role: "button" },
                React__namespace.createElement("img", { src: social.imageUrl, alt: "" }))); }))),
        React__namespace.createElement(BeeRight, null)));
};
var StyledSectionContainer = styled__default.default(SectionContainer).withConfig({ displayName: "StyledSectionContainer", componentId: "-1hsfrkd" })(templateObject_1$z || (templateObject_1$z = _tslib.__makeTemplateObject(["\n  padding: 56px 24px;\n  position: relative;\n  overflow: hidden;\n\n  @media ", " {\n    padding: 80px 24px;\n  }\n"], ["\n  padding: 56px 24px;\n  position: relative;\n  overflow: hidden;\n\n  @media ", " {\n    padding: 80px 24px;\n  }\n"])), ResponsiveSizes.desktop);
var Container$c = styled__default.default(Spacing.Flex).withConfig({ displayName: "Container", componentId: "-1624bu7" })(templateObject_2$q || (templateObject_2$q = _tslib.__makeTemplateObject(["\n  position: relative;\n  z-index: 1;\n  margin: 0 auto;\n  max-width: 552px;\n  width: 100%;\n  position: relative;\n\n  @media ", " {\n    margin: 80px auto;\n  }\n\n  @media ", " {\n    max-width: 552px;\n  }\n"], ["\n  position: relative;\n  z-index: 1;\n  margin: 0 auto;\n  max-width: 552px;\n  width: 100%;\n  position: relative;\n\n  @media ", " {\n    margin: 80px auto;\n  }\n\n  @media ", " {\n    max-width: 552px;\n  }\n"])), ResponsiveSizes.desktop, ResponsiveSizes.desktopLarge);
var BeeLeft = styled__default.default(HoneygainLogoSdk.Bee3).withConfig({ displayName: "BeeLeft", componentId: "-eshupm" })(templateObject_3$k || (templateObject_3$k = _tslib.__makeTemplateObject(["\n  display: none;\n\n  @media ", " {\n    display: block;\n    height: 135px;\n    position: absolute;\n    top: 60%;\n    left: -10vw;\n    transform: translateY(-50%);\n  }\n\n  @media ", " {\n    left: 0;\n  }\n"], ["\n  display: none;\n\n  @media ", " {\n    display: block;\n    height: 135px;\n    position: absolute;\n    top: 60%;\n    left: -10vw;\n    transform: translateY(-50%);\n  }\n\n  @media ", " {\n    left: 0;\n  }\n"])), ResponsiveSizes.desktop, ResponsiveSizes.desktopLarge);
var BeeRight = styled__default.default(HoneygainLogoSdk.Bee4).withConfig({ displayName: "BeeRight", componentId: "-rdz5e9" })(templateObject_4$e || (templateObject_4$e = _tslib.__makeTemplateObject(["\n  display: none;\n\n  @media ", " {\n    display: block;\n    position: absolute;\n    height: 160px;\n    top: 60%;\n    right: -10vw;\n    transform: translateY(-50%);\n  }\n\n  @media ", " {\n    right: 0;\n  }\n"], ["\n  display: none;\n\n  @media ", " {\n    display: block;\n    position: absolute;\n    height: 160px;\n    top: 60%;\n    right: -10vw;\n    transform: translateY(-50%);\n  }\n\n  @media ", " {\n    right: 0;\n  }\n"])), ResponsiveSizes.desktop, ResponsiveSizes.desktopLarge);
var CircleButton = styled__default.default.a.withConfig({ displayName: "CircleButton", componentId: "-f4laue" })(templateObject_5$c || (templateObject_5$c = _tslib.__makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 64px;\n  height: 64px;\n  border-radius: 9999px;\n  background-color: ", ";\n  box-shadow: ", ";\n\n  &:hover {\n    background-color: ", ";\n  }\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 64px;\n  height: 64px;\n  border-radius: 9999px;\n  background-color: ", ";\n  box-shadow: ", ";\n\n  &:hover {\n    background-color: ", ";\n  }\n"])), styles.themeColors.gray[10], styles.themeShadows.mediumBlue5, styles.themeColors.white);
var templateObject_1$z, templateObject_2$q, templateObject_3$k, templateObject_4$e, templateObject_5$c;

var CardRowLayout = function (props) { return (React__namespace.createElement(WrapperView$2, { justify: Spacing.FlexJustify.CENTER, wrap: Spacing.FlexWrap.WRAP }, React__namespace.Children.map(props.children, function (child, i) {
    return (React__namespace.createElement("div", { className: "card-child", key: i }, child));
}))); };
var WrapperView$2 = styled__default.default(Spacing.Flex).withConfig({ displayName: "WrapperView", componentId: "-5mxq8t" })(templateObject_1$y || (templateObject_1$y = _tslib.__makeTemplateObject(["\n  margin-bottom: 24px;\n\n  .card-child {\n    max-width: 346px;\n    width: 100%;\n    margin: 0 12px 24px 12px;\n  }\n\n  @media ", ", ", " {\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n\n    .card-child {\n      &:not(:first-child) {\n        margin-left: 0;\n      }\n    }\n  }\n"], ["\n  margin-bottom: 24px;\n\n  .card-child {\n    max-width: 346px;\n    width: 100%;\n    margin: 0 12px 24px 12px;\n  }\n\n  @media ", ", ", " {\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n\n    .card-child {\n      &:not(:first-child) {\n        margin-left: 0;\n      }\n    }\n  }\n"])), ResponsiveSizes.media[ResponsiveSizes.BreakpointType.TABLET], ResponsiveSizes.media[ResponsiveSizes.BreakpointType.MOBILE]);
var templateObject_1$y;

var CenteredBlocksListLayout = function (props) { return (React__namespace.createElement(Spacing.Flex, { wrap: Spacing.FlexWrap.WRAP, justify: Spacing.FlexJustify.CENTER }, React__namespace.Children.map(props.children, function (child, i) {
    return React__namespace.createElement(ItemView, { key: i }, child);
}))); };
var ItemView = styled__default.default.div.withConfig({ displayName: "ItemView", componentId: "-161wg68" })(templateObject_1$x || (templateObject_1$x = _tslib.__makeTemplateObject(["\n  padding: 20px 40px;\n"], ["\n  padding: 20px 40px;\n"])));
var templateObject_1$x;

var ColoredLayout = function (props) { return (React__namespace.createElement(BackgroundView, { color: props.color },
    React__namespace.createElement(Spacing.Spacing, { top: 8 }),
    props.width === 'narrow' ? React__namespace.createElement(Spacing.Spacing, { top: [8, 10, 8, 7] }) : React__namespace.createElement(Spacing.Spacing, { top: [24, 18, 12, 8] }),
    props.width === 'narrow' ? (React__namespace.createElement(ContentView$1, { widths: {
            largeDesktop: 1032,
            desktop: 1032,
            tablet: 832,
            mobile: 512,
        } },
        React__namespace.createElement(Content$1, { width: props.width }, props.children))) : (React__namespace.createElement(ContentView$1, { widths: {
            largeDesktop: 1128,
            desktop: 1096,
            tablet: 832,
            mobile: 512,
        } },
        React__namespace.createElement(Content$1, { width: props.width }, props.children))),
    React__namespace.createElement(BlobsWrapper$1, null,
        React__namespace.createElement(Blob1View, { color: styles.themeColors.blue['10'] }),
        React__namespace.createElement(Blob2View, { color: styles.themeColors.blue['10'] })),
    props.width === 'narrow' ? React__namespace.createElement(Spacing.Spacing, { top: [13, 9, 9, 9] }) : React__namespace.createElement(Spacing.Spacing, { top: 16 }))); };
var Content$1 = function (props) { return (React__namespace.createElement(React__namespace.Fragment, null,
    React__namespace.createElement(BeesWrapper, { width: props.width },
        React__namespace.createElement(Bee1View, null),
        React__namespace.createElement(Bee2View, null)),
    props.children)); };
var Bee1View = styled__default.default(HoneygainLogoSdk.Bee1).withConfig({ displayName: "Bee1View", componentId: "-1824xwk" })(templateObject_1$w || (templateObject_1$w = _tslib.__makeTemplateObject(["\n  position: absolute;\n  left: -536px;\n  top: -169px;\n\n  @media ", " {\n    left: 50%;\n    transform: translateX(-1155px);\n  }\n\n  @media ", " {\n    left: -842px;\n  }\n"], ["\n  position: absolute;\n  left: -536px;\n  top: -169px;\n\n  @media ", " {\n    left: 50%;\n    transform: translateX(-1155px);\n  }\n\n  @media ", " {\n    left: -842px;\n  }\n"])), ResponsiveSizes.media['tablet'], ResponsiveSizes.media['mobile']);
var Bee2View = styled__default.default(HoneygainLogoSdk.Bee2).withConfig({ displayName: "Bee2View", componentId: "-84ckfk" })(templateObject_2$p || (templateObject_2$p = _tslib.__makeTemplateObject(["\n  position: absolute;\n  top: -256px;\n  right: -133px;\n\n  @media ", " {\n    left: 50%;\n    transform: translateX(170px);\n  }\n\n  @media ", " {\n    right: -230px;\n  }\n"], ["\n  position: absolute;\n  top: -256px;\n  right: -133px;\n\n  @media ", " {\n    left: 50%;\n    transform: translateX(170px);\n  }\n\n  @media ", " {\n    right: -230px;\n  }\n"])), ResponsiveSizes.media['tablet'], ResponsiveSizes.media['mobile']);
var BeesWrapper = styled__default.default.div.withConfig({ displayName: "BeesWrapper", componentId: "-14qx0qd" })(templateObject_3$j || (templateObject_3$j = _tslib.__makeTemplateObject(["\n  position: absolute;\n  z-index: 8;\n  width: 100%;\n  ", "\n\n  @media ", ", ", " {\n    top: 375px;\n  }\n"], ["\n  position: absolute;\n  z-index: 8;\n  width: 100%;\n  ", "\n\n  @media ", ", ", " {\n    top: 375px;\n  }\n"])), function (props) { return (props.width ? 'top: 30px;' : undefined); }, ResponsiveSizes.media['tablet'], ResponsiveSizes.media['mobile']);
var Blob1View = styled__default.default(AchievementStar.BackgroundBlob4).withConfig({ displayName: "Blob1View", componentId: "-napbzc" })(templateObject_4$d || (templateObject_4$d = _tslib.__makeTemplateObject(["\n  width: 186px;\n  position: relative;\n  top: -300px;\n"], ["\n  width: 186px;\n  position: relative;\n  top: -300px;\n"])));
var Blob2View = styled__default.default(AchievementStar.BackgroundBlob5).withConfig({ displayName: "Blob2View", componentId: "-1667tur" })(templateObject_5$b || (templateObject_5$b = _tslib.__makeTemplateObject(["\n  width: 405px;\n"], ["\n  width: 405px;\n"])));
var ContentView$1 = styled__default.default(Container$t).withConfig({ displayName: "ContentView", componentId: "-j7oi4w" })(templateObject_6$9 || (templateObject_6$9 = _tslib.__makeTemplateObject(["\n  z-index: 10;\n  position: relative;\n"], ["\n  z-index: 10;\n  position: relative;\n"])));
var BackgroundView = styled__default.default.div.withConfig({ displayName: "BackgroundView", componentId: "-dcu026" })(templateObject_7$6 || (templateObject_7$6 = _tslib.__makeTemplateObject(["\n  overflow-x: hidden;\n  position: relative;\n  background-color: ", ";\n"], ["\n  overflow-x: hidden;\n  position: relative;\n  background-color: ", ";\n"])), function (props) { return (props.color ? props.color : styles.themeColors.blue['5']); });
var BlobsWrapper$1 = styled__default.default(Spacing.Flex).withConfig({ displayName: "BlobsWrapper", componentId: "-yn73ss" })(templateObject_8$5 || (templateObject_8$5 = _tslib.__makeTemplateObject(["\n  justify-content: space-evenly;\n  height: 100%;\n  position: absolute;\n  z-index: 5;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 693px;\n"], ["\n  justify-content: space-evenly;\n  height: 100%;\n  position: absolute;\n  z-index: 5;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 693px;\n"])));
var templateObject_1$w, templateObject_2$p, templateObject_3$j, templateObject_4$d, templateObject_5$b, templateObject_6$9, templateObject_7$6, templateObject_8$5;

var ComponentListItemLayout = function (props) { return (React__namespace.createElement(LayoutView, null,
    React__namespace.createElement(IconView, null, props.icon),
    React__namespace.createElement("div", null,
        React__namespace.createElement(Hyperlink.Text, { type: Hyperlink.TextType.HEADING_MEDIUM, useCompact: true, spacingType: Hyperlink.TextSpacingType.COMPACT_SMALLEST },
            React__namespace.createElement("h3", null, props.title)),
        React__namespace.createElement(Spacing.Spacing, { top: true }),
        React__namespace.createElement(Hyperlink.Text, { type: Hyperlink.TextType.BODY, useCompact: true },
            React__namespace.createElement("p", { dangerouslySetInnerHTML: { __html: props.body } }))))); };
var LayoutView = styled__default.default(Spacing.Flex).withConfig({ displayName: "LayoutView", componentId: "-1ujg0v2" })(templateObject_1$v || (templateObject_1$v = _tslib.__makeTemplateObject(["\n  padding-bottom: ", "px;\n  @media ", ", ", " {\n    flex-direction: column;\n  }\n"], ["\n  padding-bottom: ", "px;\n  @media ", ", ", " {\n    flex-direction: column;\n  }\n"])), Spacing.getSpace(6), ResponsiveSizes.media.tablet, ResponsiveSizes.media.mobile);
var IconView = styled__default.default.div.withConfig({ displayName: "IconView", componentId: "-u1iahy" })(templateObject_2$o || (templateObject_2$o = _tslib.__makeTemplateObject(["\n  padding-right: 16px;\n"], ["\n  padding-right: 16px;\n"])));
var templateObject_1$v, templateObject_2$o;

var HeroBackgroundLayout = function (props) {
    return (React__namespace.createElement(Background$2, { className: props.className },
        React__namespace.createElement(ContentView, null,
            React__namespace.createElement(Container$t, null,
                React__namespace.createElement(ContentWrapper, null,
                    React__namespace.createElement(BlobsWrapper, null,
                        React__namespace.createElement(AchievementStar.BackgroundBlob1, null),
                        React__namespace.createElement(AchievementStar.BackgroundBlob2, null)),
                    React__namespace.createElement(Body, null, props.children))))));
};
var ContentWrapper = styled__default.default(Spacing.Flex).withConfig({ displayName: "ContentWrapper", componentId: "-1h8b9rs" })(templateObject_1$u || (templateObject_1$u = _tslib.__makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var Body = styled__default.default.div.withConfig({ displayName: "Body", componentId: "-tjdupg" })(templateObject_2$n || (templateObject_2$n = _tslib.__makeTemplateObject(["\n  z-index: 10;\n"], ["\n  z-index: 10;\n"])));
var BlobsWrapper = styled__default.default.div.withConfig({ displayName: "BlobsWrapper", componentId: "-uy8bwn" })(templateObject_3$i || (templateObject_3$i = _tslib.__makeTemplateObject(["\n  display: flex;\n  width: 50%;\n  flex-direction: column;\n  justify-content: space-evenly;\n  position: absolute;\n  top: 70px;\n  left: 30px;\n  height: 50%;\n  z-index: 0;\n"], ["\n  display: flex;\n  width: 50%;\n  flex-direction: column;\n  justify-content: space-evenly;\n  position: absolute;\n  top: 70px;\n  left: 30px;\n  height: 50%;\n  z-index: 0;\n"])));
var ContentView = styled__default.default.div.withConfig({ displayName: "ContentView", componentId: "-66n5rd" })(templateObject_4$c || (templateObject_4$c = _tslib.__makeTemplateObject(["\n  height: 100%;\n  align-items: center;\n  display: flex;\n  padding-top: 64px;\n"], ["\n  height: 100%;\n  align-items: center;\n  display: flex;\n  padding-top: 64px;\n"])));
var Background$2 = styled__default.default.div.withConfig({ displayName: "Background", componentId: "-mc43p" })(templateObject_5$a || (templateObject_5$a = _tslib.__makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  min-height: 616px;\n  height: 100vh;\n  max-height: 1000px;\n  background-color: rgb(240, 249, 255);\n  flex-direction: column;\n  justify-content: flex-end;\n  overflow: hidden;\n\n  @media (max-width: 880px) and (min-width: 561px), (max-width: 560px) {\n    height: initial;\n    background: linear-gradient(rgb(240, 249, 255) 0%, rgb(240, 249, 255) 70%, rgb(255, 255, 255) 100%);\n  }\n"], ["\n  display: flex;\n  width: 100%;\n  min-height: 616px;\n  height: 100vh;\n  max-height: 1000px;\n  background-color: rgb(240, 249, 255);\n  flex-direction: column;\n  justify-content: flex-end;\n  overflow: hidden;\n\n  @media (max-width: 880px) and (min-width: 561px), (max-width: 560px) {\n    height: initial;\n    background: linear-gradient(rgb(240, 249, 255) 0%, rgb(240, 249, 255) 70%, rgb(255, 255, 255) 100%);\n  }\n"])));
var templateObject_1$u, templateObject_2$n, templateObject_3$i, templateObject_4$c, templateObject_5$a;

var HeroLayout = function (props) { return (React__namespace.createElement(React__namespace.Fragment, null,
    React__namespace.createElement(ColumnsWrapper$2, { align: Spacing.FlexAlign.CENTER, className: props.className },
        React__namespace.createElement(LeftColumnView, { flexDir: Spacing.FlexDirection.COLUMN },
            React__namespace.createElement(Hyperlink.Text, { type: Hyperlink.TextType.HEADING_XLARGE, useCompact: true },
                React__namespace.createElement("h1", null, props.title)),
            React__namespace.createElement(Spacing.Spacing, { top: [2, 2, 3, 3] }),
            React__namespace.createElement(BodyTextView, { type: Hyperlink.TextType.HEADING_SMALL, useCompact: true },
                React__namespace.createElement("p", null, props.body)),
            React__namespace.createElement(Spacing.Spacing, { top: [6, 8, 6, 3] }),
            props.button,
            React__namespace.createElement(Spacing.Spacing, { top: 4 })),
        React__namespace.createElement(IllustrationSpacing, null),
        React__namespace.createElement(RightColumnView, null, props.illustration)))); };
var BodyTextView = styled__default.default(Hyperlink.Text).withConfig({ displayName: "BodyTextView", componentId: "-linffr" })(templateObject_1$t || (templateObject_1$t = _tslib.__makeTemplateObject(["\n  max-width: 616px;\n"], ["\n  max-width: 616px;\n"])));
var IllustrationSpacing = styled__default.default.div.withConfig({ displayName: "IllustrationSpacing", componentId: "-1nj5fqa" })(templateObject_2$m || (templateObject_2$m = _tslib.__makeTemplateObject(["\n  padding-left: 24px;\n\n  @media ", " {\n    padding-top: 32px;\n  }\n\n  @media ", " {\n    padding-top: 72px;\n  }\n"], ["\n  padding-left: 24px;\n\n  @media ", " {\n    padding-top: 32px;\n  }\n\n  @media ", " {\n    padding-top: 72px;\n  }\n"])), ResponsiveSizes.media[ResponsiveSizes.BreakpointType.TABLET], ResponsiveSizes.media[ResponsiveSizes.BreakpointType.MOBILE]);
var ColumnsWrapper$2 = styled__default.default(Spacing.Flex).withConfig({ displayName: "ColumnsWrapper", componentId: "-zu7rmq" })(templateObject_3$h || (templateObject_3$h = _tslib.__makeTemplateObject(["\n  @media ", ", ", " {\n    flex-direction: column;\n  }\n"], ["\n  @media ", ", ", " {\n    flex-direction: column;\n  }\n"])), ResponsiveSizes.media[ResponsiveSizes.BreakpointType.TABLET], ResponsiveSizes.media[ResponsiveSizes.BreakpointType.MOBILE]);
var LeftColumnView = styled__default.default(Spacing.Flex).withConfig({ displayName: "LeftColumnView", componentId: "-g29dox" })(templateObject_4$b || (templateObject_4$b = _tslib.__makeTemplateObject(["\n  flex: 6;\n  z-index: 10;\n\n  @media ", ", ", " {\n    flex: auto;\n    width: 100%;\n    text-align: center;\n    align-items: center;\n  }\n"], ["\n  flex: 6;\n  z-index: 10;\n\n  @media ", ", ", " {\n    flex: auto;\n    width: 100%;\n    text-align: center;\n    align-items: center;\n  }\n"])), ResponsiveSizes.media[ResponsiveSizes.BreakpointType.TABLET], ResponsiveSizes.media[ResponsiveSizes.BreakpointType.MOBILE]);
var RightColumnView = styled__default.default.div.withConfig({ displayName: "RightColumnView", componentId: "-16gg023" })(templateObject_5$9 || (templateObject_5$9 = _tslib.__makeTemplateObject(["\n  flex: 6;\n  z-index: 10;\n\n  svg,\n  img {\n    max-width: 552px;\n    width: 100%;\n  }\n\n  @media ", ", ", " {\n    flex: auto;\n    width: 100%;\n    text-align: center;\n  }\n"], ["\n  flex: 6;\n  z-index: 10;\n\n  svg,\n  img {\n    max-width: 552px;\n    width: 100%;\n  }\n\n  @media ", ", ", " {\n    flex: auto;\n    width: 100%;\n    text-align: center;\n  }\n"])), ResponsiveSizes.media[ResponsiveSizes.BreakpointType.TABLET], ResponsiveSizes.media[ResponsiveSizes.BreakpointType.MOBILE]);
var templateObject_1$t, templateObject_2$m, templateObject_3$h, templateObject_4$b, templateObject_5$9;

var IllustrationWithTextLayout = function (props) { return (React__namespace.createElement(ColumnContainer, null,
    React__namespace.createElement(IllustrationColumn, null, props.illustration),
    React__namespace.createElement(TextColumn, null,
        React__namespace.createElement(Hyperlink.Text, { type: Hyperlink.TextType.BODY },
            React__namespace.createElement(ShouldDisplay.StringReactElement, { data: props.data }))))); };
var ColumnContainer = styled__default.default(Spacing.Flex).withConfig({ displayName: "ColumnContainer", componentId: "-sxsmnz" })(templateObject_1$s || (templateObject_1$s = _tslib.__makeTemplateObject(["\n  @media ", ", ", " {\n    flex-direction: column;\n  }\n"], ["\n  @media ", ", ", " {\n    flex-direction: column;\n  }\n"])), ResponsiveSizes.media[ResponsiveSizes.BreakpointType.TABLET], ResponsiveSizes.media[ResponsiveSizes.BreakpointType.MOBILE]);
var IllustrationColumn = styled__default.default(Spacing.Flex).withConfig({ displayName: "IllustrationColumn", componentId: "-1afa7ky" })(templateObject_2$l || (templateObject_2$l = _tslib.__makeTemplateObject(["\n  flex: 5;\n  align-items: center;\n  justify-content: center;\n"], ["\n  flex: 5;\n  align-items: center;\n  justify-content: center;\n"])));
var TextColumn = styled__default.default(Spacing.Flex).withConfig({ displayName: "TextColumn", componentId: "-ayvqmf" })(templateObject_3$g || (templateObject_3$g = _tslib.__makeTemplateObject(["\n  flex: 7;\n  align-items: center;\n"], ["\n  flex: 7;\n  align-items: center;\n"])));
var templateObject_1$s, templateObject_2$l, templateObject_3$g;

var InfoBlockListLayout = function (props) { return (React__namespace.createElement(ColumnsWrapper$1, null, React__namespace.Children.map(props.children, function (item) { return (React__namespace.createElement(ColumnView, null, item)); }))); };
var ColumnsWrapper$1 = styled__default.default(Spacing.Flex).withConfig({ displayName: "ColumnsWrapper", componentId: "-6l4546" })(templateObject_1$r || (templateObject_1$r = _tslib.__makeTemplateObject(["\n  flex-wrap: wrap;\n  flex-direction: row;\n  justify-content: space-between;\n"], ["\n  flex-wrap: wrap;\n  flex-direction: row;\n  justify-content: space-between;\n"])));
var ColumnView = styled__default.default(Spacing.Flex).withConfig({ displayName: "ColumnView", componentId: "-1fib66l" })(templateObject_2$k || (templateObject_2$k = _tslib.__makeTemplateObject(["\n  flex-basis: calc(50% - 12px);\n  margin-bottom: 24px;\n\n  @media ", ", ", " {\n    flex-basis: 100%;\n  }\n"], ["\n  flex-basis: calc(50% - 12px);\n  margin-bottom: 24px;\n\n  @media ", ", ", " {\n    flex-basis: 100%;\n  }\n"])), ResponsiveSizes.media[ResponsiveSizes.BreakpointType.TABLET], ResponsiveSizes.media[ResponsiveSizes.BreakpointType.MOBILE]);
var templateObject_1$r, templateObject_2$k;

var SequenceLayout = function (props) { return (React__namespace.createElement(WrapperView$1, { justify: Spacing.FlexJustify.CENTER, align: Spacing.FlexAlign.CENTER }, props.children)); };
var WrapperView$1 = styled__default.default(Spacing.Flex).withConfig({ displayName: "WrapperView", componentId: "-1xugdg6" })(templateObject_1$q || (templateObject_1$q = _tslib.__makeTemplateObject(["\n  @media ", ", ", " {\n    flex-direction: column;\n  }\n"], ["\n  @media ", ", ", " {\n    flex-direction: column;\n  }\n"])), ResponsiveSizes.media[ResponsiveSizes.BreakpointType.TABLET], ResponsiveSizes.media[ResponsiveSizes.BreakpointType.MOBILE]);
var templateObject_1$q;

var ValuePropositionLayout = function (props) { return (React__namespace.createElement(ColumnsWrapper, { className: classNames__default.default('proposition-col', props.className) },
    React__namespace.createElement(IllustrationView, { flex: 5 }, props.illustration),
    React__namespace.createElement(Spacing.Flex, { flex: 7, flexDir: Spacing.FlexDirection.COLUMN, justify: Spacing.FlexJustify.CENTER },
        props.heading,
        React__namespace.createElement(Hyperlink.Text, { type: Hyperlink.TextType.BODY, spacingType: Hyperlink.TextSpacingType.BETWEEN_CONTENT_AND_BUTTON },
            React__namespace.createElement(ShouldDisplay.StringReactElement, { data: props.body })),
        props.button && React__namespace.createElement(ButtonView, null, props.button)))); };
var ColumnsWrapper = styled__default.default(Spacing.Flex).withConfig({ displayName: "ColumnsWrapper", componentId: "-1nbehk0" })(templateObject_1$p || (templateObject_1$p = _tslib.__makeTemplateObject(["\n  @media ", ", ", " {\n    flex-direction: column;\n    max-width: 512px;\n    margin: 0 auto;\n  }\n"], ["\n  @media ", ", ", " {\n    flex-direction: column;\n    max-width: 512px;\n    margin: 0 auto;\n  }\n"])), ResponsiveSizes.media.tablet, ResponsiveSizes.media.mobile);
var IllustrationView = styled__default.default(Spacing.Flex).withConfig({ displayName: "IllustrationView", componentId: "-l0yahc" })(templateObject_2$j || (templateObject_2$j = _tslib.__makeTemplateObject(["\n  svg,\n  img {\n    width: 100%;\n    max-width: 456px;\n  }\n\n  @media ", ", ", " {\n    justify-content: center;\n  }\n"], ["\n  svg,\n  img {\n    width: 100%;\n    max-width: 456px;\n  }\n\n  @media ", ", ", " {\n    justify-content: center;\n  }\n"])), ResponsiveSizes.media.tablet, ResponsiveSizes.media.mobile);
var ButtonView = styled__default.default.div.withConfig({ displayName: "ButtonView", componentId: "-1x9qkg7" })(templateObject_3$f || (templateObject_3$f = _tslib.__makeTemplateObject(["\n  button {\n    width: 192px;\n\n    @media ", ", ", " {\n      width: 256px;\n    }\n  }\n\n  @media ", ", ", " {\n    text-align: center;\n  }\n"], ["\n  button {\n    width: 192px;\n\n    @media ", ", ", " {\n      width: 256px;\n    }\n  }\n\n  @media ", ", ", " {\n    text-align: center;\n  }\n"])), ResponsiveSizes.media.tablet, ResponsiveSizes.media.mobile, ResponsiveSizes.media.tablet, ResponsiveSizes.media.mobile);
var templateObject_1$p, templateObject_2$j, templateObject_3$f;

var ValuePropositionListLayout = function (props) { return (React__namespace.createElement(WrapperView, null, props.children &&
    React__namespace.Children.map(props.children, function (child, i) {
        return React__namespace.createElement(React__namespace.Fragment, null, child);
    }))); };
var WrapperView = styled__default.default(Container$t).withConfig({ displayName: "WrapperView", componentId: "-c8kjn0" })(templateObject_1$o || (templateObject_1$o = _tslib.__makeTemplateObject(["\n  @media ", ", ", " {\n    .proposition-col:nth-child(even) {\n      flex-direction: row-reverse;\n    }\n  }\n\n  .proposition-col:not(:last-child) {\n    padding-bottom: ", "px;\n\n    @media ", " {\n      padding-bottom: ", "px;\n    }\n\n    @media ", " {\n      padding-bottom: ", "px;\n    }\n\n    @media ", " {\n      padding-bottom: ", "px;\n    }\n  }\n\n  @media ", " {\n    margin: 96px auto;\n  }\n\n  @media ", " {\n    margin: 72px auto;\n  }\n\n  @media ", " {\n    margin: 16px auto 128px auto;\n  }\n\n  @media ", " {\n    margin: 48px auto 96px auto;\n  }\n"], ["\n  @media ", ", ", " {\n    .proposition-col:nth-child(even) {\n      flex-direction: row-reverse;\n    }\n  }\n\n  .proposition-col:not(:last-child) {\n    padding-bottom: ", "px;\n\n    @media ", " {\n      padding-bottom: ", "px;\n    }\n\n    @media ", " {\n      padding-bottom: ", "px;\n    }\n\n    @media ", " {\n      padding-bottom: ", "px;\n    }\n  }\n\n  @media ", " {\n    margin: 96px auto;\n  }\n\n  @media ", " {\n    margin: 72px auto;\n  }\n\n  @media ", " {\n    margin: 16px auto 128px auto;\n  }\n\n  @media ", " {\n    margin: 48px auto 96px auto;\n  }\n"])), ResponsiveSizes.media.largeDesktop, ResponsiveSizes.media.desktop, Spacing.getSpace(3), ResponsiveSizes.media.desktop, Spacing.getSpace(2), ResponsiveSizes.media.tablet, Spacing.getSpace(12), ResponsiveSizes.media.mobile, Spacing.getSpace(9), ResponsiveSizes.media.largeDesktop, ResponsiveSizes.media.desktop, ResponsiveSizes.media.tablet, ResponsiveSizes.media.mobile);
var templateObject_1$o;

var CarebuzzHeroSection = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, background = _a.background, callToAction = _a.callToAction, image = _a.image, paddingTop = _a.paddingTop, paddingBottom = _a.paddingBottom;
    return (React__namespace.createElement(Section$5, { background: background, paddingTop: paddingTop, paddingBottom: paddingBottom },
        React__namespace.createElement(Container$b, null,
            React__namespace.createElement(Title$2, null,
                React__namespace.createElement(Hyperlink.Text, { type: "heading_xlarge", useCompact: true },
                    React__namespace.createElement("h3", null, title))),
            React__namespace.createElement(Subtitle, null,
                React__namespace.createElement(Hyperlink.Text, { type: "body", useCompact: true },
                    React__namespace.createElement("h3", null, subtitle))),
            React__namespace.createElement(Button$1, null,
                React__namespace.createElement(LinkButton, { type: "accent", size: "large", href: callToAction.url, target: callToAction.target, rel: callToAction.rel, className: callToAction.className }, callToAction.text)),
            React__namespace.createElement(Image, null,
                React__namespace.createElement("img", { src: image.url, alt: image.alt })))));
};
var Section$5 = styled__default.default.div.withConfig({ shouldForwardProp: Spacing.isPropValid })(templateObject_1$n || (templateObject_1$n = _tslib.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  background-color: ", ";\n  padding: 0 24px;\n  box-sizing: border-box;\n\n  ", "\n  ", "\n"], ["\n  display: flex;\n  flex-direction: column;\n  background-color: ", ";\n  padding: 0 24px;\n  box-sizing: border-box;\n\n  ", "\n  ", "\n"])), function (props) { var _a; return styles.backgrounds[(_a = props.background) !== null && _a !== void 0 ? _a : 'white']; }, function (props) { return props.paddingTop && UseSize.getResponsiveProperty('padding-top', props.paddingTop); }, function (props) { return props.paddingBottom && UseSize.getResponsiveProperty('padding-bottom', props.paddingBottom); });
var Container$b = styled__default.default.div.withConfig({ displayName: "Container", componentId: "-1h7b6ve" })(templateObject_2$i || (templateObject_2$i = _tslib.__makeTemplateObject(["\n  margin: 0 auto;\n  flex: 1;\n  max-width: 1096px;\n  width: 100%;\n\n  display: grid;\n  grid-template-areas:\n    'title'\n    'subtitle'\n    'button'\n    'image';\n\n  @media ", " {\n    grid-template-rows: min-content;\n    grid-template-columns: 55% 45%;\n    grid-column-gap: 64px;\n    grid-template-areas:\n      'title image'\n      'subtitle image'\n      'button image';\n  }\n\n  @media ", " {\n    max-width: 1128px;\n  }\n"], ["\n  margin: 0 auto;\n  flex: 1;\n  max-width: 1096px;\n  width: 100%;\n\n  display: grid;\n  grid-template-areas:\n    'title'\n    'subtitle'\n    'button'\n    'image';\n\n  @media ", " {\n    grid-template-rows: min-content;\n    grid-template-columns: 55% 45%;\n    grid-column-gap: 64px;\n    grid-template-areas:\n      'title image'\n      'subtitle image'\n      'button image';\n  }\n\n  @media ", " {\n    max-width: 1128px;\n  }\n"])), ResponsiveSizes.desktop, ResponsiveSizes.desktopLarge);
var Title$2 = styled__default.default.div.withConfig({ displayName: "Title", componentId: "-aqc7i4" })(templateObject_3$e || (templateObject_3$e = _tslib.__makeTemplateObject(["\n  grid-area: title;\n  text-align: center;\n\n  @media ", " {\n    text-align: left;\n  }\n"], ["\n  grid-area: title;\n  text-align: center;\n\n  @media ", " {\n    text-align: left;\n  }\n"])), ResponsiveSizes.desktop);
var Subtitle = styled__default.default.div.withConfig({ displayName: "Subtitle", componentId: "-2m8vkw" })(templateObject_4$a || (templateObject_4$a = _tslib.__makeTemplateObject(["\n  grid-area: subtitle;\n  margin-top: 8px;\n  text-align: center;\n\n  ul {\n    text-align: left;\n  }\n\n  @media ", " {\n    text-align: left;\n  }\n"], ["\n  grid-area: subtitle;\n  margin-top: 8px;\n  text-align: center;\n\n  ul {\n    text-align: left;\n  }\n\n  @media ", " {\n    text-align: left;\n  }\n"])), ResponsiveSizes.desktop);
var Button$1 = styled__default.default.div.withConfig({ displayName: "Button", componentId: "-xaoc82" })(templateObject_5$8 || (templateObject_5$8 = _tslib.__makeTemplateObject(["\n  grid-area: button;\n  margin-top: 40px;\n  display: flex;\n\n  & a {\n    padding: 16px 42px;\n    width: 100%;\n\n    @media ", " {\n      width: auto;\n      flex: 0 0 auto;\n    }\n  }\n"], ["\n  grid-area: button;\n  margin-top: 40px;\n  display: flex;\n\n  & a {\n    padding: 16px 42px;\n    width: 100%;\n\n    @media ", " {\n      width: auto;\n      flex: 0 0 auto;\n    }\n  }\n"])), ResponsiveSizes.desktop);
var Image = styled__default.default.div.withConfig({ displayName: "Image", componentId: "-y85nkc" })(templateObject_6$8 || (templateObject_6$8 = _tslib.__makeTemplateObject(["\n  grid-area: image;\n  margin-top: 24px;\n  width: 100%;\n\n  & img {\n    object-fit: contain;\n    object-position: center;\n    width: 100%;\n    height: 100%;\n  }\n\n  @media ", " {\n    margin-top: 0;\n  }\n"], ["\n  grid-area: image;\n  margin-top: 24px;\n  width: 100%;\n\n  & img {\n    object-fit: contain;\n    object-position: center;\n    width: 100%;\n    height: 100%;\n  }\n\n  @media ", " {\n    margin-top: 0;\n  }\n"])), ResponsiveSizes.desktop);
var templateObject_1$n, templateObject_2$i, templateObject_3$e, templateObject_4$a, templateObject_5$8, templateObject_6$8;

var ButtonArrow = function (_a) {
    var side = _a.side, disabled = _a.disabled, onClick = _a.onClick, props = _tslib.__rest(_a, ["side", "disabled", "onClick"]);
    var rotation = side === 'left' ? 90 : -90;
    return (React__namespace.createElement(Button, _tslib.__assign({ onClick: onClick, disabled: disabled }, props),
        React__namespace.createElement(ArrowDown.ArrowDown, { style: { transform: "rotate(".concat(rotation, "deg)") }, fill: styles.themeColors.blue[60] })));
};
var Button = styled__default.default.button.withConfig({ shouldForwardProp: Spacing.isPropValid })(templateObject_2$h || (templateObject_2$h = _tslib.__makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 32px;\n  border: 1px solid ", ";\n  border-radius: 8px;\n  background-color: transparent;\n  cursor: pointer;\n\n  :focus {\n    box-shadow: 0 0 0 4px ", ";\n  }\n\n  ", "\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 32px;\n  border: 1px solid ", ";\n  border-radius: 8px;\n  background-color: transparent;\n  cursor: pointer;\n\n  :focus {\n    box-shadow: 0 0 0 4px ", ";\n  }\n\n  ", "\n"])), styles.themeColors.blue[60], styles.themeColors.blue[30], function (props) {
    return props.disabled && styled.css(templateObject_1$m || (templateObject_1$m = _tslib.__makeTemplateObject(["\n      pointer-events: none;\n      opacity: 0.2;\n      background-color: ", ";\n    "], ["\n      pointer-events: none;\n      opacity: 0.2;\n      background-color: ", ";\n    "])), styles.themeColors.blue[20]);
});
var templateObject_1$m, templateObject_2$h;

var CARD_SIZE$2 = 206;
var CARD_SPACING$2 = 24;
var Gallery = function (_a) {
    var title = _a.title, background = _a.background, pills = _a.pills, children = _a.children, props = _tslib.__rest(_a, ["title", "background", "pills", "children"]);
    var isTablet = UseSize.useSizes().isTablet;
    var slideCount = React__namespace.Children.count(children);
    var _b = hooks_index.useGallerySwiper({
        cardSize: CARD_SIZE$2,
        cardSpacing: CARD_SPACING$2,
        slideCount: slideCount,
    }), canSwipeLeft = _b.canSwipeLeft, canSwipeRight = _b.canSwipeRight, swipeLeft = _b.swipeLeft, swipeRight = _b.swipeRight, swiperEvents = _b.swiperEvents;
    var showArrows = isTablet && slideCount > 5;
    return (React__namespace.createElement(Section$4, _tslib.__assign({ background: background }, props),
        React__namespace.createElement(Container$a, null,
            React__namespace.createElement(Spacing.Flex, { justify: "space-between", align: "flex-end", gap: "16px" },
                React__namespace.createElement("div", null,
                    React__namespace.createElement(Hyperlink.Text, { type: "heading_large", useCompact: true },
                        React__namespace.createElement("h3", null, title)),
                    pills && pills.length > 0 && (React__namespace.createElement(Pills, null, pills.map(function (pill, index) { return (React__namespace.createElement(Pill, _tslib.__assign({ key: "".concat(pill.text).concat(index) }, pill))); })))),
                showArrows && (React__namespace.createElement(Spacing.Flex, { gap: "16px" },
                    React__namespace.createElement(ButtonArrow, { side: "left", onClick: swipeLeft, disabled: canSwipeLeft }),
                    React__namespace.createElement(ButtonArrow, { side: "right", onClick: swipeRight, disabled: canSwipeRight })))),
            React__namespace.createElement(Cards$2, null,
                React__namespace.createElement(SwiperContainer$2, null,
                    React__namespace.createElement(Swiper, _tslib.__assign({ slidesPerView: "auto", slidesPerGroup: 1, spaceBetween: CARD_SPACING$2, freeMode: true, mousewheel: { forceToAxis: true }, modules: [freeMode, Mousewheel] }, swiperEvents),
                        React__namespace.createElement(Spacer$2, null),
                        React__namespace.Children.map(children, function (child) { return (React__namespace.createElement(Slide$2, null, child)); }),
                        React__namespace.createElement(Spacer$2, null)))))));
};
var Section$4 = styled__default.default(SectionContainer).withConfig({ displayName: "Section", componentId: "-1pn38ca" })(templateObject_1$l || (templateObject_1$l = _tslib.__makeTemplateObject(["\n  overflow: hidden;\n"], ["\n  overflow: hidden;\n"])));
var Container$a = styled__default.default(Spacing.Flex).withConfig({ displayName: "Container", componentId: "-122oq62" })(templateObject_2$g || (templateObject_2$g = _tslib.__makeTemplateObject(["\n  flex-direction: column;\n  margin: 0 auto;\n  padding-top: 56px;\n  max-width: 1096px;\n  width: 100%;\n  --card-size: ", "px;\n  --card-spacing: ", "px;\n\n  @media ", " {\n    padding-top: 80px;\n  }\n\n  @media ", " {\n    max-width: 1128px;\n  }\n"], ["\n  flex-direction: column;\n  margin: 0 auto;\n  padding-top: 56px;\n  max-width: 1096px;\n  width: 100%;\n  --card-size: ", "px;\n  --card-spacing: ", "px;\n\n  @media ", " {\n    padding-top: 80px;\n  }\n\n  @media ", " {\n    max-width: 1128px;\n  }\n"])), CARD_SIZE$2, CARD_SPACING$2, ResponsiveSizes.desktop, ResponsiveSizes.desktopLarge);
var Pills = styled__default.default.div.withConfig({ displayName: "Pills", componentId: "-1x8z6bq" })(templateObject_3$d || (templateObject_3$d = _tslib.__makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-top: 32px;\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-top: 32px;\n"])));
var Cards$2 = styled__default.default.div.withConfig({ displayName: "Cards", componentId: "-w35h1h" })(templateObject_4$9 || (templateObject_4$9 = _tslib.__makeTemplateObject(["\n  margin-top: 32px;\n  width: 100%;\n  padding-bottom: 56px;\n\n  @media ", " {\n    padding-bottom: 80px;\n  }\n"], ["\n  margin-top: 32px;\n  width: 100%;\n  padding-bottom: 56px;\n\n  @media ", " {\n    padding-bottom: 80px;\n  }\n"])), ResponsiveSizes.desktop);
var Spacer$2 = styled__default.default(SwiperSlide).withConfig({ displayName: "Spacer", componentId: "-num0z6" })(templateObject_5$7 || (templateObject_5$7 = _tslib.__makeTemplateObject(["\n  && {\n    width: calc(3 * var(--card-size) - var(--card-spacing));\n    height: 1px;\n  }\n"], ["\n  && {\n    width: calc(3 * var(--card-size) - var(--card-spacing));\n    height: 1px;\n  }\n"])));
Spacer$2.displayName = 'SwiperSlide';
var SwiperContainer$2 = styled__default.default.div.withConfig({ displayName: "SwiperContainer", componentId: "-gfdazi" })(templateObject_6$7 || (templateObject_6$7 = _tslib.__makeTemplateObject(["\n  margin: 0 calc(-3 * var(--card-size));\n"], ["\n  margin: 0 calc(-3 * var(--card-size));\n"])));
var Slide$2 = styled__default.default(SwiperSlide).withConfig({ displayName: "Slide", componentId: "-1o5w9u3" })(templateObject_7$5 || (templateObject_7$5 = _tslib.__makeTemplateObject(["\n  && {\n    display: flex;\n    flex-direction: row;\n    height: auto;\n    width: var(--card-size);\n  }\n"], ["\n  && {\n    display: flex;\n    flex-direction: row;\n    height: auto;\n    width: var(--card-size);\n  }\n"])));
Slide$2.displayName = 'SwiperSlide';
var templateObject_1$l, templateObject_2$g, templateObject_3$d, templateObject_4$9, templateObject_5$7, templateObject_6$7, templateObject_7$5;

var CARD_SIZE$1 = 206;
var CARD_SIZE_DESKTOP = 284;
var CARD_SPACING$1 = 24;
var GalleryWithInfo = function (_a) {
    var title = _a.title, paragraph = _a.paragraph, callToAction = _a.callToAction, background = _a.background, children = _a.children, props = _tslib.__rest(_a, ["title", "paragraph", "callToAction", "background", "children"]);
    var isDesktop = UseSize.useSizes().isDesktop;
    var slideCount = React__namespace.Children.count(children);
    var _b = hooks_index.useGallerySwiper({
        cardSize: CARD_SIZE$1,
        cardSpacing: CARD_SPACING$1,
        slideCount: slideCount,
    }), canSwipeLeft = _b.canSwipeLeft, canSwipeRight = _b.canSwipeRight, swipeLeft = _b.swipeLeft, swipeRight = _b.swipeRight, swiperEvents = _b.swiperEvents;
    var enabled = isDesktop ? slideCount > 2 : true;
    return (React__namespace.createElement(Section$3, _tslib.__assign({ background: background }, props),
        React__namespace.createElement(Container$9, null,
            React__namespace.createElement(ShouldDisplay.ClientOnly, null, enabled && (React__namespace.createElement(Arrows$1, null,
                React__namespace.createElement(ButtonArrow, { side: "left", onClick: swipeLeft, disabled: canSwipeLeft }),
                React__namespace.createElement(ButtonArrow, { side: "right", onClick: swipeRight, disabled: canSwipeRight })))),
            React__namespace.createElement(Title$1, { type: "heading_large", useCompact: true },
                React__namespace.createElement("h3", null, title)),
            React__namespace.createElement(Paragraph$1, { type: "body", color: styles.themeColors.gray[90], useCompact: true },
                React__namespace.createElement("div", null, paragraph)),
            React__namespace.createElement(Cards$1, null,
                React__namespace.createElement(SwiperContainer$1, null,
                    React__namespace.createElement(Swiper, _tslib.__assign({ enabled: enabled, slidesPerView: "auto", slidesPerGroup: 1, spaceBetween: CARD_SPACING$1, freeMode: true, mousewheel: { forceToAxis: true }, modules: [freeMode, Mousewheel] }, swiperEvents),
                        React__namespace.Children.map(children, function (child) { return (React__namespace.createElement(Slide$1, null, child)); }),
                        React__namespace.createElement(Spacer$1, null)))),
            callToAction && (React__namespace.createElement(CallToActionButton, { href: callToAction.url, target: callToAction.target, rel: callToAction.rel, className: callToAction.className, type: "primary", fullWidth: { default: true, desktop: false } },
                React__namespace.createElement(Hyperlink.Text, { type: "label", color: styles.themeColors.white },
                    React__namespace.createElement("span", null, callToAction.text)))))));
};
var Section$3 = styled__default.default(SectionContainer).withConfig({ displayName: "Section", componentId: "-v74oyw" })(templateObject_1$k || (templateObject_1$k = _tslib.__makeTemplateObject(["\n  overflow: hidden;\n"], ["\n  overflow: hidden;\n"])));
var Container$9 = styled__default.default.div.withConfig({ displayName: "Container", componentId: "-15d7q1" })(templateObject_2$f || (templateObject_2$f = _tslib.__makeTemplateObject(["\n  margin: 0 auto;\n  padding: 56px 0;\n  max-width: 1096px;\n  width: 100%;\n  --card-size: ", "px;\n  --card-spacing: ", "px;\n\n  display: grid;\n  grid-template-areas:\n    'title'\n    'paragraph'\n    'arrows'\n    'cards'\n    'cta';\n  grid-template-columns: 100%;\n\n  @media ", " {\n    grid-template-areas:\n      'arrows arrows'\n      'title cards'\n      'paragraph cards'\n      'cta cards';\n\n    padding: 80px 0;\n    --card-size: ", "px;\n\n    grid-template-columns: 50% 50%;\n    grid-template-rows: auto auto 1fr;\n    padding-right: calc(-3 * var(--card-size) + var(--card-spacing));\n  }\n\n  @media ", " {\n    max-width: 1128px;\n  }\n"], ["\n  margin: 0 auto;\n  padding: 56px 0;\n  max-width: 1096px;\n  width: 100%;\n  --card-size: ", "px;\n  --card-spacing: ", "px;\n\n  display: grid;\n  grid-template-areas:\n    'title'\n    'paragraph'\n    'arrows'\n    'cards'\n    'cta';\n  grid-template-columns: 100%;\n\n  @media ", " {\n    grid-template-areas:\n      'arrows arrows'\n      'title cards'\n      'paragraph cards'\n      'cta cards';\n\n    padding: 80px 0;\n    --card-size: ", "px;\n\n    grid-template-columns: 50% 50%;\n    grid-template-rows: auto auto 1fr;\n    padding-right: calc(-3 * var(--card-size) + var(--card-spacing));\n  }\n\n  @media ", " {\n    max-width: 1128px;\n  }\n"])), CARD_SIZE$1, CARD_SPACING$1, ResponsiveSizes.desktop, CARD_SIZE_DESKTOP, ResponsiveSizes.desktopLarge);
var Title$1 = styled__default.default(Hyperlink.Text).withConfig({ displayName: "Title", componentId: "-177j1hn" })(templateObject_3$c || (templateObject_3$c = _tslib.__makeTemplateObject(["\n  grid-area: title;\n\n  @media ", " {\n    margin-right: 80px;\n  }\n"], ["\n  grid-area: title;\n\n  @media ", " {\n    margin-right: 80px;\n  }\n"])), ResponsiveSizes.desktop);
var Paragraph$1 = styled__default.default(Hyperlink.Text).withConfig({ displayName: "Paragraph", componentId: "-1x8bj86" })(templateObject_4$8 || (templateObject_4$8 = _tslib.__makeTemplateObject(["\n  grid-area: paragraph;\n  margin-top: 24px;\n\n  @media ", " {\n    margin-right: 80px;\n  }\n"], ["\n  grid-area: paragraph;\n  margin-top: 24px;\n\n  @media ", " {\n    margin-right: 80px;\n  }\n"])), ResponsiveSizes.desktop);
var CallToActionButton = styled__default.default(LinkButton).withConfig({ displayName: "CallToActionButton", componentId: "-1snwpe3" })(templateObject_5$6 || (templateObject_5$6 = _tslib.__makeTemplateObject(["\n  grid-area: cta;\n  margin-top: 40px;\n  align-self: end;\n\n  @media ", " {\n    margin: 48px 80px 0 0;\n  }\n"], ["\n  grid-area: cta;\n  margin-top: 40px;\n  align-self: end;\n\n  @media ", " {\n    margin: 48px 80px 0 0;\n  }\n"])), ResponsiveSizes.desktop);
var Cards$1 = styled__default.default.div.withConfig({ displayName: "Cards", componentId: "-1atp30" })(templateObject_6$6 || (templateObject_6$6 = _tslib.__makeTemplateObject(["\n  grid-area: cards;\n  width: 100%;\n  margin-top: 40px;\n\n  @media ", " {\n    margin: 0 80px 0 0;\n  }\n"], ["\n  grid-area: cards;\n  width: 100%;\n  margin-top: 40px;\n\n  @media ", " {\n    margin: 0 80px 0 0;\n  }\n"])), ResponsiveSizes.desktop);
var Spacer$1 = styled__default.default(SwiperSlide).withConfig({ displayName: "Spacer", componentId: "-yczju9" })(templateObject_7$4 || (templateObject_7$4 = _tslib.__makeTemplateObject(["\n  && {\n    width: calc(3 * var(--card-size) - var(--card-spacing));\n    height: 1px;\n  }\n"], ["\n  && {\n    width: calc(3 * var(--card-size) - var(--card-spacing));\n    height: 1px;\n  }\n"])));
Spacer$1.displayName = 'SwiperSlide';
var SwiperContainer$1 = styled__default.default.div.withConfig({ displayName: "SwiperContainer", componentId: "-1kh47p0" })(templateObject_8$4 || (templateObject_8$4 = _tslib.__makeTemplateObject(["\n  width: calc(100% + 3 * var(--card-size));\n  margin-right: calc(-3 * var(--card-size));\n"], ["\n  width: calc(100% + 3 * var(--card-size));\n  margin-right: calc(-3 * var(--card-size));\n"])));
var Slide$1 = styled__default.default(SwiperSlide).withConfig({ displayName: "Slide", componentId: "-3f4575" })(templateObject_9$4 || (templateObject_9$4 = _tslib.__makeTemplateObject(["\n  && {\n    display: flex;\n    flex-direction: row;\n    height: auto;\n    width: var(--card-size);\n  }\n"], ["\n  && {\n    display: flex;\n    flex-direction: row;\n    height: auto;\n    width: var(--card-size);\n  }\n"])));
Slide$1.displayName = 'SwiperSlide';
var Arrows$1 = styled__default.default.div.withConfig({ shouldForwardProp: Spacing.isPropValid })(templateObject_10$4 || (templateObject_10$4 = _tslib.__makeTemplateObject(["\n  grid-area: arrows;\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n  margin-bottom: 16px;\n  gap: 16px;\n"], ["\n  grid-area: arrows;\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n  margin-bottom: 16px;\n  gap: 16px;\n"])));
var templateObject_1$k, templateObject_2$f, templateObject_3$c, templateObject_4$8, templateObject_5$6, templateObject_6$6, templateObject_7$4, templateObject_8$4, templateObject_9$4, templateObject_10$4;

var ThemeTypeData = {
    default: {
        specialTheme: false,
        backgroundColor: styles.themeColors.blue[5],
        headingTextColor: styles.themeColors.gray[90],
        headingThemeTextColor: styles.themeColors.blue[60],
        headingSmallTextColor: styles.themeColors.gray[90],
        backgroundBlobColor: styles.themeColors.blue[10],
        trustpilotTheme: 'light',
        statisticsTheme: 'dark',
    },
    blue: {
        specialTheme: true,
        backgroundColor: styles.themeColors.blue[60],
        headingTextColor: styles.themeColors.gray[5],
        headingThemeTextColor: styles.themeColors.yellow[50],
        headingSmallTextColor: styles.themeColors.gray[20],
        backgroundBlobColor: styles.themeColors.blue[10],
        trustpilotTheme: 'dark',
        statisticsTheme: 'light',
    },
    dark: {
        specialTheme: true,
        backgroundColor: styles.themeColors.gray[100],
        headingThemeTextColor: styles.themeColors.yellow[50],
        headingTextColor: styles.themeColors.white,
        headingSmallTextColor: styles.themeColors.white,
        backgroundBlobColor: '#C3E7D1',
        trustpilotTheme: 'dark',
        statisticsTheme: 'light',
    },
    cbMintgreen: {
        specialTheme: true,
        backgroundColor: '#C3E7D1',
        headingThemeTextColor: styles.themeColors.blue[60],
        headingTextColor: styles.themeColors.gray[90],
        headingSmallTextColor: styles.themeColors.gray[90],
        backgroundBlobColor: '#C3E7D1',
        trustpilotTheme: 'light',
        statisticsTheme: 'dark',
    },
    cbSpecial: {
        specialTheme: true,
        backgroundColor: styles.themeColors.gray[100],
        headingThemeTextColor: styles.themeColors.yellow[50],
        headingTextColor: styles.themeColors.white,
        headingSmallTextColor: styles.themeColors.white,
        backgroundBlobColor: styles.themeColors.gray[5],
        trustpilotTheme: 'dark',
        statisticsTheme: 'light',
    },
    outerSpace: {
        specialTheme: true,
        backgroundColor: styles.themeColors.other.sdk.background,
        headingThemeTextColor: styles.themeColors.white,
        headingTextColor: styles.themeColors.white,
        headingSmallTextColor: styles.themeColors.white,
        backgroundBlobColor: styles.themeColors.other.sdk.background,
        trustpilotTheme: 'dark',
        statisticsTheme: 'light',
    },
};

var CardFact = function (_a) {
    var _b = _a.background, background = _b === void 0 ? 'transparent' : _b, heading = _a.heading, description = _a.description, iconUrl = _a.iconUrl, iconPosition = _a.iconPosition, className = _a.className, theme = _a.theme;
    var cardFlow = iconPosition === 'top' ? 'column-reverse' : iconPosition === 'right' ? 'row' : undefined;
    return (React__namespace.createElement(StyledCardFact$1, { flow: cardFlow !== null && cardFlow !== void 0 ? cardFlow : { default: 'column-reverse', desktop: 'row' }, justify: { default: iconPosition === 'right' ? 'space-between' : 'center', desktop: 'space-between' }, align: { default: 'start', desktop: iconPosition === 'top' ? 'start' : 'center' }, gap: { default: '8px', desktop: '16px' }, "$background": background, "$theme": theme, className: className },
        React__namespace.createElement("div", null,
            heading && (React__namespace.createElement(Hyperlink.Text, { type: "heading_medium", color: theme === 'light' ? 'white' : undefined },
                React__namespace.createElement("span", null, heading))),
            React__namespace.createElement(Hyperlink.Text, { type: "body", useCompact: true, color: theme === 'light' ? 'white' : undefined },
                React__namespace.createElement("span", null, description))),
        iconUrl && (React__namespace.createElement(IconContainer$1, null,
            React__namespace.createElement("img", { src: iconUrl, alt: "", width: "100%", height: "100%", style: { objectFit: 'contain' } })))));
};
var StyledCardFact$1 = styled__default.default(Spacing.Flex).withConfig({ displayName: "StyledCardFact", componentId: "-1s8tg05" })(templateObject_1$j || (templateObject_1$j = _tslib.__makeTemplateObject(["\n  background-color: ", ";\n  padding: 16px;\n  border: ", ";\n  border-radius: ", "px;\n"], ["\n  background-color: ", ";\n  padding: 16px;\n  border: ", ";\n  border-radius: ", "px;\n"])), function (_a) {
    var $background = _a.$background;
    return styles.backgrounds[$background !== null && $background !== void 0 ? $background : 'transparent'];
}, function (_a) {
    var $theme = _a.$theme;
    return ($theme === 'light' ? styles.themeBorder.white : styles.themeBorder.default);
}, styles.themeBorder.radius.default);
var IconContainer$1 = styled__default.default.div.withConfig({ displayName: "IconContainer", componentId: "-dn24tc" })(templateObject_2$e || (templateObject_2$e = _tslib.__makeTemplateObject(["\n  width: 48px;\n  height: 48px;\n\n  @media ", ", ", " {\n    width: 56px;\n    height: 56px;\n  }\n"], ["\n  width: 48px;\n  height: 48px;\n\n  @media ", ", ", " {\n    width: 56px;\n    height: 56px;\n  }\n"])), ResponsiveSizes.desktop, ResponsiveSizes.desktopLarge);
var templateObject_1$j, templateObject_2$e;

var Buttons = function (props) {
    var buttonCount = [props.leftButton, props.rightButton].filter(function (val) { return val !== undefined; }).length;
    return (React__namespace.createElement(ButtonsView, { buttonCount: buttonCount },
        props.leftButton,
        props.rightButton));
};
var ButtonsView = styled__default.default.div.withConfig({ shouldForwardProp: Spacing.isPropValid })(templateObject_1$i || (templateObject_1$i = _tslib.__makeTemplateObject(["\n  display: grid;\n  grid-auto-flow: row;\n  gap: 24px;\n\n  @media ", " {\n    grid-template-columns: 1fr 1fr 1fr;\n  }\n"], ["\n  display: grid;\n  grid-auto-flow: row;\n  gap: 24px;\n\n  @media ", " {\n    grid-template-columns: 1fr 1fr 1fr;\n  }\n"])), ResponsiveSizes.desktop);
var templateObject_1$i;

var HeroSection = function (props) {
    var _a;
    var theme = props.theme;
    var isDesktop = UseSize.useSizes().isDesktop;
    var hasStatistics = ((_a = props.statistics) !== null && _a !== void 0 ? _a : []).length > 0;
    var imageSrc = !props.showMobileImage || isDesktop ? props.illustrationUrl : props.imageMobileUrl;
    return (React__namespace.createElement(Background$1, { fullheight: props.fullHeight, backgroundcolor: ThemeTypeData[theme].backgroundColor, className: props.className },
        React__namespace.createElement(Container$t, null,
            React__namespace.createElement(StyledHero, { fullheight: props.fullHeight },
                React__namespace.createElement(HeadingContent, { justify: "center", flexDir: "column" },
                    React__namespace.createElement(BlobsContainer, { specialTheme: ThemeTypeData[theme].specialTheme },
                        React__namespace.createElement(AchievementStar.BackgroundBlob1, { color: ThemeTypeData[theme].backgroundBlobColor }),
                        React__namespace.createElement(AchievementStar.BackgroundBlob2, { color: ThemeTypeData[theme].backgroundBlobColor })),
                    React__namespace.createElement(TopContentContainer, { flexDir: { default: 'column', desktop: 'row' }, align: "center", gap: "24px" }, props.showTrustpilot && React__namespace.createElement(TrustpilotMicroCombo, { theme: ThemeTypeData[theme].trustpilotTheme })),
                    React__namespace.createElement(ContentContainer$1, null,
                        React__namespace.createElement(TextContainer, { top: 3, bottom: 5 },
                            React__namespace.createElement(Heading$1, { color: ThemeTypeData[theme].headingTextColor, type: "heading_xlarge", useCompact: true },
                                React__namespace.createElement("h1", null,
                                    React__namespace.createElement("div", { className: "desktop_only" },
                                        props.headingText,
                                        React__namespace.createElement("span", { style: { color: ThemeTypeData[theme].headingThemeTextColor } }, props.themedHeadingText)),
                                    React__namespace.createElement("div", { className: "mobile_only" },
                                        props.headingMobileText || props.headingText,
                                        React__namespace.createElement("span", { style: { color: ThemeTypeData[theme].headingThemeTextColor } }, props.themedHeadingMobileText || props.themedHeadingText)))),
                            React__namespace.createElement(Subheading, { color: ThemeTypeData[theme].headingSmallTextColor, type: props.fullHeight ? Hyperlink.TextType.HEADING_SMALL : Hyperlink.TextType.BODY_LARGE, useCompact: true },
                                React__namespace.createElement("small", null,
                                    " ",
                                    props.subheadingText))),
                        props.leftRightButtonsOverride ? (props.leftRightButtonsOverride) : (React__namespace.createElement(Buttons, { leftButton: props.leftButton, rightButton: props.rightButton })),
                        props.contentBelowButtons),
                    props.statistics && (React__namespace.createElement(StyledStatistics, { hasStatistics: hasStatistics }, props.statistics.map(function (data) { return (React__namespace.createElement(CardFact, { key: data.description, heading: data.heading, description: data.description, iconUrl: data.iconUrl, theme: ThemeTypeData[theme].statisticsTheme })); })))),
                React__namespace.createElement(MediaContainer, null,
                    imageSrc ? (React__namespace.createElement(Illustration, { fullheight: props.fullHeight, src: imageSrc, height: "auto", width: "100%", alt: props.illustrationAlt })) : null,
                    props.videoUrl && (React__namespace.createElement(PlayView, null,
                        React__namespace.createElement(PlayButton, { onClick: props.onVideoPlayClick, width: 124, height: 124 })))))),
        props.videoUrl && props.videoOpened ? (React__namespace.createElement(VideoOverlay, { opened: props.videoOpened, onClick: props.onVideoCloseClick },
            React__namespace.createElement(IframeWrapper, null,
                React__namespace.createElement("div", null,
                    React__namespace.createElement("iframe", { width: "966", height: "543", src: props.videoUrl, frameBorder: "0", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true })),
                React__namespace.createElement(CloseIcon, { onClick: props.onVideoCloseClick }, "x")))) : undefined));
};
var Heading$1 = styled__default.default(Hyperlink.Text).withConfig({ displayName: "Heading", componentId: "-ms19vo" })(templateObject_1$h || (templateObject_1$h = _tslib.__makeTemplateObject(["\n  margin-bottom: 16px;\n"], ["\n  margin-bottom: 16px;\n"])));
var TextContainer = styled__default.default(Spacing.Spacing).withConfig({ displayName: "TextContainer", componentId: "-12v0160" })(templateObject_2$d || (templateObject_2$d = _tslib.__makeTemplateObject(["\n  @media ", " {\n    margin-right: 80px;\n  }\n"], ["\n  @media ", " {\n    margin-right: 80px;\n  }\n"])), ResponsiveSizes.desktop);
var StyledStatistics = styled__default.default.div.withConfig({ shouldForwardProp: Spacing.isPropValid })(templateObject_3$b || (templateObject_3$b = _tslib.__makeTemplateObject(["\n  display: flex;\n  gap: 24px;\n  padding-top: 80px;\n  z-index: 10;\n"], ["\n  display: flex;\n  gap: 24px;\n  padding-top: 80px;\n  z-index: 10;\n"])));
var StyledHero = styled__default.default.div.withConfig({ shouldForwardProp: Spacing.isPropValid })(templateObject_4$7 || (templateObject_4$7 = _tslib.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n\n  @media ", " {\n    flex-direction: row;\n  }\n\n  ", "\n"], ["\n  display: flex;\n  flex-direction: column;\n\n  @media ", " {\n    flex-direction: row;\n  }\n\n  ", "\n"])), ResponsiveSizes.desktop, function (_a) {
    var fullheight = _a.fullheight;
    return fullheight
        ? "\n    width: 100%;\n\n  @media ".concat(ResponsiveSizes.media.tablet, " {\n    margin-top: ").concat(Spacing.getSpace(16), "px;\n  }\n  ")
        : "\n  ";
});
var TopContentContainer = styled__default.default(Spacing.Flex).withConfig({ displayName: "TopContentContainer", componentId: "-bc731m" })(templateObject_5$5 || (templateObject_5$5 = _tslib.__makeTemplateObject(["\n  position: relative;\n  z-index: 10;\n  width: 100%;\n\n  @media ", " {\n    width: 430px;\n  }\n"], ["\n  position: relative;\n  z-index: 10;\n  width: 100%;\n\n  @media ", " {\n    width: 430px;\n  }\n"])), ResponsiveSizes.desktop);
var HeadingContent = styled__default.default(Spacing.Flex).withConfig({ displayName: "HeadingContent", componentId: "-t98aft" })(templateObject_6$5 || (templateObject_6$5 = _tslib.__makeTemplateObject(["\n  position: relative;\n  flex: 1;\n\n  @media ", ", ", " {\n    margin-bottom: 40px;\n  }\n"], ["\n  position: relative;\n  flex: 1;\n\n  @media ", ", ", " {\n    margin-bottom: 40px;\n  }\n"])), ResponsiveSizes.media.mobile, ResponsiveSizes.media.tablet);
var Subheading = styled__default.default(Hyperlink.Text).withConfig({ displayName: "Subheading", componentId: "-jmwuha" })(templateObject_7$3 || (templateObject_7$3 = _tslib.__makeTemplateObject(["\n  & * {\n    color: ", " !important;\n  }\n  ul {\n    text-align: left;\n  }\n"], ["\n  & * {\n    color: ", " !important;\n  }\n  ul {\n    text-align: left;\n  }\n"])), function (_a) {
    var color = _a.color;
    return color;
});
var MediaContainer = styled__default.default(Spacing.Flex).withConfig({ displayName: "MediaContainer", componentId: "-du9178" })(templateObject_8$3 || (templateObject_8$3 = _tslib.__makeTemplateObject(["\n  position: relative;\n  flex: 1;\n  max-width: 441px;\n\n  @media ", " {\n    margin-left: 24px;\n  }\n"], ["\n  position: relative;\n  flex: 1;\n  max-width: 441px;\n\n  @media ", " {\n    margin-left: 24px;\n  }\n"])), ResponsiveSizes.desktop);
var Illustration = styled__default.default.img.withConfig({ shouldForwardProp: Spacing.isPropValid })(templateObject_9$3 || (templateObject_9$3 = _tslib.__makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var fullheight = _a.fullheight;
    return fullheight
        ? "\n    width: 100%;\n\n    @media ".concat(ResponsiveSizes.media.largeDesktop, " {\n      width: 530px;\n    }\n  ")
        : "\n    object-fit: contain;\n    aspect-ratio: 1 / 1;\n    max-height: 600px;\n  ";
});
var BlobsContainer = styled__default.default(Spacing.Flex).withConfig({ shouldForwardProp: Spacing.isPropValid })(templateObject_10$3 || (templateObject_10$3 = _tslib.__makeTemplateObject(["\n  flex-direction: column;\n  justify-content: space-evenly;\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  z-index: 1;\n\n  ", "\n"], ["\n  flex-direction: column;\n  justify-content: space-evenly;\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  z-index: 1;\n\n  ", "\n"])), function (props) { return props.specialTheme && "opacity: 0.05;"; });
var CloseIcon = styled__default.default.a.withConfig({ displayName: "CloseIcon", componentId: "-1eo3ctj" })(templateObject_11$3 || (templateObject_11$3 = _tslib.__makeTemplateObject(["\n  position: absolute;\n  z-index: 1000;\n  top: -10px;\n  right: 0;\n  font-size: 36px;\n  line-height: 1;\n  font-weight: 400;\n  color: #fff;\n  text-decoration: none;\n  cursor: pointer;\n  transition: all 200ms;\n"], ["\n  position: absolute;\n  z-index: 1000;\n  top: -10px;\n  right: 0;\n  font-size: 36px;\n  line-height: 1;\n  font-weight: 400;\n  color: #fff;\n  text-decoration: none;\n  cursor: pointer;\n  transition: all 200ms;\n"])));
var IframeWrapper = styled__default.default.div.withConfig({ displayName: "IframeWrapper", componentId: "-1n7v2ie" })(templateObject_12$1 || (templateObject_12$1 = _tslib.__makeTemplateObject(["\n  margin: 0 auto;\n\n  & > div {\n    position: relative;\n    padding-bottom: 56.25%;\n    height: 0;\n  }\n\n  padding: 24px;\n  max-width: 864px;\n  width: calc(100% - 48px);\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-50%);\n\n  iframe {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n"], ["\n  margin: 0 auto;\n\n  & > div {\n    position: relative;\n    padding-bottom: 56.25%;\n    height: 0;\n  }\n\n  padding: 24px;\n  max-width: 864px;\n  width: calc(100% - 48px);\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-50%);\n\n  iframe {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n"])));
var VideoOverlay = styled__default.default.div.withConfig({ shouldForwardProp: Spacing.isPropValid })(templateObject_13 || (templateObject_13 = _tslib.__makeTemplateObject(["\n  position: fixed;\n  z-index: ", ";\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: rgba(0, 0, 0, 0.5);\n  opacity: ", ";\n  transition: all ease 500ms;\n"], ["\n  position: fixed;\n  z-index: ", ";\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: rgba(0, 0, 0, 0.5);\n  opacity: ", ";\n  transition: all ease 500ms;\n"])), function (props) { return (props.opened ? 1000 : -1); }, function (props) { return (props.opened ? 1 : 0); });
var PlayView = styled__default.default.div.withConfig({ displayName: "PlayView", componentId: "-1iigrsr" })(templateObject_14 || (templateObject_14 = _tslib.__makeTemplateObject(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"], ["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"])));
var ContentContainer$1 = styled__default.default.div.withConfig({ displayName: "ContentContainer", componentId: "-1c0wx7g" })(templateObject_15 || (templateObject_15 = _tslib.__makeTemplateObject(["\n  position: relative;\n  z-index: 10;\n\n  @media ", ", ", " {\n    text-align: center;\n  }\n"], ["\n  position: relative;\n  z-index: 10;\n\n  @media ", ", ", " {\n    text-align: center;\n  }\n"])), ResponsiveSizes.media.tablet, ResponsiveSizes.media.mobile);
var Background$1 = styled__default.default.div.withConfig({ shouldForwardProp: Spacing.isPropValid })(templateObject_16 || (templateObject_16 = _tslib.__makeTemplateObject(["\n  background-color: ", ";\n  overflow: hidden;\n  ", "\n\n  padding: 48px 0;\n\n  @media ", " {\n    padding: 80px 0;\n    ", "\n  }\n"], ["\n  background-color: ", ";\n  overflow: hidden;\n  ", "\n\n  padding: 48px 0;\n\n  @media ", " {\n    padding: 80px 0;\n    ", "\n  }\n"])), function (_a) {
    var backgroundcolor = _a.backgroundcolor;
    return backgroundcolor;
}, function (_a) {
    var fullheight = _a.fullheight;
    return fullheight &&
        "\n    height: auto;\n    display: flex;\n    align-items: center;\n    padding: 0;\n\n    @media ".concat(ResponsiveSizes.desktop, " {\n     height: calc(-64px + 100vh);\n    }\n  ");
}, ResponsiveSizes.desktop, function (_a) {
    var fullheight = _a.fullheight;
    return fullheight &&
        "\n    padding: 0;\n  ";
});
var templateObject_1$h, templateObject_2$d, templateObject_3$b, templateObject_4$7, templateObject_5$5, templateObject_6$5, templateObject_7$3, templateObject_8$3, templateObject_9$3, templateObject_10$3, templateObject_11$3, templateObject_12$1, templateObject_13, templateObject_14, templateObject_15, templateObject_16;

var DesktopImage = styled__default.default.div.withConfig({ displayName: "DesktopImage", componentId: "-14qalnc" })(templateObject_1$g || (templateObject_1$g = _tslib.__makeTemplateObject(["\n  display: none;\n\n  @media ", " {\n    display: block;\n  }\n"], ["\n  display: none;\n\n  @media ", " {\n    display: block;\n  }\n"])), ResponsiveSizes.desktop);
var MobileImage = styled__default.default.div.withConfig({ displayName: "MobileImage", componentId: "-9hetlg" })(templateObject_2$c || (templateObject_2$c = _tslib.__makeTemplateObject(["\n  display: block;\n\n  @media ", " {\n    display: none;\n  }\n"], ["\n  display: block;\n\n  @media ", " {\n    display: none;\n  }\n"])), ResponsiveSizes.desktop);
var templateObject_1$g, templateObject_2$c;

var HeadingWithImage = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, tagline = _a.tagline, background = _a.background, images = _a.images, disclaimer = _a.disclaimer, callToAction = _a.callToAction, secondaryCallToAction = _a.secondaryCallToAction, sublabel = _a.sublabel, align = _a.align, props = _tslib.__rest(_a, ["title", "subtitle", "tagline", "background", "images", "disclaimer", "callToAction", "secondaryCallToAction", "sublabel", "align"]);
    var hasImages = (images === null || images === void 0 ? void 0 : images.desktop) || (images === null || images === void 0 ? void 0 : images.mobile);
    var hasOnlyMobileImage = !(images === null || images === void 0 ? void 0 : images.desktop) && (images === null || images === void 0 ? void 0 : images.mobile);
    return (React__namespace.createElement(SectionContainer, _tslib.__assign({ background: background }, props),
        React__namespace.createElement(Container$8, null,
            React__namespace.createElement(Heading, null,
                tagline && (React__namespace.createElement(Spacing.Spacing, { bottom: 2 },
                    React__namespace.createElement(Hyperlink.Text, { type: "tagline", align: "center" },
                        React__namespace.createElement("p", null, tagline)))),
                React__namespace.createElement(Hyperlink.Text, { type: "heading_large", useCompact: true, align: "center" },
                    React__namespace.createElement("h3", null, title)),
                subtitle && (React__namespace.createElement(Spacing.Spacing, { top: 3 },
                    React__namespace.createElement(Hyperlink.Text, { type: "body", useCompact: true, align: "center" },
                        React__namespace.createElement("h3", null, subtitle))))),
            hasImages && (React__namespace.createElement(ImageContainer$3, null, hasOnlyMobileImage ? (images === null || images === void 0 ? void 0 : images.mobile) : (React__namespace.createElement(React__namespace.Fragment, null,
                (images === null || images === void 0 ? void 0 : images.desktop) && React__namespace.createElement(DesktopImage, null, images === null || images === void 0 ? void 0 : images.desktop),
                (images === null || images === void 0 ? void 0 : images.mobile) && React__namespace.createElement(MobileImage, null, images === null || images === void 0 ? void 0 : images.mobile))))),
            React__namespace.createElement(SectionFooter, { disclaimer: disclaimer, callToAction: callToAction, secondaryCallToAction: secondaryCallToAction, sublabel: sublabel, align: align }))));
};
var Heading = styled__default.default.div.withConfig({ displayName: "Heading", componentId: "-1ja04cf" })(templateObject_1$f || (templateObject_1$f = _tslib.__makeTemplateObject(["\n  margin: 0 auto 16px;\n  max-width: 552px;\n"], ["\n  margin: 0 auto 16px;\n  max-width: 552px;\n"])));
var Container$8 = styled__default.default.div.withConfig({ displayName: "Container", componentId: "-b1ufuc" })(templateObject_2$b || (templateObject_2$b = _tslib.__makeTemplateObject(["\n  margin: 56px auto;\n  flex: 1;\n  max-width: 1096px;\n  width: 100%;\n\n  @media ", " {\n    margin: 80px auto;\n  }\n\n  @media ", " {\n    max-width: 1128px;\n  }\n"], ["\n  margin: 56px auto;\n  flex: 1;\n  max-width: 1096px;\n  width: 100%;\n\n  @media ", " {\n    margin: 80px auto;\n  }\n\n  @media ", " {\n    max-width: 1128px;\n  }\n"])), ResponsiveSizes.desktop, ResponsiveSizes.desktopLarge);
var ImageContainer$3 = styled__default.default.div.withConfig({ displayName: "ImageContainer", componentId: "-pve2pq" })(templateObject_3$a || (templateObject_3$a = _tslib.__makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 24px;\n  width: 100%;\n\n  & img {\n    width: 100%;\n  }\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 24px;\n  width: 100%;\n\n  & img {\n    width: 100%;\n  }\n"])));
var templateObject_1$f, templateObject_2$b, templateObject_3$a;

var Column = function (_a) {
    var height = _a.height, enabled = _a.enabled, children = _a.children;
    return (React__namespace.createElement(StyledColumn, { height: height, enabled: enabled }, enabled && children));
};
var StyledColumn = styled__default.default.div.withConfig({ shouldForwardProp: Spacing.isPropValid })(templateObject_1$e || (templateObject_1$e = _tslib.__makeTemplateObject(["\n  box-sizing: border-box;\n  flex: 1;\n  background-color: ", ";\n  border-radius: ", "px;\n  border: ", ";\n  height: ", "px;\n  position: relative;\n"], ["\n  box-sizing: border-box;\n  flex: 1;\n  background-color: ", ";\n  border-radius: ", "px;\n  border: ", ";\n  height: ", "px;\n  position: relative;\n"])), function (_a) {
    var enabled = _a.enabled;
    return (enabled ? styles.themeColors.indigo[20] : styles.backgrounds.white);
}, styles.themeBorder.radius.default, styles.themeBorder.default, function (_a) {
    var height = _a.height;
    return height;
});
var templateObject_1$e;

var desktopIllustrationStyles = {
    position: 'absolute',
    bottom: 0,
    left: '50%',
    transform: 'translateX(-50%)',
};
var mobileIllustrationStyles = {
    position: 'absolute',
    bottom: 0,
    right: 0,
};
var getInitialFeatures = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.bandwidthSharingRate, bandwidthSharingRate = _c === void 0 ? '30' : _c, _d = _b.referralBonusRate, referralBonusRate = _d === void 0 ? '$5' : _d;
    return [
        {
            key: 'bandwidthSharing',
            illustration: React__namespace.createElement(HoneygainLogoSdk.BandwidthSharing, { height: "189px", style: desktopIllustrationStyles }),
            mobileIllustration: React__namespace.createElement(HoneygainLogoSdk.BandwidthSharingNarrow, { height: "170px", style: mobileIllustrationStyles }),
            heading: 'Bandwidth sharing',
            subheading: bandwidthSharingRate,
            label: 'cents/GB',
            body: 'Bandwidth sharing is the main way to make passive income with our app. Download the app and start sharing your unused internet! There is no daily limit on how much you can share (and earn!).',
            enabled: true,
        },
        {
            key: 'luckyPot',
            illustration: React__namespace.createElement(HoneygainLogoSdk.LuckyPot, { height: "184px", style: desktopIllustrationStyles }),
            mobileIllustration: React__namespace.createElement(HoneygainLogoSdk.LuckyPotNarrow, { height: "173px", style: mobileIllustrationStyles }),
            heading: 'Daily task',
            subheading: '+100 000',
            label: 'credits',
            body: 'Earn credits* every day by completing a simple task! Just share 15MB of traffic daily to start accumulating rewards! (*shown maximum potential earnings)',
            enabled: true,
        },
        {
            key: 'referrals',
            illustration: React__namespace.createElement(HoneygainLogoSdk.Referrals, { height: "250px", style: desktopIllustrationStyles }),
            mobileIllustration: React__namespace.createElement(HoneygainLogoSdk.ReferralsNarrow, { height: "218px", style: mobileIllustrationStyles }),
            heading: 'Referrals',
            subheading: "+".concat(referralBonusRate),
            label: '',
            body: "Invite your friends to join Honeygain and collect $5 every time they progress to the $20 payout threshold. More referrals means more money for you!",
            enabled: true,
        },
        {
            key: 'achievements',
            illustration: React__namespace.createElement(HoneygainLogoSdk.Achievements, { height: "274px", style: desktopIllustrationStyles }),
            mobileIllustration: React__namespace.createElement(HoneygainLogoSdk.AchievementsNarrow, { height: "247px", style: mobileIllustrationStyles }),
            heading: 'Achievements',
            subheading: '+500',
            label: 'credits',
            body: 'Unlock various Achievements and claim your rewards! Complete different tasks and redeem credits.',
            enabled: true,
        },
        {
            key: 'contentDelivery',
            illustration: React__namespace.createElement(HoneygainLogoSdk.ContentDelivery, { height: "312px", style: desktopIllustrationStyles }),
            mobileIllustration: React__namespace.createElement(HoneygainLogoSdk.ContentDeliveryNarrow, { height: "286px", style: mobileIllustrationStyles }),
            heading: 'Content Delivery',
            subheading: '+144',
            label: 'credits/24 hrs',
            body: 'Choose Content Delivery to make money by the hour. It’s bandwidth-intensive and we have limited places available!',
            enabled: true,
        },
    ];
};
var MOBILE_COLUMN_BASE_HEIGHT = 90;
var MOBILE_COLUMN_HEIGHT_RATE = 50;
var DESKTOP_COLUMN_BASE_HEIGHT = 110;
var DESKTOP_COLUMN_HEIGHT_RATE = 42;
var BASE_GAP = 16;
var STICKY_TOP_OFFSET = 8;
var getCardOffset = function (numberOfCards, index) { return BASE_GAP * (numberOfCards - 1) - BASE_GAP * index; };
var isFirstCard = function (index) { return index === 0; };
var getLargestCardHeight = function (height, element) {
    var _a, _b, _c;
    if (((_a = element.current) === null || _a === void 0 ? void 0 : _a.clientHeight) && ((_b = element.current) === null || _b === void 0 ? void 0 : _b.clientHeight) > height) {
        return (_c = element.current) === null || _c === void 0 ? void 0 : _c.clientHeight;
    }
    return height;
};
var Calculator = function (_a) {
    var _b, _c;
    var _d = _a.customStickyTopOffset, customStickyTopOffset = _d === void 0 ? 0 : _d, bandwidthSharingRate = _a.bandwidthSharingRate, referralBonusRate = _a.referralBonusRate, translations = _a.translations, title = _a.title;
    var _e = _tslib.__read(React__namespace.useState(getInitialFeatures({ bandwidthSharingRate: bandwidthSharingRate, referralBonusRate: referralBonusRate })), 2), features = _e[0], setFeatures = _e[1];
    var isDesktop = UseSize.useSizes().isDesktop;
    var columnsRef = React__namespace.useRef(null);
    var cardRefs = React__namespace.useRef(features.map(function () { return React__namespace.createRef(); }));
    var columnsHeight = (_c = (_b = columnsRef === null || columnsRef === void 0 ? void 0 : columnsRef.current) === null || _b === void 0 ? void 0 : _b.clientHeight) !== null && _c !== void 0 ? _c : 0;
    var largestCardHeight = cardRefs.current.reduce(getLargestCardHeight, 0);
    var stickyTopOffset = STICKY_TOP_OFFSET + customStickyTopOffset;
    var onSwitch = function (index, enabled) {
        setFeatures(function (prevState) {
            prevState.splice(index, 1, _tslib.__assign(_tslib.__assign({}, prevState[index]), { enabled: enabled }));
            return _tslib.__spreadArray([], _tslib.__read(prevState), false);
        });
    };
    return (React__namespace.createElement(Container$7, { flexDir: "column", flex: 1, gap: { default: '16px', desktop: '32px' } },
        React__namespace.createElement(Spacing.Spacing, { bottom: 1 },
            React__namespace.createElement(Hyperlink.Text, { type: "heading_large", align: "center" },
                React__namespace.createElement("span", null, title !== null && title !== void 0 ? title : 'Easy ways to maximise your earnings'))),
        React__namespace.createElement(GridContainer$1, null,
            React__namespace.createElement(CalculatorHead, { stickyTopOffset: stickyTopOffset, largestCardHeight: largestCardHeight, features: features, columnsRef: columnsRef }),
            features.map(function (props, index) { return (React__namespace.createElement(StickyCard, _tslib.__assign({ translations: translations ? translations[props.key] : undefined }, props, { key: props.key, ref: cardRefs.current[index], watchIntersection: !isDesktop && !isFirstCard(index), onSwitch: function (value) { return onSwitch(index, value); }, height: largestCardHeight !== 0 ? largestCardHeight : undefined, stickyOffset: columnsHeight + BASE_GAP + stickyTopOffset + index * BASE_GAP, topOffset: getCardOffset(features.length, index) + (isFirstCard(index) ? largestCardHeight : 0), bottomOffset: getCardOffset(features.length, index), large: isFirstCard(index) }))); }))));
};
var CalculatorHead = function (props) {
    var isDesktop = UseSize.useSizes().isDesktop;
    var columnBaseHeight = isDesktop ? DESKTOP_COLUMN_BASE_HEIGHT : MOBILE_COLUMN_BASE_HEIGHT;
    var columnHeightRate = isDesktop ? DESKTOP_COLUMN_HEIGHT_RATE : MOBILE_COLUMN_HEIGHT_RATE;
    return (React__namespace.createElement(Columns, { stickyTopOffset: props.stickyTopOffset, cardsOffset: props.largestCardHeight + props.features.length * BASE_GAP, ref: props.columnsRef, align: "end", flexDir: "row", gap: { default: '16px', desktop: '24px' } }, props.features.map(function (feature, index) { return (
    // eslint-disable-next-line security/detect-object-injection
    React__namespace.createElement(Column, { height: columnBaseHeight + columnHeightRate * index, enabled: feature.enabled, key: feature.heading }, isDesktop ? feature.illustration : feature.mobileIllustration)); })));
};
var Container$7 = styled__default.default(Spacing.Flex).withConfig({ displayName: "Container", componentId: "-c8ydaa" })(templateObject_1$d || (templateObject_1$d = _tslib.__makeTemplateObject(["\n  box-sizing: border-box;\n  padding: 0 24px;\n  margin: 56px auto;\n  max-width: 1096px;\n  width: 100%;\n\n  @media ", " {\n    position: unset;\n    margin: 80px auto;\n  }\n\n  @media ", " {\n    max-width: 1128px;\n  }\n"], ["\n  box-sizing: border-box;\n  padding: 0 24px;\n  margin: 56px auto;\n  max-width: 1096px;\n  width: 100%;\n\n  @media ", " {\n    position: unset;\n    margin: 80px auto;\n  }\n\n  @media ", " {\n    max-width: 1128px;\n  }\n"])), ResponsiveSizes.desktop, ResponsiveSizes.desktopLarge);
var GridContainer$1 = styled__default.default.div.withConfig({ displayName: "GridContainer", componentId: "-1bi0twr" })(templateObject_2$a || (templateObject_2$a = _tslib.__makeTemplateObject(["\n  @media ", " {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    gap: 16px;\n  }\n"], ["\n  @media ", " {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    gap: 16px;\n  }\n"])), ResponsiveSizes.desktop);
var Columns = styled__default.default(Spacing.Flex).withConfig({ displayName: "Columns", componentId: "-1qk6tqv" })(templateObject_3$9 || (templateObject_3$9 = _tslib.__makeTemplateObject(["\n  position: sticky;\n  top: ", "px;\n  margin-bottom: ", "px;\n\n  @media ", " {\n    grid-column-end: span 3;\n    position: unset;\n    margin: 0;\n  }\n"], ["\n  position: sticky;\n  top: ", "px;\n  margin-bottom: ", "px;\n\n  @media ", " {\n    grid-column-end: span 3;\n    position: unset;\n    margin: 0;\n  }\n"])), function (_a) {
    var stickyTopOffset = _a.stickyTopOffset;
    return stickyTopOffset;
}, function (_a) {
    var cardsOffset = _a.cardsOffset;
    return cardsOffset;
}, ResponsiveSizes.desktop);
var StickyCard = styled__default.default(CardToggle).withConfig({ displayName: "StickyCard", componentId: "-95t4bx" })(templateObject_4$6 || (templateObject_4$6 = _tslib.__makeTemplateObject(["\n  position: sticky;\n  height: ", "px;\n  top: ", "px;\n  margin-top: ", "px;\n  margin-bottom: ", "px;\n\n  @media ", " {\n    height: unset;\n    position: unset;\n    top: unset;\n    margin: 0;\n    grid-row-end: ", ";\n  }\n"], ["\n  position: sticky;\n  height: ", "px;\n  top: ", "px;\n  margin-top: ", "px;\n  margin-bottom: ", "px;\n\n  @media ", " {\n    height: unset;\n    position: unset;\n    top: unset;\n    margin: 0;\n    grid-row-end: ", ";\n  }\n"])), function (_a) {
    var height = _a.height;
    return height;
}, function (_a) {
    var stickyOffset = _a.stickyOffset;
    return stickyOffset;
}, function (_a) {
    var topOffset = _a.topOffset;
    return -topOffset;
}, function (_a) {
    var bottomOffset = _a.bottomOffset;
    return bottomOffset;
}, ResponsiveSizes.desktop, function (_a) {
    var large = _a.large;
    return (large ? 'span 2' : 'span 1');
});
var templateObject_1$d, templateObject_2$a, templateObject_3$9, templateObject_4$6;

var TopBar = function (_a) {
    var label = _a.label, honeygainLogo = _a.honeygainLogo, trustpilot = _a.trustpilot;
    return (React__namespace.createElement(Spacing.Flex, { flexDir: { default: 'column', desktop: 'row' }, align: "center", gap: { default: '16px', desktop: '24px' } },
        label && React__namespace.createElement(Pill, { text: label }),
        honeygainLogo && (React__namespace.createElement(Pill, { text: "PRODUCT BY", iconSide: "right", icon: "honeygain", size: "medium", iconSize: { width: 104, height: 18 } })),
        trustpilot && (React__namespace.createElement(TrustpilotContainer, null,
            React__namespace.createElement(TrustpilotMicroStar, { width: "auto", height: "18px" })))));
};
var TrustpilotContainer = styled__default.default.div.withConfig({ displayName: "TrustpilotContainer", componentId: "-1xtbk74" })(templateObject_1$c || (templateObject_1$c = _tslib.__makeTemplateObject(["\n  width: 100%;\n  max-width: 283px;\n  margin-left: -14px;\n\n  @media ", " {\n    overflow: hidden;\n    max-width: 580px;\n  }\n"], ["\n  width: 100%;\n  max-width: 283px;\n  margin-left: -14px;\n\n  @media ", " {\n    overflow: hidden;\n    max-width: 580px;\n  }\n"])), ResponsiveSizes.desktop);
var templateObject_1$c;

var InfoWithBulletPoints = function (_a) {
    var reverse = _a.reverse, label = _a.label, honeygainLogo = _a.honeygainLogo, trustpilot = _a.trustpilot, title = _a.title, background = _a.background, image = _a.image, callToAction = _a.callToAction, sublabel = _a.sublabel, points = _a.points, props = _tslib.__rest(_a, ["reverse", "label", "honeygainLogo", "trustpilot", "title", "background", "image", "callToAction", "sublabel", "points"]);
    return (React__namespace.createElement(SectionContainer, _tslib.__assign({ background: background }, props),
        React__namespace.createElement(Container$6, { flex: 1, flexDir: { default: 'column', desktop: reverse ? 'row-reverse' : 'row' }, gap: "24px", align: "center" },
            React__namespace.createElement(Spacing.Flex, { flex: 2 }, image),
            React__namespace.createElement(Spacing.Flex, { flex: 3, flexDir: "column", gap: "16px" },
                React__namespace.createElement(Spacing.Flex, { flexDir: "column", gap: "24px" },
                    React__namespace.createElement(TopBar, { label: label, honeygainLogo: honeygainLogo, trustpilot: trustpilot }),
                    React__namespace.createElement(Hyperlink.Text, { type: "heading_large", useCompact: true },
                        React__namespace.createElement("h3", null, title)),
                    React__namespace.createElement(BulletPoints, null, points.map(function (point, index) { return (React__namespace.createElement(Spacing.Flex, { key: index, gap: "16px" },
                        React__namespace.createElement(StyledAchievementStar, null),
                        React__namespace.createElement(Hyperlink.Text, { type: "body", useCompact: true, color: styles.themeColors.gray[80] },
                            React__namespace.createElement("span", null, point)))); }))),
                React__namespace.createElement(SectionFooter, { callToAction: callToAction, sublabel: sublabel, align: "left" })))));
};
var Container$6 = styled__default.default(Spacing.Flex).withConfig({ displayName: "Container", componentId: "-1xygfvm" })(templateObject_1$b || (templateObject_1$b = _tslib.__makeTemplateObject(["\n  margin: 0 auto;\n  padding: 56px 0;\n  max-width: 1096px;\n  width: 100%;\n\n  @media ", " {\n    padding: 80px 0;\n  }\n\n  @media ", " {\n    max-width: 1128px;\n  }\n"], ["\n  margin: 0 auto;\n  padding: 56px 0;\n  max-width: 1096px;\n  width: 100%;\n\n  @media ", " {\n    padding: 80px 0;\n  }\n\n  @media ", " {\n    max-width: 1128px;\n  }\n"])), ResponsiveSizes.desktop, ResponsiveSizes.desktopLarge);
var BulletPoints = styled__default.default.ul.withConfig({ displayName: "BulletPoints", componentId: "-gx5pfm" })(templateObject_2$9 || (templateObject_2$9 = _tslib.__makeTemplateObject(["\n  padding: 0;\n  margin: 0;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n"], ["\n  padding: 0;\n  margin: 0;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n"])));
var StyledAchievementStar = styled__default.default(AchievementStar.AchievementStar).withConfig({ displayName: "StyledAchievementStar", componentId: "-cu6sit" })(templateObject_3$8 || (templateObject_3$8 = _tslib.__makeTemplateObject(["\n  min-height: 24px;\n  min-width: 24px;\n"], ["\n  min-height: 24px;\n  min-width: 24px;\n"])));
var templateObject_1$b, templateObject_2$9, templateObject_3$8;

var VideoCard = function (_a) {
    var image = _a.image, onClick = _a.onClick, props = _tslib.__rest(_a, ["image", "onClick"]);
    var _b = _tslib.__read(React__namespace.useState(false), 2), isHovering = _b[0], setIsHovering = _b[1];
    var _c = _tslib.__read(React__namespace.useState(false), 2), isActive = _c[0], setIsActive = _c[1];
    return (React__namespace.createElement(Card, _tslib.__assign({}, props, { onMouseEnter: function () { return setIsHovering(true); }, onMouseLeave: function () { return setIsHovering(false); }, onTouchStart: function () { return setIsActive(true); }, onTouchEnd: function () { return setIsActive(false); }, onClick: onClick }),
        React__namespace.createElement(ImageContainer$2, null, image),
        React__namespace.createElement(ButtonContainer, null,
            React__namespace.createElement(PlayButton, { isActive: isActive, isHovering: isHovering, width: 72, height: 72 }))));
};
var Card = styled__default.default(CardBase).withConfig({ displayName: "Card", componentId: "-5liqi7" })(templateObject_1$a || (templateObject_1$a = _tslib.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  min-width: 200px;\n  overflow: hidden;\n  position: relative;\n  cursor: pointer;\n  user-select: none;\n"], ["\n  display: flex;\n  flex-direction: column;\n  min-width: 200px;\n  overflow: hidden;\n  position: relative;\n  cursor: pointer;\n  user-select: none;\n"])));
var ImageContainer$2 = styled__default.default.div.withConfig({ displayName: "ImageContainer", componentId: "-1gftgtg" })(templateObject_2$8 || (templateObject_2$8 = _tslib.__makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n\n  & img {\n    width: 100%;\n    height: auto;\n    object-fit: cover;\n    object-position: center;\n  }\n"], ["\n  display: flex;\n  justify-content: center;\n\n  & img {\n    width: 100%;\n    height: auto;\n    object-fit: cover;\n    object-position: center;\n  }\n"])));
var ButtonContainer = styled__default.default.div.withConfig({ displayName: "ButtonContainer", componentId: "-17o9o98" })(templateObject_3$7 || (templateObject_3$7 = _tslib.__makeTemplateObject(["\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));
var templateObject_1$a, templateObject_2$8, templateObject_3$7;

var CARD_SIZE = 258;
var CARD_SPACING = 24;
var InfoWithVideoGallery = function (_a) {
    var title = _a.title, paragraph = _a.paragraph, tagline = _a.tagline, sublabel = _a.sublabel, callToAction = _a.callToAction, background = _a.background, children = _a.children, videos = _a.videos, props = _tslib.__rest(_a, ["title", "paragraph", "tagline", "sublabel", "callToAction", "background", "children", "videos"]);
    var isDesktop = UseSize.useSizes().isDesktop;
    var _b = _tslib.__read(React__namespace.useState(), 2), videoUrl = _b[0], setVideoUrl = _b[1];
    var _c = _tslib.__read(React__namespace.useState(false), 2), isPortrait = _c[0], setIsPortrait = _c[1];
    var handleCloseVideo = function () {
        setVideoUrl(null);
        setIsPortrait(false);
    };
    var slideCount = React__namespace.Children.count(children);
    var showArrows = isDesktop && slideCount > 2;
    var _d = hooks_index.useGallerySwiper({
        cardSize: CARD_SIZE,
        cardSpacing: CARD_SPACING,
        slideCount: slideCount,
    }), canSwipeLeft = _d.canSwipeLeft, canSwipeRight = _d.canSwipeRight, swipeLeft = _d.swipeLeft, swipeRight = _d.swipeRight, swiperEvents = _d.swiperEvents;
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement(Section$2, _tslib.__assign({ background: background }, props),
            React__namespace.createElement(Container$5, null,
                showArrows && (React__namespace.createElement(Arrows, null,
                    React__namespace.createElement(ButtonArrow, { side: "left", onClick: swipeLeft, disabled: canSwipeLeft }),
                    React__namespace.createElement(ButtonArrow, { side: "right", onClick: swipeRight, disabled: canSwipeRight }))),
                React__namespace.createElement(Info, null,
                    tagline && (React__namespace.createElement(Spacing.Spacing, { bottom: 2 },
                        React__namespace.createElement(Hyperlink.Text, { type: "tagline" },
                            React__namespace.createElement("p", null, tagline)))),
                    React__namespace.createElement(Title, { type: "heading_large", useCompact: true },
                        React__namespace.createElement("h3", null, title)),
                    React__namespace.createElement(Paragraph, { type: "body", color: styles.themeColors.gray[90], useCompact: true },
                        React__namespace.createElement("div", null, paragraph))),
                React__namespace.createElement(Cards, null,
                    React__namespace.createElement(SwiperContainer, null,
                        React__namespace.createElement(Swiper, _tslib.__assign({ slidesPerView: "auto", slidesPerGroup: 1, spaceBetween: CARD_SPACING, freeMode: true, mousewheel: { forceToAxis: true }, modules: [freeMode, Mousewheel] }, swiperEvents),
                            videos.map(function (video, index) {
                                var _a;
                                return (React__namespace.createElement(Slide, { key: index },
                                    React__namespace.createElement(VideoCard, { image: React__namespace.createElement("img", { src: (_a = video === null || video === void 0 ? void 0 : video.placeholderUrl) !== null && _a !== void 0 ? _a : null }), onClick: function () {
                                            var _a;
                                            setVideoUrl(video.videoUrl);
                                            setIsPortrait((_a = video.isPortrait) !== null && _a !== void 0 ? _a : false);
                                        } })));
                            }),
                            React__namespace.createElement(Spacer, null)))),
                React__namespace.createElement(CallToActionSection, null,
                    callToAction && (React__namespace.createElement(LinkButton, { href: callToAction.url, target: callToAction.target, rel: callToAction.rel, className: callToAction.className, type: "primary", fullWidth: { default: true, desktop: false } },
                        React__namespace.createElement(Hyperlink.Text, { type: "label", color: styles.themeColors.white },
                            React__namespace.createElement("span", null, callToAction.text)))),
                    sublabel && React__namespace.createElement(StyledSublabel, null, sublabel)))),
        React__namespace.createElement(VideoOverlay$2, { isOpen: !!videoUrl, videoUrl: videoUrl !== null && videoUrl !== void 0 ? videoUrl : '', isPortrait: isPortrait, onClose: handleCloseVideo })));
};
var Section$2 = styled__default.default(SectionContainer).withConfig({ displayName: "Section", componentId: "-wrfj2i" })(templateObject_1$9 || (templateObject_1$9 = _tslib.__makeTemplateObject(["\n  overflow: hidden;\n"], ["\n  overflow: hidden;\n"])));
var Container$5 = styled__default.default.div.withConfig({ displayName: "Container", componentId: "-93zkwd" })(templateObject_2$7 || (templateObject_2$7 = _tslib.__makeTemplateObject(["\n  margin: 0 auto;\n  padding: 56px 0;\n  max-width: 1096px;\n  width: 100%;\n  --card-size: ", "px;\n  --card-spacing: ", "px;\n\n  display: grid;\n  grid-template-areas:\n    'info'\n    'arrows'\n    'cards'\n    'cta';\n  grid-template-columns: 100%;\n\n  @media ", " {\n    grid-template-areas:\n      'arrows arrows'\n      'info cards'\n      'cta cards';\n\n    padding: 80px 0;\n\n    grid-template-columns: 50% 50%;\n    grid-template-rows: auto auto 1fr;\n    padding-right: calc(-3 * var(--card-size) + var(--card-spacing));\n  }\n\n  @media ", " {\n    max-width: 1128px;\n  }\n"], ["\n  margin: 0 auto;\n  padding: 56px 0;\n  max-width: 1096px;\n  width: 100%;\n  --card-size: ", "px;\n  --card-spacing: ", "px;\n\n  display: grid;\n  grid-template-areas:\n    'info'\n    'arrows'\n    'cards'\n    'cta';\n  grid-template-columns: 100%;\n\n  @media ", " {\n    grid-template-areas:\n      'arrows arrows'\n      'info cards'\n      'cta cards';\n\n    padding: 80px 0;\n\n    grid-template-columns: 50% 50%;\n    grid-template-rows: auto auto 1fr;\n    padding-right: calc(-3 * var(--card-size) + var(--card-spacing));\n  }\n\n  @media ", " {\n    max-width: 1128px;\n  }\n"])), CARD_SIZE, CARD_SPACING, ResponsiveSizes.desktop, ResponsiveSizes.desktopLarge);
var Title = styled__default.default(Hyperlink.Text).withConfig({ displayName: "Title", componentId: "-1nrk7bm" })(templateObject_3$6 || (templateObject_3$6 = _tslib.__makeTemplateObject(["\n  @media ", " {\n    margin-right: 80px;\n  }\n"], ["\n  @media ", " {\n    margin-right: 80px;\n  }\n"])), ResponsiveSizes.desktop);
var Paragraph = styled__default.default(Hyperlink.Text).withConfig({ displayName: "Paragraph", componentId: "-1ar64so" })(templateObject_4$5 || (templateObject_4$5 = _tslib.__makeTemplateObject(["\n  margin-top: 24px;\n\n  @media ", " {\n    margin-right: 80px;\n  }\n"], ["\n  margin-top: 24px;\n\n  @media ", " {\n    margin-right: 80px;\n  }\n"])), ResponsiveSizes.desktop);
var Info = styled__default.default.div.withConfig({ displayName: "Info", componentId: "-vhvl95" })(templateObject_5$4 || (templateObject_5$4 = _tslib.__makeTemplateObject(["\n  grid-area: info;\n"], ["\n  grid-area: info;\n"])));
var CallToActionSection = styled__default.default.div.withConfig({ displayName: "CallToActionSection", componentId: "-14f1es0" })(templateObject_6$4 || (templateObject_6$4 = _tslib.__makeTemplateObject(["\n  grid-area: cta;\n  margin-top: 40px;\n  align-self: end;\n\n  @media ", " {\n    margin: 48px 80px 0 0;\n  }\n"], ["\n  grid-area: cta;\n  margin-top: 40px;\n  align-self: end;\n\n  @media ", " {\n    margin: 48px 80px 0 0;\n  }\n"])), ResponsiveSizes.desktop);
var Cards = styled__default.default.div.withConfig({ displayName: "Cards", componentId: "-kdv2tb" })(templateObject_7$2 || (templateObject_7$2 = _tslib.__makeTemplateObject(["\n  grid-area: cards;\n  width: 100%;\n  margin-top: 40px;\n\n  @media ", " {\n    margin: 0 80px 0 0;\n  }\n"], ["\n  grid-area: cards;\n  width: 100%;\n  margin-top: 40px;\n\n  @media ", " {\n    margin: 0 80px 0 0;\n  }\n"])), ResponsiveSizes.desktop);
var Spacer = styled__default.default(SwiperSlide).withConfig({ displayName: "Spacer", componentId: "-1oa2hg0" })(templateObject_8$2 || (templateObject_8$2 = _tslib.__makeTemplateObject(["\n  && {\n    width: calc(3 * var(--card-size) - var(--card-spacing));\n    height: 1px;\n  }\n"], ["\n  && {\n    width: calc(3 * var(--card-size) - var(--card-spacing));\n    height: 1px;\n  }\n"])));
Spacer.displayName = 'SwiperSlide';
var SwiperContainer = styled__default.default.div.withConfig({ displayName: "SwiperContainer", componentId: "-1m5auhp" })(templateObject_9$2 || (templateObject_9$2 = _tslib.__makeTemplateObject(["\n  width: calc(100% + 3 * var(--card-size));\n  margin-right: calc(-3 * var(--card-size));\n"], ["\n  width: calc(100% + 3 * var(--card-size));\n  margin-right: calc(-3 * var(--card-size));\n"])));
var Slide = styled__default.default(SwiperSlide).withConfig({ displayName: "Slide", componentId: "-5ml7si" })(templateObject_10$2 || (templateObject_10$2 = _tslib.__makeTemplateObject(["\n  && {\n    display: flex;\n    flex-direction: row;\n    height: auto;\n    width: var(--card-size);\n  }\n"], ["\n  && {\n    display: flex;\n    flex-direction: row;\n    height: auto;\n    width: var(--card-size);\n  }\n"])));
Slide.displayName = 'SwiperSlide';
var Arrows = styled__default.default.div.withConfig({ displayName: "Arrows", componentId: "-11dt86k" })(templateObject_11$2 || (templateObject_11$2 = _tslib.__makeTemplateObject(["\n  grid-area: arrows;\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n  margin-bottom: 16px;\n  gap: 16px;\n"], ["\n  grid-area: arrows;\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n  margin-bottom: 16px;\n  gap: 16px;\n"])));
var StyledSublabel = styled__default.default(Sublabel).withConfig({ displayName: "StyledSublabel", componentId: "-zl3o7q" })(templateObject_12 || (templateObject_12 = _tslib.__makeTemplateObject(["\n  display: flex;\n  margin-top: 8px;\n\n  @media ", " {\n    justify-content: flex-start;\n  }\n"], ["\n  display: flex;\n  margin-top: 8px;\n\n  @media ", " {\n    justify-content: flex-start;\n  }\n"])), ResponsiveSizes.desktop);
var templateObject_1$9, templateObject_2$7, templateObject_3$6, templateObject_4$5, templateObject_5$4, templateObject_6$4, templateObject_7$2, templateObject_8$2, templateObject_9$2, templateObject_10$2, templateObject_11$2, templateObject_12;

var isLast = function (array, index) { return array.length === index + 1; };
var Stats = function (_a) {
    var background = _a.background, stats = _a.stats, props = _tslib.__rest(_a, ["background", "stats"]);
    return (React__namespace.createElement(SectionContainer, _tslib.__assign({ background: background }, props),
        React__namespace.createElement(Container$4, { vertical: 3 }, stats.map(function (props, index) { return (React__namespace.createElement(StyledCardFact, _tslib.__assign({}, props, { key: index, background: background, iconPosition: isLast(stats, index) ? 'right' : undefined }))); }))));
};
var Container$4 = styled__default.default(Spacing.Spacing).withConfig({ displayName: "Container", componentId: "-168zmu6" })(templateObject_1$8 || (templateObject_1$8 = _tslib.__makeTemplateObject(["\n  margin: 0 auto;\n  flex: 1;\n  max-width: 896px;\n  width: 100%;\n  display: grid;\n  gap: 24px;\n  grid-template-columns: 1fr 1fr;\n  grid-template-areas:\n    'first second'\n    'bottom bottom';\n\n  @media ", " {\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-template-areas: unset;\n  }\n"], ["\n  margin: 0 auto;\n  flex: 1;\n  max-width: 896px;\n  width: 100%;\n  display: grid;\n  gap: 24px;\n  grid-template-columns: 1fr 1fr;\n  grid-template-areas:\n    'first second'\n    'bottom bottom';\n\n  @media ", " {\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-template-areas: unset;\n  }\n"])), ResponsiveSizes.desktop);
var StyledCardFact = styled__default.default(CardFact).withConfig({ displayName: "StyledCardFact", componentId: "-hex56z" })(templateObject_2$6 || (templateObject_2$6 = _tslib.__makeTemplateObject(["\n  &:last-child {\n    grid-area: bottom;\n\n    @media ", " {\n      grid-area: unset;\n    }\n  }\n"], ["\n  &:last-child {\n    grid-area: bottom;\n\n    @media ", " {\n      grid-area: unset;\n    }\n  }\n"])), ResponsiveSizes.desktop);
var templateObject_1$8, templateObject_2$6;

var Statistics = function (_a) {
    var content = _a.content, background = _a.background;
    return (React__namespace.default.createElement(SectionContainer, { background: background },
        React__namespace.default.createElement(Container$3, null, content.map(function (val) {
            return (React__namespace.default.createElement(Statistic, { key: val.title },
                React__namespace.default.createElement(FullContentContainer, null,
                    val.imageUrl && (React__namespace.default.createElement(IconContainer, null,
                        React__namespace.default.createElement("img", { src: val.imageUrl }))),
                    React__namespace.default.createElement(ContentContainer, null, val.subtitle ? (React__namespace.default.createElement(React__namespace.default.Fragment, null,
                        React__namespace.default.createElement(Recurring, null,
                            React__namespace.default.createElement(Hyperlink.Text, { type: "heading_large", useCompact: true },
                                React__namespace.default.createElement("h4", null, val.title)),
                            React__namespace.default.createElement(Hyperlink.Text, { type: "body", useCompact: true, color: styles.themeColors.gray[60] },
                                React__namespace.default.createElement("span", null, val.subtitle))),
                        React__namespace.default.createElement(Hyperlink.Text, { type: "body", useCompact: true },
                            React__namespace.default.createElement("span", null, val.description)))) : (React__namespace.default.createElement(React__namespace.default.Fragment, null,
                        React__namespace.default.createElement(Hyperlink.Text, { type: "heading_large", useCompact: true },
                            React__namespace.default.createElement("h4", null, val.title)),
                        React__namespace.default.createElement(Hyperlink.Text, { type: "body", useCompact: true },
                            React__namespace.default.createElement("span", null, val.description))))))));
        }))));
};
var Container$3 = styled__default.default.div.withConfig({ displayName: "Container", componentId: "-83pjzd" })(templateObject_1$7 || (templateObject_1$7 = _tslib.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 64px 24px;\n  margin: 0 auto;\n  max-width: 1128px;\n\n  & > * + * {\n    margin-top: 84px;\n  }\n\n  @media ", " {\n    padding: 96px 24px;\n    flex-direction: row;\n    justify-content: space-around;\n\n    & > * + * {\n      margin-top: 0;\n      margin-left: 20px;\n    }\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 64px 24px;\n  margin: 0 auto;\n  max-width: 1128px;\n\n  & > * + * {\n    margin-top: 84px;\n  }\n\n  @media ", " {\n    padding: 96px 24px;\n    flex-direction: row;\n    justify-content: space-around;\n\n    & > * + * {\n      margin-top: 0;\n      margin-left: 20px;\n    }\n  }\n"])), ResponsiveSizes.desktop);
var Statistic = styled__default.default.div.withConfig({ displayName: "Statistic", componentId: "-1ly1bfx" })(templateObject_2$5 || (templateObject_2$5 = _tslib.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  min-width: 60vw;\n\n  @media ", " {\n    min-width: 15vw;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  min-width: 60vw;\n\n  @media ", " {\n    min-width: 15vw;\n  }\n"])), ResponsiveSizes.tablet);
var ContentContainer = styled__default.default.div.withConfig({ displayName: "ContentContainer", componentId: "-l759k5" })(templateObject_3$5 || (templateObject_3$5 = _tslib.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var FullContentContainer = styled__default.default.div.withConfig({ displayName: "FullContentContainer", componentId: "-17vzpzp" })(templateObject_4$4 || (templateObject_4$4 = _tslib.__makeTemplateObject(["\n  display: flex;\n  gap: 16px;\n"], ["\n  display: flex;\n  gap: 16px;\n"])));
var IconContainer = styled__default.default.div.withConfig({ displayName: "IconContainer", componentId: "-cpl4zw" })(templateObject_5$3 || (templateObject_5$3 = _tslib.__makeTemplateObject(["\n  img {\n    max-width: 61px;\n  }\n"], ["\n  img {\n    max-width: 61px;\n  }\n"])));
var Recurring = styled__default.default.div.withConfig({ displayName: "Recurring", componentId: "-10ddbjv" })(templateObject_6$3 || (templateObject_6$3 = _tslib.__makeTemplateObject(["\n  display: flex;\n  align-items: flex-end;\n\n  & > * + * {\n    margin-left: 3px;\n    margin-bottom: 3px;\n  }\n"], ["\n  display: flex;\n  align-items: flex-end;\n\n  & > * + * {\n    margin-left: 3px;\n    margin-bottom: 3px;\n  }\n"])));
var templateObject_1$7, templateObject_2$5, templateObject_3$5, templateObject_4$4, templateObject_5$3, templateObject_6$3;

var Testimonial = function (_a) {
    var review = _a.review, authorName = _a.authorName, authorTitle = _a.authorTitle, image = _a.image;
    return (React__namespace.createElement(StyledTestimonial, null,
        React__namespace.createElement(Spacing.Flex, { flexDir: { default: 'column', desktop: 'row' }, gap: "28px", align: { default: 'center', desktop: 'stretch' } },
            React__namespace.createElement(ImageBox, null,
                React__namespace.createElement(ImageContainer$1, null, image)),
            React__namespace.createElement(Spacing.Flex, { gap: "24px", flexDir: "column", justify: "space-between", align: "start" },
                React__namespace.createElement(Hyperlink.Text, { type: "body_medium_bold", useCompact: true, align: "left" },
                    React__namespace.createElement("span", null, review)),
                React__namespace.createElement("div", null,
                    React__namespace.createElement(Hyperlink.Text, { type: "body_medium_bold", useCompact: true, align: "left" },
                        React__namespace.createElement("span", null, authorName)),
                    React__namespace.createElement(Hyperlink.Text, { type: "subtitle", align: "left" },
                        React__namespace.createElement("span", null, authorTitle)))))));
};
var BORDER_SIZE = 2;
var PADDING_SIZE = 8;
var StyledTestimonial = styled__default.default.div.withConfig({ displayName: "StyledTestimonial", componentId: "-zmrpi3" })(templateObject_1$6 || (templateObject_1$6 = _tslib.__makeTemplateObject(["\n  ", ";\n  width: 100%;\n  padding: 24px 16px 16px;\n\n  @media ", " {\n    padding: 32px;\n  }\n"], ["\n  ", ";\n  width: 100%;\n  padding: 24px 16px 16px;\n\n  @media ", " {\n    padding: 32px;\n  }\n"])), CardBaseStyles, ResponsiveSizes.desktop);
var ImageBox = styled__default.default(CardBase).withConfig({ displayName: "ImageBox", componentId: "-ohtrws" })(templateObject_2$4 || (templateObject_2$4 = _tslib.__makeTemplateObject(["\n  box-shadow: ", "px ", "px 0 0 ", ";\n  border-radius: ", "px;\n  padding: ", "px;\n  background-color: ", ";\n  border: ", "px solid ", ";\n  flex-shrink: 0;\n  transform: translateY(-", "px);\n  box-sizing: content-box;\n  width: 138px;\n  height: 144px;\n\n  @media ", " {\n    transform: translate(-", "px, -", "px);\n    width: 148px;\n    height: 156px;\n  }\n"], ["\n  box-shadow: ", "px ", "px 0 0 ", ";\n  border-radius: ", "px;\n  padding: ", "px;\n  background-color: ", ";\n  border: ", "px solid ", ";\n  flex-shrink: 0;\n  transform: translateY(-", "px);\n  box-sizing: content-box;\n  width: 138px;\n  height: 144px;\n\n  @media ", " {\n    transform: translate(-", "px, -", "px);\n    width: 148px;\n    height: 156px;\n  }\n"])), BORDER_SIZE + PADDING_SIZE, BORDER_SIZE + PADDING_SIZE, styles.themeColors.gray[100], styles.themeBorder.radius.default, PADDING_SIZE, styles.themeColors.yellow[50], BORDER_SIZE, styles.themeColors.gray[100], BORDER_SIZE + PADDING_SIZE, ResponsiveSizes.desktop, BORDER_SIZE + PADDING_SIZE, BORDER_SIZE + PADDING_SIZE);
var ImageContainer$1 = styled__default.default.div.withConfig({ displayName: "ImageContainer", componentId: "-ql662m" })(templateObject_3$4 || (templateObject_3$4 = _tslib.__makeTemplateObject(["\n  border-radius: ", "px;\n  height: 100%;\n  width: 100%;\n"], ["\n  border-radius: ", "px;\n  height: 100%;\n  width: 100%;\n"])), styles.themeBorder.radius.default);
var templateObject_1$6, templateObject_2$4, templateObject_3$4;

var Testimonials = function (_a) {
    var title = _a.title, background = _a.background, tagline = _a.tagline, testimonials = _a.testimonials; _a.children; var props = _tslib.__rest(_a, ["title", "background", "tagline", "testimonials", "children"]);
    var isDesktop = UseSize.useSizes().isDesktop;
    var _b = _tslib.__read(React__namespace.useState(), 2), swiper = _b[0], setSwiper = _b[1];
    var slidesPerView = isDesktop ? 1 : 1.1;
    var shouldPaginate = testimonials.length > 1;
    var showArrows = isDesktop && shouldPaginate;
    var swipeLeft = function () { return swiper === null || swiper === void 0 ? void 0 : swiper.slidePrev(); };
    var swipeRight = function () { return swiper === null || swiper === void 0 ? void 0 : swiper.slideNext(); };
    return (React__namespace.createElement(Section$1, _tslib.__assign({ background: background }, props),
        React__namespace.createElement(Container$2, { flexDir: "column", align: "center", gap: "32px" },
            React__namespace.createElement(SectionHeading, { tagline: tagline, title: title }),
            React__namespace.createElement(TestimonialsContainer, null,
                showArrows && (React__namespace.createElement(React__namespace.Fragment, null,
                    React__namespace.createElement(LeftArrow, { side: "left", onClick: swipeLeft }),
                    React__namespace.createElement(RightArrow, { side: "right", onClick: swipeRight }))),
                React__namespace.createElement(SwiperContainer$3, { maxWidth: "730px" },
                    React__namespace.createElement(Swiper, { slidesPerView: slidesPerView, slidesPerGroup: 1, spaceBetween: 24, freeMode: !isDesktop, pagination: isDesktop && showArrows ? { clickable: true } : false, enabled: shouldPaginate, modules: [freeMode, Mousewheel, Pagination], mousewheel: { forceToAxis: true }, onSwiper: function (swiper) { return setSwiper(swiper); }, loop: isDesktop, className: "reviews-slider", updateOnWindowResize: true }, testimonials.map(function (testimonial, index) { return (React__namespace.createElement(SwiperSlide, { key: index, style: { display: 'flex' } },
                        React__namespace.createElement(Testimonial, { review: testimonial.review, authorName: testimonial.authorName, authorTitle: testimonial.authorTitle, image: testimonial.image }))); })))))));
};
var Section$1 = styled__default.default(SectionContainer).withConfig({ displayName: "Section", componentId: "-nrm3nr" })(templateObject_1$5 || (templateObject_1$5 = _tslib.__makeTemplateObject(["\n  overflow: hidden;\n"], ["\n  overflow: hidden;\n"])));
var Container$2 = styled__default.default(Spacing.Flex).withConfig({ displayName: "Container", componentId: "-4f8l08" })(templateObject_2$3 || (templateObject_2$3 = _tslib.__makeTemplateObject(["\n  margin: 56px auto;\n  max-width: 1096px;\n  padding-bottom: 24px;\n  width: 100%;\n\n  @media ", " {\n    padding-bottom: 0;\n    margin: 80px auto;\n  }\n\n  @media ", " {\n    max-width: 1128px;\n  }\n"], ["\n  margin: 56px auto;\n  max-width: 1096px;\n  padding-bottom: 24px;\n  width: 100%;\n\n  @media ", " {\n    padding-bottom: 0;\n    margin: 80px auto;\n  }\n\n  @media ", " {\n    max-width: 1128px;\n  }\n"])), ResponsiveSizes.desktop, ResponsiveSizes.desktopLarge);
var TestimonialsContainer = styled__default.default.div.withConfig({ displayName: "TestimonialsContainer", componentId: "-1c3je38" })(templateObject_3$3 || (templateObject_3$3 = _tslib.__makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  max-width: 858px;\n"], ["\n  position: relative;\n  width: 100%;\n  max-width: 858px;\n"])));
var StyledButtonArrow = styled__default.default(ButtonArrow).withConfig({ displayName: "StyledButtonArrow", componentId: "-1m9xhjd" })(templateObject_4$3 || (templateObject_4$3 = _tslib.__makeTemplateObject(["\n  position: absolute;\n  top: calc(50% - 32px);\n"], ["\n  position: absolute;\n  top: calc(50% - 32px);\n"])));
var LeftArrow = styled__default.default(StyledButtonArrow).withConfig({ displayName: "LeftArrow", componentId: "-dwx8ar" })(templateObject_5$2 || (templateObject_5$2 = _tslib.__makeTemplateObject(["\n  left: 0;\n"], ["\n  left: 0;\n"])));
var RightArrow = styled__default.default(StyledButtonArrow).withConfig({ displayName: "RightArrow", componentId: "-6oqlxg" })(templateObject_6$2 || (templateObject_6$2 = _tslib.__makeTemplateObject(["\n  right: 0;\n"], ["\n  right: 0;\n"])));
var templateObject_1$5, templateObject_2$3, templateObject_3$3, templateObject_4$3, templateObject_5$2, templateObject_6$2;

var Blob = function (props) { return (React__namespace.default.createElement("svg", _tslib.__assign({ width: "419", height: "402", viewBox: "0 0 419 402", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React__namespace.default.createElement("path", { d: "M8.37087 124.733L0.973755 275.063C1.10876 277.109 1.43563 279.134 1.93304 281.124C2.03252 281.522 2.1391 281.913 2.24569 282.296C2.46597 283.078 2.72178 283.838 2.9989 284.599C3.27603 285.352 3.58158 286.098 3.90844 286.823C7.58924 294.994 14.3184 301.404 22.6535 304.658L265.543 399.535C273.715 402.732 282.803 402.647 290.918 399.307C291.359 399.122 291.799 398.938 292.233 398.739C292.993 398.391 293.739 398.014 294.478 397.609C295.025 397.303 295.572 396.984 296.112 396.643C298.187 395.342 300.12 393.822 301.875 392.102C301.953 392.024 302.024 391.953 302.095 391.875C302.643 391.327 303.183 390.759 303.687 390.169C303.851 389.984 304 389.8 304.156 389.615C304.689 388.983 305.201 388.329 305.684 387.647L411.674 212.88C414.139 209.455 415.951 205.611 417.017 201.525C417.124 201.127 417.216 200.722 417.309 200.317C417.671 198.704 417.913 197.07 418.033 195.414C418.069 195.002 418.083 194.59 418.104 194.185C418.367 187.456 416.648 180.797 413.166 175.035L322.425 25.3584C321.693 24.1576 320.89 22.9993 320.023 21.905C319.59 21.3579 319.149 20.8249 318.68 20.3062C318.446 20.0433 318.218 19.7946 317.977 19.5459C317.501 19.0414 317.01 18.5582 316.506 18.0892C315.746 17.3786 314.964 16.7178 314.147 16.0783C312.513 14.8135 310.779 13.7049 308.945 12.7457C308.334 12.4259 307.716 12.1275 307.091 11.8503C306.465 11.5661 305.826 11.3103 305.179 11.0687C301.918 9.84651 298.479 9.12883 294.997 8.95118L142.684 0.971389C131.344 0.374503 120.209 4.24005 111.661 11.7224L22.9804 89.3886C15.7893 95.6843 10.9005 104.197 9.07434 113.584C8.91802 114.387 8.78301 115.204 8.66932 116.021C8.2785 118.906 8.17902 121.834 8.37087 124.74V124.726V124.733Z", fill: "#E4F3FE" }))); };

var vectorCss = styled.css(templateObject_1$4 || (templateObject_1$4 = _tslib.__makeTemplateObject(["\n  color: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  color: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), function (props) { var _a; return (_a = props.$color) !== null && _a !== void 0 ? _a : styles.themeColors.blue[10]; }, function (props) { var _a; return UseSize.getResponsiveProperty('position', (_a = props.$position) !== null && _a !== void 0 ? _a : 'absolute'); }, function (props) { return UseSize.getResponsiveProperty('top', props.$top); }, function (props) { return UseSize.getResponsiveProperty('right', props.$right); }, function (props) { return UseSize.getResponsiveProperty('bottom', props.$bottom); }, function (props) { return UseSize.getResponsiveProperty('left', props.$left); }, function (props) { return UseSize.getResponsiveProperty('transform', props.$transform); }, function (props) { return UseSize.getResponsiveProperty('width', props.$width); }, function (props) { return UseSize.getResponsiveProperty('height', props.$height); }, function (props) { return UseSize.getResponsiveProperty('display', props.$display); });
var templateObject_1$4;

var sharedImageProps = {
    $display: { default: 'none', largeDesktop: 'block' },
    $bottom: 0,
};
var sharedLeftImageProps = _tslib.__assign(_tslib.__assign({}, sharedImageProps), { $left: 0 });
var sharedRightImageProps = _tslib.__assign(_tslib.__assign({}, sharedImageProps), { $right: 0 });
var sharedMobileProps = {
    $width: '100%',
    $height: 'auto',
    $display: { default: 'block', largeDesktop: 'none' },
    $position: 'static',
};
var HeroCentered = function (_a) {
    var title = _a.title, titleMobile = _a.titleMobile, subtitle = _a.subtitle, subtitleMobile = _a.subtitleMobile, _b = _a.presentation, presentation = _b === void 0 ? 'trustpilot' : _b, tagline = _a.tagline, leftButton = _a.leftButton, rightButton = _a.rightButton, sublabel = _a.sublabel, sublabelIcon = _a.sublabelIcon, imageLeftUrl = _a.imageLeftUrl, imageRightUrl = _a.imageRightUrl, imageMobileUrl = _a.imageMobileUrl, imageOverLays = _a.imageOverLays, leftRightButtonsOverride = _a.leftRightButtonsOverride;
    return (React__namespace.default.createElement(Background, null,
        React__namespace.default.createElement(Polygon, { "$top": { default: '184px', largeDesktop: 'auto' }, "$bottom": { default: 'auto', largeDesktop: '50px' }, "$left": { default: '-50px', largeDesktop: '-100px' }, "$width": { default: '170px', largeDesktop: '400px' }, "$transform": { default: 'rotate(34deg)', desktop: 'rotate(28deg)' } }),
        React__namespace.default.createElement(Polygon, { "$top": { default: '-150px', largeDesktop: 'auto' }, "$bottom": { default: 'auto', largeDesktop: '0px' }, "$right": { default: '-50px', largeDesktop: '-120px' }, "$width": { default: '355px', largeDesktop: '417px' }, "$transform": { default: 'rotate(-152deg)', largeDesktop: 'rotate(-98deg)' } }),
        React__namespace.default.createElement(ShouldDisplay.ShouldDisplay, { display: { default: 'none', desktop: 'block' } }, imageOverLays ? (React__namespace.default.createElement(React__namespace.default.Fragment, null,
            React__namespace.default.createElement(ImageLeft, _tslib.__assign({ src: imageLeftUrl }, sharedLeftImageProps)),
            React__namespace.default.createElement(ImageLeft, _tslib.__assign({ src: imageOverLays.imageLeftOverlay }, sharedLeftImageProps)),
            React__namespace.default.createElement(ImageRight, _tslib.__assign({ src: imageRightUrl }, sharedRightImageProps)),
            React__namespace.default.createElement(ImageRight, _tslib.__assign({ src: imageOverLays.imageRightOverlay }, sharedRightImageProps)))) : (React__namespace.default.createElement(React__namespace.default.Fragment, null,
            React__namespace.default.createElement(ImageLeft, _tslib.__assign({ src: imageLeftUrl }, sharedLeftImageProps)),
            React__namespace.default.createElement(ImageRight, _tslib.__assign({ src: imageRightUrl }, sharedRightImageProps))))),
        React__namespace.default.createElement(Container$1, null,
            React__namespace.default.createElement(Hero, null,
                presentation === 'tagline' ? (React__namespace.default.createElement(Hyperlink.Text, { type: "tagline", align: "center" },
                    React__namespace.default.createElement("span", null, tagline))) : (React__namespace.default.createElement(ShouldDisplay.ClientOnly, null,
                    React__namespace.default.createElement(ShouldDisplay.ShouldDisplay, { display: { default: 'block', desktop: 'none' } },
                        React__namespace.default.createElement(TrustpilotMicroStar, null)),
                    React__namespace.default.createElement(ShouldDisplay.ShouldDisplay, { display: { default: 'none', desktop: 'block' } },
                        React__namespace.default.createElement(TrustpilotMicroCombo, null)))),
                React__namespace.default.createElement(Hyperlink.Text, { type: "heading_xlarge", useCompact: true, align: "center" },
                    React__namespace.default.createElement("h1", { className: "desktop_only" }, title),
                    React__namespace.default.createElement("h1", { className: "mobile_only" }, titleMobile || title)),
                React__namespace.default.createElement(Hyperlink.Text, { type: "body_large", useCompact: true, align: "center" },
                    React__namespace.default.createElement("p", { className: "desktop_only" }, subtitle),
                    React__namespace.default.createElement("p", { className: "mobile_only" }, subtitleMobile || subtitle)),
                React__namespace.default.createElement(Spacing.Spacing, { top: 3 }, leftRightButtonsOverride ? (leftRightButtonsOverride) : (React__namespace.default.createElement(Action, { align: "center", sublabelColor: "dark", leftButton: leftButton, rightButton: rightButton, sublabel: sublabel, sublabelIcon: sublabelIcon }))))),
        (imageOverLays === null || imageOverLays === void 0 ? void 0 : imageOverLays.imageTabletUrl) && (React__namespace.default.createElement(TabletContainer, null,
            React__namespace.default.createElement(ImageMobile, _tslib.__assign({ src: imageOverLays.imageTabletUrl, loading: "lazy" }, sharedMobileProps)),
            React__namespace.default.createElement(SharedOverlay, null,
                React__namespace.default.createElement(ImageMobile, _tslib.__assign({ src: imageOverLays.imageMobileOverlay, loading: "lazy" }, sharedMobileProps))))),
        React__namespace.default.createElement(ShouldDisplay.ShouldDisplay, { display: { default: 'block', desktop: 'none' } }, (imageOverLays === null || imageOverLays === void 0 ? void 0 : imageOverLays.imageMobileOverlay) ? (React__namespace.default.createElement(MobileContainer, null,
            React__namespace.default.createElement(ImageMobile, _tslib.__assign({ src: imageMobileUrl, loading: "lazy" }, sharedMobileProps)),
            React__namespace.default.createElement(SharedOverlay, null,
                React__namespace.default.createElement(ImageMobile, _tslib.__assign({ src: imageOverLays.imageMobileOverlay, loading: "lazy" }, sharedMobileProps))))) : (React__namespace.default.createElement(ImageMobile, _tslib.__assign({ src: imageMobileUrl }, sharedMobileProps, { loading: "lazy" }))))));
};
var Background = styled__default.default.div.withConfig({ displayName: "Background", componentId: "-61c5cn" })(templateObject_1$3 || (templateObject_1$3 = _tslib.__makeTemplateObject(["\n  position: relative;\n  overflow: hidden;\n  background-color: ", ";\n"], ["\n  position: relative;\n  overflow: hidden;\n  background-color: ", ";\n"])), styles.themeColors.blue[5]);
var Container$1 = styled__default.default.div.withConfig({ displayName: "Container", componentId: "-jer88b" })(templateObject_2$2 || (templateObject_2$2 = _tslib.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  padding: 40px 24px 24px;\n  margin: 0 auto;\n  max-width: 1128px;\n\n  @media ", " {\n    padding: 96px 24px;\n  }\n\n  @media ", " {\n    padding: 16px;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  padding: 40px 24px 24px;\n  margin: 0 auto;\n  max-width: 1128px;\n\n  @media ", " {\n    padding: 96px 24px;\n  }\n\n  @media ", " {\n    padding: 16px;\n  }\n"])), ResponsiveSizes.desktopLarge, ResponsiveSizes.media.tablet);
var Hero = styled__default.default.div.withConfig({ displayName: "Hero", componentId: "-w90aey" })(templateObject_3$2 || (templateObject_3$2 = _tslib.__makeTemplateObject(["\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  max-width: 667px;\n\n  & > * + * {\n    margin-top: 16px;\n  }\n"], ["\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  max-width: 667px;\n\n  & > * + * {\n    margin-top: 16px;\n  }\n"])));
var SharedContainer = styled__default.default.div.withConfig({ displayName: "SharedContainer", componentId: "-4i536j" })(templateObject_4$2 || (templateObject_4$2 = _tslib.__makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var SharedOverlay = styled__default.default.div.withConfig({ displayName: "SharedOverlay", componentId: "-gntmta" })(templateObject_5$1 || (templateObject_5$1 = _tslib.__makeTemplateObject(["\n  position: absolute;\n  width: 100%;\n  bottom: 0;\n"], ["\n  position: absolute;\n  width: 100%;\n  bottom: 0;\n"])));
var MobileContainer = styled__default.default(SharedContainer).withConfig({ displayName: "MobileContainer", componentId: "-p7mr5g" })(templateObject_6$1 || (templateObject_6$1 = _tslib.__makeTemplateObject(["\n  display: none;\n  @media ", " {\n    display: block;\n  }\n"], ["\n  display: none;\n  @media ", " {\n    display: block;\n  }\n"])), ResponsiveSizes.media['mobile']);
var TabletContainer = styled__default.default(SharedContainer).withConfig({ displayName: "TabletContainer", componentId: "-1c509w5" })(templateObject_7$1 || (templateObject_7$1 = _tslib.__makeTemplateObject(["\n  display: none;\n  @media ", ", ", " {\n    display: block;\n  }\n"], ["\n  display: none;\n  @media ", ", ", " {\n    display: block;\n  }\n"])), ResponsiveSizes.media.desktop, ResponsiveSizes.media['tablet']);
var ImageLeft = styled__default.default.img.withConfig({ displayName: "ImageLeft", componentId: "-1axy8e0" })(templateObject_8$1 || (templateObject_8$1 = _tslib.__makeTemplateObject(["\n  ", "\n  max-width: 25%;\n"], ["\n  ", "\n  max-width: 25%;\n"])), vectorCss);
var ImageRight = styled__default.default.img.withConfig({ displayName: "ImageRight", componentId: "-1nobkqb" })(templateObject_9$1 || (templateObject_9$1 = _tslib.__makeTemplateObject(["\n  ", "\n  max-width: 25%;\n"], ["\n  ", "\n  max-width: 25%;\n"])), vectorCss);
var ImageMobile = styled__default.default.img.withConfig({ displayName: "ImageMobile", componentId: "-1hekuln" })(templateObject_10$1 || (templateObject_10$1 = _tslib.__makeTemplateObject(["\n  ", "\n  position: relative;\n  z-index: 1;\n"], ["\n  ", "\n  position: relative;\n  z-index: 1;\n"])), vectorCss);
var Polygon = styled__default.default(Blob).withConfig({ displayName: "Polygon", componentId: "-1t7s1og" })(templateObject_11$1 || (templateObject_11$1 = _tslib.__makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), vectorCss);
var templateObject_1$3, templateObject_2$2, templateObject_3$2, templateObject_4$2, templateObject_5$1, templateObject_6$1, templateObject_7$1, templateObject_8$1, templateObject_9$1, templateObject_10$1, templateObject_11$1;

var Bee5 = function (props) { return (React__namespace.createElement("svg", _tslib.__assign({ viewBox: "0 0 181 181", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React__namespace.createElement("path", { d: "M42.7441 89.1068C38.7703 73.2972 43.0004 64.6062 56.4771 60.9315C66.3388 58.2396 71.3125 64.401 72.6969 68.4774C73.7138 71.8102 73.2267 75.1174 71.2868 78.0315C68.5265 82.1933 61.425 87.5515 43.2653 89.4657L42.8466 89.5084L42.7441 89.0982V89.1068Z", fill: "#F8F9F9" }),
    React__namespace.createElement("path", { d: "M42.2055 90.4487L41.9235 89.3206C37.8642 73.1692 42.4191 63.8885 56.2632 60.1199C66.7317 57.2656 72.0386 63.8714 73.5171 68.2212C74.6195 71.8361 74.0896 75.3911 72.013 78.5274C69.1502 82.843 61.8607 88.3977 43.3677 90.3376L42.214 90.4572L42.2055 90.4487ZM61.0488 61.1454C59.7328 61.1454 58.2886 61.3334 56.7076 61.7692C43.7095 65.3157 39.7443 73.3487 43.5044 88.5943C61.1001 86.6971 67.9452 81.5611 70.5859 77.5788C72.3719 74.8784 72.8249 71.8275 71.8848 68.7425C70.8251 65.6233 67.441 61.1454 61.0488 61.1454Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M8.29616 93.6955C4.1002 91.4822 2.16886 88.1579 1.93813 86.5769C0.322984 75.6469 11.5435 72.2286 13.8082 71.6561C24.1314 69.0325 36.7535 68.5967 42.7953 88.6364L42.9149 89.0295L42.5389 89.209C32.1729 94.2681 24.345 95.9601 18.5083 95.9601C14.0133 95.9601 10.689 94.9517 8.3047 93.6955H8.29616Z", fill: "#F8F9F9" }),
    React__namespace.createElement("path", { d: "M18.4995 96.8234C14.4403 96.8234 10.8767 96.0287 7.89429 94.4562C3.39068 92.0805 1.3568 88.517 1.08333 86.7053C-0.634359 75.0489 11.1929 71.434 13.5858 70.8273C17.927 69.7249 24.3619 68.5285 30.2072 70.8529C36.4029 73.3141 40.7868 79.0483 43.5984 88.3888L43.9317 89.4826L42.9062 89.9783C33.5999 94.5161 25.3874 96.8149 18.4995 96.8149V96.8234ZM22.8579 71.1947C19.9267 71.1947 16.9357 71.7417 14.013 72.4852C11.8766 73.0321 1.27134 76.2538 2.78393 86.4574C2.96339 87.6538 4.63836 90.8072 8.69759 92.9436C11.4237 94.3793 14.7309 95.1143 18.4995 95.1143C25.0541 95.1143 32.9247 92.918 41.8721 88.5853C37.6676 74.9122 30.4807 71.1947 22.8493 71.1947H22.8579Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M8.88582 123.341C11.0137 138.33 32.8139 149.807 57.2461 146.26C96.548 140.595 99.3595 125.528 97.1547 110.642C95.0268 95.6526 79.0207 82.2443 48.6748 86.5855C24.328 90.1235 6.75792 108.446 8.87726 123.341H8.88582Z", fill: "#FCC018" }),
    React__namespace.createElement("path", { d: "M48.2645 147.765C36.7534 147.765 25.8747 144.577 18.0382 138.706C12.304 134.416 8.843 129.144 8.0397 123.469C5.946 108.745 22.8324 89.4829 48.5636 85.7484C62.7153 83.7231 74.9443 85.4151 83.9344 90.6366C91.8392 95.2342 96.8385 102.293 98.0092 110.531C98.9236 116.684 99.3167 124.623 94.2491 131.425C88.4209 139.245 76.3543 144.381 57.3657 147.115C54.3149 147.56 51.264 147.773 48.2645 147.773V147.765ZM9.73176 123.221C10.4752 128.443 13.697 133.323 19.0637 137.33C28.6007 144.466 42.8294 147.483 57.1264 145.406C75.645 142.74 87.3356 137.826 92.8818 130.383C97.5734 124.093 97.1803 116.59 96.3172 110.762C95.2233 103.054 90.5146 96.422 83.0713 92.0979C74.423 87.073 62.57 85.4493 48.8029 87.4234C24.0459 91.0212 7.74915 109.283 9.73176 123.213V123.221Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M87.55 109.098C88.8202 108.461 88.9192 106.088 87.7713 103.797C86.6234 101.505 84.6632 100.164 83.3931 100.8C82.1229 101.436 82.0238 103.81 83.1717 106.101C84.3197 108.392 86.2799 109.734 87.55 109.098Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M82.8489 106.258C81.5927 103.746 81.7636 101.208 83.2335 100.464C84.7119 99.7293 86.8483 101.114 88.1045 103.618C89.3608 106.13 89.1898 108.668 87.72 109.412C87.4551 109.548 87.1645 109.608 86.8568 109.608C85.4895 109.608 83.8744 108.309 82.8489 106.258ZM83.5667 101.122C82.4985 101.661 82.4643 103.857 83.5069 105.934C84.541 108.002 86.327 109.301 87.3952 108.762C88.4635 108.224 88.4976 106.028 87.455 103.951C86.5748 102.199 85.1648 101.003 84.1051 101.003C83.9171 101.003 83.7291 101.045 83.5667 101.122Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M87.2304 105.355C87.5975 105.171 87.6261 104.485 87.2942 103.823C86.9623 103.16 86.3956 102.772 86.0285 102.956C85.6614 103.14 85.6328 103.826 85.9647 104.489C86.2966 105.151 86.8633 105.539 87.2304 105.355Z", fill: "#F8F9F9" }),
    React__namespace.createElement("path", { d: "M79.2032 112.655C80.4533 111.98 80.4799 109.605 79.2626 107.35C78.0452 105.094 76.0449 103.813 74.7948 104.488C73.5447 105.163 73.5181 107.538 74.7355 109.793C75.9528 112.049 77.9531 113.33 79.2032 112.655Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M76.7556 112.642C75.8583 112.069 75.0294 111.12 74.4055 109.984C73.7902 108.839 73.4569 107.625 73.4655 106.566C73.4826 105.429 73.8842 104.583 74.6192 104.19C75.3456 103.797 76.277 103.916 77.2342 104.532C78.1315 105.104 78.9604 106.053 79.5842 107.189C80.1995 108.335 80.5328 109.548 80.5243 110.608C80.5072 111.744 80.1055 112.59 79.3706 112.983C79.0886 113.137 78.7809 113.206 78.4477 113.206C77.9178 113.206 77.3367 113.018 76.7471 112.633L76.7556 112.642ZM74.9695 104.822C74.4824 105.079 74.2175 105.702 74.2004 106.566C74.1919 107.506 74.491 108.599 75.0465 109.634C75.6019 110.668 76.354 111.522 77.1402 112.026C77.8665 112.488 78.5331 112.599 79.0202 112.343C79.5073 112.086 79.7722 111.462 79.7893 110.599C79.7979 109.659 79.4988 108.565 78.9433 107.531C78.3878 106.497 77.6358 105.643 76.8496 105.138C76.3796 104.839 75.9352 104.686 75.5507 104.686C75.337 104.686 75.149 104.728 74.9781 104.822H74.9695Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M78.8488 109.109C79.2101 108.914 79.2177 108.227 78.8657 107.575C78.5137 106.923 77.9355 106.552 77.5742 106.747C77.2128 106.942 77.2053 107.629 77.5572 108.281C77.9092 108.933 78.4875 109.304 78.8488 109.109Z", fill: "#F8F9F9" }),
    React__namespace.createElement("path", { d: "M84.9087 122.205C88.9935 122.205 90.113 119 90.1301 118.966C90.2412 118.633 90.0617 118.274 89.7285 118.163C89.3952 118.052 89.0362 118.231 88.9251 118.564C88.8824 118.693 87.874 121.402 83.9003 120.872C83.567 120.829 83.2337 121.068 83.191 121.419C83.1482 121.769 83.3875 122.085 83.7379 122.128C84.1566 122.188 84.5412 122.213 84.9087 122.213V122.205Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M84.9086 122.632C84.5155 122.632 84.0968 122.607 83.6781 122.547C83.0969 122.47 82.6868 121.931 82.7637 121.359C82.8406 120.778 83.379 120.368 83.9601 120.444C87.6091 120.94 88.4893 118.53 88.5235 118.428C88.7115 117.881 89.3097 117.582 89.8652 117.761C90.4206 117.949 90.7197 118.547 90.5403 119.103C90.5317 119.137 89.3097 122.632 84.9172 122.632H84.9086ZM83.8233 121.29C83.7208 121.29 83.6268 121.367 83.6097 121.47C83.5926 121.581 83.6781 121.684 83.7892 121.701C84.1737 121.752 84.5497 121.778 84.9086 121.778C88.6517 121.778 89.6772 118.949 89.7199 118.829C89.7541 118.727 89.6942 118.607 89.5917 118.573C89.4806 118.539 89.3695 118.599 89.3268 118.701C89.2841 118.829 88.1731 121.88 83.8404 121.29C83.8404 121.29 83.8233 121.29 83.8148 121.29H83.8233Z", fill: "#121212" }),
    React__namespace.createElement("mask", { id: "mask0_3273_2776", style: { maskType: 'luminance' }, maskUnits: "userSpaceOnUse", x: "8", y: "85", width: "90", height: "62" },
        React__namespace.createElement("path", { d: "M8.88582 123.341C11.0137 138.33 32.8139 149.807 57.2461 146.26C96.548 140.595 99.3595 125.528 97.1547 110.642C95.0268 95.6526 79.0207 82.2443 48.6748 86.5855C24.328 90.1235 6.75792 108.446 8.87726 123.341H8.88582Z", fill: "white" })),
    React__namespace.createElement("g", { mask: "url(#mask0_3273_2776)" },
        React__namespace.createElement("path", { d: "M42.7955 147.67C39.3174 147.388 36.0443 146.704 32.9251 145.892C19.5596 133.27 17.1754 105.488 27.2764 93.524C30.8571 91.3021 34.7796 89.4818 39.0439 88.0547C24.2 102.822 30.3358 133.031 42.7869 147.661L42.7955 147.67Z", fill: "#121212" }),
        React__namespace.createElement("path", { d: "M42.7696 148.029C39.753 147.781 36.5996 147.217 32.8395 146.243L32.7455 146.217L32.6771 146.149C19.5936 133.8 16.5684 105.634 27.0028 93.285L27.0882 93.2081C30.6774 90.9862 34.6683 89.1318 38.9326 87.7046L40.411 87.209L39.3001 88.3114C24.1399 103.386 31.532 133.869 43.0687 147.422L43.6413 148.097L42.7611 148.029H42.7696ZM27.524 93.8063C17.3632 105.916 20.3371 133.416 33.113 145.559C36.4287 146.414 39.2659 146.952 41.9492 147.217C35.8476 139.714 31.5234 128.852 30.3185 117.948C29.0024 105.975 31.6345 95.7291 37.7447 88.8925C34.0872 90.2171 30.6518 91.8664 27.5155 93.7977L27.524 93.8063Z", fill: "#121212" }),
        React__namespace.createElement("path", { d: "M47.4441 85.8075C47.427 85.722 53.8107 85.2007 56.2975 85.0127C47.145 98.8397 45.077 133.262 65.3645 145.73C62.7581 146.303 59.9636 146.815 56.9726 147.268C56.1864 147.414 55.4686 147.448 54.6824 147.593C34.6768 131.023 37.3943 96.0196 47.4356 85.7989L47.4441 85.8075Z", fill: "#121212" }),
        React__namespace.createElement("path", { d: "M54.4518 147.884C42.3596 137.868 39.8557 122.725 39.4455 114.59C38.8302 102.566 41.9323 90.9093 47.1623 85.5682C47.1623 85.5682 47.1623 85.5597 47.1794 85.5511C47.3161 85.44 48.0938 85.2435 56.272 84.6538L57.0155 84.6025L56.6053 85.2264C51.4693 92.9944 47.9741 108.616 51.2557 123.451C53.4605 133.433 58.4085 141.03 65.5527 145.431L66.3218 145.91L65.4331 146.106C62.8266 146.679 59.998 147.2 57.0326 147.653C56.6309 147.73 56.2464 147.773 55.8704 147.824C55.5029 147.867 55.1354 147.918 54.7509 147.986L54.58 148.02L54.4518 147.909V147.884ZM50.5378 123.605C47.299 108.949 50.5891 93.5243 55.5969 85.44C52.8366 85.6451 48.3416 86.0297 47.6323 86.1408C42.5647 91.3708 39.5737 102.771 40.1719 114.555C40.5821 122.537 43.0261 137.372 54.7851 147.217C55.1269 147.157 55.4516 147.123 55.7764 147.08C56.1438 147.038 56.5113 146.986 56.913 146.918C59.545 146.516 62.066 146.063 64.4076 145.568C57.4941 141.004 52.6999 133.433 50.5293 123.605H50.5378Z", fill: "#121212" }),
        React__namespace.createElement("path", { d: "M22.7727 142.184C14.697 137.483 9.279 130.869 8.22787 123.468C7.22802 116.435 10.2276 108.718 16.0729 101.882C10.4839 113.624 14.8679 134.834 22.7727 142.184Z", fill: "#121212" }),
        React__namespace.createElement("path", { d: "M22.5932 142.5C14.1414 137.577 8.91145 130.835 7.86887 123.52C6.87756 116.546 9.69766 108.778 15.7993 101.643L17.5939 99.5488L16.4061 102.036C10.783 113.863 15.4404 134.86 23.029 141.91L25.4389 144.149L22.6017 142.5H22.5932ZM8.59525 123.417C9.50964 129.852 13.7996 135.843 20.7558 140.491C14.5345 132.484 10.9539 115.316 14.8165 104.035C9.92838 110.462 7.72358 117.273 8.59525 123.426V123.417Z", fill: "#121212" })),
    React__namespace.createElement("path", { d: "M50.9733 170.693C63.1878 170.693 73.0897 160.791 73.0897 148.576C73.0897 136.362 63.1878 126.46 50.9733 126.46C38.7588 126.46 28.8569 136.362 28.8569 148.576C28.8569 160.791 38.7588 170.693 50.9733 170.693Z", fill: "#FCC018" }),
    React__namespace.createElement("path", { d: "M50.9734 171.547C38.3086 171.547 28.0024 161.241 28.0024 148.576C28.0024 135.912 38.3086 125.605 50.9734 125.605C63.6382 125.605 73.9443 135.912 73.9443 148.576C73.9443 161.241 63.6382 171.547 50.9734 171.547ZM50.9734 127.315C39.2486 127.315 29.7116 136.852 29.7116 148.576C29.7116 160.301 39.2486 169.838 50.9734 169.838C62.6981 169.838 72.2352 160.301 72.2352 148.576C72.2352 136.852 62.6981 127.315 50.9734 127.315Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M57.3995 149.876C56.656 149.03 55.434 148.355 53.7505 147.851L49.922 146.714C48.8111 146.372 48.0078 145.962 47.4865 145.483C46.9737 145.005 46.7088 144.424 46.7088 143.731C46.7088 143.099 46.8968 142.535 47.2643 142.039C47.6317 141.544 48.1359 141.168 48.7769 140.886C49.4178 140.612 50.1356 140.476 50.9389 140.493C51.8021 140.501 52.5797 140.672 53.2634 141.014C53.9556 141.347 54.5282 141.817 54.9725 142.424C55.4255 143.031 55.716 143.731 55.8442 144.535L58.3994 144.065C58.1601 142.826 57.7072 141.757 57.0321 140.869C56.3569 139.98 55.5024 139.296 54.4683 138.818C53.8103 138.51 53.0839 138.313 52.3148 138.202V135.673H49.7853V138.151C48.9051 138.245 48.1103 138.459 47.3925 138.792C46.3755 139.271 45.5893 139.946 45.0253 140.809C44.4613 141.672 44.1793 142.689 44.1793 143.843C44.1793 146.304 45.5722 147.97 48.3667 148.842L53.0327 150.286C54.1094 150.619 54.8785 151.021 55.34 151.491C55.8015 151.961 56.0237 152.585 56.0237 153.363C56.0237 154.422 55.5964 155.285 54.7333 155.96C53.8701 156.636 52.7421 156.969 51.3577 156.969C49.9733 156.969 48.794 156.601 47.8198 155.866C46.837 155.131 46.1961 154.132 45.897 152.875L43.4102 153.286C43.6238 154.525 44.0938 155.601 44.8031 156.516C45.5124 157.43 46.4183 158.131 47.5207 158.627C48.2214 158.943 48.9734 159.139 49.7853 159.259V161.754H52.3148V159.319C53.3403 159.225 54.2547 158.986 55.0751 158.601C56.1689 158.088 57.015 157.379 57.6132 156.456C58.2114 155.542 58.5105 154.465 58.5105 153.251C58.5105 151.841 58.1345 150.713 57.391 149.867L57.3995 149.876Z", fill: "black" }),
    React__namespace.createElement("path", { d: "M85.8996 163.293L84.6348 167.437C84.5835 167.608 84.4981 167.762 84.3784 167.882C84.2588 168.01 84.1049 168.104 83.9426 168.172L80.0457 169.514C79.8235 169.608 79.6355 169.753 79.5073 169.95C79.3706 170.146 79.3022 170.369 79.3022 170.608C79.3022 170.847 79.3706 171.069 79.5073 171.266C79.6355 171.463 79.8235 171.608 80.0457 171.702L83.934 173.043C84.1049 173.103 84.2502 173.206 84.3699 173.334C84.4895 173.462 84.575 173.616 84.6262 173.787L85.8825 177.932C85.9337 178.154 86.0619 178.359 86.2499 178.504C86.4379 178.649 86.6687 178.726 86.8994 178.726C87.1301 178.726 87.3694 178.649 87.5574 178.504C87.7454 178.359 87.8736 178.162 87.9249 177.932L89.1897 173.787C89.2409 173.616 89.3264 173.462 89.446 173.334C89.5657 173.206 89.7195 173.112 89.8819 173.043L93.7787 171.71C94.0009 171.616 94.1889 171.471 94.3171 171.275C94.4453 171.078 94.5222 170.856 94.5222 170.616C94.5222 170.377 94.4538 170.155 94.3171 169.958C94.1804 169.762 94.0009 169.617 93.7787 169.523L89.8904 168.181C89.728 168.121 89.5742 168.019 89.4546 167.89C89.3349 167.762 89.2495 167.608 89.1982 167.437L87.942 163.293C87.8907 163.071 87.7625 162.866 87.5745 162.72C87.3865 162.575 87.1558 162.498 86.925 162.498C86.6943 162.498 86.455 162.575 86.2756 162.72C86.0876 162.866 85.9594 163.062 85.9081 163.293H85.8996Z", fill: "#F8F9F9" }),
    React__namespace.createElement("path", { d: "M86.9252 162.506C87.1645 162.506 87.3952 162.583 87.5747 162.728C87.7627 162.874 87.8909 163.07 87.9422 163.301L89.1984 167.446C89.2496 167.617 89.3351 167.77 89.4547 167.899C89.5744 168.027 89.7282 168.129 89.8906 168.189L93.7789 169.531C94.0011 169.625 94.1891 169.77 94.3173 169.967C94.4454 170.163 94.5224 170.385 94.5224 170.625C94.5224 170.855 94.454 171.086 94.3173 171.283C94.1805 171.479 93.9925 171.625 93.7789 171.719L89.882 173.06C89.7111 173.12 89.5658 173.223 89.4462 173.351C89.3266 173.479 89.2411 173.633 89.1898 173.804L87.9251 177.948C87.8738 178.171 87.7371 178.376 87.5576 178.521C87.3696 178.666 87.1388 178.743 86.9081 178.743C86.6688 178.743 86.4381 178.666 86.2586 178.521C86.0706 178.376 85.9425 178.179 85.8912 177.948L84.635 173.804C84.5837 173.633 84.4982 173.479 84.3786 173.351C84.2589 173.223 84.1137 173.12 83.9427 173.06L80.0544 171.719C79.8322 171.625 79.6442 171.479 79.5161 171.283C79.3879 171.086 79.311 170.864 79.311 170.625C79.311 170.394 79.3793 170.163 79.5161 169.967C79.6442 169.77 79.8408 169.625 80.0544 169.531L83.9513 168.189C84.1222 168.129 84.2675 168.027 84.3871 167.899C84.5068 167.77 84.5922 167.617 84.6435 167.454L85.9083 163.31C85.9595 163.087 86.0963 162.882 86.2757 162.737C86.4637 162.592 86.6945 162.515 86.9252 162.515M86.9252 160.806C86.3099 160.806 85.7117 161.011 85.2246 161.387C84.746 161.754 84.4042 162.267 84.2504 162.848L83.0796 166.677L79.4904 167.907C79.4904 167.907 79.4306 167.933 79.405 167.941C78.8751 168.155 78.4222 168.522 78.0975 168.992C77.7727 169.471 77.5933 170.027 77.5933 170.608C77.5933 171.189 77.7642 171.744 78.0975 172.231C78.4136 172.701 78.8666 173.069 79.405 173.282C79.4306 173.291 79.4648 173.308 79.4904 173.317L83.0796 174.556L84.2418 178.384C84.3957 178.957 84.7375 179.478 85.2075 179.846C85.6946 180.222 86.2928 180.427 86.9081 180.427C87.5234 180.427 88.1216 180.222 88.6087 179.854C89.0873 179.487 89.4291 178.965 89.5829 178.393L90.7537 174.564L94.3429 173.334C94.3429 173.334 94.4027 173.308 94.4284 173.3C94.9582 173.086 95.4111 172.718 95.7359 172.248C96.0691 171.77 96.2401 171.206 96.2401 170.633C96.2401 170.052 96.0692 169.497 95.7444 169.018C95.4197 168.54 94.9668 168.181 94.4369 167.958C94.4113 167.95 94.3771 167.933 94.3515 167.924L90.7622 166.685L89.6 162.857C89.4462 162.276 89.1044 161.763 88.6344 161.395C88.1472 161.019 87.549 160.814 86.9337 160.814L86.9252 160.806Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M124.364 159.207L123.817 160.993C123.8 161.061 123.758 161.13 123.706 161.19C123.655 161.241 123.587 161.284 123.518 161.309L121.826 161.882C121.732 161.916 121.647 161.984 121.587 162.07C121.527 162.155 121.501 162.249 121.501 162.352C121.501 162.454 121.536 162.548 121.587 162.634C121.647 162.719 121.724 162.779 121.826 162.822L123.518 163.403C123.587 163.429 123.655 163.471 123.706 163.531C123.758 163.582 123.8 163.651 123.817 163.728L124.364 165.514C124.39 165.608 124.441 165.693 124.527 165.762C124.604 165.821 124.706 165.856 124.809 165.856C124.911 165.856 125.014 165.821 125.091 165.762C125.168 165.702 125.227 165.616 125.253 165.514L125.8 163.728C125.817 163.659 125.86 163.591 125.911 163.531C125.962 163.48 126.031 163.437 126.099 163.412L127.791 162.839C127.885 162.805 127.971 162.736 128.03 162.651C128.09 162.566 128.116 162.472 128.116 162.369C128.116 162.266 128.082 162.172 128.03 162.087C127.971 162.002 127.894 161.942 127.791 161.899L126.099 161.318C126.031 161.292 125.962 161.249 125.911 161.19C125.86 161.138 125.817 161.07 125.8 160.993L125.253 159.207C125.227 159.113 125.176 159.028 125.091 158.959C125.014 158.899 124.911 158.865 124.809 158.865C124.706 158.865 124.604 158.899 124.527 158.959C124.441 159.019 124.39 159.105 124.364 159.207Z", fill: "#F8F9F9" }),
    React__namespace.createElement("path", { d: "M124.809 158.865C124.911 158.865 125.014 158.9 125.091 158.959C125.167 159.019 125.227 159.105 125.253 159.207L125.8 160.993C125.817 161.062 125.86 161.13 125.911 161.19C125.962 161.241 126.031 161.284 126.099 161.318L127.791 161.899C127.885 161.942 127.971 162.002 128.03 162.087C128.09 162.173 128.116 162.267 128.116 162.369C128.116 162.472 128.082 162.566 128.03 162.651C127.971 162.737 127.894 162.796 127.791 162.839L126.099 163.412C126.031 163.437 125.962 163.48 125.911 163.531C125.86 163.583 125.817 163.651 125.8 163.728L125.253 165.514C125.227 165.608 125.176 165.693 125.091 165.762C125.014 165.822 124.911 165.856 124.809 165.856C124.706 165.856 124.603 165.822 124.527 165.762C124.45 165.702 124.39 165.617 124.364 165.514L123.817 163.728C123.8 163.66 123.757 163.591 123.706 163.531C123.655 163.48 123.587 163.437 123.518 163.403L121.826 162.822C121.732 162.779 121.647 162.72 121.587 162.634C121.527 162.549 121.501 162.455 121.501 162.352C121.501 162.25 121.536 162.156 121.587 162.07C121.647 161.985 121.724 161.925 121.826 161.882L123.518 161.309C123.587 161.284 123.655 161.241 123.706 161.19C123.757 161.139 123.8 161.07 123.817 160.993L124.364 159.207C124.39 159.113 124.441 159.028 124.527 158.959C124.603 158.9 124.706 158.865 124.809 158.865ZM124.809 157.156C124.33 157.156 123.86 157.319 123.484 157.601C123.117 157.883 122.843 158.284 122.723 158.729L122.364 159.882L121.271 160.258C121.271 160.258 121.211 160.275 121.185 160.293C120.775 160.455 120.425 160.737 120.177 161.096C119.92 161.463 119.784 161.899 119.784 162.352C119.784 162.805 119.92 163.232 120.177 163.608C120.425 163.967 120.775 164.241 121.177 164.412C121.211 164.42 121.236 164.437 121.271 164.446L122.364 164.822L122.715 165.975C122.843 166.428 123.108 166.821 123.484 167.112C123.86 167.403 124.33 167.556 124.809 167.556C125.287 167.556 125.749 167.403 126.133 167.112C126.509 166.821 126.783 166.428 126.902 165.975L127.261 164.822L128.355 164.446C128.355 164.446 128.415 164.429 128.441 164.412C128.851 164.249 129.201 163.967 129.449 163.608C129.705 163.241 129.842 162.805 129.842 162.361C129.842 161.908 129.705 161.48 129.449 161.104C129.201 160.745 128.859 160.472 128.449 160.301C128.415 160.293 128.389 160.275 128.355 160.267L127.261 159.891L126.911 158.737C126.791 158.293 126.518 157.891 126.15 157.609C125.774 157.319 125.304 157.156 124.826 157.156H124.809Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M86.891 75.895L86.5321 77.0487C86.515 77.0914 86.4979 77.1342 86.4638 77.1769C86.4296 77.2111 86.3868 77.2367 86.3441 77.2538L85.2503 77.6298C85.1904 77.6555 85.1392 77.6982 85.0964 77.7495C85.0623 77.8007 85.0366 77.8691 85.0366 77.9289C85.0366 77.9887 85.0537 78.0571 85.0964 78.1084C85.1306 78.1597 85.1904 78.2024 85.2503 78.228L86.3441 78.604C86.3868 78.6211 86.4296 78.6468 86.4638 78.6809C86.4979 78.7151 86.5236 78.7579 86.5321 78.8091L86.8825 79.9628C86.8996 80.0226 86.9338 80.0824 86.985 80.1252C87.0363 80.1679 87.1047 80.185 87.1731 80.185C87.2414 80.185 87.3012 80.1594 87.361 80.1252C87.4123 80.0824 87.4465 80.0312 87.4636 79.9628L87.8225 78.8091C87.8396 78.7664 87.8567 78.7237 87.8909 78.6809C87.9251 78.6468 87.9678 78.6211 88.0105 78.604L89.1044 78.228C89.1642 78.2024 89.2155 78.1597 89.2582 78.1084C89.2924 78.0571 89.318 77.9887 89.318 77.9289C89.318 77.8691 89.3009 77.8007 89.2582 77.7495C89.224 77.6982 89.1642 77.6555 89.1044 77.6298L88.0105 77.2538C87.9678 77.2367 87.9251 77.2111 87.8909 77.1769C87.8567 77.1427 87.8311 77.1 87.8225 77.0487L87.4721 75.895C87.4551 75.8352 87.4209 75.7754 87.3696 75.7327C87.3183 75.6899 87.25 75.6729 87.1816 75.6729C87.1132 75.6729 87.0534 75.6985 86.9936 75.7327C86.9423 75.7754 86.9081 75.8267 86.891 75.895Z", fill: "#F8F9F9" }),
    React__namespace.createElement("path", { d: "M87.1818 75.673C87.2501 75.673 87.3099 75.6986 87.3698 75.7328C87.421 75.7756 87.4552 75.8268 87.4723 75.8952L87.8227 77.0489C87.8398 77.0916 87.8569 77.1343 87.8911 77.1771C87.9252 77.2112 87.968 77.2369 88.0107 77.254L89.1045 77.63C89.1644 77.6556 89.2156 77.6983 89.2584 77.7496C89.2926 77.8009 89.3182 77.8693 89.3182 77.9291C89.3182 77.9975 89.3011 78.0573 89.2584 78.1085C89.2242 78.1598 89.1644 78.2025 89.1045 78.2282L88.0107 78.6042C87.968 78.6213 87.9252 78.6469 87.8911 78.6811C87.8569 78.7153 87.8312 78.758 87.8227 78.8093L87.4638 79.963C87.4467 80.0228 87.4125 80.0826 87.3612 80.1253C87.3099 80.1681 87.2416 80.1852 87.1732 80.1852C87.1049 80.1852 87.045 80.1595 86.9852 80.1253C86.9339 80.0826 86.8997 80.0313 86.8827 79.963L86.5323 78.8093C86.5152 78.7666 86.4981 78.7238 86.4639 78.6811C86.4297 78.6469 86.387 78.6213 86.3443 78.6042L85.2504 78.2282C85.1906 78.2025 85.1393 78.1598 85.0966 78.1085C85.0624 78.0573 85.0368 77.9889 85.0368 77.9291C85.0368 77.8693 85.0539 77.8009 85.0966 77.7496C85.1308 77.6983 85.1906 77.6556 85.2504 77.63L86.3443 77.254C86.387 77.2369 86.4297 77.2112 86.4639 77.1771C86.4981 77.1429 86.5237 77.1002 86.5323 77.0489L86.8912 75.8952C86.9083 75.8354 86.9425 75.7756 86.9938 75.7328C87.045 75.6901 87.1134 75.673 87.1818 75.673ZM87.1818 73.9639C86.7374 73.9639 86.3101 74.1091 85.9597 74.3826C85.6179 74.639 85.3701 75.0064 85.2504 75.4252L85.1137 75.8696L84.6949 76.0148C84.6949 76.0148 84.6351 76.0319 84.6095 76.049C84.2335 76.2028 83.9173 76.4507 83.6866 76.784C83.4558 77.1172 83.3276 77.5189 83.3276 77.9376C83.3276 78.3478 83.4473 78.7495 83.6866 79.0913C83.9173 79.4246 84.2335 79.6724 84.6009 79.8262C84.6351 79.8348 84.6608 79.8519 84.6949 79.8604L85.1137 80.0057L85.2504 80.4501C85.3701 80.8603 85.6179 81.2277 85.9597 81.4927C86.3101 81.7576 86.7459 81.9029 87.1818 81.9029C87.6176 81.9029 88.0534 81.7576 88.4038 81.4927C88.7542 81.2277 89.002 80.8603 89.1131 80.4501L89.2498 80.0057L89.6686 79.8604C89.6686 79.8604 89.7284 79.8433 89.754 79.8262C90.13 79.6724 90.4462 79.4246 90.677 79.0913C90.9162 78.7495 91.0359 78.3478 91.0359 77.9376C91.0359 77.5274 90.9162 77.1258 90.677 76.784C90.4462 76.4507 90.13 76.2028 89.7626 76.049C89.7284 76.0405 89.7028 76.0234 89.6686 76.0148L89.2498 75.8696L89.1131 75.4252C88.9935 75.015 88.7542 74.6475 88.4123 74.3826C88.062 74.1177 87.6261 73.9639 87.1903 73.9639H87.1818Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M104.615 138.963L104.068 140.749C104.051 140.817 104.008 140.886 103.957 140.946C103.905 140.997 103.837 141.04 103.769 141.065L102.077 141.638C101.983 141.672 101.897 141.74 101.837 141.826C101.778 141.911 101.752 142.005 101.752 142.108C101.752 142.21 101.786 142.304 101.837 142.39C101.897 142.475 101.974 142.535 102.077 142.578L103.769 143.159C103.837 143.185 103.905 143.227 103.957 143.287C104.008 143.338 104.051 143.407 104.068 143.484L104.615 145.27C104.64 145.364 104.692 145.449 104.777 145.518C104.854 145.577 104.957 145.612 105.059 145.612C105.162 145.612 105.264 145.577 105.341 145.518C105.418 145.458 105.478 145.372 105.504 145.27L106.05 143.484C106.068 143.415 106.11 143.347 106.162 143.287C106.213 143.236 106.281 143.193 106.35 143.167L108.042 142.595C108.136 142.561 108.221 142.492 108.281 142.407C108.341 142.321 108.366 142.227 108.366 142.125C108.366 142.022 108.332 141.928 108.281 141.843C108.221 141.757 108.144 141.698 108.042 141.655L106.35 141.074C106.281 141.048 106.213 141.005 106.162 140.946C106.11 140.894 106.068 140.826 106.05 140.749L105.504 138.963C105.478 138.869 105.427 138.783 105.341 138.715C105.264 138.655 105.162 138.621 105.059 138.621C104.957 138.621 104.854 138.655 104.777 138.715C104.692 138.775 104.64 138.86 104.615 138.963Z", fill: "#F8F9F9" }),
    React__namespace.createElement("path", { d: "M105.059 138.621C105.162 138.621 105.264 138.655 105.341 138.715C105.418 138.775 105.478 138.86 105.503 138.963L106.05 140.749C106.067 140.817 106.11 140.885 106.161 140.945C106.213 140.996 106.281 141.039 106.349 141.073L108.042 141.655C108.136 141.697 108.221 141.757 108.281 141.843C108.341 141.928 108.366 142.022 108.366 142.125C108.366 142.227 108.332 142.321 108.281 142.407C108.221 142.492 108.144 142.552 108.042 142.595L106.349 143.167C106.281 143.193 106.213 143.235 106.161 143.287C106.11 143.338 106.067 143.406 106.05 143.483L105.503 145.269C105.478 145.363 105.427 145.449 105.341 145.517C105.264 145.577 105.162 145.611 105.059 145.611C104.957 145.611 104.854 145.577 104.777 145.517C104.7 145.457 104.64 145.372 104.615 145.269L104.068 143.483C104.051 143.415 104.008 143.347 103.957 143.287C103.905 143.235 103.837 143.193 103.769 143.159L102.077 142.577C101.983 142.535 101.897 142.475 101.837 142.389C101.778 142.304 101.752 142.21 101.752 142.107C101.752 142.005 101.786 141.911 101.837 141.825C101.897 141.74 101.974 141.68 102.077 141.637L103.769 141.065C103.837 141.039 103.905 140.996 103.957 140.945C104.008 140.894 104.051 140.826 104.068 140.749L104.615 138.963C104.64 138.869 104.692 138.783 104.777 138.715C104.854 138.655 104.957 138.621 105.059 138.621ZM105.059 136.912C104.581 136.912 104.11 137.074 103.734 137.356C103.367 137.638 103.094 138.04 102.974 138.484L102.615 139.638L101.521 140.014C101.521 140.014 101.461 140.031 101.436 140.048C101.025 140.21 100.675 140.492 100.427 140.851C100.171 141.219 100.034 141.655 100.034 142.099C100.034 142.552 100.171 142.979 100.427 143.355C100.675 143.714 101.025 143.987 101.427 144.158C101.461 144.167 101.487 144.184 101.521 144.193L102.615 144.569L102.965 145.722C103.085 146.175 103.358 146.568 103.734 146.859C104.11 147.149 104.581 147.303 105.059 147.303C105.538 147.303 105.999 147.149 106.384 146.859C106.76 146.568 107.033 146.175 107.153 145.722L107.512 144.569L108.606 144.193C108.606 144.193 108.665 144.175 108.691 144.158C109.101 143.996 109.452 143.714 109.699 143.355C109.956 142.988 110.093 142.552 110.093 142.099C110.093 141.646 109.956 141.219 109.699 140.843C109.452 140.484 109.11 140.21 108.7 140.039C108.665 140.031 108.64 140.014 108.606 140.005L107.512 139.629L107.161 138.475C107.042 138.031 106.768 137.629 106.401 137.347C106.025 137.057 105.555 136.895 105.076 136.895L105.059 136.912Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M121.493 106.045L120.946 107.831C120.929 107.899 120.886 107.968 120.835 108.028C120.783 108.079 120.715 108.122 120.647 108.147L118.955 108.72C118.861 108.754 118.775 108.822 118.715 108.908C118.656 108.993 118.63 109.087 118.63 109.19C118.63 109.292 118.664 109.386 118.715 109.472C118.775 109.557 118.852 109.617 118.955 109.66L120.647 110.241C120.715 110.267 120.783 110.309 120.835 110.369C120.886 110.42 120.929 110.489 120.946 110.566L121.493 112.352C121.518 112.446 121.57 112.531 121.655 112.6C121.732 112.659 121.835 112.694 121.937 112.694C122.04 112.694 122.142 112.659 122.219 112.6C122.296 112.54 122.356 112.454 122.381 112.352L122.928 110.566C122.945 110.497 122.988 110.429 123.039 110.369C123.091 110.318 123.159 110.275 123.227 110.249L124.92 109.677C125.014 109.643 125.099 109.574 125.159 109.489C125.219 109.403 125.244 109.309 125.244 109.207C125.244 109.104 125.21 109.01 125.159 108.925C125.099 108.839 125.022 108.78 124.92 108.737L123.227 108.156C123.159 108.13 123.091 108.087 123.039 108.028C122.988 107.976 122.945 107.908 122.928 107.831L122.381 106.045C122.356 105.951 122.305 105.865 122.219 105.797C122.142 105.737 122.04 105.703 121.937 105.703C121.835 105.703 121.732 105.737 121.655 105.797C121.57 105.857 121.518 105.942 121.493 106.045Z", fill: "#F8F9F9" }),
    React__namespace.createElement("path", { d: "M121.937 105.703C122.04 105.703 122.142 105.737 122.219 105.797C122.296 105.857 122.356 105.942 122.381 106.045L122.928 107.831C122.945 107.899 122.988 107.967 123.039 108.027C123.091 108.079 123.159 108.121 123.227 108.155L124.919 108.737C125.013 108.779 125.099 108.839 125.159 108.925C125.219 109.01 125.244 109.104 125.244 109.207C125.244 109.309 125.21 109.403 125.159 109.489C125.099 109.574 125.022 109.634 124.919 109.677L123.227 110.249C123.159 110.275 123.091 110.317 123.039 110.369C122.988 110.42 122.945 110.488 122.928 110.565L122.381 112.351C122.356 112.445 122.304 112.531 122.219 112.599C122.142 112.659 122.04 112.693 121.937 112.693C121.834 112.693 121.732 112.659 121.655 112.599C121.578 112.539 121.518 112.454 121.493 112.351L120.946 110.565C120.929 110.497 120.886 110.429 120.835 110.369C120.783 110.317 120.715 110.275 120.647 110.241L118.955 109.659C118.861 109.617 118.775 109.557 118.715 109.471C118.655 109.386 118.63 109.292 118.63 109.189C118.63 109.087 118.664 108.993 118.715 108.907C118.775 108.822 118.852 108.762 118.955 108.719L120.647 108.147C120.715 108.121 120.783 108.079 120.835 108.027C120.886 107.976 120.929 107.908 120.946 107.831L121.493 106.045C121.518 105.951 121.57 105.865 121.655 105.797C121.732 105.737 121.834 105.703 121.937 105.703ZM121.937 103.994C121.458 103.994 120.988 104.156 120.612 104.438C120.245 104.72 119.971 105.122 119.852 105.566L119.493 106.72L118.399 107.096C118.399 107.096 118.339 107.113 118.314 107.13C117.903 107.292 117.553 107.574 117.305 107.933C117.049 108.301 116.912 108.737 116.912 109.181C116.912 109.634 117.049 110.061 117.305 110.437C117.553 110.796 117.903 111.07 118.305 111.24C118.339 111.249 118.365 111.266 118.399 111.275L119.493 111.651L119.843 112.804C119.963 113.257 120.236 113.65 120.612 113.941C120.988 114.231 121.458 114.385 121.937 114.385C122.416 114.385 122.877 114.231 123.253 113.941C123.629 113.65 123.903 113.257 124.022 112.804L124.381 111.651L125.475 111.275C125.475 111.275 125.535 111.258 125.56 111.24C125.971 111.078 126.321 110.796 126.569 110.437C126.825 110.07 126.962 109.634 126.962 109.181C126.962 108.728 126.825 108.301 126.569 107.925C126.321 107.566 125.979 107.292 125.569 107.121C125.535 107.113 125.509 107.096 125.475 107.087L124.381 106.711L124.031 105.558C123.911 105.113 123.638 104.711 123.27 104.429C122.894 104.139 122.424 103.977 121.946 103.977L121.937 103.994Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M14.7225 147.226L13.9961 149.576C13.9705 149.67 13.9192 149.756 13.8509 149.833C13.7825 149.901 13.697 149.961 13.603 149.995L11.3726 150.756C11.2444 150.807 11.1419 150.892 11.065 151.004C10.988 151.115 10.9453 151.243 10.9453 151.371C10.9453 151.499 10.988 151.636 11.065 151.739C11.1419 151.85 11.2444 151.935 11.3726 151.986L13.603 152.747C13.697 152.781 13.7825 152.841 13.8509 152.909C13.9192 152.978 13.9705 153.072 13.9961 153.166L14.714 155.516C14.7482 155.644 14.8165 155.755 14.9276 155.84C15.0302 155.917 15.1669 155.969 15.3036 155.969C15.4404 155.969 15.5686 155.926 15.6797 155.84C15.7822 155.755 15.8591 155.644 15.8933 155.516L16.6197 153.166C16.6453 153.072 16.6966 152.986 16.765 152.909C16.8333 152.841 16.9188 152.781 17.0128 152.747L19.2432 151.986C19.3714 151.935 19.474 151.85 19.5509 151.739C19.6278 151.627 19.6705 151.499 19.6705 151.371C19.6705 151.243 19.6278 151.106 19.5509 151.004C19.474 150.892 19.3714 150.807 19.2432 150.756L17.0128 149.995C16.9188 149.961 16.8333 149.901 16.765 149.833C16.6966 149.764 16.6453 149.67 16.6197 149.576L15.9018 147.226C15.8677 147.098 15.7993 146.987 15.6882 146.902C15.5857 146.816 15.4489 146.773 15.3122 146.773C15.1755 146.773 15.0473 146.816 14.9362 146.902C14.8251 146.987 14.7567 147.098 14.7225 147.226Z", fill: "#F8F9F9" }),
    React__namespace.createElement("path", { d: "M15.3121 146.782C15.4488 146.782 15.577 146.825 15.6881 146.911C15.7907 146.996 15.8676 147.107 15.9018 147.235L16.6196 149.585C16.6452 149.679 16.6965 149.765 16.7649 149.842C16.8332 149.919 16.9187 149.97 17.0127 150.004L19.2431 150.765C19.3713 150.816 19.4739 150.901 19.5508 151.013C19.6277 151.124 19.6704 151.252 19.6704 151.38C19.6704 151.508 19.6277 151.636 19.5508 151.747C19.4739 151.859 19.3628 151.944 19.2431 151.995L17.0127 152.756C16.9187 152.79 16.8332 152.85 16.7649 152.918C16.6965 152.995 16.6452 153.081 16.6196 153.175L15.8932 155.525C15.859 155.653 15.7907 155.764 15.6796 155.849C15.577 155.926 15.4403 155.978 15.3036 155.978C15.1668 155.978 15.0386 155.935 14.9275 155.849C14.8164 155.764 14.7481 155.653 14.7139 155.525L13.9961 153.175C13.9704 153.081 13.9192 152.995 13.8508 152.918C13.7824 152.841 13.697 152.79 13.603 152.756L11.3725 151.995C11.2443 151.944 11.1418 151.859 11.0649 151.747C10.988 151.636 10.9452 151.508 10.9452 151.38C10.9452 151.252 10.988 151.115 11.0649 151.013C11.1418 150.901 11.2529 150.816 11.3725 150.765L13.603 150.004C13.697 149.97 13.7824 149.91 13.8508 149.842C13.9192 149.765 13.9704 149.679 13.9961 149.585L14.7224 147.235C14.7566 147.107 14.825 146.996 14.9361 146.911C15.0386 146.825 15.1754 146.782 15.3121 146.782ZM15.3121 145.073C14.7994 145.073 14.2952 145.244 13.8935 145.552C13.5004 145.851 13.2098 146.278 13.0817 146.765L12.5262 148.56L10.817 149.141C10.817 149.141 10.7572 149.158 10.7316 149.175C10.2958 149.355 9.91975 149.645 9.64628 150.038C9.37282 150.431 9.22754 150.893 9.22754 151.38C9.22754 151.859 9.37282 152.329 9.64628 152.722C9.91975 153.106 10.2872 153.405 10.723 153.585C10.7572 153.593 10.7829 153.61 10.817 153.619L12.5262 154.2L13.0731 155.995C13.2013 156.473 13.4919 156.901 13.8935 157.208C14.2952 157.516 14.7994 157.687 15.3036 157.687C15.8078 157.687 16.312 157.516 16.7136 157.217C17.1152 156.909 17.4058 156.482 17.534 156.003L18.0895 154.209L19.7986 153.628C19.7986 153.628 19.8584 153.61 19.8841 153.593C20.3199 153.414 20.6959 153.123 20.9694 152.73C21.2428 152.337 21.3881 151.867 21.3881 151.389C21.3881 150.91 21.2428 150.44 20.9694 150.047C20.7045 149.662 20.337 149.363 19.8926 149.184C19.8584 149.175 19.8328 149.158 19.7986 149.15L18.0895 148.568L17.5425 146.774C17.4144 146.295 17.1238 145.868 16.7307 145.56C16.329 145.253 15.8248 145.082 15.3121 145.082V145.073Z", fill: "#121212" }))); };

var Bee6 = function (props) { return (React__namespace.createElement("svg", _tslib.__assign({ viewBox: "0 0 181 181", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React__namespace.createElement("path", { d: "M139.671 30.0155L139.264 29.9739C121.596 28.1199 114.687 22.907 112.002 18.8498C110.123 16.0147 109.649 12.7972 110.63 9.55471C111.985 5.58892 116.816 -0.405495 126.41 2.21342C139.521 5.78845 143.637 14.2438 139.771 29.6248L139.671 30.0238V30.0155Z", fill: "#F8F9F9" }),
    React__namespace.createElement("path", { d: "M140.295 30.9136L139.172 30.7972C121.181 28.9099 114.089 23.5058 111.304 19.3072C109.283 16.256 108.768 12.7973 109.832 9.30543C111.279 5.04865 116.442 -1.37808 126.626 1.3988C140.095 5.0736 144.526 14.1026 140.577 29.8078L140.295 30.9053V30.9136ZM121.962 2.40479C115.735 2.40479 112.451 6.76134 111.412 9.8209C110.506 12.7973 110.946 15.7654 112.692 18.3927C115.261 22.267 121.921 27.2637 139.039 29.1094C142.689 14.2689 138.84 6.45372 126.194 3.01171C124.656 2.59601 123.251 2.40479 121.971 2.40479H121.962Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M163.358 36.2848C157.679 36.2848 150.064 34.6303 139.979 29.7167L139.613 29.5421L139.729 29.1597C145.607 9.66328 157.887 10.0873 167.931 12.6397C170.134 13.1967 181.05 16.5307 179.479 27.156C179.254 28.6941 177.367 31.9282 173.293 34.0816C170.974 35.3037 167.739 36.2848 163.366 36.2848H163.358Z", fill: "#F8F9F9" }),
    React__namespace.createElement("path", { d: "M163.358 37.1158C156.657 37.1158 148.667 34.8793 139.613 30.4646L138.615 29.9824L138.931 28.9182C145.009 8.74836 157.729 9.189 168.13 11.8329C170.458 12.4232 181.965 15.94 180.293 27.2803C180.036 29.0429 178.057 32.5098 173.667 34.8211C170.766 36.3509 167.299 37.1241 163.349 37.1241L163.358 37.1158ZM140.619 29.1011C149.332 33.3163 156.981 35.453 163.358 35.453C167.033 35.453 170.242 34.7463 172.902 33.3412C176.851 31.2544 178.481 28.1866 178.656 27.0309C180.119 17.104 169.809 13.9696 167.731 13.4375C149.573 8.8315 143.803 18.7086 140.619 29.1011Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M172.719 62.9145C170.649 77.4973 149.44 88.663 125.67 85.2127C87.4341 79.7005 84.6988 65.0428 86.8438 50.5598C88.914 35.977 104.486 22.9323 134.009 27.1558C157.696 30.5978 174.79 48.4231 172.728 62.9145H172.719Z", fill: "#FCC018" }),
    React__namespace.createElement("path", { d: "M134.4 86.676C131.474 86.676 128.514 86.4681 125.546 86.0358C107.072 83.3753 95.3325 78.3786 89.6623 70.7713C84.7404 64.1616 85.1229 56.4379 86.0125 50.4435C87.1515 42.4371 92.0152 35.5614 99.7056 31.0967C108.452 26.0169 120.349 24.3707 134.109 26.3411C159.143 29.9743 175.571 48.7142 173.534 63.0392C172.753 68.5597 169.386 73.6895 163.807 77.8631C156.175 83.5749 145.599 86.676 134.392 86.676H134.4ZM123.234 27.1891C114.355 27.1891 106.64 28.9933 100.545 32.5267C93.3039 36.7336 88.7228 43.177 87.6586 50.6763C86.8189 56.3547 86.4365 63.6544 91.0009 69.7736C96.3967 77.0068 107.77 81.7873 125.787 84.3896C139.696 86.4099 153.539 83.4751 162.817 76.5329C168.039 72.6253 171.173 67.878 171.896 62.8064C173.817 49.2546 157.97 31.4875 133.885 27.9873C130.185 27.4552 126.626 27.1975 123.243 27.1975L123.234 27.1891Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M100.435 46.1313C101.552 43.9021 101.455 41.5931 100.22 40.974C98.984 40.355 97.0769 41.6603 95.9601 43.8895C94.8433 46.1187 94.9397 48.4276 96.1754 49.0467C97.4111 49.6658 99.3182 48.3605 100.435 46.1313Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M96.854 49.5621C96.563 49.5621 96.2803 49.4956 96.0142 49.3709C94.5759 48.6475 94.4097 46.1783 95.6402 43.734C96.8623 41.2979 98.9408 39.9428 100.379 40.6661C101.817 41.3894 101.984 43.8587 100.753 46.303C99.7556 48.2984 98.1759 49.5621 96.854 49.5621ZM99.5394 41.1815C98.5085 41.1815 97.1283 42.3455 96.2803 44.0499C95.2743 46.0619 95.2993 48.2069 96.3385 48.7307C97.3778 49.2545 99.1154 47.9907 100.121 45.9787C101.127 43.9667 101.102 41.8217 100.063 41.2979C99.9053 41.2148 99.7307 41.1815 99.5394 41.1815Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M97.7243 44.5737C98.0472 43.9292 98.0194 43.2616 97.6622 43.0827C97.3051 42.9037 96.7538 43.2812 96.4309 43.9257C96.108 44.5703 96.1357 45.2378 96.4929 45.4168C96.8501 45.5957 97.4014 45.2182 97.7243 44.5737Z", fill: "#F8F9F9" }),
    React__namespace.createElement("path", { d: "M108.668 49.7612C109.853 47.5672 109.827 45.2563 108.61 44.5998C107.394 43.9433 105.448 45.1897 104.264 47.3838C103.079 49.5778 103.105 51.8887 104.322 52.5452C105.538 53.2017 107.484 51.9553 108.668 49.7612Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M105.027 53.0615C104.702 53.0615 104.403 52.9867 104.129 52.8453C103.422 52.4629 103.023 51.6398 103.006 50.534C102.99 49.5031 103.314 48.3142 103.921 47.2084C104.519 46.0943 105.334 45.1798 106.207 44.6227C107.138 44.0241 108.053 43.9077 108.751 44.2902C109.458 44.6726 109.857 45.4957 109.874 46.6015C109.89 47.6324 109.566 48.8213 108.959 49.9271C108.36 51.0412 107.546 51.9557 106.673 52.5128C106.099 52.8786 105.534 53.0698 105.018 53.0698L105.027 53.0615ZM107.862 44.7724C107.487 44.7724 107.055 44.9221 106.598 45.213C105.825 45.7036 105.101 46.535 104.561 47.541C104.021 48.547 103.721 49.6112 103.738 50.5257C103.746 51.3654 104.012 51.964 104.486 52.2218C104.96 52.4712 105.608 52.3631 106.315 51.9141C107.088 51.4236 107.812 50.5922 108.352 49.5862C108.893 48.5802 109.192 47.516 109.175 46.6015C109.167 45.7618 108.901 45.1632 108.427 44.9054C108.261 44.814 108.069 44.7724 107.87 44.7724H107.862Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M105.926 48.2954C106.269 47.661 106.262 46.9929 105.91 46.8032C105.558 46.6134 104.996 46.9739 104.653 47.6082C104.311 48.2426 104.318 48.9107 104.67 49.1004C105.021 49.2902 105.584 48.9298 105.926 48.2954Z", fill: "#F8F9F9" }),
    React__namespace.createElement("path", { d: "M98.7495 61.8083C94.7754 61.8083 93.6863 58.6905 93.6697 58.6573C93.5616 58.333 93.7362 57.9838 94.0604 57.8757C94.3847 57.7677 94.7339 57.9423 94.8419 58.2665C94.8835 58.3912 95.8646 61.0268 99.7306 60.5113C100.055 60.4697 100.379 60.7025 100.421 61.0434C100.462 61.3843 100.229 61.6919 99.8886 61.7334C99.4812 61.7916 99.1071 61.8166 98.7495 61.8166V61.8083Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M98.7496 62.2238C94.4595 62.2238 93.2872 58.8151 93.2789 58.7818C93.1958 58.5324 93.2124 58.2497 93.3371 58.0086C93.4618 57.7592 93.6697 57.5763 93.9357 57.4932C94.4761 57.3103 95.0581 57.6012 95.241 58.1417C95.2743 58.2414 96.1389 60.5777 99.6807 60.1038C100.238 60.0289 100.762 60.428 100.845 60.985C100.878 61.2594 100.811 61.5338 100.645 61.7499C100.479 61.9661 100.238 62.1074 99.9634 62.149C99.556 62.2072 99.157 62.2322 98.7662 62.2322L98.7496 62.2238ZM94.26 58.258C94.26 58.258 94.2184 58.258 94.1935 58.2664C94.127 58.2913 94.0937 58.3412 94.0771 58.3661C94.0604 58.3911 94.0438 58.4493 94.0688 58.5158C94.1103 58.6322 95.108 61.3841 98.7496 61.3841C99.0987 61.3841 99.4646 61.3592 99.8387 61.3093C99.9135 61.301 99.9551 61.2594 99.9717 61.2345C99.9883 61.2095 100.022 61.1596 100.013 61.0848C99.9967 60.985 99.9052 60.8853 99.7805 60.9102C95.5736 61.4756 94.4928 58.5158 94.4512 58.3911C94.418 58.3079 94.3431 58.2497 94.26 58.2497V58.258Z", fill: "#121212" }),
    React__namespace.createElement("mask", { id: "mask0_3273_2836", style: { maskType: 'luminance' }, maskUnits: "userSpaceOnUse", x: "86", y: "26", width: "87", height: "60" },
        React__namespace.createElement("path", { d: "M172.719 62.9145C170.649 77.4973 149.44 88.663 125.67 85.2127C87.4341 79.7005 84.6988 65.0428 86.8438 50.5598C88.914 35.977 104.486 22.9323 134.009 27.1558C157.696 30.5978 174.79 48.4231 172.728 62.9145H172.719Z", fill: "white" })),
    React__namespace.createElement("g", { mask: "url(#mask0_3273_2836)" },
        React__namespace.createElement("path", { d: "M139.721 86.5846C143.105 86.3102 146.289 85.6451 149.324 84.8552C162.327 72.5754 164.646 45.5465 154.819 33.9069C151.336 31.7453 147.52 29.9744 143.371 28.5859C157.812 42.9526 151.843 72.3426 139.729 86.5763L139.721 86.5846Z", fill: "#121212" }),
        React__namespace.createElement("path", { d: "M138.89 87.0089L139.447 86.3521C150.671 73.1661 157.854 43.5099 143.113 28.844L142.032 27.7715L143.471 28.2537C147.619 29.6421 151.502 31.4463 154.994 33.6079L155.077 33.6828C165.228 45.6965 162.285 73.0995 149.557 85.1133L149.49 85.1798L149.399 85.2048C145.74 86.1526 142.673 86.7013 139.738 86.9424L138.881 87.0089H138.89ZM144.626 29.4093C150.571 36.0606 153.132 46.0291 151.851 57.677C150.687 68.2857 146.472 78.8528 140.536 86.1525C143.146 85.8865 145.907 85.371 149.133 84.5396C161.562 72.7171 164.455 45.9626 154.57 34.1899C151.527 32.3109 148.185 30.7063 144.618 29.4177L144.626 29.4093Z", fill: "#121212" }),
        React__namespace.createElement("path", { d: "M135.198 26.408C135.215 26.3248 129.004 25.8177 126.585 25.6348C135.489 39.0869 137.501 72.5757 117.764 84.7059C120.299 85.263 123.018 85.7618 125.928 86.2024C126.693 86.3438 127.391 86.377 128.156 86.5184C147.619 70.3975 144.975 36.3432 135.206 26.3997L135.198 26.408Z", fill: "#121212" }),
        React__namespace.createElement("path", { d: "M128.256 86.9005L128.09 86.8673C127.716 86.8008 127.358 86.7592 127.001 86.7093C126.626 86.6677 126.261 86.6178 125.87 86.543C122.985 86.1024 120.225 85.5952 117.697 85.0382L116.833 84.8469L117.581 84.3814C124.54 80.108 129.345 72.7085 131.49 62.9977C134.683 48.5646 131.291 33.3582 126.286 25.8091L125.887 25.2021L126.61 25.252C134.566 25.834 135.315 26.0169 135.456 26.125C135.456 26.125 135.464 26.1333 135.473 26.1416C140.561 31.3379 143.579 42.6782 142.98 54.3761C142.573 62.291 140.145 77.0235 128.381 86.7675L128.256 86.8756V86.9005ZM118.695 84.5393C120.973 85.0215 123.426 85.4622 125.986 85.853C126.369 85.9195 126.734 85.9694 127.092 86.0109C127.408 86.0525 127.732 86.0858 128.056 86.144C139.505 76.5745 141.883 62.1414 142.273 54.3677C142.855 42.8944 139.946 31.8035 135.015 26.7236C134.325 26.6155 129.952 26.2414 127.267 26.0419C132.139 33.9069 135.331 48.9221 132.188 63.1723C130.077 72.7334 125.421 80.0996 118.687 84.5393H118.695Z", fill: "#121212" }),
        React__namespace.createElement("path", { d: "M159.201 81.2548C167.057 76.6821 172.329 70.2471 173.351 63.0471C174.324 56.2047 171.406 48.6971 165.719 42.0459C171.156 53.4694 166.891 74.1048 159.201 81.2548Z", fill: "#121212" }),
        React__namespace.createElement("path", { d: "M156.615 83.1673L158.96 80.989C166.334 74.1299 170.874 53.7024 165.403 42.1958L164.247 39.7764L165.993 41.8133C171.929 48.7472 174.665 56.3046 173.709 63.0972C172.694 70.2223 167.606 76.7738 159.384 81.5627L156.623 83.1673H156.615ZM166.949 44.1329C170.707 55.1157 167.224 71.8186 161.171 79.6005C167.939 75.086 172.112 69.2496 173.002 62.9891C173.85 57.003 171.713 50.3768 166.949 44.1246V44.1329Z", fill: "#121212" })),
    React__namespace.createElement("path", { d: "M131.764 108.99C143.648 108.99 153.281 99.3571 153.281 87.4737C153.281 75.5904 143.648 65.957 131.764 65.957C119.881 65.957 110.248 75.5904 110.248 87.4737C110.248 99.3571 119.881 108.99 131.764 108.99Z", fill: "#FCC018" }),
    React__namespace.createElement("path", { d: "M131.765 109.813C119.443 109.813 109.417 99.7867 109.417 87.4653C109.417 75.1439 119.443 65.1172 131.765 65.1172C144.086 65.1172 154.113 75.1439 154.113 87.4653C154.113 99.7867 144.086 109.813 131.765 109.813ZM131.765 66.78C120.358 66.78 111.079 76.0584 111.079 87.4653C111.079 98.8721 120.358 108.151 131.765 108.151C143.171 108.151 152.45 98.8721 152.45 87.4653C152.45 76.0584 143.171 66.78 131.765 66.78Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M138.025 88.729C137.302 87.9059 136.113 87.2491 134.475 86.7586L130.75 85.6528C129.669 85.3203 128.888 84.9212 128.381 84.4556C127.882 83.9901 127.624 83.4247 127.624 82.7513C127.624 82.136 127.807 81.5873 128.165 81.1051C128.522 80.6229 129.013 80.2571 129.636 79.9827C130.26 79.7166 130.958 79.5836 131.74 79.6002C132.579 79.6085 133.336 79.7748 134.001 80.1074C134.675 80.4316 135.232 80.8889 135.664 81.4792C136.105 82.0695 136.387 82.7513 136.512 83.5328L138.998 83.0755C138.765 81.87 138.324 80.8307 137.668 79.966C137.011 79.1014 136.179 78.4363 135.173 77.9707C134.533 77.6714 133.827 77.4802 133.078 77.3721V74.9111H130.617V77.3222C129.761 77.4136 128.988 77.6215 128.289 77.9457C127.3 78.4113 126.535 79.0682 125.986 79.9079C125.438 80.7476 125.163 81.7369 125.163 82.8593C125.163 85.2538 126.519 86.875 129.237 87.723L133.777 89.1281C134.824 89.4524 135.572 89.8431 136.021 90.3004C136.47 90.7577 136.687 91.3646 136.687 92.1211C136.687 93.1521 136.271 93.9918 135.431 94.6486C134.591 95.3054 133.494 95.6297 132.147 95.6297C130.8 95.6297 129.653 95.2722 128.705 94.5572C127.749 93.8422 127.125 92.8694 126.834 91.6473L124.415 92.0463C124.623 93.2519 125.08 94.2994 125.77 95.189C126.46 96.0786 127.342 96.7604 128.414 97.2426C129.096 97.5502 129.827 97.7414 130.617 97.8578V100.286H133.078V97.916C134.076 97.8246 134.966 97.5918 135.764 97.2176C136.828 96.7188 137.651 96.0288 138.233 95.1308C138.815 94.2412 139.106 93.1937 139.106 92.0131C139.106 90.6413 138.74 89.5438 138.017 88.7207L138.025 88.729Z", fill: "black" }),
    React__namespace.createElement("path", { d: "M97.7851 101.782L99.0156 105.814C99.0655 105.981 99.1486 106.13 99.265 106.247C99.3814 106.371 99.531 106.463 99.689 106.529L103.48 107.835C103.696 107.926 103.879 108.067 104.004 108.259C104.137 108.45 104.204 108.666 104.204 108.899C104.204 109.132 104.137 109.348 104.004 109.539C103.879 109.73 103.696 109.872 103.48 109.963L99.6973 111.268C99.531 111.327 99.3897 111.426 99.2733 111.551C99.1569 111.676 99.0738 111.825 99.0239 111.992L97.8017 116.024C97.7518 116.24 97.6271 116.44 97.4442 116.581C97.2613 116.722 97.0368 116.797 96.8123 116.797C96.5879 116.797 96.355 116.722 96.1721 116.581C95.9892 116.44 95.8645 116.248 95.8146 116.024L94.5842 111.992C94.5343 111.825 94.4512 111.676 94.3348 111.551C94.2184 111.426 94.0687 111.335 93.9107 111.268L90.1196 109.971C89.9034 109.88 89.7205 109.739 89.5958 109.547C89.4711 109.356 89.3962 109.14 89.3962 108.907C89.3962 108.674 89.4627 108.458 89.5958 108.267C89.7288 108.076 89.9034 107.934 90.1196 107.843L93.9024 106.538C94.0604 106.479 94.2101 106.38 94.3265 106.255C94.4428 106.13 94.526 105.981 94.5759 105.814L95.798 101.782C95.8479 101.566 95.9726 101.366 96.1555 101.225C96.3385 101.084 96.5629 101.009 96.7874 101.009C97.0119 101.009 97.2446 101.084 97.4192 101.225C97.6022 101.366 97.7269 101.558 97.7768 101.782H97.7851Z", fill: "#F8F9F9" }),
    React__namespace.createElement("path", { d: "M96.7957 101.017C97.0285 101.017 97.253 101.092 97.4275 101.233C97.6105 101.375 97.7352 101.566 97.785 101.791L99.0156 105.823C99.0654 105.989 99.1486 106.139 99.265 106.255C99.3814 106.38 99.531 106.471 99.689 106.538L103.48 107.843C103.696 107.935 103.879 108.076 104.004 108.267C104.137 108.458 104.203 108.675 104.203 108.907C104.203 109.132 104.137 109.356 104.004 109.548C103.879 109.739 103.696 109.88 103.48 109.972L99.6973 111.277C99.531 111.335 99.3897 111.435 99.2733 111.559C99.1569 111.684 99.0738 111.834 99.0239 112L97.8017 116.032C97.7518 116.249 97.6271 116.448 97.4442 116.589C97.2613 116.731 97.0368 116.806 96.8123 116.806C96.5795 116.806 96.355 116.731 96.1804 116.589C95.9975 116.448 95.8728 116.257 95.8229 116.032L94.5925 112C94.5426 111.834 94.4595 111.684 94.3431 111.559C94.2267 111.435 94.077 111.343 93.9191 111.277L90.1279 109.972C89.9117 109.88 89.7288 109.739 89.6041 109.548C89.4794 109.356 89.4045 109.14 89.4045 108.907C89.4045 108.683 89.471 108.458 89.6041 108.267C89.7288 108.076 89.9117 107.935 90.1279 107.843L93.9107 106.538C94.0687 106.48 94.2184 106.38 94.3348 106.255C94.4511 106.13 94.5343 105.981 94.5842 105.814L95.8063 101.782C95.8562 101.566 95.9809 101.367 96.1638 101.225C96.3468 101.084 96.5712 101.009 96.7957 101.009M96.7957 99.3462C96.1971 99.3462 95.6151 99.5457 95.1412 99.9116C94.6756 100.269 94.343 100.776 94.2017 101.333L93.071 105.058L89.5791 106.263C89.5791 106.263 89.5209 106.288 89.496 106.297C88.9805 106.505 88.5398 106.862 88.2239 107.319C87.908 107.785 87.7334 108.334 87.7417 108.891C87.7417 109.456 87.908 109.996 88.2322 110.462C88.5482 110.919 88.9888 111.277 89.5043 111.485C89.5293 111.493 89.5625 111.51 89.5874 111.518L93.0793 112.715L94.2183 116.44C94.368 116.997 94.7006 117.504 95.1578 117.862C95.6317 118.227 96.2137 118.427 96.8123 118.427C97.4109 118.427 98.0012 118.227 98.4668 117.862C98.9324 117.504 99.2649 116.997 99.4063 116.44L100.537 112.715L104.029 111.51C104.029 111.51 104.087 111.485 104.112 111.476C104.628 111.26 105.068 110.911 105.384 110.445C105.7 109.98 105.866 109.439 105.866 108.874C105.866 108.309 105.7 107.768 105.376 107.303C105.06 106.845 104.628 106.488 104.104 106.28C104.079 106.272 104.046 106.255 104.021 106.247L100.52 105.05L99.3814 101.325C99.2317 100.768 98.8991 100.261 98.4336 99.9032C97.968 99.5374 97.3777 99.3379 96.7791 99.3379L96.7957 99.3462Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M60.372 97.8082L60.9041 99.5458C60.9207 99.6123 60.9623 99.6788 61.0122 99.737C61.0621 99.7869 61.1286 99.8285 61.1951 99.8534L62.8413 100.41C62.9327 100.444 63.0158 100.51 63.074 100.593C63.1322 100.676 63.1572 100.768 63.1572 100.868C63.1572 100.967 63.1239 101.059 63.074 101.142C63.0158 101.225 62.941 101.283 62.8413 101.325L61.1951 101.89C61.1286 101.915 61.0621 101.957 61.0122 102.015C60.9623 102.065 60.9207 102.131 60.9041 102.206L60.372 103.944C60.347 104.035 60.2972 104.118 60.214 104.185C60.1392 104.243 60.0395 104.276 59.9397 104.276C59.8399 104.276 59.7401 104.243 59.6653 104.185C59.5905 104.127 59.5323 104.044 59.5073 103.944L58.9752 102.206C58.9586 102.14 58.917 102.073 58.8671 102.015C58.8173 101.965 58.7508 101.924 58.6843 101.899L57.0381 101.342C56.9467 101.308 56.8635 101.242 56.8053 101.159C56.7471 101.076 56.7222 100.984 56.7222 100.884C56.7222 100.785 56.7554 100.693 56.8053 100.61C56.8635 100.527 56.9383 100.469 57.0381 100.427L58.6843 99.8617C58.7508 99.8368 58.8173 99.7952 58.8671 99.737C58.917 99.6871 58.9586 99.6206 58.9752 99.5458L59.5073 97.8082C59.5323 97.7167 59.5822 97.6336 59.6653 97.5671C59.7401 97.5089 59.8399 97.4756 59.9397 97.4756C60.0395 97.4756 60.1392 97.5089 60.214 97.5671C60.2972 97.6253 60.347 97.7084 60.372 97.8082Z", fill: "#F8F9F9" }),
    React__namespace.createElement("path", { d: "M59.9314 97.4753C60.0311 97.4753 60.1309 97.5086 60.2057 97.5668C60.2889 97.625 60.3388 97.7081 60.3637 97.8079L60.8958 99.5455C60.9124 99.612 60.954 99.6785 61.0038 99.7367C61.0537 99.7866 61.1203 99.8282 61.1868 99.8531L62.8329 100.41C62.9244 100.443 63.0076 100.51 63.0658 100.593C63.124 100.676 63.1489 100.768 63.1489 100.867C63.1489 100.967 63.1156 101.059 63.0658 101.142C63.0076 101.225 62.9327 101.283 62.8329 101.325L61.1868 101.89C61.1203 101.915 61.0537 101.957 61.0038 102.015C60.954 102.065 60.9124 102.131 60.8958 102.206L60.3637 103.944C60.3388 104.035 60.2889 104.118 60.2057 104.185C60.1309 104.243 60.0311 104.276 59.9314 104.276C59.8316 104.276 59.7318 104.243 59.657 104.185C59.5822 104.127 59.524 104.043 59.499 103.944L58.9669 102.206C58.9503 102.139 58.9087 102.073 58.8589 102.015C58.809 101.965 58.7424 101.923 58.6759 101.898L57.0298 101.341C56.9383 101.308 56.8551 101.242 56.797 101.158C56.7388 101.075 56.7138 100.984 56.7138 100.884C56.7138 100.784 56.7471 100.693 56.797 100.61C56.8551 100.527 56.93 100.468 57.0298 100.427L58.6759 99.8615C58.7424 99.8365 58.809 99.7949 58.8589 99.7367C58.9087 99.6868 58.9503 99.6203 58.9669 99.5455L59.499 97.8079C59.524 97.7164 59.5738 97.6333 59.657 97.5668C59.7318 97.5086 59.8316 97.4753 59.9314 97.4753ZM59.9314 95.8125C59.4658 95.8125 59.0085 95.9705 58.6427 96.2531C58.2852 96.5275 58.0191 96.9183 57.9027 97.3506L57.5618 98.473L56.4977 98.8388C56.4977 98.8388 56.4395 98.8638 56.4062 98.8721C56.0071 99.03 55.6745 99.3044 55.4334 99.6536C55.184 100.011 55.051 100.435 55.051 100.876C55.051 101.316 55.184 101.732 55.4334 102.098C55.6745 102.447 56.0155 102.721 56.4145 102.879C56.4395 102.888 56.4727 102.904 56.4977 102.913L57.5618 103.279L57.9111 104.401C58.0358 104.833 58.2935 105.224 58.651 105.498C59.0251 105.781 59.4741 105.931 59.9397 105.931C60.4053 105.931 60.8625 105.773 61.2283 105.498C61.5942 105.224 61.8519 104.833 61.9766 104.393L62.3175 103.27L63.3816 102.904C63.3816 102.904 63.4399 102.879 63.4731 102.871C63.8639 102.713 64.1964 102.447 64.4375 102.098C64.687 101.732 64.82 101.308 64.82 100.876C64.82 100.435 64.687 100.011 64.4375 99.6536C64.1964 99.3044 63.8556 99.0383 63.4565 98.8804C63.4316 98.8721 63.4066 98.8638 63.3734 98.8471L62.3092 98.4813L61.96 97.3589C61.8353 96.9183 61.5775 96.5358 61.2117 96.2531C60.8459 95.9788 60.3886 95.8208 59.9314 95.8208V95.8125Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M96.8207 16.7552L97.1699 17.8776C97.1865 17.9192 97.2031 17.9608 97.2364 18.0023C97.2696 18.0356 97.3112 18.0605 97.3528 18.0772L98.417 18.443C98.4752 18.4679 98.525 18.5095 98.5666 18.5594C98.5999 18.6093 98.6248 18.6758 98.6248 18.734C98.6248 18.7922 98.6082 18.8587 98.5666 18.9086C98.5333 18.9584 98.4752 19 98.417 19.025L97.3528 19.3908C97.3112 19.4074 97.2696 19.4323 97.2364 19.4656C97.2031 19.4989 97.1782 19.5404 97.1699 19.5903L96.829 20.7127C96.8124 20.7709 96.7791 20.8291 96.7292 20.8707C96.6794 20.9122 96.6128 20.9289 96.5463 20.9289C96.4798 20.9289 96.4216 20.9039 96.3634 20.8707C96.3135 20.8291 96.2803 20.7792 96.2637 20.7127L95.9144 19.5903C95.8978 19.5487 95.8812 19.5072 95.848 19.4656C95.8147 19.4323 95.7731 19.4074 95.7315 19.3908L94.6673 19.025C94.6091 19 94.5592 18.9584 94.5177 18.9086C94.4844 18.8587 94.4595 18.7922 94.4595 18.734C94.4595 18.6758 94.4761 18.6093 94.5177 18.5594C94.5509 18.5095 94.6091 18.4679 94.6673 18.443L95.7315 18.0772C95.7731 18.0605 95.8147 18.0356 95.848 18.0023C95.8812 17.9691 95.9061 17.9275 95.9144 17.8776L96.2553 16.7552C96.272 16.697 96.3052 16.6388 96.3551 16.5973C96.405 16.5557 96.4715 16.5391 96.538 16.5391C96.6045 16.5391 96.6627 16.564 96.7209 16.5973C96.7708 16.6388 96.804 16.6887 96.8207 16.7552Z", fill: "#F8F9F9" }),
    React__namespace.createElement("path", { d: "M96.5462 16.5388C96.6128 16.5388 96.671 16.5637 96.7292 16.597C96.7791 16.6386 96.8123 16.6884 96.8289 16.755L97.1781 17.8773C97.1947 17.9189 97.2114 17.9605 97.2446 18.0021C97.2779 18.0353 97.3195 18.0603 97.3611 18.0769L98.4335 18.4427C98.4917 18.4676 98.5416 18.5092 98.5832 18.5591C98.6164 18.609 98.6414 18.6755 98.6414 18.7337C98.6414 18.8002 98.6248 18.8584 98.5832 18.9083C98.5499 18.9582 98.4917 18.9997 98.4335 19.0247L97.3693 19.3905C97.3278 19.4071 97.2862 19.4321 97.253 19.4653C97.2197 19.4986 97.1948 19.5401 97.1864 19.59L96.8455 20.7124C96.8289 20.7706 96.7957 20.8288 96.7458 20.8704C96.6959 20.912 96.6294 20.9286 96.5629 20.9286C96.4964 20.9286 96.4381 20.9036 96.38 20.8704C96.3301 20.8288 96.2968 20.7789 96.2802 20.7124L95.931 19.59C95.9144 19.5485 95.8977 19.5069 95.8645 19.4653C95.8312 19.4321 95.7897 19.4071 95.7481 19.3905L94.6839 19.0247C94.6257 18.9997 94.5758 18.9582 94.5343 18.9083C94.501 18.8584 94.4761 18.7919 94.4761 18.7337C94.4761 18.6672 94.4927 18.609 94.5343 18.5591C94.5758 18.5092 94.6257 18.4676 94.6839 18.4427L95.7481 18.0769C95.7897 18.0603 95.8312 18.0353 95.8645 18.0021C95.8977 17.9688 95.9227 17.9272 95.931 17.8773L96.2719 16.755C96.2885 16.6968 96.3218 16.6386 96.3717 16.597C96.4216 16.5554 96.4881 16.5388 96.5546 16.5388M96.5546 14.876C96.1222 14.876 95.6982 15.0173 95.3573 15.2834C95.0248 15.5411 94.7837 15.8986 94.6756 16.2977L94.5426 16.73L94.1352 16.8713C94.1352 16.8713 94.077 16.8963 94.0437 16.9046C93.6779 17.0543 93.3703 17.2954 93.1542 17.6196C92.9297 17.9522 92.8049 18.3346 92.8049 18.742C92.8049 19.1494 92.9297 19.5318 93.1542 19.8644C93.3786 20.1886 93.6862 20.4297 94.052 20.5794C94.077 20.5877 94.1019 20.596 94.1352 20.6127L94.5426 20.754L94.6756 21.1863C94.792 21.5854 95.0331 21.9429 95.3657 22.2006C95.7065 22.4584 96.1305 22.5997 96.5546 22.5997C96.9869 22.5997 97.4026 22.4584 97.7435 22.2006C98.076 21.9429 98.3171 21.5854 98.4335 21.1863L98.5665 20.754L98.974 20.6127C98.974 20.6127 99.0322 20.5877 99.0654 20.5794C99.4229 20.4297 99.7305 20.1886 99.955 19.8727C100.188 19.5318 100.313 19.1494 100.304 18.742C100.304 18.3429 100.179 17.9522 99.9467 17.6196C99.7305 17.3037 99.4146 17.0543 99.0488 16.9046C99.0238 16.8963 98.9906 16.8797 98.9657 16.8713L98.5583 16.73L98.4252 16.2977C98.3088 15.8986 98.0677 15.5411 97.7351 15.2834C97.4026 15.0256 96.9786 14.8843 96.5462 14.8843L96.5546 14.876Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M79.5774 78.1128L80.1095 79.8505C80.1261 79.917 80.1676 79.9835 80.2175 80.0417C80.2674 80.0916 80.3339 80.1331 80.4004 80.1581L82.0466 80.7151C82.1381 80.7484 82.2212 80.8149 82.2794 80.898C82.3376 80.9812 82.3625 81.0726 82.3625 81.1724C82.3625 81.2722 82.3293 81.3636 82.2794 81.4467C82.2212 81.5299 82.1464 81.5881 82.0466 81.6297L80.4004 82.195C80.3339 82.22 80.2674 82.2615 80.2175 82.3197C80.1676 82.3696 80.1261 82.4361 80.1095 82.5109L79.5774 84.2486C79.5524 84.34 79.5025 84.4232 79.4194 84.4897C79.3446 84.5479 79.2448 84.5812 79.145 84.5812C79.0452 84.5812 78.9455 84.5479 78.8706 84.4897C78.7958 84.4315 78.7376 84.3484 78.7127 84.2486L78.1806 82.5109C78.164 82.4444 78.1224 82.3779 78.0725 82.3197C78.0226 82.2699 77.9561 82.2283 77.8896 82.2033L76.2434 81.6463C76.152 81.613 76.0688 81.5465 76.0106 81.4634C75.9524 81.3803 75.9275 81.2888 75.9275 81.189C75.9275 81.0892 75.9607 80.9978 76.0106 80.9147C76.0688 80.8315 76.1437 80.7733 76.2434 80.7318L77.8896 80.1664C77.9561 80.1415 78.0226 80.0999 78.0725 80.0417C78.1224 79.9918 78.164 79.9253 78.1806 79.8505L78.7127 78.1128C78.7376 78.0214 78.7875 77.9382 78.8706 77.8717C78.9455 77.8135 79.0452 77.7803 79.145 77.7803C79.2448 77.7803 79.3446 77.8135 79.4194 77.8717C79.5025 77.9299 79.5524 78.0131 79.5774 78.1128Z", fill: "#F8F9F9" }),
    React__namespace.createElement("path", { d: "M79.145 77.78C79.2447 77.78 79.3445 77.8132 79.4194 77.8714C79.5025 77.9296 79.5524 78.0128 79.5773 78.1125L80.1094 79.8502C80.1261 79.9167 80.1676 79.9832 80.2175 80.0414C80.2674 80.0913 80.3339 80.1329 80.4004 80.1578L82.0466 80.7149C82.138 80.7481 82.2212 80.8146 82.2794 80.8977C82.3376 80.9809 82.3625 81.0723 82.3625 81.1721C82.3625 81.2719 82.3293 81.3633 82.2794 81.4465C82.2212 81.5296 82.1463 81.5878 82.0466 81.6294L80.4004 82.1947C80.3339 82.2197 80.2674 82.2613 80.2175 82.3195C80.1676 82.3693 80.1261 82.4358 80.1094 82.5107L79.5773 84.2483C79.5524 84.3398 79.5025 84.4229 79.4194 84.4894C79.3445 84.5476 79.2447 84.5809 79.145 84.5809C79.0452 84.5809 78.9454 84.5476 78.8706 84.4894C78.7958 84.4312 78.7376 84.3481 78.7126 84.2483L78.1806 82.5107C78.1639 82.4441 78.1224 82.3777 78.0725 82.3195C78.0226 82.2696 77.9561 82.228 77.8896 82.203L76.2434 81.646C76.1519 81.6128 76.0688 81.5463 76.0106 81.4631C75.9524 81.38 75.9275 81.2885 75.9275 81.1887C75.9275 81.089 75.9607 80.9975 76.0106 80.9144C76.0688 80.8312 76.1436 80.773 76.2434 80.7315L77.8896 80.1661C77.9561 80.1412 78.0226 80.0996 78.0725 80.0414C78.1224 79.9915 78.1639 79.925 78.1806 79.8502L78.7126 78.1125C78.7376 78.0211 78.7875 77.938 78.8706 77.8714C78.9537 77.8049 79.0452 77.78 79.145 77.78ZM79.145 76.1172C78.6794 76.1172 78.2221 76.2752 77.8563 76.5578C77.4988 76.8322 77.2327 77.223 77.1164 77.6553L76.7755 78.7777L75.7113 79.1435C75.7113 79.1435 75.6531 79.1684 75.6198 79.1767C75.2208 79.3347 74.8882 79.6091 74.6471 79.9583C74.3977 80.3158 74.2646 80.7398 74.2646 81.1804C74.2646 81.6211 74.3977 82.0368 74.6471 82.4026C74.8882 82.7518 75.2291 83.0261 75.6282 83.1841C75.6531 83.1924 75.678 83.2007 75.7113 83.2174L76.7755 83.5832L77.1247 84.7056C77.2494 85.1379 77.5071 85.5287 77.8646 85.803C78.2388 86.0857 78.696 86.2354 79.1533 86.2354C79.6189 86.2354 80.0761 86.0774 80.442 85.803C80.8078 85.5287 81.0655 85.1379 81.1902 84.6973L81.5311 83.5749L82.5953 83.2091C82.5953 83.2091 82.6535 83.1841 82.6868 83.1758C83.0775 83.0178 83.4101 82.7518 83.6512 82.4026C83.9006 82.0368 84.0336 81.6128 84.0336 81.1804C84.0336 80.7398 83.9006 80.3158 83.6512 79.9583C83.4101 79.6091 83.0692 79.343 82.6701 79.1851C82.6452 79.1768 82.6203 79.1684 82.587 79.1518L81.5228 78.786L81.1736 77.6636C81.0489 77.2313 80.7911 76.8405 80.4253 76.5578C80.0595 76.2835 79.6022 76.1255 79.145 76.1255V76.1172Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M173.692 103.129L174.399 105.415C174.424 105.507 174.474 105.59 174.54 105.665C174.607 105.731 174.69 105.79 174.781 105.823L176.951 106.563C177.076 106.613 177.176 106.696 177.251 106.804C177.326 106.912 177.367 107.037 177.367 107.161C177.367 107.286 177.326 107.419 177.251 107.519C177.176 107.627 177.076 107.71 176.951 107.76L174.781 108.5C174.69 108.533 174.607 108.591 174.54 108.658C174.474 108.724 174.424 108.816 174.399 108.907L173.701 111.194C173.667 111.318 173.601 111.427 173.493 111.51C173.393 111.584 173.26 111.634 173.127 111.634C172.994 111.634 172.869 111.593 172.761 111.51C172.661 111.427 172.587 111.318 172.553 111.194L171.847 108.907C171.822 108.816 171.772 108.733 171.705 108.658C171.639 108.591 171.556 108.533 171.464 108.5L169.294 107.76C169.169 107.71 169.07 107.627 168.995 107.519C168.92 107.411 168.878 107.286 168.878 107.161C168.878 107.037 168.92 106.904 168.995 106.804C169.07 106.696 169.169 106.613 169.294 106.563L171.464 105.823C171.556 105.79 171.639 105.731 171.705 105.665C171.772 105.598 171.822 105.507 171.847 105.415L172.545 103.129C172.578 103.004 172.645 102.896 172.753 102.813C172.853 102.73 172.986 102.688 173.119 102.688C173.252 102.688 173.376 102.73 173.484 102.813C173.593 102.896 173.659 103.004 173.692 103.129Z", fill: "#F8F9F9" }),
    React__namespace.createElement("path", { d: "M173.127 102.689C173.26 102.689 173.385 102.73 173.493 102.813C173.601 102.897 173.667 103.005 173.701 103.129L174.407 105.416C174.432 105.507 174.482 105.59 174.549 105.665C174.615 105.732 174.698 105.79 174.79 105.823L176.96 106.563C177.084 106.613 177.184 106.696 177.259 106.804C177.334 106.912 177.375 107.037 177.375 107.162C177.375 107.286 177.334 107.419 177.259 107.519C177.184 107.627 177.084 107.71 176.96 107.76L174.79 108.5C174.698 108.533 174.615 108.592 174.549 108.658C174.482 108.725 174.432 108.816 174.407 108.908L173.709 111.194C173.676 111.319 173.609 111.427 173.501 111.51C173.401 111.585 173.268 111.635 173.135 111.635C173.002 111.635 172.877 111.593 172.769 111.51C172.67 111.427 172.595 111.319 172.562 111.194L171.855 108.908C171.83 108.816 171.78 108.733 171.713 108.658C171.647 108.592 171.564 108.533 171.472 108.5L169.302 107.76C169.178 107.71 169.078 107.627 169.003 107.519C168.928 107.411 168.887 107.286 168.887 107.162C168.887 107.037 168.928 106.904 169.003 106.804C169.078 106.704 169.178 106.613 169.302 106.563L171.472 105.823C171.564 105.79 171.647 105.732 171.713 105.665C171.78 105.599 171.83 105.507 171.855 105.416L172.553 103.129C172.586 103.005 172.653 102.897 172.761 102.813C172.869 102.73 172.994 102.689 173.127 102.689ZM173.127 101.026C172.628 101.026 172.138 101.192 171.747 101.491C171.364 101.791 171.082 102.206 170.957 102.672L170.425 104.418L168.762 104.983C168.762 104.983 168.704 105.008 168.671 105.017C168.247 105.191 167.881 105.482 167.623 105.856C167.357 106.239 167.216 106.696 167.216 107.162C167.216 107.627 167.357 108.084 167.623 108.467C167.881 108.841 168.247 109.132 168.679 109.307C168.704 109.315 168.729 109.323 168.762 109.34L170.425 109.905L170.965 111.651C171.09 112.117 171.373 112.533 171.755 112.824C172.154 113.123 172.636 113.289 173.135 113.289C173.634 113.289 174.116 113.123 174.507 112.824C174.898 112.524 175.18 112.108 175.305 111.643L175.837 109.897L177.5 109.332C177.5 109.332 177.558 109.307 177.591 109.298C178.015 109.124 178.373 108.841 178.631 108.467C178.897 108.076 179.038 107.627 179.038 107.153C179.038 106.679 178.897 106.23 178.622 105.84C178.365 105.466 177.999 105.175 177.575 105.008C177.55 105 177.525 104.992 177.492 104.975L175.829 104.41L175.288 102.664C175.164 102.198 174.881 101.782 174.49 101.483C174.108 101.184 173.617 101.018 173.119 101.018L173.127 101.026Z", fill: "#121212" }))); };

var Bee7 = function (props) { return (React__namespace.createElement("svg", _tslib.__assign({ viewBox: "0 0 342 81", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React__namespace.createElement("path", { d: "M314.067 20.6686L313.794 20.6405C301.957 19.3873 297.328 15.8639 295.529 13.1215C294.27 11.2052 293.953 9.03045 294.61 6.83882C295.518 4.15828 298.754 0.10656 305.183 1.87673C313.967 4.29315 316.724 10.0083 314.134 20.4045L314.067 20.6742V20.6686Z", fill: "#F8F9F9" }),
    React__namespace.createElement("path", { d: "M314.485 21.2753L313.733 21.1966C301.679 19.921 296.927 16.2683 295.061 13.4304C293.707 11.368 293.362 9.03025 294.075 6.67003C295.044 3.79281 298.504 -0.551124 305.327 1.32581C314.351 3.80967 317.32 9.91253 314.674 20.5279L314.485 21.2697V21.2753ZM302.202 2.00578C298.03 2.00578 295.83 4.95044 295.133 7.01844C294.526 9.03025 294.822 11.0364 295.991 12.8122C297.713 15.4309 302.174 18.8083 313.644 20.0559C316.089 10.0249 313.51 4.74251 305.038 2.41601C304.007 2.13503 303.066 2.00578 302.208 2.00578H302.202Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M329.937 24.9061C326.133 24.9061 321.03 23.7878 314.273 20.4667L314.028 20.3487L314.106 20.0902C318.045 6.91225 326.272 7.19884 333.001 8.92405C334.477 9.30057 341.791 11.554 340.738 18.7358C340.588 19.7755 339.324 21.9615 336.594 23.417C335.04 24.243 332.873 24.9061 329.943 24.9061H329.937Z", fill: "#F8F9F9" }),
    React__namespace.createElement("path", { d: "M329.937 25.4679C325.448 25.4679 320.095 23.9563 314.028 20.9723L313.36 20.6463L313.572 19.927C317.644 6.29391 326.166 6.59175 333.135 8.37878C334.695 8.77777 342.404 11.1548 341.284 18.82C341.112 20.0113 339.786 22.3547 336.845 23.9169C334.901 24.9509 332.578 25.4735 329.932 25.4735L329.937 25.4679ZM314.702 20.0506C320.54 22.8998 325.665 24.344 329.937 24.344C332.4 24.344 334.55 23.8663 336.332 22.9166C338.978 21.5061 340.07 19.4325 340.187 18.6514C341.167 11.9416 334.26 9.82301 332.868 9.46336C320.702 6.35011 316.836 13.0262 314.702 20.0506Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M336.21 42.9052C334.823 52.7619 320.613 60.309 304.687 57.9769C279.068 54.2511 277.236 44.3438 278.673 34.5545C280.06 24.6977 290.493 15.8806 310.274 18.7354C326.144 21.0619 337.597 33.1103 336.215 42.9052H336.21Z", fill: "#FCC018" }),
    React__namespace.createElement("path", { d: "M310.536 58.9657C308.575 58.9657 306.592 58.8252 304.603 58.533C292.226 56.7347 284.36 53.3574 280.561 48.2155C277.264 43.7479 277.52 38.5273 278.116 34.4756C278.879 29.0639 282.138 24.4166 287.29 21.3988C293.151 17.9653 301.122 16.8526 310.341 18.1844C327.114 20.6402 338.121 33.3067 336.756 42.9893C336.232 46.7207 333.976 50.1879 330.239 53.009C325.125 56.8696 318.039 58.9657 310.53 58.9657H310.536ZM303.055 18.7576C297.106 18.7576 291.936 19.9771 287.853 22.3654C283.001 25.2089 279.932 29.5641 279.219 34.6329C278.656 38.4711 278.4 43.4051 281.458 47.5411C285.073 52.4301 292.694 55.6614 304.765 57.4203C314.084 58.7859 323.359 56.8022 329.576 52.1098C333.074 49.4686 335.174 46.2599 335.659 42.8319C336.945 33.672 326.328 21.663 310.191 19.2971C307.712 18.9375 305.328 18.7633 303.06 18.7633L303.055 18.7576Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M287.779 31.5605C288.527 30.0538 288.463 28.4931 287.635 28.0746C286.807 27.6562 285.529 28.5385 284.781 30.0452C284.033 31.552 284.097 33.1126 284.925 33.5311C285.753 33.9495 287.031 33.0673 287.779 31.5605Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M285.38 33.8797C285.185 33.8797 284.995 33.8347 284.817 33.7505C283.853 33.2615 283.742 31.5925 284.566 29.9404C285.385 28.2938 286.778 27.3778 287.742 27.8668C288.705 28.3557 288.817 30.0247 287.992 31.6768C287.324 33.0255 286.265 33.8797 285.38 33.8797ZM287.179 28.2152C286.488 28.2152 285.564 29.0019 284.995 30.1539C284.321 31.5139 284.338 32.9637 285.034 33.3177C285.731 33.6718 286.895 32.8176 287.569 31.4577C288.243 30.0977 288.226 28.6479 287.53 28.2938C287.424 28.2376 287.307 28.2152 287.179 28.2152Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M285.963 30.5085C286.179 30.0729 286.16 29.6217 285.921 29.5007C285.682 29.3798 285.312 29.6349 285.096 30.0706C284.88 30.5062 284.898 30.9574 285.138 31.0784C285.377 31.1993 285.746 30.9442 285.963 30.5085Z", fill: "#F8F9F9" }),
    React__namespace.createElement("path", { d: "M293.295 34.0145C294.089 32.5315 294.072 30.9696 293.257 30.5259C292.442 30.0821 291.138 30.9246 290.344 32.4076C289.551 33.8906 289.568 35.4525 290.383 35.8963C291.198 36.34 292.502 35.4975 293.295 34.0145Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M290.855 36.2459C290.638 36.2459 290.438 36.1953 290.254 36.0998C289.78 35.8413 289.513 35.285 289.502 34.5375C289.491 33.8407 289.708 33.0371 290.115 32.2897C290.516 31.5367 291.062 30.9185 291.646 30.542C292.27 30.1374 292.883 30.0587 293.351 30.3172C293.825 30.5757 294.092 31.1321 294.103 31.8795C294.114 32.5763 293.897 33.3799 293.49 34.1273C293.089 34.8803 292.543 35.4985 291.958 35.875C291.574 36.1223 291.195 36.2515 290.85 36.2515L290.855 36.2459ZM292.755 30.6432C292.504 30.6432 292.215 30.7443 291.908 30.941C291.39 31.2726 290.906 31.8345 290.544 32.5145C290.181 33.1945 289.981 33.9138 289.992 34.5319C289.998 35.0995 290.176 35.5041 290.493 35.6783C290.811 35.8469 291.245 35.7739 291.719 35.4704C292.237 35.1388 292.722 34.5769 293.084 33.8969C293.446 33.2169 293.646 32.4976 293.635 31.8795C293.63 31.3119 293.451 30.9073 293.134 30.7331C293.022 30.6713 292.894 30.6432 292.761 30.6432H292.755Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M291.459 33.024C291.688 32.5953 291.683 32.1437 291.447 32.0154C291.212 31.8872 290.835 32.1308 290.606 32.5596C290.376 32.9884 290.381 33.4399 290.617 33.5682C290.852 33.6964 291.229 33.4528 291.459 33.024Z", fill: "#F8F9F9" }),
    React__namespace.createElement("path", { d: "M286.65 42.1572C283.987 42.1572 283.257 40.0499 283.246 40.0274C283.174 39.8082 283.291 39.5722 283.508 39.4992C283.725 39.4261 283.959 39.5441 284.032 39.7633C284.06 39.8476 284.717 41.629 287.307 41.2806C287.524 41.2525 287.742 41.4098 287.769 41.6402C287.797 41.8706 287.641 42.0785 287.413 42.1066C287.14 42.146 286.889 42.1628 286.65 42.1628V42.1572Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M286.65 42.4386C283.775 42.4386 282.99 40.1346 282.984 40.1121C282.929 39.9435 282.94 39.7524 283.023 39.5895C283.107 39.4209 283.246 39.2973 283.424 39.2411C283.787 39.1174 284.176 39.3141 284.299 39.6794C284.321 39.7468 284.901 41.3259 287.274 41.0056C287.647 40.955 287.998 41.2248 288.053 41.6013C288.076 41.7867 288.031 41.9722 287.92 42.1183C287.808 42.2644 287.647 42.3599 287.463 42.388C287.19 42.4274 286.923 42.4442 286.661 42.4442L286.65 42.4386ZM283.642 39.7581C283.642 39.7581 283.614 39.7581 283.597 39.7637C283.553 39.7805 283.53 39.8143 283.519 39.8311C283.508 39.848 283.497 39.8873 283.514 39.9323C283.541 40.0109 284.21 41.871 286.65 41.871C286.884 41.871 287.129 41.8542 287.379 41.8204C287.43 41.8148 287.457 41.7867 287.469 41.7699C287.48 41.753 287.502 41.7193 287.496 41.6687C287.485 41.6013 287.424 41.5339 287.34 41.5507C284.522 41.9328 283.798 39.9323 283.77 39.848C283.748 39.7918 283.697 39.7524 283.642 39.7524V39.7581Z", fill: "#121212" }),
    React__namespace.createElement("mask", { id: "mask0_3275_2784", style: { maskType: 'luminance' }, maskUnits: "userSpaceOnUse", x: "278", y: "18", width: "59", height: "41" },
        React__namespace.createElement("path", { d: "M336.21 42.9052C334.823 52.7619 320.613 60.309 304.687 57.9769C279.068 54.2511 277.236 44.3438 278.673 34.5545C280.06 24.6977 290.493 15.8806 310.274 18.7354C326.144 21.0619 337.597 33.1103 336.215 42.9052H336.21Z", fill: "white" })),
    React__namespace.createElement("g", { mask: "url(#mask0_3275_2784)" },
        React__namespace.createElement("path", { d: "M314.101 58.9043C316.368 58.7189 318.501 58.2693 320.535 57.7355C329.247 49.4353 330.801 31.1661 324.217 23.2987C321.883 21.8376 319.326 20.6406 316.546 19.7021C326.222 29.4128 322.223 49.278 314.106 58.8987L314.101 58.9043Z", fill: "#121212" }),
        React__namespace.createElement("path", { d: "M313.544 59.1909L313.917 58.7469C321.437 49.8343 326.25 29.7892 316.373 19.8763L315.649 19.1514L316.613 19.4773C319.393 20.4158 321.994 21.6352 324.334 23.0963L324.389 23.1469C331.191 31.2672 329.219 49.7893 320.69 57.9096L320.646 57.9546L320.585 57.9714C318.134 58.6121 316.078 58.9829 314.112 59.1459L313.538 59.1909H313.544ZM317.387 20.2584C321.37 24.7541 323.086 31.492 322.228 39.365C321.448 46.5356 318.624 53.6781 314.647 58.612C316.396 58.4322 318.245 58.0838 320.406 57.5218C328.734 49.5308 330.673 31.447 324.049 23.4897C322.011 22.2196 319.771 21.1351 317.382 20.264L317.387 20.2584Z", fill: "#121212" }),
        React__namespace.createElement("path", { d: "M311.07 18.2297C311.081 18.1735 306.92 17.8307 305.299 17.707C311.265 26.7995 312.613 49.4352 299.389 57.6341C301.088 58.0107 302.91 58.3478 304.859 58.6457C305.372 58.7412 305.84 58.7637 306.352 58.8592C319.393 47.9628 317.621 24.945 311.076 18.224L311.07 18.2297Z", fill: "#121212" }),
        React__namespace.createElement("path", { d: "M306.419 59.1179L306.308 59.0955C306.057 59.0505 305.818 59.0224 305.578 58.9887C305.327 58.9606 305.082 58.9269 304.82 58.8763C302.887 58.5785 301.038 58.2357 299.345 57.8591L298.765 57.7299L299.267 57.4152C303.929 54.5267 307.149 49.5253 308.586 42.9616C310.725 33.2061 308.452 22.9279 305.099 17.8253L304.832 17.415L305.316 17.4488C310.647 17.8421 311.148 17.9658 311.243 18.0388C311.243 18.0388 311.249 18.0444 311.254 18.0501C314.663 21.5623 316.685 29.2274 316.284 37.1341C316.011 42.484 314.385 52.4419 306.503 59.028L306.419 59.1011V59.1179ZM300.013 57.522C301.539 57.8479 303.183 58.1458 304.898 58.4099C305.155 58.4548 305.4 58.4885 305.639 58.5166C305.851 58.5447 306.068 58.5672 306.285 58.6066C313.956 52.1384 315.549 42.3828 315.811 37.1285C316.201 29.3735 314.251 21.877 310.948 18.4434C310.486 18.3704 307.556 18.1175 305.756 17.9826C309.021 23.2987 311.16 33.4477 309.054 43.0797C307.639 49.5422 304.52 54.5211 300.008 57.522H300.013Z", fill: "#121212" }),
        React__namespace.createElement("path", { d: "M327.152 55.3027C332.416 52.2119 335.948 47.8624 336.633 42.9958C337.285 38.3709 335.33 33.2964 331.52 28.8008C335.163 36.5221 332.305 50.4699 327.152 55.3027Z", fill: "#121212" }),
        React__namespace.createElement("path", { d: "M325.42 56.5952L326.991 55.1229C331.932 50.4867 334.973 36.6794 331.308 28.9019L330.534 27.2666L331.703 28.6434C335.681 33.3301 337.513 38.4383 336.873 43.0295C336.193 47.8455 332.784 52.2737 327.275 55.5106L325.425 56.5952H325.42ZM332.344 30.2113C334.862 37.6347 332.528 48.9245 328.473 54.1844C333.007 51.1329 335.803 47.188 336.399 42.9565C336.967 38.9104 335.536 34.4316 332.344 30.2056V30.2113Z", fill: "#121212" })),
    React__namespace.createElement("path", { d: "M308.77 74.0488C316.732 74.0488 323.186 67.5375 323.186 59.5054C323.186 51.4732 316.732 44.9619 308.77 44.9619C300.808 44.9619 294.354 51.4732 294.354 59.5054C294.354 67.5375 300.808 74.0488 308.77 74.0488Z", fill: "#FCC018" }),
    React__namespace.createElement("path", { d: "M308.77 74.6054C300.515 74.6054 293.797 67.8282 293.797 59.5C293.797 51.1717 300.515 44.3945 308.77 44.3945C317.025 44.3945 323.743 51.1717 323.743 59.5C323.743 67.8282 317.025 74.6054 308.77 74.6054ZM308.77 45.5184C301.127 45.5184 294.911 51.7899 294.911 59.5C294.911 67.21 301.127 73.4815 308.77 73.4815C316.413 73.4815 322.629 67.21 322.629 59.5C322.629 51.7899 316.413 45.5184 308.77 45.5184Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M312.964 60.3534C312.48 59.7971 311.683 59.3531 310.586 59.0216L308.09 58.2742C307.366 58.0494 306.843 57.7797 306.503 57.465C306.169 57.1503 305.996 56.7681 305.996 56.3129C305.996 55.8971 306.118 55.5262 306.358 55.2002C306.597 54.8743 306.926 54.6271 307.344 54.4416C307.762 54.2618 308.23 54.1719 308.753 54.1831C309.316 54.1887 309.823 54.3011 310.268 54.5259C310.72 54.7451 311.093 55.0541 311.383 55.4531C311.678 55.8521 311.867 56.3129 311.951 56.8412L313.616 56.5321C313.46 55.7173 313.165 55.0148 312.725 54.4304C312.285 53.8459 311.728 53.3964 311.054 53.0817C310.625 52.8794 310.151 52.7501 309.65 52.6771V51.0137H308.001V52.6433C307.427 52.7052 306.909 52.8457 306.442 53.0648C305.779 53.3795 305.266 53.8235 304.899 54.391C304.531 54.9586 304.347 55.6273 304.347 56.386C304.347 58.0044 305.255 59.1002 307.077 59.6734L310.118 60.6232C310.82 60.8423 311.321 61.1064 311.622 61.4155C311.923 61.7246 312.068 62.1348 312.068 62.6462C312.068 63.343 311.789 63.9106 311.227 64.3545C310.664 64.7985 309.929 65.0177 309.026 65.0177C308.124 65.0177 307.355 64.776 306.72 64.2927C306.079 63.8095 305.662 63.152 305.467 62.3259L303.846 62.5956C303.985 63.4105 304.291 64.1185 304.754 64.7198C305.216 65.3211 305.806 65.7819 306.525 66.1079C306.982 66.3158 307.472 66.445 308.001 66.5237V68.1646H309.65V66.563C310.319 66.5012 310.915 66.3439 311.449 66.091C312.162 65.7538 312.714 65.2874 313.104 64.6805C313.494 64.0792 313.689 63.3711 313.689 62.5731C313.689 61.6459 313.444 60.9041 312.959 60.3478L312.964 60.3534Z", fill: "black" }),
    React__namespace.createElement("path", { d: "M286.004 69.1769L286.828 71.9024C286.861 72.0148 286.917 72.116 286.995 72.1946C287.073 72.2789 287.173 72.3407 287.279 72.3857L289.819 73.268C289.964 73.3298 290.087 73.4253 290.17 73.5546C290.259 73.6838 290.304 73.8299 290.304 73.9873C290.304 74.1446 290.259 74.2907 290.17 74.42C290.087 74.5492 289.964 74.6448 289.819 74.7066L287.285 75.5889C287.173 75.6282 287.079 75.6956 287.001 75.7799C286.923 75.8642 286.867 75.9654 286.834 76.0778L286.015 78.8033C285.981 78.9494 285.898 79.0842 285.775 79.1798C285.653 79.2753 285.502 79.3259 285.352 79.3259C285.201 79.3259 285.045 79.2753 284.923 79.1798C284.8 79.0842 284.717 78.955 284.683 78.8033L283.859 76.0778C283.826 75.9654 283.77 75.8642 283.692 75.7799C283.614 75.6956 283.514 75.6338 283.408 75.5889L280.868 74.7122C280.723 74.6504 280.6 74.5549 280.517 74.4256C280.433 74.2964 280.383 74.1502 280.383 73.9929C280.383 73.8355 280.428 73.6894 280.517 73.5602C280.606 73.4309 280.723 73.3354 280.868 73.2736L283.402 72.3913C283.508 72.352 283.608 72.2845 283.686 72.2002C283.764 72.116 283.82 72.0148 283.853 71.9024L284.672 69.1769C284.706 69.0308 284.789 68.8959 284.912 68.8004C285.034 68.7049 285.185 68.6543 285.335 68.6543C285.486 68.6543 285.642 68.7049 285.758 68.8004C285.881 68.8959 285.965 69.0252 285.998 69.1769H286.004Z", fill: "#F8F9F9" }),
    React__namespace.createElement("path", { d: "M285.341 68.6596C285.497 68.6596 285.647 68.7101 285.764 68.8057C285.887 68.9012 285.97 69.0305 286.004 69.1822L286.828 71.9077C286.862 72.0201 286.917 72.1212 286.995 72.1999C287.073 72.2842 287.173 72.346 287.279 72.391L289.819 73.2732C289.964 73.335 290.087 73.4306 290.17 73.5598C290.259 73.6891 290.304 73.8352 290.304 73.9925C290.304 74.1443 290.259 74.296 290.17 74.4253C290.087 74.5545 289.964 74.65 289.819 74.7118L287.285 75.5941C287.173 75.6335 287.079 75.7009 287.001 75.7852C286.923 75.8695 286.867 75.9706 286.834 76.083L286.015 78.8085C285.981 78.9546 285.898 79.0895 285.775 79.185C285.653 79.2806 285.502 79.3311 285.352 79.3311C285.196 79.3311 285.046 79.2806 284.929 79.185C284.806 79.0895 284.722 78.9602 284.689 78.8085L283.865 76.083C283.831 75.9706 283.776 75.8695 283.698 75.7852C283.62 75.7009 283.519 75.6391 283.413 75.5941L280.873 74.7118C280.728 74.65 280.606 74.5545 280.522 74.4253C280.439 74.296 280.389 74.1499 280.389 73.9925C280.389 73.8408 280.433 73.6891 280.522 73.5598C280.606 73.4306 280.728 73.335 280.873 73.2732L283.408 72.391C283.514 72.3516 283.614 72.2842 283.692 72.1999C283.77 72.1156 283.826 72.0144 283.859 71.9021L284.678 69.1766C284.711 69.0305 284.795 68.8956 284.917 68.8001C285.04 68.7045 285.19 68.6539 285.341 68.6539M285.341 67.53C284.94 67.53 284.55 67.6649 284.232 67.9122C283.92 68.1538 283.698 68.4966 283.603 68.8731L282.845 71.3907L280.506 72.2055C280.506 72.2055 280.467 72.2224 280.45 72.228C280.105 72.3685 279.809 72.6101 279.598 72.9192C279.386 73.2339 279.269 73.6048 279.275 73.9813C279.275 74.3634 279.386 74.7287 279.603 75.0434C279.815 75.3525 280.11 75.5941 280.456 75.7346C280.472 75.7402 280.495 75.7515 280.511 75.7571L282.851 76.5663L283.614 79.0839C283.714 79.4604 283.937 79.8032 284.243 80.0448C284.561 80.2921 284.951 80.427 285.352 80.427C285.753 80.427 286.148 80.2921 286.46 80.0448C286.772 79.8032 286.995 79.4604 287.09 79.0839L287.847 76.5663L290.187 75.7515C290.187 75.7515 290.226 75.7346 290.243 75.729C290.588 75.5829 290.883 75.3469 291.095 75.0322C291.307 74.7175 291.418 74.3522 291.418 73.9701C291.418 73.5879 291.307 73.2227 291.089 72.908C290.878 72.5989 290.588 72.3573 290.237 72.2168C290.22 72.2111 290.198 72.1999 290.181 72.1943L287.836 71.3851L287.073 68.8675C286.973 68.491 286.75 68.1482 286.438 67.9065C286.126 67.6593 285.731 67.5244 285.33 67.5244L285.341 67.53Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M220.32 64.1485L218.65 61.8584C218.582 61.7638 218.496 61.6872 218.396 61.6393C218.295 61.5861 218.18 61.5616 218.065 61.5548L215.376 61.5774C215.219 61.5679 215.072 61.5191 214.951 61.4254C214.824 61.3336 214.734 61.211 214.683 61.0628C214.631 60.9146 214.626 60.762 214.668 60.6103C214.704 60.4605 214.789 60.3293 214.906 60.2224L217.013 58.5397C217.106 58.4652 217.173 58.3699 217.219 58.2643C217.265 58.1587 217.285 58.0447 217.28 57.9276L217.163 55.0853C217.147 54.9365 217.182 54.7813 217.266 54.6502C217.351 54.519 217.477 54.4208 217.619 54.3703C217.761 54.3197 217.925 54.315 218.072 54.3638C218.219 54.4126 218.34 54.5062 218.421 54.6379L220.092 56.928C220.16 57.0226 220.246 57.0991 220.347 57.1523C220.448 57.2055 220.563 57.23 220.678 57.2368L223.366 57.209C223.523 57.2185 223.67 57.2673 223.791 57.361C223.912 57.4546 224.007 57.5754 224.059 57.7236C224.11 57.8718 224.116 58.0244 224.074 58.1761C224.032 58.3278 223.952 58.4571 223.836 58.564L221.728 60.2467C221.641 60.3193 221.568 60.4165 221.522 60.5221C221.476 60.6277 221.457 60.7417 221.462 60.8588L221.578 63.7011C221.595 63.8499 221.56 64.005 221.475 64.1362C221.391 64.2674 221.265 64.3656 221.123 64.4161C220.981 64.4666 220.817 64.4714 220.675 64.4207C220.528 64.3719 220.406 64.2783 220.325 64.1466L220.32 64.1485Z", fill: "#F8F9F9" }),
    React__namespace.createElement("path", { d: "M221.116 64.4127C220.968 64.4652 220.809 64.4681 220.668 64.4174C220.521 64.3686 220.399 64.2749 220.318 64.1433L218.648 61.8532C218.58 61.7586 218.494 61.6821 218.395 61.6342C218.293 61.581 218.178 61.5564 218.064 61.5497L215.374 61.5723C215.217 61.5627 215.07 61.5139 214.949 61.4203C214.822 61.3285 214.732 61.2058 214.681 61.0576C214.631 60.9147 214.624 60.7568 214.666 60.6051C214.703 60.4553 214.787 60.3242 214.904 60.2173L217.011 58.5346C217.104 58.4601 217.171 58.3648 217.217 58.2592C217.264 58.1536 217.283 58.0396 217.278 57.9225L217.161 55.0802C217.145 54.9314 217.18 54.7763 217.264 54.6451C217.349 54.514 217.475 54.4158 217.617 54.3652C217.764 54.3128 217.923 54.3099 218.065 54.3606C218.212 54.4094 218.333 54.503 218.414 54.6347L220.084 56.9248C220.153 57.0194 220.238 57.0959 220.34 57.1491C220.441 57.2023 220.556 57.2268 220.671 57.2336L223.36 57.211C223.517 57.2206 223.664 57.2694 223.786 57.363C223.907 57.4567 224.002 57.5775 224.053 57.7257C224.103 57.8686 224.11 58.0264 224.068 58.1781C224.032 58.328 223.947 58.4591 223.83 58.566L221.723 60.2487C221.636 60.3213 221.563 60.4185 221.517 60.5241C221.471 60.6297 221.451 60.7437 221.456 60.8608L221.573 63.703C221.589 63.8519 221.554 64.007 221.47 64.1382C221.385 64.2693 221.26 64.3675 221.117 64.418M221.485 65.4766C221.864 65.3419 222.188 65.0838 222.408 64.7442C222.624 64.4118 222.722 64.014 222.689 63.6276L222.582 61.0018L224.527 59.4481C224.527 59.4481 224.558 59.4191 224.572 59.4082C224.853 59.1598 225.053 58.833 225.152 58.4708C225.249 58.1032 225.238 57.7146 225.11 57.3619C224.985 57.0019 224.76 56.6953 224.452 56.4719C224.151 56.252 223.793 56.1236 223.421 56.1073C223.403 56.1076 223.378 56.1045 223.361 56.1049L220.885 56.1289L219.341 54.0141C219.123 53.6932 218.8 53.4452 218.431 53.3205C218.051 53.1943 217.638 53.1983 217.259 53.3331C216.88 53.4679 216.55 53.7278 216.336 54.0655C216.12 54.398 216.021 54.7957 216.055 55.1822L216.162 57.808L214.217 59.3616C214.217 59.3616 214.185 59.3906 214.171 59.4015C213.893 59.6552 213.691 59.9767 213.593 60.3442C213.496 60.7118 213.51 61.0933 213.635 61.4532C213.76 61.8131 213.985 62.1197 214.293 62.3431C214.594 62.5631 214.947 62.6933 215.325 62.7077C215.342 62.7074 215.367 62.7105 215.385 62.7102L217.866 62.6843L219.41 64.7991C219.628 65.12 219.951 65.368 220.324 65.4908C220.7 65.6188 221.118 65.613 221.497 65.4782L221.485 65.4766Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M260.937 66.4904L261.293 67.6649C261.304 67.7099 261.332 67.7548 261.366 67.7942C261.399 67.8279 261.444 67.856 261.488 67.8728L262.591 68.2493C262.652 68.2718 262.708 68.3168 262.747 68.373C262.786 68.4292 262.803 68.491 262.803 68.5584C262.803 68.6259 262.78 68.6877 262.747 68.7439C262.708 68.8001 262.658 68.8394 262.591 68.8675L261.488 69.2496C261.444 69.2665 261.399 69.2946 261.366 69.3339C261.332 69.3676 261.304 69.4126 261.293 69.4632L260.937 70.6377C260.92 70.6995 260.886 70.7557 260.831 70.8006C260.781 70.84 260.714 70.8625 260.647 70.8625C260.58 70.8625 260.513 70.84 260.463 70.8006C260.413 70.7613 260.374 70.7051 260.357 70.6377L260.001 69.4632C259.99 69.4182 259.962 69.3733 259.928 69.3339C259.895 69.3002 259.85 69.2721 259.806 69.2552L258.703 68.8787C258.642 68.8563 258.586 68.8113 258.547 68.7551C258.508 68.6989 258.491 68.6371 258.491 68.5697C258.491 68.5022 258.513 68.4404 258.547 68.3842C258.586 68.328 258.636 68.2887 258.703 68.2606L259.806 67.8785C259.85 67.8616 259.895 67.8335 259.928 67.7942C259.962 67.7604 259.99 67.7155 260.001 67.6649L260.357 66.4904C260.374 66.4286 260.407 66.3724 260.463 66.3274C260.513 66.2881 260.58 66.2656 260.647 66.2656C260.714 66.2656 260.781 66.2881 260.831 66.3274C260.886 66.3668 260.92 66.423 260.937 66.4904Z", fill: "#F8F9F9" }),
    React__namespace.createElement("path", { d: "M260.641 66.2655C260.708 66.2655 260.775 66.288 260.825 66.3273C260.881 66.3667 260.914 66.4229 260.931 66.4903L261.288 67.6648C261.299 67.7098 261.327 67.7547 261.36 67.794C261.393 67.8278 261.438 67.8559 261.483 67.8727L262.585 68.2492C262.647 68.2717 262.702 68.3167 262.741 68.3729C262.78 68.4291 262.797 68.4909 262.797 68.5583C262.797 68.6257 262.775 68.6876 262.741 68.7438C262.702 68.7999 262.652 68.8393 262.585 68.8674L261.483 69.2495C261.438 69.2664 261.393 69.2945 261.36 69.3338C261.327 69.3675 261.299 69.4125 261.288 69.4631L260.931 70.6375C260.914 70.6994 260.881 70.7556 260.825 70.8005C260.775 70.8399 260.708 70.8623 260.641 70.8623C260.575 70.8623 260.508 70.8399 260.458 70.8005C260.407 70.7612 260.368 70.705 260.352 70.6375L259.995 69.4631C259.984 69.4181 259.956 69.3732 259.923 69.3338C259.889 69.3001 259.845 69.272 259.8 69.2551L258.697 68.8786C258.636 68.8562 258.58 68.8112 258.541 68.755C258.502 68.6988 258.486 68.637 258.486 68.5695C258.486 68.5021 258.508 68.4403 258.541 68.3841C258.58 68.3279 258.631 68.2886 258.697 68.2605L259.8 67.8784C259.845 67.8615 259.889 67.8334 259.923 67.794C259.956 67.7603 259.984 67.7154 259.995 67.6648L260.352 66.4903C260.368 66.4285 260.402 66.3723 260.458 66.3273C260.508 66.288 260.575 66.2655 260.641 66.2655ZM260.641 65.1416C260.329 65.1416 260.023 65.2484 259.778 65.4394C259.538 65.6249 259.36 65.889 259.282 66.1812L259.054 66.9399L258.341 67.1871C258.341 67.1871 258.302 67.204 258.28 67.2096C258.012 67.3164 257.789 67.5018 257.628 67.7379C257.461 67.9795 257.372 68.2661 257.372 68.5639C257.372 68.8618 257.461 69.1427 257.628 69.39C257.789 69.626 258.018 69.8115 258.285 69.9182C258.302 69.9239 258.324 69.9351 258.341 69.9407L259.054 70.188L259.288 70.9466C259.371 71.2389 259.544 71.503 259.784 71.6884C260.034 71.8795 260.335 71.9806 260.647 71.9806C260.959 71.9806 261.265 71.8739 261.51 71.6884C261.756 71.503 261.928 71.2388 262.012 70.941L262.24 70.1824L262.953 69.9351C262.953 69.9351 262.992 69.9183 263.014 69.9126C263.276 69.8059 263.499 69.626 263.661 69.39C263.828 69.1427 263.917 68.8562 263.917 68.5639C263.917 68.2661 263.828 67.9795 263.661 67.7379C263.499 67.5018 263.271 67.322 263.003 67.2152C262.987 67.2096 262.97 67.204 262.948 67.1928L262.235 66.9455L262.001 66.1869C261.917 65.889 261.744 65.6305 261.499 65.4394C261.254 65.254 260.948 65.1472 260.641 65.1472V65.1416Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M187.612 53.8776L186.891 52.8912C186.866 52.8526 186.824 52.8196 186.78 52.7938C186.737 52.7733 186.686 52.7618 186.638 52.7609L185.473 52.7769C185.408 52.7763 185.34 52.7527 185.285 52.7129C185.23 52.673 185.194 52.6204 185.172 52.5569C185.15 52.4934 185.151 52.4277 185.164 52.3635C185.182 52.2975 185.217 52.2436 185.271 52.1947L186.188 51.4641C186.225 51.4333 186.258 51.3918 186.277 51.3435C186.297 51.3005 186.309 51.2488 186.303 51.1975L186.256 49.9714C186.252 49.9076 186.265 49.8434 186.303 49.7824C186.337 49.7285 186.393 49.6848 186.456 49.6624C186.52 49.6399 186.59 49.6386 186.65 49.6588C186.711 49.679 186.766 49.7189 186.804 49.7768L187.525 50.7632C187.55 50.8018 187.591 50.8347 187.635 50.8606C187.678 50.8811 187.729 50.8926 187.777 50.8935L188.942 50.8775C189.008 50.8781 189.075 50.9017 189.13 50.9415C189.185 50.9813 189.221 51.034 189.243 51.0975C189.266 51.161 189.265 51.2267 189.251 51.2908C189.233 51.3569 189.198 51.4108 189.144 51.4597L188.227 52.1903C188.19 52.2211 188.157 52.2626 188.139 52.3108C188.118 52.3538 188.106 52.4055 188.112 52.4569L188.159 53.6829C188.164 53.7468 188.15 53.8109 188.112 53.872C188.078 53.9259 188.022 53.9695 187.959 53.992C187.896 54.0145 187.825 54.0157 187.765 53.9955C187.699 53.9772 187.649 53.9355 187.612 53.8776Z", fill: "#F8F9F9" }),
    React__namespace.createElement("path", { d: "M187.964 53.9904C187.901 54.0129 187.83 54.0142 187.77 53.994C187.705 53.9756 187.655 53.9339 187.617 53.876L186.896 52.8896C186.871 52.851 186.83 52.8181 186.785 52.7922C186.743 52.7717 186.691 52.7602 186.644 52.7593L185.478 52.7753C185.413 52.7747 185.346 52.7511 185.29 52.7113C185.235 52.6715 185.199 52.6189 185.177 52.5553C185.155 52.4918 185.156 52.4261 185.169 52.362C185.188 52.2959 185.222 52.242 185.276 52.1931L186.194 51.4626C186.23 51.4317 186.263 51.3903 186.282 51.342C186.303 51.299 186.314 51.2473 186.308 51.1959L186.261 49.97C186.257 49.9061 186.27 49.842 186.308 49.7809C186.343 49.727 186.398 49.6833 186.462 49.6609C186.525 49.6384 186.595 49.6371 186.656 49.6573C186.716 49.6775 186.771 49.7174 186.809 49.7753L187.53 50.7617C187.555 50.8003 187.596 50.8332 187.64 50.8591C187.683 50.8796 187.734 50.8911 187.782 50.892L188.948 50.876C189.013 50.8766 189.08 50.9002 189.135 50.94C189.191 50.9798 189.227 51.0324 189.249 51.096C189.271 51.1595 189.27 51.2252 189.257 51.2893C189.238 51.3554 189.204 51.4093 189.15 51.4582L188.232 52.1887C188.195 52.2196 188.162 52.261 188.144 52.3093C188.123 52.3523 188.112 52.404 188.118 52.4554L188.164 53.6813C188.169 53.7452 188.156 53.8093 188.118 53.8704C188.083 53.9243 188.027 53.968 187.964 53.9904ZM188.331 55.049C188.626 54.9442 188.881 54.7406 189.05 54.4783C189.216 54.2232 189.298 53.9145 189.276 53.6131L189.244 52.8218L189.837 52.3493C189.837 52.3493 189.869 52.3203 189.888 52.3075C190.106 52.1171 190.256 51.8676 190.331 51.591C190.41 51.3073 190.401 51.0074 190.304 50.7269C190.206 50.4463 190.03 50.2117 189.791 50.0349C189.562 49.8669 189.285 49.769 188.997 49.7583C188.98 49.7586 188.955 49.7555 188.937 49.7558L188.183 49.7625L187.714 49.1266C187.539 48.8795 187.289 48.6888 187.002 48.5946C186.703 48.4989 186.386 48.5047 186.091 48.6095C185.796 48.7143 185.541 48.9178 185.37 49.1749C185.199 49.4319 185.122 49.7387 185.141 50.0473L185.173 50.8385L184.58 51.311C184.58 51.311 184.548 51.34 184.529 51.3528C184.316 51.5413 184.165 51.7856 184.089 52.0622C184.012 52.3512 184.021 52.6511 184.117 52.9263C184.214 53.2068 184.392 53.4468 184.629 53.6182C184.859 53.7862 185.134 53.8789 185.421 53.8896C185.439 53.8893 185.456 53.8889 185.481 53.892L186.236 53.8853L186.705 54.5212C186.881 54.7737 187.129 54.9591 187.423 55.0567C187.716 55.149 188.04 55.1466 188.33 55.0437L188.331 55.049Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M285.357 11.7057L285.591 12.4643C285.602 12.4924 285.614 12.5205 285.636 12.5486C285.658 12.5711 285.686 12.588 285.714 12.5992L286.427 12.8465C286.466 12.8633 286.499 12.8914 286.527 12.9251C286.549 12.9588 286.566 13.0038 286.566 13.0431C286.566 13.0825 286.555 13.1274 286.527 13.1612C286.505 13.1949 286.466 13.223 286.427 13.2398L285.714 13.4871C285.686 13.4983 285.658 13.5152 285.636 13.5377C285.614 13.5601 285.597 13.5882 285.591 13.622L285.363 14.3806C285.352 14.4199 285.33 14.4593 285.296 14.4874C285.263 14.5155 285.218 14.5267 285.174 14.5267C285.129 14.5267 285.09 14.5099 285.051 14.4874C285.018 14.4593 284.995 14.4256 284.984 14.3806L284.75 13.622C284.739 13.5939 284.728 13.5658 284.706 13.5377C284.683 13.5152 284.656 13.4983 284.628 13.4871L283.915 13.2398C283.876 13.223 283.842 13.1949 283.814 13.1612C283.792 13.1274 283.775 13.0825 283.775 13.0431C283.775 13.0038 283.787 12.9588 283.814 12.9251C283.837 12.8914 283.876 12.8633 283.915 12.8465L284.628 12.5992C284.656 12.588 284.683 12.5711 284.706 12.5486C284.728 12.5261 284.745 12.498 284.75 12.4643L284.979 11.7057C284.99 11.6663 285.012 11.627 285.045 11.5989C285.079 11.5708 285.123 11.5596 285.168 11.5596C285.213 11.5596 285.252 11.5764 285.291 11.5989C285.324 11.627 285.346 11.6607 285.357 11.7057Z", fill: "#F8F9F9" }),
    React__namespace.createElement("path", { d: "M285.174 11.5595C285.218 11.5595 285.257 11.5763 285.296 11.5988C285.33 11.6269 285.352 11.6606 285.363 11.7056L285.597 12.4642C285.608 12.4923 285.619 12.5204 285.642 12.5485C285.664 12.571 285.692 12.5878 285.72 12.5991L286.438 12.8464C286.477 12.8632 286.511 12.8913 286.538 12.925C286.561 12.9587 286.577 13.0037 286.577 13.043C286.577 13.088 286.566 13.1273 286.538 13.161C286.516 13.1948 286.477 13.2229 286.438 13.2397L285.725 13.487C285.697 13.4982 285.669 13.5151 285.647 13.5376C285.625 13.56 285.608 13.5881 285.603 13.6218L285.374 14.3805C285.363 14.4198 285.341 14.4592 285.307 14.4873C285.274 14.5154 285.229 14.5266 285.185 14.5266C285.14 14.5266 285.101 14.5097 285.062 14.4873C285.029 14.4592 285.007 14.4254 284.995 14.3805L284.761 13.6218C284.75 13.5937 284.739 13.5657 284.717 13.5376C284.695 13.5151 284.667 13.4982 284.639 13.487L283.926 13.2397C283.887 13.2229 283.854 13.1948 283.826 13.161C283.803 13.1273 283.787 13.0824 283.787 13.043C283.787 12.9981 283.798 12.9587 283.826 12.925C283.854 12.8913 283.887 12.8632 283.926 12.8464L284.639 12.5991C284.667 12.5878 284.695 12.571 284.717 12.5485C284.739 12.526 284.756 12.4979 284.761 12.4642L284.99 11.7056C285.001 11.6662 285.023 11.6269 285.057 11.5988C285.09 11.5707 285.135 11.5595 285.179 11.5595M285.179 10.4355C284.89 10.4355 284.606 10.5311 284.377 10.7109C284.154 10.8851 283.993 11.1268 283.92 11.3965L283.831 11.6887L283.558 11.7843C283.558 11.7843 283.519 11.8011 283.497 11.8067C283.252 11.9079 283.046 12.0708 282.901 12.29C282.751 12.5148 282.667 12.7733 282.667 13.0487C282.667 13.324 282.751 13.5825 282.901 13.8073C283.051 14.0265 283.257 14.1894 283.503 14.2906C283.519 14.2962 283.536 14.3018 283.558 14.3131L283.831 14.4086L283.92 14.7008C283.998 14.9705 284.16 15.2122 284.383 15.3864C284.611 15.5606 284.895 15.6561 285.179 15.6561C285.469 15.6561 285.747 15.5606 285.976 15.3864C286.199 15.2122 286.36 14.9705 286.438 14.7008L286.527 14.4086L286.8 14.3131C286.8 14.3131 286.839 14.2962 286.862 14.2906C287.101 14.1894 287.307 14.0265 287.458 13.8129C287.614 13.5825 287.697 13.324 287.692 13.0487C287.692 12.7789 287.608 12.5148 287.452 12.29C287.307 12.0765 287.095 11.9079 286.85 11.8067C286.834 11.8011 286.811 11.7899 286.795 11.7843L286.522 11.6887L286.433 11.3965C286.355 11.1268 286.193 10.8851 285.97 10.7109C285.747 10.5367 285.463 10.4412 285.174 10.4412L285.179 10.4355Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M273.804 53.1779L274.161 54.3524C274.172 54.3974 274.2 54.4423 274.233 54.4816C274.267 54.5154 274.311 54.5435 274.356 54.5603L275.459 54.9368C275.52 54.9593 275.576 55.0043 275.615 55.0605C275.654 55.1167 275.67 55.1785 275.67 55.2459C275.67 55.3133 275.648 55.3752 275.615 55.4314C275.576 55.4875 275.526 55.5269 275.459 55.555L274.356 55.9371C274.311 55.954 274.267 55.9821 274.233 56.0214C274.2 56.0551 274.172 56.1001 274.161 56.1507L273.804 57.3252C273.788 57.387 273.754 57.4432 273.698 57.4881C273.648 57.5275 273.581 57.5499 273.515 57.5499C273.448 57.5499 273.381 57.5275 273.331 57.4881C273.281 57.4488 273.242 57.3926 273.225 57.3252L272.868 56.1507C272.857 56.1057 272.829 56.0608 272.796 56.0214C272.763 55.9877 272.718 55.9596 272.673 55.9427L271.571 55.5662C271.509 55.5438 271.454 55.4988 271.415 55.4426C271.376 55.3864 271.359 55.3246 271.359 55.2571C271.359 55.1897 271.381 55.1279 271.415 55.0717C271.454 55.0155 271.504 54.9762 271.571 54.9481L272.673 54.566C272.718 54.5491 272.763 54.521 272.796 54.4816C272.829 54.4479 272.857 54.403 272.868 54.3524L273.225 53.1779C273.242 53.1161 273.275 53.0599 273.331 53.0149C273.381 52.9756 273.448 52.9531 273.515 52.9531C273.581 52.9531 273.648 52.9756 273.698 53.0149C273.754 53.0543 273.788 53.1105 273.804 53.1779Z", fill: "#F8F9F9" }),
    React__namespace.createElement("path", { d: "M273.515 52.953C273.582 52.953 273.648 52.9755 273.699 53.0148C273.754 53.0542 273.788 53.1104 273.804 53.1778L274.161 54.3523C274.172 54.3973 274.2 54.4422 274.233 54.4815C274.267 54.5153 274.311 54.5434 274.356 54.5602L275.459 54.9367C275.52 54.9592 275.576 55.0042 275.615 55.0604C275.654 55.1165 275.67 55.1784 275.67 55.2458C275.67 55.3132 275.648 55.375 275.615 55.4312C275.576 55.4874 275.526 55.5268 275.459 55.5549L274.356 55.937C274.311 55.9539 274.267 55.982 274.233 56.0213C274.2 56.055 274.172 56.1 274.161 56.1506L273.804 57.3251C273.788 57.3869 273.754 57.4431 273.699 57.488C273.648 57.5273 273.582 57.5498 273.515 57.5498C273.448 57.5498 273.381 57.5273 273.331 57.488C273.281 57.4487 273.242 57.3925 273.225 57.3251L272.869 56.1506C272.857 56.1056 272.83 56.0606 272.796 56.0213C272.763 55.9876 272.718 55.9595 272.674 55.9426L271.571 55.5661C271.509 55.5436 271.454 55.4987 271.415 55.4425C271.376 55.3863 271.359 55.3245 271.359 55.257C271.359 55.1896 271.381 55.1278 271.415 55.0716C271.454 55.0154 271.504 54.9761 271.571 54.948L272.674 54.5658C272.718 54.549 272.763 54.5209 272.796 54.4815C272.83 54.4478 272.857 54.4029 272.869 54.3523L273.225 53.1778C273.242 53.116 273.275 53.0598 273.331 53.0148C273.387 52.9699 273.448 52.953 273.515 52.953ZM273.515 51.8291C273.203 51.8291 272.896 51.9359 272.651 52.1269C272.412 52.3124 272.234 52.5765 272.156 52.8687L271.927 53.6274L271.214 53.8746C271.214 53.8746 271.175 53.8915 271.153 53.8971C270.885 54.0039 270.663 54.1893 270.501 54.4254C270.334 54.667 270.245 54.9536 270.245 55.2514C270.245 55.5493 270.334 55.8302 270.501 56.0775C270.663 56.3135 270.891 56.499 271.158 56.6057C271.175 56.6114 271.192 56.617 271.214 56.6282L271.927 56.8755L272.161 57.6341C272.245 57.9263 272.417 58.1905 272.657 58.3759C272.908 58.567 273.214 58.6681 273.52 58.6681C273.832 58.6681 274.139 58.5614 274.384 58.3759C274.629 58.1905 274.801 57.9263 274.885 57.6285L275.113 56.8699L275.826 56.6226C275.826 56.6226 275.865 56.6057 275.888 56.6001C276.15 56.4934 276.372 56.3135 276.534 56.0775C276.701 55.8302 276.79 55.5436 276.79 55.2514C276.79 54.9536 276.701 54.667 276.534 54.4254C276.372 54.1893 276.144 54.0095 275.877 53.9027C275.86 53.8971 275.843 53.8915 275.821 53.8802L275.108 53.633L274.874 52.8743C274.79 52.5821 274.618 52.318 274.373 52.1269C274.127 51.9415 273.821 51.8347 273.515 51.8347V51.8291Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M246.236 53.8757L245.515 52.8893C245.49 52.8507 245.449 52.8177 245.405 52.7918C245.362 52.7713 245.311 52.7598 245.263 52.7589L244.098 52.7749C244.032 52.7743 243.965 52.7507 243.91 52.7109C243.855 52.6711 243.819 52.6185 243.797 52.555C243.774 52.4914 243.775 52.4257 243.789 52.3616C243.807 52.2955 243.842 52.2416 243.896 52.1927L244.813 51.4622C244.85 51.4313 244.883 51.3899 244.902 51.3416C244.922 51.2986 244.934 51.2469 244.928 51.1955L244.881 49.9695C244.876 49.9056 244.89 49.8415 244.928 49.7804C244.962 49.7265 245.018 49.6829 245.081 49.6604C245.144 49.638 245.215 49.6367 245.275 49.6569C245.335 49.6771 245.391 49.7169 245.428 49.7748L246.149 50.7612C246.174 50.7998 246.216 50.8328 246.26 50.8586C246.303 50.8792 246.354 50.8906 246.402 50.8915L247.567 50.8755C247.632 50.8761 247.7 50.8997 247.755 50.9396C247.81 50.9794 247.846 51.032 247.868 51.0955C247.89 51.159 247.889 51.2247 247.876 51.2889C247.858 51.3549 247.823 51.4088 247.769 51.4578L246.852 52.1883C246.815 52.2192 246.782 52.2606 246.763 52.3089C246.743 52.3519 246.731 52.4036 246.737 52.455L246.784 53.681C246.788 53.7448 246.775 53.809 246.737 53.8701C246.703 53.924 246.647 53.9676 246.584 53.9901C246.52 54.0125 246.45 54.0138 246.39 53.9936C246.324 53.9753 246.274 53.9336 246.236 53.8757Z", fill: "#F8F9F9" }),
    React__namespace.createElement("path", { d: "M246.584 53.9904C246.521 54.0129 246.45 54.0142 246.39 53.994C246.324 53.9756 246.274 53.9339 246.236 53.876L245.516 52.8896C245.49 52.851 245.449 52.8181 245.405 52.7922C245.362 52.7717 245.311 52.7602 245.263 52.7593L244.098 52.7753C244.032 52.7747 243.965 52.7511 243.91 52.7113C243.855 52.6715 243.819 52.6189 243.797 52.5554C243.775 52.4918 243.775 52.4261 243.789 52.362C243.807 52.296 243.842 52.2421 243.896 52.1931L244.813 51.4626C244.85 51.4317 244.883 51.3903 244.902 51.342C244.922 51.299 244.934 51.2473 244.928 51.196L244.881 49.9699C244.876 49.9061 244.89 49.842 244.928 49.7809C244.962 49.727 245.018 49.6834 245.081 49.6609C245.144 49.6384 245.215 49.6371 245.275 49.6573C245.335 49.6776 245.391 49.7174 245.429 49.7753L246.149 50.7617C246.175 50.8003 246.216 50.8333 246.26 50.8591C246.303 50.8796 246.354 50.8911 246.402 50.892L247.567 50.876C247.632 50.8766 247.7 50.9002 247.755 50.94C247.81 50.9798 247.846 51.0324 247.868 51.096C247.89 51.1595 247.889 51.2252 247.876 51.2893C247.858 51.3554 247.823 51.4093 247.769 51.4582L246.852 52.1887C246.815 52.2196 246.782 52.261 246.763 52.3093C246.743 52.3523 246.731 52.404 246.737 52.4554L246.784 53.6814C246.788 53.7452 246.775 53.8094 246.737 53.8704C246.699 53.9315 246.647 53.968 246.584 53.9904ZM246.951 55.049C247.246 54.9442 247.501 54.7406 247.67 54.4783C247.836 54.2232 247.918 53.9145 247.896 53.6131L247.864 52.8218L248.457 52.3493C248.457 52.3493 248.488 52.3203 248.508 52.3076C248.725 52.1171 248.875 51.8676 248.951 51.591C249.03 51.3073 249.021 51.0074 248.923 50.7269C248.826 50.4464 248.65 50.2117 248.411 50.0349C248.181 49.8669 247.905 49.769 247.617 49.7583C247.599 49.7586 247.582 49.7589 247.557 49.7558L246.802 49.7626L246.333 49.1266C246.159 48.8795 245.909 48.6888 245.622 48.5946C245.323 48.4989 245 48.5066 244.71 48.6095C244.416 48.7143 244.161 48.9178 243.99 49.1749C243.819 49.4319 243.742 49.7387 243.76 50.0473L243.792 50.8386L243.199 51.311C243.199 51.311 243.168 51.34 243.149 51.3528C242.936 51.5413 242.784 51.7856 242.709 52.0621C242.632 52.3512 242.641 52.6511 242.736 52.9263C242.834 53.2068 243.012 53.4468 243.249 53.6182C243.479 53.7862 243.753 53.8789 244.041 53.8896C244.058 53.8893 244.076 53.889 244.101 53.8921L244.856 53.8853L245.325 54.5212C245.499 54.7684 245.749 54.9591 246.043 55.0567C246.335 55.149 246.66 55.1466 246.949 55.0437L246.951 55.049Z", fill: "#121212" }),
    React__namespace.createElement("path", { d: "M336.862 70.0869L337.335 71.6323C337.352 71.6941 337.385 71.7503 337.43 71.8009C337.474 71.8458 337.53 71.8852 337.591 71.9076L339.045 72.4078C339.129 72.4415 339.196 72.4977 339.246 72.5707C339.296 72.6438 339.324 72.7281 339.324 72.8124C339.324 72.8967 339.296 72.9866 339.246 73.054C339.196 73.1271 339.129 73.1833 339.045 73.217L337.591 73.7171C337.53 73.7396 337.474 73.779 337.43 73.8239C337.385 73.8689 337.352 73.9307 337.335 73.9925L336.867 75.5379C336.845 75.6222 336.8 75.6952 336.728 75.7514C336.661 75.802 336.572 75.8357 336.483 75.8357C336.394 75.8357 336.31 75.8076 336.238 75.7514C336.171 75.6952 336.121 75.6222 336.098 75.5379L335.625 73.9925C335.608 73.9307 335.575 73.8745 335.53 73.8239C335.486 73.779 335.43 73.7396 335.369 73.7171L333.915 73.217C333.831 73.1833 333.764 73.1271 333.714 73.054C333.664 72.981 333.636 72.8967 333.636 72.8124C333.636 72.7281 333.664 72.6382 333.714 72.5707C333.764 72.4977 333.831 72.4415 333.915 72.4078L335.369 71.9076C335.43 71.8852 335.486 71.8458 335.53 71.8009C335.575 71.7559 335.608 71.6941 335.625 71.6323L336.093 70.0869C336.115 70.0026 336.16 69.9295 336.232 69.8734C336.299 69.8172 336.388 69.7891 336.477 69.7891C336.566 69.7891 336.65 69.8172 336.722 69.8734C336.795 69.9295 336.839 70.0026 336.862 70.0869Z", fill: "#F8F9F9" }),
    React__namespace.createElement("path", { d: "M336.483 69.7887C336.572 69.7887 336.656 69.8168 336.728 69.873C336.8 69.9292 336.845 70.0023 336.867 70.0866L337.341 71.6319C337.357 71.6938 337.391 71.7499 337.435 71.8005C337.48 71.8455 337.536 71.8848 337.597 71.9073L339.051 72.4074C339.134 72.4412 339.201 72.4973 339.251 72.5704C339.301 72.6435 339.329 72.7278 339.329 72.8121C339.329 72.8963 339.301 72.9863 339.251 73.0537C339.201 73.1267 339.134 73.1829 339.051 73.2167L337.597 73.7168C337.536 73.7393 337.48 73.7786 337.435 73.8236C337.391 73.8685 337.357 73.9303 337.341 73.9922L336.873 75.5375C336.85 75.6218 336.806 75.6949 336.733 75.7511C336.667 75.8017 336.577 75.8354 336.488 75.8354C336.399 75.8354 336.316 75.8073 336.243 75.7511C336.176 75.6949 336.126 75.6218 336.104 75.5375L335.63 73.9922C335.614 73.9303 335.58 73.8741 335.536 73.8236C335.491 73.7786 335.436 73.7393 335.374 73.7168L333.92 73.2167C333.837 73.1829 333.77 73.1267 333.72 73.0537C333.67 72.9806 333.642 72.8963 333.642 72.8121C333.642 72.7278 333.67 72.6378 333.72 72.5704C333.77 72.503 333.837 72.4412 333.92 72.4074L335.374 71.9073C335.436 71.8848 335.491 71.8455 335.536 71.8005C335.58 71.7556 335.614 71.6938 335.63 71.6319L336.098 70.0866C336.121 70.0023 336.165 69.9292 336.238 69.873C336.31 69.8168 336.394 69.7887 336.483 69.7887ZM336.483 68.6648C336.149 68.6648 335.82 68.7772 335.558 68.9795C335.302 69.1818 335.112 69.4628 335.029 69.7775L334.672 70.9576L333.558 71.3397C333.558 71.3397 333.519 71.3566 333.497 71.3622C333.213 71.4802 332.968 71.6769 332.795 71.9298C332.617 72.1883 332.522 72.4974 332.522 72.8121C332.522 73.1268 332.617 73.4358 332.795 73.6943C332.968 73.9472 333.213 74.1439 333.503 74.2619C333.519 74.2675 333.536 74.2731 333.558 74.2844L334.672 74.6665L335.034 75.8466C335.118 76.1613 335.307 76.4423 335.564 76.639C335.831 76.8413 336.154 76.9537 336.488 76.9537C336.823 76.9537 337.146 76.8413 337.407 76.639C337.669 76.4367 337.859 76.1557 337.942 75.841L338.299 74.6609L339.413 74.2788C339.413 74.2788 339.452 74.2619 339.474 74.2563C339.758 74.1383 339.998 73.9472 340.17 73.6943C340.349 73.4302 340.443 73.1267 340.443 72.8064C340.443 72.4861 340.349 72.1826 340.165 71.9185C339.992 71.6656 339.747 71.469 339.463 71.3566C339.446 71.351 339.43 71.3453 339.407 71.3341L338.293 70.952L337.931 69.7719C337.848 69.4572 337.658 69.1762 337.396 68.9739C337.14 68.7716 336.811 68.6592 336.477 68.6592L336.483 68.6648Z", fill: "#121212" }))); };

var BigHeadline = function (_a) {
    var background = _a.background, heading = _a.heading, leftBee = _a.leftBee, rightBee = _a.rightBee, mobileBee = _a.mobileBee, callToAction = _a.callToAction, callToActionIcon = _a.callToActionIcon, props = _tslib.__rest(_a, ["background", "heading", "leftBee", "rightBee", "mobileBee", "callToAction", "callToActionIcon"]);
    return (React__namespace.createElement(SectionContainer, _tslib.__assign({ background: background }, props),
        React__namespace.createElement(Container, { flex: 1, gap: "24px", align: { default: 'stretch', desktop: 'center' }, justify: "center", flexDir: { default: 'column', desktop: 'row' } },
            React__namespace.createElement(DesktopBeeContainer, null, leftBee !== null && leftBee !== void 0 ? leftBee : React__namespace.createElement(Bee5, { width: "100%", height: "100%" })),
            React__namespace.createElement(MobileBeeContainer, { justify: "end" }, mobileBee !== null && mobileBee !== void 0 ? mobileBee : React__namespace.createElement(Bee7, { height: "100%" })),
            React__namespace.createElement(Content, { flex: 1, gap: { default: '40px', desktop: '24px' }, flexDir: "column", align: "center" },
                React__namespace.createElement(Hyperlink.Text, { type: "heading_xlarge", useCompact: true, align: "center" },
                    React__namespace.createElement("h3", null, heading)),
                (callToAction === null || callToAction === void 0 ? void 0 : callToAction.text) && (React__namespace.createElement(LinkButton, { icon: callToActionIcon ? React__namespace.createElement(Icon, { height: 24, width: 24, name: callToActionIcon, fill: "black" }) : undefined, iconSide: "right", type: "accent", size: "large", href: callToAction.url, target: callToAction.target, className: callToAction.className, rel: callToAction.rel }, callToAction.text))),
            React__namespace.createElement(DesktopBeeContainer, null, rightBee !== null && rightBee !== void 0 ? rightBee : React__namespace.createElement(Bee6, { width: 180, height: 180 })))));
};
var Container = styled__default.default(Spacing.Flex).withConfig({ displayName: "Container", componentId: "-13aea1d" })(templateObject_1$2 || (templateObject_1$2 = _tslib.__makeTemplateObject(["\n  margin: 0 auto;\n  padding: 56px 0;\n  max-width: 1096px;\n  width: 100%;\n\n  @media ", " {\n    padding: 80px 0;\n  }\n\n  @media ", " {\n    max-width: 1128px;\n  }\n"], ["\n  margin: 0 auto;\n  padding: 56px 0;\n  max-width: 1096px;\n  width: 100%;\n\n  @media ", " {\n    padding: 80px 0;\n  }\n\n  @media ", " {\n    max-width: 1128px;\n  }\n"])), ResponsiveSizes.desktop, ResponsiveSizes.desktopLarge);
var Content = styled__default.default(Spacing.Flex).withConfig({ displayName: "Content", componentId: "-yusu4" })(templateObject_2$1 || (templateObject_2$1 = _tslib.__makeTemplateObject(["\n  @media ", " {\n    max-width: 770px;\n  }\n"], ["\n  @media ", " {\n    max-width: 770px;\n  }\n"])), ResponsiveSizes.desktop);
var DesktopBeeContainer = styled__default.default.div.withConfig({ displayName: "DesktopBeeContainer", componentId: "-1eezzvb" })(templateObject_3$1 || (templateObject_3$1 = _tslib.__makeTemplateObject(["\n  height: 180px;\n  width: 180px;\n  display: none;\n\n  @media ", " {\n    display: block;\n  }\n"], ["\n  height: 180px;\n  width: 180px;\n  display: none;\n\n  @media ", " {\n    display: block;\n  }\n"])), ResponsiveSizes.desktop);
var MobileBeeContainer = styled__default.default(Spacing.Flex).withConfig({ displayName: "MobileBeeContainer", componentId: "-ynmjfx" })(templateObject_4$1 || (templateObject_4$1 = _tslib.__makeTemplateObject(["\n  height: 80px;\n\n  @media ", " {\n    display: none;\n  }\n"], ["\n  height: 80px;\n\n  @media ", " {\n    display: none;\n  }\n"])), ResponsiveSizes.desktop);
var templateObject_1$2, templateObject_2$1, templateObject_3$1, templateObject_4$1;

var ResponsiveImage = function (_a) {
    var desktopLargeSrc = _a.desktopLargeSrc, desktopSrc = _a.desktopSrc, tabletSrc = _a.tabletSrc, mobileSrc = _a.mobileSrc, alt = _a.alt;
    return (React__namespace.default.createElement(ResponsiveImageContainer, null,
        desktopLargeSrc && React__namespace.default.createElement("img", { src: desktopLargeSrc, alt: alt, className: "desktopLarge" }),
        desktopSrc && React__namespace.default.createElement("img", { src: desktopSrc, alt: alt, className: "desktop" }),
        tabletSrc && React__namespace.default.createElement("img", { src: tabletSrc, alt: alt, className: "tablet" }),
        mobileSrc && React__namespace.default.createElement("img", { src: mobileSrc, alt: alt, className: "mobile" })));
};
var ResponsiveImageContainer = styled__default.default.div.withConfig({ displayName: "ResponsiveImageContainer", componentId: "-1y6owdw" })(templateObject_1$1 || (templateObject_1$1 = _tslib.__makeTemplateObject(["\n  img {\n    display: none;\n\n    &.mobile {\n      display: block;\n      @media ", " {\n        display: none;\n      }\n    }\n\n    &.tablet {\n      @media ", " {\n        display: block;\n      }\n      @media ", " {\n        display: none;\n      }\n    }\n\n    &.desktop {\n      @media ", " {\n        display: block;\n      }\n      @media ", " {\n        display: none;\n      }\n    }\n\n    &.desktopLarge {\n      @media ", " {\n        display: block;\n      }\n    }\n  }\n"], ["\n  img {\n    display: none;\n\n    &.mobile {\n      display: block;\n      @media ", " {\n        display: none;\n      }\n    }\n\n    &.tablet {\n      @media ", " {\n        display: block;\n      }\n      @media ", " {\n        display: none;\n      }\n    }\n\n    &.desktop {\n      @media ", " {\n        display: block;\n      }\n      @media ", " {\n        display: none;\n      }\n    }\n\n    &.desktopLarge {\n      @media ", " {\n        display: block;\n      }\n    }\n  }\n"])), ResponsiveSizes.tablet, ResponsiveSizes.tablet, ResponsiveSizes.desktop, ResponsiveSizes.desktop, ResponsiveSizes.desktopLarge, ResponsiveSizes.desktopLarge);
var templateObject_1$1;

var DefaultValues = {
    firstGrid: {
        title: '80M+',
        subtitle: 'users',
        color: '#FFE296',
    },
    secondGrid: {
        title: '$26.58',
        subtitle: 'avg payout sum',
        color: '#C6D5FD',
    },
    thirdGrid: {
        title: '195',
        subtitle: 'countries worldwide',
        color: '#E8E6E0',
    },
};
var StatisticsGrid = function (_a) {
    var background = _a.background, desktopFirstImageUrl = _a.desktopFirstImageUrl, mobileFirstImageUrl = _a.mobileFirstImageUrl, desktopSecondImageUrl = _a.desktopSecondImageUrl, mobileSecondImageUrl = _a.mobileSecondImageUrl, iconUrl = _a.iconUrl, firstGrid = _a.firstGrid, secondGrid = _a.secondGrid, thirdGrid = _a.thirdGrid;
    var isDesktop = UseSize.useSizes().isDesktop;
    var sizes = {
        title: isDesktop ? 'compact_heading_xxlarge' : 'compact_heading_large',
        subtitle: isDesktop ? 'body' : 'compact_body',
    };
    var mobileFirstImage = mobileFirstImageUrl || desktopFirstImageUrl;
    var mobileSecondImage = mobileSecondImageUrl || desktopSecondImageUrl;
    return (React__namespace.default.createElement(ShouldDisplay.ClientOnly, null,
        React__namespace.default.createElement(OuterSection, { background: background, sidePadding: false },
            React__namespace.default.createElement(Section, null,
                React__namespace.default.createElement(GridContainer, null,
                    React__namespace.default.createElement(FirstImageContainer, null,
                        React__namespace.default.createElement(ResponsiveImage, { desktopSrc: desktopFirstImageUrl, tabletSrc: desktopFirstImageUrl, desktopLargeSrc: desktopFirstImageUrl, mobileSrc: mobileFirstImage })),
                    React__namespace.default.createElement(UsersGridItem, { "$userGridColor": firstGrid === null || firstGrid === void 0 ? void 0 : firstGrid.color },
                        React__namespace.default.createElement(Hyperlink.Text, { type: sizes.title },
                            React__namespace.default.createElement("p", null, firstGrid === null || firstGrid === void 0 ? void 0 : firstGrid.title)),
                        React__namespace.default.createElement(Hyperlink.Text, { type: sizes.subtitle },
                            React__namespace.default.createElement("p", null, firstGrid === null || firstGrid === void 0 ? void 0 : firstGrid.subtitle))),
                    React__namespace.default.createElement(PayoutGridItem, { "$payoutGridColor": secondGrid === null || secondGrid === void 0 ? void 0 : secondGrid.color },
                        React__namespace.default.createElement("div", null,
                            React__namespace.default.createElement(Hyperlink.Text, { type: sizes.title },
                                React__namespace.default.createElement("p", null, secondGrid === null || secondGrid === void 0 ? void 0 : secondGrid.title)),
                            React__namespace.default.createElement(Hyperlink.Text, { type: sizes.subtitle },
                                React__namespace.default.createElement("p", null, secondGrid === null || secondGrid === void 0 ? void 0 : secondGrid.subtitle))),
                        (iconUrl === null || iconUrl === void 0 ? void 0 : iconUrl.length) ? (React__namespace.default.createElement(IconSizeContainer, null,
                            React__namespace.default.createElement("img", { src: iconUrl }))) : null),
                    React__namespace.default.createElement(CountriesGridItem, { "$countriesGridColor": thirdGrid === null || thirdGrid === void 0 ? void 0 : thirdGrid.color },
                        React__namespace.default.createElement(Hyperlink.Text, { type: sizes.title },
                            React__namespace.default.createElement("p", null, thirdGrid === null || thirdGrid === void 0 ? void 0 : thirdGrid.title)),
                        React__namespace.default.createElement(Hyperlink.Text, { type: sizes.subtitle },
                            React__namespace.default.createElement("p", null, thirdGrid === null || thirdGrid === void 0 ? void 0 : thirdGrid.subtitle))),
                    React__namespace.default.createElement(SecondImageContainer, null,
                        React__namespace.default.createElement(ResponsiveImage, { desktopSrc: desktopSecondImageUrl, tabletSrc: desktopSecondImageUrl, desktopLargeSrc: desktopSecondImageUrl, mobileSrc: mobileSecondImage })))))));
};
var OuterSection = styled__default.default(SectionContainer).withConfig({ displayName: "OuterSection", componentId: "-1tbvfq5" })(templateObject_1 || (templateObject_1 = _tslib.__makeTemplateObject(["\n  padding: 32px 25px;\n\n  @media ", " {\n    padding: 70px 25px;\n  }\n"], ["\n  padding: 32px 25px;\n\n  @media ", " {\n    padding: 70px 25px;\n  }\n"])), ResponsiveSizes.desktop);
var Section = styled__default.default.div.withConfig({ displayName: "Section", componentId: "-mtdgq4" })(templateObject_2 || (templateObject_2 = _tslib.__makeTemplateObject(["\n  border: 2px solid ", ";\n  border-radius: 10px;\n  overflow: hidden;\n  max-width: 936px;\n  width: 100%;\n  box-sizing: border-box;\n  margin: auto;\n"], ["\n  border: 2px solid ", ";\n  border-radius: 10px;\n  overflow: hidden;\n  max-width: 936px;\n  width: 100%;\n  box-sizing: border-box;\n  margin: auto;\n"])), styles.themeColors.gray[100]);
var GridContainer = styled__default.default.div.withConfig({ displayName: "GridContainer", componentId: "-1nmlbca" })(templateObject_3 || (templateObject_3 = _tslib.__makeTemplateObject(["\n  display: grid;\n  /* 200 in order to have 0.5% accuracy. */\n  grid-template-columns: repeat(200, 1fr);\n  grid-template-rows: auto auto;\n  text-align: center;\n\n  div:nth-child(1) {\n    grid-row: 3;\n    grid-column: span 100;\n  }\n\n  div:nth-child(2) {\n    grid-row: 1;\n    grid-column: span 122;\n  }\n\n  div:nth-child(3) {\n    grid-row: 2;\n    grid-column: 1 / -1;\n  }\n\n  div:nth-child(4) {\n    grid-row: 3;\n    grid-column: span 100;\n  }\n\n  div:nth-child(5) {\n    grid-row: 1;\n    grid-column: span 200;\n  }\n\n  @media ", " {\n    div:nth-child(1) {\n      grid-row: 1 / 3;\n      grid-column: span 73;\n    }\n\n    div:nth-child(2) {\n      grid-row: 1;\n      grid-column: span 45;\n    }\n\n    div:nth-child(3) {\n      grid-row: 1;\n      grid-column: span 82;\n    }\n\n    div:nth-child(4) {\n      grid-row: 2;\n      grid-column: span 62;\n    }\n\n    div:nth-child(5) {\n      grid-row: 2;\n      grid-column: span 82;\n    }\n  }\n"], ["\n  display: grid;\n  /* 200 in order to have 0.5% accuracy. */\n  grid-template-columns: repeat(200, 1fr);\n  grid-template-rows: auto auto;\n  text-align: center;\n\n  div:nth-child(1) {\n    grid-row: 3;\n    grid-column: span 100;\n  }\n\n  div:nth-child(2) {\n    grid-row: 1;\n    grid-column: span 122;\n  }\n\n  div:nth-child(3) {\n    grid-row: 2;\n    grid-column: 1 / -1;\n  }\n\n  div:nth-child(4) {\n    grid-row: 3;\n    grid-column: span 100;\n  }\n\n  div:nth-child(5) {\n    grid-row: 1;\n    grid-column: span 200;\n  }\n\n  @media ", " {\n    div:nth-child(1) {\n      grid-row: 1 / 3;\n      grid-column: span 73;\n    }\n\n    div:nth-child(2) {\n      grid-row: 1;\n      grid-column: span 45;\n    }\n\n    div:nth-child(3) {\n      grid-row: 1;\n      grid-column: span 82;\n    }\n\n    div:nth-child(4) {\n      grid-row: 2;\n      grid-column: span 62;\n    }\n\n    div:nth-child(5) {\n      grid-row: 2;\n      grid-column: span 82;\n    }\n  }\n"])), ResponsiveSizes.tablet);
var IconSizeContainer = styled__default.default.div.withConfig({ displayName: "IconSizeContainer", componentId: "-1avfjh2" })(templateObject_4 || (templateObject_4 = _tslib.__makeTemplateObject(["\n  * {\n    width: 43px;\n    height: 43px;\n\n    @media ", " {\n      width: 102px;\n      height: 102px;\n    }\n  }\n"], ["\n  * {\n    width: 43px;\n    height: 43px;\n\n    @media ", " {\n      width: 102px;\n      height: 102px;\n    }\n  }\n"])), ResponsiveSizes.desktop);
var ImageContainer = styled__default.default.div.withConfig({ displayName: "ImageContainer", componentId: "-10vb25b" })(templateObject_5 || (templateObject_5 = _tslib.__makeTemplateObject(["\n  * {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n"], ["\n  * {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n"])));
var FirstImageContainer = styled__default.default(ImageContainer).withConfig({ displayName: "FirstImageContainer", componentId: "-1qzwgid" })(templateObject_6 || (templateObject_6 = _tslib.__makeTemplateObject(["\n  border-top: 2px solid ", ";\n  border-right: 2px solid ", ";\n\n  @media ", " {\n    border-top: 0;\n    border-right: 2px solid ", ";\n  }\n"], ["\n  border-top: 2px solid ", ";\n  border-right: 2px solid ", ";\n\n  @media ", " {\n    border-top: 0;\n    border-right: 2px solid ", ";\n  }\n"])), styles.themeColors.gray[100], styles.themeColors.gray[100], ResponsiveSizes.tablet, styles.themeColors.gray[100]);
var SecondImageContainer = styled__default.default(ImageContainer).withConfig({ displayName: "SecondImageContainer", componentId: "-v8pxnl" })(templateObject_7 || (templateObject_7 = _tslib.__makeTemplateObject(["\n  border-left: 0;\n  border-bottom: 2px solid ", ";\n  @media ", " {\n    border-left: 2px solid ", ";\n    border-bottom: 0;\n  }\n"], ["\n  border-left: 0;\n  border-bottom: 2px solid ", ";\n  @media ", " {\n    border-left: 2px solid ", ";\n    border-bottom: 0;\n  }\n"])), styles.themeColors.gray[100], ResponsiveSizes.tablet, styles.themeColors.gray[100]);
var BaseGridItem = styled__default.default.div.withConfig({ displayName: "BaseGridItem", componentId: "-wtjeyu" })(templateObject_8 || (templateObject_8 = _tslib.__makeTemplateObject(["\n  text-align: left;\n  padding: 15px 32px;\n\n  @media ", " {\n    padding: 26px 24px;\n  }\n  @media ", " {\n    padding: 15px;\n  }\n"], ["\n  text-align: left;\n  padding: 15px 32px;\n\n  @media ", " {\n    padding: 26px 24px;\n  }\n  @media ", " {\n    padding: 15px;\n  }\n"])), ResponsiveSizes.desktop, ResponsiveSizes.tablet);
var UsersGridItem = styled__default.default(BaseGridItem).withConfig({ displayName: "UsersGridItem", componentId: "-kn8xz8" })(templateObject_9 || (templateObject_9 = _tslib.__makeTemplateObject(["\n  background-color: ", ";\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  border-bottom: 2px solid ", ";\n  border-right: 2px solid ", ";\n"], ["\n  background-color: ", ";\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  border-bottom: 2px solid ", ";\n  border-right: 2px solid ", ";\n"])), function (_a) {
    var $userGridColor = _a.$userGridColor;
    return $userGridColor !== null && $userGridColor !== void 0 ? $userGridColor : '#ffe296';
}, styles.themeColors.gray[100], styles.themeColors.gray[100]);
var PayoutGridItem = styled__default.default(BaseGridItem).withConfig({ displayName: "PayoutGridItem", componentId: "-zesvw4" })(templateObject_10 || (templateObject_10 = _tslib.__makeTemplateObject(["\n  background-color: ", ";\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  border-bottom: 0;\n  @media ", " {\n    border-bottom: 2px solid ", ";\n  }\n"], ["\n  background-color: ", ";\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  border-bottom: 0;\n  @media ", " {\n    border-bottom: 2px solid ", ";\n  }\n"])), function (_a) {
    var $payoutGridColor = _a.$payoutGridColor;
    return $payoutGridColor !== null && $payoutGridColor !== void 0 ? $payoutGridColor : '#c6d5fd';
}, ResponsiveSizes.tablet, styles.themeColors.gray[100]);
var CountriesGridItem = styled__default.default(BaseGridItem).withConfig({ displayName: "CountriesGridItem", componentId: "-1w0yck4" })(templateObject_11 || (templateObject_11 = _tslib.__makeTemplateObject(["\n  background-color: ", ";\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  border-top: 2px solid ", ";\n\n  @media ", " {\n    border-top: 0;\n  }\n"], ["\n  background-color: ", ";\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  border-top: 2px solid ", ";\n\n  @media ", " {\n    border-top: 0;\n  }\n"])), function (_a) {
    var $countriesGridColor = _a.$countriesGridColor;
    return $countriesGridColor !== null && $countriesGridColor !== void 0 ? $countriesGridColor : '#e8e6e0';
}, styles.themeColors.gray[100], ResponsiveSizes.tablet);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;

exports.Accordion = Accordion;
exports.Action = Action;
exports.Badge = Badge;
exports.BigHeadline = BigHeadline;
exports.BlobNumbersColumnLayout = BlobNumbersColumnLayout;
exports.BlobNumbersLayout = BlobNumbersLayout;
exports.BottomCTA = BottomCTA;
exports.Button = Button$3;
exports.ButtonIcon = ButtonIcon;
exports.ButtonV2 = Button$2;
exports.Calculator = Calculator;
exports.Card = Card$6;
exports.CardClickable = CardClickable;
exports.CardHeader = CardHeader;
exports.CardRowLayout = CardRowLayout;
exports.CardTab = CardTab;
exports.CardTabContainer = CardTabContainer$1;
exports.CardToggle = CardToggle;
exports.CardWithAuthor = CardWithAuthor;
exports.CardWithTopic = CardWithTopic;
exports.CardsSet = CardsSet;
exports.CarebuzzHeroSection = CarebuzzHeroSection;
exports.Carousel = Carousel;
exports.CenteredBlocksListLayout = CenteredBlocksListLayout;
exports.Checkbox = InputCheckbox;
exports.ClickableSmallCardsSet = ClickableSmallCardsSet;
exports.ColoredLayout = ColoredLayout;
exports.ComponentListItemLayout = ComponentListItemLayout;
exports.Container = Container$t;
exports.ContributionProgress = ContributionProgress;
exports.CookieConsent = CookieConsent;
exports.CopyButton = CopyButton;
exports.CopyTextField = CopyTextField;
exports.Copyright = Copyright;
exports.CustomerReviews = Reviews;
exports.CustomerReviewsData = REVIEWS;
exports.Dialog = Dialog;
exports.Dropdown = Dropdown;
exports.DropdownPanel = DropdownPanel;
exports.FAQ = FAQ;
exports.FeatureCard = FeatureCard;
exports.FeatureCardsSet = FeatureCardsSet;
exports.Footer = Footer;
exports.Gallery = Gallery;
exports.GalleryCard = GalleryCard;
exports.GalleryWithInfo = GalleryWithInfo;
exports.HeadingWithImage = HeadingWithImage;
exports.HelloBar = HelloBar;
exports.HeroBackgroundLayout = HeroBackgroundLayout;
exports.HeroCentered = HeroCentered;
exports.HeroLayout = HeroLayout;
exports.HeroSection = HeroSection$1;
exports.HeroV2 = HeroSection;
exports.HuaweiDownloadButton = HuaweiDownloadButton;
exports.Icon = Icon;
exports.IconButton = IconButton$3;
exports.IconProvider = IconProvider;
exports.IllustrationWithTextLayout = IllustrationWithTextLayout;
exports.InfoBlock = InfoBlock;
exports.InfoBlockListLayout = InfoBlockListLayout;
exports.InfoCard = InfoCard;
exports.InfoCardCompact = InfoCardCompact;
exports.InfoCardIllustrative = InfoCardIllustrative;
exports.InfoWithAccordion = InfoWithAccordion;
exports.InfoWithBulletPoints = InfoWithBulletPoints;
exports.InfoWithImage = InfoWithImage;
exports.InfoWithVideoGallery = InfoWithVideoGallery;
exports.Input = Input;
exports.InputField = InputField;
exports.InputFieldWithButton = InputFieldWithButton;
exports.InputGroup = InputGroup;
exports.InputIcon = InputIcon;
exports.InputMessage = InputMessage;
exports.Label = Label;
exports.LanguageSwitcher = LanguageSwitcher;
exports.LinkButton = LinkButton;
exports.Loader = Loader;
exports.Logos = Logos;
exports.MediaGallery = MediaGallery;
exports.Modal = Modal;
exports.MonthPicker = MonthPicker$1;
exports.NamedAvatar = NamedAvatar;
exports.NumbersLayout = NumbersLayout;
exports.OpenableCard = OpenableCard;
exports.Pill = Pill;
exports.PlayButton = PlayButton;
exports.Popup = Popup;
exports.PriceBox = PriceBox;
exports.PriceInCoins = PriceInCoins;
exports.Promo = Promo;
exports.Radio = InputRadio;
exports.ScrollDown = ScrollDown;
exports.SectionFooter = SectionFooter;
exports.SequenceLayout = SequenceLayout;
exports.SequenceLayoutItem = SequenceLayoutItem;
exports.ShareDropdown = ShareDropdown;
exports.Slider = Slider;
exports.SocialButton = SocialButton;
exports.Socials = Socials;
exports.Statistics = Statistics;
exports.StatisticsGrid = StatisticsGrid;
exports.StatisticsGridDefaultValues = DefaultValues;
exports.Stats = Stats;
exports.StatusCard = StatusCard;
exports.Stepper = Stepper;
exports.Steps = Steps;
exports.Sublabel = Sublabel;
exports.Switch = Switch;
exports.Testimonials = Testimonials;
exports.Timer = Timer;
exports.Tooltip = Tooltip;
exports.TooltipContent = TooltipContent;
exports.TooltipTrigger = TooltipTrigger;
exports.TopMenu = TopMenu;
exports.TrustpilotMicroCombo = TrustpilotMicroCombo;
exports.TrustpilotMicroStar = TrustpilotMicroStar;
exports.TrustpilotStarter = TrustpilotStarter;
exports.ValuePropositionLayout = ValuePropositionLayout;
exports.ValuePropositionListLayout = ValuePropositionListLayout;
exports.VideoOverlay = VideoOverlay$2;
exports.VideoReviews = VideoReviews;
exports.icons = icons;
exports.timerUnits = timerUnits;
exports.useTooltip = useTooltip;
exports.useTooltipContext = useTooltipContext;
exports.useTrustpilot = useTrustpilot;
//# sourceMappingURL=index.js.map
